
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8b1a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8b1a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2eQj8", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
};
var globalObject = getGlobal();
module.exports = exports = globalObject.fetch;
// Needed for TypeScript and Webpack.
if (globalObject.fetch) exports.default = globalObject.fetch.bind(globalObject);
exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

});

parcelRegister("btw6N", function(module, exports) {
var $85ab4f41d0004e1c$var$naiveFallback = function() {
    if (typeof self === "object" && self) return self;
    if (typeof window === "object" && window) return window;
    throw new Error("Unable to resolve global `this`");
};
module.exports = function() {
    if (this) return this;
    // Unexpected strict mode (may happen if e.g. bundled into ESM module)
    // Fallback to standard globalThis if available
    if (typeof globalThis === "object" && globalThis) return globalThis;
    // Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
    // In all ES5+ engines global object inherits from Object.prototype
    // (if you approached one that doesn't please report)
    try {
        Object.defineProperty(Object.prototype, "__global__", {
            get: function() {
                return this;
            },
            configurable: true
        });
    } catch (error) {
        // Unfortunate case of updates to Object.prototype being restricted
        // via preventExtensions, seal or freeze
        return $85ab4f41d0004e1c$var$naiveFallback();
    }
    try {
        // Safari case (window.__global__ works, but __global__ does not)
        if (!__global__) return $85ab4f41d0004e1c$var$naiveFallback();
        return __global__;
    } finally{
        delete Object.prototype.__global__;
    }
}();

});

parcelRegister("aTayz", function(module, exports) {
module.exports = JSON.parse('{"name":"websocket","description":"Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.","keywords":["websocket","websockets","socket","networking","comet","push","RFC-6455","realtime","server","client"],"author":"Brian McKelvey <theturtle32@gmail.com> (https://github.com/theturtle32)","contributors":["I\xf1aki Baz Castillo <ibc@aliax.net> (http://dev.sipdoc.net)"],"version":"1.0.34","repository":{"type":"git","url":"https://github.com/theturtle32/WebSocket-Node.git"},"homepage":"https://github.com/theturtle32/WebSocket-Node","engines":{"node":">=4.0.0"},"dependencies":{"bufferutil":"^4.0.1","debug":"^2.2.0","es5-ext":"^0.10.50","typedarray-to-buffer":"^3.1.5","utf-8-validate":"^5.0.2","yaeti":"^0.0.6"},"devDependencies":{"buffer-equal":"^1.0.0","gulp":"^4.0.2","gulp-jshint":"^2.0.4","jshint-stylish":"^2.2.1","jshint":"^2.0.0","tape":"^4.9.1"},"config":{"verbose":false},"scripts":{"test":"tape test/unit/*.js","gulp":"gulp"},"main":"index","directories":{"lib":"./lib"},"browser":"lib/browser.js","license":"Apache-2.0"}');

});

parcelRegister("f5Vhp", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("c2AYn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $ckQi5 = parcelRequire("ckQi5");
function $8c4259fed83ea091$var$emptyFunction() {}
function $8c4259fed83ea091$var$emptyFunctionWithReset() {}
$8c4259fed83ea091$var$emptyFunctionWithReset.resetWarningCache = $8c4259fed83ea091$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $ckQi5) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $8c4259fed83ea091$var$emptyFunctionWithReset,
        resetWarningCache: $8c4259fed83ea091$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("ckQi5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8fafea209d1a60da$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8fafea209d1a60da$var$ReactPropTypesSecret;

});


parcelRegister("1ptWM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $106f5b1c6c33542b$export$a7c73072b1a182ae; }, function (v) { return $106f5b1c6c33542b$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $106f5b1c6c33542b$export$9f27bc3417b4524d; }, function (v) { return $106f5b1c6c33542b$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $106f5b1c6c33542b$export$db77ccec0bb4ccac; }, function (v) { return $106f5b1c6c33542b$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $106f5b1c6c33542b$export$8392c0c9d3dcbd35; }, function (v) { return $106f5b1c6c33542b$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $106f5b1c6c33542b$export$ffb0004e005737fa; }, function (v) { return $106f5b1c6c33542b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $106f5b1c6c33542b$export$b624eff549462981; }, function (v) { return $106f5b1c6c33542b$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $106f5b1c6c33542b$export$7897aa7841a5380c; }, function (v) { return $106f5b1c6c33542b$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $106f5b1c6c33542b$export$602eac185826482c; }, function (v) { return $106f5b1c6c33542b$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $106f5b1c6c33542b$export$e2c29f18771995cb; }, function (v) { return $106f5b1c6c33542b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $106f5b1c6c33542b$export$5f8d39834fd61797; }, function (v) { return $106f5b1c6c33542b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $106f5b1c6c33542b$export$74bf444e3cd11ea5; }, function (v) { return $106f5b1c6c33542b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $106f5b1c6c33542b$export$998bcd577473dd93; }, function (v) { return $106f5b1c6c33542b$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $106f5b1c6c33542b$export$92387174baf9b227; }, function (v) { return $106f5b1c6c33542b$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $106f5b1c6c33542b$export$ec112efeb987d9c6; }, function (v) { return $106f5b1c6c33542b$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $106f5b1c6c33542b$export$b706b080d889d2c9; }, function (v) { return $106f5b1c6c33542b$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $106f5b1c6c33542b$export$5be5a87408f70ddc; }, function (v) { return $106f5b1c6c33542b$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $106f5b1c6c33542b$export$45a5e7f76e0caa8d; }, function (v) { return $106f5b1c6c33542b$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $106f5b1c6c33542b$export$455c2e768291efa6; }, function (v) { return $106f5b1c6c33542b$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $106f5b1c6c33542b$export$9522e17588c12572; }, function (v) { return $106f5b1c6c33542b$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $106f5b1c6c33542b$export$2110ac352bb060b9; }, function (v) { return $106f5b1c6c33542b$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $106f5b1c6c33542b$export$56885ab8b9c456ab; }, function (v) { return $106f5b1c6c33542b$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $106f5b1c6c33542b$export$d927fcb6adf8f9de; }, function (v) { return $106f5b1c6c33542b$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $106f5b1c6c33542b$export$b82d16f27459e05a; }, function (v) { return $106f5b1c6c33542b$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $106f5b1c6c33542b$export$522c17b4f5e123e8; }, function (v) { return $106f5b1c6c33542b$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $106f5b1c6c33542b$export$1aabd8a0274ecfd6; }, function (v) { return $106f5b1c6c33542b$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $106f5b1c6c33542b$export$3d6c20d97e46b957; }, function (v) { return $106f5b1c6c33542b$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $106f5b1c6c33542b$export$9b621391a187a31a; }, function (v) { return $106f5b1c6c33542b$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $106f5b1c6c33542b$export$f5bbd400c2f4426f; }, function (v) { return $106f5b1c6c33542b$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $106f5b1c6c33542b$export$a7c73072b1a182ae;
var $106f5b1c6c33542b$export$9f27bc3417b4524d;
var $106f5b1c6c33542b$export$db77ccec0bb4ccac;
var $106f5b1c6c33542b$export$8392c0c9d3dcbd35;
var $106f5b1c6c33542b$export$ffb0004e005737fa;
var $106f5b1c6c33542b$export$b624eff549462981;
var $106f5b1c6c33542b$export$7897aa7841a5380c;
var $106f5b1c6c33542b$export$602eac185826482c;
var $106f5b1c6c33542b$export$e2c29f18771995cb;
var $106f5b1c6c33542b$export$5f8d39834fd61797;
var $106f5b1c6c33542b$export$74bf444e3cd11ea5;
var $106f5b1c6c33542b$export$998bcd577473dd93;
var $106f5b1c6c33542b$export$92387174baf9b227;
var $106f5b1c6c33542b$export$ec112efeb987d9c6;
var $106f5b1c6c33542b$export$b706b080d889d2c9;
var $106f5b1c6c33542b$export$5be5a87408f70ddc;
var $106f5b1c6c33542b$export$45a5e7f76e0caa8d;
var $106f5b1c6c33542b$export$455c2e768291efa6;
var $106f5b1c6c33542b$export$9522e17588c12572;
var $106f5b1c6c33542b$export$2110ac352bb060b9;
var $106f5b1c6c33542b$export$56885ab8b9c456ab;
var $106f5b1c6c33542b$export$d927fcb6adf8f9de;
var $106f5b1c6c33542b$export$b82d16f27459e05a;
var $106f5b1c6c33542b$export$522c17b4f5e123e8;
var $106f5b1c6c33542b$export$1aabd8a0274ecfd6;
var $106f5b1c6c33542b$export$3d6c20d97e46b957;
var $106f5b1c6c33542b$export$9b621391a187a31a;
var $106f5b1c6c33542b$export$f5bbd400c2f4426f;
"use strict";
var $106f5b1c6c33542b$var$b = Symbol.for("react.element"), $106f5b1c6c33542b$var$c = Symbol.for("react.portal"), $106f5b1c6c33542b$var$d = Symbol.for("react.fragment"), $106f5b1c6c33542b$var$e = Symbol.for("react.strict_mode"), $106f5b1c6c33542b$var$f = Symbol.for("react.profiler"), $106f5b1c6c33542b$var$g = Symbol.for("react.provider"), $106f5b1c6c33542b$var$h = Symbol.for("react.context"), $106f5b1c6c33542b$var$k = Symbol.for("react.server_context"), $106f5b1c6c33542b$var$l = Symbol.for("react.forward_ref"), $106f5b1c6c33542b$var$m = Symbol.for("react.suspense"), $106f5b1c6c33542b$var$n = Symbol.for("react.suspense_list"), $106f5b1c6c33542b$var$p = Symbol.for("react.memo"), $106f5b1c6c33542b$var$q = Symbol.for("react.lazy"), $106f5b1c6c33542b$var$t = Symbol.for("react.offscreen"), $106f5b1c6c33542b$var$u;
$106f5b1c6c33542b$var$u = Symbol.for("react.module.reference");
function $106f5b1c6c33542b$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $106f5b1c6c33542b$var$b:
                switch(a = a.type, a){
                    case $106f5b1c6c33542b$var$d:
                    case $106f5b1c6c33542b$var$f:
                    case $106f5b1c6c33542b$var$e:
                    case $106f5b1c6c33542b$var$m:
                    case $106f5b1c6c33542b$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $106f5b1c6c33542b$var$k:
                            case $106f5b1c6c33542b$var$h:
                            case $106f5b1c6c33542b$var$l:
                            case $106f5b1c6c33542b$var$q:
                            case $106f5b1c6c33542b$var$p:
                            case $106f5b1c6c33542b$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $106f5b1c6c33542b$var$c:
                return r;
        }
    }
}
$106f5b1c6c33542b$export$a7c73072b1a182ae = $106f5b1c6c33542b$var$h;
$106f5b1c6c33542b$export$9f27bc3417b4524d = $106f5b1c6c33542b$var$g;
$106f5b1c6c33542b$export$db77ccec0bb4ccac = $106f5b1c6c33542b$var$b;
$106f5b1c6c33542b$export$8392c0c9d3dcbd35 = $106f5b1c6c33542b$var$l;
$106f5b1c6c33542b$export$ffb0004e005737fa = $106f5b1c6c33542b$var$d;
$106f5b1c6c33542b$export$b624eff549462981 = $106f5b1c6c33542b$var$q;
$106f5b1c6c33542b$export$7897aa7841a5380c = $106f5b1c6c33542b$var$p;
$106f5b1c6c33542b$export$602eac185826482c = $106f5b1c6c33542b$var$c;
$106f5b1c6c33542b$export$e2c29f18771995cb = $106f5b1c6c33542b$var$f;
$106f5b1c6c33542b$export$5f8d39834fd61797 = $106f5b1c6c33542b$var$e;
$106f5b1c6c33542b$export$74bf444e3cd11ea5 = $106f5b1c6c33542b$var$m;
$106f5b1c6c33542b$export$998bcd577473dd93 = $106f5b1c6c33542b$var$n;
$106f5b1c6c33542b$export$92387174baf9b227 = function() {
    return !1;
};
$106f5b1c6c33542b$export$ec112efeb987d9c6 = function() {
    return !1;
};
$106f5b1c6c33542b$export$b706b080d889d2c9 = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$h;
};
$106f5b1c6c33542b$export$5be5a87408f70ddc = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$g;
};
$106f5b1c6c33542b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $106f5b1c6c33542b$var$b;
};
$106f5b1c6c33542b$export$455c2e768291efa6 = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$l;
};
$106f5b1c6c33542b$export$9522e17588c12572 = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$d;
};
$106f5b1c6c33542b$export$2110ac352bb060b9 = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$q;
};
$106f5b1c6c33542b$export$56885ab8b9c456ab = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$p;
};
$106f5b1c6c33542b$export$d927fcb6adf8f9de = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$c;
};
$106f5b1c6c33542b$export$b82d16f27459e05a = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$f;
};
$106f5b1c6c33542b$export$522c17b4f5e123e8 = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$e;
};
$106f5b1c6c33542b$export$1aabd8a0274ecfd6 = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$m;
};
$106f5b1c6c33542b$export$3d6c20d97e46b957 = function(a) {
    return $106f5b1c6c33542b$var$v(a) === $106f5b1c6c33542b$var$n;
};
$106f5b1c6c33542b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $106f5b1c6c33542b$var$d || a === $106f5b1c6c33542b$var$f || a === $106f5b1c6c33542b$var$e || a === $106f5b1c6c33542b$var$m || a === $106f5b1c6c33542b$var$n || a === $106f5b1c6c33542b$var$t || "object" === typeof a && null !== a && (a.$$typeof === $106f5b1c6c33542b$var$q || a.$$typeof === $106f5b1c6c33542b$var$p || a.$$typeof === $106f5b1c6c33542b$var$g || a.$$typeof === $106f5b1c6c33542b$var$h || a.$$typeof === $106f5b1c6c33542b$var$l || a.$$typeof === $106f5b1c6c33542b$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$106f5b1c6c33542b$export$f5bbd400c2f4426f = $106f5b1c6c33542b$var$v;

});

parcelRegister("jLwkL", function(module, exports) {
module.exports = new URL("Highlight1.6704459e.svg", import.meta.url).toString();

});

parcelRegister("cokhW", function(module, exports) {
module.exports = new URL("Highlight2.389f4d9e.svg", import.meta.url).toString();

});

parcelRegister("akrcu", function(module, exports) {
module.exports = new URL("Heart.782b0c7a.svg", import.meta.url).toString();

});

parcelRegister("GHvYx", function(module, exports) {
module.exports = new URL("CheckedBox.de8e4a62.svg", import.meta.url).toString();

});

var $e48b1195589f71e3$var$n, $e48b1195589f71e3$export$41c562ebe57d11e2, $e48b1195589f71e3$var$u, $e48b1195589f71e3$export$a8257692ac88316c, $e48b1195589f71e3$var$i, $e48b1195589f71e3$var$o, $e48b1195589f71e3$var$r, $e48b1195589f71e3$var$f, $e48b1195589f71e3$var$e, $e48b1195589f71e3$var$c, $e48b1195589f71e3$var$s, $e48b1195589f71e3$var$a, $e48b1195589f71e3$var$h = {}, $e48b1195589f71e3$var$p = [], $e48b1195589f71e3$var$v = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $e48b1195589f71e3$var$y = Array.isArray;
function $e48b1195589f71e3$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $e48b1195589f71e3$var$w(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $e48b1195589f71e3$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $e48b1195589f71e3$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $e48b1195589f71e3$var$g(l, f, i, o, null);
}
function $e48b1195589f71e3$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$e48b1195589f71e3$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $e48b1195589f71e3$export$41c562ebe57d11e2.vnode && $e48b1195589f71e3$export$41c562ebe57d11e2.vnode(f), f;
}
function $e48b1195589f71e3$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $e48b1195589f71e3$export$ffb0004e005737fa(n) {
    return n.children;
}
function $e48b1195589f71e3$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $e48b1195589f71e3$var$x(n, l) {
    if (null == l) return n.__ ? $e48b1195589f71e3$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $e48b1195589f71e3$var$x(n) : null;
}
function $e48b1195589f71e3$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $e48b1195589f71e3$var$C(n);
    }
}
function $e48b1195589f71e3$var$M(n) {
    (!n.__d && (n.__d = !0) && $e48b1195589f71e3$var$i.push(n) && !$e48b1195589f71e3$var$P.__r++ || $e48b1195589f71e3$var$o !== $e48b1195589f71e3$export$41c562ebe57d11e2.debounceRendering) && (($e48b1195589f71e3$var$o = $e48b1195589f71e3$export$41c562ebe57d11e2.debounceRendering) || $e48b1195589f71e3$var$r)($e48b1195589f71e3$var$P);
}
function $e48b1195589f71e3$var$P() {
    var n, u, t, o, r, e, c, s;
    for($e48b1195589f71e3$var$i.sort($e48b1195589f71e3$var$f); n = $e48b1195589f71e3$var$i.shift();)n.__d && (u = $e48b1195589f71e3$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $e48b1195589f71e3$var$d({}, r)).__v = r.__v + 1, $e48b1195589f71e3$export$41c562ebe57d11e2.vnode && $e48b1195589f71e3$export$41c562ebe57d11e2.vnode(o), $e48b1195589f71e3$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $e48b1195589f71e3$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $e48b1195589f71e3$var$j(c, o, s), o.__e != e && $e48b1195589f71e3$var$C(o)), $e48b1195589f71e3$var$i.length > u && $e48b1195589f71e3$var$i.sort($e48b1195589f71e3$var$f));
    $e48b1195589f71e3$var$P.__r = 0;
}
function $e48b1195589f71e3$var$S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, v, y, d, w, _ = t && t.__k || $e48b1195589f71e3$var$p, g = l.length;
    for(u.__d = e, $e48b1195589f71e3$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && "boolean" != typeof y && "function" != typeof y && (v = -1 === y.__i ? $e48b1195589f71e3$var$h : _[y.__i] || $e48b1195589f71e3$var$h, y.__i = a, $e48b1195589f71e3$var$O(n, y, v, i, o, r, f, e, c, s), d = y.__e, y.ref && v.ref != y.ref && (v.ref && $e48b1195589f71e3$var$N(v.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || v.__k === y.__k ? (e && "string" == typeof y.type && !n.contains(e) && (e = $e48b1195589f71e3$var$x(v)), e = $e48b1195589f71e3$var$I(y, e, n)) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $e48b1195589f71e3$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $e48b1195589f71e3$var$g(null, i, null, null, null) : $e48b1195589f71e3$var$y(i) ? $e48b1195589f71e3$var$g($e48b1195589f71e3$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $e48b1195589f71e3$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $e48b1195589f71e3$var$L(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a = f - r : f == r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r && a++, f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $e48b1195589f71e3$var$x(o)), $e48b1195589f71e3$var$V(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $e48b1195589f71e3$var$x(o)), $e48b1195589f71e3$var$V(o, o));
}
function $e48b1195589f71e3$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $e48b1195589f71e3$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $e48b1195589f71e3$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($e48b1195589f71e3$var$y(n) ? n.some(function(n) {
        $e48b1195589f71e3$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $e48b1195589f71e3$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $e48b1195589f71e3$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $e48b1195589f71e3$var$v.test(l) ? u : u + "px";
}
function $e48b1195589f71e3$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $e48b1195589f71e3$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $e48b1195589f71e3$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $e48b1195589f71e3$var$e, n.addEventListener(l, o ? $e48b1195589f71e3$var$s : $e48b1195589f71e3$var$c, o)) : n.removeEventListener(l, o ? $e48b1195589f71e3$var$s : $e48b1195589f71e3$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $e48b1195589f71e3$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $e48b1195589f71e3$var$e++;
            else if (u.t < t.u) return;
            return t($e48b1195589f71e3$export$41c562ebe57d11e2.event ? $e48b1195589f71e3$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $e48b1195589f71e3$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, p, v, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $e48b1195589f71e3$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new $e48b1195589f71e3$export$16fa2f45be04daa8(m, M), h.constructor = T, h.render = $e48b1195589f71e3$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $e48b1195589f71e3$var$d({}, h.__s)), $e48b1195589f71e3$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), v = h.props, w = h.state, h.__v = u, p) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = $e48b1195589f71e3$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $e48b1195589f71e3$var$d($e48b1195589f71e3$var$d({}, i), h.getChildContext())), x && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, w)), $e48b1195589f71e3$var$S(n, $e48b1195589f71e3$var$y(L = null != a && a.type === $e48b1195589f71e3$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $e48b1195589f71e3$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $e48b1195589f71e3$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $e48b1195589f71e3$export$41c562ebe57d11e2.diffed) && a(u);
}
function $e48b1195589f71e3$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$e48b1195589f71e3$var$N(t[i], t[++i], t[++i]);
    $e48b1195589f71e3$export$41c562ebe57d11e2.__c && $e48b1195589f71e3$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $e48b1195589f71e3$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $e48b1195589f71e3$var$z(l, u, t, i, o, r, f, e, c) {
    var s, a, p, v, d, _, g, m = t.props, k = u.props, b = u.type;
    if ("svg" === b ? o = "http://www.w3.org/2000/svg" : "math" === b ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != r) {
        for(s = 0; s < r.length; s++)if ((d = r[s]) && "setAttribute" in d == !!b && (b ? d.localName === b : 3 === d.nodeType)) {
            l = d, r[s] = null;
            break;
        }
    }
    if (null == l) {
        if (null === b) return document.createTextNode(k);
        l = document.createElementNS(o, b, k.is && k), r = null, e = !1;
    }
    if (null === b) m === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $e48b1195589f71e3$var$n.call(l.childNodes), m = t.props || $e48b1195589f71e3$var$h, !e && null != r) for(m = {}, s = 0; s < l.attributes.length; s++)m[(d = l.attributes[s]).name] = d.value;
        for(s in m)if (d = m[s], "children" == s) ;
        else if ("dangerouslySetInnerHTML" == s) p = d;
        else if ("key" !== s && !(s in k)) {
            if ("value" == s && "defaultValue" in k || "checked" == s && "defaultChecked" in k) continue;
            $e48b1195589f71e3$var$A(l, s, null, d, o);
        }
        for(s in k)d = k[s], "children" == s ? v = d : "dangerouslySetInnerHTML" == s ? a = d : "value" == s ? _ = d : "checked" == s ? g = d : "key" === s || e && "function" != typeof d || m[s] === d || $e48b1195589f71e3$var$A(l, s, d, m[s], o);
        if (a) e || p && (a.__html === p.__html || a.__html === l.innerHTML) || (l.innerHTML = a.__html), u.__k = [];
        else if (p && (l.innerHTML = ""), $e48b1195589f71e3$var$S(l, $e48b1195589f71e3$var$y(v) ? v : [
            v
        ], u, t, i, "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : o, r, f, r ? r[0] : t.__k && $e48b1195589f71e3$var$x(t, 0), e, c), null != r) for(s = r.length; s--;)null != r[s] && $e48b1195589f71e3$var$w(r[s]);
        e || (s = "value", void 0 !== _ && (_ !== l[s] || "progress" === b && !_ || "option" === b && _ !== m[s]) && $e48b1195589f71e3$var$A(l, s, _, m[s], o), s = "checked", void 0 !== g && g !== l[s] && $e48b1195589f71e3$var$A(l, s, g, m[s], o));
    }
    return l;
}
function $e48b1195589f71e3$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $e48b1195589f71e3$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $e48b1195589f71e3$var$V(n, u, t) {
    var i, o;
    if ($e48b1195589f71e3$export$41c562ebe57d11e2.unmount && $e48b1195589f71e3$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $e48b1195589f71e3$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $e48b1195589f71e3$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $e48b1195589f71e3$var$V(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $e48b1195589f71e3$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $e48b1195589f71e3$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $e48b1195589f71e3$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $e48b1195589f71e3$export$41c562ebe57d11e2.__ && $e48b1195589f71e3$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $e48b1195589f71e3$var$O(t, u = (!o && i || t).__k = $e48b1195589f71e3$export$c8a8987d4410bf2d($e48b1195589f71e3$export$ffb0004e005737fa, null, [
        u
    ]), r || $e48b1195589f71e3$var$h, $e48b1195589f71e3$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $e48b1195589f71e3$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $e48b1195589f71e3$var$j(f, u, e);
}
function $e48b1195589f71e3$export$fa8d919ba61d84db(n, l) {
    $e48b1195589f71e3$export$b3890eb0ae9dca99(n, l, $e48b1195589f71e3$export$fa8d919ba61d84db);
}
function $e48b1195589f71e3$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $e48b1195589f71e3$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $e48b1195589f71e3$var$n.call(arguments, 2) : t), $e48b1195589f71e3$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $e48b1195589f71e3$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $e48b1195589f71e3$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $e48b1195589f71e3$var$M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$e48b1195589f71e3$var$n = $e48b1195589f71e3$var$p.slice, $e48b1195589f71e3$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $e48b1195589f71e3$var$u = 0, $e48b1195589f71e3$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $e48b1195589f71e3$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $e48b1195589f71e3$var$d({}, this.state), "function" == typeof n && (n = n($e48b1195589f71e3$var$d({}, u), this.props)), n && $e48b1195589f71e3$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $e48b1195589f71e3$var$M(this));
}, $e48b1195589f71e3$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $e48b1195589f71e3$var$M(this));
}, $e48b1195589f71e3$export$16fa2f45be04daa8.prototype.render = $e48b1195589f71e3$export$ffb0004e005737fa, $e48b1195589f71e3$var$i = [], $e48b1195589f71e3$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $e48b1195589f71e3$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $e48b1195589f71e3$var$P.__r = 0, $e48b1195589f71e3$var$e = 0, $e48b1195589f71e3$var$c = $e48b1195589f71e3$var$F(!1), $e48b1195589f71e3$var$s = $e48b1195589f71e3$var$F(!0), $e48b1195589f71e3$var$a = 0;


var $3945ef68f6afb8b5$var$t = /["&<]/;
function $3945ef68f6afb8b5$var$n(r) {
    if (0 === r.length || !1 === $3945ef68f6afb8b5$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $3945ef68f6afb8b5$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $3945ef68f6afb8b5$var$f = 0, $3945ef68f6afb8b5$var$i = Array.isArray;
function $3945ef68f6afb8b5$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: --$3945ef68f6afb8b5$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $e48b1195589f71e3$export$41c562ebe57d11e2).vnode && (0, $e48b1195589f71e3$export$41c562ebe57d11e2).vnode(l), l;
}
function $3945ef68f6afb8b5$export$45700d561b2268ac(r) {
    var t = $3945ef68f6afb8b5$export$34b9dba7ce09269b((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $3945ef68f6afb8b5$var$c = {}, $3945ef68f6afb8b5$var$p = /[A-Z]/g;
function $3945ef68f6afb8b5$export$991f6ffe102e5bac(e, t) {
    if ((0, $e48b1195589f71e3$export$41c562ebe57d11e2).attr) {
        var f = (0, $e48b1195589f71e3$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if ("ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $3945ef68f6afb8b5$var$c[u] || ($3945ef68f6afb8b5$var$c[u] = u.replace($3945ef68f6afb8b5$var$p, "-$&").toLowerCase()), _ = ";";
                "number" != typeof a || l.startsWith("--") || $3945ef68f6afb8b5$var$o.test(l) || (_ = "px;"), i = i + l + ":" + a + _;
            }
        }
        return e + '="' + i + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $3945ef68f6afb8b5$var$n(t) + '"';
}
function $3945ef68f6afb8b5$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($3945ef68f6afb8b5$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $3945ef68f6afb8b5$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $3945ef68f6afb8b5$var$n("" + r);
}


var $69d723089b47cf34$exports = {};

$parcel$defineInteropFlag($69d723089b47cf34$exports);

$parcel$export($69d723089b47cf34$exports, "PureComponent", function () { return $69d723089b47cf34$export$221d75b3f55bb0bd; });
$parcel$export($69d723089b47cf34$exports, "memo", function () { return $69d723089b47cf34$export$7c73462e0d25e514; });
$parcel$export($69d723089b47cf34$exports, "forwardRef", function () { return $69d723089b47cf34$export$257a8862b851cb5b; });
$parcel$export($69d723089b47cf34$exports, "Children", function () { return $69d723089b47cf34$export$dca3b0875bd9a954; });
$parcel$export($69d723089b47cf34$exports, "Suspense", function () { return $69d723089b47cf34$export$74bf444e3cd11ea5; });
$parcel$export($69d723089b47cf34$exports, "lazy", function () { return $69d723089b47cf34$export$488013bae63b21da; });
$parcel$export($69d723089b47cf34$exports, "SuspenseList", function () { return $69d723089b47cf34$export$998bcd577473dd93; });
$parcel$export($69d723089b47cf34$exports, "createPortal", function () { return $69d723089b47cf34$export$d39a5bbd09211389; });
$parcel$export($69d723089b47cf34$exports, "render", function () { return $69d723089b47cf34$export$b3890eb0ae9dca99; });
$parcel$export($69d723089b47cf34$exports, "hydrate", function () { return $69d723089b47cf34$export$fa8d919ba61d84db; });
$parcel$export($69d723089b47cf34$exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $69d723089b47cf34$export$ae55be85d98224ed; });
$parcel$export($69d723089b47cf34$exports, "useDeferredValue", function () { return $69d723089b47cf34$export$6a7bc4e911dc01cf; });
$parcel$export($69d723089b47cf34$exports, "useInsertionEffect", function () { return $69d723089b47cf34$export$aaabe4eda9ed9969; });
$parcel$export($69d723089b47cf34$exports, "useSyncExternalStore", function () { return $69d723089b47cf34$export$306c0aa65ff9ec16; });
$parcel$export($69d723089b47cf34$exports, "useTransition", function () { return $69d723089b47cf34$export$7b286972b8d8ccbf; });
$parcel$export($69d723089b47cf34$exports, "version", function () { return $69d723089b47cf34$export$83d89fbfd8236492; });
$parcel$export($69d723089b47cf34$exports, "createFactory", function () { return $69d723089b47cf34$export$d38cd72104c1f0e9; });
$parcel$export($69d723089b47cf34$exports, "isValidElement", function () { return $69d723089b47cf34$export$a8257692ac88316c; });
$parcel$export($69d723089b47cf34$exports, "isFragment", function () { return $69d723089b47cf34$export$9522e17588c12572; });
$parcel$export($69d723089b47cf34$exports, "isMemo", function () { return $69d723089b47cf34$export$56885ab8b9c456ab; });
$parcel$export($69d723089b47cf34$exports, "cloneElement", function () { return $69d723089b47cf34$export$e530037191fcd5d7; });
$parcel$export($69d723089b47cf34$exports, "unmountComponentAtNode", function () { return $69d723089b47cf34$export$502457920280e6be; });
$parcel$export($69d723089b47cf34$exports, "findDOMNode", function () { return $69d723089b47cf34$export$466bfc07425424d5; });
$parcel$export($69d723089b47cf34$exports, "unstable_batchedUpdates", function () { return $69d723089b47cf34$export$c78a37762a8d58e1; });
$parcel$export($69d723089b47cf34$exports, "flushSync", function () { return $69d723089b47cf34$export$cd75ccfd720a3cd4; });
$parcel$export($69d723089b47cf34$exports, "StrictMode", function () { return $69d723089b47cf34$export$5f8d39834fd61797; });
$parcel$export($69d723089b47cf34$exports, "startTransition", function () { return $69d723089b47cf34$export$7568632d0d33d16d; });
$parcel$export($69d723089b47cf34$exports, "isElement", function () { return $69d723089b47cf34$export$45a5e7f76e0caa8d; });
$parcel$export($69d723089b47cf34$exports, "default", function () { return $69d723089b47cf34$export$2e2bcd8739ae039; });
$parcel$export($69d723089b47cf34$exports, "Component", function () { return $e48b1195589f71e3$export$16fa2f45be04daa8; });
$parcel$export($69d723089b47cf34$exports, "Fragment", function () { return $e48b1195589f71e3$export$ffb0004e005737fa; });
$parcel$export($69d723089b47cf34$exports, "createContext", function () { return $e48b1195589f71e3$export$fd42f52fd3ae1109; });
$parcel$export($69d723089b47cf34$exports, "createElement", function () { return $e48b1195589f71e3$export$c8a8987d4410bf2d; });
$parcel$export($69d723089b47cf34$exports, "createRef", function () { return $e48b1195589f71e3$export$7d1e3a5e95ceca43; });

var $a70cf465074cab30$exports = {};

$parcel$export($a70cf465074cab30$exports, "useState", function () { return $a70cf465074cab30$export$60241385465d0a34; });
$parcel$export($a70cf465074cab30$exports, "useReducer", function () { return $a70cf465074cab30$export$13e3392192263954; });
$parcel$export($a70cf465074cab30$exports, "useEffect", function () { return $a70cf465074cab30$export$6d9c69b0de29b591; });
$parcel$export($a70cf465074cab30$exports, "useLayoutEffect", function () { return $a70cf465074cab30$export$e5c5a5f917a5871c; });
$parcel$export($a70cf465074cab30$exports, "useRef", function () { return $a70cf465074cab30$export$b8f5890fc79d6aca; });
$parcel$export($a70cf465074cab30$exports, "useMemo", function () { return $a70cf465074cab30$export$1538c33de8887b59; });
$parcel$export($a70cf465074cab30$exports, "useImperativeHandle", function () { return $a70cf465074cab30$export$d5a552a76deda3c2; });
$parcel$export($a70cf465074cab30$exports, "useCallback", function () { return $a70cf465074cab30$export$35808ee640e87ca7; });
$parcel$export($a70cf465074cab30$exports, "useContext", function () { return $a70cf465074cab30$export$fae74005e78b1a27; });
$parcel$export($a70cf465074cab30$exports, "useDebugValue", function () { return $a70cf465074cab30$export$dc8fbce3eb94dc1e; });
$parcel$export($a70cf465074cab30$exports, "useErrorBoundary", function () { return $a70cf465074cab30$export$c052f6604b7d51fe; });
$parcel$export($a70cf465074cab30$exports, "useId", function () { return $a70cf465074cab30$export$f680877a34711e37; });

var $a70cf465074cab30$var$t, $a70cf465074cab30$var$r, $a70cf465074cab30$var$u, $a70cf465074cab30$var$i, $a70cf465074cab30$var$o = 0, $a70cf465074cab30$var$f = [], $a70cf465074cab30$var$c = (0, $e48b1195589f71e3$export$41c562ebe57d11e2), $a70cf465074cab30$var$e = $a70cf465074cab30$var$c.__b, $a70cf465074cab30$var$a = $a70cf465074cab30$var$c.__r, $a70cf465074cab30$var$v = $a70cf465074cab30$var$c.diffed, $a70cf465074cab30$var$l = $a70cf465074cab30$var$c.__c, $a70cf465074cab30$var$m = $a70cf465074cab30$var$c.unmount, $a70cf465074cab30$var$s = $a70cf465074cab30$var$c.__;
function $a70cf465074cab30$var$d(n, t) {
    $a70cf465074cab30$var$c.__h && $a70cf465074cab30$var$c.__h($a70cf465074cab30$var$r, n, $a70cf465074cab30$var$o || t), $a70cf465074cab30$var$o = 0;
    var u = $a70cf465074cab30$var$r.__H || ($a70cf465074cab30$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $a70cf465074cab30$export$60241385465d0a34(n) {
    return $a70cf465074cab30$var$o = 1, $a70cf465074cab30$export$13e3392192263954($a70cf465074cab30$var$D, n);
}
function $a70cf465074cab30$export$13e3392192263954(n, u, i) {
    var o = $a70cf465074cab30$var$d($a70cf465074cab30$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $a70cf465074cab30$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $a70cf465074cab30$var$r, !$a70cf465074cab30$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $a70cf465074cab30$var$r.u = !0;
        var c = $a70cf465074cab30$var$r.shouldComponentUpdate, e = $a70cf465074cab30$var$r.componentWillUpdate;
        $a70cf465074cab30$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $a70cf465074cab30$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $a70cf465074cab30$export$6d9c69b0de29b591(n, u) {
    var i = $a70cf465074cab30$var$d($a70cf465074cab30$var$t++, 3);
    !$a70cf465074cab30$var$c.__s && $a70cf465074cab30$var$C(i.__H, u) && (i.__ = n, i.i = u, $a70cf465074cab30$var$r.__H.__h.push(i));
}
function $a70cf465074cab30$export$e5c5a5f917a5871c(n, u) {
    var i = $a70cf465074cab30$var$d($a70cf465074cab30$var$t++, 4);
    !$a70cf465074cab30$var$c.__s && $a70cf465074cab30$var$C(i.__H, u) && (i.__ = n, i.i = u, $a70cf465074cab30$var$r.__h.push(i));
}
function $a70cf465074cab30$export$b8f5890fc79d6aca(n) {
    return $a70cf465074cab30$var$o = 5, $a70cf465074cab30$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $a70cf465074cab30$export$d5a552a76deda3c2(n, t, r) {
    $a70cf465074cab30$var$o = 6, $a70cf465074cab30$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $a70cf465074cab30$export$1538c33de8887b59(n, r) {
    var u = $a70cf465074cab30$var$d($a70cf465074cab30$var$t++, 7);
    return $a70cf465074cab30$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $a70cf465074cab30$export$35808ee640e87ca7(n, t) {
    return $a70cf465074cab30$var$o = 8, $a70cf465074cab30$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $a70cf465074cab30$export$fae74005e78b1a27(n) {
    var u = $a70cf465074cab30$var$r.context[n.__c], i = $a70cf465074cab30$var$d($a70cf465074cab30$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($a70cf465074cab30$var$r)), u.props.value) : n.__;
}
function $a70cf465074cab30$export$dc8fbce3eb94dc1e(n, t) {
    $a70cf465074cab30$var$c.useDebugValue && $a70cf465074cab30$var$c.useDebugValue(t ? t(n) : n);
}
function $a70cf465074cab30$export$c052f6604b7d51fe(n) {
    var u = $a70cf465074cab30$var$d($a70cf465074cab30$var$t++, 10), i = $a70cf465074cab30$export$60241385465d0a34();
    return u.__ = n, $a70cf465074cab30$var$r.componentDidCatch || ($a70cf465074cab30$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $a70cf465074cab30$export$f680877a34711e37() {
    var n = $a70cf465074cab30$var$d($a70cf465074cab30$var$t++, 11);
    if (!n.__) {
        for(var u = $a70cf465074cab30$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $a70cf465074cab30$var$j() {
    for(var n; n = $a70cf465074cab30$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($a70cf465074cab30$var$z), n.__H.__h.forEach($a70cf465074cab30$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $a70cf465074cab30$var$c.__e(t, n.__v);
    }
}
$a70cf465074cab30$var$c.__b = function(n) {
    $a70cf465074cab30$var$r = null, $a70cf465074cab30$var$e && $a70cf465074cab30$var$e(n);
}, $a70cf465074cab30$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $a70cf465074cab30$var$s && $a70cf465074cab30$var$s(n, t);
}, $a70cf465074cab30$var$c.__r = function(n) {
    $a70cf465074cab30$var$a && $a70cf465074cab30$var$a(n), $a70cf465074cab30$var$t = 0;
    var i = ($a70cf465074cab30$var$r = n.__c).__H;
    i && ($a70cf465074cab30$var$u === $a70cf465074cab30$var$r ? (i.__h = [], $a70cf465074cab30$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
    })) : (i.__h.forEach($a70cf465074cab30$var$z), i.__h.forEach($a70cf465074cab30$var$B), i.__h = [], $a70cf465074cab30$var$t = 0)), $a70cf465074cab30$var$u = $a70cf465074cab30$var$r;
}, $a70cf465074cab30$var$c.diffed = function(n) {
    $a70cf465074cab30$var$v && $a70cf465074cab30$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $a70cf465074cab30$var$f.push(t) && $a70cf465074cab30$var$i === $a70cf465074cab30$var$c.requestAnimationFrame || (($a70cf465074cab30$var$i = $a70cf465074cab30$var$c.requestAnimationFrame) || $a70cf465074cab30$var$w)($a70cf465074cab30$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.i = void 0;
    })), $a70cf465074cab30$var$u = $a70cf465074cab30$var$r = null;
}, $a70cf465074cab30$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($a70cf465074cab30$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $a70cf465074cab30$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $a70cf465074cab30$var$c.__e(r, n.__v);
        }
    }), $a70cf465074cab30$var$l && $a70cf465074cab30$var$l(n, t);
}, $a70cf465074cab30$var$c.unmount = function(n) {
    $a70cf465074cab30$var$m && $a70cf465074cab30$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $a70cf465074cab30$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $a70cf465074cab30$var$c.__e(t, r.__v));
};
var $a70cf465074cab30$var$k = "function" == typeof requestAnimationFrame;
function $a70cf465074cab30$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $a70cf465074cab30$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $a70cf465074cab30$var$k && (t = requestAnimationFrame(r));
}
function $a70cf465074cab30$var$z(n) {
    var t = $a70cf465074cab30$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $a70cf465074cab30$var$r = t;
}
function $a70cf465074cab30$var$B(n) {
    var t = $a70cf465074cab30$var$r;
    n.__c = n.__(), $a70cf465074cab30$var$r = t;
}
function $a70cf465074cab30$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $a70cf465074cab30$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $69d723089b47cf34$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $69d723089b47cf34$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $69d723089b47cf34$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $69d723089b47cf34$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $69d723089b47cf34$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $e48b1195589f71e3$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($69d723089b47cf34$export$221d75b3f55bb0bd.prototype = new (0, $e48b1195589f71e3$export$16fa2f45be04daa8)).isPureReactComponent = !0, $69d723089b47cf34$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $69d723089b47cf34$var$E(this.props, n) || $69d723089b47cf34$var$E(this.state, t);
};
var $69d723089b47cf34$var$R = (0, $e48b1195589f71e3$export$41c562ebe57d11e2).__b;
(0, $e48b1195589f71e3$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $69d723089b47cf34$var$R && $69d723089b47cf34$var$R(n);
};
var $69d723089b47cf34$var$w = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $69d723089b47cf34$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $69d723089b47cf34$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $69d723089b47cf34$var$w, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $69d723089b47cf34$var$I = function(n, t) {
    return null == n ? null : (0, $e48b1195589f71e3$export$47e4c5b300681277)((0, $e48b1195589f71e3$export$47e4c5b300681277)(n).map(t));
}, $69d723089b47cf34$export$dca3b0875bd9a954 = {
    map: $69d723089b47cf34$var$I,
    forEach: $69d723089b47cf34$var$I,
    count: function(n) {
        return n ? (0, $e48b1195589f71e3$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $e48b1195589f71e3$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $e48b1195589f71e3$export$47e4c5b300681277)
}, $69d723089b47cf34$var$M = (0, $e48b1195589f71e3$export$41c562ebe57d11e2).__e;
(0, $e48b1195589f71e3$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $69d723089b47cf34$var$M(n, t, e, r);
};
var $69d723089b47cf34$var$T = (0, $e48b1195589f71e3$export$41c562ebe57d11e2).unmount;
function $69d723089b47cf34$var$A(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $69d723089b47cf34$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $69d723089b47cf34$var$A(n, t, e);
    })), n;
}
function $69d723089b47cf34$var$D(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $69d723089b47cf34$var$D(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $69d723089b47cf34$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $69d723089b47cf34$var$O(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $69d723089b47cf34$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $e48b1195589f71e3$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $69d723089b47cf34$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $e48b1195589f71e3$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $69d723089b47cf34$var$T && $69d723089b47cf34$var$T(n);
}, ($69d723089b47cf34$export$74bf444e3cd11ea5.prototype = new (0, $e48b1195589f71e3$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $69d723089b47cf34$var$O(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(c) : c());
    };
    e.__R = i;
    var c = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $69d723089b47cf34$var$D(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $69d723089b47cf34$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $69d723089b47cf34$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $69d723089b47cf34$var$A(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $e48b1195589f71e3$export$c8a8987d4410bf2d)((0, $e48b1195589f71e3$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $e48b1195589f71e3$export$c8a8987d4410bf2d)((0, $e48b1195589f71e3$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $69d723089b47cf34$var$V = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $69d723089b47cf34$var$W(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $69d723089b47cf34$var$P(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $e48b1195589f71e3$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        contains: function() {
            return !0;
        },
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $e48b1195589f71e3$export$b3890eb0ae9dca99)((0, $e48b1195589f71e3$export$c8a8987d4410bf2d)($69d723089b47cf34$var$W, {
        context: e.context
    }, n.__v), e.l);
}
function $69d723089b47cf34$export$d39a5bbd09211389(n, e) {
    var r = (0, $e48b1195589f71e3$export$c8a8987d4410bf2d)($69d723089b47cf34$var$P, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($69d723089b47cf34$export$998bcd577473dd93.prototype = new (0, $e48b1195589f71e3$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $69d723089b47cf34$var$O(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $69d723089b47cf34$var$V(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $69d723089b47cf34$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $e48b1195589f71e3$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $69d723089b47cf34$export$998bcd577473dd93.prototype.componentDidUpdate = $69d723089b47cf34$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $69d723089b47cf34$var$V(n, e, t);
    });
};
var $69d723089b47cf34$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $69d723089b47cf34$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $69d723089b47cf34$var$H = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $69d723089b47cf34$var$Z = /[A-Z0-9]/g, $69d723089b47cf34$var$Y = "undefined" != typeof document, $69d723089b47cf34$var$$ = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $69d723089b47cf34$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $e48b1195589f71e3$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $69d723089b47cf34$export$fa8d919ba61d84db(n, t, e) {
    return (0, $e48b1195589f71e3$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $e48b1195589f71e3$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $e48b1195589f71e3$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $69d723089b47cf34$var$J = (0, $e48b1195589f71e3$export$41c562ebe57d11e2).event;
function $69d723089b47cf34$var$K() {}
function $69d723089b47cf34$var$Q() {
    return this.cancelBubble;
}
function $69d723089b47cf34$var$X() {
    return this.defaultPrevented;
}
(0, $e48b1195589f71e3$export$41c562ebe57d11e2).event = function(n) {
    return $69d723089b47cf34$var$J && (n = $69d723089b47cf34$var$J(n)), n.persist = $69d723089b47cf34$var$K, n.isPropagationStopped = $69d723089b47cf34$var$Q, n.isDefaultPrevented = $69d723089b47cf34$var$X, n.nativeEvent = n;
};
var $69d723089b47cf34$var$nn, $69d723089b47cf34$var$tn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $69d723089b47cf34$var$en = (0, $e48b1195589f71e3$export$41c562ebe57d11e2).vnode;
(0, $e48b1195589f71e3$export$41c562ebe57d11e2).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {};
        for(var o in t){
            var i = t[o];
            if (!("value" === o && "defaultValue" in t && null == i || $69d723089b47cf34$var$Y && "children" === o && "noscript" === e || "class" === o || "className" === o)) {
                var c = o.toLowerCase();
                "defaultValue" === o && "value" in t && null == t.value ? o = "value" : "download" === o && !0 === i ? i = "" : "translate" === c && "no" === i ? i = !1 : "ondoubleclick" === c ? o = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $69d723089b47cf34$var$$(t.type) ? "onfocus" === c ? o = "onfocusin" : "onblur" === c ? o = "onfocusout" : $69d723089b47cf34$var$H.test(o) ? o = c : -1 === e.indexOf("-") && $69d723089b47cf34$var$B.test(o) ? o = o.replace($69d723089b47cf34$var$Z, "-$&").toLowerCase() : null === i && (i = void 0) : c = o = "oninput", "oninput" === c && u[o = c] && (o = "oninputCapture"), u[o] = i;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $e48b1195589f71e3$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $e48b1195589f71e3$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $69d723089b47cf34$var$tn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $69d723089b47cf34$var$z, $69d723089b47cf34$var$en && $69d723089b47cf34$var$en(n);
};
var $69d723089b47cf34$var$rn = (0, $e48b1195589f71e3$export$41c562ebe57d11e2).__r;
(0, $e48b1195589f71e3$export$41c562ebe57d11e2).__r = function(n) {
    $69d723089b47cf34$var$rn && $69d723089b47cf34$var$rn(n), $69d723089b47cf34$var$nn = n.__c;
};
var $69d723089b47cf34$var$un = (0, $e48b1195589f71e3$export$41c562ebe57d11e2).diffed;
(0, $e48b1195589f71e3$export$41c562ebe57d11e2).diffed = function(n) {
    $69d723089b47cf34$var$un && $69d723089b47cf34$var$un(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $69d723089b47cf34$var$nn = null;
};
var $69d723089b47cf34$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $69d723089b47cf34$var$nn.__n[n.__c].props.value;
            },
            useCallback: (0, $a70cf465074cab30$export$35808ee640e87ca7),
            useContext: (0, $a70cf465074cab30$export$fae74005e78b1a27),
            useDebugValue: (0, $a70cf465074cab30$export$dc8fbce3eb94dc1e),
            useDeferredValue: $69d723089b47cf34$export$6a7bc4e911dc01cf,
            useEffect: (0, $a70cf465074cab30$export$6d9c69b0de29b591),
            useId: (0, $a70cf465074cab30$export$f680877a34711e37),
            useImperativeHandle: (0, $a70cf465074cab30$export$d5a552a76deda3c2),
            useInsertionEffect: $69d723089b47cf34$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $a70cf465074cab30$export$e5c5a5f917a5871c),
            useMemo: (0, $a70cf465074cab30$export$1538c33de8887b59),
            useReducer: (0, $a70cf465074cab30$export$13e3392192263954),
            useRef: (0, $a70cf465074cab30$export$b8f5890fc79d6aca),
            useState: (0, $a70cf465074cab30$export$60241385465d0a34),
            useSyncExternalStore: $69d723089b47cf34$export$306c0aa65ff9ec16,
            useTransition: $69d723089b47cf34$export$7b286972b8d8ccbf
        }
    }
}, $69d723089b47cf34$export$83d89fbfd8236492 = "17.0.2";
function $69d723089b47cf34$export$d38cd72104c1f0e9(n) {
    return (0, $e48b1195589f71e3$export$c8a8987d4410bf2d).bind(null, n);
}
function $69d723089b47cf34$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $69d723089b47cf34$var$z;
}
function $69d723089b47cf34$export$9522e17588c12572(n) {
    return $69d723089b47cf34$export$a8257692ac88316c(n) && n.type === (0, $e48b1195589f71e3$export$ffb0004e005737fa);
}
function $69d723089b47cf34$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $69d723089b47cf34$export$e530037191fcd5d7(n) {
    return $69d723089b47cf34$export$a8257692ac88316c(n) ? (0, $e48b1195589f71e3$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $69d723089b47cf34$export$502457920280e6be(n) {
    return !!n.__k && ((0, $e48b1195589f71e3$export$b3890eb0ae9dca99)(null, n), !0);
}
function $69d723089b47cf34$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $69d723089b47cf34$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $69d723089b47cf34$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $69d723089b47cf34$export$5f8d39834fd61797 = (0, $e48b1195589f71e3$export$ffb0004e005737fa);
function $69d723089b47cf34$export$7568632d0d33d16d(n) {
    n();
}
function $69d723089b47cf34$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $69d723089b47cf34$export$7b286972b8d8ccbf() {
    return [
        !1,
        $69d723089b47cf34$export$7568632d0d33d16d
    ];
}
var $69d723089b47cf34$export$aaabe4eda9ed9969 = (0, $a70cf465074cab30$export$e5c5a5f917a5871c), $69d723089b47cf34$export$45a5e7f76e0caa8d = $69d723089b47cf34$export$a8257692ac88316c;
function $69d723089b47cf34$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $a70cf465074cab30$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $a70cf465074cab30$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $69d723089b47cf34$var$xn(u) && o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $a70cf465074cab30$export$6d9c69b0de29b591)(function() {
        return $69d723089b47cf34$var$xn(u) && o({
            h: u
        }), n(function() {
            $69d723089b47cf34$var$xn(u) && o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
function $69d723089b47cf34$var$xn(n) {
    var t, e, r = n.v, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
var $69d723089b47cf34$export$2e2bcd8739ae039 = {
    useState: (0, $a70cf465074cab30$export$60241385465d0a34),
    useId: (0, $a70cf465074cab30$export$f680877a34711e37),
    useReducer: (0, $a70cf465074cab30$export$13e3392192263954),
    useEffect: (0, $a70cf465074cab30$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $a70cf465074cab30$export$e5c5a5f917a5871c),
    useInsertionEffect: $69d723089b47cf34$export$aaabe4eda9ed9969,
    useTransition: $69d723089b47cf34$export$7b286972b8d8ccbf,
    useDeferredValue: $69d723089b47cf34$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $69d723089b47cf34$export$306c0aa65ff9ec16,
    startTransition: $69d723089b47cf34$export$7568632d0d33d16d,
    useRef: (0, $a70cf465074cab30$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $a70cf465074cab30$export$d5a552a76deda3c2),
    useMemo: (0, $a70cf465074cab30$export$1538c33de8887b59),
    useCallback: (0, $a70cf465074cab30$export$35808ee640e87ca7),
    useContext: (0, $a70cf465074cab30$export$fae74005e78b1a27),
    useDebugValue: (0, $a70cf465074cab30$export$dc8fbce3eb94dc1e),
    version: "17.0.2",
    Children: $69d723089b47cf34$export$dca3b0875bd9a954,
    render: $69d723089b47cf34$export$b3890eb0ae9dca99,
    hydrate: $69d723089b47cf34$export$fa8d919ba61d84db,
    unmountComponentAtNode: $69d723089b47cf34$export$502457920280e6be,
    createPortal: $69d723089b47cf34$export$d39a5bbd09211389,
    createElement: (0, $e48b1195589f71e3$export$c8a8987d4410bf2d),
    createContext: (0, $e48b1195589f71e3$export$fd42f52fd3ae1109),
    createFactory: $69d723089b47cf34$export$d38cd72104c1f0e9,
    cloneElement: $69d723089b47cf34$export$e530037191fcd5d7,
    createRef: (0, $e48b1195589f71e3$export$7d1e3a5e95ceca43),
    Fragment: (0, $e48b1195589f71e3$export$ffb0004e005737fa),
    isValidElement: $69d723089b47cf34$export$a8257692ac88316c,
    isElement: $69d723089b47cf34$export$45a5e7f76e0caa8d,
    isFragment: $69d723089b47cf34$export$9522e17588c12572,
    isMemo: $69d723089b47cf34$export$56885ab8b9c456ab,
    findDOMNode: $69d723089b47cf34$export$466bfc07425424d5,
    Component: (0, $e48b1195589f71e3$export$16fa2f45be04daa8),
    PureComponent: $69d723089b47cf34$export$221d75b3f55bb0bd,
    memo: $69d723089b47cf34$export$7c73462e0d25e514,
    forwardRef: $69d723089b47cf34$export$257a8862b851cb5b,
    flushSync: $69d723089b47cf34$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $69d723089b47cf34$export$c78a37762a8d58e1,
    StrictMode: $69d723089b47cf34$export$5f8d39834fd61797,
    Suspense: $69d723089b47cf34$export$74bf444e3cd11ea5,
    SuspenseList: $69d723089b47cf34$export$998bcd577473dd93,
    lazy: $69d723089b47cf34$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $69d723089b47cf34$export$ae55be85d98224ed
};
$parcel$exportWildcard($69d723089b47cf34$exports, $a70cf465074cab30$exports);



function $06caa6fd762958d5$export$882461b6382ed46c(container) {
    return {
        // eslint-disable-next-line
        render: function(children) {
            (0, $69d723089b47cf34$export$b3890eb0ae9dca99)(children, container);
        },
        // eslint-disable-next-line
        unmount: function() {
            (0, $69d723089b47cf34$export$502457920280e6be)(container);
        }
    };
}
function $06caa6fd762958d5$export$757ceba2d55c277e(container, children) {
    (0, $69d723089b47cf34$export$fa8d919ba61d84db)(children, container);
    return $06caa6fd762958d5$export$882461b6382ed46c(container);
}
var $06caa6fd762958d5$export$2e2bcd8739ae039 = {
    createRoot: $06caa6fd762958d5$export$882461b6382ed46c,
    hydrateRoot: $06caa6fd762958d5$export$757ceba2d55c277e
};




/**
 * React Router DOM v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * @remix-run/router v1.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $525aacf624f88612$var$_extends() {
    $525aacf624f88612$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $525aacf624f88612$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $525aacf624f88612$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($525aacf624f88612$export$e19cd5f9376f8cee || ($525aacf624f88612$export$e19cd5f9376f8cee = {}));
const $525aacf624f88612$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $525aacf624f88612$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $525aacf624f88612$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $525aacf624f88612$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $525aacf624f88612$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $525aacf624f88612$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $525aacf624f88612$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $525aacf624f88612$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $525aacf624f88612$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $525aacf624f88612$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $525aacf624f88612$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $525aacf624f88612$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $525aacf624f88612$export$fe53371bee54353d(to);
    }
    return $525aacf624f88612$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $525aacf624f88612$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $525aacf624f88612$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $525aacf624f88612$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $525aacf624f88612$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $525aacf624f88612$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $525aacf624f88612$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $525aacf624f88612$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $525aacf624f88612$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $525aacf624f88612$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $525aacf624f88612$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $525aacf624f88612$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $525aacf624f88612$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $525aacf624f88612$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $525aacf624f88612$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $525aacf624f88612$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $525aacf624f88612$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $525aacf624f88612$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $525aacf624f88612$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($525aacf624f88612$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $525aacf624f88612$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $525aacf624f88612$export$e19cd5f9376f8cee.Push;
        let location = $525aacf624f88612$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $525aacf624f88612$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $525aacf624f88612$export$e19cd5f9376f8cee.Replace;
        let location = $525aacf624f88612$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $525aacf624f88612$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $525aacf624f88612$export$fe53371bee54353d(to);
        $525aacf624f88612$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($525aacf624f88612$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($525aacf624f88612$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $525aacf624f88612$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($525aacf624f88612$var$ResultType || ($525aacf624f88612$var$ResultType = {}));
const $525aacf624f88612$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $525aacf624f88612$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $525aacf624f88612$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $525aacf624f88612$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $525aacf624f88612$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($525aacf624f88612$var$isIndexRoute(route)) {
            let indexRoute = $525aacf624f88612$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $525aacf624f88612$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $525aacf624f88612$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $525aacf624f88612$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $525aacf624f88612$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $525aacf624f88612$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $525aacf624f88612$var$flattenRoutes(routes);
    $525aacf624f88612$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $525aacf624f88612$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $525aacf624f88612$var$safelyDecodeURI(pathname));
    return matches;
}
function $525aacf624f88612$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $525aacf624f88612$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $525aacf624f88612$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $525aacf624f88612$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $525aacf624f88612$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $525aacf624f88612$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $525aacf624f88612$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $525aacf624f88612$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $525aacf624f88612$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $525aacf624f88612$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $525aacf624f88612$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $525aacf624f88612$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $525aacf624f88612$var$paramRe = /^:\w+$/;
const $525aacf624f88612$var$dynamicSegmentValue = 3;
const $525aacf624f88612$var$indexRouteValue = 2;
const $525aacf624f88612$var$emptySegmentValue = 1;
const $525aacf624f88612$var$staticSegmentValue = 10;
const $525aacf624f88612$var$splatPenalty = -2;
const $525aacf624f88612$var$isSplat = (s)=>s === "*";
function $525aacf624f88612$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($525aacf624f88612$var$isSplat)) initialScore += $525aacf624f88612$var$splatPenalty;
    if (index) initialScore += $525aacf624f88612$var$indexRouteValue;
    return segments.filter((s)=>!$525aacf624f88612$var$isSplat(s)).reduce((score, segment)=>score + ($525aacf624f88612$var$paramRe.test(segment) ? $525aacf624f88612$var$dynamicSegmentValue : segment === "" ? $525aacf624f88612$var$emptySegmentValue : $525aacf624f88612$var$staticSegmentValue), initialScore);
}
function $525aacf624f88612$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $525aacf624f88612$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $525aacf624f88612$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $525aacf624f88612$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $525aacf624f88612$export$a5c6d149b50c1d86($525aacf624f88612$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $525aacf624f88612$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $525aacf624f88612$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $525aacf624f88612$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $525aacf624f88612$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $525aacf624f88612$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $525aacf624f88612$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $525aacf624f88612$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $525aacf624f88612$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $525aacf624f88612$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $525aacf624f88612$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $525aacf624f88612$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $525aacf624f88612$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $525aacf624f88612$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $525aacf624f88612$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $525aacf624f88612$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $525aacf624f88612$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $525aacf624f88612$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $525aacf624f88612$var$normalizeSearch(search),
        hash: $525aacf624f88612$var$normalizeHash(hash)
    };
}
function $525aacf624f88612$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $525aacf624f88612$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $525aacf624f88612$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $525aacf624f88612$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $525aacf624f88612$export$8ccf933b0513f8d0(toArg);
    else {
        to = $525aacf624f88612$var$_extends({}, toArg);
        $525aacf624f88612$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $525aacf624f88612$var$getInvalidPathError("?", "pathname", "search", to));
        $525aacf624f88612$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $525aacf624f88612$var$getInvalidPathError("#", "pathname", "hash", to));
        $525aacf624f88612$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $525aacf624f88612$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $525aacf624f88612$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $525aacf624f88612$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $525aacf624f88612$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $525aacf624f88612$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $525aacf624f88612$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $525aacf624f88612$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $525aacf624f88612$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $525aacf624f88612$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $525aacf624f88612$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $525aacf624f88612$export$42a99a7a4bc0e76a extends Error {
}
class $525aacf624f88612$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $525aacf624f88612$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $525aacf624f88612$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $525aacf624f88612$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $525aacf624f88612$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $525aacf624f88612$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $525aacf624f88612$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $525aacf624f88612$var$unwrapTrackedPromise(value) {
    if (!$525aacf624f88612$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $525aacf624f88612$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $525aacf624f88612$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $525aacf624f88612$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $525aacf624f88612$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $525aacf624f88612$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $525aacf624f88612$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $525aacf624f88612$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $525aacf624f88612$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $525aacf624f88612$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $525aacf624f88612$var$validMutationMethods = new Set($525aacf624f88612$var$validMutationMethodsArr);
const $525aacf624f88612$var$validRequestMethodsArr = [
    "get",
    ...$525aacf624f88612$var$validMutationMethodsArr
];
const $525aacf624f88612$var$validRequestMethods = new Set($525aacf624f88612$var$validRequestMethodsArr);
const $525aacf624f88612$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $525aacf624f88612$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $525aacf624f88612$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $525aacf624f88612$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $525aacf624f88612$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $525aacf624f88612$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $525aacf624f88612$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $525aacf624f88612$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $525aacf624f88612$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $525aacf624f88612$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $525aacf624f88612$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $525aacf624f88612$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $525aacf624f88612$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $525aacf624f88612$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $525aacf624f88612$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $525aacf624f88612$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $525aacf624f88612$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $525aacf624f88612$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $525aacf624f88612$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $525aacf624f88612$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $525aacf624f88612$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$525aacf624f88612$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($525aacf624f88612$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $525aacf624f88612$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state, {
                unstable_viewTransitionOpts: viewTransitionOpts
            }));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $525aacf624f88612$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $525aacf624f88612$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $525aacf624f88612$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $525aacf624f88612$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $525aacf624f88612$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $525aacf624f88612$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $525aacf624f88612$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $525aacf624f88612$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($525aacf624f88612$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $525aacf624f88612$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $525aacf624f88612$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $525aacf624f88612$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $525aacf624f88612$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $525aacf624f88612$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $525aacf624f88612$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $525aacf624f88612$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $525aacf624f88612$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $525aacf624f88612$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $525aacf624f88612$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $525aacf624f88612$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $525aacf624f88612$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $525aacf624f88612$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $525aacf624f88612$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $525aacf624f88612$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $525aacf624f88612$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $525aacf624f88612$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$525aacf624f88612$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $525aacf624f88612$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $525aacf624f88612$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $525aacf624f88612$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $525aacf624f88612$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $525aacf624f88612$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $525aacf624f88612$var$ResultType.error,
            error: $525aacf624f88612$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $525aacf624f88612$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($525aacf624f88612$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($525aacf624f88612$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $525aacf624f88612$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $525aacf624f88612$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($525aacf624f88612$var$isDeferredResult(result)) throw $525aacf624f88612$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $525aacf624f88612$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $525aacf624f88612$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $525aacf624f88612$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $525aacf624f88612$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $525aacf624f88612$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($525aacf624f88612$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $525aacf624f88612$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $525aacf624f88612$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $525aacf624f88612$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $525aacf624f88612$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $525aacf624f88612$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $525aacf624f88612$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $525aacf624f88612$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $525aacf624f88612$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $525aacf624f88612$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $525aacf624f88612$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $525aacf624f88612$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $525aacf624f88612$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $525aacf624f88612$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $525aacf624f88612$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($525aacf624f88612$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $525aacf624f88612$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $525aacf624f88612$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($525aacf624f88612$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($525aacf624f88612$var$isDeferredResult(actionResult)) throw $525aacf624f88612$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $525aacf624f88612$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $525aacf624f88612$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $525aacf624f88612$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $525aacf624f88612$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $525aacf624f88612$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $525aacf624f88612$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $525aacf624f88612$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $525aacf624f88612$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $525aacf624f88612$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $525aacf624f88612$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($525aacf624f88612$var$_extends({
                errors: errors,
                loaderData: $525aacf624f88612$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $525aacf624f88612$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $525aacf624f88612$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $525aacf624f88612$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($525aacf624f88612$var$isDeferredResult(result)) result = await $525aacf624f88612$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($525aacf624f88612$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $525aacf624f88612$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($525aacf624f88612$var$isErrorResult(result)) {
            let boundaryMatch = $525aacf624f88612$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $525aacf624f88612$export$3e9cee6b33872309(!$525aacf624f88612$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $525aacf624f88612$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $525aacf624f88612$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $525aacf624f88612$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($525aacf624f88612$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $525aacf624f88612$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $525aacf624f88612$export$e19cd5f9376f8cee.Replace : $525aacf624f88612$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $525aacf624f88612$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($525aacf624f88612$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $525aacf624f88612$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $525aacf624f88612$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $525aacf624f88612$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$525aacf624f88612$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $525aacf624f88612$var$callLoaderOrAction("loader", $525aacf624f88612$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $525aacf624f88612$var$ResultType.error,
                        error: $525aacf624f88612$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $525aacf624f88612$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $525aacf624f88612$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $525aacf624f88612$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $525aacf624f88612$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $525aacf624f88612$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $525aacf624f88612$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $525aacf624f88612$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $525aacf624f88612$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $525aacf624f88612$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $525aacf624f88612$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $525aacf624f88612$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $525aacf624f88612$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$525aacf624f88612$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $525aacf624f88612$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $525aacf624f88612$export$4d0306f8f6a4585b = Symbol("deferred");
function $525aacf624f88612$export$3336b097a6fbc59a(routes, opts) {
    $525aacf624f88612$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $525aacf624f88612$var$defaultMapRouteProperties;
    let dataRoutes = $525aacf624f88612$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $525aacf624f88612$var$createLocation("", $525aacf624f88612$export$fe53371bee54353d(url), null, "default");
        let matches = $525aacf624f88612$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$525aacf624f88612$var$isValidMethod(method) && method !== "HEAD") {
            let error = $525aacf624f88612$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $525aacf624f88612$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $525aacf624f88612$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $525aacf624f88612$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($525aacf624f88612$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $525aacf624f88612$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $525aacf624f88612$var$createLocation("", $525aacf624f88612$export$fe53371bee54353d(url), null, "default");
        let matches = $525aacf624f88612$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$525aacf624f88612$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $525aacf624f88612$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $525aacf624f88612$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $525aacf624f88612$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $525aacf624f88612$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $525aacf624f88612$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($525aacf624f88612$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$525aacf624f88612$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $525aacf624f88612$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($525aacf624f88612$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $525aacf624f88612$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $525aacf624f88612$var$isResponse(result) ? result : $525aacf624f88612$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($525aacf624f88612$var$isQueryRouteResponse(e)) {
                if (e.type === $525aacf624f88612$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($525aacf624f88612$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $525aacf624f88612$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $525aacf624f88612$var$ResultType.error,
                error: error
            };
        } else {
            result = await $525aacf624f88612$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($525aacf624f88612$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($525aacf624f88612$var$isDeferredResult(result)) {
            let error = $525aacf624f88612$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $525aacf624f88612$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($525aacf624f88612$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($525aacf624f88612$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $525aacf624f88612$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $525aacf624f88612$var$_extends({}, context, {
                statusCode: $525aacf624f88612$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $525aacf624f88612$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $525aacf624f88612$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $525aacf624f88612$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $525aacf624f88612$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $525aacf624f88612$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$525aacf624f88612$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $525aacf624f88612$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $525aacf624f88612$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $525aacf624f88612$export$fec11da027c70692(routes, context, error) {
    let newContext = $525aacf624f88612$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $525aacf624f88612$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $525aacf624f88612$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $525aacf624f88612$export$cae722b0cc860f13(to ? to : ".", $525aacf624f88612$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $525aacf624f88612$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$525aacf624f88612$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $525aacf624f88612$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $525aacf624f88612$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $525aacf624f88612$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$525aacf624f88612$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$525aacf624f88612$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $525aacf624f88612$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $525aacf624f88612$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $525aacf624f88612$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$525aacf624f88612$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$525aacf624f88612$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $525aacf624f88612$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $525aacf624f88612$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $525aacf624f88612$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $525aacf624f88612$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $525aacf624f88612$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($525aacf624f88612$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $525aacf624f88612$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $525aacf624f88612$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $525aacf624f88612$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $525aacf624f88612$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $525aacf624f88612$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $525aacf624f88612$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($525aacf624f88612$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $525aacf624f88612$var$shouldRevalidateLoader(match, $525aacf624f88612$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $525aacf624f88612$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $525aacf624f88612$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $525aacf624f88612$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $525aacf624f88612$var$shouldRevalidateLoader(fetcherMatch, $525aacf624f88612$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $525aacf624f88612$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $525aacf624f88612$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $525aacf624f88612$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $525aacf624f88612$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $525aacf624f88612$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $525aacf624f88612$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$525aacf624f88612$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $525aacf624f88612$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $525aacf624f88612$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $525aacf624f88612$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $525aacf624f88612$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $525aacf624f88612$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $525aacf624f88612$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $525aacf624f88612$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $525aacf624f88612$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $525aacf624f88612$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($525aacf624f88612$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($525aacf624f88612$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $525aacf624f88612$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$525aacf624f88612$var$ABSOLUTE_URL_REGEX.test(location)) location = $525aacf624f88612$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $525aacf624f88612$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $525aacf624f88612$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $525aacf624f88612$var$ResultType.error ? $525aacf624f88612$var$ResultType.error : $525aacf624f88612$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $525aacf624f88612$var$ResultType.error) return {
            type: resultType,
            error: new $525aacf624f88612$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $525aacf624f88612$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $525aacf624f88612$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($525aacf624f88612$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $525aacf624f88612$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $525aacf624f88612$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $525aacf624f88612$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($525aacf624f88612$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $525aacf624f88612$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $525aacf624f88612$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $525aacf624f88612$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $525aacf624f88612$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $525aacf624f88612$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $525aacf624f88612$export$3e9cee6b33872309(!$525aacf624f88612$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($525aacf624f88612$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $525aacf624f88612$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $525aacf624f88612$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($525aacf624f88612$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $525aacf624f88612$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $525aacf624f88612$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $525aacf624f88612$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($525aacf624f88612$var$isErrorResult(result)) {
            let boundaryMatch = $525aacf624f88612$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $525aacf624f88612$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($525aacf624f88612$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $525aacf624f88612$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($525aacf624f88612$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $525aacf624f88612$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $525aacf624f88612$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $525aacf624f88612$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $525aacf624f88612$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $525aacf624f88612$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $525aacf624f88612$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $525aacf624f88612$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $525aacf624f88612$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $525aacf624f88612$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($525aacf624f88612$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $525aacf624f88612$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $525aacf624f88612$export$8ccf933b0513f8d0(path) : path;
    return $525aacf624f88612$export$fe53371bee54353d($525aacf624f88612$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $525aacf624f88612$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $525aacf624f88612$var$isDeferredResult(result) {
    return result.type === $525aacf624f88612$var$ResultType.deferred;
}
function $525aacf624f88612$var$isErrorResult(result) {
    return result.type === $525aacf624f88612$var$ResultType.error;
}
function $525aacf624f88612$var$isRedirectResult(result) {
    return (result && result.type) === $525aacf624f88612$var$ResultType.redirect;
}
function $525aacf624f88612$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $525aacf624f88612$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $525aacf624f88612$var$isRedirectResponse(result) {
    if (!$525aacf624f88612$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $525aacf624f88612$var$isQueryRouteResponse(obj) {
    return obj && $525aacf624f88612$var$isResponse(obj.response) && (obj.type === $525aacf624f88612$var$ResultType.data || obj.type === $525aacf624f88612$var$ResultType.error);
}
function $525aacf624f88612$var$isValidMethod(method) {
    return $525aacf624f88612$var$validRequestMethods.has(method.toLowerCase());
}
function $525aacf624f88612$var$isMutationMethod(method) {
    return $525aacf624f88612$var$validMutationMethods.has(method.toLowerCase());
}
async function $525aacf624f88612$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$525aacf624f88612$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($525aacf624f88612$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $525aacf624f88612$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $525aacf624f88612$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $525aacf624f88612$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $525aacf624f88612$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $525aacf624f88612$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $525aacf624f88612$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $525aacf624f88612$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $525aacf624f88612$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $525aacf624f88612$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $525aacf624f88612$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $525aacf624f88612$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $525aacf624f88612$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $525aacf624f88612$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $525aacf624f88612$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $525aacf624f88612$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $525aacf624f88612$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $525aacf624f88612$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $525aacf624f88612$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($525aacf624f88612$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $525aacf624f88612$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($525aacf624f88612$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $525aacf624f88612$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

function $23ae8c349145cf41$var$_extends() {
    $23ae8c349145cf41$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $23ae8c349145cf41$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $23ae8c349145cf41$export$3add0d5dce533e2e = /*#__PURE__*/ $69d723089b47cf34$exports.createContext(null);
const $23ae8c349145cf41$export$145dfa71566a64dc = /*#__PURE__*/ $69d723089b47cf34$exports.createContext(null);
const $23ae8c349145cf41$var$AwaitContext = /*#__PURE__*/ $69d723089b47cf34$exports.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $23ae8c349145cf41$export$26749e8557646306 = /*#__PURE__*/ $69d723089b47cf34$exports.createContext(null);
const $23ae8c349145cf41$export$c7914228fb69b0f5 = /*#__PURE__*/ $69d723089b47cf34$exports.createContext(null);
const $23ae8c349145cf41$export$9072aa6dd1f93057 = /*#__PURE__*/ $69d723089b47cf34$exports.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $23ae8c349145cf41$var$RouteErrorContext = /*#__PURE__*/ $69d723089b47cf34$exports.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $23ae8c349145cf41$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$23ae8c349145cf41$export$9c954a9d03d32f4a() && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $23ae8c349145cf41$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $525aacf624f88612$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $23ae8c349145cf41$export$9c954a9d03d32f4a() {
    return $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $23ae8c349145cf41$export$45d76561a5302f2b() {
    !$23ae8c349145cf41$export$9c954a9d03d32f4a() && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    return $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $23ae8c349145cf41$export$1b3f31771c5d07c() {
    return $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $23ae8c349145cf41$export$6c330e8992e8a295(pattern) {
    !$23ae8c349145cf41$export$9c954a9d03d32f4a() && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $23ae8c349145cf41$export$45d76561a5302f2b();
    return $69d723089b47cf34$exports.useMemo(()=>(0, $525aacf624f88612$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $23ae8c349145cf41$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $23ae8c349145cf41$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $69d723089b47cf34$exports.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $23ae8c349145cf41$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $23ae8c349145cf41$var$useNavigateStable() : $23ae8c349145cf41$var$useNavigateUnstable();
}
function $23ae8c349145cf41$var$useNavigateUnstable() {
    !$23ae8c349145cf41$export$9c954a9d03d32f4a() && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let dataRouterContext = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$26749e8557646306);
    let { matches: matches } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $23ae8c349145cf41$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $525aacf624f88612$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $69d723089b47cf34$exports.useRef(false);
    $23ae8c349145cf41$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $69d723089b47cf34$exports.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $525aacf624f88612$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $525aacf624f88612$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $23ae8c349145cf41$var$OutletContext = /*#__PURE__*/ $69d723089b47cf34$exports.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $23ae8c349145cf41$export$4138103a3ae699cc() {
    return $69d723089b47cf34$exports.useContext($23ae8c349145cf41$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $23ae8c349145cf41$export$a3be3530d8e40d0b(context) {
    let outlet = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $23ae8c349145cf41$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $23ae8c349145cf41$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $23ae8c349145cf41$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $525aacf624f88612$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $69d723089b47cf34$exports.useMemo(()=>(0, $525aacf624f88612$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $23ae8c349145cf41$export$5d3fca4a98652595(routes, locationArg) {
    return $23ae8c349145cf41$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $23ae8c349145cf41$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$23ae8c349145cf41$export$9c954a9d03d32f4a() && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$26749e8557646306);
    let { matches: parentMatches } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $23ae8c349145cf41$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $525aacf624f88612$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $525aacf624f88612$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $23ae8c349145cf41$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $525aacf624f88612$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $525aacf624f88612$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $23ae8c349145cf41$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $525aacf624f88612$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $23ae8c349145cf41$var$DefaultErrorComponent() {
    let error = $23ae8c349145cf41$export$ed527bf60f6e05f2();
    let message = (0, $525aacf624f88612$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($69d723089b47cf34$exports.Fragment, null, /*#__PURE__*/ $69d723089b47cf34$exports.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $69d723089b47cf34$exports.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $69d723089b47cf34$exports.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $23ae8c349145cf41$var$defaultErrorElement = /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$DefaultErrorComponent, null);
class $23ae8c349145cf41$var$RenderErrorBoundary extends $69d723089b47cf34$exports.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $23ae8c349145cf41$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $23ae8c349145cf41$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $23ae8c349145cf41$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $69d723089b47cf34$exports.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $23ae8c349145cf41$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($23ae8c349145cf41$var$DataRouterHook || {});
var $23ae8c349145cf41$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($23ae8c349145cf41$var$DataRouterStateHook || {});
function $23ae8c349145cf41$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $23ae8c349145cf41$var$useDataRouterContext(hookName) {
    let ctx = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$3add0d5dce533e2e);
    !ctx && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    return ctx;
}
function $23ae8c349145cf41$var$useDataRouterState(hookName) {
    let state = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$145dfa71566a64dc);
    !state && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    return state;
}
function $23ae8c349145cf41$var$useRouteContext(hookName) {
    let route = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057);
    !route && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $23ae8c349145cf41$var$useCurrentRouteId(hookName) {
    let route = $23ae8c349145cf41$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $23ae8c349145cf41$export$5fc8298006ad9e58() {
    return $23ae8c349145cf41$var$useCurrentRouteId($23ae8c349145cf41$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $23ae8c349145cf41$export$d0fd4b7106de2769() {
    let state = $23ae8c349145cf41$var$useDataRouterState($23ae8c349145cf41$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $23ae8c349145cf41$export$600dc272ed516c15() {
    let dataRouterContext = $23ae8c349145cf41$var$useDataRouterContext($23ae8c349145cf41$var$DataRouterHook.UseRevalidator);
    let state = $23ae8c349145cf41$var$useDataRouterState($23ae8c349145cf41$var$DataRouterStateHook.UseRevalidator);
    return $69d723089b47cf34$exports.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $23ae8c349145cf41$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $23ae8c349145cf41$var$useDataRouterState($23ae8c349145cf41$var$DataRouterStateHook.UseMatches);
    return $69d723089b47cf34$exports.useMemo(()=>matches.map((m)=>(0, $525aacf624f88612$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $23ae8c349145cf41$export$1448a5050d252c4d() {
    let state = $23ae8c349145cf41$var$useDataRouterState($23ae8c349145cf41$var$DataRouterStateHook.UseLoaderData);
    let routeId = $23ae8c349145cf41$var$useCurrentRouteId($23ae8c349145cf41$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $23ae8c349145cf41$export$fd5d37484eab868d(routeId) {
    let state = $23ae8c349145cf41$var$useDataRouterState($23ae8c349145cf41$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $23ae8c349145cf41$export$fdc00f3f26066d5e() {
    let state = $23ae8c349145cf41$var$useDataRouterState($23ae8c349145cf41$var$DataRouterStateHook.UseActionData);
    let route = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057);
    !route && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $23ae8c349145cf41$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$var$RouteErrorContext);
    let state = $23ae8c349145cf41$var$useDataRouterState($23ae8c349145cf41$var$DataRouterStateHook.UseRouteError);
    let routeId = $23ae8c349145cf41$var$useCurrentRouteId($23ae8c349145cf41$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $23ae8c349145cf41$export$78a72ddb39bdd145() {
    let value = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $23ae8c349145cf41$export$17f53340677d5831() {
    let value = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $23ae8c349145cf41$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $23ae8c349145cf41$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $23ae8c349145cf41$var$useDataRouterContext($23ae8c349145cf41$var$DataRouterHook.UseBlocker);
    let state = $23ae8c349145cf41$var$useDataRouterState($23ae8c349145cf41$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $69d723089b47cf34$exports.useState("");
    let blockerFunction = $69d723089b47cf34$exports.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $23ae8c349145cf41$var$_extends({}, currentLocation, {
                pathname: (0, $525aacf624f88612$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $23ae8c349145cf41$var$_extends({}, nextLocation, {
                pathname: (0, $525aacf624f88612$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $69d723089b47cf34$exports.useEffect(()=>{
        let key = String(++$23ae8c349145cf41$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $69d723089b47cf34$exports.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $525aacf624f88612$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $23ae8c349145cf41$var$useNavigateStable() {
    let { router: router } = $23ae8c349145cf41$var$useDataRouterContext($23ae8c349145cf41$var$DataRouterHook.UseNavigateStable);
    let id = $23ae8c349145cf41$var$useCurrentRouteId($23ae8c349145cf41$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $69d723089b47cf34$exports.useRef(false);
    $23ae8c349145cf41$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $69d723089b47cf34$exports.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $23ae8c349145cf41$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $23ae8c349145cf41$var$alreadyWarned = {};
function $23ae8c349145cf41$var$warningOnce(key, cond, message) {
    if (!cond && !$23ae8c349145cf41$var$alreadyWarned[key]) $23ae8c349145cf41$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $23ae8c349145cf41$var$START_TRANSITION = "startTransition";
const $23ae8c349145cf41$var$startTransitionImpl = $69d723089b47cf34$exports[$23ae8c349145cf41$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $23ae8c349145cf41$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $69d723089b47cf34$exports.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $69d723089b47cf34$exports.useCallback((newState)=>{
        if (v7_startTransition && $23ae8c349145cf41$var$startTransitionImpl) $23ae8c349145cf41$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $69d723089b47cf34$exports.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $69d723089b47cf34$exports.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $69d723089b47cf34$exports.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($69d723089b47cf34$exports.Fragment, null, /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $23ae8c349145cf41$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $23ae8c349145cf41$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $23ae8c349145cf41$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $69d723089b47cf34$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $525aacf624f88612$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $69d723089b47cf34$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $69d723089b47cf34$exports.useCallback((newState)=>{
        v7_startTransition && $23ae8c349145cf41$var$startTransitionImpl ? $23ae8c349145cf41$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $69d723089b47cf34$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $23ae8c349145cf41$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$23ae8c349145cf41$export$9c954a9d03d32f4a() && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let { matches: matches } = $69d723089b47cf34$exports.useContext($23ae8c349145cf41$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $23ae8c349145cf41$export$45d76561a5302f2b();
    let navigate = $23ae8c349145cf41$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $525aacf624f88612$export$cae722b0cc860f13)(to, (0, $525aacf624f88612$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $69d723089b47cf34$exports.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $23ae8c349145cf41$export$910ae8079b2c2852(props) {
    return $23ae8c349145cf41$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $23ae8c349145cf41$export$e7b0ac011bb776c6(_props) {
    (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $23ae8c349145cf41$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $525aacf624f88612$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$23ae8c349145cf41$export$9c954a9d03d32f4a() && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $69d723089b47cf34$exports.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $525aacf624f88612$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $69d723089b47cf34$exports.useMemo(()=>{
        let trailingPathname = (0, $525aacf624f88612$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $23ae8c349145cf41$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $23ae8c349145cf41$export$5d3fca4a98652595($23ae8c349145cf41$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $23ae8c349145cf41$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$ResolveAwait, null, children));
}
var $23ae8c349145cf41$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($23ae8c349145cf41$var$AwaitRenderStatus || {});
const $23ae8c349145cf41$var$neverSettledPromise = new Promise(()=>{});
class $23ae8c349145cf41$var$AwaitErrorBoundary extends $69d723089b47cf34$exports.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $23ae8c349145cf41$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $23ae8c349145cf41$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $23ae8c349145cf41$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $23ae8c349145cf41$var$AwaitRenderStatus.error : promise._data !== undefined ? $23ae8c349145cf41$var$AwaitRenderStatus.success : $23ae8c349145cf41$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $23ae8c349145cf41$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $23ae8c349145cf41$var$AwaitRenderStatus.error && promise._error instanceof (0, $525aacf624f88612$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $23ae8c349145cf41$var$neverSettledPromise;
        if (status === $23ae8c349145cf41$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $23ae8c349145cf41$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $23ae8c349145cf41$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($23ae8c349145cf41$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $23ae8c349145cf41$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $23ae8c349145cf41$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($69d723089b47cf34$exports.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $23ae8c349145cf41$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $69d723089b47cf34$exports.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $69d723089b47cf34$exports.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $69d723089b47cf34$exports.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $23ae8c349145cf41$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $23ae8c349145cf41$export$e7b0ac011bb776c6) && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $23ae8c349145cf41$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $23ae8c349145cf41$export$daf73786167a7f72(matches) {
    return $23ae8c349145cf41$var$_renderMatches(matches);
}
function $23ae8c349145cf41$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $69d723089b47cf34$exports.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $69d723089b47cf34$exports.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $23ae8c349145cf41$export$f30f7e456d254e83(routes, opts) {
    return (0, $525aacf624f88612$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $23ae8c349145cf41$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $525aacf624f88612$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $23ae8c349145cf41$export$52b333d321859367
    }).initialize();
}



function $f1091c596cd24cbd$var$_extends() {
    $f1091c596cd24cbd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f1091c596cd24cbd$var$_extends.apply(this, arguments);
}
function $f1091c596cd24cbd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $f1091c596cd24cbd$var$defaultMethod = "get";
const $f1091c596cd24cbd$var$defaultEncType = "application/x-www-form-urlencoded";
function $f1091c596cd24cbd$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $f1091c596cd24cbd$var$isButtonElement(object) {
    return $f1091c596cd24cbd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $f1091c596cd24cbd$var$isFormElement(object) {
    return $f1091c596cd24cbd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $f1091c596cd24cbd$var$isInputElement(object) {
    return $f1091c596cd24cbd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $f1091c596cd24cbd$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $f1091c596cd24cbd$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$f1091c596cd24cbd$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $f1091c596cd24cbd$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $f1091c596cd24cbd$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $f1091c596cd24cbd$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $f1091c596cd24cbd$var$_formDataSupportsSubmitter = null;
function $f1091c596cd24cbd$var$isFormDataSubmitterSupported() {
    if ($f1091c596cd24cbd$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $f1091c596cd24cbd$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $f1091c596cd24cbd$var$_formDataSupportsSubmitter = true;
    }
    return $f1091c596cd24cbd$var$_formDataSupportsSubmitter;
}
const $f1091c596cd24cbd$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $f1091c596cd24cbd$var$getFormEncType(encType) {
    if (encType != null && !$f1091c596cd24cbd$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $f1091c596cd24cbd$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($f1091c596cd24cbd$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $525aacf624f88612$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $f1091c596cd24cbd$var$defaultMethod;
        encType = $f1091c596cd24cbd$var$getFormEncType(target.getAttribute("enctype")) || $f1091c596cd24cbd$var$defaultEncType;
        formData = new FormData(target);
    } else if ($f1091c596cd24cbd$var$isButtonElement(target) || $f1091c596cd24cbd$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $525aacf624f88612$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $f1091c596cd24cbd$var$defaultMethod;
        encType = $f1091c596cd24cbd$var$getFormEncType(target.getAttribute("formenctype")) || $f1091c596cd24cbd$var$getFormEncType(form.getAttribute("enctype")) || $f1091c596cd24cbd$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$f1091c596cd24cbd$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($f1091c596cd24cbd$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $f1091c596cd24cbd$var$defaultMethod;
        action = null;
        encType = $f1091c596cd24cbd$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $f1091c596cd24cbd$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $f1091c596cd24cbd$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $f1091c596cd24cbd$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $f1091c596cd24cbd$export$1f3f55432a00e06d(routes, opts) {
    return (0, $525aacf624f88612$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f1091c596cd24cbd$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $525aacf624f88612$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $f1091c596cd24cbd$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $23ae8c349145cf41$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $f1091c596cd24cbd$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $525aacf624f88612$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f1091c596cd24cbd$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $525aacf624f88612$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $f1091c596cd24cbd$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $23ae8c349145cf41$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $f1091c596cd24cbd$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $f1091c596cd24cbd$var$_extends({}, state, {
        errors: $f1091c596cd24cbd$var$deserializeErrors(state.errors)
    });
    return state;
}
function $f1091c596cd24cbd$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $525aacf624f88612$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $f1091c596cd24cbd$export$7ad602f0e94e62d1 = /*#__PURE__*/ $69d723089b47cf34$exports.createContext({
    isTransitioning: false
});
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f1091c596cd24cbd$var$START_TRANSITION = "startTransition";
const $f1091c596cd24cbd$var$startTransitionImpl = $69d723089b47cf34$exports[$f1091c596cd24cbd$var$START_TRANSITION];
function $f1091c596cd24cbd$var$startTransitionSafe(cb) {
    if ($f1091c596cd24cbd$var$startTransitionImpl) $f1091c596cd24cbd$var$startTransitionImpl(cb);
    else cb();
}
class $f1091c596cd24cbd$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f1091c596cd24cbd$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $69d723089b47cf34$exports.useState(router.state);
    let [pendingState, setPendingState] = $69d723089b47cf34$exports.useState();
    let [vtContext, setVtContext] = $69d723089b47cf34$exports.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $69d723089b47cf34$exports.useState();
    let [transition, setTransition] = $69d723089b47cf34$exports.useState();
    let [interruption, setInterruption] = $69d723089b47cf34$exports.useState();
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $69d723089b47cf34$exports.useCallback((cb)=>{
        if (v7_startTransition) $f1091c596cd24cbd$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $69d723089b47cf34$exports.useCallback((newState, _ref2)=>{
        let { unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(()=>setStateImpl(newState));
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        optInStartTransition,
        transition,
        renderDfd,
        router.window
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $69d723089b47cf34$exports.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $69d723089b47cf34$exports.useEffect(()=>{
        if (vtContext.isTransitioning) setRenderDfd(new $f1091c596cd24cbd$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $69d723089b47cf34$exports.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $69d723089b47cf34$exports.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $69d723089b47cf34$exports.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $69d723089b47cf34$exports.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $69d723089b47cf34$exports.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($69d723089b47cf34$exports.Fragment, null, /*#__PURE__*/ $69d723089b47cf34$exports.createElement((0, $23ae8c349145cf41$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $69d723089b47cf34$exports.createElement((0, $23ae8c349145cf41$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $69d723089b47cf34$exports.createElement($f1091c596cd24cbd$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $69d723089b47cf34$exports.createElement((0, $23ae8c349145cf41$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $69d723089b47cf34$exports.createElement($f1091c596cd24cbd$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement)))), null);
}
function $f1091c596cd24cbd$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $23ae8c349145cf41$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $f1091c596cd24cbd$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $69d723089b47cf34$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $525aacf624f88612$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $69d723089b47cf34$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $69d723089b47cf34$exports.useCallback((newState)=>{
        v7_startTransition && $f1091c596cd24cbd$var$startTransitionImpl ? $f1091c596cd24cbd$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $69d723089b47cf34$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement((0, $23ae8c349145cf41$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $f1091c596cd24cbd$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $69d723089b47cf34$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $525aacf624f88612$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $69d723089b47cf34$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $69d723089b47cf34$exports.useCallback((newState)=>{
        v7_startTransition && $f1091c596cd24cbd$var$startTransitionImpl ? $f1091c596cd24cbd$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $69d723089b47cf34$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement((0, $23ae8c349145cf41$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $f1091c596cd24cbd$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $69d723089b47cf34$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $69d723089b47cf34$exports.useCallback((newState)=>{
        v7_startTransition && $f1091c596cd24cbd$var$startTransitionImpl ? $f1091c596cd24cbd$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $69d723089b47cf34$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement((0, $23ae8c349145cf41$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $f1091c596cd24cbd$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $f1091c596cd24cbd$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $f1091c596cd24cbd$export$a6c7ac8248d6e38a = /*#__PURE__*/ $69d723089b47cf34$exports.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $f1091c596cd24cbd$var$_objectWithoutPropertiesLoose(_ref7, $f1091c596cd24cbd$var$_excluded);
    let { basename: basename } = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $f1091c596cd24cbd$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($f1091c596cd24cbd$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $525aacf624f88612$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $23ae8c349145cf41$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $f1091c596cd24cbd$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $69d723089b47cf34$exports.createElement("a", $f1091c596cd24cbd$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $f1091c596cd24cbd$export$b0d92dbee9b5b60d = /*#__PURE__*/ $69d723089b47cf34$exports.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $f1091c596cd24cbd$var$_objectWithoutPropertiesLoose(_ref8, $f1091c596cd24cbd$var$_excluded2);
    let path = (0, $23ae8c349145cf41$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $23ae8c349145cf41$export$45d76561a5302f2b)();
    let routerState = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$145dfa71566a64dc));
    let { navigator: navigator } = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $f1091c596cd24cbd$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($f1091c596cd24cbd$export$a6c7ac8248d6e38a, $f1091c596cd24cbd$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $f1091c596cd24cbd$export$a7fed597f4b8afd8 = /*#__PURE__*/ $69d723089b47cf34$exports.forwardRef((props, ref)=>{
    let submit = $f1091c596cd24cbd$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($f1091c596cd24cbd$var$FormImpl, $f1091c596cd24cbd$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $f1091c596cd24cbd$var$FormImpl = /*#__PURE__*/ $69d723089b47cf34$exports.forwardRef((_ref9, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $f1091c596cd24cbd$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $f1091c596cd24cbd$var$_objectWithoutPropertiesLoose(_ref9, $f1091c596cd24cbd$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $f1091c596cd24cbd$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $69d723089b47cf34$exports.createElement("form", $f1091c596cd24cbd$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $f1091c596cd24cbd$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $f1091c596cd24cbd$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $f1091c596cd24cbd$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($f1091c596cd24cbd$var$DataRouterHook || ($f1091c596cd24cbd$var$DataRouterHook = {}));
var $f1091c596cd24cbd$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($f1091c596cd24cbd$var$DataRouterStateHook || ($f1091c596cd24cbd$var$DataRouterStateHook = {}));
function $f1091c596cd24cbd$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $f1091c596cd24cbd$var$useDataRouterContext(hookName) {
    let ctx = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$3add0d5dce533e2e));
    !ctx && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f1091c596cd24cbd$var$useDataRouterState(hookName) {
    let state = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$145dfa71566a64dc));
    !state && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $f1091c596cd24cbd$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $23ae8c349145cf41$export$9770f232ac06a008)();
    let location = (0, $23ae8c349145cf41$export$45d76561a5302f2b)();
    let path = (0, $23ae8c349145cf41$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $69d723089b47cf34$exports.useCallback((event)=>{
        if ($f1091c596cd24cbd$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $525aacf624f88612$export$fe53371bee54353d)(location) === (0, $525aacf624f88612$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $f1091c596cd24cbd$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $69d723089b47cf34$exports.useRef($f1091c596cd24cbd$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $69d723089b47cf34$exports.useRef(false);
    let location = (0, $23ae8c349145cf41$export$45d76561a5302f2b)();
    let searchParams = $69d723089b47cf34$exports.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $f1091c596cd24cbd$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $23ae8c349145cf41$export$9770f232ac06a008)();
    let setSearchParams = $69d723089b47cf34$exports.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $f1091c596cd24cbd$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $f1091c596cd24cbd$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $f1091c596cd24cbd$export$47c85c6e3a081d3() {
    let { router: router } = $f1091c596cd24cbd$var$useDataRouterContext($f1091c596cd24cbd$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$26749e8557646306));
    let currentRouteId = (0, $23ae8c349145cf41$export$5fc8298006ad9e58)();
    return $69d723089b47cf34$exports.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $f1091c596cd24cbd$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $f1091c596cd24cbd$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $f1091c596cd24cbd$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $f1091c596cd24cbd$var$useDataRouterContext($f1091c596cd24cbd$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$26749e8557646306));
    return $69d723089b47cf34$exports.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $f1091c596cd24cbd$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $f1091c596cd24cbd$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $f1091c596cd24cbd$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$26749e8557646306));
    let routeContext = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$9072aa6dd1f93057));
    !routeContext && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $f1091c596cd24cbd$var$_extends({}, (0, $23ae8c349145cf41$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $23ae8c349145cf41$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $525aacf624f88612$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $525aacf624f88612$export$fe53371bee54353d)(path);
}
function $f1091c596cd24cbd$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $69d723089b47cf34$exports.forwardRef((props, ref)=>{
        let submit = $f1091c596cd24cbd$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $69d723089b47cf34$exports.createElement($f1091c596cd24cbd$var$FormImpl, $f1091c596cd24cbd$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $f1091c596cd24cbd$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $f1091c596cd24cbd$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $f1091c596cd24cbd$var$useDataRouterContext($f1091c596cd24cbd$var$DataRouterHook.UseFetcher);
    let route = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$9072aa6dd1f93057));
    !route && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $69d723089b47cf34$exports.useState(()=>String(++$f1091c596cd24cbd$var$fetcherId));
    let [Form] = $69d723089b47cf34$exports.useState(()=>{
        !routeId && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
        return $f1091c596cd24cbd$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $69d723089b47cf34$exports.useState(()=>(href)=>{
            !router && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
            !routeId && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $f1091c596cd24cbd$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $69d723089b47cf34$exports.useMemo(()=>$f1091c596cd24cbd$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $69d723089b47cf34$exports.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $f1091c596cd24cbd$export$fa996778a3a31087() {
    let state = $f1091c596cd24cbd$var$useDataRouterState($f1091c596cd24cbd$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $f1091c596cd24cbd$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $f1091c596cd24cbd$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $f1091c596cd24cbd$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $f1091c596cd24cbd$var$useDataRouterContext($f1091c596cd24cbd$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $f1091c596cd24cbd$var$useDataRouterState($f1091c596cd24cbd$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $69d723089b47cf34$exports.useContext((0, $23ae8c349145cf41$export$26749e8557646306));
    let location = (0, $23ae8c349145cf41$export$45d76561a5302f2b)();
    let matches = (0, $23ae8c349145cf41$export$2378eb7f5ff86053)();
    let navigation = (0, $23ae8c349145cf41$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $69d723089b47cf34$exports.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $f1091c596cd24cbd$var$usePageHide($69d723089b47cf34$exports.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $f1091c596cd24cbd$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $f1091c596cd24cbd$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($f1091c596cd24cbd$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $69d723089b47cf34$exports.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $f1091c596cd24cbd$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $f1091c596cd24cbd$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $69d723089b47cf34$exports.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($f1091c596cd24cbd$var$_extends({}, location, {
                    pathname: (0, $525aacf624f88612$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($f1091c596cd24cbd$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $69d723089b47cf34$exports.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $f1091c596cd24cbd$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $69d723089b47cf34$exports.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $f1091c596cd24cbd$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $69d723089b47cf34$exports.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $f1091c596cd24cbd$export$39f4eb3dbd812741(_ref11) {
    let { when: when, message: message } = _ref11;
    let blocker = (0, $23ae8c349145cf41$export$2af03a1de5c0910)(when);
    $69d723089b47cf34$exports.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $69d723089b47cf34$exports.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $f1091c596cd24cbd$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $69d723089b47cf34$exports.useContext($f1091c596cd24cbd$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $525aacf624f88612$export$3e9cee6b33872309)(false);
    let { basename: basename } = $f1091c596cd24cbd$var$useDataRouterContext($f1091c596cd24cbd$var$DataRouterHook.useViewTransitionState);
    let path = (0, $23ae8c349145cf41$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $525aacf624f88612$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $525aacf624f88612$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $525aacf624f88612$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $525aacf624f88612$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $3afe40411ef8172d$exports = {};
$3afe40411ef8172d$exports = new URL("cleverpenman-transparent.d879d2a2.webp", import.meta.url).toString();


const $5db68e7af9fcf8ff$export$a06f1c675e846f6f = ()=>{
    const primaryItems = [
        {
            name: "Guthaben aufladen",
            href: "https://buy.cleverpenman.com/"
        },
        {
            name: "Blogartikel aus Video generieren",
            href: "/articles/wie-man-aus-einem-video-einen-blog-artikel-generiert"
        },
        {
            name: "Social Media Post aus Video generieren",
            href: "/articles/wie-man-aus-einem-video-einen-blog-artikel-generiert"
        }
    ];
    const secondaryItems = [
        {
            name: "Impressum",
            href: "/impressum"
        },
        {
            name: "Datenschutz",
            href: "/datenschutz"
        }
    ];
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("footer", {
        className: "bg-gray-900 text-white py-8",
        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
            className: "container mx-auto px-4",
            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: "flex flex-col md:flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "mb-6 md:mb-0 md:w-1/3",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                src: new URL($3afe40411ef8172d$exports).href,
                                alt: "CleverPenMan Logo",
                                className: "h-12 mb-4"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                className: "text-sm",
                                children: "CleverPenMan hilft dir, aus Videos schnell und einfach Blogartikel und Social Media Posts zu generieren."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "mb-6 md:mb-0",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                className: "text-lg font-semibold mb-4",
                                children: "Wichtige Themen"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                                children: primaryItems.map((item, index)=>/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        className: "mb-2 list-none",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                            to: item.href,
                                            className: "hover:text-gray-300",
                                            children: item.name
                                        })
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                className: "text-lg font-semibold mb-4",
                                children: "\xdcber uns"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                                children: secondaryItems.map((item, index)=>/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        className: "mb-2 list-none",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                            to: item.href,
                                            className: "hover:text-gray-300",
                                            children: item.name
                                        })
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        })
    });
};






const $c1334e9b7557fad0$export$42cfbb80f7861e77 = ()=>{
    const [menuOpen, setMenuOpen] = (0, $a70cf465074cab30$export$60241385465d0a34)(false);
    const toggleMenu = ()=>{
        setMenuOpen(!menuOpen);
    };
    const primaryItems = [
        {
            name: "3 Schritte von Video zu Artikel",
            href: "/#how"
        },
        {
            name: "Funktionen",
            href: "/#features"
        },
        {
            name: "Preise",
            href: "/#pricing"
        }
    ];
    const secondaryItems = {
        // signin: { name: "Guthaben aufladen", href: "/login" },
        signup: {
            name: "Artikel erstellen",
            href: "/create-transcript"
        }
    };
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("nav", {
        className: "bg-white shadow-lg mb-12 md:mb-0",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: "max-w-6xl mx-auto px-4",
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                            className: "flex space-x-7",
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        className: "flex items-center py-4 px-2",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                                src: new URL($3afe40411ef8172d$exports).href,
                                                alt: "Logo",
                                                className: "h-14 w-14 mr-2"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("span", {
                                                className: "font-semibold text-lg",
                                                children: "CleverPenMan.com"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    className: "hidden md:flex items-center space-x-8",
                                    children: primaryItems.map((item)=>/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                                            className: "py-4 px-2 text-gray-500 font-semibold hover:text-gray-900 transition duration-300",
                                            href: item.href,
                                            children: item.name
                                        }, item.name))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                            className: "hidden md:flex items-center space-x-3",
                            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                to: secondaryItems.signup.href,
                                className: "font-montserrat bg-black px-6 py-2 rounded-lg border-2 border-black border-solid text-white ",
                                children: secondaryItems.signup.name
                            })
                        }),
                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                            className: "md:hidden flex items-center",
                            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                className: "outline-none mobile-menu-button",
                                onClick: toggleMenu,
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("svg", {
                                    className: "w-6 h-6 text-gray-500 hover:text-blue-500",
                                    fill: "none",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("path", {
                                        d: "M4 6h16M4 12h16M4 18h16"
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: `mobile-menu ${menuOpen ? "" : "hidden"}`,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                    className: "px-4 pb-4",
                    children: [
                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                            className: "list-none",
                            children: primaryItems.map((item)=>/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                                        className: "block text-sm px-2 py-4 hover:bg-blue-500 transition duration-300",
                                        href: item.href,
                                        children: item.name
                                    })
                                }, item.name))
                        }),
                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                            className: "flex flex-col items-center space-y-2",
                            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                to: secondaryItems.signup.href,
                                className: "font-montserrat bg-black px-6 py-2 rounded-lg border-2 border-black border-solid text-white ",
                                children: secondaryItems.signup.name
                            })
                        })
                    ]
                })
            })
        ]
    });
};






var $79d162a4cce76e3c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $79d162a4cce76e3c$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === "undefined") _fetch = (...args)=>$79d162a4cce76e3c$var$__awaiter(void 0, void 0, void 0, function*() {
            return yield (yield Promise.resolve((parcelRequire("f5Vhp")))).fetch(...args);
        });
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $17367bd8a14f7b69$export$738689d52335bb3c extends Error {
    constructor(message, name = "FunctionsError", context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $17367bd8a14f7b69$export$14f2b6540d498ce extends $17367bd8a14f7b69$export$738689d52335bb3c {
    constructor(context){
        super("Failed to send a request to the Edge Function", "FunctionsFetchError", context);
    }
}
class $17367bd8a14f7b69$export$d08a45df86040161 extends $17367bd8a14f7b69$export$738689d52335bb3c {
    constructor(context){
        super("Relay Error invoking the Edge Function", "FunctionsRelayError", context);
    }
}
class $17367bd8a14f7b69$export$761f8c0e0fa4624f extends $17367bd8a14f7b69$export$738689d52335bb3c {
    constructor(context){
        super("Edge Function returned a non-2xx status code", "FunctionsHttpError", context);
    }
}


var $588417d55a54c202$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $588417d55a54c202$export$1d0b400bf8a0fa55 {
    constructor(url, { headers: headers = {}, customFetch: customFetch } = {}){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $79d162a4cce76e3c$export$98d92b1aa79f8cc7)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $588417d55a54c202$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, "Content-Type") || !headers)) {
                    if (typeof Blob !== "undefined" && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers["Content-Type"] = "application/octet-stream";
                        body = functionArgs;
                    } else if (typeof functionArgs === "string") {
                        // plain string
                        _headers["Content-Type"] = "text/plain";
                        body = functionArgs;
                    } else if (typeof FormData !== "undefined" && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers["Content-Type"] = "application/json";
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || "POST",
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $17367bd8a14f7b69$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get("x-relay-error");
                if (isRelayError && isRelayError === "true") throw new (0, $17367bd8a14f7b69$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $17367bd8a14f7b69$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get("Content-Type")) !== null && _a !== void 0 ? _a : "text/plain").split(";")[0].trim();
                let data;
                if (responseType === "application/json") data = yield response.json();
                else if (responseType === "application/octet-stream") data = yield response.blob();
                else if (responseType === "multipart/form-data") data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error: error
                };
            }
        });
    }
}


// @ts-ignore

var $2eQj8 = parcelRequire("2eQj8");
class $aa7e4f8644b57275$export$2e2bcd8739ae039 {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === "undefined") this.fetch = (0, (/*@__PURE__*/$parcel$interopDefault($2eQj8)));
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            "GET",
            "HEAD"
        ].includes(this.method)) this.headers["Accept-Profile"] = this.schema;
        else this.headers["Content-Profile"] = this.schema;
        if (this.method !== "GET" && this.method !== "HEAD") this.headers["Content-Type"] = "application/json";
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== "HEAD") {
                    const body = await res.text();
                    if (body === "") ;
                    else if (this.headers["Accept"] === "text/csv") data = body;
                    else if (this.headers["Accept"] && this.headers["Accept"].includes("application/vnd.pgrst.plan+text")) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers["Prefer"]) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get("content-range")) === null || _b === void 0 ? void 0 : _b.split("/");
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === "GET" && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: "PGRST116",
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: "JSON object requested, multiple (or no) rows returned"
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = "Not Acceptable";
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = "OK";
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === "") {
                        status = 204;
                        statusText = "No Content";
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes("Results contain 0 rows"))) {
                    error = null;
                    status = 200;
                    statusText = "OK";
                }
                if (error && this.shouldThrowOnError) throw error;
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ""}`,
                    hint: "",
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ""}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ""
            };
        });
        return res.then(onfulfilled, onrejected);
    }
}


class $e9af4d8c4ba4c1ff$export$2e2bcd8739ae039 extends (0, $aa7e4f8644b57275$export$2e2bcd8739ae039) {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === '"') quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        if (this.headers["Prefer"]) this.headers["Prefer"] += ",";
        this.headers["Prefer"] += "return=representation";
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order foreign tables, but it doesn't affect the ordering of the
     * current table.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.foreignTable - Set this to order a foreign table by foreign
     * columns
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable } = {}) {
        const key = foreignTable ? `${foreignTable}.order` : "order";
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ""}${column}.${ascending ? "asc" : "desc"}${nullsFirst === undefined ? "" : nullsFirst ? ".nullsfirst" : ".nullslast"}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.foreignTable - Set this to limit rows of foreign tables
     * instead of the current table
     */ limit(count, { foreignTable: foreignTable } = {}) {
        const key = typeof foreignTable === "undefined" ? "limit" : `${foreignTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset (`from`) and ending at the offset (`from + to`).
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.foreignTable - Set this to limit rows of foreign tables
     * instead of the current table
     */ range(from, to, { foreignTable: foreignTable } = {}) {
        const keyOffset = typeof foreignTable === "undefined" ? "offset" : `${foreignTable}.offset`;
        const keyLimit = typeof foreignTable === "undefined" ? "limit" : `${foreignTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers["Accept"] = "application/vnd.pgrst.object+json";
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === "GET") this.headers["Accept"] = "application/json";
        else this.headers["Accept"] = "application/vnd.pgrst.object+json";
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers["Accept"] = "text/csv";
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers["Accept"] = "application/geo+json";
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = "text" } = {}) {
        const options = [
            analyze ? "analyze" : null,
            verbose ? "verbose" : null,
            settings ? "settings" : null,
            buffers ? "buffers" : null,
            wal ? "wal" : null
        ].filter(Boolean).join("|");
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = this.headers["Accept"];
        this.headers["Accept"] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === "json") return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers["Prefer"]) !== null && _a !== void 0 ? _a : "").trim().length > 0) this.headers["Prefer"] += ",tx=rollback";
        else this.headers["Prefer"] = "tx=rollback";
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     */ returns() {
        return this;
    }
}


class $b762d781a6ab0022$export$2e2bcd8739ae039 extends (0, $e9af4d8c4ba4c1ff$export$2e2bcd8739ae039) {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = values.map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === "string" && new RegExp("[,()]").test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === "string") // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(",")}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === "string") // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(",")}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === "string") // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(",")}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = "";
        if (type === "plain") typePart = "pl";
        else if (type === "phrase") typePart = "ph";
        else if (type === "websearch") typePart = "w";
        const configPart = config === undefined ? "" : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param foreignTable - Set this to filter on foreign tables instead of the
     * current table
     */ or(filters, { foreignTable: foreignTable } = {}) {
        const key = foreignTable ? `${foreignTable}.or` : "or";
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}


class $d448a160aa4935e3$export$2e2bcd8739ae039 {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? "HEAD" : "GET";
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === '"') quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        if (count) this.headers["Prefer"] = `count=${count}`;
        return new (0, $b762d781a6ab0022$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = "POST";
        const prefersHeaders = [];
        if (this.headers["Prefer"]) prefersHeaders.push(this.headers["Prefer"]);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push("missing=default");
        this.headers["Prefer"] = prefersHeaders.join(",");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new (0, $b762d781a6ab0022$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = "POST";
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? "ignore" : "merge"}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set("on_conflict", onConflict);
        if (this.headers["Prefer"]) prefersHeaders.push(this.headers["Prefer"]);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push("missing=default");
        this.headers["Prefer"] = prefersHeaders.join(",");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new (0, $b762d781a6ab0022$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = "PATCH";
        const prefersHeaders = [];
        if (this.headers["Prefer"]) prefersHeaders.push(this.headers["Prefer"]);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers["Prefer"] = prefersHeaders.join(",");
        return new (0, $b762d781a6ab0022$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = "DELETE";
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers["Prefer"]) prefersHeaders.unshift(this.headers["Prefer"]);
        this.headers["Prefer"] = prefersHeaders.join(",");
        return new (0, $b762d781a6ab0022$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}



const $60182b8b72c978f6$export$83d89fbfd8236492 = "1.8.4";


const $ab7f1c8b697f22c2$export$88a84136db6a4b64 = {
    "X-Client-Info": `postgrest-js/${(0, $60182b8b72c978f6$export$83d89fbfd8236492)}`
};


class $6444a94a19ea6021$export$2e2bcd8739ae039 {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $ab7f1c8b697f22c2$export$88a84136db6a4b64)), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new (0, $d448a160aa4935e3$export$2e2bcd8739ae039)(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $6444a94a19ea6021$export$2e2bcd8739ae039(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head) {
            method = "HEAD";
            Object.entries(args).forEach(([name, value])=>{
                url.searchParams.append(name, `${value}`);
            });
        } else {
            method = "POST";
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers["Prefer"] = `count=${count}`;
        return new (0, $b762d781a6ab0022$export$2e2bcd8739ae039)({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}








var $088387c6e15fdbab$exports = {};
var $088387c6e15fdbab$var$_globalThis;

if (typeof globalThis === "object") $088387c6e15fdbab$var$_globalThis = globalThis;
else try {
    $088387c6e15fdbab$var$_globalThis = (parcelRequire("btw6N"));
} catch (error) {} finally{
    if (!$088387c6e15fdbab$var$_globalThis && typeof window !== "undefined") $088387c6e15fdbab$var$_globalThis = window;
    if (!$088387c6e15fdbab$var$_globalThis) throw new Error("Could not determine global this");
}
var $088387c6e15fdbab$var$NativeWebSocket = $088387c6e15fdbab$var$_globalThis.WebSocket || $088387c6e15fdbab$var$_globalThis.MozWebSocket;
var $b70c87ef3b5a2ac2$exports = {};

$b70c87ef3b5a2ac2$exports = (parcelRequire("aTayz")).version;


/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */ function $088387c6e15fdbab$var$W3CWebSocket(uri, protocols) {
    var native_instance;
    if (protocols) native_instance = new $088387c6e15fdbab$var$NativeWebSocket(uri, protocols);
    else native_instance = new $088387c6e15fdbab$var$NativeWebSocket(uri);
    /**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */ return native_instance;
}
if ($088387c6e15fdbab$var$NativeWebSocket) [
    "CONNECTING",
    "OPEN",
    "CLOSING",
    "CLOSED"
].forEach(function(prop) {
    Object.defineProperty($088387c6e15fdbab$var$W3CWebSocket, prop, {
        get: function() {
            return $088387c6e15fdbab$var$NativeWebSocket[prop];
        }
    });
});
/**
 * Module exports.
 */ $088387c6e15fdbab$exports = {
    "w3cwebsocket": $088387c6e15fdbab$var$NativeWebSocket ? $088387c6e15fdbab$var$W3CWebSocket : null,
    "version": $b70c87ef3b5a2ac2$exports
};


const $eaf8570c4c7fcc3a$export$83d89fbfd8236492 = "2.7.4";


const $51460e977affd95d$export$88a84136db6a4b64 = {
    "X-Client-Info": `realtime-js/${(0, $eaf8570c4c7fcc3a$export$83d89fbfd8236492)}`
};
const $51460e977affd95d$export$df3f558bb9a9c991 = "1.0.0";
const $51460e977affd95d$export$7bd623b29ec8e1eb = 10000;
const $51460e977affd95d$export$5e80cf62e56a877b = 1000;
var $51460e977affd95d$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($51460e977affd95d$export$a6d0320a1563d49e || ($51460e977affd95d$export$a6d0320a1563d49e = {}));
var $51460e977affd95d$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($51460e977affd95d$export$b83816118db74fe7 || ($51460e977affd95d$export$b83816118db74fe7 = {}));
var $51460e977affd95d$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($51460e977affd95d$export$8db7548e65d6ea55 || ($51460e977affd95d$export$8db7548e65d6ea55 = {}));
var $51460e977affd95d$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($51460e977affd95d$export$b2688bfb999f5751 || ($51460e977affd95d$export$b2688bfb999f5751 = {}));
var $51460e977affd95d$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($51460e977affd95d$export$deda39003d27273 || ($51460e977affd95d$export$deda39003d27273 = {}));


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $46471561959fb4ee$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $176e635c3db47007$export$2e2bcd8739ae039 {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === "string") return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}




class $664ef07e6441b3e7$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $51460e977affd95d$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = "";
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
        this.rateLimited = false;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = "";
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived("timeout")) return;
        this.startTimeout();
        this.sent = true;
        const status = this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
        if (status === "rate limited") this.rateLimited = true;
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger("timeout", {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $c068d061422f3fa8$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($c068d061422f3fa8$export$f1ce049df2794fb4 || ($c068d061422f3fa8$export$f1ce049df2794fb4 = {}));
class $c068d061422f3fa8$export$2e2bcd8739ae039 {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: "presence_state",
            diff: "presence_diff"
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $c068d061422f3fa8$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $c068d061422f3fa8$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $c068d061422f3fa8$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger("presence", {
                event: "join",
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger("presence", {
                event: "leave",
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger("presence", {
                event: "sync"
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ("metas" in presences) newState[key] = presences.metas.map((presence)=>{
                presence["presence_ref"] = presence["phx_ref"];
                delete presence["phx_ref"];
                delete presence["phx_ref_prev"];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $707f1bed5eb6db8c$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($707f1bed5eb6db8c$export$4d213a7d364021dc || ($707f1bed5eb6db8c$export$4d213a7d364021dc = {}));
const $707f1bed5eb6db8c$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $707f1bed5eb6db8c$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $707f1bed5eb6db8c$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $707f1bed5eb6db8c$export$3df02a362b86a91(colType, value);
    return $707f1bed5eb6db8c$var$noop(value);
};
const $707f1bed5eb6db8c$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === "_") {
        const dataType = type.slice(1, type.length);
        return $707f1bed5eb6db8c$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.bool:
            return $707f1bed5eb6db8c$export$3c2e6d1b7583eee6(value);
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.float4:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.float8:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.int2:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.int4:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.int8:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.numeric:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.oid:
            return $707f1bed5eb6db8c$export$a0a81dc3380ce7d3(value);
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.json:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.jsonb:
            return $707f1bed5eb6db8c$export$d5b7a8bf56ee1fe2(value);
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.timestamp:
            return $707f1bed5eb6db8c$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.abstime:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.date:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.daterange:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.int4range:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.int8range:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.money:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.reltime:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.text:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.time:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.timestamptz:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.timetz:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.tsrange:
        case $707f1bed5eb6db8c$export$4d213a7d364021dc.tstzrange:
            return $707f1bed5eb6db8c$var$noop(value);
        default:
            // Return the value for remaining types
            return $707f1bed5eb6db8c$var$noop(value);
    }
};
const $707f1bed5eb6db8c$var$noop = (value)=>{
    return value;
};
const $707f1bed5eb6db8c$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case "t":
            return true;
        case "f":
            return false;
        default:
            return value;
    }
};
const $707f1bed5eb6db8c$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === "string") {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $707f1bed5eb6db8c$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === "string") try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $707f1bed5eb6db8c$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== "string") return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === "{" && closeBrace === "}") {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse("[" + valTrim + "]");
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(",") : [];
        }
        return arr.map((val)=>$707f1bed5eb6db8c$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $707f1bed5eb6db8c$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === "string") return value.replace(" ", "T");
    return value;
};


var $0418cad238c9f441$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0418cad238c9f441$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($0418cad238c9f441$export$bc171c571098b6c4 || ($0418cad238c9f441$export$bc171c571098b6c4 = {}));
var $0418cad238c9f441$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    /**
     * listen to Postgres changes.
     */ REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
})($0418cad238c9f441$export$9e3fe8e487ef792e || ($0418cad238c9f441$export$9e3fe8e487ef792e = {}));
var $0418cad238c9f441$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($0418cad238c9f441$export$a6885b926af646a2 || ($0418cad238c9f441$export$a6885b926af646a2 = {}));
class $0418cad238c9f441$export$2e2bcd8739ae039 {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $51460e977affd95d$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ""
            }
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $664ef07e6441b3e7$export$2e2bcd8739ae039)(this, (0, $51460e977affd95d$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $46471561959fb4ee$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive("ok", ()=>{
            this.state = (0, $51460e977affd95d$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log("channel", `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $51460e977affd95d$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log("channel", `error ${this.topic}`, reason);
            this.state = (0, $51460e977affd95d$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive("timeout", ()=>{
            if (!this._isJoining()) return;
            this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $51460e977affd95d$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $51460e977affd95d$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $c068d061422f3fa8$export$2e2bcd8739ae039)(this);
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast: broadcast, presence: presence } } = this.params;
            this._onError((e)=>callback && callback("CHANNEL_ERROR", e));
            this._onClose(()=>callback && callback("CLOSED"));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : []
            };
            if (this.socket.accessToken) accessTokenPayload.access_token = this.socket.accessToken;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive("ok", ({ postgres_changes: serverPostgresFilters })=>{
                var _a;
                this.socket.accessToken && this.socket.setAuth(this.socket.accessToken);
                if (serverPostgresFilters === undefined) {
                    callback && callback("SUBSCRIBED");
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = serverPostgresFilters && serverPostgresFilters[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            callback && callback("CHANNEL_ERROR", new Error("mismatch between server and client bindings for postgres changes"));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback("SUBSCRIBED");
                    return;
                }
            }).receive("error", (error)=>{
                callback && callback("CHANNEL_ERROR", new Error(JSON.stringify(Object.values(error).join(", ") || "error")));
                return;
            }).receive("timeout", ()=>{
                callback && callback("TIMED_OUT");
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    track(payload, opts = {}) {
        return $0418cad238c9f441$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.send({
                type: "presence",
                event: "track",
                payload: payload
            }, opts.timeout || this.timeout);
        });
    }
    untrack(opts = {}) {
        return $0418cad238c9f441$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.send({
                type: "presence",
                event: "untrack"
            }, opts);
        });
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    send(payload, opts = {}) {
        return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(payload.type, payload, opts.timeout || this.timeout);
            if (push.rateLimited) resolve("rate limited");
            if (payload.type === "broadcast" && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve("ok");
            push.receive("ok", ()=>resolve("ok"));
            push.receive("timeout", ()=>resolve("timed out"));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $51460e977affd95d$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log("channel", `leave ${this.topic}`);
            this._trigger((0, $51460e977affd95d$export$8db7548e65d6ea55).close, "leave", this._joinRef());
        };
        this.rejoinTimer.reset();
        // Destroy joinPush to avoid connection timeouts during unscription phase
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, $664ef07e6441b3e7$export$2e2bcd8739ae039)(this, (0, $51460e977affd95d$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive("ok", ()=>{
                onClose();
                resolve("ok");
            }).receive("timeout", ()=>{
                onClose();
                resolve("timed out");
            }).receive("error", ()=>{
                resolve("error");
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger("ok", {});
        });
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $664ef07e6441b3e7$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $51460e977affd95d$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw "channel onMessage callbacks must return the payload, modified or unmodified";
        if ([
            "insert",
            "update",
            "delete"
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === "*" || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                "broadcast",
                "presence",
                "postgres_changes"
            ].includes(typeLower)) {
                if ("id" in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === "*" || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === "*" || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === "object" && "ids" in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $51460e977affd95d$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $51460e977affd95d$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $51460e977affd95d$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $51460e977affd95d$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $0418cad238c9f441$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $51460e977affd95d$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $51460e977affd95d$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $51460e977affd95d$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === "INSERT" || payload.type === "UPDATE") records.new = $707f1bed5eb6db8c$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === "UPDATE" || payload.type === "DELETE") records.old = $707f1bed5eb6db8c$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
}


var $bc6d42c48befec0d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $bc6d42c48befec0d$var$noop = ()=>{};
class $bc6d42c48befec0d$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket.
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     */ constructor(endPoint, options){
        var _a, _b;
        this.accessToken = null;
        this.channels = [];
        this.endPoint = "";
        this.headers = (0, $51460e977affd95d$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $51460e977affd95d$export$7bd623b29ec8e1eb);
        this.transport = (0, $088387c6e15fdbab$exports.w3cwebsocket);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = $bc6d42c48befec0d$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $176e635c3db47007$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.eventsPerSecondLimitMs = 100;
        this.inThrottle = false;
        this.endPoint = `${endPoint}/${(0, $51460e977affd95d$export$b2688bfb999f5751).websocket}`;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const eventsPerSecond = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.eventsPerSecond;
        if (eventsPerSecond) this.eventsPerSecondLimitMs = Math.floor(1000 / eventsPerSecond);
        const accessToken = (_b = options === null || options === void 0 ? void 0 : options.params) === null || _b === void 0 ? void 0 : _b.apikey;
        if (accessToken) this.accessToken = accessToken;
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $46471561959fb4ee$export$2e2bcd8739ae039)(()=>$bc6d42c48befec0d$var$__awaiter(this, void 0, void 0, function*() {
                this.disconnect();
                this.connect();
            }), this.reconnectAfterMs);
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        this.conn = new this.transport(this._endPointURL(), [], null, this.headers);
        if (this.conn) {
            this.conn.binaryType = "arraybuffer";
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : "");
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ removeChannel(channel) {
        return $bc6d42c48befec0d$var$__awaiter(this, void 0, void 0, function*() {
            const status = yield channel.unsubscribe();
            if (this.channels.length === 0) this.disconnect();
            return status;
        });
    }
    /**
     * Unsubscribes and removes all channels
     */ removeAllChannels() {
        return $bc6d42c48befec0d$var$__awaiter(this, void 0, void 0, function*() {
            const values_1 = yield Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
            this.disconnect();
            return values_1;
        });
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $51460e977affd95d$export$a6d0320a1563d49e).connecting:
                return (0, $51460e977affd95d$export$deda39003d27273).Connecting;
            case (0, $51460e977affd95d$export$a6d0320a1563d49e).open:
                return (0, $51460e977affd95d$export$deda39003d27273).Open;
            case (0, $51460e977affd95d$export$a6d0320a1563d49e).closing:
                return (0, $51460e977affd95d$export$deda39003d27273).Closing;
            default:
                return (0, $51460e977affd95d$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $51460e977affd95d$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        if (!this.isConnected()) this.connect();
        const chan = new (0, $0418cad238c9f441$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
        this.channels.push(chan);
        return chan;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        let callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log("push", `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) {
            if ([
                "broadcast",
                "presence",
                "postgres_changes"
            ].includes(event)) {
                const isThrottled = this._throttle(callback)();
                if (isThrottled) return "rate limited";
            } else callback();
        } else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * @param token A JWT string.
     */ setAuth(token) {
        this.accessToken = token;
        this.channels.forEach((channel)=>{
            token && channel.updateJoinPayload({
                access_token: token
            });
            if (channel.joinedOnce && channel._isJoined()) channel._push((0, $51460e977affd95d$export$8db7548e65d6ea55).access_token, {
                access_token: token
            });
        });
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log("transport", `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c._joinRef() !== channel._joinRef());
    }
    /**
     * Returns the URL of the websocket.
     *
     * @internal
     */ _endPointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $51460e977affd95d$export$df3f558bb9a9c991)
        }));
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef || event === (payload === null || payload === void 0 ? void 0 : payload.type)) this.pendingHeartbeatRef = null;
            this.log("receive", `${payload.status || ""} ${topic} ${event} ${ref && "(" + ref + ")" || ""}`, payload);
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ _onConnOpen() {
        this.log("transport", `connected to ${this._endPointURL()}`);
        this._flushSendBuffer();
        this.reconnectTimer.reset();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = setInterval(()=>this._sendHeartbeat(), this.heartbeatIntervalMs);
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log("transport", "close", event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log("transport", error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $51460e977affd95d$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? "&" : "?";
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    /** @internal */ _flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /** @internal */ _sendHeartbeat() {
        var _a;
        if (!this.isConnected()) return;
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $51460e977affd95d$export$5e80cf62e56a877b), "hearbeat timeout");
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.setAuth(this.accessToken);
    }
    /** @internal */ _throttle(callback, eventsPerSecondLimitMs = this.eventsPerSecondLimitMs) {
        return ()=>{
            if (this.inThrottle) return true;
            callback();
            if (eventsPerSecondLimitMs > 0) {
                this.inThrottle = true;
                setTimeout(()=>{
                    this.inThrottle = false;
                }, eventsPerSecondLimitMs);
            }
            return false;
        };
    }
}






class $1ed77b6a5caa997a$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = "StorageError";
    }
}
function $1ed77b6a5caa997a$export$5a322e77e5eb0561(error) {
    return typeof error === "object" && error !== null && "__isStorageError" in error;
}
class $1ed77b6a5caa997a$export$ca9ecfd959b3871c extends $1ed77b6a5caa997a$export$697502632950e9d3 {
    constructor(message, status){
        super(message);
        this.name = "StorageApiError";
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class $1ed77b6a5caa997a$export$29127ca2e1a271d extends $1ed77b6a5caa997a$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = "StorageUnknownError";
        this.originalError = originalError;
    }
}



var $094c5854c2a15200$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $094c5854c2a15200$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === "undefined") _fetch = (...args)=>$094c5854c2a15200$var$__awaiter(void 0, void 0, void 0, function*() {
            return yield (yield Promise.resolve((parcelRequire("f5Vhp")))).fetch(...args);
        });
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $094c5854c2a15200$export$ace1d6afc438cf26 = ()=>$094c5854c2a15200$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === "undefined") return (yield Promise.resolve((parcelRequire("f5Vhp")))).Response;
        return Response;
    });


var $abdd27a6fd353141$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $abdd27a6fd353141$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $abdd27a6fd353141$var$handleError = (error, reject)=>$abdd27a6fd353141$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $094c5854c2a15200$export$ace1d6afc438cf26)();
        if (error instanceof Res) error.json().then((err)=>{
            reject(new (0, $1ed77b6a5caa997a$export$ca9ecfd959b3871c)($abdd27a6fd353141$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $1ed77b6a5caa997a$export$29127ca2e1a271d)($abdd27a6fd353141$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $1ed77b6a5caa997a$export$29127ca2e1a271d)($abdd27a6fd353141$var$_getErrorMessage(error), error));
    });
const $abdd27a6fd353141$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET") return params;
    params.headers = Object.assign({
        "Content-Type": "application/json"
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $abdd27a6fd353141$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $abdd27a6fd353141$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $abdd27a6fd353141$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$abdd27a6fd353141$var$handleError(error, reject));
        });
    });
}
function $abdd27a6fd353141$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $abdd27a6fd353141$var$__awaiter(this, void 0, void 0, function*() {
        return $abdd27a6fd353141$var$_handleRequest(fetcher, "GET", url, options, parameters);
    });
}
function $abdd27a6fd353141$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $abdd27a6fd353141$var$__awaiter(this, void 0, void 0, function*() {
        return $abdd27a6fd353141$var$_handleRequest(fetcher, "POST", url, options, parameters, body);
    });
}
function $abdd27a6fd353141$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $abdd27a6fd353141$var$__awaiter(this, void 0, void 0, function*() {
        return $abdd27a6fd353141$var$_handleRequest(fetcher, "PUT", url, options, parameters, body);
    });
}
function $abdd27a6fd353141$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $abdd27a6fd353141$var$__awaiter(this, void 0, void 0, function*() {
        return $abdd27a6fd353141$var$_handleRequest(fetcher, "DELETE", url, options, parameters, body);
    });
}



var $50975414fa7ed87f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $50975414fa7ed87f$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: "name",
        order: "asc"
    }
};
const $50975414fa7ed87f$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: "3600",
    contentType: "text/plain;charset=UTF-8",
    upsert: false
};
class $50975414fa7ed87f$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $094c5854c2a15200$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $50975414fa7ed87f$var$DEFAULT_FILE_OPTIONS), fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), method === "POST" && {
                    "x-upsert": String(options.upsert)
                });
                if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append("cacheControl", options.cacheControl);
                    body.append("", fileBody);
                } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append("cacheControl", options.cacheControl);
                } else {
                    body = fileBody;
                    headers["cache-control"] = `max-age=${options.cacheControl}`;
                    headers["content-type"] = options.contentType;
                }
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                if (res.ok) return {
                    data: {
                        path: cleanPath
                    },
                    error: null
                };
                else {
                    const error = yield res.json();
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate("POST", path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set("token", token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $50975414fa7ed87f$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    "x-upsert": String(options.upsert)
                });
                if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append("cacheControl", options.cacheControl);
                    body.append("", fileBody);
                } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append("cacheControl", options.cacheControl);
                } else {
                    body = fileBody;
                    headers["cache-control"] = `max-age=${options.cacheControl}`;
                    headers["content-type"] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: "PUT",
                    body: body,
                    headers: headers
                });
                if (res.ok) return {
                    data: {
                        path: cleanPath
                    },
                    error: null
                };
                else {
                    const error = yield res.json();
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     */ createSignedUploadUrl(path) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const data = yield (0, $abdd27a6fd353141$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: this.headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get("token");
                if (!token) throw new (0, $1ed77b6a5caa997a$export$697502632950e9d3)("No token returned by API");
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate("PUT", path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     */ move(fromPath, toPath) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     */ copy(fromPath, toPath) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $abdd27a6fd353141$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? "" : options.download}` : "";
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? "" : options.download}` : "";
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== "undefined";
            const renderPath = wantsTransformation ? "render/image/authenticated" : "object";
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : "";
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $abdd27a6fd353141$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? "" : options.download}` : "";
        if (downloadQueryParam !== "") _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== "undefined";
        const renderPath = wantsTransformation ? "render/image" : "object";
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== "") _queryString.push(transformationQuery);
        let queryString = _queryString.join("&");
        if (queryString !== "") queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $50975414fa7ed87f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $50975414fa7ed87f$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ""
                });
                const data = yield (0, $abdd27a6fd353141$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join("&");
    }
}


// generated by genversion
const $abf9d8d885dc95d9$export$83d89fbfd8236492 = "2.5.3";


const $8b4bc8d7328039dc$export$88a84136db6a4b64 = {
    "X-Client-Info": `storage-js/${(0, $abf9d8d885dc95d9$export$83d89fbfd8236492)}`
};





var $d2de8b9c9d6011a1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $d2de8b9c9d6011a1$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $8b4bc8d7328039dc$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $094c5854c2a15200$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $d2de8b9c9d6011a1$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $d2de8b9c9d6011a1$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $d2de8b9c9d6011a1$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $d2de8b9c9d6011a1$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $d2de8b9c9d6011a1$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $d2de8b9c9d6011a1$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $abdd27a6fd353141$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $1ed77b6a5caa997a$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
}


class $48fe968ae386da99$export$6c85f5032e75eff9 extends (0, $d2de8b9c9d6011a1$export$2e2bcd8739ae039) {
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $50975414fa7ed87f$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
}


// constants.ts
const $8dc4a92f25b5ea76$export$83d89fbfd8236492 = "2.33.1";


const $c5113035f7eb8801$export$88a84136db6a4b64 = {
    "X-Client-Info": `supabase-js/${(0, $8dc4a92f25b5ea76$export$83d89fbfd8236492)}`
};



var $f5Vhp = parcelRequire("f5Vhp");
var $e337ab32d749d3c4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e337ab32d749d3c4$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === "undefined") _fetch = (0, (/*@__PURE__*/$parcel$interopDefault($f5Vhp)));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $e337ab32d749d3c4$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === "undefined") return 0, $f5Vhp.Headers;
    return Headers;
};
const $e337ab32d749d3c4$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $e337ab32d749d3c4$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $e337ab32d749d3c4$export$3d2cf54f85b7fc8a();
    return (input, init)=>$e337ab32d749d3c4$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has("apikey")) headers.set("apikey", supabaseKey);
            if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


function $fc9502da14a2d9cf$export$31b40729666a4ae0() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $fc9502da14a2d9cf$export$d95b4586d238a081(url) {
    return url.replace(/\/$/, "");
}
const $fc9502da14a2d9cf$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined";
function $fc9502da14a2d9cf$export$da186dc3f8eace71(options, defaults) {
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    return {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions)
    };
}


function $00422035477681d2$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $00422035477681d2$export$31b40729666a4ae0() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $00422035477681d2$export$4e09c449d6c407f7 = ()=>typeof document !== "undefined";
const $00422035477681d2$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $00422035477681d2$export$9ec034ee80211814 = ()=>{
    if (!$00422035477681d2$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== "object") return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($00422035477681d2$var$localStorageWriteTests.tested) return $00422035477681d2$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $00422035477681d2$var$localStorageWriteTests.tested = true;
        $00422035477681d2$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $00422035477681d2$var$localStorageWriteTests.tested = true;
        $00422035477681d2$var$localStorageWriteTests.writable = false;
    }
    return $00422035477681d2$var$localStorageWriteTests.writable;
};
function $00422035477681d2$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === "#") try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $00422035477681d2$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === "undefined") _fetch = async (...args)=>await (await Promise.resolve((parcelRequire("f5Vhp")))).fetch(...args);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $00422035477681d2$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === "object" && maybeResponse !== null && "status" in maybeResponse && "ok" in maybeResponse && "json" in maybeResponse && typeof maybeResponse.json === "function";
};
const $00422035477681d2$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $00422035477681d2$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $00422035477681d2$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
function $00422035477681d2$export$f0d30a693d94f11c(value) {
    const key = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let base64 = "";
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    value = value.replace("-", "+").replace("_", "/");
    while(i < value.length){
        enc1 = key.indexOf(value.charAt(i++));
        enc2 = key.indexOf(value.charAt(i++));
        enc3 = key.indexOf(value.charAt(i++));
        enc4 = key.indexOf(value.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        base64 = base64 + String.fromCharCode(chr1);
        if (enc3 != 64 && chr2 != 0) base64 = base64 + String.fromCharCode(chr2);
        if (enc4 != 64 && chr3 != 0) base64 = base64 + String.fromCharCode(chr3);
    }
    return base64;
}
class $00422035477681d2$export$85f6557964517f1a {
    constructor(){
        this.promise = new $00422035477681d2$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$00422035477681d2$export$85f6557964517f1a.promiseConstructor = Promise;
function $00422035477681d2$export$cc1c0b988f7b5577(token) {
    // Regex checks for base64url format
    const base64UrlRegex = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}=?$|[a-z0-9_-]{2}(==)?$)$/i;
    const parts = token.split(".");
    if (parts.length !== 3) throw new Error("JWT is not valid: not a JWT structure");
    if (!base64UrlRegex.test(parts[1])) throw new Error("JWT is not valid: payload is not in base64url format");
    const base64Url = parts[1];
    return JSON.parse($00422035477681d2$export$f0d30a693d94f11c(base64Url));
}
async function $00422035477681d2$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $00422035477681d2$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $00422035477681d2$var$dec2hex(dec) {
    return ("0" + dec.toString(16)).substr(-2);
}
function $00422035477681d2$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === "undefined") {
        const charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        const charSetLen = charSet.length;
        let verifier = "";
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $00422035477681d2$var$dec2hex).join("");
}
async function $00422035477681d2$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest("SHA-256", encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join("");
}
function $00422035477681d2$var$base64urlencode(str) {
    return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
async function $00422035477681d2$export$eb79e16bb8189148(verifier) {
    if (typeof crypto === "undefined") {
        console.warn("WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.");
        return verifier;
    }
    const hashed = await $00422035477681d2$var$sha256(verifier);
    return $00422035477681d2$var$base64urlencode(hashed);
}


class $74b584ebdcc77088$export$145273558d58e0ac extends Error {
    constructor(message, status){
        super(message);
        this.__isAuthError = true;
        this.name = "AuthError";
        this.status = status;
    }
}
function $74b584ebdcc77088$export$cde1786a482f9a1c(error) {
    return typeof error === "object" && error !== null && "__isAuthError" in error;
}
class $74b584ebdcc77088$export$45fde0b55b14f37b extends $74b584ebdcc77088$export$145273558d58e0ac {
    constructor(message, status){
        super(message, status);
        this.name = "AuthApiError";
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
function $74b584ebdcc77088$export$4fe744aeb810d543(error) {
    return $74b584ebdcc77088$export$cde1786a482f9a1c(error) && error.name === "AuthApiError";
}
class $74b584ebdcc77088$export$f7559805d4a50078 extends $74b584ebdcc77088$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = "AuthUnknownError";
        this.originalError = originalError;
    }
}
class $74b584ebdcc77088$export$823c745ae0673c5e extends $74b584ebdcc77088$export$145273558d58e0ac {
    constructor(message, name, status){
        super(message);
        this.name = name;
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class $74b584ebdcc77088$export$403b3fc0d3ad5f0c extends $74b584ebdcc77088$export$823c745ae0673c5e {
    constructor(){
        super("Auth session missing!", "AuthSessionMissingError", 400);
    }
}
class $74b584ebdcc77088$export$7e277b620449c1b4 extends $74b584ebdcc77088$export$823c745ae0673c5e {
    constructor(){
        super("Auth session or user missing", "AuthInvalidTokenResponseError", 500);
    }
}
class $74b584ebdcc77088$export$9ef583f0381b4cc extends $74b584ebdcc77088$export$823c745ae0673c5e {
    constructor(message){
        super(message, "AuthInvalidCredentialsError", 400);
    }
}
class $74b584ebdcc77088$export$bf5df8e043856ef5 extends $74b584ebdcc77088$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, "AuthImplicitGrantRedirectError", 500);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $74b584ebdcc77088$export$39583657eb2a7027 extends $74b584ebdcc77088$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, "AuthPKCEGrantCodeExchangeError", 500);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $74b584ebdcc77088$export$2423b763f68be1b4 extends $74b584ebdcc77088$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, "AuthRetryableFetchError", status);
    }
}
function $74b584ebdcc77088$export$a77af358da5fb874(error) {
    return $74b584ebdcc77088$export$cde1786a482f9a1c(error) && error.name === "AuthRetryableFetchError";
}


var $441cebcd96f53249$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $441cebcd96f53249$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $441cebcd96f53249$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $441cebcd96f53249$var$handleError(error) {
    if (!(0, $00422035477681d2$export$e8ad6599be1036a7)(error)) throw new (0, $74b584ebdcc77088$export$2423b763f68be1b4)($441cebcd96f53249$var$_getErrorMessage(error), 0);
    if ($441cebcd96f53249$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $74b584ebdcc77088$export$2423b763f68be1b4)($441cebcd96f53249$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $74b584ebdcc77088$export$f7559805d4a50078)($441cebcd96f53249$var$_getErrorMessage(e), e);
    }
    throw new (0, $74b584ebdcc77088$export$45fde0b55b14f37b)($441cebcd96f53249$var$_getErrorMessage(data), error.status || 500);
}
const $441cebcd96f53249$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET") return params;
    params.headers = Object.assign({
        "Content-Type": "application/json;charset=UTF-8"
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $441cebcd96f53249$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (options === null || options === void 0 ? void 0 : options.jwt) headers["Authorization"] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs["redirect_to"] = options.redirectTo;
    const queryString = Object.keys(qs).length ? "?" + new URLSearchParams(qs).toString() : "";
    const data = await $441cebcd96f53249$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $441cebcd96f53249$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $441cebcd96f53249$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, requestParams);
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $74b584ebdcc77088$export$2423b763f68be1b4)($441cebcd96f53249$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $441cebcd96f53249$var$handleError(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $441cebcd96f53249$var$handleError(e);
    }
}
function $441cebcd96f53249$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($441cebcd96f53249$var$hasSession(data)) {
        session = Object.assign({}, data);
        session.expires_at = (0, $00422035477681d2$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $441cebcd96f53249$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $441cebcd96f53249$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $441cebcd96f53249$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $441cebcd96f53249$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $441cebcd96f53249$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $441cebcd96f53249$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $8c23ed1786bd4033$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $8c23ed1786bd4033$export$2e2bcd8739ae039 {
    constructor({ url: url = "", headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $00422035477681d2$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = "global") {
        try {
            await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $441cebcd96f53249$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $8c23ed1786bd4033$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ("newEmail" in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body["newEmail"];
            }
            return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $441cebcd96f53249$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $441cebcd96f53249$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ""
                },
                xform: (0, $441cebcd96f53249$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get("x-total-count")) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get("link")) === null || _f === void 0 ? void 0 : _f.split(",")) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(";")[0].split("=")[1].substring(0, 1));
                    const rel = JSON.parse(link.split(";")[1].split("=")[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $441cebcd96f53249$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "PUT", `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $441cebcd96f53249$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "DELETE", `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $441cebcd96f53249$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data: data, error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "DELETE", `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}



// Generated by genversion.
const $3cad4007a086d949$export$83d89fbfd8236492 = "2.48.1";


const $9623383d022f1317$export$7fedf552187f0c3d = "http://localhost:9999";
const $9623383d022f1317$export$86880b4b2e1a2384 = "supabase.auth.token";
const $9623383d022f1317$export$2f9161bad044dacb = "";
const $9623383d022f1317$export$88a84136db6a4b64 = {
    "X-Client-Info": `gotrue-js/${(0, $3cad4007a086d949$export$83d89fbfd8236492)}`
};
const $9623383d022f1317$export$7d4b3a66850dd9bd = 10; // in seconds
const $9623383d022f1317$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};






const $0eabd3cfbc6ba931$var$localStorageAdapter = {
    getItem: (key)=>{
        if (!(0, $00422035477681d2$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, $00422035477681d2$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, $00422035477681d2$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
var $0eabd3cfbc6ba931$export$2e2bcd8739ae039 = $0eabd3cfbc6ba931$var$localStorageAdapter;


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $a560963161c8cc32$export$ad067ce270531206() {
    if (typeof globalThis === "object") return;
    try {
        Object.defineProperty(Object.prototype, "__magic__", {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== "undefined") // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}



(0, $a560963161c8cc32$export$ad067ce270531206)(); // Make "globalThis" available
const $3be7e0c5163b59ae$var$DEFAULT_OPTIONS = {
    url: (0, $9623383d022f1317$export$7fedf552187f0c3d),
    storageKey: (0, $9623383d022f1317$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $9623383d022f1317$export$88a84136db6a4b64),
    flowType: "implicit",
    debug: false
};
/** Current session will be checked for refresh at this interval. */ const $3be7e0c5163b59ae$var$AUTO_REFRESH_TICK_DURATION = 30000;
/**
 * A token refresh will be attempted this many ticks before the current session expires. */ const $3be7e0c5163b59ae$var$AUTO_REFRESH_TICK_THRESHOLD = 3;
async function $3be7e0c5163b59ae$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class $3be7e0c5163b59ae$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.instanceID = $3be7e0c5163b59ae$export$2e2bcd8739ae039.nextInstanceID;
        $3be7e0c5163b59ae$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $00422035477681d2$export$4e09c449d6c407f7)()) console.warn("Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.");
        const settings = Object.assign(Object.assign({}, $3be7e0c5163b59ae$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = settings.debug;
        this.inMemorySession = null;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.persistSession = settings.persistSession;
        this.storage = settings.storage || (0, $0eabd3cfbc6ba931$export$2e2bcd8739ae039);
        this.admin = new (0, $8c23ed1786bd4033$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $00422035477681d2$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $3be7e0c5163b59ae$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession && this.storage === (0, $0eabd3cfbc6ba931$export$2e2bcd8739ae039) && !(0, $00422035477681d2$export$9ec034ee80211814)()) console.warn(`No storage option exists to persist the session, which may result in unexpected behavior when using auth.
        If you want to set persistSession to true, please provide a storage option or you may set persistSession to false to disable this warning.`);
        if ((0, $00422035477681d2$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error("Failed to create a new BroadcastChannel, multi-tab state changes will not be available", e);
            }
            (_a = this.broadcastChannel) === null || _a === void 0 || _a.addEventListener("message", async (event)=>{
                this._debug("received broadcast notification from other tab or client", event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    _debug(...args) {
        if (this.logDebugMessages) console.log(`GoTrueClient@${this.instanceID} (${(0, $3cad4007a086d949$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        try {
            const isPKCEFlow = (0, $00422035477681d2$export$4e09c449d6c407f7)() ? await this._isPKCEFlow() : false;
            this._debug("#_initialize()", "begin", "is PKCE flow", isPKCEFlow);
            if (isPKCEFlow || this.detectSessionInUrl && this._isImplicitGrantFlow()) {
                const { data: data, error: error } = await this._getSessionFromURL(isPKCEFlow);
                if (error) {
                    this._debug("#_initialize()", "error detecting session from URL", error);
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug("#_initialize()", "detected session in URL", session, "redirect type", redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === "recovery") await this._notifyAllSubscribers("PASSWORD_RECOVERY", session);
                    else await this._notifyAllSubscribers("SIGNED_IN", session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $74b584ebdcc77088$export$f7559805d4a50078)("Unexpected error during initialization", error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug("#_initialize()", "end");
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            await this._removeSession();
            let res;
            if ("email" in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === "pkce") {
                    const codeVerifier = (0, $00422035477681d2$export$b6c3b8498f152f15)();
                    await (0, $00422035477681d2$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
                    codeChallenge = await (0, $00422035477681d2$export$eb79e16bb8189148)(codeVerifier);
                    codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
                }
                res = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $441cebcd96f53249$export$273fe4673a018c2e)
                });
            } else if ("phone" in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : "sms",
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $441cebcd96f53249$export$273fe4673a018c2e)
                });
            } else throw new (0, $74b584ebdcc77088$export$9ef583f0381b4cc)("You must provide either an email or phone number and a password");
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers("SIGNED_IN", session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            await this._removeSession();
            let res;
            if ("email" in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $441cebcd96f53249$export$273fe4673a018c2e)
                });
            } else if ("phone" in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $441cebcd96f53249$export$273fe4673a018c2e)
                });
            } else throw new (0, $74b584ebdcc77088$export$9ef583f0381b4cc)("You must provide either an email or phone number and a password");
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $74b584ebdcc77088$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers("SIGNED_IN", data.session);
            }
            return {
                data: {
                    user: data.user,
                    session: data.session
                },
                error: error
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        await this._removeSession();
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const codeVerifier = await (0, $00422035477681d2$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const { data: data, error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=pkce`, {
            headers: this.headers,
            body: {
                auth_code: authCode,
                code_verifier: codeVerifier
            },
            xform: (0, $441cebcd96f53249$export$273fe4673a018c2e)
        });
        await (0, $00422035477681d2$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
        if (error) return {
            data: {
                user: null,
                session: null
            },
            error: error
        };
        else if (!data || !data.session || !data.user) return {
            data: {
                user: null,
                session: null
            },
            error: new (0, $74b584ebdcc77088$export$7e277b620449c1b4)()
        };
        if (data.session) {
            await this._saveSession(data.session);
            await this._notifyAllSubscribers("SIGNED_IN", data.session);
        }
        return {
            data: data,
            error: error
        };
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        await this._removeSession();
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $441cebcd96f53249$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $74b584ebdcc77088$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers("SIGNED_IN", data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            await this._removeSession();
            if ("email" in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === "pkce") {
                    const codeVerifier = (0, $00422035477681d2$export$b6c3b8498f152f15)();
                    await (0, $00422035477681d2$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
                    codeChallenge = await (0, $00422035477681d2$export$eb79e16bb8189148)(codeVerifier);
                    codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
                }
                const { error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ("phone" in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : "sms"
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $74b584ebdcc77088$export$9ef583f0381b4cc)("You must provide either an email or phone number.");
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP received via mobile.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            if (params.type !== "email_change" && params.type !== "phone_change") // we don't want to remove the authenticated session if the user is performing an email_change or phone_change verification
            await this._removeSession();
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ("options" in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $441cebcd96f53249$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error("An error occurred on token verification.");
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers("SIGNED_IN", session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            await this._removeSession();
            return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, "providerId" in params ? {
                    provider_id: params.providerId
                } : null), "domain" in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true
                }),
                headers: this.headers,
                xform: (0, $441cebcd96f53249$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $74b584ebdcc77088$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            if (credentials.type != "email_change" && credentials.type != "phone_change") await this._removeSession();
            const endpoint = `${this.url}/resend`;
            if ("email" in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ("phone" in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $74b584ebdcc77088$export$9ef583f0381b4cc)("You must provide either an email or phone number and a type");
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     */ async getSession() {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug("#_acquireLock", "begin", acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we jsut care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug("#_acquireLock", "lock acquired for storage key", this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug("#_acquireLock", "lock released for storage key", this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug("#_acquireLock", "end");
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug("#_useSession", "begin");
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug("#_useSession", "end");
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug("#__loadSession()", "begin");
        if (!this.lockAcquired) this._debug("#__loadSession()", "used outside of an acquired lock!", new Error().stack);
        try {
            let currentSession = null;
            if (this.persistSession) {
                const maybeSession = await (0, $00422035477681d2$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
                this._debug("#getSession()", "session from storage", maybeSession);
                if (maybeSession !== null) {
                    if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                    else {
                        this._debug("#getSession()", "session from storage is not valid");
                        await this._removeSession();
                    }
                }
            } else {
                currentSession = this.inMemorySession;
                this._debug("#getSession()", "session from memory", currentSession);
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            const hasExpired = currentSession.expires_at ? currentSession.expires_at <= Date.now() / 1000 : false;
            this._debug("#__loadSession()", `session has${hasExpired ? "" : " not"} expired`, "expires_at", currentSession.expires_at);
            if (!hasExpired) return {
                data: {
                    session: currentSession
                },
                error: null
            };
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug("#__loadSession()", "end");
        }
    }
    /**
     * Gets the current user details if there is an existing session.
     * @param jwt Takes in an optional access token jwt. If no jwt is provided, getUser() will attempt to get the jwt from the current session.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $441cebcd96f53249$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined,
                    xform: (0, $441cebcd96f53249$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $74b584ebdcc77088$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                const { data: data, error: userError } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "PUT", `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: attributes,
                    jwt: session.access_token,
                    xform: (0, $441cebcd96f53249$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers("USER_UPDATED", session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Decodes a JWT (without performing any validation).
     */ _decodeJWT(jwt) {
        return (0, $00422035477681d2$export$cc1c0b988f7b5577)(jwt);
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $74b584ebdcc77088$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const payload = (0, $00422035477681d2$export$cc1c0b988f7b5577)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: "bearer",
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers("SIGNED_IN", session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $74b584ebdcc77088$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(isPKCEFlow) {
        try {
            if (!(0, $00422035477681d2$export$4e09c449d6c407f7)()) throw new (0, $74b584ebdcc77088$export$bf5df8e043856ef5)("No browser detected.");
            if (this.flowType === "implicit" && !this._isImplicitGrantFlow()) throw new (0, $74b584ebdcc77088$export$bf5df8e043856ef5)("Not a valid implicit grant flow url.");
            else if (this.flowType == "pkce" && !isPKCEFlow) throw new (0, $74b584ebdcc77088$export$39583657eb2a7027)("Not a valid PKCE flow url.");
            const params = (0, $00422035477681d2$export$7a29392fb778224c)(window.location.href);
            if (isPKCEFlow) {
                if (!params.code) throw new (0, $74b584ebdcc77088$export$39583657eb2a7027)("No code detected.");
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete("code");
                window.history.replaceState(window.history.state, "", url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            if (params.error || params.error_description || params.error_code) throw new (0, $74b584ebdcc77088$export$bf5df8e043856ef5)(params.error_description || "Error in URL with unspecified error_description", {
                error: params.error || "unspecified_error",
                code: params.error_code || "unspecified_code"
            });
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $74b584ebdcc77088$export$bf5df8e043856ef5)("No session defined in URL");
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            const expires_at = timeNow + expiresIn;
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expires_at,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = "";
            this._debug("#_getSessionFromURL()", "clearing window.location.hash");
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantFlow() {
        const params = (0, $00422035477681d2$export$7a29392fb778224c)(window.location.href);
        return !!((0, $00422035477681d2$export$4e09c449d6c407f7)() && (params.access_token || params.error_description));
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCEFlow() {
        const params = (0, $00422035477681d2$export$7a29392fb778224c)(window.location.href);
        const currentStorageContent = await (0, $00422035477681d2$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session
     * and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using others scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: "global"
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: "global"
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $74b584ebdcc77088$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401))) return {
                        error: error
                    };
                }
            }
            if (scope !== "others") {
                await this._removeSession();
                await (0, $00422035477681d2$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                await this._notifyAllSubscribers("SIGNED_OUT", null);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $00422035477681d2$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug("#unsubscribe()", "state change callback with id removed", id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug("#onAuthStateChange()", "registered callback with id", id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback("INITIAL_SESSION", session));
                this._debug("INITIAL_SESSION", "callback id", id, "session", session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback("INITIAL_SESSION", null));
                this._debug("INITIAL_SESSION", "callback id", id, "error", err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address.
     * This method supports the PKCE flow.
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === "pkce") {
            const codeVerifier = (0, $00422035477681d2$export$b6c3b8498f152f15)();
            await (0, $00422035477681d2$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
            codeChallenge = await (0, $00422035477681d2$export$eb79e16bb8189148)(codeVerifier);
            codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
        }
        try {
            return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, "begin");
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $00422035477681d2$export$9e1b8e833f44ff21)(async (attempt)=>{
                await (0, $00422035477681d2$export$e772c8ff12451969)(attempt * 200); // 0, 200, 400, 800, ...
                this._debug(debugName, "refreshing attempt", attempt);
                return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $441cebcd96f53249$export$273fe4673a018c2e)
                });
            }, (attempt, _, result)=>result && result.error && (0, $74b584ebdcc77088$export$a77af358da5fb874)(result.error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + (attempt + 1) * 200 - startedAt < $3be7e0c5163b59ae$var$AUTO_REFRESH_TICK_DURATION);
        } catch (error) {
            this._debug(debugName, "error", error);
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, "end");
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === "object" && maybeSession !== null && "access_token" in maybeSession && "refresh_token" in maybeSession && "expires_at" in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug("#_handleProviderSignIn()", "provider", provider, "options", options, "url", url);
        // try to open on the browser
        if ((0, $00422035477681d2$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = "#_recoverAndRefresh()";
        this._debug(debugName, "begin");
        try {
            const currentSession = await (0, $00422035477681d2$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug(debugName, "session from storage", currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, "session is not valid");
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const timeNow = Math.round(Date.now() / 1000);
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) < timeNow + (0, $9623383d022f1317$export$7d4b3a66850dd9bd);
            this._debug(debugName, `session has${expiresWithMargin ? "" : " not"} expired with margin of ${(0, $9623383d022f1317$export$7d4b3a66850dd9bd)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $74b584ebdcc77088$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, "refresh failed with a non-retryable error, removing the session", error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers("SIGNED_IN", currentSession);
        } catch (err) {
            this._debug(debugName, "error", err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, "end");
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $74b584ebdcc77088$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, "begin");
        try {
            this.refreshingDeferred = new (0, $00422035477681d2$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $74b584ebdcc77088$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers("TOKEN_REFRESHED", data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, "error", error);
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, "end");
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, "begin", session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, "end");
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug("#_saveSession()", session);
        if (!this.persistSession) this.inMemorySession = session;
        if (this.persistSession && session.expires_at) await this._persistSession(session);
    }
    _persistSession(currentSession) {
        this._debug("#_persistSession()", currentSession);
        return (0, $00422035477681d2$export$e82c36d29078a87f)(this.storage, this.storageKey, currentSession);
    }
    async _removeSession() {
        this._debug("#_removeSession()");
        if (this.persistSession) await (0, $00422035477681d2$export$d35c645d585317ec)(this.storage, this.storageKey);
        else this.inMemorySession = null;
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug("#_removeVisibilityChangedCallback()");
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $00422035477681d2$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener("visibilitychange", callback);
        } catch (e) {
            console.error("removing visibilitychange callback failed", e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug("#_startAutoRefresh()");
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), $3be7e0c5163b59ae$var$AUTO_REFRESH_TICK_DURATION);
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === "object" && typeof ticker.unref === "function") // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== "undefined" && typeof Deno.unrefTimer === "function") // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-ignore
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug("#_stopAutoRefresh()");
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug("#_autoRefreshTokenTick()", "begin");
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug("#_autoRefreshTokenTick()", "no session");
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / $3be7e0c5163b59ae$var$AUTO_REFRESH_TICK_DURATION);
                            this._debug("#_autoRefreshTokenTick()", `access token expires in ${expiresInTicks} ticks, a tick lasts ${$3be7e0c5163b59ae$var$AUTO_REFRESH_TICK_DURATION}ms, refresh threshold is ${$3be7e0c5163b59ae$var$AUTO_REFRESH_TICK_THRESHOLD} ticks`);
                            if (expiresInTicks <= $3be7e0c5163b59ae$var$AUTO_REFRESH_TICK_THRESHOLD) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error("Auto refresh tick failed with error. This is likely a transient error.", e);
                    }
                } finally{
                    this._debug("#_autoRefreshTokenTick()", "end");
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout) this._debug("auto refresh token tick lock not available");
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug("#_handleVisibilityChange()");
        if (!(0, $00422035477681d2$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener("visibilitychange", this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error("_handleVisibilityChange", error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, "visibilityState", document.visibilityState);
        if (document.visibilityState === "visible") {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== "visible") {
                        this._debug(methodName, "acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting");
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === "hidden") {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === "pkce") {
            const codeVerifier = (0, $00422035477681d2$export$b6c3b8498f152f15)();
            await (0, $00422035477681d2$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
            const codeChallenge = await (0, $00422035477681d2$export$eb79e16bb8189148)(codeVerifier);
            const codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
            this._debug("PKCE", "code verifier", `${codeVerifier.substring(0, 5)}...`, "code challenge", codeChallenge, "method", codeChallengeMethod);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        return `${this.url}/authorize?${urlParams.join("&")}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "DELETE", `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#enroll}
     */ async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const { data: data, error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/factors`, {
                    body: {
                        friendly_name: params.friendlyName,
                        factor_type: params.factorType,
                        issuer: params.issuer
                    },
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const { data: data, error: error } = await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/factors/${params.factorId}/verify`, {
                    body: {
                        code: params.code,
                        challenge_id: params.challengeId
                    },
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                await this._saveSession(Object.assign({
                    expires_at: Math.round(Date.now() / 1000) + data.expires_in
                }, data));
                await this._notifyAllSubscribers("MFA_CHALLENGE_VERIFIED", data);
                return {
                    data: data,
                    error: error
                };
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $441cebcd96f53249$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/factors/${params.factorId}/challenge`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $74b584ebdcc77088$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        const { data: { user: user }, error: userError } = await this._getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === "totp" && factor.status === "verified");
        return {
            data: {
                all: factors,
                totp: totp
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return await this._useSession(async (result)=>{
            var _a, _b;
            const { data: { session: session }, error: sessionError } = result;
            if (sessionError) return {
                data: null,
                error: sessionError
            };
            if (!session) return {
                data: {
                    currentLevel: null,
                    nextLevel: null,
                    currentAuthenticationMethods: []
                },
                error: null
            };
            const payload = this._decodeJWT(session.access_token);
            let currentLevel = null;
            if (payload.aal) currentLevel = payload.aal;
            let nextLevel = currentLevel;
            const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === "verified")) !== null && _b !== void 0 ? _b : [];
            if (verifiedFactors.length > 0) nextLevel = "aal2";
            const currentAuthenticationMethods = payload.amr || [];
            return {
                data: {
                    currentLevel: currentLevel,
                    nextLevel: nextLevel,
                    currentAuthenticationMethods: currentAuthenticationMethods
                },
                error: null
            };
        });
    }
}
$3be7e0c5163b59ae$export$2e2bcd8739ae039.nextInstanceID = 0;






const $a0906aa99f10b2a4$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $00422035477681d2$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem("supabase.gotrue-js.locks.debug") === "true")
};
class $a0906aa99f10b2a4$export$4aa56776043a4631 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
async function $a0906aa99f10b2a4$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($a0906aa99f10b2a4$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock: acquire lock", name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($a0906aa99f10b2a4$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock acquire timed out", name);
    }, acquireTimeout);
    return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
        mode: "exclusive",
        ifAvailable: true
    } : {
        mode: "exclusive",
        signal: abortController.signal
    }, async (lock)=>{
        if (lock) {
            if ($a0906aa99f10b2a4$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock: acquired", name);
            try {
                return await fn();
            } finally{
                if ($a0906aa99f10b2a4$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock: released", name);
            }
        } else {
            if ($a0906aa99f10b2a4$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock: not immediately available", name);
            throw new $a0906aa99f10b2a4$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
        }
    });
}




class $749e3e5261e69d2f$export$8199a418bb09bd56 extends (0, $3be7e0c5163b59ae$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $a4ec8e76ad84e045$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a4ec8e76ad84e045$var$DEFAULT_GLOBAL_OPTIONS = {
    headers: (0, $c5113035f7eb8801$export$88a84136db6a4b64)
};
const $a4ec8e76ad84e045$var$DEFAULT_DB_OPTIONS = {
    schema: "public"
};
const $a4ec8e76ad84e045$var$DEFAULT_AUTH_OPTIONS = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit"
};
const $a4ec8e76ad84e045$var$DEFAULT_REALTIME_OPTIONS = {};
class $a4ec8e76ad84e045$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error("supabaseUrl is required.");
        if (!supabaseKey) throw new Error("supabaseKey is required.");
        const _supabaseUrl = (0, $fc9502da14a2d9cf$export$d95b4586d238a081)(supabaseUrl);
        this.realtimeUrl = `${_supabaseUrl}/realtime/v1`.replace(/^http/i, "ws");
        this.authUrl = `${_supabaseUrl}/auth/v1`;
        this.storageUrl = `${_supabaseUrl}/storage/v1`;
        this.functionsUrl = `${_supabaseUrl}/functions/v1`;
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${new URL(this.authUrl).hostname.split(".")[0]}-auth-token`;
        const DEFAULTS = {
            db: $a4ec8e76ad84e045$var$DEFAULT_DB_OPTIONS,
            realtime: $a4ec8e76ad84e045$var$DEFAULT_REALTIME_OPTIONS,
            auth: Object.assign(Object.assign({}, $a4ec8e76ad84e045$var$DEFAULT_AUTH_OPTIONS), {
                storageKey: defaultStorageKey
            }),
            global: $a4ec8e76ad84e045$var$DEFAULT_GLOBAL_OPTIONS
        };
        const settings = (0, $fc9502da14a2d9cf$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_b = (_a = settings.auth) === null || _a === void 0 ? void 0 : _a.storageKey) !== null && _b !== void 0 ? _b : "";
        this.headers = (_d = (_c = settings.global) === null || _c === void 0 ? void 0 : _c.headers) !== null && _d !== void 0 ? _d : {};
        this.auth = this._initSupabaseAuthClient((_e = settings.auth) !== null && _e !== void 0 ? _e : {}, this.headers, (_f = settings.global) === null || _f === void 0 ? void 0 : _f.fetch);
        this.fetch = (0, $e337ab32d749d3c4$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), (_g = settings.global) === null || _g === void 0 ? void 0 : _g.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers
        }, settings.realtime));
        this.rest = new (0, $6444a94a19ea6021$export$2e2bcd8739ae039)(`${_supabaseUrl}/rest/v1`, {
            headers: this.headers,
            schema: (_h = settings.db) === null || _h === void 0 ? void 0 : _h.schema,
            fetch: this.fetch
        });
        this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $588417d55a54c202$export$1d0b400bf8a0fa55)(this.functionsUrl, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $48fe968ae386da99$export$6c85f5032e75eff9)(this.storageUrl, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    /**
     * Perform a query on a schema distinct from the default schema supplied via
     * the `options.db.schema` constructor parameter.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The name of the schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $a4ec8e76ad84e045$var$__awaiter(this, void 0, void 0, function*() {
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, debug: debug }, headers, fetch) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $749e3e5261e69d2f$export$8199a418bb09bd56)({
            url: this.authUrl,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            debug: debug,
            fetch: fetch
        });
    }
    _initRealtimeClient(options) {
        return new (0, $bc6d42c48befec0d$export$2e2bcd8739ae039)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, "CLIENT", session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === "TOKEN_REFRESHED" || event === "SIGNED_IN") && this.changedAccessToken !== token) {
            // Token has changed
            this.realtime.setAuth(token !== null && token !== void 0 ? token : null);
            this.changedAccessToken = token;
        } else if (event === "SIGNED_OUT") {
            // Token is removed
            this.realtime.setAuth(this.supabaseKey);
            if (source == "STORAGE") this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}





const $0fc83e79bdde18ac$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $a4ec8e76ad84e045$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};


"use client";
let $1a50cd70d80fe90f$export$a0b632a28672d3c0 = (0, $0fc83e79bdde18ac$export$5d730b7aed1a3eb0)("https://sb-v2c.boringserver.de", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.ewogICJyb2xlIjogImFub24iLAogICJpc3MiOiAic3VwYWJhc2UiLAogICJpYXQiOiAxNjk0NDY2MDAwLAogICJleHAiOiAxODUyMzE4ODAwCn0.sRg2W2AvdCjM0X2MORpnfMUHBISVxE8IMcYKbAxEi8U", {
    auth: {
        persistSession: true
    }
});
$parcel$global.supabase = $1a50cd70d80fe90f$export$a0b632a28672d3c0;
const $1a50cd70d80fe90f$export$8877424c5d02150d = (jwt)=>{
    $1a50cd70d80fe90f$export$a0b632a28672d3c0 = (0, $0fc83e79bdde18ac$export$5d730b7aed1a3eb0)("https://sb-v2c.boringserver.de", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.ewogICJyb2xlIjogImFub24iLAogICJpc3MiOiAic3VwYWJhc2UiLAogICJpYXQiOiAxNjk0NDY2MDAwLAogICJleHAiOiAxODUyMzE4ODAwCn0.sRg2W2AvdCjM0X2MORpnfMUHBISVxE8IMcYKbAxEi8U", {
        global: {
            headers: {
                Authorization: `Bearer ${jwt}`
            }
        },
        auth: {
            autoRefreshToken: false
        },
        realtime: {
            headers: {
                apikey: jwt
            },
            params: {
                apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.ewogICJyb2xlIjogImFub24iLAogICJpc3MiOiAic3VwYWJhc2UiLAogICJpYXQiOiAxNjk0NDY2MDAwLAogICJleHAiOiAxODUyMzE4ODAwCn0.sRg2W2AvdCjM0X2MORpnfMUHBISVxE8IMcYKbAxEi8U"
            }
        }
    });
    $1a50cd70d80fe90f$export$a0b632a28672d3c0.realtime.setAuth(jwt);
    $parcel$global.supabase = $1a50cd70d80fe90f$export$a0b632a28672d3c0;
};
const $1a50cd70d80fe90f$export$4e887858c29ba818 = ()=>{
    $1a50cd70d80fe90f$export$a0b632a28672d3c0 = (0, $0fc83e79bdde18ac$export$5d730b7aed1a3eb0)("https://sb-v2c.boringserver.de", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.ewogICJyb2xlIjogImFub24iLAogICJpc3MiOiAic3VwYWJhc2UiLAogICJpYXQiOiAxNjk0NDY2MDAwLAogICJleHAiOiAxODUyMzE4ODAwCn0.sRg2W2AvdCjM0X2MORpnfMUHBISVxE8IMcYKbAxEi8U", {
        auth: {
            persistSession: false
        }
    });
    $parcel$global.supabase = $1a50cd70d80fe90f$export$a0b632a28672d3c0;
};


const $d336a34c328aa6f0$export$41c7a4cacf5bab80 = async ({ video_id: video_id, variant: variant, instructions: instructions, speechForm: speechForm, tone: tone, sourceLang: sourceLang, targetLang: targetLang, enforce_gender_neutral_language: enforce_gender_neutral_language })=>{
    try {
        const { data: data, error: error } = await (0, $1a50cd70d80fe90f$export$a0b632a28672d3c0).functions.invoke("createContent", {
            body: {
                video_id: video_id,
                variant: variant,
                instructions: instructions,
                speechForm: speechForm,
                tone: tone,
                sourceLang: sourceLang,
                targetLang: targetLang,
                enforce_gender_neutral_language: enforce_gender_neutral_language
            }
        });
        if (error) throw error;
        const { id: id } = data;
        return id;
    } catch (err) {
        alert("Something went wrong: " + err);
    }
    return null;
};



const $ee081fee25ce8b96$export$46465da417f6860a = async ({ url: url, sourceLang: sourceLang })=>{
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;
    const match = regex.exec(url);
    if (!match) {
        alert("Ung\xfcltige URL");
        return;
    }
    const { data: data, error: error } = await (0, $1a50cd70d80fe90f$export$a0b632a28672d3c0).functions.invoke("createTranscript", {
        body: {
            url: url,
            sourceLang: sourceLang
        }
    });
    if (error) throw error;
    const transcript_id = data?.id;
    if (!transcript_id) throw new Error("Something went wrong...");
    return transcript_id;
};





function $47afaa71a6a401ac$var$Icon() {
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48px",
        height: "48px",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("g", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("circle", {
                        cx: "60",
                        cy: "50",
                        r: "4",
                        fill: "#7cb9e8",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("animate", {
                                attributeName: "cx",
                                repeatCount: "indefinite",
                                dur: "0.9900990099009901s",
                                values: "95;35",
                                keyTimes: "0;1",
                                begin: "-0.6767000000000001s"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("animate", {
                                attributeName: "fill-opacity",
                                repeatCount: "indefinite",
                                dur: "0.9900990099009901s",
                                values: "0;1;1",
                                keyTimes: "0;0.2;1",
                                begin: "-0.6767000000000001s"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("circle", {
                        cx: "60",
                        cy: "50",
                        r: "4",
                        fill: "#7cb9e8",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("animate", {
                                attributeName: "cx",
                                repeatCount: "indefinite",
                                dur: "0.9900990099009901s",
                                values: "95;35",
                                keyTimes: "0;1",
                                begin: "-0.33330000000000004s"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("animate", {
                                attributeName: "fill-opacity",
                                repeatCount: "indefinite",
                                dur: "0.9900990099009901s",
                                values: "0;1;1",
                                keyTimes: "0;0.2;1",
                                begin: "-0.33330000000000004s"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("circle", {
                        cx: "60",
                        cy: "50",
                        r: "4",
                        fill: "#7cb9e8",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("animate", {
                                attributeName: "cx",
                                repeatCount: "indefinite",
                                dur: "0.9900990099009901s",
                                values: "95;35",
                                keyTimes: "0;1",
                                begin: "0s"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("animate", {
                                attributeName: "fill-opacity",
                                repeatCount: "indefinite",
                                dur: "0.9900990099009901s",
                                values: "0;1;1",
                                keyTimes: "0;0.2;1",
                                begin: "0s"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("g", {
                transform: "translate(-15 0)",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("path", {
                        d: "M50 50L20 50A30 30 0 0 0 80 50Z",
                        fill: "#1e88e5",
                        transform: "rotate(90 50 50)"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("path", {
                        d: "M50 50L20 50A30 30 0 0 0 80 50Z",
                        fill: "#1e88e5",
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            repeatCount: "indefinite",
                            dur: "0.9900990099009901s",
                            values: "0 50 50;45 50 50;0 50 50",
                            keyTimes: "0;0.5;1"
                        })
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("path", {
                        d: "M50 50L20 50A30 30 0 0 1 80 50Z",
                        fill: "#1e88e5",
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            repeatCount: "indefinite",
                            dur: "0.9900990099009901s",
                            values: "0 50 50;-45 50 50;0 50 50",
                            keyTimes: "0;0.5;1"
                        })
                    })
                ]
            })
        ]
    });
}
var $47afaa71a6a401ac$export$2e2bcd8739ae039 = $47afaa71a6a401ac$var$Icon;




function $8deb727031ea0754$export$bea8ebba691c5813({ value: value, onChange: onChange, options: options, optionLabels: optionLabels }) {
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "flex space-x-4",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                className: `${value == options[0] ? "bg-[00005D] text-white" : "bg-white hover:bg-gray-200 hover:text-black"} font-bold py-2 px-4 rounded`,
                onClick: ()=>onChange(options[0]),
                children: optionLabels?.[0] ?? options[0].toString()
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                className: `${value == options[1] ? "bg-[00005D] text-white" : "bg-white hover:bg-gray-200 hover:text-black"} font-bold py-2 px-4 rounded`,
                onClick: ()=>onChange(options[1]),
                children: optionLabels?.[1] ?? options[1].toString()
            })
        ]
    });
}




function $b6777f1c1ba36d0f$var$CustomSelect({ options: options, value: value, onSelect: onSelect }) {
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("select", {
                value: value,
                className: "block text-white font-bold appearance-none w-full bg-[00005D] border border-purple-900 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline",
                id: "select",
                onChange: (e)=>onSelect(e.target.value),
                children: options.map((option)=>/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("option", {
                        value: option.value,
                        children: option.label
                    }, option.value))
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-white",
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("svg", {
                    className: "fill-current h-4 w-4",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("path", {
                        fillRule: "evenodd",
                        d: "M6.293 9.293a1 1 0 011.414 0L10 10.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
}
var $b6777f1c1ba36d0f$export$2e2bcd8739ae039 = $b6777f1c1ba36d0f$var$CustomSelect;




const $aa75190f061ee859$export$57776a505fcc1846 = ({ value: value, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $8deb727031ea0754$export$bea8ebba691c5813), {
        value: value,
        onChange: onChange,
        options: [
            "en",
            "de"
        ],
        optionLabels: [
            "Englisch",
            "Deutsch"
        ]
    });
};
var $aa75190f061ee859$export$2e2bcd8739ae039 = $aa75190f061ee859$export$57776a505fcc1846;





const $b84d49b1a1347f2d$export$a92f85ab3e9ad68b = /*#__PURE__*/ (0, $69d723089b47cf34$export$2e2bcd8739ae039).createContext(null);
const $b84d49b1a1347f2d$export$5261e812c31263e7 = ({ children: children })=>{
    const [config, setConfig] = (0, $69d723089b47cf34$export$2e2bcd8739ae039).useState({
        sourceLang: "de",
        targetLang: "de",
        instructions: "",
        speechForm: "polite",
        tone: "neutral",
        enforce_gender_neutral_language: "not_important"
    });
    const setConfigByKey = (0, $a70cf465074cab30$export$35808ee640e87ca7)((key, value)=>{
        setConfig({
            ...config,
            [key]: value
        });
    }, [
        config
    ]);
    const value = (0, $a70cf465074cab30$export$1538c33de8887b59)(()=>({
            config: config,
            setConfigByKey: setConfigByKey
        }), [
        config,
        setConfigByKey
    ]);
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)($b84d49b1a1347f2d$export$a92f85ab3e9ad68b.Provider, {
        value: value,
        children: children
    });
};


const $fadf4212432a6cdb$export$b3611e87cd5ba6ce = ()=>(0, $69d723089b47cf34$export$2e2bcd8739ae039).useContext((0, $b84d49b1a1347f2d$export$a92f85ab3e9ad68b));





const $bd2db0da17abe19a$export$1218bc8dc9713867 = /*#__PURE__*/ (0, $e48b1195589f71e3$export$fd42f52fd3ae1109)(null);
const $bd2db0da17abe19a$export$d724fb526705b3e = ({ children: children })=>{
    const [url, setUrl] = (0, $a70cf465074cab30$export$60241385465d0a34)("");
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)($bd2db0da17abe19a$export$1218bc8dc9713867.Provider, {
        value: {
            url: url,
            setUrl: setUrl
        },
        children: children
    });
};


"use client";
const $5d6f5477ad1a9e8b$var$ToneOptions = [
    {
        label: "neutral",
        value: "neutral"
    },
    {
        label: "locker",
        value: "casual"
    },
    {
        label: "verspielt",
        value: "playful"
    },
    {
        label: "mitrei\xdfend",
        value: "engaging"
    },
    {
        label: "inspirierend",
        value: "inspirational"
    },
    {
        label: "humorvoll",
        value: "humorous"
    },
    {
        label: "formell",
        value: "formal"
    },
    {
        label: "informativ",
        value: "informative"
    },
    {
        label: "akademisch",
        value: "academic"
    },
    {
        label: "technisch",
        value: "technical"
    }
];
const $5d6f5477ad1a9e8b$export$6672fc3587a16178 = ({ onSubmit: onSubmit, loading: loading })=>{
    const { config: config, setConfigByKey: setConfigByKey } = (0, $fadf4212432a6cdb$export$b3611e87cd5ba6ce)();
    const { url: url, setUrl: setUrl } = (0, $a70cf465074cab30$export$fae74005e78b1a27)((0, $bd2db0da17abe19a$export$1218bc8dc9713867));
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: "max-w-[600px] w-full bg-secondary rounded-md shadow-2xl p-[16px] flex flex-col gap-[16px] animate-fadeIn",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                className: "block mb-2 text-sm font-medium",
                                children: "Aus welchem Video m\xf6chtest du einen Artikel erstellen?"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("input", {
                                value: url,
                                onChange: (e)=>setUrl(e.target.value),
                                type: "text",
                                id: "url",
                                className: "border text-sm rounded-lg block w-full p-2.5 border-gray-600 placeholder-gray-400  focus:ring-coral-500 focus:border-coral-500",
                                placeholder: "https://www.youtube.com/watch?v=TX9qSaGXFyg",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                        onClick: !loading ? onSubmit : undefined,
                        type: "button",
                        className: `w-full text-white h-[40px] bg-gradient-to-br bg-black hover:bg-[00005D] focus:ring-4 focus:outline-none focus:ring-coral-300 dark:focus:ring-coral-800 font-medium rounded-lg text-sm flex  items-center justify-center text-center mr-2 mb-2`,
                        children: !loading ? "Artikel generieren" : /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $47afaa71a6a401ac$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        children: loading ? "Pro 10 Minuten Video dauert die Generierung etwa eine Minute. Dieses Fenster bitte nicht schlie\xdfen. Du wirst automatisch auf den generierten Artikel weitergeleitet." : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: "flex flex-col gap-[8px] items-center max-w-[600px] w-full mt-5",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                        className: "text-[20px] font-semibold ",
                        children: "Optionen"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "flex gap-[8px] w-full flex-col",
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                            className: "max-w-[600px] w-full bg-secondary rounded-md shadow-2xl p-[16px] flex flex-col gap-[16px] animate-fadeIn",
                            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                        className: "block mb-2 text-sm font-medium",
                                        children: "Sprache des Videos"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $aa75190f061ee859$export$2e2bcd8739ae039), {
                                        value: config.sourceLang,
                                        onChange: (v)=>setConfigByKey("sourceLang", v)
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                        className: "block mb-2 text-sm font-medium",
                                        children: "In welcher Sprache soll der Artikel verfasst sein?"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $aa75190f061ee859$export$2e2bcd8739ae039), {
                                        value: config.targetLang,
                                        onChange: (v)=>setConfigByKey("targetLang", v)
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                        className: "block mb-2 text-sm font-medium",
                                        children: "Wie sollen Lesende angesprochen werden?"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $8deb727031ea0754$export$bea8ebba691c5813), {
                                        value: config.speechForm,
                                        onChange: (v)=>setConfigByKey("speechForm", v),
                                        options: [
                                            "polite",
                                            "general"
                                        ],
                                        optionLabels: [
                                            "Siezen",
                                            "Duzen"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                                className: "block mb-2 text-sm font-medium",
                                                htmlFor: "select",
                                                children: "Tonfall des Textes"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $b6777f1c1ba36d0f$export$2e2bcd8739ae039), {
                                                options: $5d6f5477ad1a9e8b$var$ToneOptions,
                                                onSelect: (v)=>setConfigByKey("tone", v),
                                                value: config.tone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                                className: "block mb-2 text-sm font-medium",
                                                htmlFor: "select",
                                                children: "Soll genderneutrale Sprache verwendet werden?"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $8deb727031ea0754$export$bea8ebba691c5813), {
                                                value: config.enforce_gender_neutral_language,
                                                onChange: (v)=>setConfigByKey("enforce_gender_neutral_language", v),
                                                options: [
                                                    "strict",
                                                    "not_important"
                                                ],
                                                optionLabels: [
                                                    "Ja",
                                                    "Nicht unbedingt"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {})
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};










const $de187eb300fae735$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $69d723089b47cf34$export$2e2bcd8739ae039).createContext(null);
function $de187eb300fae735$export$87091915187a1a85({ children: children }) {
    let [jwt, setJwt] = (0, $69d723089b47cf34$export$2e2bcd8739ae039).useState(localStorage.getItem("v2ct"));
    let [voucher, setVoucher] = (0, $69d723089b47cf34$export$2e2bcd8739ae039).useState(localStorage.getItem("v2cv"));
    (0, $a70cf465074cab30$export$6d9c69b0de29b591)(()=>{
        const storedJwt = localStorage.getItem("v2ct");
        const storedVoucher = localStorage.getItem("v2cv");
        if (jwt === null && storedJwt !== null) setJwt(storedJwt);
        if (voucher === null && storedVoucher !== null) setVoucher(storedVoucher);
        if (jwt !== null) (0, $1a50cd70d80fe90f$export$8877424c5d02150d)(jwt);
    }, []);
    let signIn = async (voucher)=>{
        if (!jwt) {
            const { error: error, data: data } = await (0, $1a50cd70d80fe90f$export$a0b632a28672d3c0).functions.invoke("getToken", {
                body: {
                    voucher_id: voucher
                }
            });
            if (error) throw Error(error);
            setJwt(data.jwt);
            localStorage.setItem("v2ct", data.jwt);
            localStorage.setItem("v2cv", data.voucherId);
            setVoucher(data.voucherId);
            (0, $1a50cd70d80fe90f$export$8877424c5d02150d)(data.jwt);
        }
    };
    let signOut = ()=>{
        (0, $1a50cd70d80fe90f$export$4e887858c29ba818)();
        setVoucher(null);
        setJwt(null);
        localStorage.removeItem("v2ct");
        localStorage.removeItem("v2cv");
        window.location.reload();
    };
    let value = {
        jwt: jwt,
        signIn: signIn,
        signOut: signOut,
        voucher: voucher
    };
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)($de187eb300fae735$export$a0fd8390cfe8ae69.Provider, {
        value: value,
        children: children
    });
}


const $1b1216ab6f64a7b3$export$1d39dc5b47e56ff0 = ()=>(0, $69d723089b47cf34$export$2e2bcd8739ae039).useContext((0, $de187eb300fae735$export$a0fd8390cfe8ae69));




async function $ac0a6b968bc69320$export$31d6a278b5f09bf3(voucher) {
    const { error: error, data: data } = await (0, $1a50cd70d80fe90f$export$a0b632a28672d3c0).functions.invoke("getVoucher", {
        body: {
            voucher_id: voucher
        }
    });
    if (error) console.error(error);
    if (typeof data.voucher.uses_left !== "number") throw new Error("expected voucher uses to be number");
    return data.voucher.uses_left;
}


const $57fbefa1899fb8b2$export$77c219755a7e3571 = ()=>{
    const auth = (0, $1b1216ab6f64a7b3$export$1d39dc5b47e56ff0)();
    const navigate = (0, $23ae8c349145cf41$export$9770f232ac06a008)();
    const [usesLeft, setUsesLeft] = (0, $a70cf465074cab30$export$60241385465d0a34)(null);
    (0, $a70cf465074cab30$export$6d9c69b0de29b591)(()=>{
        if (!auth.jwt) return;
        (0, $ac0a6b968bc69320$export$31d6a278b5f09bf3)(auth.voucher).then((res)=>setUsesLeft(res));
    }, [
        auth.jwt,
        auth.voucher
    ]);
    if (!auth.jwt) return null;
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "text-gray-600",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    " ",
                    "Dein Guthaben Code:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        className: "text-gray-800",
                        children: auth.voucher
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                className: "mt-2",
                children: [
                    "Das restliche Guthaben betr\xe4gt",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        className: "text-gray-800",
                        children: [
                            usesLeft,
                            " Artikel."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                    className: "font-montserrat mt-4 hover:bg-white px-6 py-4 border-2 border-black border-solid rounded-lg",
                    onClick: ()=>{
                        auth.signOut();
                        navigate("/");
                    },
                    children: "Abmelden"
                })
            })
        ]
    });
};



const $127fc70a3eb0946d$export$e0492843958acefd = ()=>{
    const navigate = (0, $23ae8c349145cf41$export$9770f232ac06a008)();
    const { url: url, setUrl: setUrl } = (0, $a70cf465074cab30$export$fae74005e78b1a27)((0, $bd2db0da17abe19a$export$1218bc8dc9713867));
    const [loading, setLoading] = (0, $a70cf465074cab30$export$60241385465d0a34)(false);
    const { config: config } = (0, $fadf4212432a6cdb$export$b3611e87cd5ba6ce)();
    const requestContent = async (variant, instructions, video_id)=>{
        try {
            const id = await (0, $d336a34c328aa6f0$export$41c7a4cacf5bab80)({
                ...config,
                variant: variant,
                instructions: instructions,
                video_id: video_id
            });
            return id;
        } catch (err) {
            alert(`Unable to process given video, try another one. (Error: ${err})`);
        }
    };
    const getTranscript = async ()=>{
        try {
            const transcriptId = await (0, $ee081fee25ce8b96$export$46465da417f6860a)({
                url: url,
                sourceLang: config.sourceLang
            });
            return transcriptId;
        } catch (err) {
            alert(`Videoinhalt nicht erkannt. Stimmt die Spracheinstellung? (Fehler: ${err})`);
        }
    };
    const onSubmit = async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            const transcriptId = await getTranscript();
            const id = await requestContent("blog", "", transcriptId); // TODO remove or implement instructions
            navigate(`/blog/${id}`);
        } catch (err) {
            alert(`Video konnte nicht verarbeitet werden (Fehler: ${err}`);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
        className: "sectionSize bg-secondary align",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "secondaryTitle bg-underline3 bg-100%",
                children: "Artikel erstellen"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $5d6f5477ad1a9e8b$export$6672fc3587a16178), {
                onSubmit: onSubmit,
                loading: loading
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: "mt-20",
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $57fbefa1899fb8b2$export$77c219755a7e3571), {})
            })
        ]
    });
};



/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */ /**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $75b5f8c3284da1b7$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $75b5f8c3284da1b7$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $75b5f8c3284da1b7$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $186565a236e81cbc$var$hasOwnProperty = {}.hasOwnProperty;
function $186565a236e81cbc$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$186565a236e81cbc$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $186565a236e81cbc$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $186565a236e81cbc$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$186565a236e81cbc$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $186565a236e81cbc$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $186565a236e81cbc$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $75b5f8c3284da1b7$export$869882364835d202)(existing, 0, 0, before);
}
function $186565a236e81cbc$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$186565a236e81cbc$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $186565a236e81cbc$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $186565a236e81cbc$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $13427ae9ca1bb67d$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $c275d3577f33f6fc$export$d65d6b62c24d5436 = $c275d3577f33f6fc$var$regexCheck(/[A-Za-z]/);
const $c275d3577f33f6fc$export$75c76db11865a9f4 = $c275d3577f33f6fc$var$regexCheck(/[\dA-Za-z]/);
const $c275d3577f33f6fc$export$4397998b34fe597d = $c275d3577f33f6fc$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $c275d3577f33f6fc$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $c275d3577f33f6fc$export$ca8b5b1a6c320e6e = $c275d3577f33f6fc$var$regexCheck(/\d/);
const $c275d3577f33f6fc$export$eca2752363989806 = $c275d3577f33f6fc$var$regexCheck(/[\dA-Fa-f]/);
const $c275d3577f33f6fc$export$35794a7d1db99380 = $c275d3577f33f6fc$var$regexCheck(/[!-/:-@[-`{-~]/);
function $c275d3577f33f6fc$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $c275d3577f33f6fc$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $c275d3577f33f6fc$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $c275d3577f33f6fc$export$aa04114dd888a7a0 = $c275d3577f33f6fc$var$regexCheck((0, $13427ae9ca1bb67d$export$85b5101f24802e8c));
const $c275d3577f33f6fc$export$a0ff789c034ffdf4 = $c275d3577f33f6fc$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $c275d3577f33f6fc$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


const $a2737e5271d93243$var$wwwPrefix = {
    tokenize: $a2737e5271d93243$var$tokenizeWwwPrefix,
    partial: true
};
const $a2737e5271d93243$var$domain = {
    tokenize: $a2737e5271d93243$var$tokenizeDomain,
    partial: true
};
const $a2737e5271d93243$var$path = {
    tokenize: $a2737e5271d93243$var$tokenizePath,
    partial: true
};
const $a2737e5271d93243$var$trail = {
    tokenize: $a2737e5271d93243$var$tokenizeTrail,
    partial: true
};
const $a2737e5271d93243$var$emailDomainDotTrail = {
    tokenize: $a2737e5271d93243$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $a2737e5271d93243$var$wwwAutolink = {
    tokenize: $a2737e5271d93243$var$tokenizeWwwAutolink,
    previous: $a2737e5271d93243$var$previousWww
};
const $a2737e5271d93243$var$protocolAutolink = {
    tokenize: $a2737e5271d93243$var$tokenizeProtocolAutolink,
    previous: $a2737e5271d93243$var$previousProtocol
};
const $a2737e5271d93243$var$emailAutolink = {
    tokenize: $a2737e5271d93243$var$tokenizeEmailAutolink,
    previous: $a2737e5271d93243$var$previousEmail
};
/** @type {ConstructRecord} */ const $a2737e5271d93243$var$text = {};
const $a2737e5271d93243$export$608123d9b549151 = {
    text: $a2737e5271d93243$var$text
};
/** @type {Code} */ let $a2737e5271d93243$var$code = 48;
// Add alphanumerics.
while($a2737e5271d93243$var$code < 123){
    $a2737e5271d93243$var$text[$a2737e5271d93243$var$code] = $a2737e5271d93243$var$emailAutolink;
    $a2737e5271d93243$var$code++;
    if ($a2737e5271d93243$var$code === 58) $a2737e5271d93243$var$code = 65;
    else if ($a2737e5271d93243$var$code === 91) $a2737e5271d93243$var$code = 97;
}
$a2737e5271d93243$var$text[43] = $a2737e5271d93243$var$emailAutolink;
$a2737e5271d93243$var$text[45] = $a2737e5271d93243$var$emailAutolink;
$a2737e5271d93243$var$text[46] = $a2737e5271d93243$var$emailAutolink;
$a2737e5271d93243$var$text[95] = $a2737e5271d93243$var$emailAutolink;
$a2737e5271d93243$var$text[72] = [
    $a2737e5271d93243$var$emailAutolink,
    $a2737e5271d93243$var$protocolAutolink
];
$a2737e5271d93243$var$text[104] = [
    $a2737e5271d93243$var$emailAutolink,
    $a2737e5271d93243$var$protocolAutolink
];
$a2737e5271d93243$var$text[87] = [
    $a2737e5271d93243$var$emailAutolink,
    $a2737e5271d93243$var$wwwAutolink
];
$a2737e5271d93243$var$text[119] = [
    $a2737e5271d93243$var$emailAutolink,
    $a2737e5271d93243$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2737e5271d93243$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$a2737e5271d93243$var$gfmAtext(code) || !$a2737e5271d93243$var$previousEmail.call(self, self.previous) || $a2737e5271d93243$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($a2737e5271d93243$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($a2737e5271d93243$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2737e5271d93243$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$a2737e5271d93243$var$previousWww.call(self, self.previous) || $a2737e5271d93243$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($a2737e5271d93243$var$wwwPrefix, effects.attempt($a2737e5271d93243$var$domain, effects.attempt($a2737e5271d93243$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2737e5271d93243$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $a2737e5271d93243$var$previousProtocol.call(self, self.previous) && !$a2737e5271d93243$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $c275d3577f33f6fc$export$67dbf494fc8394df)(code) || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) || (0, $c275d3577f33f6fc$export$a0ff789c034ffdf4)(code) || (0, $c275d3577f33f6fc$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($a2737e5271d93243$var$domain, effects.attempt($a2737e5271d93243$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2737e5271d93243$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2737e5271d93243$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($a2737e5271d93243$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) || (0, $c275d3577f33f6fc$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $c275d3577f33f6fc$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2737e5271d93243$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($a2737e5271d93243$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) || (0, $c275d3577f33f6fc$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2737e5271d93243$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) || (0, $c275d3577f33f6fc$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) || (0, $c275d3577f33f6fc$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2737e5271d93243$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $a2737e5271d93243$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $a2737e5271d93243$var$previousProtocol(code) {
    return !(0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $a2737e5271d93243$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $a2737e5271d93243$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $a2737e5271d93243$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $a2737e5271d93243$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
const $0aa32956095b059c$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $0aa32956095b059c$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $0aa32956095b059c$var$characterReferences[value] + ";";
    }
}


function $ed1b1d373b59fd1b$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $0aa32956095b059c$export$c564cdbbe6da493)($ed1b1d373b59fd1b$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $ed1b1d373b59fd1b$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}


const $c3b500e15efcdb45$export$999603f1f1c3d2f9 = {
    exit: {
        literalAutolinkEmail: $c3b500e15efcdb45$var$literalAutolinkEmail,
        literalAutolinkHttp: $c3b500e15efcdb45$var$literalAutolinkHttp,
        literalAutolinkWww: $c3b500e15efcdb45$var$literalAutolinkWww
    }
};
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $c3b500e15efcdb45$var$literalAutolinkWww(token) {
    $c3b500e15efcdb45$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $c3b500e15efcdb45$var$literalAutolinkEmail(token) {
    $c3b500e15efcdb45$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $c3b500e15efcdb45$var$literalAutolinkHttp(token) {
    $c3b500e15efcdb45$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {void}
 */ function $c3b500e15efcdb45$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $ed1b1d373b59fd1b$export$d130a2d684099e5a)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $44c65789cb843c57$export$d50d28ce3ab2a612 = {
    tokenize: $44c65789cb843c57$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $44c65789cb843c57$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}




/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $66178553af254d60$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $ce57c678acb6b816$var$indent = {
    tokenize: $ce57c678acb6b816$var$tokenizeIndent,
    partial: true
};
function $ce57c678acb6b816$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                tokenize: $ce57c678acb6b816$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $ce57c678acb6b816$var$tokenizeDefinitionContinuation
                },
                exit: $ce57c678acb6b816$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                tokenize: $ce57c678acb6b816$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                add: "after",
                tokenize: $ce57c678acb6b816$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $ce57c678acb6b816$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce57c678acb6b816$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $66178553af254d60$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $ce57c678acb6b816$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: "gfmFootnoteCall",
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: "gfmFootnoteCallMarker",
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: "gfmFootnoteCallString",
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: "string",
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            "enter",
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            "enter",
            marker,
            context
        ],
        [
            "exit",
            marker,
            context
        ],
        // Everything in between.
        [
            "enter",
            string,
            context
        ],
        [
            "enter",
            chunk,
            context
        ],
        [
            "exit",
            chunk,
            context
        ],
        [
            "exit",
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            "exit",
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce57c678acb6b816$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteCall");
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter("gfmFootnoteCallMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallMarker");
        effects.enter("gfmFootnoteCallString");
        effects.enter("chunkString").contentType = "string";
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteCallString");
            if (!defined.includes((0, $66178553af254d60$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter("gfmFootnoteCallLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteCallLabelMarker");
            effects.exit("gfmFootnoteCall");
            return ok;
        }
        if (!(0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce57c678acb6b816$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteDefinition")._container = true;
        effects.enter("gfmFootnoteDefinitionLabel");
        effects.enter("gfmFootnoteDefinitionLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteDefinitionLabelMarker");
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter("gfmFootnoteDefinitionMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionMarker");
            effects.enter("gfmFootnoteDefinitionLabelString");
            effects.enter("chunkString").contentType = "string";
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteDefinitionLabelString");
            identifier = (0, $66178553af254d60$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter("gfmFootnoteDefinitionLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionLabelMarker");
            effects.exit("gfmFootnoteDefinitionLabel");
            return labelAfter;
        }
        if (!(0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce57c678acb6b816$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $44c65789cb843c57$export$d50d28ce3ab2a612), ok, effects.attempt($ce57c678acb6b816$var$indent, ok, nok));
}
/** @type {Exiter} */ function $ce57c678acb6b816$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit("gfmFootnoteDefinition");
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce57c678acb6b816$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @callback BackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   * `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   * `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   * `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent them from
 *   *clobbering*.
 *
 *   The default is `'user-content-'`.
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {string} [label='Footnotes']
 *   Textual label to use for the footnotes section.
 *
 *   The default value is `'Footnotes'`.
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {string} [labelAttributes='class="sr-only"']
 *   Attributes to use on the footnote label.
 *
 *   Change it to show the label and add other attributes.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different attributes.
 *
 *   > 👉 **Note**: `id="footnote-label"` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string} [labelTagName='h2']
 *   HTML tag name to use for the footnote label element.
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {BackLabelTemplate | string} [backLabel]
 *   Textual label to describe the backreference back to references.
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *  }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `aria-label` attribute on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 */ 

const $d10f1ff117c1f99b$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $d10f1ff117c1f99b$var$emptyOptions = {};
function $d10f1ff117c1f99b$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $d10f1ff117c1f99b$export$a731a1f6cf81900c(options) {
    const config = options || $d10f1ff117c1f99b$var$emptyOptions;
    const label = config.label || "Footnotes";
    const labelTagName = config.labelTagName || "h2";
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $d10f1ff117c1f99b$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? "user-content-" : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData("tightStack");
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData("gfmFootnoteDefinitions");
                const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                const tightStack = this.getData("tightStack");
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData("gfmFootnoteDefinitions", definitions = {});
                if (!$d10f1ff117c1f99b$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData("slurpOneLineEnding", true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData("lastWasTag");
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = /** @type {Array<string>} */ this.getData("gfmFootnoteDefinitionStack");
                if (!footnoteStack) this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
                footnoteStack.push((0, $66178553af254d60$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume() // Drop the label.
                ;
                this.buffer() // Get ready for a value.
                ;
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData("gfmFootnoteCallOrder");
                let counts = this.getData("gfmFootnoteCallCounts");
                const id = (0, $66178553af254d60$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData("gfmFootnoteCallOrder", calls = []);
                if (!counts) this.setData("gfmFootnoteCallCounts", counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $ed1b1d373b59fd1b$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>");
            },
            null () {
                const calls = /** @type {Array<string>} */ this.getData("gfmFootnoteCallOrder") || [];
                const counts = /** @type {Record<string, number>} */ this.getData("gfmFootnoteCallCounts") || {};
                const definitions = /** @type {Record<string, string>} */ this.getData("gfmFootnoteDefinitions") || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">");
                    this.raw(this.encode(label));
                    this.tag("</" + labelTagName + ">");
                    this.lineEndingIfNeeded();
                    this.tag("<ol>");
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $ed1b1d373b59fd1b$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>");
                    const reference = references.join(" ");
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, (/** @type {string} */ $0)=>{
                        injected = true;
                        return " " + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag("</li>");
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag("</ol>");
                    this.lineEndingIfNeeded();
                    this.tag("</section>");
                }
            }
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $e084bd2160831bdd$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) || (0, $c275d3577f33f6fc$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $c275d3577f33f6fc$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $67be2b7105a26e97$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $0fc7bfc94cef281f$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                /** @type {Token} */ const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $75b5f8c3284da1b7$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $67be2b7105a26e97$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $75b5f8c3284da1b7$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $75b5f8c3284da1b7$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $e084bd2160831bdd$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $e084bd2160831bdd$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function instead of object.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GFM strikethrough when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $185de8dcdb1aee2a$export$58acedca46108820 = {
    enter: {
        strikethrough () {
            this.tag("<del>");
        }
    },
    exit: {
        strikethrough () {
            this.tag("</del>");
        }
    }
};


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $64798abe44cbf078$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */ add(index, remove, add) {
        $64798abe44cbf078$var$addImpl(this, index, remove, add);
    }
    // To do: not used here.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {void}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */ consume(events) {
        this.map.sort((a, b)=>a[0] - b[0]);
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]));
            // eslint-disable-next-line unicorn/no-array-push-push
            vecs.push(this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */ function $64798abe44cbf078$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       console.log('to do: links?', add, rmCurr)
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */ function $34566bba7c0fdf8d$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}


const $d487398e1b9f74f6$export$e36cebda627bf2dd = {
    flow: {
        null: {
            tokenize: $d487398e1b9f74f6$var$tokenizeTable,
            resolveAll: $d487398e1b9f74f6$var$resolveTable
        }
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d487398e1b9f74f6$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ // eslint-disable-next-line complexity
function $d487398e1b9f74f6$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $64798abe44cbf078$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $d487398e1b9f74f6$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $d487398e1b9f74f6$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $d487398e1b9f74f6$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $d487398e1b9f74f6$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $d487398e1b9f74f6$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $d487398e1b9f74f6$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") event[1]._align = (0, $34566bba7c0fdf8d$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $d487398e1b9f74f6$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $d487398e1b9f74f6$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $d487398e1b9f74f6$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $d487398e1b9f74f6$var$getPoint(context.events, range[2]);
        const relatedEnd = $d487398e1b9f74f6$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $d487398e1b9f74f6$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $d487398e1b9f74f6$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $d487398e1b9f74f6$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */ function $d487398e1b9f74f6$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $904a6b18a2160f0c$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
const $904a6b18a2160f0c$export$c64626c032567c7f = {
    enter: {
        table (token) {
            const tableAlign = token._align;
            this.lineEndingIfNeeded();
            this.tag("<table>");
            this.setData("tableAlign", tableAlign);
        },
        tableBody () {
            this.tag("<tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $904a6b18a2160f0c$var$alignment[tableAlign[tableColumn]];
            if (align === undefined) // Capture results to ignore them.
            this.buffer();
            else {
                this.lineEndingIfNeeded();
                this.tag("<td" + align + ">");
            }
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("<thead>");
        },
        tableHeader () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $904a6b18a2160f0c$var$alignment[tableAlign[tableColumn]];
            this.lineEndingIfNeeded();
            this.tag("<th" + align + ">");
        },
        tableRow () {
            this.setData("tableColumn", 0);
            this.lineEndingIfNeeded();
            this.tag("<tr>");
        }
    },
    exit: {
        // Overwrite the default code text data handler to unescape escaped pipes when
        // they are in tables.
        codeTextData (token) {
            let value = this.sliceSerialize(token);
            if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $904a6b18a2160f0c$var$replace);
            this.raw(this.encode(value));
        },
        table () {
            this.setData("tableAlign");
            // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
            // but we do need to reset it to match a funky newline GH generates for
            // list items combined with tables.
            this.setData("slurpAllLineEndings");
            this.lineEndingIfNeeded();
            this.tag("</table>");
        },
        tableBody () {
            this.lineEndingIfNeeded();
            this.tag("</tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            if (tableColumn in tableAlign) {
                this.tag("</td>");
                this.setData("tableColumn", tableColumn + 1);
            } else // Stop capturing.
            this.resume();
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("</thead>");
        },
        tableHeader () {
            const tableColumn = this.getData("tableColumn");
            this.tag("</th>");
            this.setData("tableColumn", tableColumn + 1);
        },
        tableRow () {
            const tableAlign = this.getData("tableAlign");
            let tableColumn = this.getData("tableColumn");
            while(tableColumn < tableAlign.length){
                this.lineEndingIfNeeded();
                this.tag("<td" + $904a6b18a2160f0c$var$alignment[tableAlign[tableColumn]] + "></td>");
                tableColumn++;
            }
            this.setData("tableColumn", tableColumn);
            this.lineEndingIfNeeded();
            this.tag("</tr>");
        }
    }
};
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $904a6b18a2160f0c$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $7fa9e8d677b5b86f$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $7fa9e8d677b5b86f$var$reText = new RegExp("^" + $7fa9e8d677b5b86f$var$reFlow.source, "i");
const $7fa9e8d677b5b86f$export$c9bf87ea36d00682 = {
    exit: {
        htmlFlowData (token) {
            $7fa9e8d677b5b86f$var$exitHtmlData.call(this, token, $7fa9e8d677b5b86f$var$reFlow);
        },
        htmlTextData (token) {
            $7fa9e8d677b5b86f$var$exitHtmlData.call(this, token, $7fa9e8d677b5b86f$var$reText);
        }
    }
};
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 */ function $7fa9e8d677b5b86f$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $2172042b5a9881da$var$tasklistCheck = {
    tokenize: $2172042b5a9881da$var$tokenizeTasklistCheck
};
const $2172042b5a9881da$export$2912e8b2802475ff = {
    text: {
        [91]: $2172042b5a9881da$var$tasklistCheck
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2172042b5a9881da$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $2172042b5a9881da$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2172042b5a9881da$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function to make extension.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to
 * support GFM task list items when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $1dceb850c21c0c0c$export$4b6a13e2af1b08ed = {
    enter: {
        taskListCheck () {
            this.tag('<input type="checkbox" disabled="" ');
        }
    },
    exit: {
        taskListCheck () {
            this.tag("/>");
        },
        taskListCheckValueChecked () {
            this.tag('checked="" ');
        }
    }
};


function $c87631406a61c03d$export$59ffe8c4d7a4aab2(options) {
    return (0, $186565a236e81cbc$export$86a865d89ef3c690)([
        (0, $a2737e5271d93243$export$608123d9b549151),
        (0, $ce57c678acb6b816$export$c82499b6656305df)(),
        (0, $0fc7bfc94cef281f$export$8bbec8ea1400a00e)(options),
        (0, $d487398e1b9f74f6$export$e36cebda627bf2dd),
        (0, $2172042b5a9881da$export$2912e8b2802475ff)
    ]);
}
function $c87631406a61c03d$export$6983b82e6105d62a(options) {
    return (0, $186565a236e81cbc$export$eaf8c406dfb0a620)([
        (0, $c3b500e15efcdb45$export$999603f1f1c3d2f9),
        (0, $d10f1ff117c1f99b$export$a731a1f6cf81900c)(options),
        (0, $185de8dcdb1aee2a$export$58acedca46108820),
        (0, $904a6b18a2160f0c$export$c64626c032567c7f),
        (0, $7fa9e8d677b5b86f$export$c9bf87ea36d00682),
        (0, $1dceb850c21c0c0c$export$4b6a13e2af1b08ed)
    ]);
}


/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $3b4df2281911471a$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */ function $5da7f379b6fd04f7$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $48292efd24e962b4$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $48292efd24e962b4$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $48292efd24e962b4$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $48292efd24e962b4$var$ok;
    if (typeof test === "string") return $48292efd24e962b4$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $48292efd24e962b4$var$anyFactory(test) : $48292efd24e962b4$var$propsFactory(test);
    if (typeof test === "function") return $48292efd24e962b4$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $48292efd24e962b4$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $48292efd24e962b4$export$9c68d69a4c5bbcf9(tests[index]);
    return $48292efd24e962b4$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $48292efd24e962b4$var$propsFactory(check) {
    return $48292efd24e962b4$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $48292efd24e962b4$var$typeFactory(check) {
    return $48292efd24e962b4$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $48292efd24e962b4$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $48292efd24e962b4$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $7e0f8d5bc7ec7b5e$export$35e9368ef982300f(d) {
    return d;
}


const $81e4472458365bd0$export$f4d8133c446fe484 = true;
const $81e4472458365bd0$export$7f100f842f565dc9 = false;
const $81e4472458365bd0$export$8773f85c2fb2c116 = "skip";
const $81e4472458365bd0$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $48292efd24e962b4$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $7e0f8d5bc7ec7b5e$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $81e4472458365bd0$var$toResult(visitor(node, parents));
                if (result[0] === $81e4472458365bd0$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $81e4472458365bd0$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $81e4472458365bd0$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $81e4472458365bd0$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $81e4472458365bd0$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}



const $80fd16af14ed8f4d$var$own = {}.hasOwnProperty;
const $80fd16af14ed8f4d$export$fb306ebf003fc574 = /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/ /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */ function(tree, find, replace, options) {
    /** @type {Options | null | undefined} */ let settings;
    /** @type {FindAndReplaceSchema|FindAndReplaceList} */ let schema;
    if (typeof find === "string" || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [
            [
                find,
                replace
            ]
        ];
        settings = options;
    } else {
        schema = find;
        // @ts-expect-error don’t expect replace twice.
        settings = replace;
    }
    if (!settings) settings = {};
    const ignored = (0, $48292efd24e962b4$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $80fd16af14ed8f4d$var$toPairs(schema);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $81e4472458365bd0$export$70008a21eb6de899)(tree, "text", visitor);
    // To do next major: don’t return the given tree.
    return tree;
    /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parent | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            if (ignored(parent, // @ts-expect-error: TS doesn’t understand but it’s perfect.
            grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                // @ts-expect-error: stack is fine.
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value !== false) {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
};
/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $80fd16af14ed8f4d$var$toPairs(schema) {
    /** @type {Pairs} */ const result = [];
    if (typeof schema !== "object") throw new TypeError("Expected array or object as schema");
    if (Array.isArray(schema)) {
        let index = -1;
        while(++index < schema.length)result.push([
            $80fd16af14ed8f4d$var$toExpression(schema[index][0]),
            $80fd16af14ed8f4d$var$toFunction(schema[index][1])
        ]);
    } else {
        /** @type {string} */ let key;
        for(key in schema)if ($80fd16af14ed8f4d$var$own.call(schema, key)) result.push([
            $80fd16af14ed8f4d$var$toExpression(key),
            $80fd16af14ed8f4d$var$toFunction(schema[key])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $80fd16af14ed8f4d$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $5da7f379b6fd04f7$export$2e2bcd8739ae039)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $80fd16af14ed8f4d$var$toFunction(replace) {
    return typeof replace === "function" ? replace : ()=>replace;
}



/** @type {ConstructName} */ const $1f7de4af6831997f$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $1f7de4af6831997f$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
const $1f7de4af6831997f$export$b6afdfff2163546f = {
    transforms: [
        $1f7de4af6831997f$var$transformGfmAutolinkLiterals
    ],
    enter: {
        literalAutolink: $1f7de4af6831997f$var$enterLiteralAutolink,
        literalAutolinkEmail: $1f7de4af6831997f$var$enterLiteralAutolinkValue,
        literalAutolinkHttp: $1f7de4af6831997f$var$enterLiteralAutolinkValue,
        literalAutolinkWww: $1f7de4af6831997f$var$enterLiteralAutolinkValue
    },
    exit: {
        literalAutolink: $1f7de4af6831997f$var$exitLiteralAutolink,
        literalAutolinkEmail: $1f7de4af6831997f$var$exitLiteralAutolinkEmail,
        literalAutolinkHttp: $1f7de4af6831997f$var$exitLiteralAutolinkHttp,
        literalAutolinkWww: $1f7de4af6831997f$var$exitLiteralAutolinkWww
    }
};
const $1f7de4af6831997f$export$d3ace9096b01c39d = {
    unsafe: [
        {
            character: "@",
            before: "[+\\-.\\w]",
            after: "[\\-.\\w]",
            inConstruct: $1f7de4af6831997f$var$inConstruct,
            notInConstruct: $1f7de4af6831997f$var$notInConstruct
        },
        {
            character: ".",
            before: "[Ww]",
            after: "[\\-.\\w]",
            inConstruct: $1f7de4af6831997f$var$inConstruct,
            notInConstruct: $1f7de4af6831997f$var$notInConstruct
        },
        {
            character: ":",
            before: "[ps]",
            after: "\\/",
            inConstruct: $1f7de4af6831997f$var$inConstruct,
            notInConstruct: $1f7de4af6831997f$var$notInConstruct
        }
    ]
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $1f7de4af6831997f$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $1f7de4af6831997f$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $1f7de4af6831997f$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $1f7de4af6831997f$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = /** @type {Link} */ this.stack[this.stack.length - 1];
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $1f7de4af6831997f$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $1f7de4af6831997f$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $1f7de4af6831997f$var$transformGfmAutolinkLiterals(tree) {
    (0, $80fd16af14ed8f4d$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $1f7de4af6831997f$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $1f7de4af6831997f$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */ // eslint-disable-next-line max-params
function $1f7de4af6831997f$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$1f7de4af6831997f$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$1f7de4af6831997f$var$isCorrectDomain(domain)) return false;
    const parts = $1f7de4af6831997f$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $1f7de4af6831997f$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$1f7de4af6831997f$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $1f7de4af6831997f$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $1f7de4af6831997f$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $3b4df2281911471a$export$fa42eaa97a352e23)(url, "(");
    let closingParens = (0, $3b4df2281911471a$export$fa42eaa97a352e23)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $1f7de4af6831997f$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $c275d3577f33f6fc$export$a0ff789c034ffdf4)(code) || (0, $c275d3577f33f6fc$export$aa04114dd888a7a0)(code)) && (!email || code !== 47);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */ 
/**
 * @typedef {import('../types.js').AssociationId} AssociationId
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $bb2b00c498d6c4ac$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


const $7b4a2926083c7906$var$own = {}.hasOwnProperty;
function $7b4a2926083c7906$export$289b6a6320f709b4(value) {
    return $7b4a2926083c7906$var$own.call((0, $bb2b00c498d6c4ac$export$ec810d1aafce79a7), value) ? (0, $bb2b00c498d6c4ac$export$ec810d1aafce79a7)[value] : false;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $c89216bfb3510b31$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}


const $87cb2746e82212d2$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $87cb2746e82212d2$export$a0fb664af7d0cc44(value) {
    return value.replace($87cb2746e82212d2$var$characterEscapeOrReference, $87cb2746e82212d2$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $87cb2746e82212d2$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $c89216bfb3510b31$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $7b4a2926083c7906$export$289b6a6320f709b4)($2) || $0;
}


function $fd9dcf25da617346$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || "";
    return (0, $87cb2746e82212d2$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @typedef {import('../types.js').FlowContent} FlowContent
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').TrackFields} TrackFields
 */ /**
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $b9e31f9be4232e5b$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: "\n",
            after: "\n",
            ...tracker.current()
        })));
        if (child.type !== "list") state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($b9e31f9be4232e5b$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join("");
}
/**
 * @param {Node} left
 * @param {Node} right
 * @param {Parent} parent
 * @param {State} state
 * @returns {string}
 */ function $b9e31f9be4232e5b$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === "number") return "\n".repeat(1 + result);
        if (result === false) return "\n\n<!---->\n\n";
    }
    return "\n\n";
}


/**
 * @typedef {import('../types.js').IndentLines} IndentLines
 */ const $4d2fa39734b2d67c$var$eol = /\r?\n|\r/g;
function $4d2fa39734b2d67c$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $4d2fa39734b2d67c$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join("");
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').SafeConfig} SafeConfig
 */ /**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */ function $5f4434e645d15f19$export$7993761911514c15(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? "[\\r\\n][\\t ]*" : "") + (pattern.before ? "(?:" + pattern.before + ")" : "");
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (pattern.after ? "(?:" + pattern.after + ")" : ""), "g");
    }
    return pattern._compiled;
}


/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 * @typedef {import('../types.js').ConstructName} ConstructName
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $9bd223816b17a9b7$export$78221a09424368d(stack, pattern) {
    return $9bd223816b17a9b7$var$listInScope(stack, pattern.inConstruct, true) && !$9bd223816b17a9b7$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $9bd223816b17a9b7$var$listInScope(stack, list, none) {
    if (typeof list === "string") list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $adcb7085a0a9759e$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || "") + (input || "") + (config.after || "");
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $9bd223816b17a9b7$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = (0, $5f4434e645d15f19$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = "before" in pattern || Boolean(pattern.atBreak);
            const after = "after" in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($adcb7085a0a9759e$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($adcb7085a0a9759e$var$escapeBackslashes(value.slice(start, position), "\\"));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push("\\");
        else {
            // Character reference.
            result.push("&#x" + value.charCodeAt(position).toString(16).toUpperCase() + ";");
            start++;
        }
    }
    result.push($adcb7085a0a9759e$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join("");
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $adcb7085a0a9759e$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $adcb7085a0a9759e$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push("\\");
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join("");
}


/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $48aa3a14c6019a91$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || "";
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


$708afa07059a0a6d$var$footnoteReference.peek = $708afa07059a0a6d$var$footnoteReferencePeek;
function $708afa07059a0a6d$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $708afa07059a0a6d$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $708afa07059a0a6d$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $708afa07059a0a6d$var$enterFootnoteCall,
            gfmFootnoteCallString: $708afa07059a0a6d$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $708afa07059a0a6d$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $708afa07059a0a6d$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $708afa07059a0a6d$var$exitFootnoteCall,
            gfmFootnoteCallString: $708afa07059a0a6d$var$exitFootnoteCallString
        }
    };
}
function $708afa07059a0a6d$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: "[",
                inConstruct: [
                    "phrasing",
                    "label",
                    "reference"
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $708afa07059a0a6d$var$footnoteDefinition,
            footnoteReference: $708afa07059a0a6d$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $708afa07059a0a6d$var$enterFootnoteDefinition(token) {
    this.enter({
        type: "footnoteDefinition",
        identifier: "",
        label: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $708afa07059a0a6d$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $708afa07059a0a6d$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $66178553af254d60$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $708afa07059a0a6d$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $708afa07059a0a6d$var$enterFootnoteCall(token) {
    this.enter({
        type: "footnoteReference",
        identifier: "",
        label: ""
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $708afa07059a0a6d$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $708afa07059a0a6d$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $66178553af254d60$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $708afa07059a0a6d$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $708afa07059a0a6d$var$footnoteReference(node, _, context, safeOptions) {
    const tracker = (0, $48aa3a14c6019a91$export$6b2a7d5132615086)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteReference");
    const subexit = context.enter("reference");
    value += tracker.move((0, $adcb7085a0a9759e$export$170b8c323eee7bec)(context, (0, $fd9dcf25da617346$export$c4ca1a6065421754)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    exit();
    value += tracker.move("]");
    return value;
}
/** @type {ToMarkdownHandle} */ function $708afa07059a0a6d$var$footnoteReferencePeek() {
    return "[";
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $708afa07059a0a6d$var$footnoteDefinition(node, _, context, safeOptions) {
    const tracker = (0, $48aa3a14c6019a91$export$6b2a7d5132615086)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteDefinition");
    const subexit = context.enter("label");
    value += tracker.move((0, $adcb7085a0a9759e$export$170b8c323eee7bec)(context, (0, $fd9dcf25da617346$export$c4ca1a6065421754)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    value += tracker.move("]:" + (node.children && node.children.length > 0 ? " " : ""));
    tracker.shift(4);
    value += tracker.move((0, $4d2fa39734b2d67c$export$7c3cf23d514b264a)((0, $b9e31f9be4232e5b$export$134f7fdacfea8b16)(node, context, tracker.current()), $708afa07059a0a6d$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $708afa07059a0a6d$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? "" : "    ") + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $25977758edbf45fe$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: "",
                after: "",
                ...tracker.current()
            }).charAt(0) : "";
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(""));
        }
        results.push(tracker.move(state.handle(child, parent, state, {
            ...tracker.current(),
            before: before,
            after: after
        })));
        before = results[results.length - 1].slice(-1);
    }
    indexStack.pop();
    return results.join("");
}



// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.
/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $b25c12060bdea2eb$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$b25c12060bdea2eb$var$handleDelete.peek = $b25c12060bdea2eb$var$peekDelete;
const $b25c12060bdea2eb$export$34d64e709dd0b9bb = {
    canContainEols: [
        "delete"
    ],
    enter: {
        strikethrough: $b25c12060bdea2eb$var$enterStrikethrough
    },
    exit: {
        strikethrough: $b25c12060bdea2eb$var$exitStrikethrough
    }
};
const $b25c12060bdea2eb$export$1632835bd2c84956 = {
    unsafe: [
        {
            character: "~",
            inConstruct: "phrasing",
            notInConstruct: $b25c12060bdea2eb$var$constructsWithoutStrikethrough
        }
    ],
    handlers: {
        delete: $b25c12060bdea2eb$var$handleDelete
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b25c12060bdea2eb$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b25c12060bdea2eb$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $b25c12060bdea2eb$var$handleDelete(node, _, context, safeOptions) {
    const tracker = (0, $48aa3a14c6019a91$export$6b2a7d5132615086)(safeOptions);
    const exit = context.enter("strikethrough");
    let value = tracker.move("~~");
    value += (0, $25977758edbf45fe$export$f4090a9439f37631)(node, context, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $b25c12060bdea2eb$var$peekDelete() {
    return "~";
}


/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */ 
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ 
$913660b04d6a816c$export$91b9bee19a0d8569.peek = $913660b04d6a816c$var$inlineCodePeek;
function $913660b04d6a816c$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = (0, $5f4434e645d15f19$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $913660b04d6a816c$var$inlineCodePeek() {
    return "`";
}


/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $58985ddc0740694e$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $58985ddc0740694e$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $58985ddc0740694e$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $58985ddc0740694e$var$toAlignment(align[columnIndex]);
    else {
        const code = $58985ddc0740694e$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push("|");
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) line.push(" ");
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(" ");
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $58985ddc0740694e$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $58985ddc0740694e$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $58985ddc0740694e$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


const $edcbfefec694fafb$export$8bd0ec8ecf6adb7d = {
    enter: {
        table: $edcbfefec694fafb$var$enterTable,
        tableData: $edcbfefec694fafb$var$enterCell,
        tableHeader: $edcbfefec694fafb$var$enterCell,
        tableRow: $edcbfefec694fafb$var$enterRow
    },
    exit: {
        codeText: $edcbfefec694fafb$var$exitCodeText,
        table: $edcbfefec694fafb$var$exitTable,
        tableData: $edcbfefec694fafb$var$exit,
        tableHeader: $edcbfefec694fafb$var$exit,
        tableRow: $edcbfefec694fafb$var$exit
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $edcbfefec694fafb$var$enterTable(token) {
    /** @type {Array<'left' | 'right' | 'center' | 'none'>} */ // @ts-expect-error: `align` is custom.
    const align = token._align;
    this.enter({
        type: "table",
        align: align.map((d)=>d === "none" ? null : d),
        children: []
    }, token);
    this.setData("inTable", true);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $edcbfefec694fafb$var$exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $edcbfefec694fafb$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $edcbfefec694fafb$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $edcbfefec694fafb$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $edcbfefec694fafb$var$exitCodeText(token) {
    let value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, $edcbfefec694fafb$var$replace);
    const node = /** @type {InlineCode} */ this.stack[this.stack.length - 1];
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $edcbfefec694fafb$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $edcbfefec694fafb$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, context, safeOptions) {
        return serializeData(handleTableAsData(node, context, safeOptions), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, context, safeOptions) {
        const row = handleTableRowAsData(node, context, safeOptions);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, context, safeOptions) {
        const exit = context.enter("tableCell");
        const subexit = context.enter("phrasing");
        const value = (0, $25977758edbf45fe$export$f4090a9439f37631)(node, context, {
            ...safeOptions,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $58985ddc0740694e$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = context.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableRowAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = context.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, context) {
        let value = (0, $913660b04d6a816c$export$91b9bee19a0d8569)(node, parent, context);
        if (context.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}


/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */ /**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ /**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $6e6ed14ff38feb68$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $58792a2735d32b8a$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "tab";
    // To do: remove in a major.
    // @ts-expect-error: deprecated.
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}


function $7f19abff2149d89e$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $58792a2735d32b8a$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $6e6ed14ff38feb68$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}



const $6fbf53a4d65ef0db$export$a427a608608b215f = {
    exit: {
        taskListCheckValueChecked: $6fbf53a4d65ef0db$var$exitCheck,
        taskListCheckValueUnchecked: $6fbf53a4d65ef0db$var$exitCheck,
        paragraph: $6fbf53a4d65ef0db$var$exitParagraphWithTaskListItem
    }
};
const $6fbf53a4d65ef0db$export$9975722e7e834b78 = {
    unsafe: [
        {
            atBreak: true,
            character: "-",
            after: "[:|-]"
        }
    ],
    handlers: {
        listItem: $6fbf53a4d65ef0db$var$listItemWithTaskListItem
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $6fbf53a4d65ef0db$var$exitCheck(token) {
    const node = /** @type {ListItem} */ this.stack[this.stack.length - 2];
    // We’re always in a paragraph, in a list item.
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $6fbf53a4d65ef0db$var$exitParagraphWithTaskListItem(token) {
    const parent = /** @type {Parents} */ this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = /** @type {Paragraph} */ this.stack[this.stack.length - 1];
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $6fbf53a4d65ef0db$var$listItemWithTaskListItem(node, parent, context, safeOptions) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = (0, $48aa3a14c6019a91$export$6b2a7d5132615086)(safeOptions);
    if (checkable) tracker.move(checkbox);
    let value = (0, $7f19abff2149d89e$export$76c7e83ecc9cdf05)(node, parent, context, {
        ...safeOptions,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $e01cba2abe892bc2$export$95adae814eb7433e() {
    return [
        (0, $1f7de4af6831997f$export$b6afdfff2163546f),
        (0, $708afa07059a0a6d$export$c9d5ad4bdf6ff801)(),
        (0, $b25c12060bdea2eb$export$34d64e709dd0b9bb),
        (0, $edcbfefec694fafb$export$8bd0ec8ecf6adb7d),
        (0, $6fbf53a4d65ef0db$export$a427a608608b215f)
    ];
}
function $e01cba2abe892bc2$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $1f7de4af6831997f$export$d3ace9096b01c39d),
            (0, $708afa07059a0a6d$export$3727766a73a6c09f)(),
            (0, $b25c12060bdea2eb$export$1632835bd2c84956),
            (0, $edcbfefec694fafb$export$dafcad76ea6e0045)(options),
            (0, $6fbf53a4d65ef0db$export$9975722e7e834b78)
        ]
    };
}


function $f826a548de96aedc$export$2e2bcd8739ae039(options = {}) {
    const data = this.data();
    add("micromarkExtensions", (0, $c87631406a61c03d$export$59ffe8c4d7a4aab2)(options));
    add("fromMarkdownExtensions", (0, $e01cba2abe892bc2$export$95adae814eb7433e)());
    add("toMarkdownExtensions", (0, $e01cba2abe892bc2$export$ea77de6901e7c72b)(options));
    /**
   * @param {string} field
   * @param {unknown} value
   */ function add(field, value) {
        const list = /** @type {unknown[]} */ // Other extensions
        /* c8 ignore next 2 */ data[field] ? data[field] : data[field] = [];
        list.push(value);
    }
}


/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $a0fb930c162b32ee$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $a0fb930c162b32ee$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $a2556f70e5f1c215$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $a2556f70e5f1c215$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $a2556f70e5f1c215$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $a2556f70e5f1c215$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $a2556f70e5f1c215$var$point(point) {
    return $a2556f70e5f1c215$var$index(point && point.line) + ":" + $a2556f70e5f1c215$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $a2556f70e5f1c215$var$position(pos) {
    return $a2556f70e5f1c215$var$point(pos && pos.start) + "-" + $a2556f70e5f1c215$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $a2556f70e5f1c215$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $f22b538721ec2da2$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $a2556f70e5f1c215$export$c304dd45fe166145)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.file = "";
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.name = "";
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.reason = "";
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.message = "";
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.stack = "";
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.fatal = null;
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.column = null;
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.line = null;
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.source = null;
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.ruleId = null;
$f22b538721ec2da2$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $15a1b57b37ffb599$export$bb654e07daaf8c3a = {
    basename: $15a1b57b37ffb599$var$basename,
    dirname: $15a1b57b37ffb599$var$dirname,
    extname: $15a1b57b37ffb599$var$extname,
    join: $15a1b57b37ffb599$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $15a1b57b37ffb599$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $15a1b57b37ffb599$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $15a1b57b37ffb599$var$dirname(path) {
    $15a1b57b37ffb599$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $15a1b57b37ffb599$var$extname(path) {
    $15a1b57b37ffb599$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $15a1b57b37ffb599$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $15a1b57b37ffb599$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $15a1b57b37ffb599$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $15a1b57b37ffb599$var$normalize(path) {
    $15a1b57b37ffb599$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $15a1b57b37ffb599$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $15a1b57b37ffb599$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $15a1b57b37ffb599$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $612f4a8024e92378$export$97a5aaf482767187 = {
    cwd: $612f4a8024e92378$var$cwd
};
function $612f4a8024e92378$var$cwd() {
    return "/";
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $d7a944431339c932$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $2603eb386647b162$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $d7a944431339c932$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $2603eb386647b162$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $2603eb386647b162$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $4cd8dfbbfabb6d9c$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $4cd8dfbbfabb6d9c$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $4cd8dfbbfabb6d9c$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $d7a944431339c932$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $612f4a8024e92378$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $4cd8dfbbfabb6d9c$var$order.length){
            const prop = $4cd8dfbbfabb6d9c$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$4cd8dfbbfabb6d9c$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $d7a944431339c932$export$8304a22d431f958)(path)) path = (0, $2603eb386647b162$export$9b2b676c902de799)(path);
        $4cd8dfbbfabb6d9c$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $4cd8dfbbfabb6d9c$var$assertPath(this.basename, "dirname");
        this.path = (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $4cd8dfbbfabb6d9c$var$assertNonEmpty(basename, "basename");
        $4cd8dfbbfabb6d9c$var$assertPart(basename, "basename");
        this.path = (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $4cd8dfbbfabb6d9c$var$assertPart(extname, "extname");
        $4cd8dfbbfabb6d9c$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $4cd8dfbbfabb6d9c$var$assertNonEmpty(stem, "stem");
        $4cd8dfbbfabb6d9c$var$assertPart(stem, "stem");
        this.path = (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $f22b538721ec2da2$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $4cd8dfbbfabb6d9c$var$assertPart(part, name) {
    if (part && part.includes((0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $15a1b57b37ffb599$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $4cd8dfbbfabb6d9c$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $4cd8dfbbfabb6d9c$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $4cd8dfbbfabb6d9c$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a0fb930c162b32ee$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $caf229a5e99d04ae$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $7d1ff2ef7eae34c6$exports = {};
"use strict";
var $7d1ff2ef7eae34c6$var$hasOwn = Object.prototype.hasOwnProperty;
var $7d1ff2ef7eae34c6$var$toStr = Object.prototype.toString;
var $7d1ff2ef7eae34c6$var$defineProperty = Object.defineProperty;
var $7d1ff2ef7eae34c6$var$gOPD = Object.getOwnPropertyDescriptor;
var $7d1ff2ef7eae34c6$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $7d1ff2ef7eae34c6$var$toStr.call(arr) === "[object Array]";
};
var $7d1ff2ef7eae34c6$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $7d1ff2ef7eae34c6$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $7d1ff2ef7eae34c6$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $7d1ff2ef7eae34c6$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $7d1ff2ef7eae34c6$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $7d1ff2ef7eae34c6$var$setProperty = function setProperty(target, options) {
    if ($7d1ff2ef7eae34c6$var$defineProperty && options.name === "__proto__") $7d1ff2ef7eae34c6$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $7d1ff2ef7eae34c6$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$7d1ff2ef7eae34c6$var$hasOwn.call(obj, name)) return void 0;
        else if ($7d1ff2ef7eae34c6$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $7d1ff2ef7eae34c6$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$7d1ff2ef7eae34c6$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $7d1ff2ef7eae34c6$var$getProperty(target, name);
            copy = $7d1ff2ef7eae34c6$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($7d1ff2ef7eae34c6$var$isPlainObject(copy) || (copyIsArray = $7d1ff2ef7eae34c6$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $7d1ff2ef7eae34c6$var$isArray(src) ? src : [];
                    } else clone = src && $7d1ff2ef7eae34c6$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $7d1ff2ef7eae34c6$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $7d1ff2ef7eae34c6$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $80aa4ed758dc5539$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */ function $52d8a49820b5e3a7$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $52d8a49820b5e3a7$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $52d8a49820b5e3a7$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result instanceof Promise) result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $a5b453dffc62716c$export$7cc1b2fe10c52bb = $a5b453dffc62716c$var$base().freeze();
const $a5b453dffc62716c$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $a5b453dffc62716c$var$base() {
    const transformers = (0, $52d8a49820b5e3a7$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $a5b453dffc62716c$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($7d1ff2ef7eae34c6$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $a5b453dffc62716c$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $a5b453dffc62716c$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $a5b453dffc62716c$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $a5b453dffc62716c$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $80aa4ed758dc5539$export$2e2bcd8739ae039)(entry[1]) && (0, $80aa4ed758dc5539$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($7d1ff2ef7eae34c6$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $a5b453dffc62716c$var$vfile(doc);
        const Parser = processor.Parser;
        $a5b453dffc62716c$var$assertParser("parse", Parser);
        if ($a5b453dffc62716c$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $a5b453dffc62716c$var$vfile(doc);
        const Compiler = processor.Compiler;
        $a5b453dffc62716c$var$assertCompiler("stringify", Compiler);
        $a5b453dffc62716c$var$assertNode(node);
        if ($a5b453dffc62716c$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $a5b453dffc62716c$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $a5b453dffc62716c$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $a5b453dffc62716c$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $caf229a5e99d04ae$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $a5b453dffc62716c$var$assertParser("process", processor.Parser);
        $a5b453dffc62716c$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $a5b453dffc62716c$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($a5b453dffc62716c$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $a5b453dffc62716c$var$assertParser("processSync", processor.Parser);
        $a5b453dffc62716c$var$assertCompiler("processSync", processor.Compiler);
        const file = $a5b453dffc62716c$var$vfile(doc);
        processor.process(file, done);
        $a5b453dffc62716c$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $caf229a5e99d04ae$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $a5b453dffc62716c$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($a5b453dffc62716c$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $a5b453dffc62716c$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($a5b453dffc62716c$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $a5b453dffc62716c$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $a5b453dffc62716c$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $a5b453dffc62716c$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $a5b453dffc62716c$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $80aa4ed758dc5539$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $a5b453dffc62716c$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $a5b453dffc62716c$var$vfile(value) {
    return $a5b453dffc62716c$var$looksLikeAVFile(value) ? value : new (0, $4cd8dfbbfabb6d9c$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $a5b453dffc62716c$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $a5b453dffc62716c$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($a0fb930c162b32ee$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $373de7e3bc4690a3$var$emptyOptions = {};
function $373de7e3bc4690a3$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $373de7e3bc4690a3$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $373de7e3bc4690a3$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $373de7e3bc4690a3$var$one(value, includeImageAlt, includeHtml) {
    if ($373de7e3bc4690a3$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $373de7e3bc4690a3$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $373de7e3bc4690a3$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $373de7e3bc4690a3$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $373de7e3bc4690a3$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $373de7e3bc4690a3$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ 

const $8ec00b32d3218ccf$export$a7db06668cad9adb = {
    tokenize: $8ec00b32d3218ccf$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $8ec00b32d3218ccf$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $e01d645e244b740a$export$5a7bfc01df82fcd1 = {
    tokenize: $e01d645e244b740a$var$initializeDocument
};
/** @type {Construct} */ const $e01d645e244b740a$var$containerConstruct = {
    tokenize: $e01d645e244b740a$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $e01d645e244b740a$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $75b5f8c3284da1b7$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($e01d645e244b740a$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($e01d645e244b740a$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $75b5f8c3284da1b7$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e01d645e244b740a$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $578774a39e153815$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $578774a39e153815$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $75b5f8c3284da1b7$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $578774a39e153815$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $75b5f8c3284da1b7$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $a00b60ee37575802$export$a7db06668cad9adb = {
    tokenize: $a00b60ee37575802$var$tokenizeContent,
    resolve: $a00b60ee37575802$var$resolveContent
};
/** @type {Construct} */ const $a00b60ee37575802$var$continuationConstruct = {
    tokenize: $a00b60ee37575802$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $a00b60ee37575802$var$resolveContent(events) {
    (0, $578774a39e153815$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a00b60ee37575802$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return effects.check($a00b60ee37575802$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a00b60ee37575802$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $0570907c6f006fdd$export$ccc7b0636abaffc3 = {
    tokenize: $0570907c6f006fdd$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $0570907c6f006fdd$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $44c65789cb843c57$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $a00b60ee37575802$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $9c62ffb0e0cb5561$export$50397835cbfdbc24 = {
    resolveAll: $9c62ffb0e0cb5561$var$createResolver()
};
const $9c62ffb0e0cb5561$export$22b082955e083ec3 = $9c62ffb0e0cb5561$var$initializeFactory("string");
const $9c62ffb0e0cb5561$export$6f093cfa640b7166 = $9c62ffb0e0cb5561$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $9c62ffb0e0cb5561$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $9c62ffb0e0cb5561$var$createResolver(field === "text" ? $9c62ffb0e0cb5561$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $9c62ffb0e0cb5561$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $9c62ffb0e0cb5561$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 


function $f3e6dcebfa17fcf8$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $67be2b7105a26e97$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $f3e6dcebfa17fcf8$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $f3e6dcebfa17fcf8$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $75b5f8c3284da1b7$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $f3e6dcebfa17fcf8$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $f3e6dcebfa17fcf8$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $02e9d2cb49aff48d$exports = {};

$parcel$export($02e9d2cb49aff48d$exports, "document", function () { return $02e9d2cb49aff48d$export$5a7bfc01df82fcd1; });
$parcel$export($02e9d2cb49aff48d$exports, "contentInitial", function () { return $02e9d2cb49aff48d$export$5a2181fb44b58173; });
$parcel$export($02e9d2cb49aff48d$exports, "flowInitial", function () { return $02e9d2cb49aff48d$export$cf8bead395eff824; });
$parcel$export($02e9d2cb49aff48d$exports, "flow", function () { return $02e9d2cb49aff48d$export$ccc7b0636abaffc3; });
$parcel$export($02e9d2cb49aff48d$exports, "string", function () { return $02e9d2cb49aff48d$export$22b082955e083ec3; });
$parcel$export($02e9d2cb49aff48d$exports, "text", function () { return $02e9d2cb49aff48d$export$6f093cfa640b7166; });
$parcel$export($02e9d2cb49aff48d$exports, "insideSpan", function () { return $02e9d2cb49aff48d$export$d44f260a3f9b69f5; });
$parcel$export($02e9d2cb49aff48d$exports, "attentionMarkers", function () { return $02e9d2cb49aff48d$export$b9c0b60d74426aea; });
$parcel$export($02e9d2cb49aff48d$exports, "disable", function () { return $02e9d2cb49aff48d$export$e20fbacbb41798b; });
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $d5a2a1fdd8f73507$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $d5a2a1fdd8f73507$var$tokenizeAttention,
    resolveAll: $d5a2a1fdd8f73507$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $d5a2a1fdd8f73507$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $d5a2a1fdd8f73507$var$movePoint(start, -use);
            $d5a2a1fdd8f73507$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(nextEvents, (0, $67be2b7105a26e97$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $75b5f8c3284da1b7$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d5a2a1fdd8f73507$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $e084bd2160831bdd$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $e084bd2160831bdd$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $d5a2a1fdd8f73507$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $d5888fe564db4ae1$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $d5888fe564db4ae1$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d5888fe564db4ae1$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $c275d3577f33f6fc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $c275d3577f33f6fc$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $45a0bdae007d746a$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $45a0bdae007d746a$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $45a0bdae007d746a$var$tokenizeBlockQuoteContinuation
    },
    exit: $45a0bdae007d746a$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $45a0bdae007d746a$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $45a0bdae007d746a$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($45a0bdae007d746a$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $45a0bdae007d746a$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $1621c6470995c0f9$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $1621c6470995c0f9$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1621c6470995c0f9$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $c275d3577f33f6fc$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $6beb966b8df5fab3$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $6beb966b8df5fab3$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6beb966b8df5fab3$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $c275d3577f33f6fc$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $c275d3577f33f6fc$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $c275d3577f33f6fc$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $c275d3577f33f6fc$export$75c76db11865a9f4) && !(0, $7b4a2926083c7906$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $2bf81a70515746be$var$nonLazyContinuation = {
    tokenize: $2bf81a70515746be$var$tokenizeNonLazyContinuation,
    partial: true
};
const $2bf81a70515746be$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $2bf81a70515746be$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2bf81a70515746be$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($2bf81a70515746be$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return effects.check($2bf81a70515746be$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2bf81a70515746be$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $2c81ff0ab5bc8a4a$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $2c81ff0ab5bc8a4a$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $2c81ff0ab5bc8a4a$var$furtherStart = {
    tokenize: $2c81ff0ab5bc8a4a$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c81ff0ab5bc8a4a$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return effects.attempt($2c81ff0ab5bc8a4a$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c81ff0ab5bc8a4a$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $1e2e8dffc5627260$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $1e2e8dffc5627260$var$tokenizeCodeText,
    resolve: $1e2e8dffc5627260$var$resolveCodeText,
    previous: $1e2e8dffc5627260$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $1e2e8dffc5627260$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $1e2e8dffc5627260$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1e2e8dffc5627260$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $e8ad752075ea58d8$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $c275d3577f33f6fc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $c275d3577f33f6fc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $f26daf768b8b983f$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $6d53e1a06d086569$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $30e556d0fbae69cb$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $f7427d8b6ceaa24c$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $f7427d8b6ceaa24c$var$tokenizeDefinition
};
/** @type {Construct} */ const $f7427d8b6ceaa24c$var$titleBefore = {
    tokenize: $f7427d8b6ceaa24c$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f7427d8b6ceaa24c$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $f26daf768b8b983f$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $66178553af254d60$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) ? (0, $30e556d0fbae69cb$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $e8ad752075ea58d8$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($f7427d8b6ceaa24c$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f7427d8b6ceaa24c$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) ? (0, $30e556d0fbae69cb$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $6d53e1a06d086569$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $9b03e7f2b0f95f39$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $9b03e7f2b0f95f39$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9b03e7f2b0f95f39$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $e5ab45ff407cbf6f$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $e5ab45ff407cbf6f$var$tokenizeHeadingAtx,
    resolve: $e5ab45ff407cbf6f$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $e5ab45ff407cbf6f$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $75b5f8c3284da1b7$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e5ab45ff407cbf6f$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $c0c3415e021ba00d$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $c0c3415e021ba00d$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $b901ba2d28a0ddf0$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $b901ba2d28a0ddf0$var$tokenizeHtmlFlow,
    resolveTo: $b901ba2d28a0ddf0$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $b901ba2d28a0ddf0$var$blankLineBefore = {
    tokenize: $b901ba2d28a0ddf0$var$tokenizeBlankLineBefore,
    partial: true
};
const $b901ba2d28a0ddf0$var$nonLazyContinuationStart = {
    tokenize: $b901ba2d28a0ddf0$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $b901ba2d28a0ddf0$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b901ba2d28a0ddf0$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $c0c3415e021ba00d$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $c0c3415e021ba00d$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($b901ba2d28a0ddf0$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($b901ba2d28a0ddf0$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $c0c3415e021ba00d$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b901ba2d28a0ddf0$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b901ba2d28a0ddf0$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $44c65789cb843c57$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $0accded2412eea26$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $0accded2412eea26$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0accded2412eea26$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $c275d3577f33f6fc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $c275d3577f33f6fc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $cfd83a510f70e4c8$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $cfd83a510f70e4c8$var$tokenizeLabelEnd,
    resolveTo: $cfd83a510f70e4c8$var$resolveToLabelEnd,
    resolveAll: $cfd83a510f70e4c8$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $cfd83a510f70e4c8$var$resourceConstruct = {
    tokenize: $cfd83a510f70e4c8$var$tokenizeResource
};
/** @type {Construct} */ const $cfd83a510f70e4c8$var$referenceFullConstruct = {
    tokenize: $cfd83a510f70e4c8$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $cfd83a510f70e4c8$var$referenceCollapsedConstruct = {
    tokenize: $cfd83a510f70e4c8$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $cfd83a510f70e4c8$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $cfd83a510f70e4c8$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(media, (0, $67be2b7105a26e97$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $75b5f8c3284da1b7$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $75b5f8c3284da1b7$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $cfd83a510f70e4c8$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $66178553af254d60$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($cfd83a510f70e4c8$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($cfd83a510f70e4c8$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($cfd83a510f70e4c8$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $cfd83a510f70e4c8$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) ? (0, $30e556d0fbae69cb$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $e8ad752075ea58d8$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) ? (0, $30e556d0fbae69cb$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $6d53e1a06d086569$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $c275d3577f33f6fc$export$a30284361b3814b7)(code) ? (0, $30e556d0fbae69cb$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $cfd83a510f70e4c8$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $f26daf768b8b983f$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $66178553af254d60$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $cfd83a510f70e4c8$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $1ad8326a026ed1e7$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $1ad8326a026ed1e7$var$tokenizeLabelStartImage,
    resolveAll: (0, $cfd83a510f70e4c8$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1ad8326a026ed1e7$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $3959129b396fffe9$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $3959129b396fffe9$var$tokenizeLabelStartLink,
    resolveAll: (0, $cfd83a510f70e4c8$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3959129b396fffe9$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $970a7a0a95274c83$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $970a7a0a95274c83$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $970a7a0a95274c83$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $fb7cd2f8fd050263$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $fb7cd2f8fd050263$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fb7cd2f8fd050263$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $c58ea1699c96b2d2$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $c58ea1699c96b2d2$var$tokenizeListStart,
    continuation: {
        tokenize: $c58ea1699c96b2d2$var$tokenizeListContinuation
    },
    exit: $c58ea1699c96b2d2$var$tokenizeListEnd
};
/** @type {Construct} */ const $c58ea1699c96b2d2$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $c58ea1699c96b2d2$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $c58ea1699c96b2d2$var$indentConstruct = {
    tokenize: $c58ea1699c96b2d2$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $c58ea1699c96b2d2$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $c275d3577f33f6fc$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $fb7cd2f8fd050263$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $c275d3577f33f6fc$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $44c65789cb843c57$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($c58ea1699c96b2d2$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $c58ea1699c96b2d2$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $44c65789cb843c57$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($c58ea1699c96b2d2$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, effects.attempt($c58ea1699c96b2d2$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $c58ea1699c96b2d2$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $c58ea1699c96b2d2$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $c58ea1699c96b2d2$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $44ef6f40b459086c$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $44ef6f40b459086c$var$tokenizeSetextUnderline,
    resolveTo: $44ef6f40b459086c$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $44ef6f40b459086c$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $44ef6f40b459086c$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $c275d3577f33f6fc$export$2c6cf65c1127992a)(code) ? (0, $4e1cd30d93e3f1f7$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $c275d3577f33f6fc$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $02e9d2cb49aff48d$export$5a7bfc01df82fcd1 = {
    [42]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [43]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [45]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [48]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [49]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [50]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [51]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [52]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [53]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [54]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [55]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [56]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [57]: (0, $c58ea1699c96b2d2$export$8837f4fc672e936d),
    [62]: (0, $45a0bdae007d746a$export$200dcd0a5903c968)
};
const $02e9d2cb49aff48d$export$5a2181fb44b58173 = {
    [91]: (0, $f7427d8b6ceaa24c$export$69f215ed977cdb73)
};
const $02e9d2cb49aff48d$export$cf8bead395eff824 = {
    [-2]: (0, $2c81ff0ab5bc8a4a$export$47910b7ab28d1853),
    [-1]: (0, $2c81ff0ab5bc8a4a$export$47910b7ab28d1853),
    [32]: (0, $2c81ff0ab5bc8a4a$export$47910b7ab28d1853)
};
const $02e9d2cb49aff48d$export$ccc7b0636abaffc3 = {
    [35]: (0, $e5ab45ff407cbf6f$export$3871e9deb360695c),
    [42]: (0, $fb7cd2f8fd050263$export$ba7b13e047416c03),
    [45]: [
        (0, $44ef6f40b459086c$export$e104e2de391dfde9),
        (0, $fb7cd2f8fd050263$export$ba7b13e047416c03)
    ],
    [60]: (0, $b901ba2d28a0ddf0$export$476ac411cb7d0d8f),
    [61]: (0, $44ef6f40b459086c$export$e104e2de391dfde9),
    [95]: (0, $fb7cd2f8fd050263$export$ba7b13e047416c03),
    [96]: (0, $2bf81a70515746be$export$c23e4921f8d87e7c),
    [126]: (0, $2bf81a70515746be$export$c23e4921f8d87e7c)
};
const $02e9d2cb49aff48d$export$22b082955e083ec3 = {
    [38]: (0, $6beb966b8df5fab3$export$e31905600aaf3d8e),
    [92]: (0, $1621c6470995c0f9$export$2005478564e78d96)
};
const $02e9d2cb49aff48d$export$6f093cfa640b7166 = {
    [-5]: (0, $970a7a0a95274c83$export$8e62e0ad51c97b2),
    [-4]: (0, $970a7a0a95274c83$export$8e62e0ad51c97b2),
    [-3]: (0, $970a7a0a95274c83$export$8e62e0ad51c97b2),
    [33]: (0, $1ad8326a026ed1e7$export$3d754936e25aa5f5),
    [38]: (0, $6beb966b8df5fab3$export$e31905600aaf3d8e),
    [42]: (0, $d5a2a1fdd8f73507$export$45b92471da762af7),
    [60]: [
        (0, $d5888fe564db4ae1$export$17ddf85e4c916ad6),
        (0, $0accded2412eea26$export$398af27f284914fe)
    ],
    [91]: (0, $3959129b396fffe9$export$5c0cee0701a3b584),
    [92]: [
        (0, $9b03e7f2b0f95f39$export$86c573ab9e06f418),
        (0, $1621c6470995c0f9$export$2005478564e78d96)
    ],
    [93]: (0, $cfd83a510f70e4c8$export$470a5dafbbf62654),
    [95]: (0, $d5a2a1fdd8f73507$export$45b92471da762af7),
    [96]: (0, $1e2e8dffc5627260$export$d24f93e715f9df88)
};
const $02e9d2cb49aff48d$export$d44f260a3f9b69f5 = {
    null: [
        (0, $d5a2a1fdd8f73507$export$45b92471da762af7),
        (0, $9c62ffb0e0cb5561$export$50397835cbfdbc24)
    ]
};
const $02e9d2cb49aff48d$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $02e9d2cb49aff48d$export$e20fbacbb41798b = {
    null: []
};


function $4ef47e4ac00fc294$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $186565a236e81cbc$export$86a865d89ef3c690)([
        $02e9d2cb49aff48d$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $8ec00b32d3218ccf$export$a7db06668cad9adb)),
        document: create((0, $e01d645e244b740a$export$5a7bfc01df82fcd1)),
        flow: create((0, $0570907c6f006fdd$export$ccc7b0636abaffc3)),
        string: create((0, $9c62ffb0e0cb5561$export$22b082955e083ec3)),
        text: create((0, $9c62ffb0e0cb5561$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $f3e6dcebfa17fcf8$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $c7ed8f11ea55043d$var$search = /[\0\t\n\r]/g;
function $c7ed8f11ea55043d$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $c7ed8f11ea55043d$var$search.lastIndex = startPosition;
            match = $c7ed8f11ea55043d$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $a731a8728654ea1c$export$bd0e6e1378a871d7(events) {
    while(!(0, $578774a39e153815$export$12949d1dd00fddf4)(events));
    return events;
}







const $de0d50573e3790d7$var$own = {}.hasOwnProperty;
const $de0d50573e3790d7$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $de0d50573e3790d7$var$compiler(options)((0, $a731a8728654ea1c$export$bd0e6e1378a871d7)((0, $4ef47e4ac00fc294$export$98e6a39c04603d36)(options).document().write((0, $c7ed8f11ea55043d$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $de0d50573e3790d7$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $de0d50573e3790d7$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($de0d50573e3790d7$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $de0d50573e3790d7$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $de0d50573e3790d7$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $de0d50573e3790d7$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $de0d50573e3790d7$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $a2556f70e5f1c215$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $de0d50573e3790d7$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $de0d50573e3790d7$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $373de7e3bc4690a3$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $66178553af254d60$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $de0d50573e3790d7$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $de0d50573e3790d7$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $de0d50573e3790d7$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $87cb2746e82212d2$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $66178553af254d60$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $66178553af254d60$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $c89216bfb3510b31$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $7b4a2926083c7906$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $de0d50573e3790d7$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $de0d50573e3790d7$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $de0d50573e3790d7$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $de0d50573e3790d7$var$configure(combined, value);
        else $de0d50573e3790d7$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $de0d50573e3790d7$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($de0d50573e3790d7$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $de0d50573e3790d7$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $a2556f70e5f1c215$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $a2556f70e5f1c215$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $a2556f70e5f1c215$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $cc55dc5144f1938e$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $de0d50573e3790d7$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
function $26133b30ce9c806b$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $ed1b1d373b59fd1b$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ 
const $93d8bd8148453afd$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $81e4472458365bd0$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $31d9094bf1c6aaa4$export$771bf3e4949bfbee = $31d9094bf1c6aaa4$var$point("start");
const $31d9094bf1c6aaa4$export$da309cdce9dc2a25 = $31d9094bf1c6aaa4$var$point("end");
function $31d9094bf1c6aaa4$export$5880b8b5730aff45(node) {
    return {
        start: $31d9094bf1c6aaa4$export$771bf3e4949bfbee(node),
        end: $31d9094bf1c6aaa4$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $31d9094bf1c6aaa4$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $65fab1695d90f3c7$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $91b6d905cb0255be$var$own = {}.hasOwnProperty;
function $91b6d905cb0255be$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $93d8bd8148453afd$export$bf638b60ea8b89b7)(tree, "definition", (definition)=>{
        const id = $91b6d905cb0255be$var$clean(definition.identifier);
        if (id && !$91b6d905cb0255be$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $91b6d905cb0255be$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $91b6d905cb0255be$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $91b6d905cb0255be$var$clean(value) {
    return String(value || "").toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $b2112a0e3509995e$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $ce38be6effb9e10a$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7334534ae7a8dcce$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $e6db5e53de63e794$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8c6fdcf0d3e774f9$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $dcad3d92a73fd9f3$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $ed1b1d373b59fd1b$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $7f6aed4d5e580445$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $dcad3d92a73fd9f3$export$7f87ee744075c1ba)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $91b1e0044e18dc72$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $1e15b6a5caf896e6$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $84fd020005f3a56e$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $e3042f7c706375d3$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $84fd020005f3a56e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $ed1b1d373b59fd1b$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $044891f866fc1368$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $ed1b1d373b59fd1b$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c62827462825ec9c$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $b908ee0c8de632d7$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $84fd020005f3a56e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $ed1b1d373b59fd1b$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $b76a2e6fc19feea8$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $ed1b1d373b59fd1b$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $371cf8a95244b7ab$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $371cf8a95244b7ab$var$listLoose(parent) : $371cf8a95244b7ab$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $371cf8a95244b7ab$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $371cf8a95244b7ab$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $371cf8a95244b7ab$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $85f719493879cc0e$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $5b55b937704b532d$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $642e80d6c5f31991$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $baecbbb910f79007$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $5b56b26bcfb2f7d7$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $31d9094bf1c6aaa4$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $31d9094bf1c6aaa4$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $eef4fbf3868afd54$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $54faf07c0cde11ed$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $2634c7c2521afd5a$var$tab = 9 /* `\t` */ ;
const $2634c7c2521afd5a$var$space = 32 /* ` ` */ ;
function $2634c7c2521afd5a$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($2634c7c2521afd5a$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($2634c7c2521afd5a$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $2634c7c2521afd5a$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $2634c7c2521afd5a$var$tab || code === $2634c7c2521afd5a$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $2634c7c2521afd5a$var$tab || code === $2634c7c2521afd5a$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $30b346b9198ff5ad$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $2634c7c2521afd5a$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $888054abd66b465d$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $077e069a28543766$export$455ce229eb3d2472 = {
    blockquote: $b2112a0e3509995e$export$67dc04e652a298ca,
    break: (0, $ce38be6effb9e10a$export$371da9dd35aba193),
    code: $7334534ae7a8dcce$export$6565f9f03506010b,
    delete: (0, $e6db5e53de63e794$export$19426ff118fe8be),
    emphasis: $8c6fdcf0d3e774f9$export$bef81ba411953b51,
    footnoteReference: $dcad3d92a73fd9f3$export$7f87ee744075c1ba,
    footnote: $7f6aed4d5e580445$export$3b6a720baa2c20ec,
    heading: $91b1e0044e18dc72$export$46e4a324ac90507f,
    html: $1e15b6a5caf896e6$export$c0bb0b647f701bb5,
    imageReference: $e3042f7c706375d3$export$f281796f6bc3b8db,
    image: $044891f866fc1368$export$5c452ff88e35e47d,
    inlineCode: $c62827462825ec9c$export$91b9bee19a0d8569,
    linkReference: $b908ee0c8de632d7$export$e6c469b1b7b2bc6a,
    link: $b76a2e6fc19feea8$export$9c30223ca0a664fb,
    listItem: $371cf8a95244b7ab$export$76c7e83ecc9cdf05,
    list: $85f719493879cc0e$export$8837f4fc672e936d,
    paragraph: $5b55b937704b532d$export$9c206ddddb32a9b,
    root: $642e80d6c5f31991$export$e8e78c978b129247,
    strong: $baecbbb910f79007$export$59ae2c325a998f89,
    table: $5b56b26bcfb2f7d7$export$9852986a3ec5f6a0,
    tableCell: $54faf07c0cde11ed$export$e1e720e5f4603e6a,
    tableRow: $eef4fbf3868afd54$export$ce666bf02318c957,
    text: $30b346b9198ff5ad$export$6f093cfa640b7166,
    thematicBreak: $888054abd66b465d$export$ba7b13e047416c03,
    toml: $077e069a28543766$var$ignore,
    yaml: $077e069a28543766$var$ignore,
    definition: $077e069a28543766$var$ignore,
    footnoteDefinition: $077e069a28543766$var$ignore
};
// Return nothing for nodes that are ignored.
function $077e069a28543766$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $db02d3c776d5a83f$var$own = {}.hasOwnProperty;
function $db02d3c776d5a83f$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $077e069a28543766$export$455ce229eb3d2472),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $91b6d905cb0255be$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $db02d3c776d5a83f$var$patch;
    state.applyData = $db02d3c776d5a83f$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $db02d3c776d5a83f$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $93d8bd8148453afd$export$bf638b60ea8b89b7)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$db02d3c776d5a83f$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $65fab1695d90f3c7$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $31d9094bf1c6aaa4$export$771bf3e4949bfbee)(ctx),
                end: (0, $31d9094bf1c6aaa4$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $db02d3c776d5a83f$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $db02d3c776d5a83f$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $db02d3c776d5a83f$var$patch(from, to) {
    if (from.position) to.position = (0, $31d9094bf1c6aaa4$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $db02d3c776d5a83f$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $db02d3c776d5a83f$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($db02d3c776d5a83f$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? {
        ...node,
        children: $db02d3c776d5a83f$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $db02d3c776d5a83f$var$defaultUnknownHandler(state, node);
}
function $db02d3c776d5a83f$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $db02d3c776d5a83f$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $db02d3c776d5a83f$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($db02d3c776d5a83f$var$own.call(data, "hProperties") || $db02d3c776d5a83f$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $db02d3c776d5a83f$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $db02d3c776d5a83f$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}


function $7044d480fc4adede$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $db02d3c776d5a83f$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $26133b30ce9c806b$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $c98cde52b35c611d$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $c98cde52b35c611d$var$bridge(destination, options) : $c98cde52b35c611d$var$mutate(destination || options);
};
var $c98cde52b35c611d$export$2e2bcd8739ae039 = $c98cde52b35c611d$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $c98cde52b35c611d$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $7044d480fc4adede$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $c98cde52b35c611d$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $7044d480fc4adede$export$c0e4c5cf07538633)(node, options);
}


var $c136e6708cf86fd6$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c136e6708cf86fd6$var$ReactIs, $c136e6708cf86fd6$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c136e6708cf86fd6$exports = (parcelRequire("c2AYn"))();


/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $7a9ee4208f197ad8$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $7a9ee4208f197ad8$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $7a9ee4208f197ad8$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $7a9ee4208f197ad8$export$19342e026b58ebb7.prototype.space = null;


function $d9864c56d41e1566$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $7a9ee4208f197ad8$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $2e7eb01261ef6246$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $493e6e366fe1fdf0$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.space = null;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.boolean = false;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.booleanish = false;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.number = false;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$493e6e366fe1fdf0$export$c4868e4a24d48fad.prototype.defined = false;


var $503cd94928620f2b$exports = {};

$parcel$export($503cd94928620f2b$exports, "boolean", function () { return $503cd94928620f2b$export$4a21f16c33752377; });
$parcel$export($503cd94928620f2b$exports, "booleanish", function () { return $503cd94928620f2b$export$55e9e1fbc638dc8f; });
$parcel$export($503cd94928620f2b$exports, "overloadedBoolean", function () { return $503cd94928620f2b$export$242ac3d3042558aa; });
$parcel$export($503cd94928620f2b$exports, "number", function () { return $503cd94928620f2b$export$98e628dec113755e; });
$parcel$export($503cd94928620f2b$exports, "spaceSeparated", function () { return $503cd94928620f2b$export$ab8645c862eb5a3e; });
$parcel$export($503cd94928620f2b$exports, "commaSeparated", function () { return $503cd94928620f2b$export$9c8d678629b3d3; });
$parcel$export($503cd94928620f2b$exports, "commaOrSpaceSeparated", function () { return $503cd94928620f2b$export$2ad25cfebf36cacd; });
let $503cd94928620f2b$var$powers = 0;
const $503cd94928620f2b$export$4a21f16c33752377 = $503cd94928620f2b$var$increment();
const $503cd94928620f2b$export$55e9e1fbc638dc8f = $503cd94928620f2b$var$increment();
const $503cd94928620f2b$export$242ac3d3042558aa = $503cd94928620f2b$var$increment();
const $503cd94928620f2b$export$98e628dec113755e = $503cd94928620f2b$var$increment();
const $503cd94928620f2b$export$ab8645c862eb5a3e = $503cd94928620f2b$var$increment();
const $503cd94928620f2b$export$9c8d678629b3d3 = $503cd94928620f2b$var$increment();
const $503cd94928620f2b$export$2ad25cfebf36cacd = $503cd94928620f2b$var$increment();
function $503cd94928620f2b$var$increment() {
    return 2 ** ++$503cd94928620f2b$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $ea037b07a41284b6$var$checks = Object.keys($503cd94928620f2b$exports);
class $ea037b07a41284b6$export$ea6b9f0064e88c9b extends (0, $493e6e366fe1fdf0$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $ea037b07a41284b6$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $ea037b07a41284b6$var$checks.length){
            const check = $ea037b07a41284b6$var$checks[index];
            $ea037b07a41284b6$var$mark(this, $ea037b07a41284b6$var$checks[index], (mask & $503cd94928620f2b$exports[check]) === $503cd94928620f2b$exports[check]);
        }
    }
}
$ea037b07a41284b6$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $ea037b07a41284b6$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $05ac66e5362a7fe7$var$own = {}.hasOwnProperty;
function $05ac66e5362a7fe7$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($05ac66e5362a7fe7$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $ea037b07a41284b6$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $2e7eb01261ef6246$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $2e7eb01261ef6246$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $7a9ee4208f197ad8$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $30c76797347b6145$export$2bd1230ec7600845 = (0, $05ac66e5362a7fe7$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $2c553d406c48812c$export$f2913fe8983302e = (0, $05ac66e5362a7fe7$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $8cdde5635a902ba5$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $45c38b8dfef0b221$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $8cdde5635a902ba5$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $55b1e2b7f6ed3c26$export$e20c24a128671213 = (0, $05ac66e5362a7fe7$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $45c38b8dfef0b221$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $09e63b4d958c4fb5$export$4d2d26490572750a = (0, $05ac66e5362a7fe7$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaColIndex: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaColSpan: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaControls: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        ariaLevel: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaPressed: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaRowIndex: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaRowSpan: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaSelected: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaValueMin: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaValueNow: (0, $503cd94928620f2b$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $aa94da6ea4f3f3c9$export$c0bb0b647f701bb5 = (0, $05ac66e5362a7fe7$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $45c38b8dfef0b221$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $503cd94928620f2b$export$9c8d678629b3d3),
        acceptCharset: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        accessKey: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $503cd94928620f2b$export$4a21f16c33752377),
        allowPaymentRequest: (0, $503cd94928620f2b$export$4a21f16c33752377),
        allowUserMedia: (0, $503cd94928620f2b$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $503cd94928620f2b$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        autoFocus: (0, $503cd94928620f2b$export$4a21f16c33752377),
        autoPlay: (0, $503cd94928620f2b$export$4a21f16c33752377),
        capture: (0, $503cd94928620f2b$export$4a21f16c33752377),
        charSet: null,
        checked: (0, $503cd94928620f2b$export$4a21f16c33752377),
        cite: null,
        className: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        cols: (0, $503cd94928620f2b$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        controls: (0, $503cd94928620f2b$export$4a21f16c33752377),
        controlsList: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        coords: (0, $503cd94928620f2b$export$98e628dec113755e) | (0, $503cd94928620f2b$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $503cd94928620f2b$export$4a21f16c33752377),
        defer: (0, $503cd94928620f2b$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $503cd94928620f2b$export$4a21f16c33752377),
        download: (0, $503cd94928620f2b$export$242ac3d3042558aa),
        draggable: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $503cd94928620f2b$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        height: (0, $503cd94928620f2b$export$98e628dec113755e),
        hidden: (0, $503cd94928620f2b$export$4a21f16c33752377),
        high: (0, $503cd94928620f2b$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        httpEquiv: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $503cd94928620f2b$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        itemRef: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        itemScope: (0, $503cd94928620f2b$export$4a21f16c33752377),
        itemType: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $503cd94928620f2b$export$4a21f16c33752377),
        low: (0, $503cd94928620f2b$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $503cd94928620f2b$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $503cd94928620f2b$export$98e628dec113755e),
        multiple: (0, $503cd94928620f2b$export$4a21f16c33752377),
        muted: (0, $503cd94928620f2b$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $503cd94928620f2b$export$4a21f16c33752377),
        noValidate: (0, $503cd94928620f2b$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $503cd94928620f2b$export$4a21f16c33752377),
        optimum: (0, $503cd94928620f2b$export$98e628dec113755e),
        pattern: null,
        ping: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $503cd94928620f2b$export$4a21f16c33752377),
        poster: null,
        preload: null,
        readOnly: (0, $503cd94928620f2b$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        required: (0, $503cd94928620f2b$export$4a21f16c33752377),
        reversed: (0, $503cd94928620f2b$export$4a21f16c33752377),
        rows: (0, $503cd94928620f2b$export$98e628dec113755e),
        rowSpan: (0, $503cd94928620f2b$export$98e628dec113755e),
        sandbox: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $503cd94928620f2b$export$4a21f16c33752377),
        seamless: (0, $503cd94928620f2b$export$4a21f16c33752377),
        selected: (0, $503cd94928620f2b$export$4a21f16c33752377),
        shape: null,
        size: (0, $503cd94928620f2b$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $503cd94928620f2b$export$98e628dec113755e),
        spellCheck: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $503cd94928620f2b$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $503cd94928620f2b$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $503cd94928620f2b$export$4a21f16c33752377),
        useMap: null,
        value: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        width: (0, $503cd94928620f2b$export$98e628dec113755e),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $503cd94928620f2b$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $503cd94928620f2b$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $503cd94928620f2b$export$4a21f16c33752377),
        declare: (0, $503cd94928620f2b$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $503cd94928620f2b$export$98e628dec113755e),
        leftMargin: (0, $503cd94928620f2b$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $503cd94928620f2b$export$98e628dec113755e),
        marginWidth: (0, $503cd94928620f2b$export$98e628dec113755e),
        noResize: (0, $503cd94928620f2b$export$4a21f16c33752377),
        noHref: (0, $503cd94928620f2b$export$4a21f16c33752377),
        noShade: (0, $503cd94928620f2b$export$4a21f16c33752377),
        noWrap: (0, $503cd94928620f2b$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $503cd94928620f2b$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $503cd94928620f2b$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $503cd94928620f2b$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $503cd94928620f2b$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $503cd94928620f2b$export$4a21f16c33752377),
        disableRemotePlayback: (0, $503cd94928620f2b$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $503cd94928620f2b$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $b45f29588e8ad591$export$7ed1367e7fa1ad68 = (0, $05ac66e5362a7fe7$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $8cdde5635a902ba5$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        accentHeight: (0, $503cd94928620f2b$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $503cd94928620f2b$export$98e628dec113755e),
        amplitude: (0, $503cd94928620f2b$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $503cd94928620f2b$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $503cd94928620f2b$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $503cd94928620f2b$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $503cd94928620f2b$export$98e628dec113755e),
        className: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $503cd94928620f2b$export$98e628dec113755e),
        diffuseConstant: (0, $503cd94928620f2b$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $503cd94928620f2b$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $503cd94928620f2b$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $503cd94928620f2b$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $503cd94928620f2b$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $503cd94928620f2b$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $503cd94928620f2b$export$9c8d678629b3d3),
        g2: (0, $503cd94928620f2b$export$9c8d678629b3d3),
        glyphName: (0, $503cd94928620f2b$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $503cd94928620f2b$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $503cd94928620f2b$export$98e628dec113755e),
        horizOriginX: (0, $503cd94928620f2b$export$98e628dec113755e),
        horizOriginY: (0, $503cd94928620f2b$export$98e628dec113755e),
        id: null,
        ideographic: (0, $503cd94928620f2b$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $503cd94928620f2b$export$98e628dec113755e),
        k: (0, $503cd94928620f2b$export$98e628dec113755e),
        k1: (0, $503cd94928620f2b$export$98e628dec113755e),
        k2: (0, $503cd94928620f2b$export$98e628dec113755e),
        k3: (0, $503cd94928620f2b$export$98e628dec113755e),
        k4: (0, $503cd94928620f2b$export$98e628dec113755e),
        kernelMatrix: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $503cd94928620f2b$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $503cd94928620f2b$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $503cd94928620f2b$export$98e628dec113755e),
        overlineThickness: (0, $503cd94928620f2b$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $503cd94928620f2b$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $503cd94928620f2b$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $503cd94928620f2b$export$98e628dec113755e),
        pointsAtY: (0, $503cd94928620f2b$export$98e628dec113755e),
        pointsAtZ: (0, $503cd94928620f2b$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        rev: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        requiredFonts: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        requiredFormats: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $503cd94928620f2b$export$98e628dec113755e),
        specularExponent: (0, $503cd94928620f2b$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $503cd94928620f2b$export$98e628dec113755e),
        strikethroughThickness: (0, $503cd94928620f2b$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $503cd94928620f2b$export$98e628dec113755e),
        strokeOpacity: (0, $503cd94928620f2b$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $503cd94928620f2b$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        tabIndex: (0, $503cd94928620f2b$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $503cd94928620f2b$export$98e628dec113755e),
        targetY: (0, $503cd94928620f2b$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $503cd94928620f2b$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $503cd94928620f2b$export$98e628dec113755e),
        underlineThickness: (0, $503cd94928620f2b$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $503cd94928620f2b$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $503cd94928620f2b$export$98e628dec113755e),
        vMathematical: (0, $503cd94928620f2b$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $503cd94928620f2b$export$98e628dec113755e),
        vIdeographic: (0, $503cd94928620f2b$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $503cd94928620f2b$export$98e628dec113755e),
        vertOriginX: (0, $503cd94928620f2b$export$98e628dec113755e),
        vertOriginY: (0, $503cd94928620f2b$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $503cd94928620f2b$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $a5d32c782dfb87d4$var$valid = /^data[-\w.:]+$/i;
const $a5d32c782dfb87d4$var$dash = /-[a-z]/g;
const $a5d32c782dfb87d4$var$cap = /[A-Z]/g;
function $a5d32c782dfb87d4$export$71aa6c912b956294(schema, value) {
    const normal = (0, $2e7eb01261ef6246$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $493e6e366fe1fdf0$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $a5d32c782dfb87d4$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($a5d32c782dfb87d4$var$dash, $a5d32c782dfb87d4$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$a5d32c782dfb87d4$var$dash.test(rest)) {
                let dashes = rest.replace($a5d32c782dfb87d4$var$cap, $a5d32c782dfb87d4$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $ea037b07a41284b6$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $a5d32c782dfb87d4$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $a5d32c782dfb87d4$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $8bf36950978896bf$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};



const $d5b213d436a94199$export$c0bb0b647f701bb5 = (0, $d9864c56d41e1566$export$4950aa0f605343fb)([
    (0, $2c553d406c48812c$export$f2913fe8983302e),
    (0, $30c76797347b6145$export$2bd1230ec7600845),
    (0, $55b1e2b7f6ed3c26$export$e20c24a128671213),
    (0, $09e63b4d958c4fb5$export$4d2d26490572750a),
    (0, $aa94da6ea4f3f3c9$export$c0bb0b647f701bb5)
], "html");
const $d5b213d436a94199$export$7ed1367e7fa1ad68 = (0, $d9864c56d41e1566$export$4950aa0f605343fb)([
    (0, $2c553d406c48812c$export$f2913fe8983302e),
    (0, $30c76797347b6145$export$2bd1230ec7600845),
    (0, $55b1e2b7f6ed3c26$export$e20c24a128671213),
    (0, $09e63b4d958c4fb5$export$4d2d26490572750a),
    (0, $b45f29588e8ad591$export$7ed1367e7fa1ad68)
], "svg");



function $0d7d987ac34fd284$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $93d8bd8148453afd$export$bf638b60ea8b89b7)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $755e78824a51df5f$exports = {};
"use strict";

$755e78824a51df5f$exports = (parcelRequire("1ptWM"));


/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $33a0a8c852e5b6ca$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $3ffb311c7c73400a$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $3ffb311c7c73400a$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $8ee927eafd1154d1$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $8ee927eafd1154d1$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


var $4dd34db35cdb5b4d$exports = {};
var $128186a98ece3de5$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $128186a98ece3de5$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $128186a98ece3de5$var$NEWLINE_REGEX = /\n/g;
var $128186a98ece3de5$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $128186a98ece3de5$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $128186a98ece3de5$var$COLON_REGEX = /^:\s*/;
var $128186a98ece3de5$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $128186a98ece3de5$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $128186a98ece3de5$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $128186a98ece3de5$var$NEWLINE = "\n";
var $128186a98ece3de5$var$FORWARD_SLASH = "/";
var $128186a98ece3de5$var$ASTERISK = "*";
var $128186a98ece3de5$var$EMPTY_STRING = "";
// types
var $128186a98ece3de5$var$TYPE_COMMENT = "comment";
var $128186a98ece3de5$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $128186a98ece3de5$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($128186a98ece3de5$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($128186a98ece3de5$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($128186a98ece3de5$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($128186a98ece3de5$var$FORWARD_SLASH != style.charAt(0) || $128186a98ece3de5$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($128186a98ece3de5$var$EMPTY_STRING != style.charAt(i) && ($128186a98ece3de5$var$ASTERISK != style.charAt(i) || $128186a98ece3de5$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($128186a98ece3de5$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $128186a98ece3de5$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($128186a98ece3de5$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($128186a98ece3de5$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($128186a98ece3de5$var$VALUE_REGEX);
        var ret = pos({
            type: $128186a98ece3de5$var$TYPE_DECLARATION,
            property: $128186a98ece3de5$var$trim(prop[0].replace($128186a98ece3de5$var$COMMENT_REGEX, $128186a98ece3de5$var$EMPTY_STRING)),
            value: val ? $128186a98ece3de5$var$trim(val[0].replace($128186a98ece3de5$var$COMMENT_REGEX, $128186a98ece3de5$var$EMPTY_STRING)) : $128186a98ece3de5$var$EMPTY_STRING
        });
        // ;
        match($128186a98ece3de5$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $128186a98ece3de5$var$trim(str) {
    return str ? str.replace($128186a98ece3de5$var$TRIM_REGEX, $128186a98ece3de5$var$EMPTY_STRING) : $128186a98ece3de5$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $4dd34db35cdb5b4d$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $128186a98ece3de5$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$4dd34db35cdb5b4d$exports = $4dd34db35cdb5b4d$var$StyleToObject;
$4dd34db35cdb5b4d$exports.default = $4dd34db35cdb5b4d$var$StyleToObject; // ESM support


var $0a064ccd80edcd31$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4dd34db35cdb5b4d$exports)));


const $498871221c7a8ad7$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $498871221c7a8ad7$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $498871221c7a8ad7$var$protocols.length){
        const protocol = $498871221c7a8ad7$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}


const $dc44599e8b2193a8$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $dc44599e8b2193a8$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $dc44599e8b2193a8$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($dc44599e8b2193a8$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$dc44599e8b2193a8$var$tableElements.has(node.tagName) || !(0, $33a0a8c852e5b6ca$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $dc44599e8b2193a8$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $498871221c7a8ad7$export$b83532a10e2e268b) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $d5b213d436a94199$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($dc44599e8b2193a8$var$own.call(node.properties, property)) $dc44599e8b2193a8$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $dc44599e8b2193a8$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $dc44599e8b2193a8$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, $69d723089b47cf34$export$2e2bcd8739ae039).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($755e78824a51df5f$exports))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $dc44599e8b2193a8$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $dc44599e8b2193a8$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $dc44599e8b2193a8$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $dc44599e8b2193a8$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $dc44599e8b2193a8$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, $69d723089b47cf34$export$2e2bcd8739ae039).createElement(component, properties, children) : (0, $69d723089b47cf34$export$2e2bcd8739ae039).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $dc44599e8b2193a8$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $dc44599e8b2193a8$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $dc44599e8b2193a8$var$addProperty(props, prop, value, ctx) {
    const info = (0, $a5d32c782dfb87d4$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $8ee927eafd1154d1$export$fac44ee5b035f737)(result) : (0, $3ffb311c7c73400a$export$fac44ee5b035f737)(result);
    if (info.property === "style" && typeof result === "string") result = $dc44599e8b2193a8$var$parseStyle(result);
    if (info.space && info.property) props[$dc44599e8b2193a8$var$own.call((0, $8bf36950978896bf$export$d8abd7e5fb6871f9), info.property) ? (0, $8bf36950978896bf$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $dc44599e8b2193a8$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $0a064ccd80edcd31$export$2e2bcd8739ae039)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $dc44599e8b2193a8$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $dc44599e8b2193a8$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $dc44599e8b2193a8$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}


const $4c150aafc3247272$var$own = {}.hasOwnProperty;
const $4c150aafc3247272$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $4c150aafc3247272$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $4c150aafc3247272$export$83ef7ab426386201(options) {
    for(const key in $4c150aafc3247272$var$deprecated)if ($4c150aafc3247272$var$own.call($4c150aafc3247272$var$deprecated, key) && $4c150aafc3247272$var$own.call(options, key)) {
        const deprecation = $4c150aafc3247272$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$4c150aafc3247272$var$changelog}#${deprecation.id}> for more info)`);
        delete $4c150aafc3247272$var$deprecated[key];
    }
    const processor = (0, $a5b453dffc62716c$export$7cc1b2fe10c52bb)().use((0, $cc55dc5144f1938e$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $c98cde52b35c611d$export$2e2bcd8739ae039), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $0d7d987ac34fd284$export$2e2bcd8739ae039), options);
    const file = new (0, $4cd8dfbbfabb6d9c$export$93dff69eb10dc7ce)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, $69d723089b47cf34$export$2e2bcd8739ae039).createElement((0, $69d723089b47cf34$export$2e2bcd8739ae039).Fragment, {}, (0, $dc44599e8b2193a8$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $d5b213d436a94199$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, $69d723089b47cf34$export$2e2bcd8739ae039).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$4c150aafc3247272$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($c136e6708cf86fd6$exports))).object
};


/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-raw').Options} Options
 * @typedef {import('hast-util-raw')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('vfile').VFile} VFile
 * @typedef {import('parse5').Document} P5Document
 * @typedef {import('parse5').DocumentFragment} P5Fragment
 * @typedef {Omit<import('parse5').Element, 'parentNode'>} P5Element
 * @typedef {import('parse5').Attribute} P5Attribute
 * @typedef {Omit<import('parse5').Location, 'startOffset' | 'endOffset'> & {startOffset: number|undefined, endOffset: number|undefined}} P5Location
 * @typedef {import('parse5').ParserOptions} P5ParserOptions
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Content} Content
 * @typedef {Root|Content} Node
 * @typedef {import('../complex-types').Raw} Raw
 *
 * @typedef {Omit<Comment, 'value'> & {value: {stitch: Node}}} Stitch
 *
 * @typedef Options
 * @property {Array<string>} [passThrough]
 *   List of custom hast node types to pass through (keep) in hast.
 *   If the passed through nodes have children, those children are expected to
 *   be hast and will be handled.
 *
 * @typedef HiddenTokenizer
 * @property {Array<HiddenLocationTracker>} __mixins
 *   Way too simple, but works for us.
 * @property {HiddenPreprocessor} preprocessor
 * @property {(value: string) => void} write
 * @property {() => number} _consume
 * @property {Array<HiddenToken>} tokenQueue
 * @property {string} state
 * @property {string} returnState
 * @property {number} charRefCode
 * @property {Array<number>} tempBuff
 * @property {Function} _flushCodePointsConsumedAsCharacterReference
 * @property {string} lastStartTagName
 * @property {number} consumedAfterSnapshot
 * @property {boolean} active
 * @property {HiddenToken|undefined} currentCharacterToken
 * @property {HiddenToken|undefined} currentToken
 * @property {unknown} currentAttr
 * @property {Function} NAMED_CHARACTER_REFERENCE_STATE
 * @property {Function} NUMERIC_CHARACTER_REFERENCE_END_STATE
 *
 * @typedef {Record<string, unknown> & {location: P5Location}} HiddenToken
 *
 * @typedef HiddenPreprocessor
 * @property {string|undefined} html
 * @property {number} pos
 * @property {number} lastGapPos
 * @property {number} lastCharPos
 * @property {Array<number>} gapStack
 * @property {boolean} skipNextNewLine
 * @property {boolean} lastChunkWritten
 * @property {boolean} endOfChunkHit
 *
 * @typedef HiddenLocationTracker
 * @property {P5Location|undefined} currentAttrLocation
 * @property {P5Location} ctLoc
 * @property {HiddenPosTracker} posTracker
 *
 * @typedef HiddenPosTracker
 * @property {boolean} isEol
 * @property {number} lineStartPos
 * @property {number} droppedBufferSize
 * @property {number} offset
 * @property {number} col
 * @property {number} line
 */ // @ts-expect-error: untyped.
var $3c987794e73954fa$exports = {};
"use strict";
var $1402a60f2d09b0f9$exports = {};
"use strict";
var $14db446065d7ad01$exports = {};
"use strict";
var $4e69a73910c07b7d$export$e8d20e7a50e6c279;
var $4e69a73910c07b7d$export$e3f6c2feb5c0ecc0;
var $4e69a73910c07b7d$export$3dc99c30563e6ab8;
//Surrogates
var $4e69a73910c07b7d$export$7e678b42035e707f;
var $4e69a73910c07b7d$export$e7f1d94bb17e4055;
var $4e69a73910c07b7d$export$91e83256751ec906;
//NOTE: excluding NULL and ASCII whitespace
var $4e69a73910c07b7d$export$d6953a6077926e;
var $4e69a73910c07b7d$export$b3484aaf321bda02;
"use strict";
const $4e69a73910c07b7d$var$UNDEFINED_CODE_POINTS = [
    0xfffe,
    0xffff,
    0x1fffe,
    0x1ffff,
    0x2fffe,
    0x2ffff,
    0x3fffe,
    0x3ffff,
    0x4fffe,
    0x4ffff,
    0x5fffe,
    0x5ffff,
    0x6fffe,
    0x6ffff,
    0x7fffe,
    0x7ffff,
    0x8fffe,
    0x8ffff,
    0x9fffe,
    0x9ffff,
    0xafffe,
    0xaffff,
    0xbfffe,
    0xbffff,
    0xcfffe,
    0xcffff,
    0xdfffe,
    0xdffff,
    0xefffe,
    0xeffff,
    0xffffe,
    0xfffff,
    0x10fffe,
    0x10ffff
];
$4e69a73910c07b7d$export$e8d20e7a50e6c279 = "\uFFFD";
$4e69a73910c07b7d$export$e3f6c2feb5c0ecc0 = {
    EOF: -1,
    NULL: 0x00,
    TABULATION: 0x09,
    CARRIAGE_RETURN: 0x0d,
    LINE_FEED: 0x0a,
    FORM_FEED: 0x0c,
    SPACE: 0x20,
    EXCLAMATION_MARK: 0x21,
    QUOTATION_MARK: 0x22,
    NUMBER_SIGN: 0x23,
    AMPERSAND: 0x26,
    APOSTROPHE: 0x27,
    HYPHEN_MINUS: 0x2d,
    SOLIDUS: 0x2f,
    DIGIT_0: 0x30,
    DIGIT_9: 0x39,
    SEMICOLON: 0x3b,
    LESS_THAN_SIGN: 0x3c,
    EQUALS_SIGN: 0x3d,
    GREATER_THAN_SIGN: 0x3e,
    QUESTION_MARK: 0x3f,
    LATIN_CAPITAL_A: 0x41,
    LATIN_CAPITAL_F: 0x46,
    LATIN_CAPITAL_X: 0x58,
    LATIN_CAPITAL_Z: 0x5a,
    RIGHT_SQUARE_BRACKET: 0x5d,
    GRAVE_ACCENT: 0x60,
    LATIN_SMALL_A: 0x61,
    LATIN_SMALL_F: 0x66,
    LATIN_SMALL_X: 0x78,
    LATIN_SMALL_Z: 0x7a,
    REPLACEMENT_CHARACTER: 0xfffd
};
$4e69a73910c07b7d$export$3dc99c30563e6ab8 = {
    DASH_DASH_STRING: [
        0x2d,
        0x2d
    ],
    DOCTYPE_STRING: [
        0x44,
        0x4f,
        0x43,
        0x54,
        0x59,
        0x50,
        0x45
    ],
    CDATA_START_STRING: [
        0x5b,
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ],
    SCRIPT_STRING: [
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ],
    PUBLIC_STRING: [
        0x50,
        0x55,
        0x42,
        0x4c,
        0x49,
        0x43
    ],
    SYSTEM_STRING: [
        0x53,
        0x59,
        0x53,
        0x54,
        0x45,
        0x4d
    ] //SYSTEM
};
$4e69a73910c07b7d$export$7e678b42035e707f = function(cp) {
    return cp >= 0xd800 && cp <= 0xdfff;
};
$4e69a73910c07b7d$export$e7f1d94bb17e4055 = function(cp) {
    return cp >= 0xdc00 && cp <= 0xdfff;
};
$4e69a73910c07b7d$export$91e83256751ec906 = function(cp1, cp2) {
    return (cp1 - 0xd800) * 0x400 + 0x2400 + cp2;
};
$4e69a73910c07b7d$export$d6953a6077926e = function(cp) {
    return cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f || cp >= 0x7f && cp <= 0x9f;
};
$4e69a73910c07b7d$export$b3484aaf321bda02 = function(cp) {
    return cp >= 0xfdd0 && cp <= 0xfdef || $4e69a73910c07b7d$var$UNDEFINED_CODE_POINTS.indexOf(cp) > -1;
};


var $17010537ac9d51f5$exports = {};
"use strict";
$17010537ac9d51f5$exports = {
    controlCharacterInInputStream: "control-character-in-input-stream",
    noncharacterInInputStream: "noncharacter-in-input-stream",
    surrogateInInputStream: "surrogate-in-input-stream",
    nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
    endTagWithAttributes: "end-tag-with-attributes",
    endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
    unexpectedSolidusInTag: "unexpected-solidus-in-tag",
    unexpectedNullCharacter: "unexpected-null-character",
    unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
    invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
    unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
    missingEndTagName: "missing-end-tag-name",
    unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
    unknownNamedCharacterReference: "unknown-named-character-reference",
    missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
    unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
    unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
    eofBeforeTagName: "eof-before-tag-name",
    eofInTag: "eof-in-tag",
    missingAttributeValue: "missing-attribute-value",
    missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
    missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
    missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
    missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
    missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
    missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
    missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
    missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
    abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
    abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
    cdataInHtmlContent: "cdata-in-html-content",
    incorrectlyOpenedComment: "incorrectly-opened-comment",
    eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
    eofInDoctype: "eof-in-doctype",
    nestedComment: "nested-comment",
    abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
    eofInComment: "eof-in-comment",
    incorrectlyClosedComment: "incorrectly-closed-comment",
    eofInCdata: "eof-in-cdata",
    absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
    nullCharacterReference: "null-character-reference",
    surrogateCharacterReference: "surrogate-character-reference",
    characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
    controlCharacterReference: "control-character-reference",
    noncharacterCharacterReference: "noncharacter-character-reference",
    missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
    missingDoctypeName: "missing-doctype-name",
    invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
    duplicateAttribute: "duplicate-attribute",
    nonConformingDoctype: "non-conforming-doctype",
    missingDoctype: "missing-doctype",
    misplacedDoctype: "misplaced-doctype",
    endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
    closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
    disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
    openElementsLeftAfterEof: "open-elements-left-after-eof",
    abandonedHeadElementChild: "abandoned-head-element-child",
    misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
    nestedNoscriptInHead: "nested-noscript-in-head",
    eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};


//Aliases
const $14db446065d7ad01$var$$ = $4e69a73910c07b7d$export$e3f6c2feb5c0ecc0;
//Const
const $14db446065d7ad01$var$DEFAULT_BUFFER_WATERLINE = 65536;
//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
class $14db446065d7ad01$var$Preprocessor {
    constructor(){
        this.html = null;
        this.pos = -1;
        this.lastGapPos = -1;
        this.lastCharPos = -1;
        this.gapStack = [];
        this.skipNextNewLine = false;
        this.lastChunkWritten = false;
        this.endOfChunkHit = false;
        this.bufferWaterline = $14db446065d7ad01$var$DEFAULT_BUFFER_WATERLINE;
    }
    _err() {
    // NOTE: err reporting is noop by default. Enabled by mixin.
    }
    _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
    }
    _processSurrogate(cp) {
        //NOTE: try to peek a surrogate pair
        if (this.pos !== this.lastCharPos) {
            const nextCp = this.html.charCodeAt(this.pos + 1);
            if ($4e69a73910c07b7d$export$e7f1d94bb17e4055(nextCp)) {
                //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
                this.pos++;
                //NOTE: add gap that should be avoided during retreat
                this._addGap();
                return $4e69a73910c07b7d$export$91e83256751ec906(cp, nextCp);
            }
        } else if (!this.lastChunkWritten) {
            this.endOfChunkHit = true;
            return $14db446065d7ad01$var$$.EOF;
        }
        //NOTE: isolated surrogate
        this._err($17010537ac9d51f5$exports.surrogateInInputStream);
        return cp;
    }
    dropParsedChunk() {
        if (this.pos > this.bufferWaterline) {
            this.lastCharPos -= this.pos;
            this.html = this.html.substring(this.pos);
            this.pos = 0;
            this.lastGapPos = -1;
            this.gapStack = [];
        }
    }
    write(chunk, isLastChunk) {
        if (this.html) this.html += chunk;
        else this.html = chunk;
        this.lastCharPos = this.html.length - 1;
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
    }
    insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1, this.html.length);
        this.lastCharPos = this.html.length - 1;
        this.endOfChunkHit = false;
    }
    advance() {
        this.pos++;
        if (this.pos > this.lastCharPos) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return $14db446065d7ad01$var$$.EOF;
        }
        let cp = this.html.charCodeAt(this.pos);
        //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
        //must be ignored.
        if (this.skipNextNewLine && cp === $14db446065d7ad01$var$$.LINE_FEED) {
            this.skipNextNewLine = false;
            this._addGap();
            return this.advance();
        }
        //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
        if (cp === $14db446065d7ad01$var$$.CARRIAGE_RETURN) {
            this.skipNextNewLine = true;
            return $14db446065d7ad01$var$$.LINE_FEED;
        }
        this.skipNextNewLine = false;
        if ($4e69a73910c07b7d$export$7e678b42035e707f(cp)) cp = this._processSurrogate(cp);
        //OPTIMIZATION: first check if code point is in the common allowed
        //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
        //before going into detailed performance cost validation.
        const isCommonValidRange = cp > 0x1f && cp < 0x7f || cp === $14db446065d7ad01$var$$.LINE_FEED || cp === $14db446065d7ad01$var$$.CARRIAGE_RETURN || cp > 0x9f && cp < 0xfdd0;
        if (!isCommonValidRange) this._checkForProblematicCharacters(cp);
        return cp;
    }
    _checkForProblematicCharacters(cp) {
        if ($4e69a73910c07b7d$export$d6953a6077926e(cp)) this._err($17010537ac9d51f5$exports.controlCharacterInInputStream);
        else if ($4e69a73910c07b7d$export$b3484aaf321bda02(cp)) this._err($17010537ac9d51f5$exports.noncharacterInInputStream);
    }
    retreat() {
        if (this.pos === this.lastGapPos) {
            this.lastGapPos = this.gapStack.pop();
            this.pos--;
        }
        this.pos--;
    }
}
$14db446065d7ad01$exports = $14db446065d7ad01$var$Preprocessor;



var $9849b1bcc152963f$exports = {};
"use strict";
//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate-named-entity-data/README.md)
$9849b1bcc152963f$exports = new Uint16Array([
    4,
    52,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    106,
    303,
    412,
    810,
    1432,
    1701,
    1796,
    1987,
    2114,
    2360,
    2420,
    2484,
    3170,
    3251,
    4140,
    4393,
    4575,
    4610,
    5106,
    5512,
    5728,
    6117,
    6274,
    6315,
    6345,
    6427,
    6516,
    7002,
    7910,
    8733,
    9323,
    9870,
    10170,
    10631,
    10893,
    11318,
    11386,
    11467,
    12773,
    13092,
    14474,
    14922,
    15448,
    15542,
    16419,
    17666,
    18166,
    18611,
    19004,
    19095,
    19298,
    19397,
    4,
    16,
    69,
    77,
    97,
    98,
    99,
    102,
    103,
    108,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    140,
    150,
    158,
    169,
    176,
    194,
    199,
    210,
    216,
    222,
    226,
    242,
    256,
    266,
    283,
    294,
    108,
    105,
    103,
    5,
    198,
    1,
    59,
    148,
    1,
    198,
    80,
    5,
    38,
    1,
    59,
    156,
    1,
    38,
    99,
    117,
    116,
    101,
    5,
    193,
    1,
    59,
    167,
    1,
    193,
    114,
    101,
    118,
    101,
    59,
    1,
    258,
    4,
    2,
    105,
    121,
    182,
    191,
    114,
    99,
    5,
    194,
    1,
    59,
    189,
    1,
    194,
    59,
    1,
    1040,
    114,
    59,
    3,
    55349,
    56580,
    114,
    97,
    118,
    101,
    5,
    192,
    1,
    59,
    208,
    1,
    192,
    112,
    104,
    97,
    59,
    1,
    913,
    97,
    99,
    114,
    59,
    1,
    256,
    100,
    59,
    1,
    10835,
    4,
    2,
    103,
    112,
    232,
    237,
    111,
    110,
    59,
    1,
    260,
    102,
    59,
    3,
    55349,
    56632,
    112,
    108,
    121,
    70,
    117,
    110,
    99,
    116,
    105,
    111,
    110,
    59,
    1,
    8289,
    105,
    110,
    103,
    5,
    197,
    1,
    59,
    264,
    1,
    197,
    4,
    2,
    99,
    115,
    272,
    277,
    114,
    59,
    3,
    55349,
    56476,
    105,
    103,
    110,
    59,
    1,
    8788,
    105,
    108,
    100,
    101,
    5,
    195,
    1,
    59,
    292,
    1,
    195,
    109,
    108,
    5,
    196,
    1,
    59,
    301,
    1,
    196,
    4,
    8,
    97,
    99,
    101,
    102,
    111,
    114,
    115,
    117,
    321,
    350,
    354,
    383,
    388,
    394,
    400,
    405,
    4,
    2,
    99,
    114,
    327,
    336,
    107,
    115,
    108,
    97,
    115,
    104,
    59,
    1,
    8726,
    4,
    2,
    118,
    119,
    342,
    345,
    59,
    1,
    10983,
    101,
    100,
    59,
    1,
    8966,
    121,
    59,
    1,
    1041,
    4,
    3,
    99,
    114,
    116,
    362,
    369,
    379,
    97,
    117,
    115,
    101,
    59,
    1,
    8757,
    110,
    111,
    117,
    108,
    108,
    105,
    115,
    59,
    1,
    8492,
    97,
    59,
    1,
    914,
    114,
    59,
    3,
    55349,
    56581,
    112,
    102,
    59,
    3,
    55349,
    56633,
    101,
    118,
    101,
    59,
    1,
    728,
    99,
    114,
    59,
    1,
    8492,
    109,
    112,
    101,
    113,
    59,
    1,
    8782,
    4,
    14,
    72,
    79,
    97,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    111,
    114,
    115,
    117,
    442,
    447,
    456,
    504,
    542,
    547,
    569,
    573,
    577,
    616,
    678,
    784,
    790,
    796,
    99,
    121,
    59,
    1,
    1063,
    80,
    89,
    5,
    169,
    1,
    59,
    454,
    1,
    169,
    4,
    3,
    99,
    112,
    121,
    464,
    470,
    497,
    117,
    116,
    101,
    59,
    1,
    262,
    4,
    2,
    59,
    105,
    476,
    478,
    1,
    8914,
    116,
    97,
    108,
    68,
    105,
    102,
    102,
    101,
    114,
    101,
    110,
    116,
    105,
    97,
    108,
    68,
    59,
    1,
    8517,
    108,
    101,
    121,
    115,
    59,
    1,
    8493,
    4,
    4,
    97,
    101,
    105,
    111,
    514,
    520,
    530,
    535,
    114,
    111,
    110,
    59,
    1,
    268,
    100,
    105,
    108,
    5,
    199,
    1,
    59,
    528,
    1,
    199,
    114,
    99,
    59,
    1,
    264,
    110,
    105,
    110,
    116,
    59,
    1,
    8752,
    111,
    116,
    59,
    1,
    266,
    4,
    2,
    100,
    110,
    553,
    560,
    105,
    108,
    108,
    97,
    59,
    1,
    184,
    116,
    101,
    114,
    68,
    111,
    116,
    59,
    1,
    183,
    114,
    59,
    1,
    8493,
    105,
    59,
    1,
    935,
    114,
    99,
    108,
    101,
    4,
    4,
    68,
    77,
    80,
    84,
    591,
    596,
    603,
    609,
    111,
    116,
    59,
    1,
    8857,
    105,
    110,
    117,
    115,
    59,
    1,
    8854,
    108,
    117,
    115,
    59,
    1,
    8853,
    105,
    109,
    101,
    115,
    59,
    1,
    8855,
    111,
    4,
    2,
    99,
    115,
    623,
    646,
    107,
    119,
    105,
    115,
    101,
    67,
    111,
    110,
    116,
    111,
    117,
    114,
    73,
    110,
    116,
    101,
    103,
    114,
    97,
    108,
    59,
    1,
    8754,
    101,
    67,
    117,
    114,
    108,
    121,
    4,
    2,
    68,
    81,
    658,
    671,
    111,
    117,
    98,
    108,
    101,
    81,
    117,
    111,
    116,
    101,
    59,
    1,
    8221,
    117,
    111,
    116,
    101,
    59,
    1,
    8217,
    4,
    4,
    108,
    110,
    112,
    117,
    688,
    701,
    736,
    753,
    111,
    110,
    4,
    2,
    59,
    101,
    696,
    698,
    1,
    8759,
    59,
    1,
    10868,
    4,
    3,
    103,
    105,
    116,
    709,
    717,
    722,
    114,
    117,
    101,
    110,
    116,
    59,
    1,
    8801,
    110,
    116,
    59,
    1,
    8751,
    111,
    117,
    114,
    73,
    110,
    116,
    101,
    103,
    114,
    97,
    108,
    59,
    1,
    8750,
    4,
    2,
    102,
    114,
    742,
    745,
    59,
    1,
    8450,
    111,
    100,
    117,
    99,
    116,
    59,
    1,
    8720,
    110,
    116,
    101,
    114,
    67,
    108,
    111,
    99,
    107,
    119,
    105,
    115,
    101,
    67,
    111,
    110,
    116,
    111,
    117,
    114,
    73,
    110,
    116,
    101,
    103,
    114,
    97,
    108,
    59,
    1,
    8755,
    111,
    115,
    115,
    59,
    1,
    10799,
    99,
    114,
    59,
    3,
    55349,
    56478,
    112,
    4,
    2,
    59,
    67,
    803,
    805,
    1,
    8915,
    97,
    112,
    59,
    1,
    8781,
    4,
    11,
    68,
    74,
    83,
    90,
    97,
    99,
    101,
    102,
    105,
    111,
    115,
    834,
    850,
    855,
    860,
    865,
    888,
    903,
    916,
    921,
    1011,
    1415,
    4,
    2,
    59,
    111,
    840,
    842,
    1,
    8517,
    116,
    114,
    97,
    104,
    100,
    59,
    1,
    10513,
    99,
    121,
    59,
    1,
    1026,
    99,
    121,
    59,
    1,
    1029,
    99,
    121,
    59,
    1,
    1039,
    4,
    3,
    103,
    114,
    115,
    873,
    879,
    883,
    103,
    101,
    114,
    59,
    1,
    8225,
    114,
    59,
    1,
    8609,
    104,
    118,
    59,
    1,
    10980,
    4,
    2,
    97,
    121,
    894,
    900,
    114,
    111,
    110,
    59,
    1,
    270,
    59,
    1,
    1044,
    108,
    4,
    2,
    59,
    116,
    910,
    912,
    1,
    8711,
    97,
    59,
    1,
    916,
    114,
    59,
    3,
    55349,
    56583,
    4,
    2,
    97,
    102,
    927,
    998,
    4,
    2,
    99,
    109,
    933,
    992,
    114,
    105,
    116,
    105,
    99,
    97,
    108,
    4,
    4,
    65,
    68,
    71,
    84,
    950,
    957,
    978,
    985,
    99,
    117,
    116,
    101,
    59,
    1,
    180,
    111,
    4,
    2,
    116,
    117,
    964,
    967,
    59,
    1,
    729,
    98,
    108,
    101,
    65,
    99,
    117,
    116,
    101,
    59,
    1,
    733,
    114,
    97,
    118,
    101,
    59,
    1,
    96,
    105,
    108,
    100,
    101,
    59,
    1,
    732,
    111,
    110,
    100,
    59,
    1,
    8900,
    102,
    101,
    114,
    101,
    110,
    116,
    105,
    97,
    108,
    68,
    59,
    1,
    8518,
    4,
    4,
    112,
    116,
    117,
    119,
    1021,
    1026,
    1048,
    1249,
    102,
    59,
    3,
    55349,
    56635,
    4,
    3,
    59,
    68,
    69,
    1034,
    1036,
    1041,
    1,
    168,
    111,
    116,
    59,
    1,
    8412,
    113,
    117,
    97,
    108,
    59,
    1,
    8784,
    98,
    108,
    101,
    4,
    6,
    67,
    68,
    76,
    82,
    85,
    86,
    1065,
    1082,
    1101,
    1189,
    1211,
    1236,
    111,
    110,
    116,
    111,
    117,
    114,
    73,
    110,
    116,
    101,
    103,
    114,
    97,
    108,
    59,
    1,
    8751,
    111,
    4,
    2,
    116,
    119,
    1089,
    1092,
    59,
    1,
    168,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8659,
    4,
    2,
    101,
    111,
    1107,
    1141,
    102,
    116,
    4,
    3,
    65,
    82,
    84,
    1117,
    1124,
    1136,
    114,
    114,
    111,
    119,
    59,
    1,
    8656,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8660,
    101,
    101,
    59,
    1,
    10980,
    110,
    103,
    4,
    2,
    76,
    82,
    1149,
    1177,
    101,
    102,
    116,
    4,
    2,
    65,
    82,
    1158,
    1165,
    114,
    114,
    111,
    119,
    59,
    1,
    10232,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    10234,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    10233,
    105,
    103,
    104,
    116,
    4,
    2,
    65,
    84,
    1199,
    1206,
    114,
    114,
    111,
    119,
    59,
    1,
    8658,
    101,
    101,
    59,
    1,
    8872,
    112,
    4,
    2,
    65,
    68,
    1218,
    1225,
    114,
    114,
    111,
    119,
    59,
    1,
    8657,
    111,
    119,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8661,
    101,
    114,
    116,
    105,
    99,
    97,
    108,
    66,
    97,
    114,
    59,
    1,
    8741,
    110,
    4,
    6,
    65,
    66,
    76,
    82,
    84,
    97,
    1264,
    1292,
    1299,
    1352,
    1391,
    1408,
    114,
    114,
    111,
    119,
    4,
    3,
    59,
    66,
    85,
    1276,
    1278,
    1283,
    1,
    8595,
    97,
    114,
    59,
    1,
    10515,
    112,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8693,
    114,
    101,
    118,
    101,
    59,
    1,
    785,
    101,
    102,
    116,
    4,
    3,
    82,
    84,
    86,
    1310,
    1323,
    1334,
    105,
    103,
    104,
    116,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10576,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10590,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    1345,
    1347,
    1,
    8637,
    97,
    114,
    59,
    1,
    10582,
    105,
    103,
    104,
    116,
    4,
    2,
    84,
    86,
    1362,
    1373,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10591,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    1384,
    1386,
    1,
    8641,
    97,
    114,
    59,
    1,
    10583,
    101,
    101,
    4,
    2,
    59,
    65,
    1399,
    1401,
    1,
    8868,
    114,
    114,
    111,
    119,
    59,
    1,
    8615,
    114,
    114,
    111,
    119,
    59,
    1,
    8659,
    4,
    2,
    99,
    116,
    1421,
    1426,
    114,
    59,
    3,
    55349,
    56479,
    114,
    111,
    107,
    59,
    1,
    272,
    4,
    16,
    78,
    84,
    97,
    99,
    100,
    102,
    103,
    108,
    109,
    111,
    112,
    113,
    115,
    116,
    117,
    120,
    1466,
    1470,
    1478,
    1489,
    1515,
    1520,
    1525,
    1536,
    1544,
    1593,
    1609,
    1617,
    1650,
    1664,
    1668,
    1677,
    71,
    59,
    1,
    330,
    72,
    5,
    208,
    1,
    59,
    1476,
    1,
    208,
    99,
    117,
    116,
    101,
    5,
    201,
    1,
    59,
    1487,
    1,
    201,
    4,
    3,
    97,
    105,
    121,
    1497,
    1503,
    1512,
    114,
    111,
    110,
    59,
    1,
    282,
    114,
    99,
    5,
    202,
    1,
    59,
    1510,
    1,
    202,
    59,
    1,
    1069,
    111,
    116,
    59,
    1,
    278,
    114,
    59,
    3,
    55349,
    56584,
    114,
    97,
    118,
    101,
    5,
    200,
    1,
    59,
    1534,
    1,
    200,
    101,
    109,
    101,
    110,
    116,
    59,
    1,
    8712,
    4,
    2,
    97,
    112,
    1550,
    1555,
    99,
    114,
    59,
    1,
    274,
    116,
    121,
    4,
    2,
    83,
    86,
    1563,
    1576,
    109,
    97,
    108,
    108,
    83,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9723,
    101,
    114,
    121,
    83,
    109,
    97,
    108,
    108,
    83,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9643,
    4,
    2,
    103,
    112,
    1599,
    1604,
    111,
    110,
    59,
    1,
    280,
    102,
    59,
    3,
    55349,
    56636,
    115,
    105,
    108,
    111,
    110,
    59,
    1,
    917,
    117,
    4,
    2,
    97,
    105,
    1624,
    1640,
    108,
    4,
    2,
    59,
    84,
    1631,
    1633,
    1,
    10869,
    105,
    108,
    100,
    101,
    59,
    1,
    8770,
    108,
    105,
    98,
    114,
    105,
    117,
    109,
    59,
    1,
    8652,
    4,
    2,
    99,
    105,
    1656,
    1660,
    114,
    59,
    1,
    8496,
    109,
    59,
    1,
    10867,
    97,
    59,
    1,
    919,
    109,
    108,
    5,
    203,
    1,
    59,
    1675,
    1,
    203,
    4,
    2,
    105,
    112,
    1683,
    1689,
    115,
    116,
    115,
    59,
    1,
    8707,
    111,
    110,
    101,
    110,
    116,
    105,
    97,
    108,
    69,
    59,
    1,
    8519,
    4,
    5,
    99,
    102,
    105,
    111,
    115,
    1713,
    1717,
    1722,
    1762,
    1791,
    121,
    59,
    1,
    1060,
    114,
    59,
    3,
    55349,
    56585,
    108,
    108,
    101,
    100,
    4,
    2,
    83,
    86,
    1732,
    1745,
    109,
    97,
    108,
    108,
    83,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9724,
    101,
    114,
    121,
    83,
    109,
    97,
    108,
    108,
    83,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9642,
    4,
    3,
    112,
    114,
    117,
    1770,
    1775,
    1781,
    102,
    59,
    3,
    55349,
    56637,
    65,
    108,
    108,
    59,
    1,
    8704,
    114,
    105,
    101,
    114,
    116,
    114,
    102,
    59,
    1,
    8497,
    99,
    114,
    59,
    1,
    8497,
    4,
    12,
    74,
    84,
    97,
    98,
    99,
    100,
    102,
    103,
    111,
    114,
    115,
    116,
    1822,
    1827,
    1834,
    1848,
    1855,
    1877,
    1882,
    1887,
    1890,
    1896,
    1978,
    1984,
    99,
    121,
    59,
    1,
    1027,
    5,
    62,
    1,
    59,
    1832,
    1,
    62,
    109,
    109,
    97,
    4,
    2,
    59,
    100,
    1843,
    1845,
    1,
    915,
    59,
    1,
    988,
    114,
    101,
    118,
    101,
    59,
    1,
    286,
    4,
    3,
    101,
    105,
    121,
    1863,
    1869,
    1874,
    100,
    105,
    108,
    59,
    1,
    290,
    114,
    99,
    59,
    1,
    284,
    59,
    1,
    1043,
    111,
    116,
    59,
    1,
    288,
    114,
    59,
    3,
    55349,
    56586,
    59,
    1,
    8921,
    112,
    102,
    59,
    3,
    55349,
    56638,
    101,
    97,
    116,
    101,
    114,
    4,
    6,
    69,
    70,
    71,
    76,
    83,
    84,
    1915,
    1933,
    1944,
    1953,
    1959,
    1971,
    113,
    117,
    97,
    108,
    4,
    2,
    59,
    76,
    1925,
    1927,
    1,
    8805,
    101,
    115,
    115,
    59,
    1,
    8923,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8807,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    10914,
    101,
    115,
    115,
    59,
    1,
    8823,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    10878,
    105,
    108,
    100,
    101,
    59,
    1,
    8819,
    99,
    114,
    59,
    3,
    55349,
    56482,
    59,
    1,
    8811,
    4,
    8,
    65,
    97,
    99,
    102,
    105,
    111,
    115,
    117,
    2005,
    2012,
    2026,
    2032,
    2036,
    2049,
    2073,
    2089,
    82,
    68,
    99,
    121,
    59,
    1,
    1066,
    4,
    2,
    99,
    116,
    2018,
    2023,
    101,
    107,
    59,
    1,
    711,
    59,
    1,
    94,
    105,
    114,
    99,
    59,
    1,
    292,
    114,
    59,
    1,
    8460,
    108,
    98,
    101,
    114,
    116,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8459,
    4,
    2,
    112,
    114,
    2055,
    2059,
    102,
    59,
    1,
    8461,
    105,
    122,
    111,
    110,
    116,
    97,
    108,
    76,
    105,
    110,
    101,
    59,
    1,
    9472,
    4,
    2,
    99,
    116,
    2079,
    2083,
    114,
    59,
    1,
    8459,
    114,
    111,
    107,
    59,
    1,
    294,
    109,
    112,
    4,
    2,
    68,
    69,
    2097,
    2107,
    111,
    119,
    110,
    72,
    117,
    109,
    112,
    59,
    1,
    8782,
    113,
    117,
    97,
    108,
    59,
    1,
    8783,
    4,
    14,
    69,
    74,
    79,
    97,
    99,
    100,
    102,
    103,
    109,
    110,
    111,
    115,
    116,
    117,
    2144,
    2149,
    2155,
    2160,
    2171,
    2189,
    2194,
    2198,
    2209,
    2245,
    2307,
    2329,
    2334,
    2341,
    99,
    121,
    59,
    1,
    1045,
    108,
    105,
    103,
    59,
    1,
    306,
    99,
    121,
    59,
    1,
    1025,
    99,
    117,
    116,
    101,
    5,
    205,
    1,
    59,
    2169,
    1,
    205,
    4,
    2,
    105,
    121,
    2177,
    2186,
    114,
    99,
    5,
    206,
    1,
    59,
    2184,
    1,
    206,
    59,
    1,
    1048,
    111,
    116,
    59,
    1,
    304,
    114,
    59,
    1,
    8465,
    114,
    97,
    118,
    101,
    5,
    204,
    1,
    59,
    2207,
    1,
    204,
    4,
    3,
    59,
    97,
    112,
    2217,
    2219,
    2238,
    1,
    8465,
    4,
    2,
    99,
    103,
    2225,
    2229,
    114,
    59,
    1,
    298,
    105,
    110,
    97,
    114,
    121,
    73,
    59,
    1,
    8520,
    108,
    105,
    101,
    115,
    59,
    1,
    8658,
    4,
    2,
    116,
    118,
    2251,
    2281,
    4,
    2,
    59,
    101,
    2257,
    2259,
    1,
    8748,
    4,
    2,
    103,
    114,
    2265,
    2271,
    114,
    97,
    108,
    59,
    1,
    8747,
    115,
    101,
    99,
    116,
    105,
    111,
    110,
    59,
    1,
    8898,
    105,
    115,
    105,
    98,
    108,
    101,
    4,
    2,
    67,
    84,
    2293,
    2300,
    111,
    109,
    109,
    97,
    59,
    1,
    8291,
    105,
    109,
    101,
    115,
    59,
    1,
    8290,
    4,
    3,
    103,
    112,
    116,
    2315,
    2320,
    2325,
    111,
    110,
    59,
    1,
    302,
    102,
    59,
    3,
    55349,
    56640,
    97,
    59,
    1,
    921,
    99,
    114,
    59,
    1,
    8464,
    105,
    108,
    100,
    101,
    59,
    1,
    296,
    4,
    2,
    107,
    109,
    2347,
    2352,
    99,
    121,
    59,
    1,
    1030,
    108,
    5,
    207,
    1,
    59,
    2358,
    1,
    207,
    4,
    5,
    99,
    102,
    111,
    115,
    117,
    2372,
    2386,
    2391,
    2397,
    2414,
    4,
    2,
    105,
    121,
    2378,
    2383,
    114,
    99,
    59,
    1,
    308,
    59,
    1,
    1049,
    114,
    59,
    3,
    55349,
    56589,
    112,
    102,
    59,
    3,
    55349,
    56641,
    4,
    2,
    99,
    101,
    2403,
    2408,
    114,
    59,
    3,
    55349,
    56485,
    114,
    99,
    121,
    59,
    1,
    1032,
    107,
    99,
    121,
    59,
    1,
    1028,
    4,
    7,
    72,
    74,
    97,
    99,
    102,
    111,
    115,
    2436,
    2441,
    2446,
    2452,
    2467,
    2472,
    2478,
    99,
    121,
    59,
    1,
    1061,
    99,
    121,
    59,
    1,
    1036,
    112,
    112,
    97,
    59,
    1,
    922,
    4,
    2,
    101,
    121,
    2458,
    2464,
    100,
    105,
    108,
    59,
    1,
    310,
    59,
    1,
    1050,
    114,
    59,
    3,
    55349,
    56590,
    112,
    102,
    59,
    3,
    55349,
    56642,
    99,
    114,
    59,
    3,
    55349,
    56486,
    4,
    11,
    74,
    84,
    97,
    99,
    101,
    102,
    108,
    109,
    111,
    115,
    116,
    2508,
    2513,
    2520,
    2562,
    2585,
    2981,
    2986,
    3004,
    3011,
    3146,
    3167,
    99,
    121,
    59,
    1,
    1033,
    5,
    60,
    1,
    59,
    2518,
    1,
    60,
    4,
    5,
    99,
    109,
    110,
    112,
    114,
    2532,
    2538,
    2544,
    2548,
    2558,
    117,
    116,
    101,
    59,
    1,
    313,
    98,
    100,
    97,
    59,
    1,
    923,
    103,
    59,
    1,
    10218,
    108,
    97,
    99,
    101,
    116,
    114,
    102,
    59,
    1,
    8466,
    114,
    59,
    1,
    8606,
    4,
    3,
    97,
    101,
    121,
    2570,
    2576,
    2582,
    114,
    111,
    110,
    59,
    1,
    317,
    100,
    105,
    108,
    59,
    1,
    315,
    59,
    1,
    1051,
    4,
    2,
    102,
    115,
    2591,
    2907,
    116,
    4,
    10,
    65,
    67,
    68,
    70,
    82,
    84,
    85,
    86,
    97,
    114,
    2614,
    2663,
    2672,
    2728,
    2735,
    2760,
    2820,
    2870,
    2888,
    2895,
    4,
    2,
    110,
    114,
    2620,
    2633,
    103,
    108,
    101,
    66,
    114,
    97,
    99,
    107,
    101,
    116,
    59,
    1,
    10216,
    114,
    111,
    119,
    4,
    3,
    59,
    66,
    82,
    2644,
    2646,
    2651,
    1,
    8592,
    97,
    114,
    59,
    1,
    8676,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8646,
    101,
    105,
    108,
    105,
    110,
    103,
    59,
    1,
    8968,
    111,
    4,
    2,
    117,
    119,
    2679,
    2692,
    98,
    108,
    101,
    66,
    114,
    97,
    99,
    107,
    101,
    116,
    59,
    1,
    10214,
    110,
    4,
    2,
    84,
    86,
    2699,
    2710,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10593,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    2721,
    2723,
    1,
    8643,
    97,
    114,
    59,
    1,
    10585,
    108,
    111,
    111,
    114,
    59,
    1,
    8970,
    105,
    103,
    104,
    116,
    4,
    2,
    65,
    86,
    2745,
    2752,
    114,
    114,
    111,
    119,
    59,
    1,
    8596,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10574,
    4,
    2,
    101,
    114,
    2766,
    2792,
    101,
    4,
    3,
    59,
    65,
    86,
    2775,
    2777,
    2784,
    1,
    8867,
    114,
    114,
    111,
    119,
    59,
    1,
    8612,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10586,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    3,
    59,
    66,
    69,
    2806,
    2808,
    2813,
    1,
    8882,
    97,
    114,
    59,
    1,
    10703,
    113,
    117,
    97,
    108,
    59,
    1,
    8884,
    112,
    4,
    3,
    68,
    84,
    86,
    2829,
    2841,
    2852,
    111,
    119,
    110,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10577,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10592,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    2863,
    2865,
    1,
    8639,
    97,
    114,
    59,
    1,
    10584,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    2881,
    2883,
    1,
    8636,
    97,
    114,
    59,
    1,
    10578,
    114,
    114,
    111,
    119,
    59,
    1,
    8656,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8660,
    115,
    4,
    6,
    69,
    70,
    71,
    76,
    83,
    84,
    2922,
    2936,
    2947,
    2956,
    2962,
    2974,
    113,
    117,
    97,
    108,
    71,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    8922,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8806,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    8822,
    101,
    115,
    115,
    59,
    1,
    10913,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    10877,
    105,
    108,
    100,
    101,
    59,
    1,
    8818,
    114,
    59,
    3,
    55349,
    56591,
    4,
    2,
    59,
    101,
    2992,
    2994,
    1,
    8920,
    102,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8666,
    105,
    100,
    111,
    116,
    59,
    1,
    319,
    4,
    3,
    110,
    112,
    119,
    3019,
    3110,
    3115,
    103,
    4,
    4,
    76,
    82,
    108,
    114,
    3030,
    3058,
    3070,
    3098,
    101,
    102,
    116,
    4,
    2,
    65,
    82,
    3039,
    3046,
    114,
    114,
    111,
    119,
    59,
    1,
    10229,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    10231,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    10230,
    101,
    102,
    116,
    4,
    2,
    97,
    114,
    3079,
    3086,
    114,
    114,
    111,
    119,
    59,
    1,
    10232,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    10234,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    10233,
    102,
    59,
    3,
    55349,
    56643,
    101,
    114,
    4,
    2,
    76,
    82,
    3123,
    3134,
    101,
    102,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8601,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8600,
    4,
    3,
    99,
    104,
    116,
    3154,
    3158,
    3161,
    114,
    59,
    1,
    8466,
    59,
    1,
    8624,
    114,
    111,
    107,
    59,
    1,
    321,
    59,
    1,
    8810,
    4,
    8,
    97,
    99,
    101,
    102,
    105,
    111,
    115,
    117,
    3188,
    3192,
    3196,
    3222,
    3227,
    3237,
    3243,
    3248,
    112,
    59,
    1,
    10501,
    121,
    59,
    1,
    1052,
    4,
    2,
    100,
    108,
    3202,
    3213,
    105,
    117,
    109,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8287,
    108,
    105,
    110,
    116,
    114,
    102,
    59,
    1,
    8499,
    114,
    59,
    3,
    55349,
    56592,
    110,
    117,
    115,
    80,
    108,
    117,
    115,
    59,
    1,
    8723,
    112,
    102,
    59,
    3,
    55349,
    56644,
    99,
    114,
    59,
    1,
    8499,
    59,
    1,
    924,
    4,
    9,
    74,
    97,
    99,
    101,
    102,
    111,
    115,
    116,
    117,
    3271,
    3276,
    3283,
    3306,
    3422,
    3427,
    4120,
    4126,
    4137,
    99,
    121,
    59,
    1,
    1034,
    99,
    117,
    116,
    101,
    59,
    1,
    323,
    4,
    3,
    97,
    101,
    121,
    3291,
    3297,
    3303,
    114,
    111,
    110,
    59,
    1,
    327,
    100,
    105,
    108,
    59,
    1,
    325,
    59,
    1,
    1053,
    4,
    3,
    103,
    115,
    119,
    3314,
    3380,
    3415,
    97,
    116,
    105,
    118,
    101,
    4,
    3,
    77,
    84,
    86,
    3327,
    3340,
    3365,
    101,
    100,
    105,
    117,
    109,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    104,
    105,
    4,
    2,
    99,
    110,
    3348,
    3357,
    107,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    101,
    114,
    121,
    84,
    104,
    105,
    110,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    116,
    101,
    100,
    4,
    2,
    71,
    76,
    3389,
    3405,
    114,
    101,
    97,
    116,
    101,
    114,
    71,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    8811,
    101,
    115,
    115,
    76,
    101,
    115,
    115,
    59,
    1,
    8810,
    76,
    105,
    110,
    101,
    59,
    1,
    10,
    114,
    59,
    3,
    55349,
    56593,
    4,
    4,
    66,
    110,
    112,
    116,
    3437,
    3444,
    3460,
    3464,
    114,
    101,
    97,
    107,
    59,
    1,
    8288,
    66,
    114,
    101,
    97,
    107,
    105,
    110,
    103,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    160,
    102,
    59,
    1,
    8469,
    4,
    13,
    59,
    67,
    68,
    69,
    71,
    72,
    76,
    78,
    80,
    82,
    83,
    84,
    86,
    3492,
    3494,
    3517,
    3536,
    3578,
    3657,
    3685,
    3784,
    3823,
    3860,
    3915,
    4066,
    4107,
    1,
    10988,
    4,
    2,
    111,
    117,
    3500,
    3510,
    110,
    103,
    114,
    117,
    101,
    110,
    116,
    59,
    1,
    8802,
    112,
    67,
    97,
    112,
    59,
    1,
    8813,
    111,
    117,
    98,
    108,
    101,
    86,
    101,
    114,
    116,
    105,
    99,
    97,
    108,
    66,
    97,
    114,
    59,
    1,
    8742,
    4,
    3,
    108,
    113,
    120,
    3544,
    3552,
    3571,
    101,
    109,
    101,
    110,
    116,
    59,
    1,
    8713,
    117,
    97,
    108,
    4,
    2,
    59,
    84,
    3561,
    3563,
    1,
    8800,
    105,
    108,
    100,
    101,
    59,
    3,
    8770,
    824,
    105,
    115,
    116,
    115,
    59,
    1,
    8708,
    114,
    101,
    97,
    116,
    101,
    114,
    4,
    7,
    59,
    69,
    70,
    71,
    76,
    83,
    84,
    3600,
    3602,
    3609,
    3621,
    3631,
    3637,
    3650,
    1,
    8815,
    113,
    117,
    97,
    108,
    59,
    1,
    8817,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    3,
    8807,
    824,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    3,
    8811,
    824,
    101,
    115,
    115,
    59,
    1,
    8825,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    3,
    10878,
    824,
    105,
    108,
    100,
    101,
    59,
    1,
    8821,
    117,
    109,
    112,
    4,
    2,
    68,
    69,
    3666,
    3677,
    111,
    119,
    110,
    72,
    117,
    109,
    112,
    59,
    3,
    8782,
    824,
    113,
    117,
    97,
    108,
    59,
    3,
    8783,
    824,
    101,
    4,
    2,
    102,
    115,
    3692,
    3724,
    116,
    84,
    114,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    3,
    59,
    66,
    69,
    3709,
    3711,
    3717,
    1,
    8938,
    97,
    114,
    59,
    3,
    10703,
    824,
    113,
    117,
    97,
    108,
    59,
    1,
    8940,
    115,
    4,
    6,
    59,
    69,
    71,
    76,
    83,
    84,
    3739,
    3741,
    3748,
    3757,
    3764,
    3777,
    1,
    8814,
    113,
    117,
    97,
    108,
    59,
    1,
    8816,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    8824,
    101,
    115,
    115,
    59,
    3,
    8810,
    824,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    3,
    10877,
    824,
    105,
    108,
    100,
    101,
    59,
    1,
    8820,
    101,
    115,
    116,
    101,
    100,
    4,
    2,
    71,
    76,
    3795,
    3812,
    114,
    101,
    97,
    116,
    101,
    114,
    71,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    3,
    10914,
    824,
    101,
    115,
    115,
    76,
    101,
    115,
    115,
    59,
    3,
    10913,
    824,
    114,
    101,
    99,
    101,
    100,
    101,
    115,
    4,
    3,
    59,
    69,
    83,
    3838,
    3840,
    3848,
    1,
    8832,
    113,
    117,
    97,
    108,
    59,
    3,
    10927,
    824,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8928,
    4,
    2,
    101,
    105,
    3866,
    3881,
    118,
    101,
    114,
    115,
    101,
    69,
    108,
    101,
    109,
    101,
    110,
    116,
    59,
    1,
    8716,
    103,
    104,
    116,
    84,
    114,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    3,
    59,
    66,
    69,
    3900,
    3902,
    3908,
    1,
    8939,
    97,
    114,
    59,
    3,
    10704,
    824,
    113,
    117,
    97,
    108,
    59,
    1,
    8941,
    4,
    2,
    113,
    117,
    3921,
    3973,
    117,
    97,
    114,
    101,
    83,
    117,
    4,
    2,
    98,
    112,
    3933,
    3952,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    3942,
    3945,
    3,
    8847,
    824,
    113,
    117,
    97,
    108,
    59,
    1,
    8930,
    101,
    114,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    3963,
    3966,
    3,
    8848,
    824,
    113,
    117,
    97,
    108,
    59,
    1,
    8931,
    4,
    3,
    98,
    99,
    112,
    3981,
    4000,
    4045,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    3990,
    3993,
    3,
    8834,
    8402,
    113,
    117,
    97,
    108,
    59,
    1,
    8840,
    99,
    101,
    101,
    100,
    115,
    4,
    4,
    59,
    69,
    83,
    84,
    4015,
    4017,
    4025,
    4037,
    1,
    8833,
    113,
    117,
    97,
    108,
    59,
    3,
    10928,
    824,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8929,
    105,
    108,
    100,
    101,
    59,
    3,
    8831,
    824,
    101,
    114,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    4056,
    4059,
    3,
    8835,
    8402,
    113,
    117,
    97,
    108,
    59,
    1,
    8841,
    105,
    108,
    100,
    101,
    4,
    4,
    59,
    69,
    70,
    84,
    4080,
    4082,
    4089,
    4100,
    1,
    8769,
    113,
    117,
    97,
    108,
    59,
    1,
    8772,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8775,
    105,
    108,
    100,
    101,
    59,
    1,
    8777,
    101,
    114,
    116,
    105,
    99,
    97,
    108,
    66,
    97,
    114,
    59,
    1,
    8740,
    99,
    114,
    59,
    3,
    55349,
    56489,
    105,
    108,
    100,
    101,
    5,
    209,
    1,
    59,
    4135,
    1,
    209,
    59,
    1,
    925,
    4,
    14,
    69,
    97,
    99,
    100,
    102,
    103,
    109,
    111,
    112,
    114,
    115,
    116,
    117,
    118,
    4170,
    4176,
    4187,
    4205,
    4212,
    4217,
    4228,
    4253,
    4259,
    4292,
    4295,
    4316,
    4337,
    4346,
    108,
    105,
    103,
    59,
    1,
    338,
    99,
    117,
    116,
    101,
    5,
    211,
    1,
    59,
    4185,
    1,
    211,
    4,
    2,
    105,
    121,
    4193,
    4202,
    114,
    99,
    5,
    212,
    1,
    59,
    4200,
    1,
    212,
    59,
    1,
    1054,
    98,
    108,
    97,
    99,
    59,
    1,
    336,
    114,
    59,
    3,
    55349,
    56594,
    114,
    97,
    118,
    101,
    5,
    210,
    1,
    59,
    4226,
    1,
    210,
    4,
    3,
    97,
    101,
    105,
    4236,
    4241,
    4246,
    99,
    114,
    59,
    1,
    332,
    103,
    97,
    59,
    1,
    937,
    99,
    114,
    111,
    110,
    59,
    1,
    927,
    112,
    102,
    59,
    3,
    55349,
    56646,
    101,
    110,
    67,
    117,
    114,
    108,
    121,
    4,
    2,
    68,
    81,
    4272,
    4285,
    111,
    117,
    98,
    108,
    101,
    81,
    117,
    111,
    116,
    101,
    59,
    1,
    8220,
    117,
    111,
    116,
    101,
    59,
    1,
    8216,
    59,
    1,
    10836,
    4,
    2,
    99,
    108,
    4301,
    4306,
    114,
    59,
    3,
    55349,
    56490,
    97,
    115,
    104,
    5,
    216,
    1,
    59,
    4314,
    1,
    216,
    105,
    4,
    2,
    108,
    109,
    4323,
    4332,
    100,
    101,
    5,
    213,
    1,
    59,
    4330,
    1,
    213,
    101,
    115,
    59,
    1,
    10807,
    109,
    108,
    5,
    214,
    1,
    59,
    4344,
    1,
    214,
    101,
    114,
    4,
    2,
    66,
    80,
    4354,
    4380,
    4,
    2,
    97,
    114,
    4360,
    4364,
    114,
    59,
    1,
    8254,
    97,
    99,
    4,
    2,
    101,
    107,
    4372,
    4375,
    59,
    1,
    9182,
    101,
    116,
    59,
    1,
    9140,
    97,
    114,
    101,
    110,
    116,
    104,
    101,
    115,
    105,
    115,
    59,
    1,
    9180,
    4,
    9,
    97,
    99,
    102,
    104,
    105,
    108,
    111,
    114,
    115,
    4413,
    4422,
    4426,
    4431,
    4435,
    4438,
    4448,
    4471,
    4561,
    114,
    116,
    105,
    97,
    108,
    68,
    59,
    1,
    8706,
    121,
    59,
    1,
    1055,
    114,
    59,
    3,
    55349,
    56595,
    105,
    59,
    1,
    934,
    59,
    1,
    928,
    117,
    115,
    77,
    105,
    110,
    117,
    115,
    59,
    1,
    177,
    4,
    2,
    105,
    112,
    4454,
    4467,
    110,
    99,
    97,
    114,
    101,
    112,
    108,
    97,
    110,
    101,
    59,
    1,
    8460,
    102,
    59,
    1,
    8473,
    4,
    4,
    59,
    101,
    105,
    111,
    4481,
    4483,
    4526,
    4531,
    1,
    10939,
    99,
    101,
    100,
    101,
    115,
    4,
    4,
    59,
    69,
    83,
    84,
    4498,
    4500,
    4507,
    4519,
    1,
    8826,
    113,
    117,
    97,
    108,
    59,
    1,
    10927,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8828,
    105,
    108,
    100,
    101,
    59,
    1,
    8830,
    109,
    101,
    59,
    1,
    8243,
    4,
    2,
    100,
    112,
    4537,
    4543,
    117,
    99,
    116,
    59,
    1,
    8719,
    111,
    114,
    116,
    105,
    111,
    110,
    4,
    2,
    59,
    97,
    4555,
    4557,
    1,
    8759,
    108,
    59,
    1,
    8733,
    4,
    2,
    99,
    105,
    4567,
    4572,
    114,
    59,
    3,
    55349,
    56491,
    59,
    1,
    936,
    4,
    4,
    85,
    102,
    111,
    115,
    4585,
    4594,
    4599,
    4604,
    79,
    84,
    5,
    34,
    1,
    59,
    4592,
    1,
    34,
    114,
    59,
    3,
    55349,
    56596,
    112,
    102,
    59,
    1,
    8474,
    99,
    114,
    59,
    3,
    55349,
    56492,
    4,
    12,
    66,
    69,
    97,
    99,
    101,
    102,
    104,
    105,
    111,
    114,
    115,
    117,
    4636,
    4642,
    4650,
    4681,
    4704,
    4763,
    4767,
    4771,
    5047,
    5069,
    5081,
    5094,
    97,
    114,
    114,
    59,
    1,
    10512,
    71,
    5,
    174,
    1,
    59,
    4648,
    1,
    174,
    4,
    3,
    99,
    110,
    114,
    4658,
    4664,
    4668,
    117,
    116,
    101,
    59,
    1,
    340,
    103,
    59,
    1,
    10219,
    114,
    4,
    2,
    59,
    116,
    4675,
    4677,
    1,
    8608,
    108,
    59,
    1,
    10518,
    4,
    3,
    97,
    101,
    121,
    4689,
    4695,
    4701,
    114,
    111,
    110,
    59,
    1,
    344,
    100,
    105,
    108,
    59,
    1,
    342,
    59,
    1,
    1056,
    4,
    2,
    59,
    118,
    4710,
    4712,
    1,
    8476,
    101,
    114,
    115,
    101,
    4,
    2,
    69,
    85,
    4722,
    4748,
    4,
    2,
    108,
    113,
    4728,
    4736,
    101,
    109,
    101,
    110,
    116,
    59,
    1,
    8715,
    117,
    105,
    108,
    105,
    98,
    114,
    105,
    117,
    109,
    59,
    1,
    8651,
    112,
    69,
    113,
    117,
    105,
    108,
    105,
    98,
    114,
    105,
    117,
    109,
    59,
    1,
    10607,
    114,
    59,
    1,
    8476,
    111,
    59,
    1,
    929,
    103,
    104,
    116,
    4,
    8,
    65,
    67,
    68,
    70,
    84,
    85,
    86,
    97,
    4792,
    4840,
    4849,
    4905,
    4912,
    4972,
    5022,
    5040,
    4,
    2,
    110,
    114,
    4798,
    4811,
    103,
    108,
    101,
    66,
    114,
    97,
    99,
    107,
    101,
    116,
    59,
    1,
    10217,
    114,
    111,
    119,
    4,
    3,
    59,
    66,
    76,
    4822,
    4824,
    4829,
    1,
    8594,
    97,
    114,
    59,
    1,
    8677,
    101,
    102,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8644,
    101,
    105,
    108,
    105,
    110,
    103,
    59,
    1,
    8969,
    111,
    4,
    2,
    117,
    119,
    4856,
    4869,
    98,
    108,
    101,
    66,
    114,
    97,
    99,
    107,
    101,
    116,
    59,
    1,
    10215,
    110,
    4,
    2,
    84,
    86,
    4876,
    4887,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10589,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    4898,
    4900,
    1,
    8642,
    97,
    114,
    59,
    1,
    10581,
    108,
    111,
    111,
    114,
    59,
    1,
    8971,
    4,
    2,
    101,
    114,
    4918,
    4944,
    101,
    4,
    3,
    59,
    65,
    86,
    4927,
    4929,
    4936,
    1,
    8866,
    114,
    114,
    111,
    119,
    59,
    1,
    8614,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10587,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    3,
    59,
    66,
    69,
    4958,
    4960,
    4965,
    1,
    8883,
    97,
    114,
    59,
    1,
    10704,
    113,
    117,
    97,
    108,
    59,
    1,
    8885,
    112,
    4,
    3,
    68,
    84,
    86,
    4981,
    4993,
    5004,
    111,
    119,
    110,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10575,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10588,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    5015,
    5017,
    1,
    8638,
    97,
    114,
    59,
    1,
    10580,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    5033,
    5035,
    1,
    8640,
    97,
    114,
    59,
    1,
    10579,
    114,
    114,
    111,
    119,
    59,
    1,
    8658,
    4,
    2,
    112,
    117,
    5053,
    5057,
    102,
    59,
    1,
    8477,
    110,
    100,
    73,
    109,
    112,
    108,
    105,
    101,
    115,
    59,
    1,
    10608,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8667,
    4,
    2,
    99,
    104,
    5087,
    5091,
    114,
    59,
    1,
    8475,
    59,
    1,
    8625,
    108,
    101,
    68,
    101,
    108,
    97,
    121,
    101,
    100,
    59,
    1,
    10740,
    4,
    13,
    72,
    79,
    97,
    99,
    102,
    104,
    105,
    109,
    111,
    113,
    115,
    116,
    117,
    5134,
    5150,
    5157,
    5164,
    5198,
    5203,
    5259,
    5265,
    5277,
    5283,
    5374,
    5380,
    5385,
    4,
    2,
    67,
    99,
    5140,
    5146,
    72,
    99,
    121,
    59,
    1,
    1065,
    121,
    59,
    1,
    1064,
    70,
    84,
    99,
    121,
    59,
    1,
    1068,
    99,
    117,
    116,
    101,
    59,
    1,
    346,
    4,
    5,
    59,
    97,
    101,
    105,
    121,
    5176,
    5178,
    5184,
    5190,
    5195,
    1,
    10940,
    114,
    111,
    110,
    59,
    1,
    352,
    100,
    105,
    108,
    59,
    1,
    350,
    114,
    99,
    59,
    1,
    348,
    59,
    1,
    1057,
    114,
    59,
    3,
    55349,
    56598,
    111,
    114,
    116,
    4,
    4,
    68,
    76,
    82,
    85,
    5216,
    5227,
    5238,
    5250,
    111,
    119,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8595,
    101,
    102,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8592,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8594,
    112,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8593,
    103,
    109,
    97,
    59,
    1,
    931,
    97,
    108,
    108,
    67,
    105,
    114,
    99,
    108,
    101,
    59,
    1,
    8728,
    112,
    102,
    59,
    3,
    55349,
    56650,
    4,
    2,
    114,
    117,
    5289,
    5293,
    116,
    59,
    1,
    8730,
    97,
    114,
    101,
    4,
    4,
    59,
    73,
    83,
    85,
    5306,
    5308,
    5322,
    5367,
    1,
    9633,
    110,
    116,
    101,
    114,
    115,
    101,
    99,
    116,
    105,
    111,
    110,
    59,
    1,
    8851,
    117,
    4,
    2,
    98,
    112,
    5329,
    5347,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    5338,
    5340,
    1,
    8847,
    113,
    117,
    97,
    108,
    59,
    1,
    8849,
    101,
    114,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    5358,
    5360,
    1,
    8848,
    113,
    117,
    97,
    108,
    59,
    1,
    8850,
    110,
    105,
    111,
    110,
    59,
    1,
    8852,
    99,
    114,
    59,
    3,
    55349,
    56494,
    97,
    114,
    59,
    1,
    8902,
    4,
    4,
    98,
    99,
    109,
    112,
    5395,
    5420,
    5475,
    5478,
    4,
    2,
    59,
    115,
    5401,
    5403,
    1,
    8912,
    101,
    116,
    4,
    2,
    59,
    69,
    5411,
    5413,
    1,
    8912,
    113,
    117,
    97,
    108,
    59,
    1,
    8838,
    4,
    2,
    99,
    104,
    5426,
    5468,
    101,
    101,
    100,
    115,
    4,
    4,
    59,
    69,
    83,
    84,
    5440,
    5442,
    5449,
    5461,
    1,
    8827,
    113,
    117,
    97,
    108,
    59,
    1,
    10928,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8829,
    105,
    108,
    100,
    101,
    59,
    1,
    8831,
    84,
    104,
    97,
    116,
    59,
    1,
    8715,
    59,
    1,
    8721,
    4,
    3,
    59,
    101,
    115,
    5486,
    5488,
    5507,
    1,
    8913,
    114,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    5498,
    5500,
    1,
    8835,
    113,
    117,
    97,
    108,
    59,
    1,
    8839,
    101,
    116,
    59,
    1,
    8913,
    4,
    11,
    72,
    82,
    83,
    97,
    99,
    102,
    104,
    105,
    111,
    114,
    115,
    5536,
    5546,
    5552,
    5567,
    5579,
    5602,
    5607,
    5655,
    5695,
    5701,
    5711,
    79,
    82,
    78,
    5,
    222,
    1,
    59,
    5544,
    1,
    222,
    65,
    68,
    69,
    59,
    1,
    8482,
    4,
    2,
    72,
    99,
    5558,
    5563,
    99,
    121,
    59,
    1,
    1035,
    121,
    59,
    1,
    1062,
    4,
    2,
    98,
    117,
    5573,
    5576,
    59,
    1,
    9,
    59,
    1,
    932,
    4,
    3,
    97,
    101,
    121,
    5587,
    5593,
    5599,
    114,
    111,
    110,
    59,
    1,
    356,
    100,
    105,
    108,
    59,
    1,
    354,
    59,
    1,
    1058,
    114,
    59,
    3,
    55349,
    56599,
    4,
    2,
    101,
    105,
    5613,
    5631,
    4,
    2,
    114,
    116,
    5619,
    5627,
    101,
    102,
    111,
    114,
    101,
    59,
    1,
    8756,
    97,
    59,
    1,
    920,
    4,
    2,
    99,
    110,
    5637,
    5647,
    107,
    83,
    112,
    97,
    99,
    101,
    59,
    3,
    8287,
    8202,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8201,
    108,
    100,
    101,
    4,
    4,
    59,
    69,
    70,
    84,
    5668,
    5670,
    5677,
    5688,
    1,
    8764,
    113,
    117,
    97,
    108,
    59,
    1,
    8771,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8773,
    105,
    108,
    100,
    101,
    59,
    1,
    8776,
    112,
    102,
    59,
    3,
    55349,
    56651,
    105,
    112,
    108,
    101,
    68,
    111,
    116,
    59,
    1,
    8411,
    4,
    2,
    99,
    116,
    5717,
    5722,
    114,
    59,
    3,
    55349,
    56495,
    114,
    111,
    107,
    59,
    1,
    358,
    4,
    14,
    97,
    98,
    99,
    100,
    102,
    103,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    5758,
    5789,
    5805,
    5823,
    5830,
    5835,
    5846,
    5852,
    5921,
    5937,
    6089,
    6095,
    6101,
    6108,
    4,
    2,
    99,
    114,
    5764,
    5774,
    117,
    116,
    101,
    5,
    218,
    1,
    59,
    5772,
    1,
    218,
    114,
    4,
    2,
    59,
    111,
    5781,
    5783,
    1,
    8607,
    99,
    105,
    114,
    59,
    1,
    10569,
    114,
    4,
    2,
    99,
    101,
    5796,
    5800,
    121,
    59,
    1,
    1038,
    118,
    101,
    59,
    1,
    364,
    4,
    2,
    105,
    121,
    5811,
    5820,
    114,
    99,
    5,
    219,
    1,
    59,
    5818,
    1,
    219,
    59,
    1,
    1059,
    98,
    108,
    97,
    99,
    59,
    1,
    368,
    114,
    59,
    3,
    55349,
    56600,
    114,
    97,
    118,
    101,
    5,
    217,
    1,
    59,
    5844,
    1,
    217,
    97,
    99,
    114,
    59,
    1,
    362,
    4,
    2,
    100,
    105,
    5858,
    5905,
    101,
    114,
    4,
    2,
    66,
    80,
    5866,
    5892,
    4,
    2,
    97,
    114,
    5872,
    5876,
    114,
    59,
    1,
    95,
    97,
    99,
    4,
    2,
    101,
    107,
    5884,
    5887,
    59,
    1,
    9183,
    101,
    116,
    59,
    1,
    9141,
    97,
    114,
    101,
    110,
    116,
    104,
    101,
    115,
    105,
    115,
    59,
    1,
    9181,
    111,
    110,
    4,
    2,
    59,
    80,
    5913,
    5915,
    1,
    8899,
    108,
    117,
    115,
    59,
    1,
    8846,
    4,
    2,
    103,
    112,
    5927,
    5932,
    111,
    110,
    59,
    1,
    370,
    102,
    59,
    3,
    55349,
    56652,
    4,
    8,
    65,
    68,
    69,
    84,
    97,
    100,
    112,
    115,
    5955,
    5985,
    5996,
    6009,
    6026,
    6033,
    6044,
    6075,
    114,
    114,
    111,
    119,
    4,
    3,
    59,
    66,
    68,
    5967,
    5969,
    5974,
    1,
    8593,
    97,
    114,
    59,
    1,
    10514,
    111,
    119,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8645,
    111,
    119,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8597,
    113,
    117,
    105,
    108,
    105,
    98,
    114,
    105,
    117,
    109,
    59,
    1,
    10606,
    101,
    101,
    4,
    2,
    59,
    65,
    6017,
    6019,
    1,
    8869,
    114,
    114,
    111,
    119,
    59,
    1,
    8613,
    114,
    114,
    111,
    119,
    59,
    1,
    8657,
    111,
    119,
    110,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8661,
    101,
    114,
    4,
    2,
    76,
    82,
    6052,
    6063,
    101,
    102,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8598,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8599,
    105,
    4,
    2,
    59,
    108,
    6082,
    6084,
    1,
    978,
    111,
    110,
    59,
    1,
    933,
    105,
    110,
    103,
    59,
    1,
    366,
    99,
    114,
    59,
    3,
    55349,
    56496,
    105,
    108,
    100,
    101,
    59,
    1,
    360,
    109,
    108,
    5,
    220,
    1,
    59,
    6115,
    1,
    220,
    4,
    9,
    68,
    98,
    99,
    100,
    101,
    102,
    111,
    115,
    118,
    6137,
    6143,
    6148,
    6152,
    6166,
    6250,
    6255,
    6261,
    6267,
    97,
    115,
    104,
    59,
    1,
    8875,
    97,
    114,
    59,
    1,
    10987,
    121,
    59,
    1,
    1042,
    97,
    115,
    104,
    4,
    2,
    59,
    108,
    6161,
    6163,
    1,
    8873,
    59,
    1,
    10982,
    4,
    2,
    101,
    114,
    6172,
    6175,
    59,
    1,
    8897,
    4,
    3,
    98,
    116,
    121,
    6183,
    6188,
    6238,
    97,
    114,
    59,
    1,
    8214,
    4,
    2,
    59,
    105,
    6194,
    6196,
    1,
    8214,
    99,
    97,
    108,
    4,
    4,
    66,
    76,
    83,
    84,
    6209,
    6214,
    6220,
    6231,
    97,
    114,
    59,
    1,
    8739,
    105,
    110,
    101,
    59,
    1,
    124,
    101,
    112,
    97,
    114,
    97,
    116,
    111,
    114,
    59,
    1,
    10072,
    105,
    108,
    100,
    101,
    59,
    1,
    8768,
    84,
    104,
    105,
    110,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8202,
    114,
    59,
    3,
    55349,
    56601,
    112,
    102,
    59,
    3,
    55349,
    56653,
    99,
    114,
    59,
    3,
    55349,
    56497,
    100,
    97,
    115,
    104,
    59,
    1,
    8874,
    4,
    5,
    99,
    101,
    102,
    111,
    115,
    6286,
    6292,
    6298,
    6303,
    6309,
    105,
    114,
    99,
    59,
    1,
    372,
    100,
    103,
    101,
    59,
    1,
    8896,
    114,
    59,
    3,
    55349,
    56602,
    112,
    102,
    59,
    3,
    55349,
    56654,
    99,
    114,
    59,
    3,
    55349,
    56498,
    4,
    4,
    102,
    105,
    111,
    115,
    6325,
    6330,
    6333,
    6339,
    114,
    59,
    3,
    55349,
    56603,
    59,
    1,
    926,
    112,
    102,
    59,
    3,
    55349,
    56655,
    99,
    114,
    59,
    3,
    55349,
    56499,
    4,
    9,
    65,
    73,
    85,
    97,
    99,
    102,
    111,
    115,
    117,
    6365,
    6370,
    6375,
    6380,
    6391,
    6405,
    6410,
    6416,
    6422,
    99,
    121,
    59,
    1,
    1071,
    99,
    121,
    59,
    1,
    1031,
    99,
    121,
    59,
    1,
    1070,
    99,
    117,
    116,
    101,
    5,
    221,
    1,
    59,
    6389,
    1,
    221,
    4,
    2,
    105,
    121,
    6397,
    6402,
    114,
    99,
    59,
    1,
    374,
    59,
    1,
    1067,
    114,
    59,
    3,
    55349,
    56604,
    112,
    102,
    59,
    3,
    55349,
    56656,
    99,
    114,
    59,
    3,
    55349,
    56500,
    109,
    108,
    59,
    1,
    376,
    4,
    8,
    72,
    97,
    99,
    100,
    101,
    102,
    111,
    115,
    6445,
    6450,
    6457,
    6472,
    6477,
    6501,
    6505,
    6510,
    99,
    121,
    59,
    1,
    1046,
    99,
    117,
    116,
    101,
    59,
    1,
    377,
    4,
    2,
    97,
    121,
    6463,
    6469,
    114,
    111,
    110,
    59,
    1,
    381,
    59,
    1,
    1047,
    111,
    116,
    59,
    1,
    379,
    4,
    2,
    114,
    116,
    6483,
    6497,
    111,
    87,
    105,
    100,
    116,
    104,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    97,
    59,
    1,
    918,
    114,
    59,
    1,
    8488,
    112,
    102,
    59,
    1,
    8484,
    99,
    114,
    59,
    3,
    55349,
    56501,
    4,
    16,
    97,
    98,
    99,
    101,
    102,
    103,
    108,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    119,
    6550,
    6561,
    6568,
    6612,
    6622,
    6634,
    6645,
    6672,
    6699,
    6854,
    6870,
    6923,
    6933,
    6963,
    6974,
    6983,
    99,
    117,
    116,
    101,
    5,
    225,
    1,
    59,
    6559,
    1,
    225,
    114,
    101,
    118,
    101,
    59,
    1,
    259,
    4,
    6,
    59,
    69,
    100,
    105,
    117,
    121,
    6582,
    6584,
    6588,
    6591,
    6600,
    6609,
    1,
    8766,
    59,
    3,
    8766,
    819,
    59,
    1,
    8767,
    114,
    99,
    5,
    226,
    1,
    59,
    6598,
    1,
    226,
    116,
    101,
    5,
    180,
    1,
    59,
    6607,
    1,
    180,
    59,
    1,
    1072,
    108,
    105,
    103,
    5,
    230,
    1,
    59,
    6620,
    1,
    230,
    4,
    2,
    59,
    114,
    6628,
    6630,
    1,
    8289,
    59,
    3,
    55349,
    56606,
    114,
    97,
    118,
    101,
    5,
    224,
    1,
    59,
    6643,
    1,
    224,
    4,
    2,
    101,
    112,
    6651,
    6667,
    4,
    2,
    102,
    112,
    6657,
    6663,
    115,
    121,
    109,
    59,
    1,
    8501,
    104,
    59,
    1,
    8501,
    104,
    97,
    59,
    1,
    945,
    4,
    2,
    97,
    112,
    6678,
    6692,
    4,
    2,
    99,
    108,
    6684,
    6688,
    114,
    59,
    1,
    257,
    103,
    59,
    1,
    10815,
    5,
    38,
    1,
    59,
    6697,
    1,
    38,
    4,
    2,
    100,
    103,
    6705,
    6737,
    4,
    5,
    59,
    97,
    100,
    115,
    118,
    6717,
    6719,
    6724,
    6727,
    6734,
    1,
    8743,
    110,
    100,
    59,
    1,
    10837,
    59,
    1,
    10844,
    108,
    111,
    112,
    101,
    59,
    1,
    10840,
    59,
    1,
    10842,
    4,
    7,
    59,
    101,
    108,
    109,
    114,
    115,
    122,
    6753,
    6755,
    6758,
    6762,
    6814,
    6835,
    6848,
    1,
    8736,
    59,
    1,
    10660,
    101,
    59,
    1,
    8736,
    115,
    100,
    4,
    2,
    59,
    97,
    6770,
    6772,
    1,
    8737,
    4,
    8,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    6790,
    6793,
    6796,
    6799,
    6802,
    6805,
    6808,
    6811,
    59,
    1,
    10664,
    59,
    1,
    10665,
    59,
    1,
    10666,
    59,
    1,
    10667,
    59,
    1,
    10668,
    59,
    1,
    10669,
    59,
    1,
    10670,
    59,
    1,
    10671,
    116,
    4,
    2,
    59,
    118,
    6821,
    6823,
    1,
    8735,
    98,
    4,
    2,
    59,
    100,
    6830,
    6832,
    1,
    8894,
    59,
    1,
    10653,
    4,
    2,
    112,
    116,
    6841,
    6845,
    104,
    59,
    1,
    8738,
    59,
    1,
    197,
    97,
    114,
    114,
    59,
    1,
    9084,
    4,
    2,
    103,
    112,
    6860,
    6865,
    111,
    110,
    59,
    1,
    261,
    102,
    59,
    3,
    55349,
    56658,
    4,
    7,
    59,
    69,
    97,
    101,
    105,
    111,
    112,
    6886,
    6888,
    6891,
    6897,
    6900,
    6904,
    6908,
    1,
    8776,
    59,
    1,
    10864,
    99,
    105,
    114,
    59,
    1,
    10863,
    59,
    1,
    8778,
    100,
    59,
    1,
    8779,
    115,
    59,
    1,
    39,
    114,
    111,
    120,
    4,
    2,
    59,
    101,
    6917,
    6919,
    1,
    8776,
    113,
    59,
    1,
    8778,
    105,
    110,
    103,
    5,
    229,
    1,
    59,
    6931,
    1,
    229,
    4,
    3,
    99,
    116,
    121,
    6941,
    6946,
    6949,
    114,
    59,
    3,
    55349,
    56502,
    59,
    1,
    42,
    109,
    112,
    4,
    2,
    59,
    101,
    6957,
    6959,
    1,
    8776,
    113,
    59,
    1,
    8781,
    105,
    108,
    100,
    101,
    5,
    227,
    1,
    59,
    6972,
    1,
    227,
    109,
    108,
    5,
    228,
    1,
    59,
    6981,
    1,
    228,
    4,
    2,
    99,
    105,
    6989,
    6997,
    111,
    110,
    105,
    110,
    116,
    59,
    1,
    8755,
    110,
    116,
    59,
    1,
    10769,
    4,
    16,
    78,
    97,
    98,
    99,
    100,
    101,
    102,
    105,
    107,
    108,
    110,
    111,
    112,
    114,
    115,
    117,
    7036,
    7041,
    7119,
    7135,
    7149,
    7155,
    7219,
    7224,
    7347,
    7354,
    7463,
    7489,
    7786,
    7793,
    7814,
    7866,
    111,
    116,
    59,
    1,
    10989,
    4,
    2,
    99,
    114,
    7047,
    7094,
    107,
    4,
    4,
    99,
    101,
    112,
    115,
    7058,
    7064,
    7073,
    7080,
    111,
    110,
    103,
    59,
    1,
    8780,
    112,
    115,
    105,
    108,
    111,
    110,
    59,
    1,
    1014,
    114,
    105,
    109,
    101,
    59,
    1,
    8245,
    105,
    109,
    4,
    2,
    59,
    101,
    7088,
    7090,
    1,
    8765,
    113,
    59,
    1,
    8909,
    4,
    2,
    118,
    119,
    7100,
    7105,
    101,
    101,
    59,
    1,
    8893,
    101,
    100,
    4,
    2,
    59,
    103,
    7113,
    7115,
    1,
    8965,
    101,
    59,
    1,
    8965,
    114,
    107,
    4,
    2,
    59,
    116,
    7127,
    7129,
    1,
    9141,
    98,
    114,
    107,
    59,
    1,
    9142,
    4,
    2,
    111,
    121,
    7141,
    7146,
    110,
    103,
    59,
    1,
    8780,
    59,
    1,
    1073,
    113,
    117,
    111,
    59,
    1,
    8222,
    4,
    5,
    99,
    109,
    112,
    114,
    116,
    7167,
    7181,
    7188,
    7193,
    7199,
    97,
    117,
    115,
    4,
    2,
    59,
    101,
    7176,
    7178,
    1,
    8757,
    59,
    1,
    8757,
    112,
    116,
    121,
    118,
    59,
    1,
    10672,
    115,
    105,
    59,
    1,
    1014,
    110,
    111,
    117,
    59,
    1,
    8492,
    4,
    3,
    97,
    104,
    119,
    7207,
    7210,
    7213,
    59,
    1,
    946,
    59,
    1,
    8502,
    101,
    101,
    110,
    59,
    1,
    8812,
    114,
    59,
    3,
    55349,
    56607,
    103,
    4,
    7,
    99,
    111,
    115,
    116,
    117,
    118,
    119,
    7241,
    7262,
    7288,
    7305,
    7328,
    7335,
    7340,
    4,
    3,
    97,
    105,
    117,
    7249,
    7253,
    7258,
    112,
    59,
    1,
    8898,
    114,
    99,
    59,
    1,
    9711,
    112,
    59,
    1,
    8899,
    4,
    3,
    100,
    112,
    116,
    7270,
    7275,
    7281,
    111,
    116,
    59,
    1,
    10752,
    108,
    117,
    115,
    59,
    1,
    10753,
    105,
    109,
    101,
    115,
    59,
    1,
    10754,
    4,
    2,
    113,
    116,
    7294,
    7300,
    99,
    117,
    112,
    59,
    1,
    10758,
    97,
    114,
    59,
    1,
    9733,
    114,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    2,
    100,
    117,
    7318,
    7324,
    111,
    119,
    110,
    59,
    1,
    9661,
    112,
    59,
    1,
    9651,
    112,
    108,
    117,
    115,
    59,
    1,
    10756,
    101,
    101,
    59,
    1,
    8897,
    101,
    100,
    103,
    101,
    59,
    1,
    8896,
    97,
    114,
    111,
    119,
    59,
    1,
    10509,
    4,
    3,
    97,
    107,
    111,
    7362,
    7436,
    7458,
    4,
    2,
    99,
    110,
    7368,
    7432,
    107,
    4,
    3,
    108,
    115,
    116,
    7377,
    7386,
    7394,
    111,
    122,
    101,
    110,
    103,
    101,
    59,
    1,
    10731,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9642,
    114,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    4,
    59,
    100,
    108,
    114,
    7411,
    7413,
    7419,
    7425,
    1,
    9652,
    111,
    119,
    110,
    59,
    1,
    9662,
    101,
    102,
    116,
    59,
    1,
    9666,
    105,
    103,
    104,
    116,
    59,
    1,
    9656,
    107,
    59,
    1,
    9251,
    4,
    2,
    49,
    51,
    7442,
    7454,
    4,
    2,
    50,
    52,
    7448,
    7451,
    59,
    1,
    9618,
    59,
    1,
    9617,
    52,
    59,
    1,
    9619,
    99,
    107,
    59,
    1,
    9608,
    4,
    2,
    101,
    111,
    7469,
    7485,
    4,
    2,
    59,
    113,
    7475,
    7478,
    3,
    61,
    8421,
    117,
    105,
    118,
    59,
    3,
    8801,
    8421,
    116,
    59,
    1,
    8976,
    4,
    4,
    112,
    116,
    119,
    120,
    7499,
    7504,
    7517,
    7523,
    102,
    59,
    3,
    55349,
    56659,
    4,
    2,
    59,
    116,
    7510,
    7512,
    1,
    8869,
    111,
    109,
    59,
    1,
    8869,
    116,
    105,
    101,
    59,
    1,
    8904,
    4,
    12,
    68,
    72,
    85,
    86,
    98,
    100,
    104,
    109,
    112,
    116,
    117,
    118,
    7549,
    7571,
    7597,
    7619,
    7655,
    7660,
    7682,
    7708,
    7715,
    7721,
    7728,
    7750,
    4,
    4,
    76,
    82,
    108,
    114,
    7559,
    7562,
    7565,
    7568,
    59,
    1,
    9559,
    59,
    1,
    9556,
    59,
    1,
    9558,
    59,
    1,
    9555,
    4,
    5,
    59,
    68,
    85,
    100,
    117,
    7583,
    7585,
    7588,
    7591,
    7594,
    1,
    9552,
    59,
    1,
    9574,
    59,
    1,
    9577,
    59,
    1,
    9572,
    59,
    1,
    9575,
    4,
    4,
    76,
    82,
    108,
    114,
    7607,
    7610,
    7613,
    7616,
    59,
    1,
    9565,
    59,
    1,
    9562,
    59,
    1,
    9564,
    59,
    1,
    9561,
    4,
    7,
    59,
    72,
    76,
    82,
    104,
    108,
    114,
    7635,
    7637,
    7640,
    7643,
    7646,
    7649,
    7652,
    1,
    9553,
    59,
    1,
    9580,
    59,
    1,
    9571,
    59,
    1,
    9568,
    59,
    1,
    9579,
    59,
    1,
    9570,
    59,
    1,
    9567,
    111,
    120,
    59,
    1,
    10697,
    4,
    4,
    76,
    82,
    108,
    114,
    7670,
    7673,
    7676,
    7679,
    59,
    1,
    9557,
    59,
    1,
    9554,
    59,
    1,
    9488,
    59,
    1,
    9484,
    4,
    5,
    59,
    68,
    85,
    100,
    117,
    7694,
    7696,
    7699,
    7702,
    7705,
    1,
    9472,
    59,
    1,
    9573,
    59,
    1,
    9576,
    59,
    1,
    9516,
    59,
    1,
    9524,
    105,
    110,
    117,
    115,
    59,
    1,
    8863,
    108,
    117,
    115,
    59,
    1,
    8862,
    105,
    109,
    101,
    115,
    59,
    1,
    8864,
    4,
    4,
    76,
    82,
    108,
    114,
    7738,
    7741,
    7744,
    7747,
    59,
    1,
    9563,
    59,
    1,
    9560,
    59,
    1,
    9496,
    59,
    1,
    9492,
    4,
    7,
    59,
    72,
    76,
    82,
    104,
    108,
    114,
    7766,
    7768,
    7771,
    7774,
    7777,
    7780,
    7783,
    1,
    9474,
    59,
    1,
    9578,
    59,
    1,
    9569,
    59,
    1,
    9566,
    59,
    1,
    9532,
    59,
    1,
    9508,
    59,
    1,
    9500,
    114,
    105,
    109,
    101,
    59,
    1,
    8245,
    4,
    2,
    101,
    118,
    7799,
    7804,
    118,
    101,
    59,
    1,
    728,
    98,
    97,
    114,
    5,
    166,
    1,
    59,
    7812,
    1,
    166,
    4,
    4,
    99,
    101,
    105,
    111,
    7824,
    7829,
    7834,
    7846,
    114,
    59,
    3,
    55349,
    56503,
    109,
    105,
    59,
    1,
    8271,
    109,
    4,
    2,
    59,
    101,
    7841,
    7843,
    1,
    8765,
    59,
    1,
    8909,
    108,
    4,
    3,
    59,
    98,
    104,
    7855,
    7857,
    7860,
    1,
    92,
    59,
    1,
    10693,
    115,
    117,
    98,
    59,
    1,
    10184,
    4,
    2,
    108,
    109,
    7872,
    7885,
    108,
    4,
    2,
    59,
    101,
    7879,
    7881,
    1,
    8226,
    116,
    59,
    1,
    8226,
    112,
    4,
    3,
    59,
    69,
    101,
    7894,
    7896,
    7899,
    1,
    8782,
    59,
    1,
    10926,
    4,
    2,
    59,
    113,
    7905,
    7907,
    1,
    8783,
    59,
    1,
    8783,
    4,
    15,
    97,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    111,
    114,
    115,
    116,
    117,
    119,
    121,
    7942,
    8021,
    8075,
    8080,
    8121,
    8126,
    8157,
    8279,
    8295,
    8430,
    8446,
    8485,
    8491,
    8707,
    8726,
    4,
    3,
    99,
    112,
    114,
    7950,
    7956,
    8007,
    117,
    116,
    101,
    59,
    1,
    263,
    4,
    6,
    59,
    97,
    98,
    99,
    100,
    115,
    7970,
    7972,
    7977,
    7984,
    7998,
    8003,
    1,
    8745,
    110,
    100,
    59,
    1,
    10820,
    114,
    99,
    117,
    112,
    59,
    1,
    10825,
    4,
    2,
    97,
    117,
    7990,
    7994,
    112,
    59,
    1,
    10827,
    112,
    59,
    1,
    10823,
    111,
    116,
    59,
    1,
    10816,
    59,
    3,
    8745,
    65024,
    4,
    2,
    101,
    111,
    8013,
    8017,
    116,
    59,
    1,
    8257,
    110,
    59,
    1,
    711,
    4,
    4,
    97,
    101,
    105,
    117,
    8031,
    8046,
    8056,
    8061,
    4,
    2,
    112,
    114,
    8037,
    8041,
    115,
    59,
    1,
    10829,
    111,
    110,
    59,
    1,
    269,
    100,
    105,
    108,
    5,
    231,
    1,
    59,
    8054,
    1,
    231,
    114,
    99,
    59,
    1,
    265,
    112,
    115,
    4,
    2,
    59,
    115,
    8069,
    8071,
    1,
    10828,
    109,
    59,
    1,
    10832,
    111,
    116,
    59,
    1,
    267,
    4,
    3,
    100,
    109,
    110,
    8088,
    8097,
    8104,
    105,
    108,
    5,
    184,
    1,
    59,
    8095,
    1,
    184,
    112,
    116,
    121,
    118,
    59,
    1,
    10674,
    116,
    5,
    162,
    2,
    59,
    101,
    8112,
    8114,
    1,
    162,
    114,
    100,
    111,
    116,
    59,
    1,
    183,
    114,
    59,
    3,
    55349,
    56608,
    4,
    3,
    99,
    101,
    105,
    8134,
    8138,
    8154,
    121,
    59,
    1,
    1095,
    99,
    107,
    4,
    2,
    59,
    109,
    8146,
    8148,
    1,
    10003,
    97,
    114,
    107,
    59,
    1,
    10003,
    59,
    1,
    967,
    114,
    4,
    7,
    59,
    69,
    99,
    101,
    102,
    109,
    115,
    8174,
    8176,
    8179,
    8258,
    8261,
    8268,
    8273,
    1,
    9675,
    59,
    1,
    10691,
    4,
    3,
    59,
    101,
    108,
    8187,
    8189,
    8193,
    1,
    710,
    113,
    59,
    1,
    8791,
    101,
    4,
    2,
    97,
    100,
    8200,
    8223,
    114,
    114,
    111,
    119,
    4,
    2,
    108,
    114,
    8210,
    8216,
    101,
    102,
    116,
    59,
    1,
    8634,
    105,
    103,
    104,
    116,
    59,
    1,
    8635,
    4,
    5,
    82,
    83,
    97,
    99,
    100,
    8235,
    8238,
    8241,
    8246,
    8252,
    59,
    1,
    174,
    59,
    1,
    9416,
    115,
    116,
    59,
    1,
    8859,
    105,
    114,
    99,
    59,
    1,
    8858,
    97,
    115,
    104,
    59,
    1,
    8861,
    59,
    1,
    8791,
    110,
    105,
    110,
    116,
    59,
    1,
    10768,
    105,
    100,
    59,
    1,
    10991,
    99,
    105,
    114,
    59,
    1,
    10690,
    117,
    98,
    115,
    4,
    2,
    59,
    117,
    8288,
    8290,
    1,
    9827,
    105,
    116,
    59,
    1,
    9827,
    4,
    4,
    108,
    109,
    110,
    112,
    8305,
    8326,
    8376,
    8400,
    111,
    110,
    4,
    2,
    59,
    101,
    8313,
    8315,
    1,
    58,
    4,
    2,
    59,
    113,
    8321,
    8323,
    1,
    8788,
    59,
    1,
    8788,
    4,
    2,
    109,
    112,
    8332,
    8344,
    97,
    4,
    2,
    59,
    116,
    8339,
    8341,
    1,
    44,
    59,
    1,
    64,
    4,
    3,
    59,
    102,
    108,
    8352,
    8354,
    8358,
    1,
    8705,
    110,
    59,
    1,
    8728,
    101,
    4,
    2,
    109,
    120,
    8365,
    8371,
    101,
    110,
    116,
    59,
    1,
    8705,
    101,
    115,
    59,
    1,
    8450,
    4,
    2,
    103,
    105,
    8382,
    8395,
    4,
    2,
    59,
    100,
    8388,
    8390,
    1,
    8773,
    111,
    116,
    59,
    1,
    10861,
    110,
    116,
    59,
    1,
    8750,
    4,
    3,
    102,
    114,
    121,
    8408,
    8412,
    8417,
    59,
    3,
    55349,
    56660,
    111,
    100,
    59,
    1,
    8720,
    5,
    169,
    2,
    59,
    115,
    8424,
    8426,
    1,
    169,
    114,
    59,
    1,
    8471,
    4,
    2,
    97,
    111,
    8436,
    8441,
    114,
    114,
    59,
    1,
    8629,
    115,
    115,
    59,
    1,
    10007,
    4,
    2,
    99,
    117,
    8452,
    8457,
    114,
    59,
    3,
    55349,
    56504,
    4,
    2,
    98,
    112,
    8463,
    8474,
    4,
    2,
    59,
    101,
    8469,
    8471,
    1,
    10959,
    59,
    1,
    10961,
    4,
    2,
    59,
    101,
    8480,
    8482,
    1,
    10960,
    59,
    1,
    10962,
    100,
    111,
    116,
    59,
    1,
    8943,
    4,
    7,
    100,
    101,
    108,
    112,
    114,
    118,
    119,
    8507,
    8522,
    8536,
    8550,
    8600,
    8697,
    8702,
    97,
    114,
    114,
    4,
    2,
    108,
    114,
    8516,
    8519,
    59,
    1,
    10552,
    59,
    1,
    10549,
    4,
    2,
    112,
    115,
    8528,
    8532,
    114,
    59,
    1,
    8926,
    99,
    59,
    1,
    8927,
    97,
    114,
    114,
    4,
    2,
    59,
    112,
    8545,
    8547,
    1,
    8630,
    59,
    1,
    10557,
    4,
    6,
    59,
    98,
    99,
    100,
    111,
    115,
    8564,
    8566,
    8573,
    8587,
    8592,
    8596,
    1,
    8746,
    114,
    99,
    97,
    112,
    59,
    1,
    10824,
    4,
    2,
    97,
    117,
    8579,
    8583,
    112,
    59,
    1,
    10822,
    112,
    59,
    1,
    10826,
    111,
    116,
    59,
    1,
    8845,
    114,
    59,
    1,
    10821,
    59,
    3,
    8746,
    65024,
    4,
    4,
    97,
    108,
    114,
    118,
    8610,
    8623,
    8663,
    8672,
    114,
    114,
    4,
    2,
    59,
    109,
    8618,
    8620,
    1,
    8631,
    59,
    1,
    10556,
    121,
    4,
    3,
    101,
    118,
    119,
    8632,
    8651,
    8656,
    113,
    4,
    2,
    112,
    115,
    8639,
    8645,
    114,
    101,
    99,
    59,
    1,
    8926,
    117,
    99,
    99,
    59,
    1,
    8927,
    101,
    101,
    59,
    1,
    8910,
    101,
    100,
    103,
    101,
    59,
    1,
    8911,
    101,
    110,
    5,
    164,
    1,
    59,
    8670,
    1,
    164,
    101,
    97,
    114,
    114,
    111,
    119,
    4,
    2,
    108,
    114,
    8684,
    8690,
    101,
    102,
    116,
    59,
    1,
    8630,
    105,
    103,
    104,
    116,
    59,
    1,
    8631,
    101,
    101,
    59,
    1,
    8910,
    101,
    100,
    59,
    1,
    8911,
    4,
    2,
    99,
    105,
    8713,
    8721,
    111,
    110,
    105,
    110,
    116,
    59,
    1,
    8754,
    110,
    116,
    59,
    1,
    8753,
    108,
    99,
    116,
    121,
    59,
    1,
    9005,
    4,
    19,
    65,
    72,
    97,
    98,
    99,
    100,
    101,
    102,
    104,
    105,
    106,
    108,
    111,
    114,
    115,
    116,
    117,
    119,
    122,
    8773,
    8778,
    8783,
    8821,
    8839,
    8854,
    8887,
    8914,
    8930,
    8944,
    9036,
    9041,
    9058,
    9197,
    9227,
    9258,
    9281,
    9297,
    9305,
    114,
    114,
    59,
    1,
    8659,
    97,
    114,
    59,
    1,
    10597,
    4,
    4,
    103,
    108,
    114,
    115,
    8793,
    8799,
    8805,
    8809,
    103,
    101,
    114,
    59,
    1,
    8224,
    101,
    116,
    104,
    59,
    1,
    8504,
    114,
    59,
    1,
    8595,
    104,
    4,
    2,
    59,
    118,
    8816,
    8818,
    1,
    8208,
    59,
    1,
    8867,
    4,
    2,
    107,
    108,
    8827,
    8834,
    97,
    114,
    111,
    119,
    59,
    1,
    10511,
    97,
    99,
    59,
    1,
    733,
    4,
    2,
    97,
    121,
    8845,
    8851,
    114,
    111,
    110,
    59,
    1,
    271,
    59,
    1,
    1076,
    4,
    3,
    59,
    97,
    111,
    8862,
    8864,
    8880,
    1,
    8518,
    4,
    2,
    103,
    114,
    8870,
    8876,
    103,
    101,
    114,
    59,
    1,
    8225,
    114,
    59,
    1,
    8650,
    116,
    115,
    101,
    113,
    59,
    1,
    10871,
    4,
    3,
    103,
    108,
    109,
    8895,
    8902,
    8907,
    5,
    176,
    1,
    59,
    8900,
    1,
    176,
    116,
    97,
    59,
    1,
    948,
    112,
    116,
    121,
    118,
    59,
    1,
    10673,
    4,
    2,
    105,
    114,
    8920,
    8926,
    115,
    104,
    116,
    59,
    1,
    10623,
    59,
    3,
    55349,
    56609,
    97,
    114,
    4,
    2,
    108,
    114,
    8938,
    8941,
    59,
    1,
    8643,
    59,
    1,
    8642,
    4,
    5,
    97,
    101,
    103,
    115,
    118,
    8956,
    8986,
    8989,
    8996,
    9001,
    109,
    4,
    3,
    59,
    111,
    115,
    8965,
    8967,
    8983,
    1,
    8900,
    110,
    100,
    4,
    2,
    59,
    115,
    8975,
    8977,
    1,
    8900,
    117,
    105,
    116,
    59,
    1,
    9830,
    59,
    1,
    9830,
    59,
    1,
    168,
    97,
    109,
    109,
    97,
    59,
    1,
    989,
    105,
    110,
    59,
    1,
    8946,
    4,
    3,
    59,
    105,
    111,
    9009,
    9011,
    9031,
    1,
    247,
    100,
    101,
    5,
    247,
    2,
    59,
    111,
    9020,
    9022,
    1,
    247,
    110,
    116,
    105,
    109,
    101,
    115,
    59,
    1,
    8903,
    110,
    120,
    59,
    1,
    8903,
    99,
    121,
    59,
    1,
    1106,
    99,
    4,
    2,
    111,
    114,
    9048,
    9053,
    114,
    110,
    59,
    1,
    8990,
    111,
    112,
    59,
    1,
    8973,
    4,
    5,
    108,
    112,
    116,
    117,
    119,
    9070,
    9076,
    9081,
    9130,
    9144,
    108,
    97,
    114,
    59,
    1,
    36,
    102,
    59,
    3,
    55349,
    56661,
    4,
    5,
    59,
    101,
    109,
    112,
    115,
    9093,
    9095,
    9109,
    9116,
    9122,
    1,
    729,
    113,
    4,
    2,
    59,
    100,
    9102,
    9104,
    1,
    8784,
    111,
    116,
    59,
    1,
    8785,
    105,
    110,
    117,
    115,
    59,
    1,
    8760,
    108,
    117,
    115,
    59,
    1,
    8724,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    8865,
    98,
    108,
    101,
    98,
    97,
    114,
    119,
    101,
    100,
    103,
    101,
    59,
    1,
    8966,
    110,
    4,
    3,
    97,
    100,
    104,
    9153,
    9160,
    9172,
    114,
    114,
    111,
    119,
    59,
    1,
    8595,
    111,
    119,
    110,
    97,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8650,
    97,
    114,
    112,
    111,
    111,
    110,
    4,
    2,
    108,
    114,
    9184,
    9190,
    101,
    102,
    116,
    59,
    1,
    8643,
    105,
    103,
    104,
    116,
    59,
    1,
    8642,
    4,
    2,
    98,
    99,
    9203,
    9211,
    107,
    97,
    114,
    111,
    119,
    59,
    1,
    10512,
    4,
    2,
    111,
    114,
    9217,
    9222,
    114,
    110,
    59,
    1,
    8991,
    111,
    112,
    59,
    1,
    8972,
    4,
    3,
    99,
    111,
    116,
    9235,
    9248,
    9252,
    4,
    2,
    114,
    121,
    9241,
    9245,
    59,
    3,
    55349,
    56505,
    59,
    1,
    1109,
    108,
    59,
    1,
    10742,
    114,
    111,
    107,
    59,
    1,
    273,
    4,
    2,
    100,
    114,
    9264,
    9269,
    111,
    116,
    59,
    1,
    8945,
    105,
    4,
    2,
    59,
    102,
    9276,
    9278,
    1,
    9663,
    59,
    1,
    9662,
    4,
    2,
    97,
    104,
    9287,
    9292,
    114,
    114,
    59,
    1,
    8693,
    97,
    114,
    59,
    1,
    10607,
    97,
    110,
    103,
    108,
    101,
    59,
    1,
    10662,
    4,
    2,
    99,
    105,
    9311,
    9315,
    121,
    59,
    1,
    1119,
    103,
    114,
    97,
    114,
    114,
    59,
    1,
    10239,
    4,
    18,
    68,
    97,
    99,
    100,
    101,
    102,
    103,
    108,
    109,
    110,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    120,
    9361,
    9376,
    9398,
    9439,
    9444,
    9447,
    9462,
    9495,
    9531,
    9585,
    9598,
    9614,
    9659,
    9755,
    9771,
    9792,
    9808,
    9826,
    4,
    2,
    68,
    111,
    9367,
    9372,
    111,
    116,
    59,
    1,
    10871,
    116,
    59,
    1,
    8785,
    4,
    2,
    99,
    115,
    9382,
    9392,
    117,
    116,
    101,
    5,
    233,
    1,
    59,
    9390,
    1,
    233,
    116,
    101,
    114,
    59,
    1,
    10862,
    4,
    4,
    97,
    105,
    111,
    121,
    9408,
    9414,
    9430,
    9436,
    114,
    111,
    110,
    59,
    1,
    283,
    114,
    4,
    2,
    59,
    99,
    9421,
    9423,
    1,
    8790,
    5,
    234,
    1,
    59,
    9428,
    1,
    234,
    108,
    111,
    110,
    59,
    1,
    8789,
    59,
    1,
    1101,
    111,
    116,
    59,
    1,
    279,
    59,
    1,
    8519,
    4,
    2,
    68,
    114,
    9453,
    9458,
    111,
    116,
    59,
    1,
    8786,
    59,
    3,
    55349,
    56610,
    4,
    3,
    59,
    114,
    115,
    9470,
    9472,
    9482,
    1,
    10906,
    97,
    118,
    101,
    5,
    232,
    1,
    59,
    9480,
    1,
    232,
    4,
    2,
    59,
    100,
    9488,
    9490,
    1,
    10902,
    111,
    116,
    59,
    1,
    10904,
    4,
    4,
    59,
    105,
    108,
    115,
    9505,
    9507,
    9515,
    9518,
    1,
    10905,
    110,
    116,
    101,
    114,
    115,
    59,
    1,
    9191,
    59,
    1,
    8467,
    4,
    2,
    59,
    100,
    9524,
    9526,
    1,
    10901,
    111,
    116,
    59,
    1,
    10903,
    4,
    3,
    97,
    112,
    115,
    9539,
    9544,
    9564,
    99,
    114,
    59,
    1,
    275,
    116,
    121,
    4,
    3,
    59,
    115,
    118,
    9554,
    9556,
    9561,
    1,
    8709,
    101,
    116,
    59,
    1,
    8709,
    59,
    1,
    8709,
    112,
    4,
    2,
    49,
    59,
    9571,
    9583,
    4,
    2,
    51,
    52,
    9577,
    9580,
    59,
    1,
    8196,
    59,
    1,
    8197,
    1,
    8195,
    4,
    2,
    103,
    115,
    9591,
    9594,
    59,
    1,
    331,
    112,
    59,
    1,
    8194,
    4,
    2,
    103,
    112,
    9604,
    9609,
    111,
    110,
    59,
    1,
    281,
    102,
    59,
    3,
    55349,
    56662,
    4,
    3,
    97,
    108,
    115,
    9622,
    9635,
    9640,
    114,
    4,
    2,
    59,
    115,
    9629,
    9631,
    1,
    8917,
    108,
    59,
    1,
    10723,
    117,
    115,
    59,
    1,
    10865,
    105,
    4,
    3,
    59,
    108,
    118,
    9649,
    9651,
    9656,
    1,
    949,
    111,
    110,
    59,
    1,
    949,
    59,
    1,
    1013,
    4,
    4,
    99,
    115,
    117,
    118,
    9669,
    9686,
    9716,
    9747,
    4,
    2,
    105,
    111,
    9675,
    9680,
    114,
    99,
    59,
    1,
    8790,
    108,
    111,
    110,
    59,
    1,
    8789,
    4,
    2,
    105,
    108,
    9692,
    9696,
    109,
    59,
    1,
    8770,
    97,
    110,
    116,
    4,
    2,
    103,
    108,
    9705,
    9710,
    116,
    114,
    59,
    1,
    10902,
    101,
    115,
    115,
    59,
    1,
    10901,
    4,
    3,
    97,
    101,
    105,
    9724,
    9729,
    9734,
    108,
    115,
    59,
    1,
    61,
    115,
    116,
    59,
    1,
    8799,
    118,
    4,
    2,
    59,
    68,
    9741,
    9743,
    1,
    8801,
    68,
    59,
    1,
    10872,
    112,
    97,
    114,
    115,
    108,
    59,
    1,
    10725,
    4,
    2,
    68,
    97,
    9761,
    9766,
    111,
    116,
    59,
    1,
    8787,
    114,
    114,
    59,
    1,
    10609,
    4,
    3,
    99,
    100,
    105,
    9779,
    9783,
    9788,
    114,
    59,
    1,
    8495,
    111,
    116,
    59,
    1,
    8784,
    109,
    59,
    1,
    8770,
    4,
    2,
    97,
    104,
    9798,
    9801,
    59,
    1,
    951,
    5,
    240,
    1,
    59,
    9806,
    1,
    240,
    4,
    2,
    109,
    114,
    9814,
    9822,
    108,
    5,
    235,
    1,
    59,
    9820,
    1,
    235,
    111,
    59,
    1,
    8364,
    4,
    3,
    99,
    105,
    112,
    9834,
    9838,
    9843,
    108,
    59,
    1,
    33,
    115,
    116,
    59,
    1,
    8707,
    4,
    2,
    101,
    111,
    9849,
    9859,
    99,
    116,
    97,
    116,
    105,
    111,
    110,
    59,
    1,
    8496,
    110,
    101,
    110,
    116,
    105,
    97,
    108,
    101,
    59,
    1,
    8519,
    4,
    12,
    97,
    99,
    101,
    102,
    105,
    106,
    108,
    110,
    111,
    112,
    114,
    115,
    9896,
    9910,
    9914,
    9921,
    9954,
    9960,
    9967,
    9989,
    9994,
    10027,
    10036,
    10164,
    108,
    108,
    105,
    110,
    103,
    100,
    111,
    116,
    115,
    101,
    113,
    59,
    1,
    8786,
    121,
    59,
    1,
    1092,
    109,
    97,
    108,
    101,
    59,
    1,
    9792,
    4,
    3,
    105,
    108,
    114,
    9929,
    9935,
    9950,
    108,
    105,
    103,
    59,
    1,
    64259,
    4,
    2,
    105,
    108,
    9941,
    9945,
    103,
    59,
    1,
    64256,
    105,
    103,
    59,
    1,
    64260,
    59,
    3,
    55349,
    56611,
    108,
    105,
    103,
    59,
    1,
    64257,
    108,
    105,
    103,
    59,
    3,
    102,
    106,
    4,
    3,
    97,
    108,
    116,
    9975,
    9979,
    9984,
    116,
    59,
    1,
    9837,
    105,
    103,
    59,
    1,
    64258,
    110,
    115,
    59,
    1,
    9649,
    111,
    102,
    59,
    1,
    402,
    4,
    2,
    112,
    114,
    10000,
    10005,
    102,
    59,
    3,
    55349,
    56663,
    4,
    2,
    97,
    107,
    10011,
    10016,
    108,
    108,
    59,
    1,
    8704,
    4,
    2,
    59,
    118,
    10022,
    10024,
    1,
    8916,
    59,
    1,
    10969,
    97,
    114,
    116,
    105,
    110,
    116,
    59,
    1,
    10765,
    4,
    2,
    97,
    111,
    10042,
    10159,
    4,
    2,
    99,
    115,
    10048,
    10155,
    4,
    6,
    49,
    50,
    51,
    52,
    53,
    55,
    10062,
    10102,
    10114,
    10135,
    10139,
    10151,
    4,
    6,
    50,
    51,
    52,
    53,
    54,
    56,
    10076,
    10083,
    10086,
    10093,
    10096,
    10099,
    5,
    189,
    1,
    59,
    10081,
    1,
    189,
    59,
    1,
    8531,
    5,
    188,
    1,
    59,
    10091,
    1,
    188,
    59,
    1,
    8533,
    59,
    1,
    8537,
    59,
    1,
    8539,
    4,
    2,
    51,
    53,
    10108,
    10111,
    59,
    1,
    8532,
    59,
    1,
    8534,
    4,
    3,
    52,
    53,
    56,
    10122,
    10129,
    10132,
    5,
    190,
    1,
    59,
    10127,
    1,
    190,
    59,
    1,
    8535,
    59,
    1,
    8540,
    53,
    59,
    1,
    8536,
    4,
    2,
    54,
    56,
    10145,
    10148,
    59,
    1,
    8538,
    59,
    1,
    8541,
    56,
    59,
    1,
    8542,
    108,
    59,
    1,
    8260,
    119,
    110,
    59,
    1,
    8994,
    99,
    114,
    59,
    3,
    55349,
    56507,
    4,
    17,
    69,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    105,
    106,
    108,
    110,
    111,
    114,
    115,
    116,
    118,
    10206,
    10217,
    10247,
    10254,
    10268,
    10273,
    10358,
    10363,
    10374,
    10380,
    10385,
    10406,
    10458,
    10464,
    10470,
    10497,
    10610,
    4,
    2,
    59,
    108,
    10212,
    10214,
    1,
    8807,
    59,
    1,
    10892,
    4,
    3,
    99,
    109,
    112,
    10225,
    10231,
    10244,
    117,
    116,
    101,
    59,
    1,
    501,
    109,
    97,
    4,
    2,
    59,
    100,
    10239,
    10241,
    1,
    947,
    59,
    1,
    989,
    59,
    1,
    10886,
    114,
    101,
    118,
    101,
    59,
    1,
    287,
    4,
    2,
    105,
    121,
    10260,
    10265,
    114,
    99,
    59,
    1,
    285,
    59,
    1,
    1075,
    111,
    116,
    59,
    1,
    289,
    4,
    4,
    59,
    108,
    113,
    115,
    10283,
    10285,
    10288,
    10308,
    1,
    8805,
    59,
    1,
    8923,
    4,
    3,
    59,
    113,
    115,
    10296,
    10298,
    10301,
    1,
    8805,
    59,
    1,
    8807,
    108,
    97,
    110,
    116,
    59,
    1,
    10878,
    4,
    4,
    59,
    99,
    100,
    108,
    10318,
    10320,
    10324,
    10345,
    1,
    10878,
    99,
    59,
    1,
    10921,
    111,
    116,
    4,
    2,
    59,
    111,
    10332,
    10334,
    1,
    10880,
    4,
    2,
    59,
    108,
    10340,
    10342,
    1,
    10882,
    59,
    1,
    10884,
    4,
    2,
    59,
    101,
    10351,
    10354,
    3,
    8923,
    65024,
    115,
    59,
    1,
    10900,
    114,
    59,
    3,
    55349,
    56612,
    4,
    2,
    59,
    103,
    10369,
    10371,
    1,
    8811,
    59,
    1,
    8921,
    109,
    101,
    108,
    59,
    1,
    8503,
    99,
    121,
    59,
    1,
    1107,
    4,
    4,
    59,
    69,
    97,
    106,
    10395,
    10397,
    10400,
    10403,
    1,
    8823,
    59,
    1,
    10898,
    59,
    1,
    10917,
    59,
    1,
    10916,
    4,
    4,
    69,
    97,
    101,
    115,
    10416,
    10419,
    10434,
    10453,
    59,
    1,
    8809,
    112,
    4,
    2,
    59,
    112,
    10426,
    10428,
    1,
    10890,
    114,
    111,
    120,
    59,
    1,
    10890,
    4,
    2,
    59,
    113,
    10440,
    10442,
    1,
    10888,
    4,
    2,
    59,
    113,
    10448,
    10450,
    1,
    10888,
    59,
    1,
    8809,
    105,
    109,
    59,
    1,
    8935,
    112,
    102,
    59,
    3,
    55349,
    56664,
    97,
    118,
    101,
    59,
    1,
    96,
    4,
    2,
    99,
    105,
    10476,
    10480,
    114,
    59,
    1,
    8458,
    109,
    4,
    3,
    59,
    101,
    108,
    10489,
    10491,
    10494,
    1,
    8819,
    59,
    1,
    10894,
    59,
    1,
    10896,
    5,
    62,
    6,
    59,
    99,
    100,
    108,
    113,
    114,
    10512,
    10514,
    10527,
    10532,
    10538,
    10545,
    1,
    62,
    4,
    2,
    99,
    105,
    10520,
    10523,
    59,
    1,
    10919,
    114,
    59,
    1,
    10874,
    111,
    116,
    59,
    1,
    8919,
    80,
    97,
    114,
    59,
    1,
    10645,
    117,
    101,
    115,
    116,
    59,
    1,
    10876,
    4,
    5,
    97,
    100,
    101,
    108,
    115,
    10557,
    10574,
    10579,
    10599,
    10605,
    4,
    2,
    112,
    114,
    10563,
    10570,
    112,
    114,
    111,
    120,
    59,
    1,
    10886,
    114,
    59,
    1,
    10616,
    111,
    116,
    59,
    1,
    8919,
    113,
    4,
    2,
    108,
    113,
    10586,
    10592,
    101,
    115,
    115,
    59,
    1,
    8923,
    108,
    101,
    115,
    115,
    59,
    1,
    10892,
    101,
    115,
    115,
    59,
    1,
    8823,
    105,
    109,
    59,
    1,
    8819,
    4,
    2,
    101,
    110,
    10616,
    10626,
    114,
    116,
    110,
    101,
    113,
    113,
    59,
    3,
    8809,
    65024,
    69,
    59,
    3,
    8809,
    65024,
    4,
    10,
    65,
    97,
    98,
    99,
    101,
    102,
    107,
    111,
    115,
    121,
    10653,
    10658,
    10713,
    10718,
    10724,
    10760,
    10765,
    10786,
    10850,
    10875,
    114,
    114,
    59,
    1,
    8660,
    4,
    4,
    105,
    108,
    109,
    114,
    10668,
    10674,
    10678,
    10684,
    114,
    115,
    112,
    59,
    1,
    8202,
    102,
    59,
    1,
    189,
    105,
    108,
    116,
    59,
    1,
    8459,
    4,
    2,
    100,
    114,
    10690,
    10695,
    99,
    121,
    59,
    1,
    1098,
    4,
    3,
    59,
    99,
    119,
    10703,
    10705,
    10710,
    1,
    8596,
    105,
    114,
    59,
    1,
    10568,
    59,
    1,
    8621,
    97,
    114,
    59,
    1,
    8463,
    105,
    114,
    99,
    59,
    1,
    293,
    4,
    3,
    97,
    108,
    114,
    10732,
    10748,
    10754,
    114,
    116,
    115,
    4,
    2,
    59,
    117,
    10741,
    10743,
    1,
    9829,
    105,
    116,
    59,
    1,
    9829,
    108,
    105,
    112,
    59,
    1,
    8230,
    99,
    111,
    110,
    59,
    1,
    8889,
    114,
    59,
    3,
    55349,
    56613,
    115,
    4,
    2,
    101,
    119,
    10772,
    10779,
    97,
    114,
    111,
    119,
    59,
    1,
    10533,
    97,
    114,
    111,
    119,
    59,
    1,
    10534,
    4,
    5,
    97,
    109,
    111,
    112,
    114,
    10798,
    10803,
    10809,
    10839,
    10844,
    114,
    114,
    59,
    1,
    8703,
    116,
    104,
    116,
    59,
    1,
    8763,
    107,
    4,
    2,
    108,
    114,
    10816,
    10827,
    101,
    102,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8617,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8618,
    102,
    59,
    3,
    55349,
    56665,
    98,
    97,
    114,
    59,
    1,
    8213,
    4,
    3,
    99,
    108,
    116,
    10858,
    10863,
    10869,
    114,
    59,
    3,
    55349,
    56509,
    97,
    115,
    104,
    59,
    1,
    8463,
    114,
    111,
    107,
    59,
    1,
    295,
    4,
    2,
    98,
    112,
    10881,
    10887,
    117,
    108,
    108,
    59,
    1,
    8259,
    104,
    101,
    110,
    59,
    1,
    8208,
    4,
    15,
    97,
    99,
    101,
    102,
    103,
    105,
    106,
    109,
    110,
    111,
    112,
    113,
    115,
    116,
    117,
    10925,
    10936,
    10958,
    10977,
    10990,
    11001,
    11039,
    11045,
    11101,
    11192,
    11220,
    11226,
    11237,
    11285,
    11299,
    99,
    117,
    116,
    101,
    5,
    237,
    1,
    59,
    10934,
    1,
    237,
    4,
    3,
    59,
    105,
    121,
    10944,
    10946,
    10955,
    1,
    8291,
    114,
    99,
    5,
    238,
    1,
    59,
    10953,
    1,
    238,
    59,
    1,
    1080,
    4,
    2,
    99,
    120,
    10964,
    10968,
    121,
    59,
    1,
    1077,
    99,
    108,
    5,
    161,
    1,
    59,
    10975,
    1,
    161,
    4,
    2,
    102,
    114,
    10983,
    10986,
    59,
    1,
    8660,
    59,
    3,
    55349,
    56614,
    114,
    97,
    118,
    101,
    5,
    236,
    1,
    59,
    10999,
    1,
    236,
    4,
    4,
    59,
    105,
    110,
    111,
    11011,
    11013,
    11028,
    11034,
    1,
    8520,
    4,
    2,
    105,
    110,
    11019,
    11024,
    110,
    116,
    59,
    1,
    10764,
    116,
    59,
    1,
    8749,
    102,
    105,
    110,
    59,
    1,
    10716,
    116,
    97,
    59,
    1,
    8489,
    108,
    105,
    103,
    59,
    1,
    307,
    4,
    3,
    97,
    111,
    112,
    11053,
    11092,
    11096,
    4,
    3,
    99,
    103,
    116,
    11061,
    11065,
    11088,
    114,
    59,
    1,
    299,
    4,
    3,
    101,
    108,
    112,
    11073,
    11076,
    11082,
    59,
    1,
    8465,
    105,
    110,
    101,
    59,
    1,
    8464,
    97,
    114,
    116,
    59,
    1,
    8465,
    104,
    59,
    1,
    305,
    102,
    59,
    1,
    8887,
    101,
    100,
    59,
    1,
    437,
    4,
    5,
    59,
    99,
    102,
    111,
    116,
    11113,
    11115,
    11121,
    11136,
    11142,
    1,
    8712,
    97,
    114,
    101,
    59,
    1,
    8453,
    105,
    110,
    4,
    2,
    59,
    116,
    11129,
    11131,
    1,
    8734,
    105,
    101,
    59,
    1,
    10717,
    100,
    111,
    116,
    59,
    1,
    305,
    4,
    5,
    59,
    99,
    101,
    108,
    112,
    11154,
    11156,
    11161,
    11179,
    11186,
    1,
    8747,
    97,
    108,
    59,
    1,
    8890,
    4,
    2,
    103,
    114,
    11167,
    11173,
    101,
    114,
    115,
    59,
    1,
    8484,
    99,
    97,
    108,
    59,
    1,
    8890,
    97,
    114,
    104,
    107,
    59,
    1,
    10775,
    114,
    111,
    100,
    59,
    1,
    10812,
    4,
    4,
    99,
    103,
    112,
    116,
    11202,
    11206,
    11211,
    11216,
    121,
    59,
    1,
    1105,
    111,
    110,
    59,
    1,
    303,
    102,
    59,
    3,
    55349,
    56666,
    97,
    59,
    1,
    953,
    114,
    111,
    100,
    59,
    1,
    10812,
    117,
    101,
    115,
    116,
    5,
    191,
    1,
    59,
    11235,
    1,
    191,
    4,
    2,
    99,
    105,
    11243,
    11248,
    114,
    59,
    3,
    55349,
    56510,
    110,
    4,
    5,
    59,
    69,
    100,
    115,
    118,
    11261,
    11263,
    11266,
    11271,
    11282,
    1,
    8712,
    59,
    1,
    8953,
    111,
    116,
    59,
    1,
    8949,
    4,
    2,
    59,
    118,
    11277,
    11279,
    1,
    8948,
    59,
    1,
    8947,
    59,
    1,
    8712,
    4,
    2,
    59,
    105,
    11291,
    11293,
    1,
    8290,
    108,
    100,
    101,
    59,
    1,
    297,
    4,
    2,
    107,
    109,
    11305,
    11310,
    99,
    121,
    59,
    1,
    1110,
    108,
    5,
    239,
    1,
    59,
    11316,
    1,
    239,
    4,
    6,
    99,
    102,
    109,
    111,
    115,
    117,
    11332,
    11346,
    11351,
    11357,
    11363,
    11380,
    4,
    2,
    105,
    121,
    11338,
    11343,
    114,
    99,
    59,
    1,
    309,
    59,
    1,
    1081,
    114,
    59,
    3,
    55349,
    56615,
    97,
    116,
    104,
    59,
    1,
    567,
    112,
    102,
    59,
    3,
    55349,
    56667,
    4,
    2,
    99,
    101,
    11369,
    11374,
    114,
    59,
    3,
    55349,
    56511,
    114,
    99,
    121,
    59,
    1,
    1112,
    107,
    99,
    121,
    59,
    1,
    1108,
    4,
    8,
    97,
    99,
    102,
    103,
    104,
    106,
    111,
    115,
    11404,
    11418,
    11433,
    11438,
    11445,
    11450,
    11455,
    11461,
    112,
    112,
    97,
    4,
    2,
    59,
    118,
    11413,
    11415,
    1,
    954,
    59,
    1,
    1008,
    4,
    2,
    101,
    121,
    11424,
    11430,
    100,
    105,
    108,
    59,
    1,
    311,
    59,
    1,
    1082,
    114,
    59,
    3,
    55349,
    56616,
    114,
    101,
    101,
    110,
    59,
    1,
    312,
    99,
    121,
    59,
    1,
    1093,
    99,
    121,
    59,
    1,
    1116,
    112,
    102,
    59,
    3,
    55349,
    56668,
    99,
    114,
    59,
    3,
    55349,
    56512,
    4,
    23,
    65,
    66,
    69,
    72,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    106,
    108,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    118,
    11515,
    11538,
    11544,
    11555,
    11560,
    11721,
    11780,
    11818,
    11868,
    12136,
    12160,
    12171,
    12203,
    12208,
    12246,
    12275,
    12327,
    12509,
    12523,
    12569,
    12641,
    12732,
    12752,
    4,
    3,
    97,
    114,
    116,
    11523,
    11528,
    11532,
    114,
    114,
    59,
    1,
    8666,
    114,
    59,
    1,
    8656,
    97,
    105,
    108,
    59,
    1,
    10523,
    97,
    114,
    114,
    59,
    1,
    10510,
    4,
    2,
    59,
    103,
    11550,
    11552,
    1,
    8806,
    59,
    1,
    10891,
    97,
    114,
    59,
    1,
    10594,
    4,
    9,
    99,
    101,
    103,
    109,
    110,
    112,
    113,
    114,
    116,
    11580,
    11586,
    11594,
    11600,
    11606,
    11624,
    11627,
    11636,
    11694,
    117,
    116,
    101,
    59,
    1,
    314,
    109,
    112,
    116,
    121,
    118,
    59,
    1,
    10676,
    114,
    97,
    110,
    59,
    1,
    8466,
    98,
    100,
    97,
    59,
    1,
    955,
    103,
    4,
    3,
    59,
    100,
    108,
    11615,
    11617,
    11620,
    1,
    10216,
    59,
    1,
    10641,
    101,
    59,
    1,
    10216,
    59,
    1,
    10885,
    117,
    111,
    5,
    171,
    1,
    59,
    11634,
    1,
    171,
    114,
    4,
    8,
    59,
    98,
    102,
    104,
    108,
    112,
    115,
    116,
    11655,
    11657,
    11669,
    11673,
    11677,
    11681,
    11685,
    11690,
    1,
    8592,
    4,
    2,
    59,
    102,
    11663,
    11665,
    1,
    8676,
    115,
    59,
    1,
    10527,
    115,
    59,
    1,
    10525,
    107,
    59,
    1,
    8617,
    112,
    59,
    1,
    8619,
    108,
    59,
    1,
    10553,
    105,
    109,
    59,
    1,
    10611,
    108,
    59,
    1,
    8610,
    4,
    3,
    59,
    97,
    101,
    11702,
    11704,
    11709,
    1,
    10923,
    105,
    108,
    59,
    1,
    10521,
    4,
    2,
    59,
    115,
    11715,
    11717,
    1,
    10925,
    59,
    3,
    10925,
    65024,
    4,
    3,
    97,
    98,
    114,
    11729,
    11734,
    11739,
    114,
    114,
    59,
    1,
    10508,
    114,
    107,
    59,
    1,
    10098,
    4,
    2,
    97,
    107,
    11745,
    11758,
    99,
    4,
    2,
    101,
    107,
    11752,
    11755,
    59,
    1,
    123,
    59,
    1,
    91,
    4,
    2,
    101,
    115,
    11764,
    11767,
    59,
    1,
    10635,
    108,
    4,
    2,
    100,
    117,
    11774,
    11777,
    59,
    1,
    10639,
    59,
    1,
    10637,
    4,
    4,
    97,
    101,
    117,
    121,
    11790,
    11796,
    11811,
    11815,
    114,
    111,
    110,
    59,
    1,
    318,
    4,
    2,
    100,
    105,
    11802,
    11807,
    105,
    108,
    59,
    1,
    316,
    108,
    59,
    1,
    8968,
    98,
    59,
    1,
    123,
    59,
    1,
    1083,
    4,
    4,
    99,
    113,
    114,
    115,
    11828,
    11832,
    11845,
    11864,
    97,
    59,
    1,
    10550,
    117,
    111,
    4,
    2,
    59,
    114,
    11840,
    11842,
    1,
    8220,
    59,
    1,
    8222,
    4,
    2,
    100,
    117,
    11851,
    11857,
    104,
    97,
    114,
    59,
    1,
    10599,
    115,
    104,
    97,
    114,
    59,
    1,
    10571,
    104,
    59,
    1,
    8626,
    4,
    5,
    59,
    102,
    103,
    113,
    115,
    11880,
    11882,
    12008,
    12011,
    12031,
    1,
    8804,
    116,
    4,
    5,
    97,
    104,
    108,
    114,
    116,
    11895,
    11913,
    11935,
    11947,
    11996,
    114,
    114,
    111,
    119,
    4,
    2,
    59,
    116,
    11905,
    11907,
    1,
    8592,
    97,
    105,
    108,
    59,
    1,
    8610,
    97,
    114,
    112,
    111,
    111,
    110,
    4,
    2,
    100,
    117,
    11925,
    11931,
    111,
    119,
    110,
    59,
    1,
    8637,
    112,
    59,
    1,
    8636,
    101,
    102,
    116,
    97,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8647,
    105,
    103,
    104,
    116,
    4,
    3,
    97,
    104,
    115,
    11959,
    11974,
    11984,
    114,
    114,
    111,
    119,
    4,
    2,
    59,
    115,
    11969,
    11971,
    1,
    8596,
    59,
    1,
    8646,
    97,
    114,
    112,
    111,
    111,
    110,
    115,
    59,
    1,
    8651,
    113,
    117,
    105,
    103,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8621,
    104,
    114,
    101,
    101,
    116,
    105,
    109,
    101,
    115,
    59,
    1,
    8907,
    59,
    1,
    8922,
    4,
    3,
    59,
    113,
    115,
    12019,
    12021,
    12024,
    1,
    8804,
    59,
    1,
    8806,
    108,
    97,
    110,
    116,
    59,
    1,
    10877,
    4,
    5,
    59,
    99,
    100,
    103,
    115,
    12043,
    12045,
    12049,
    12070,
    12083,
    1,
    10877,
    99,
    59,
    1,
    10920,
    111,
    116,
    4,
    2,
    59,
    111,
    12057,
    12059,
    1,
    10879,
    4,
    2,
    59,
    114,
    12065,
    12067,
    1,
    10881,
    59,
    1,
    10883,
    4,
    2,
    59,
    101,
    12076,
    12079,
    3,
    8922,
    65024,
    115,
    59,
    1,
    10899,
    4,
    5,
    97,
    100,
    101,
    103,
    115,
    12095,
    12103,
    12108,
    12126,
    12131,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10885,
    111,
    116,
    59,
    1,
    8918,
    113,
    4,
    2,
    103,
    113,
    12115,
    12120,
    116,
    114,
    59,
    1,
    8922,
    103,
    116,
    114,
    59,
    1,
    10891,
    116,
    114,
    59,
    1,
    8822,
    105,
    109,
    59,
    1,
    8818,
    4,
    3,
    105,
    108,
    114,
    12144,
    12150,
    12156,
    115,
    104,
    116,
    59,
    1,
    10620,
    111,
    111,
    114,
    59,
    1,
    8970,
    59,
    3,
    55349,
    56617,
    4,
    2,
    59,
    69,
    12166,
    12168,
    1,
    8822,
    59,
    1,
    10897,
    4,
    2,
    97,
    98,
    12177,
    12198,
    114,
    4,
    2,
    100,
    117,
    12184,
    12187,
    59,
    1,
    8637,
    4,
    2,
    59,
    108,
    12193,
    12195,
    1,
    8636,
    59,
    1,
    10602,
    108,
    107,
    59,
    1,
    9604,
    99,
    121,
    59,
    1,
    1113,
    4,
    5,
    59,
    97,
    99,
    104,
    116,
    12220,
    12222,
    12227,
    12235,
    12241,
    1,
    8810,
    114,
    114,
    59,
    1,
    8647,
    111,
    114,
    110,
    101,
    114,
    59,
    1,
    8990,
    97,
    114,
    100,
    59,
    1,
    10603,
    114,
    105,
    59,
    1,
    9722,
    4,
    2,
    105,
    111,
    12252,
    12258,
    100,
    111,
    116,
    59,
    1,
    320,
    117,
    115,
    116,
    4,
    2,
    59,
    97,
    12267,
    12269,
    1,
    9136,
    99,
    104,
    101,
    59,
    1,
    9136,
    4,
    4,
    69,
    97,
    101,
    115,
    12285,
    12288,
    12303,
    12322,
    59,
    1,
    8808,
    112,
    4,
    2,
    59,
    112,
    12295,
    12297,
    1,
    10889,
    114,
    111,
    120,
    59,
    1,
    10889,
    4,
    2,
    59,
    113,
    12309,
    12311,
    1,
    10887,
    4,
    2,
    59,
    113,
    12317,
    12319,
    1,
    10887,
    59,
    1,
    8808,
    105,
    109,
    59,
    1,
    8934,
    4,
    8,
    97,
    98,
    110,
    111,
    112,
    116,
    119,
    122,
    12345,
    12359,
    12364,
    12421,
    12446,
    12467,
    12474,
    12490,
    4,
    2,
    110,
    114,
    12351,
    12355,
    103,
    59,
    1,
    10220,
    114,
    59,
    1,
    8701,
    114,
    107,
    59,
    1,
    10214,
    103,
    4,
    3,
    108,
    109,
    114,
    12373,
    12401,
    12409,
    101,
    102,
    116,
    4,
    2,
    97,
    114,
    12382,
    12389,
    114,
    114,
    111,
    119,
    59,
    1,
    10229,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    10231,
    97,
    112,
    115,
    116,
    111,
    59,
    1,
    10236,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    10230,
    112,
    97,
    114,
    114,
    111,
    119,
    4,
    2,
    108,
    114,
    12433,
    12439,
    101,
    102,
    116,
    59,
    1,
    8619,
    105,
    103,
    104,
    116,
    59,
    1,
    8620,
    4,
    3,
    97,
    102,
    108,
    12454,
    12458,
    12462,
    114,
    59,
    1,
    10629,
    59,
    3,
    55349,
    56669,
    117,
    115,
    59,
    1,
    10797,
    105,
    109,
    101,
    115,
    59,
    1,
    10804,
    4,
    2,
    97,
    98,
    12480,
    12485,
    115,
    116,
    59,
    1,
    8727,
    97,
    114,
    59,
    1,
    95,
    4,
    3,
    59,
    101,
    102,
    12498,
    12500,
    12506,
    1,
    9674,
    110,
    103,
    101,
    59,
    1,
    9674,
    59,
    1,
    10731,
    97,
    114,
    4,
    2,
    59,
    108,
    12517,
    12519,
    1,
    40,
    116,
    59,
    1,
    10643,
    4,
    5,
    97,
    99,
    104,
    109,
    116,
    12535,
    12540,
    12548,
    12561,
    12564,
    114,
    114,
    59,
    1,
    8646,
    111,
    114,
    110,
    101,
    114,
    59,
    1,
    8991,
    97,
    114,
    4,
    2,
    59,
    100,
    12556,
    12558,
    1,
    8651,
    59,
    1,
    10605,
    59,
    1,
    8206,
    114,
    105,
    59,
    1,
    8895,
    4,
    6,
    97,
    99,
    104,
    105,
    113,
    116,
    12583,
    12589,
    12594,
    12597,
    12614,
    12635,
    113,
    117,
    111,
    59,
    1,
    8249,
    114,
    59,
    3,
    55349,
    56513,
    59,
    1,
    8624,
    109,
    4,
    3,
    59,
    101,
    103,
    12606,
    12608,
    12611,
    1,
    8818,
    59,
    1,
    10893,
    59,
    1,
    10895,
    4,
    2,
    98,
    117,
    12620,
    12623,
    59,
    1,
    91,
    111,
    4,
    2,
    59,
    114,
    12630,
    12632,
    1,
    8216,
    59,
    1,
    8218,
    114,
    111,
    107,
    59,
    1,
    322,
    5,
    60,
    8,
    59,
    99,
    100,
    104,
    105,
    108,
    113,
    114,
    12660,
    12662,
    12675,
    12680,
    12686,
    12692,
    12698,
    12705,
    1,
    60,
    4,
    2,
    99,
    105,
    12668,
    12671,
    59,
    1,
    10918,
    114,
    59,
    1,
    10873,
    111,
    116,
    59,
    1,
    8918,
    114,
    101,
    101,
    59,
    1,
    8907,
    109,
    101,
    115,
    59,
    1,
    8905,
    97,
    114,
    114,
    59,
    1,
    10614,
    117,
    101,
    115,
    116,
    59,
    1,
    10875,
    4,
    2,
    80,
    105,
    12711,
    12716,
    97,
    114,
    59,
    1,
    10646,
    4,
    3,
    59,
    101,
    102,
    12724,
    12726,
    12729,
    1,
    9667,
    59,
    1,
    8884,
    59,
    1,
    9666,
    114,
    4,
    2,
    100,
    117,
    12739,
    12746,
    115,
    104,
    97,
    114,
    59,
    1,
    10570,
    104,
    97,
    114,
    59,
    1,
    10598,
    4,
    2,
    101,
    110,
    12758,
    12768,
    114,
    116,
    110,
    101,
    113,
    113,
    59,
    3,
    8808,
    65024,
    69,
    59,
    3,
    8808,
    65024,
    4,
    14,
    68,
    97,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    110,
    111,
    112,
    115,
    117,
    12803,
    12809,
    12893,
    12908,
    12914,
    12928,
    12933,
    12937,
    13011,
    13025,
    13032,
    13049,
    13052,
    13069,
    68,
    111,
    116,
    59,
    1,
    8762,
    4,
    4,
    99,
    108,
    112,
    114,
    12819,
    12827,
    12849,
    12887,
    114,
    5,
    175,
    1,
    59,
    12825,
    1,
    175,
    4,
    2,
    101,
    116,
    12833,
    12836,
    59,
    1,
    9794,
    4,
    2,
    59,
    101,
    12842,
    12844,
    1,
    10016,
    115,
    101,
    59,
    1,
    10016,
    4,
    2,
    59,
    115,
    12855,
    12857,
    1,
    8614,
    116,
    111,
    4,
    4,
    59,
    100,
    108,
    117,
    12869,
    12871,
    12877,
    12883,
    1,
    8614,
    111,
    119,
    110,
    59,
    1,
    8615,
    101,
    102,
    116,
    59,
    1,
    8612,
    112,
    59,
    1,
    8613,
    107,
    101,
    114,
    59,
    1,
    9646,
    4,
    2,
    111,
    121,
    12899,
    12905,
    109,
    109,
    97,
    59,
    1,
    10793,
    59,
    1,
    1084,
    97,
    115,
    104,
    59,
    1,
    8212,
    97,
    115,
    117,
    114,
    101,
    100,
    97,
    110,
    103,
    108,
    101,
    59,
    1,
    8737,
    114,
    59,
    3,
    55349,
    56618,
    111,
    59,
    1,
    8487,
    4,
    3,
    99,
    100,
    110,
    12945,
    12954,
    12985,
    114,
    111,
    5,
    181,
    1,
    59,
    12952,
    1,
    181,
    4,
    4,
    59,
    97,
    99,
    100,
    12964,
    12966,
    12971,
    12976,
    1,
    8739,
    115,
    116,
    59,
    1,
    42,
    105,
    114,
    59,
    1,
    10992,
    111,
    116,
    5,
    183,
    1,
    59,
    12983,
    1,
    183,
    117,
    115,
    4,
    3,
    59,
    98,
    100,
    12995,
    12997,
    13000,
    1,
    8722,
    59,
    1,
    8863,
    4,
    2,
    59,
    117,
    13006,
    13008,
    1,
    8760,
    59,
    1,
    10794,
    4,
    2,
    99,
    100,
    13017,
    13021,
    112,
    59,
    1,
    10971,
    114,
    59,
    1,
    8230,
    112,
    108,
    117,
    115,
    59,
    1,
    8723,
    4,
    2,
    100,
    112,
    13038,
    13044,
    101,
    108,
    115,
    59,
    1,
    8871,
    102,
    59,
    3,
    55349,
    56670,
    59,
    1,
    8723,
    4,
    2,
    99,
    116,
    13058,
    13063,
    114,
    59,
    3,
    55349,
    56514,
    112,
    111,
    115,
    59,
    1,
    8766,
    4,
    3,
    59,
    108,
    109,
    13077,
    13079,
    13087,
    1,
    956,
    116,
    105,
    109,
    97,
    112,
    59,
    1,
    8888,
    97,
    112,
    59,
    1,
    8888,
    4,
    24,
    71,
    76,
    82,
    86,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    108,
    109,
    111,
    112,
    114,
    115,
    116,
    117,
    118,
    119,
    13142,
    13165,
    13217,
    13229,
    13247,
    13330,
    13359,
    13414,
    13420,
    13508,
    13513,
    13579,
    13602,
    13626,
    13631,
    13762,
    13767,
    13855,
    13936,
    13995,
    14214,
    14285,
    14312,
    14432,
    4,
    2,
    103,
    116,
    13148,
    13152,
    59,
    3,
    8921,
    824,
    4,
    2,
    59,
    118,
    13158,
    13161,
    3,
    8811,
    8402,
    59,
    3,
    8811,
    824,
    4,
    3,
    101,
    108,
    116,
    13173,
    13200,
    13204,
    102,
    116,
    4,
    2,
    97,
    114,
    13181,
    13188,
    114,
    114,
    111,
    119,
    59,
    1,
    8653,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8654,
    59,
    3,
    8920,
    824,
    4,
    2,
    59,
    118,
    13210,
    13213,
    3,
    8810,
    8402,
    59,
    3,
    8810,
    824,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8655,
    4,
    2,
    68,
    100,
    13235,
    13241,
    97,
    115,
    104,
    59,
    1,
    8879,
    97,
    115,
    104,
    59,
    1,
    8878,
    4,
    5,
    98,
    99,
    110,
    112,
    116,
    13259,
    13264,
    13270,
    13275,
    13308,
    108,
    97,
    59,
    1,
    8711,
    117,
    116,
    101,
    59,
    1,
    324,
    103,
    59,
    3,
    8736,
    8402,
    4,
    5,
    59,
    69,
    105,
    111,
    112,
    13287,
    13289,
    13293,
    13298,
    13302,
    1,
    8777,
    59,
    3,
    10864,
    824,
    100,
    59,
    3,
    8779,
    824,
    115,
    59,
    1,
    329,
    114,
    111,
    120,
    59,
    1,
    8777,
    117,
    114,
    4,
    2,
    59,
    97,
    13316,
    13318,
    1,
    9838,
    108,
    4,
    2,
    59,
    115,
    13325,
    13327,
    1,
    9838,
    59,
    1,
    8469,
    4,
    2,
    115,
    117,
    13336,
    13344,
    112,
    5,
    160,
    1,
    59,
    13342,
    1,
    160,
    109,
    112,
    4,
    2,
    59,
    101,
    13352,
    13355,
    3,
    8782,
    824,
    59,
    3,
    8783,
    824,
    4,
    5,
    97,
    101,
    111,
    117,
    121,
    13371,
    13385,
    13391,
    13407,
    13411,
    4,
    2,
    112,
    114,
    13377,
    13380,
    59,
    1,
    10819,
    111,
    110,
    59,
    1,
    328,
    100,
    105,
    108,
    59,
    1,
    326,
    110,
    103,
    4,
    2,
    59,
    100,
    13399,
    13401,
    1,
    8775,
    111,
    116,
    59,
    3,
    10861,
    824,
    112,
    59,
    1,
    10818,
    59,
    1,
    1085,
    97,
    115,
    104,
    59,
    1,
    8211,
    4,
    7,
    59,
    65,
    97,
    100,
    113,
    115,
    120,
    13436,
    13438,
    13443,
    13466,
    13472,
    13478,
    13494,
    1,
    8800,
    114,
    114,
    59,
    1,
    8663,
    114,
    4,
    2,
    104,
    114,
    13450,
    13454,
    107,
    59,
    1,
    10532,
    4,
    2,
    59,
    111,
    13460,
    13462,
    1,
    8599,
    119,
    59,
    1,
    8599,
    111,
    116,
    59,
    3,
    8784,
    824,
    117,
    105,
    118,
    59,
    1,
    8802,
    4,
    2,
    101,
    105,
    13484,
    13489,
    97,
    114,
    59,
    1,
    10536,
    109,
    59,
    3,
    8770,
    824,
    105,
    115,
    116,
    4,
    2,
    59,
    115,
    13503,
    13505,
    1,
    8708,
    59,
    1,
    8708,
    114,
    59,
    3,
    55349,
    56619,
    4,
    4,
    69,
    101,
    115,
    116,
    13523,
    13527,
    13563,
    13568,
    59,
    3,
    8807,
    824,
    4,
    3,
    59,
    113,
    115,
    13535,
    13537,
    13559,
    1,
    8817,
    4,
    3,
    59,
    113,
    115,
    13545,
    13547,
    13551,
    1,
    8817,
    59,
    3,
    8807,
    824,
    108,
    97,
    110,
    116,
    59,
    3,
    10878,
    824,
    59,
    3,
    10878,
    824,
    105,
    109,
    59,
    1,
    8821,
    4,
    2,
    59,
    114,
    13574,
    13576,
    1,
    8815,
    59,
    1,
    8815,
    4,
    3,
    65,
    97,
    112,
    13587,
    13592,
    13597,
    114,
    114,
    59,
    1,
    8654,
    114,
    114,
    59,
    1,
    8622,
    97,
    114,
    59,
    1,
    10994,
    4,
    3,
    59,
    115,
    118,
    13610,
    13612,
    13623,
    1,
    8715,
    4,
    2,
    59,
    100,
    13618,
    13620,
    1,
    8956,
    59,
    1,
    8954,
    59,
    1,
    8715,
    99,
    121,
    59,
    1,
    1114,
    4,
    7,
    65,
    69,
    97,
    100,
    101,
    115,
    116,
    13647,
    13652,
    13656,
    13661,
    13665,
    13737,
    13742,
    114,
    114,
    59,
    1,
    8653,
    59,
    3,
    8806,
    824,
    114,
    114,
    59,
    1,
    8602,
    114,
    59,
    1,
    8229,
    4,
    4,
    59,
    102,
    113,
    115,
    13675,
    13677,
    13703,
    13725,
    1,
    8816,
    116,
    4,
    2,
    97,
    114,
    13684,
    13691,
    114,
    114,
    111,
    119,
    59,
    1,
    8602,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8622,
    4,
    3,
    59,
    113,
    115,
    13711,
    13713,
    13717,
    1,
    8816,
    59,
    3,
    8806,
    824,
    108,
    97,
    110,
    116,
    59,
    3,
    10877,
    824,
    4,
    2,
    59,
    115,
    13731,
    13734,
    3,
    10877,
    824,
    59,
    1,
    8814,
    105,
    109,
    59,
    1,
    8820,
    4,
    2,
    59,
    114,
    13748,
    13750,
    1,
    8814,
    105,
    4,
    2,
    59,
    101,
    13757,
    13759,
    1,
    8938,
    59,
    1,
    8940,
    105,
    100,
    59,
    1,
    8740,
    4,
    2,
    112,
    116,
    13773,
    13778,
    102,
    59,
    3,
    55349,
    56671,
    5,
    172,
    3,
    59,
    105,
    110,
    13787,
    13789,
    13829,
    1,
    172,
    110,
    4,
    4,
    59,
    69,
    100,
    118,
    13800,
    13802,
    13806,
    13812,
    1,
    8713,
    59,
    3,
    8953,
    824,
    111,
    116,
    59,
    3,
    8949,
    824,
    4,
    3,
    97,
    98,
    99,
    13820,
    13823,
    13826,
    59,
    1,
    8713,
    59,
    1,
    8951,
    59,
    1,
    8950,
    105,
    4,
    2,
    59,
    118,
    13836,
    13838,
    1,
    8716,
    4,
    3,
    97,
    98,
    99,
    13846,
    13849,
    13852,
    59,
    1,
    8716,
    59,
    1,
    8958,
    59,
    1,
    8957,
    4,
    3,
    97,
    111,
    114,
    13863,
    13892,
    13899,
    114,
    4,
    4,
    59,
    97,
    115,
    116,
    13874,
    13876,
    13883,
    13888,
    1,
    8742,
    108,
    108,
    101,
    108,
    59,
    1,
    8742,
    108,
    59,
    3,
    11005,
    8421,
    59,
    3,
    8706,
    824,
    108,
    105,
    110,
    116,
    59,
    1,
    10772,
    4,
    3,
    59,
    99,
    101,
    13907,
    13909,
    13914,
    1,
    8832,
    117,
    101,
    59,
    1,
    8928,
    4,
    2,
    59,
    99,
    13920,
    13923,
    3,
    10927,
    824,
    4,
    2,
    59,
    101,
    13929,
    13931,
    1,
    8832,
    113,
    59,
    3,
    10927,
    824,
    4,
    4,
    65,
    97,
    105,
    116,
    13946,
    13951,
    13971,
    13982,
    114,
    114,
    59,
    1,
    8655,
    114,
    114,
    4,
    3,
    59,
    99,
    119,
    13961,
    13963,
    13967,
    1,
    8603,
    59,
    3,
    10547,
    824,
    59,
    3,
    8605,
    824,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8603,
    114,
    105,
    4,
    2,
    59,
    101,
    13990,
    13992,
    1,
    8939,
    59,
    1,
    8941,
    4,
    7,
    99,
    104,
    105,
    109,
    112,
    113,
    117,
    14011,
    14036,
    14060,
    14080,
    14085,
    14090,
    14106,
    4,
    4,
    59,
    99,
    101,
    114,
    14021,
    14023,
    14028,
    14032,
    1,
    8833,
    117,
    101,
    59,
    1,
    8929,
    59,
    3,
    10928,
    824,
    59,
    3,
    55349,
    56515,
    111,
    114,
    116,
    4,
    2,
    109,
    112,
    14045,
    14050,
    105,
    100,
    59,
    1,
    8740,
    97,
    114,
    97,
    108,
    108,
    101,
    108,
    59,
    1,
    8742,
    109,
    4,
    2,
    59,
    101,
    14067,
    14069,
    1,
    8769,
    4,
    2,
    59,
    113,
    14075,
    14077,
    1,
    8772,
    59,
    1,
    8772,
    105,
    100,
    59,
    1,
    8740,
    97,
    114,
    59,
    1,
    8742,
    115,
    117,
    4,
    2,
    98,
    112,
    14098,
    14102,
    101,
    59,
    1,
    8930,
    101,
    59,
    1,
    8931,
    4,
    3,
    98,
    99,
    112,
    14114,
    14157,
    14171,
    4,
    4,
    59,
    69,
    101,
    115,
    14124,
    14126,
    14130,
    14133,
    1,
    8836,
    59,
    3,
    10949,
    824,
    59,
    1,
    8840,
    101,
    116,
    4,
    2,
    59,
    101,
    14141,
    14144,
    3,
    8834,
    8402,
    113,
    4,
    2,
    59,
    113,
    14151,
    14153,
    1,
    8840,
    59,
    3,
    10949,
    824,
    99,
    4,
    2,
    59,
    101,
    14164,
    14166,
    1,
    8833,
    113,
    59,
    3,
    10928,
    824,
    4,
    4,
    59,
    69,
    101,
    115,
    14181,
    14183,
    14187,
    14190,
    1,
    8837,
    59,
    3,
    10950,
    824,
    59,
    1,
    8841,
    101,
    116,
    4,
    2,
    59,
    101,
    14198,
    14201,
    3,
    8835,
    8402,
    113,
    4,
    2,
    59,
    113,
    14208,
    14210,
    1,
    8841,
    59,
    3,
    10950,
    824,
    4,
    4,
    103,
    105,
    108,
    114,
    14224,
    14228,
    14238,
    14242,
    108,
    59,
    1,
    8825,
    108,
    100,
    101,
    5,
    241,
    1,
    59,
    14236,
    1,
    241,
    103,
    59,
    1,
    8824,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    2,
    108,
    114,
    14254,
    14269,
    101,
    102,
    116,
    4,
    2,
    59,
    101,
    14263,
    14265,
    1,
    8938,
    113,
    59,
    1,
    8940,
    105,
    103,
    104,
    116,
    4,
    2,
    59,
    101,
    14279,
    14281,
    1,
    8939,
    113,
    59,
    1,
    8941,
    4,
    2,
    59,
    109,
    14291,
    14293,
    1,
    957,
    4,
    3,
    59,
    101,
    115,
    14301,
    14303,
    14308,
    1,
    35,
    114,
    111,
    59,
    1,
    8470,
    112,
    59,
    1,
    8199,
    4,
    9,
    68,
    72,
    97,
    100,
    103,
    105,
    108,
    114,
    115,
    14332,
    14338,
    14344,
    14349,
    14355,
    14369,
    14376,
    14408,
    14426,
    97,
    115,
    104,
    59,
    1,
    8877,
    97,
    114,
    114,
    59,
    1,
    10500,
    112,
    59,
    3,
    8781,
    8402,
    97,
    115,
    104,
    59,
    1,
    8876,
    4,
    2,
    101,
    116,
    14361,
    14365,
    59,
    3,
    8805,
    8402,
    59,
    3,
    62,
    8402,
    110,
    102,
    105,
    110,
    59,
    1,
    10718,
    4,
    3,
    65,
    101,
    116,
    14384,
    14389,
    14393,
    114,
    114,
    59,
    1,
    10498,
    59,
    3,
    8804,
    8402,
    4,
    2,
    59,
    114,
    14399,
    14402,
    3,
    60,
    8402,
    105,
    101,
    59,
    3,
    8884,
    8402,
    4,
    2,
    65,
    116,
    14414,
    14419,
    114,
    114,
    59,
    1,
    10499,
    114,
    105,
    101,
    59,
    3,
    8885,
    8402,
    105,
    109,
    59,
    3,
    8764,
    8402,
    4,
    3,
    65,
    97,
    110,
    14440,
    14445,
    14468,
    114,
    114,
    59,
    1,
    8662,
    114,
    4,
    2,
    104,
    114,
    14452,
    14456,
    107,
    59,
    1,
    10531,
    4,
    2,
    59,
    111,
    14462,
    14464,
    1,
    8598,
    119,
    59,
    1,
    8598,
    101,
    97,
    114,
    59,
    1,
    10535,
    4,
    18,
    83,
    97,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    108,
    109,
    111,
    112,
    114,
    115,
    116,
    117,
    118,
    14512,
    14515,
    14535,
    14560,
    14597,
    14603,
    14618,
    14643,
    14657,
    14662,
    14701,
    14741,
    14747,
    14769,
    14851,
    14877,
    14907,
    14916,
    59,
    1,
    9416,
    4,
    2,
    99,
    115,
    14521,
    14531,
    117,
    116,
    101,
    5,
    243,
    1,
    59,
    14529,
    1,
    243,
    116,
    59,
    1,
    8859,
    4,
    2,
    105,
    121,
    14541,
    14557,
    114,
    4,
    2,
    59,
    99,
    14548,
    14550,
    1,
    8858,
    5,
    244,
    1,
    59,
    14555,
    1,
    244,
    59,
    1,
    1086,
    4,
    5,
    97,
    98,
    105,
    111,
    115,
    14572,
    14577,
    14583,
    14587,
    14591,
    115,
    104,
    59,
    1,
    8861,
    108,
    97,
    99,
    59,
    1,
    337,
    118,
    59,
    1,
    10808,
    116,
    59,
    1,
    8857,
    111,
    108,
    100,
    59,
    1,
    10684,
    108,
    105,
    103,
    59,
    1,
    339,
    4,
    2,
    99,
    114,
    14609,
    14614,
    105,
    114,
    59,
    1,
    10687,
    59,
    3,
    55349,
    56620,
    4,
    3,
    111,
    114,
    116,
    14626,
    14630,
    14640,
    110,
    59,
    1,
    731,
    97,
    118,
    101,
    5,
    242,
    1,
    59,
    14638,
    1,
    242,
    59,
    1,
    10689,
    4,
    2,
    98,
    109,
    14649,
    14654,
    97,
    114,
    59,
    1,
    10677,
    59,
    1,
    937,
    110,
    116,
    59,
    1,
    8750,
    4,
    4,
    97,
    99,
    105,
    116,
    14672,
    14677,
    14693,
    14698,
    114,
    114,
    59,
    1,
    8634,
    4,
    2,
    105,
    114,
    14683,
    14687,
    114,
    59,
    1,
    10686,
    111,
    115,
    115,
    59,
    1,
    10683,
    110,
    101,
    59,
    1,
    8254,
    59,
    1,
    10688,
    4,
    3,
    97,
    101,
    105,
    14709,
    14714,
    14719,
    99,
    114,
    59,
    1,
    333,
    103,
    97,
    59,
    1,
    969,
    4,
    3,
    99,
    100,
    110,
    14727,
    14733,
    14736,
    114,
    111,
    110,
    59,
    1,
    959,
    59,
    1,
    10678,
    117,
    115,
    59,
    1,
    8854,
    112,
    102,
    59,
    3,
    55349,
    56672,
    4,
    3,
    97,
    101,
    108,
    14755,
    14759,
    14764,
    114,
    59,
    1,
    10679,
    114,
    112,
    59,
    1,
    10681,
    117,
    115,
    59,
    1,
    8853,
    4,
    7,
    59,
    97,
    100,
    105,
    111,
    115,
    118,
    14785,
    14787,
    14792,
    14831,
    14837,
    14841,
    14848,
    1,
    8744,
    114,
    114,
    59,
    1,
    8635,
    4,
    4,
    59,
    101,
    102,
    109,
    14802,
    14804,
    14817,
    14824,
    1,
    10845,
    114,
    4,
    2,
    59,
    111,
    14811,
    14813,
    1,
    8500,
    102,
    59,
    1,
    8500,
    5,
    170,
    1,
    59,
    14822,
    1,
    170,
    5,
    186,
    1,
    59,
    14829,
    1,
    186,
    103,
    111,
    102,
    59,
    1,
    8886,
    114,
    59,
    1,
    10838,
    108,
    111,
    112,
    101,
    59,
    1,
    10839,
    59,
    1,
    10843,
    4,
    3,
    99,
    108,
    111,
    14859,
    14863,
    14873,
    114,
    59,
    1,
    8500,
    97,
    115,
    104,
    5,
    248,
    1,
    59,
    14871,
    1,
    248,
    108,
    59,
    1,
    8856,
    105,
    4,
    2,
    108,
    109,
    14884,
    14893,
    100,
    101,
    5,
    245,
    1,
    59,
    14891,
    1,
    245,
    101,
    115,
    4,
    2,
    59,
    97,
    14901,
    14903,
    1,
    8855,
    115,
    59,
    1,
    10806,
    109,
    108,
    5,
    246,
    1,
    59,
    14914,
    1,
    246,
    98,
    97,
    114,
    59,
    1,
    9021,
    4,
    12,
    97,
    99,
    101,
    102,
    104,
    105,
    108,
    109,
    111,
    114,
    115,
    117,
    14948,
    14992,
    14996,
    15033,
    15038,
    15068,
    15090,
    15189,
    15192,
    15222,
    15427,
    15441,
    114,
    4,
    4,
    59,
    97,
    115,
    116,
    14959,
    14961,
    14976,
    14989,
    1,
    8741,
    5,
    182,
    2,
    59,
    108,
    14968,
    14970,
    1,
    182,
    108,
    101,
    108,
    59,
    1,
    8741,
    4,
    2,
    105,
    108,
    14982,
    14986,
    109,
    59,
    1,
    10995,
    59,
    1,
    11005,
    59,
    1,
    8706,
    121,
    59,
    1,
    1087,
    114,
    4,
    5,
    99,
    105,
    109,
    112,
    116,
    15009,
    15014,
    15019,
    15024,
    15027,
    110,
    116,
    59,
    1,
    37,
    111,
    100,
    59,
    1,
    46,
    105,
    108,
    59,
    1,
    8240,
    59,
    1,
    8869,
    101,
    110,
    107,
    59,
    1,
    8241,
    114,
    59,
    3,
    55349,
    56621,
    4,
    3,
    105,
    109,
    111,
    15046,
    15057,
    15063,
    4,
    2,
    59,
    118,
    15052,
    15054,
    1,
    966,
    59,
    1,
    981,
    109,
    97,
    116,
    59,
    1,
    8499,
    110,
    101,
    59,
    1,
    9742,
    4,
    3,
    59,
    116,
    118,
    15076,
    15078,
    15087,
    1,
    960,
    99,
    104,
    102,
    111,
    114,
    107,
    59,
    1,
    8916,
    59,
    1,
    982,
    4,
    2,
    97,
    117,
    15096,
    15119,
    110,
    4,
    2,
    99,
    107,
    15103,
    15115,
    107,
    4,
    2,
    59,
    104,
    15110,
    15112,
    1,
    8463,
    59,
    1,
    8462,
    118,
    59,
    1,
    8463,
    115,
    4,
    9,
    59,
    97,
    98,
    99,
    100,
    101,
    109,
    115,
    116,
    15140,
    15142,
    15148,
    15151,
    15156,
    15168,
    15171,
    15179,
    15184,
    1,
    43,
    99,
    105,
    114,
    59,
    1,
    10787,
    59,
    1,
    8862,
    105,
    114,
    59,
    1,
    10786,
    4,
    2,
    111,
    117,
    15162,
    15165,
    59,
    1,
    8724,
    59,
    1,
    10789,
    59,
    1,
    10866,
    110,
    5,
    177,
    1,
    59,
    15177,
    1,
    177,
    105,
    109,
    59,
    1,
    10790,
    119,
    111,
    59,
    1,
    10791,
    59,
    1,
    177,
    4,
    3,
    105,
    112,
    117,
    15200,
    15208,
    15213,
    110,
    116,
    105,
    110,
    116,
    59,
    1,
    10773,
    102,
    59,
    3,
    55349,
    56673,
    110,
    100,
    5,
    163,
    1,
    59,
    15220,
    1,
    163,
    4,
    10,
    59,
    69,
    97,
    99,
    101,
    105,
    110,
    111,
    115,
    117,
    15244,
    15246,
    15249,
    15253,
    15258,
    15334,
    15347,
    15367,
    15416,
    15421,
    1,
    8826,
    59,
    1,
    10931,
    112,
    59,
    1,
    10935,
    117,
    101,
    59,
    1,
    8828,
    4,
    2,
    59,
    99,
    15264,
    15266,
    1,
    10927,
    4,
    6,
    59,
    97,
    99,
    101,
    110,
    115,
    15280,
    15282,
    15290,
    15299,
    15303,
    15329,
    1,
    8826,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10935,
    117,
    114,
    108,
    121,
    101,
    113,
    59,
    1,
    8828,
    113,
    59,
    1,
    10927,
    4,
    3,
    97,
    101,
    115,
    15311,
    15319,
    15324,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10937,
    113,
    113,
    59,
    1,
    10933,
    105,
    109,
    59,
    1,
    8936,
    105,
    109,
    59,
    1,
    8830,
    109,
    101,
    4,
    2,
    59,
    115,
    15342,
    15344,
    1,
    8242,
    59,
    1,
    8473,
    4,
    3,
    69,
    97,
    115,
    15355,
    15358,
    15362,
    59,
    1,
    10933,
    112,
    59,
    1,
    10937,
    105,
    109,
    59,
    1,
    8936,
    4,
    3,
    100,
    102,
    112,
    15375,
    15378,
    15404,
    59,
    1,
    8719,
    4,
    3,
    97,
    108,
    115,
    15386,
    15392,
    15398,
    108,
    97,
    114,
    59,
    1,
    9006,
    105,
    110,
    101,
    59,
    1,
    8978,
    117,
    114,
    102,
    59,
    1,
    8979,
    4,
    2,
    59,
    116,
    15410,
    15412,
    1,
    8733,
    111,
    59,
    1,
    8733,
    105,
    109,
    59,
    1,
    8830,
    114,
    101,
    108,
    59,
    1,
    8880,
    4,
    2,
    99,
    105,
    15433,
    15438,
    114,
    59,
    3,
    55349,
    56517,
    59,
    1,
    968,
    110,
    99,
    115,
    112,
    59,
    1,
    8200,
    4,
    6,
    102,
    105,
    111,
    112,
    115,
    117,
    15462,
    15467,
    15472,
    15478,
    15485,
    15491,
    114,
    59,
    3,
    55349,
    56622,
    110,
    116,
    59,
    1,
    10764,
    112,
    102,
    59,
    3,
    55349,
    56674,
    114,
    105,
    109,
    101,
    59,
    1,
    8279,
    99,
    114,
    59,
    3,
    55349,
    56518,
    4,
    3,
    97,
    101,
    111,
    15499,
    15520,
    15534,
    116,
    4,
    2,
    101,
    105,
    15506,
    15515,
    114,
    110,
    105,
    111,
    110,
    115,
    59,
    1,
    8461,
    110,
    116,
    59,
    1,
    10774,
    115,
    116,
    4,
    2,
    59,
    101,
    15528,
    15530,
    1,
    63,
    113,
    59,
    1,
    8799,
    116,
    5,
    34,
    1,
    59,
    15540,
    1,
    34,
    4,
    21,
    65,
    66,
    72,
    97,
    98,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    120,
    15586,
    15609,
    15615,
    15620,
    15796,
    15855,
    15893,
    15931,
    15977,
    16001,
    16039,
    16183,
    16204,
    16222,
    16228,
    16285,
    16312,
    16318,
    16363,
    16408,
    16416,
    4,
    3,
    97,
    114,
    116,
    15594,
    15599,
    15603,
    114,
    114,
    59,
    1,
    8667,
    114,
    59,
    1,
    8658,
    97,
    105,
    108,
    59,
    1,
    10524,
    97,
    114,
    114,
    59,
    1,
    10511,
    97,
    114,
    59,
    1,
    10596,
    4,
    7,
    99,
    100,
    101,
    110,
    113,
    114,
    116,
    15636,
    15651,
    15656,
    15664,
    15687,
    15696,
    15770,
    4,
    2,
    101,
    117,
    15642,
    15646,
    59,
    3,
    8765,
    817,
    116,
    101,
    59,
    1,
    341,
    105,
    99,
    59,
    1,
    8730,
    109,
    112,
    116,
    121,
    118,
    59,
    1,
    10675,
    103,
    4,
    4,
    59,
    100,
    101,
    108,
    15675,
    15677,
    15680,
    15683,
    1,
    10217,
    59,
    1,
    10642,
    59,
    1,
    10661,
    101,
    59,
    1,
    10217,
    117,
    111,
    5,
    187,
    1,
    59,
    15694,
    1,
    187,
    114,
    4,
    11,
    59,
    97,
    98,
    99,
    102,
    104,
    108,
    112,
    115,
    116,
    119,
    15721,
    15723,
    15727,
    15739,
    15742,
    15746,
    15750,
    15754,
    15758,
    15763,
    15767,
    1,
    8594,
    112,
    59,
    1,
    10613,
    4,
    2,
    59,
    102,
    15733,
    15735,
    1,
    8677,
    115,
    59,
    1,
    10528,
    59,
    1,
    10547,
    115,
    59,
    1,
    10526,
    107,
    59,
    1,
    8618,
    112,
    59,
    1,
    8620,
    108,
    59,
    1,
    10565,
    105,
    109,
    59,
    1,
    10612,
    108,
    59,
    1,
    8611,
    59,
    1,
    8605,
    4,
    2,
    97,
    105,
    15776,
    15781,
    105,
    108,
    59,
    1,
    10522,
    111,
    4,
    2,
    59,
    110,
    15788,
    15790,
    1,
    8758,
    97,
    108,
    115,
    59,
    1,
    8474,
    4,
    3,
    97,
    98,
    114,
    15804,
    15809,
    15814,
    114,
    114,
    59,
    1,
    10509,
    114,
    107,
    59,
    1,
    10099,
    4,
    2,
    97,
    107,
    15820,
    15833,
    99,
    4,
    2,
    101,
    107,
    15827,
    15830,
    59,
    1,
    125,
    59,
    1,
    93,
    4,
    2,
    101,
    115,
    15839,
    15842,
    59,
    1,
    10636,
    108,
    4,
    2,
    100,
    117,
    15849,
    15852,
    59,
    1,
    10638,
    59,
    1,
    10640,
    4,
    4,
    97,
    101,
    117,
    121,
    15865,
    15871,
    15886,
    15890,
    114,
    111,
    110,
    59,
    1,
    345,
    4,
    2,
    100,
    105,
    15877,
    15882,
    105,
    108,
    59,
    1,
    343,
    108,
    59,
    1,
    8969,
    98,
    59,
    1,
    125,
    59,
    1,
    1088,
    4,
    4,
    99,
    108,
    113,
    115,
    15903,
    15907,
    15914,
    15927,
    97,
    59,
    1,
    10551,
    100,
    104,
    97,
    114,
    59,
    1,
    10601,
    117,
    111,
    4,
    2,
    59,
    114,
    15922,
    15924,
    1,
    8221,
    59,
    1,
    8221,
    104,
    59,
    1,
    8627,
    4,
    3,
    97,
    99,
    103,
    15939,
    15966,
    15970,
    108,
    4,
    4,
    59,
    105,
    112,
    115,
    15950,
    15952,
    15957,
    15963,
    1,
    8476,
    110,
    101,
    59,
    1,
    8475,
    97,
    114,
    116,
    59,
    1,
    8476,
    59,
    1,
    8477,
    116,
    59,
    1,
    9645,
    5,
    174,
    1,
    59,
    15975,
    1,
    174,
    4,
    3,
    105,
    108,
    114,
    15985,
    15991,
    15997,
    115,
    104,
    116,
    59,
    1,
    10621,
    111,
    111,
    114,
    59,
    1,
    8971,
    59,
    3,
    55349,
    56623,
    4,
    2,
    97,
    111,
    16007,
    16028,
    114,
    4,
    2,
    100,
    117,
    16014,
    16017,
    59,
    1,
    8641,
    4,
    2,
    59,
    108,
    16023,
    16025,
    1,
    8640,
    59,
    1,
    10604,
    4,
    2,
    59,
    118,
    16034,
    16036,
    1,
    961,
    59,
    1,
    1009,
    4,
    3,
    103,
    110,
    115,
    16047,
    16167,
    16171,
    104,
    116,
    4,
    6,
    97,
    104,
    108,
    114,
    115,
    116,
    16063,
    16081,
    16103,
    16130,
    16143,
    16155,
    114,
    114,
    111,
    119,
    4,
    2,
    59,
    116,
    16073,
    16075,
    1,
    8594,
    97,
    105,
    108,
    59,
    1,
    8611,
    97,
    114,
    112,
    111,
    111,
    110,
    4,
    2,
    100,
    117,
    16093,
    16099,
    111,
    119,
    110,
    59,
    1,
    8641,
    112,
    59,
    1,
    8640,
    101,
    102,
    116,
    4,
    2,
    97,
    104,
    16112,
    16120,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8644,
    97,
    114,
    112,
    111,
    111,
    110,
    115,
    59,
    1,
    8652,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8649,
    113,
    117,
    105,
    103,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8605,
    104,
    114,
    101,
    101,
    116,
    105,
    109,
    101,
    115,
    59,
    1,
    8908,
    103,
    59,
    1,
    730,
    105,
    110,
    103,
    100,
    111,
    116,
    115,
    101,
    113,
    59,
    1,
    8787,
    4,
    3,
    97,
    104,
    109,
    16191,
    16196,
    16201,
    114,
    114,
    59,
    1,
    8644,
    97,
    114,
    59,
    1,
    8652,
    59,
    1,
    8207,
    111,
    117,
    115,
    116,
    4,
    2,
    59,
    97,
    16214,
    16216,
    1,
    9137,
    99,
    104,
    101,
    59,
    1,
    9137,
    109,
    105,
    100,
    59,
    1,
    10990,
    4,
    4,
    97,
    98,
    112,
    116,
    16238,
    16252,
    16257,
    16278,
    4,
    2,
    110,
    114,
    16244,
    16248,
    103,
    59,
    1,
    10221,
    114,
    59,
    1,
    8702,
    114,
    107,
    59,
    1,
    10215,
    4,
    3,
    97,
    102,
    108,
    16265,
    16269,
    16273,
    114,
    59,
    1,
    10630,
    59,
    3,
    55349,
    56675,
    117,
    115,
    59,
    1,
    10798,
    105,
    109,
    101,
    115,
    59,
    1,
    10805,
    4,
    2,
    97,
    112,
    16291,
    16304,
    114,
    4,
    2,
    59,
    103,
    16298,
    16300,
    1,
    41,
    116,
    59,
    1,
    10644,
    111,
    108,
    105,
    110,
    116,
    59,
    1,
    10770,
    97,
    114,
    114,
    59,
    1,
    8649,
    4,
    4,
    97,
    99,
    104,
    113,
    16328,
    16334,
    16339,
    16342,
    113,
    117,
    111,
    59,
    1,
    8250,
    114,
    59,
    3,
    55349,
    56519,
    59,
    1,
    8625,
    4,
    2,
    98,
    117,
    16348,
    16351,
    59,
    1,
    93,
    111,
    4,
    2,
    59,
    114,
    16358,
    16360,
    1,
    8217,
    59,
    1,
    8217,
    4,
    3,
    104,
    105,
    114,
    16371,
    16377,
    16383,
    114,
    101,
    101,
    59,
    1,
    8908,
    109,
    101,
    115,
    59,
    1,
    8906,
    105,
    4,
    4,
    59,
    101,
    102,
    108,
    16394,
    16396,
    16399,
    16402,
    1,
    9657,
    59,
    1,
    8885,
    59,
    1,
    9656,
    116,
    114,
    105,
    59,
    1,
    10702,
    108,
    117,
    104,
    97,
    114,
    59,
    1,
    10600,
    59,
    1,
    8478,
    4,
    19,
    97,
    98,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    109,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    119,
    122,
    16459,
    16466,
    16472,
    16572,
    16590,
    16672,
    16687,
    16746,
    16844,
    16850,
    16924,
    16963,
    16988,
    17115,
    17121,
    17154,
    17206,
    17614,
    17656,
    99,
    117,
    116,
    101,
    59,
    1,
    347,
    113,
    117,
    111,
    59,
    1,
    8218,
    4,
    10,
    59,
    69,
    97,
    99,
    101,
    105,
    110,
    112,
    115,
    121,
    16494,
    16496,
    16499,
    16513,
    16518,
    16531,
    16536,
    16556,
    16564,
    16569,
    1,
    8827,
    59,
    1,
    10932,
    4,
    2,
    112,
    114,
    16505,
    16508,
    59,
    1,
    10936,
    111,
    110,
    59,
    1,
    353,
    117,
    101,
    59,
    1,
    8829,
    4,
    2,
    59,
    100,
    16524,
    16526,
    1,
    10928,
    105,
    108,
    59,
    1,
    351,
    114,
    99,
    59,
    1,
    349,
    4,
    3,
    69,
    97,
    115,
    16544,
    16547,
    16551,
    59,
    1,
    10934,
    112,
    59,
    1,
    10938,
    105,
    109,
    59,
    1,
    8937,
    111,
    108,
    105,
    110,
    116,
    59,
    1,
    10771,
    105,
    109,
    59,
    1,
    8831,
    59,
    1,
    1089,
    111,
    116,
    4,
    3,
    59,
    98,
    101,
    16582,
    16584,
    16587,
    1,
    8901,
    59,
    1,
    8865,
    59,
    1,
    10854,
    4,
    7,
    65,
    97,
    99,
    109,
    115,
    116,
    120,
    16606,
    16611,
    16634,
    16642,
    16646,
    16652,
    16668,
    114,
    114,
    59,
    1,
    8664,
    114,
    4,
    2,
    104,
    114,
    16618,
    16622,
    107,
    59,
    1,
    10533,
    4,
    2,
    59,
    111,
    16628,
    16630,
    1,
    8600,
    119,
    59,
    1,
    8600,
    116,
    5,
    167,
    1,
    59,
    16640,
    1,
    167,
    105,
    59,
    1,
    59,
    119,
    97,
    114,
    59,
    1,
    10537,
    109,
    4,
    2,
    105,
    110,
    16659,
    16665,
    110,
    117,
    115,
    59,
    1,
    8726,
    59,
    1,
    8726,
    116,
    59,
    1,
    10038,
    114,
    4,
    2,
    59,
    111,
    16679,
    16682,
    3,
    55349,
    56624,
    119,
    110,
    59,
    1,
    8994,
    4,
    4,
    97,
    99,
    111,
    121,
    16697,
    16702,
    16716,
    16739,
    114,
    112,
    59,
    1,
    9839,
    4,
    2,
    104,
    121,
    16708,
    16713,
    99,
    121,
    59,
    1,
    1097,
    59,
    1,
    1096,
    114,
    116,
    4,
    2,
    109,
    112,
    16724,
    16729,
    105,
    100,
    59,
    1,
    8739,
    97,
    114,
    97,
    108,
    108,
    101,
    108,
    59,
    1,
    8741,
    5,
    173,
    1,
    59,
    16744,
    1,
    173,
    4,
    2,
    103,
    109,
    16752,
    16770,
    109,
    97,
    4,
    3,
    59,
    102,
    118,
    16762,
    16764,
    16767,
    1,
    963,
    59,
    1,
    962,
    59,
    1,
    962,
    4,
    8,
    59,
    100,
    101,
    103,
    108,
    110,
    112,
    114,
    16788,
    16790,
    16795,
    16806,
    16817,
    16828,
    16832,
    16838,
    1,
    8764,
    111,
    116,
    59,
    1,
    10858,
    4,
    2,
    59,
    113,
    16801,
    16803,
    1,
    8771,
    59,
    1,
    8771,
    4,
    2,
    59,
    69,
    16812,
    16814,
    1,
    10910,
    59,
    1,
    10912,
    4,
    2,
    59,
    69,
    16823,
    16825,
    1,
    10909,
    59,
    1,
    10911,
    101,
    59,
    1,
    8774,
    108,
    117,
    115,
    59,
    1,
    10788,
    97,
    114,
    114,
    59,
    1,
    10610,
    97,
    114,
    114,
    59,
    1,
    8592,
    4,
    4,
    97,
    101,
    105,
    116,
    16860,
    16883,
    16891,
    16904,
    4,
    2,
    108,
    115,
    16866,
    16878,
    108,
    115,
    101,
    116,
    109,
    105,
    110,
    117,
    115,
    59,
    1,
    8726,
    104,
    112,
    59,
    1,
    10803,
    112,
    97,
    114,
    115,
    108,
    59,
    1,
    10724,
    4,
    2,
    100,
    108,
    16897,
    16900,
    59,
    1,
    8739,
    101,
    59,
    1,
    8995,
    4,
    2,
    59,
    101,
    16910,
    16912,
    1,
    10922,
    4,
    2,
    59,
    115,
    16918,
    16920,
    1,
    10924,
    59,
    3,
    10924,
    65024,
    4,
    3,
    102,
    108,
    112,
    16932,
    16938,
    16958,
    116,
    99,
    121,
    59,
    1,
    1100,
    4,
    2,
    59,
    98,
    16944,
    16946,
    1,
    47,
    4,
    2,
    59,
    97,
    16952,
    16954,
    1,
    10692,
    114,
    59,
    1,
    9023,
    102,
    59,
    3,
    55349,
    56676,
    97,
    4,
    2,
    100,
    114,
    16970,
    16985,
    101,
    115,
    4,
    2,
    59,
    117,
    16978,
    16980,
    1,
    9824,
    105,
    116,
    59,
    1,
    9824,
    59,
    1,
    8741,
    4,
    3,
    99,
    115,
    117,
    16996,
    17028,
    17089,
    4,
    2,
    97,
    117,
    17002,
    17015,
    112,
    4,
    2,
    59,
    115,
    17009,
    17011,
    1,
    8851,
    59,
    3,
    8851,
    65024,
    112,
    4,
    2,
    59,
    115,
    17022,
    17024,
    1,
    8852,
    59,
    3,
    8852,
    65024,
    117,
    4,
    2,
    98,
    112,
    17035,
    17062,
    4,
    3,
    59,
    101,
    115,
    17043,
    17045,
    17048,
    1,
    8847,
    59,
    1,
    8849,
    101,
    116,
    4,
    2,
    59,
    101,
    17056,
    17058,
    1,
    8847,
    113,
    59,
    1,
    8849,
    4,
    3,
    59,
    101,
    115,
    17070,
    17072,
    17075,
    1,
    8848,
    59,
    1,
    8850,
    101,
    116,
    4,
    2,
    59,
    101,
    17083,
    17085,
    1,
    8848,
    113,
    59,
    1,
    8850,
    4,
    3,
    59,
    97,
    102,
    17097,
    17099,
    17112,
    1,
    9633,
    114,
    4,
    2,
    101,
    102,
    17106,
    17109,
    59,
    1,
    9633,
    59,
    1,
    9642,
    59,
    1,
    9642,
    97,
    114,
    114,
    59,
    1,
    8594,
    4,
    4,
    99,
    101,
    109,
    116,
    17131,
    17136,
    17142,
    17148,
    114,
    59,
    3,
    55349,
    56520,
    116,
    109,
    110,
    59,
    1,
    8726,
    105,
    108,
    101,
    59,
    1,
    8995,
    97,
    114,
    102,
    59,
    1,
    8902,
    4,
    2,
    97,
    114,
    17160,
    17172,
    114,
    4,
    2,
    59,
    102,
    17167,
    17169,
    1,
    9734,
    59,
    1,
    9733,
    4,
    2,
    97,
    110,
    17178,
    17202,
    105,
    103,
    104,
    116,
    4,
    2,
    101,
    112,
    17188,
    17197,
    112,
    115,
    105,
    108,
    111,
    110,
    59,
    1,
    1013,
    104,
    105,
    59,
    1,
    981,
    115,
    59,
    1,
    175,
    4,
    5,
    98,
    99,
    109,
    110,
    112,
    17218,
    17351,
    17420,
    17423,
    17427,
    4,
    9,
    59,
    69,
    100,
    101,
    109,
    110,
    112,
    114,
    115,
    17238,
    17240,
    17243,
    17248,
    17261,
    17267,
    17279,
    17285,
    17291,
    1,
    8834,
    59,
    1,
    10949,
    111,
    116,
    59,
    1,
    10941,
    4,
    2,
    59,
    100,
    17254,
    17256,
    1,
    8838,
    111,
    116,
    59,
    1,
    10947,
    117,
    108,
    116,
    59,
    1,
    10945,
    4,
    2,
    69,
    101,
    17273,
    17276,
    59,
    1,
    10955,
    59,
    1,
    8842,
    108,
    117,
    115,
    59,
    1,
    10943,
    97,
    114,
    114,
    59,
    1,
    10617,
    4,
    3,
    101,
    105,
    117,
    17299,
    17335,
    17339,
    116,
    4,
    3,
    59,
    101,
    110,
    17308,
    17310,
    17322,
    1,
    8834,
    113,
    4,
    2,
    59,
    113,
    17317,
    17319,
    1,
    8838,
    59,
    1,
    10949,
    101,
    113,
    4,
    2,
    59,
    113,
    17330,
    17332,
    1,
    8842,
    59,
    1,
    10955,
    109,
    59,
    1,
    10951,
    4,
    2,
    98,
    112,
    17345,
    17348,
    59,
    1,
    10965,
    59,
    1,
    10963,
    99,
    4,
    6,
    59,
    97,
    99,
    101,
    110,
    115,
    17366,
    17368,
    17376,
    17385,
    17389,
    17415,
    1,
    8827,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10936,
    117,
    114,
    108,
    121,
    101,
    113,
    59,
    1,
    8829,
    113,
    59,
    1,
    10928,
    4,
    3,
    97,
    101,
    115,
    17397,
    17405,
    17410,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10938,
    113,
    113,
    59,
    1,
    10934,
    105,
    109,
    59,
    1,
    8937,
    105,
    109,
    59,
    1,
    8831,
    59,
    1,
    8721,
    103,
    59,
    1,
    9834,
    4,
    13,
    49,
    50,
    51,
    59,
    69,
    100,
    101,
    104,
    108,
    109,
    110,
    112,
    115,
    17455,
    17462,
    17469,
    17476,
    17478,
    17481,
    17496,
    17509,
    17524,
    17530,
    17536,
    17548,
    17554,
    5,
    185,
    1,
    59,
    17460,
    1,
    185,
    5,
    178,
    1,
    59,
    17467,
    1,
    178,
    5,
    179,
    1,
    59,
    17474,
    1,
    179,
    1,
    8835,
    59,
    1,
    10950,
    4,
    2,
    111,
    115,
    17487,
    17491,
    116,
    59,
    1,
    10942,
    117,
    98,
    59,
    1,
    10968,
    4,
    2,
    59,
    100,
    17502,
    17504,
    1,
    8839,
    111,
    116,
    59,
    1,
    10948,
    115,
    4,
    2,
    111,
    117,
    17516,
    17520,
    108,
    59,
    1,
    10185,
    98,
    59,
    1,
    10967,
    97,
    114,
    114,
    59,
    1,
    10619,
    117,
    108,
    116,
    59,
    1,
    10946,
    4,
    2,
    69,
    101,
    17542,
    17545,
    59,
    1,
    10956,
    59,
    1,
    8843,
    108,
    117,
    115,
    59,
    1,
    10944,
    4,
    3,
    101,
    105,
    117,
    17562,
    17598,
    17602,
    116,
    4,
    3,
    59,
    101,
    110,
    17571,
    17573,
    17585,
    1,
    8835,
    113,
    4,
    2,
    59,
    113,
    17580,
    17582,
    1,
    8839,
    59,
    1,
    10950,
    101,
    113,
    4,
    2,
    59,
    113,
    17593,
    17595,
    1,
    8843,
    59,
    1,
    10956,
    109,
    59,
    1,
    10952,
    4,
    2,
    98,
    112,
    17608,
    17611,
    59,
    1,
    10964,
    59,
    1,
    10966,
    4,
    3,
    65,
    97,
    110,
    17622,
    17627,
    17650,
    114,
    114,
    59,
    1,
    8665,
    114,
    4,
    2,
    104,
    114,
    17634,
    17638,
    107,
    59,
    1,
    10534,
    4,
    2,
    59,
    111,
    17644,
    17646,
    1,
    8601,
    119,
    59,
    1,
    8601,
    119,
    97,
    114,
    59,
    1,
    10538,
    108,
    105,
    103,
    5,
    223,
    1,
    59,
    17664,
    1,
    223,
    4,
    13,
    97,
    98,
    99,
    100,
    101,
    102,
    104,
    105,
    111,
    112,
    114,
    115,
    119,
    17694,
    17709,
    17714,
    17737,
    17742,
    17749,
    17754,
    17860,
    17905,
    17957,
    17964,
    18090,
    18122,
    4,
    2,
    114,
    117,
    17700,
    17706,
    103,
    101,
    116,
    59,
    1,
    8982,
    59,
    1,
    964,
    114,
    107,
    59,
    1,
    9140,
    4,
    3,
    97,
    101,
    121,
    17722,
    17728,
    17734,
    114,
    111,
    110,
    59,
    1,
    357,
    100,
    105,
    108,
    59,
    1,
    355,
    59,
    1,
    1090,
    111,
    116,
    59,
    1,
    8411,
    108,
    114,
    101,
    99,
    59,
    1,
    8981,
    114,
    59,
    3,
    55349,
    56625,
    4,
    4,
    101,
    105,
    107,
    111,
    17764,
    17805,
    17836,
    17851,
    4,
    2,
    114,
    116,
    17770,
    17786,
    101,
    4,
    2,
    52,
    102,
    17777,
    17780,
    59,
    1,
    8756,
    111,
    114,
    101,
    59,
    1,
    8756,
    97,
    4,
    3,
    59,
    115,
    118,
    17795,
    17797,
    17802,
    1,
    952,
    121,
    109,
    59,
    1,
    977,
    59,
    1,
    977,
    4,
    2,
    99,
    110,
    17811,
    17831,
    107,
    4,
    2,
    97,
    115,
    17818,
    17826,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    8776,
    105,
    109,
    59,
    1,
    8764,
    115,
    112,
    59,
    1,
    8201,
    4,
    2,
    97,
    115,
    17842,
    17846,
    112,
    59,
    1,
    8776,
    105,
    109,
    59,
    1,
    8764,
    114,
    110,
    5,
    254,
    1,
    59,
    17858,
    1,
    254,
    4,
    3,
    108,
    109,
    110,
    17868,
    17873,
    17901,
    100,
    101,
    59,
    1,
    732,
    101,
    115,
    5,
    215,
    3,
    59,
    98,
    100,
    17884,
    17886,
    17898,
    1,
    215,
    4,
    2,
    59,
    97,
    17892,
    17894,
    1,
    8864,
    114,
    59,
    1,
    10801,
    59,
    1,
    10800,
    116,
    59,
    1,
    8749,
    4,
    3,
    101,
    112,
    115,
    17913,
    17917,
    17953,
    97,
    59,
    1,
    10536,
    4,
    4,
    59,
    98,
    99,
    102,
    17927,
    17929,
    17934,
    17939,
    1,
    8868,
    111,
    116,
    59,
    1,
    9014,
    105,
    114,
    59,
    1,
    10993,
    4,
    2,
    59,
    111,
    17945,
    17948,
    3,
    55349,
    56677,
    114,
    107,
    59,
    1,
    10970,
    97,
    59,
    1,
    10537,
    114,
    105,
    109,
    101,
    59,
    1,
    8244,
    4,
    3,
    97,
    105,
    112,
    17972,
    17977,
    18082,
    100,
    101,
    59,
    1,
    8482,
    4,
    7,
    97,
    100,
    101,
    109,
    112,
    115,
    116,
    17993,
    18051,
    18056,
    18059,
    18066,
    18072,
    18076,
    110,
    103,
    108,
    101,
    4,
    5,
    59,
    100,
    108,
    113,
    114,
    18009,
    18011,
    18017,
    18032,
    18035,
    1,
    9653,
    111,
    119,
    110,
    59,
    1,
    9663,
    101,
    102,
    116,
    4,
    2,
    59,
    101,
    18026,
    18028,
    1,
    9667,
    113,
    59,
    1,
    8884,
    59,
    1,
    8796,
    105,
    103,
    104,
    116,
    4,
    2,
    59,
    101,
    18045,
    18047,
    1,
    9657,
    113,
    59,
    1,
    8885,
    111,
    116,
    59,
    1,
    9708,
    59,
    1,
    8796,
    105,
    110,
    117,
    115,
    59,
    1,
    10810,
    108,
    117,
    115,
    59,
    1,
    10809,
    98,
    59,
    1,
    10701,
    105,
    109,
    101,
    59,
    1,
    10811,
    101,
    122,
    105,
    117,
    109,
    59,
    1,
    9186,
    4,
    3,
    99,
    104,
    116,
    18098,
    18111,
    18116,
    4,
    2,
    114,
    121,
    18104,
    18108,
    59,
    3,
    55349,
    56521,
    59,
    1,
    1094,
    99,
    121,
    59,
    1,
    1115,
    114,
    111,
    107,
    59,
    1,
    359,
    4,
    2,
    105,
    111,
    18128,
    18133,
    120,
    116,
    59,
    1,
    8812,
    104,
    101,
    97,
    100,
    4,
    2,
    108,
    114,
    18143,
    18154,
    101,
    102,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8606,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8608,
    4,
    18,
    65,
    72,
    97,
    98,
    99,
    100,
    102,
    103,
    104,
    108,
    109,
    111,
    112,
    114,
    115,
    116,
    117,
    119,
    18204,
    18209,
    18214,
    18234,
    18250,
    18268,
    18292,
    18308,
    18319,
    18343,
    18379,
    18397,
    18413,
    18504,
    18547,
    18553,
    18584,
    18603,
    114,
    114,
    59,
    1,
    8657,
    97,
    114,
    59,
    1,
    10595,
    4,
    2,
    99,
    114,
    18220,
    18230,
    117,
    116,
    101,
    5,
    250,
    1,
    59,
    18228,
    1,
    250,
    114,
    59,
    1,
    8593,
    114,
    4,
    2,
    99,
    101,
    18241,
    18245,
    121,
    59,
    1,
    1118,
    118,
    101,
    59,
    1,
    365,
    4,
    2,
    105,
    121,
    18256,
    18265,
    114,
    99,
    5,
    251,
    1,
    59,
    18263,
    1,
    251,
    59,
    1,
    1091,
    4,
    3,
    97,
    98,
    104,
    18276,
    18281,
    18287,
    114,
    114,
    59,
    1,
    8645,
    108,
    97,
    99,
    59,
    1,
    369,
    97,
    114,
    59,
    1,
    10606,
    4,
    2,
    105,
    114,
    18298,
    18304,
    115,
    104,
    116,
    59,
    1,
    10622,
    59,
    3,
    55349,
    56626,
    114,
    97,
    118,
    101,
    5,
    249,
    1,
    59,
    18317,
    1,
    249,
    4,
    2,
    97,
    98,
    18325,
    18338,
    114,
    4,
    2,
    108,
    114,
    18332,
    18335,
    59,
    1,
    8639,
    59,
    1,
    8638,
    108,
    107,
    59,
    1,
    9600,
    4,
    2,
    99,
    116,
    18349,
    18374,
    4,
    2,
    111,
    114,
    18355,
    18369,
    114,
    110,
    4,
    2,
    59,
    101,
    18363,
    18365,
    1,
    8988,
    114,
    59,
    1,
    8988,
    111,
    112,
    59,
    1,
    8975,
    114,
    105,
    59,
    1,
    9720,
    4,
    2,
    97,
    108,
    18385,
    18390,
    99,
    114,
    59,
    1,
    363,
    5,
    168,
    1,
    59,
    18395,
    1,
    168,
    4,
    2,
    103,
    112,
    18403,
    18408,
    111,
    110,
    59,
    1,
    371,
    102,
    59,
    3,
    55349,
    56678,
    4,
    6,
    97,
    100,
    104,
    108,
    115,
    117,
    18427,
    18434,
    18445,
    18470,
    18475,
    18494,
    114,
    114,
    111,
    119,
    59,
    1,
    8593,
    111,
    119,
    110,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8597,
    97,
    114,
    112,
    111,
    111,
    110,
    4,
    2,
    108,
    114,
    18457,
    18463,
    101,
    102,
    116,
    59,
    1,
    8639,
    105,
    103,
    104,
    116,
    59,
    1,
    8638,
    117,
    115,
    59,
    1,
    8846,
    105,
    4,
    3,
    59,
    104,
    108,
    18484,
    18486,
    18489,
    1,
    965,
    59,
    1,
    978,
    111,
    110,
    59,
    1,
    965,
    112,
    97,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8648,
    4,
    3,
    99,
    105,
    116,
    18512,
    18537,
    18542,
    4,
    2,
    111,
    114,
    18518,
    18532,
    114,
    110,
    4,
    2,
    59,
    101,
    18526,
    18528,
    1,
    8989,
    114,
    59,
    1,
    8989,
    111,
    112,
    59,
    1,
    8974,
    110,
    103,
    59,
    1,
    367,
    114,
    105,
    59,
    1,
    9721,
    99,
    114,
    59,
    3,
    55349,
    56522,
    4,
    3,
    100,
    105,
    114,
    18561,
    18566,
    18572,
    111,
    116,
    59,
    1,
    8944,
    108,
    100,
    101,
    59,
    1,
    361,
    105,
    4,
    2,
    59,
    102,
    18579,
    18581,
    1,
    9653,
    59,
    1,
    9652,
    4,
    2,
    97,
    109,
    18590,
    18595,
    114,
    114,
    59,
    1,
    8648,
    108,
    5,
    252,
    1,
    59,
    18601,
    1,
    252,
    97,
    110,
    103,
    108,
    101,
    59,
    1,
    10663,
    4,
    15,
    65,
    66,
    68,
    97,
    99,
    100,
    101,
    102,
    108,
    110,
    111,
    112,
    114,
    115,
    122,
    18643,
    18648,
    18661,
    18667,
    18847,
    18851,
    18857,
    18904,
    18909,
    18915,
    18931,
    18937,
    18943,
    18949,
    18996,
    114,
    114,
    59,
    1,
    8661,
    97,
    114,
    4,
    2,
    59,
    118,
    18656,
    18658,
    1,
    10984,
    59,
    1,
    10985,
    97,
    115,
    104,
    59,
    1,
    8872,
    4,
    2,
    110,
    114,
    18673,
    18679,
    103,
    114,
    116,
    59,
    1,
    10652,
    4,
    7,
    101,
    107,
    110,
    112,
    114,
    115,
    116,
    18695,
    18704,
    18711,
    18720,
    18742,
    18754,
    18810,
    112,
    115,
    105,
    108,
    111,
    110,
    59,
    1,
    1013,
    97,
    112,
    112,
    97,
    59,
    1,
    1008,
    111,
    116,
    104,
    105,
    110,
    103,
    59,
    1,
    8709,
    4,
    3,
    104,
    105,
    114,
    18728,
    18732,
    18735,
    105,
    59,
    1,
    981,
    59,
    1,
    982,
    111,
    112,
    116,
    111,
    59,
    1,
    8733,
    4,
    2,
    59,
    104,
    18748,
    18750,
    1,
    8597,
    111,
    59,
    1,
    1009,
    4,
    2,
    105,
    117,
    18760,
    18766,
    103,
    109,
    97,
    59,
    1,
    962,
    4,
    2,
    98,
    112,
    18772,
    18791,
    115,
    101,
    116,
    110,
    101,
    113,
    4,
    2,
    59,
    113,
    18784,
    18787,
    3,
    8842,
    65024,
    59,
    3,
    10955,
    65024,
    115,
    101,
    116,
    110,
    101,
    113,
    4,
    2,
    59,
    113,
    18803,
    18806,
    3,
    8843,
    65024,
    59,
    3,
    10956,
    65024,
    4,
    2,
    104,
    114,
    18816,
    18822,
    101,
    116,
    97,
    59,
    1,
    977,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    2,
    108,
    114,
    18834,
    18840,
    101,
    102,
    116,
    59,
    1,
    8882,
    105,
    103,
    104,
    116,
    59,
    1,
    8883,
    121,
    59,
    1,
    1074,
    97,
    115,
    104,
    59,
    1,
    8866,
    4,
    3,
    101,
    108,
    114,
    18865,
    18884,
    18890,
    4,
    3,
    59,
    98,
    101,
    18873,
    18875,
    18880,
    1,
    8744,
    97,
    114,
    59,
    1,
    8891,
    113,
    59,
    1,
    8794,
    108,
    105,
    112,
    59,
    1,
    8942,
    4,
    2,
    98,
    116,
    18896,
    18901,
    97,
    114,
    59,
    1,
    124,
    59,
    1,
    124,
    114,
    59,
    3,
    55349,
    56627,
    116,
    114,
    105,
    59,
    1,
    8882,
    115,
    117,
    4,
    2,
    98,
    112,
    18923,
    18927,
    59,
    3,
    8834,
    8402,
    59,
    3,
    8835,
    8402,
    112,
    102,
    59,
    3,
    55349,
    56679,
    114,
    111,
    112,
    59,
    1,
    8733,
    116,
    114,
    105,
    59,
    1,
    8883,
    4,
    2,
    99,
    117,
    18955,
    18960,
    114,
    59,
    3,
    55349,
    56523,
    4,
    2,
    98,
    112,
    18966,
    18981,
    110,
    4,
    2,
    69,
    101,
    18973,
    18977,
    59,
    3,
    10955,
    65024,
    59,
    3,
    8842,
    65024,
    110,
    4,
    2,
    69,
    101,
    18988,
    18992,
    59,
    3,
    10956,
    65024,
    59,
    3,
    8843,
    65024,
    105,
    103,
    122,
    97,
    103,
    59,
    1,
    10650,
    4,
    7,
    99,
    101,
    102,
    111,
    112,
    114,
    115,
    19020,
    19026,
    19061,
    19066,
    19072,
    19075,
    19089,
    105,
    114,
    99,
    59,
    1,
    373,
    4,
    2,
    100,
    105,
    19032,
    19055,
    4,
    2,
    98,
    103,
    19038,
    19043,
    97,
    114,
    59,
    1,
    10847,
    101,
    4,
    2,
    59,
    113,
    19050,
    19052,
    1,
    8743,
    59,
    1,
    8793,
    101,
    114,
    112,
    59,
    1,
    8472,
    114,
    59,
    3,
    55349,
    56628,
    112,
    102,
    59,
    3,
    55349,
    56680,
    59,
    1,
    8472,
    4,
    2,
    59,
    101,
    19081,
    19083,
    1,
    8768,
    97,
    116,
    104,
    59,
    1,
    8768,
    99,
    114,
    59,
    3,
    55349,
    56524,
    4,
    14,
    99,
    100,
    102,
    104,
    105,
    108,
    109,
    110,
    111,
    114,
    115,
    117,
    118,
    119,
    19125,
    19146,
    19152,
    19157,
    19173,
    19176,
    19192,
    19197,
    19202,
    19236,
    19252,
    19269,
    19286,
    19291,
    4,
    3,
    97,
    105,
    117,
    19133,
    19137,
    19142,
    112,
    59,
    1,
    8898,
    114,
    99,
    59,
    1,
    9711,
    112,
    59,
    1,
    8899,
    116,
    114,
    105,
    59,
    1,
    9661,
    114,
    59,
    3,
    55349,
    56629,
    4,
    2,
    65,
    97,
    19163,
    19168,
    114,
    114,
    59,
    1,
    10234,
    114,
    114,
    59,
    1,
    10231,
    59,
    1,
    958,
    4,
    2,
    65,
    97,
    19182,
    19187,
    114,
    114,
    59,
    1,
    10232,
    114,
    114,
    59,
    1,
    10229,
    97,
    112,
    59,
    1,
    10236,
    105,
    115,
    59,
    1,
    8955,
    4,
    3,
    100,
    112,
    116,
    19210,
    19215,
    19230,
    111,
    116,
    59,
    1,
    10752,
    4,
    2,
    102,
    108,
    19221,
    19225,
    59,
    3,
    55349,
    56681,
    117,
    115,
    59,
    1,
    10753,
    105,
    109,
    101,
    59,
    1,
    10754,
    4,
    2,
    65,
    97,
    19242,
    19247,
    114,
    114,
    59,
    1,
    10233,
    114,
    114,
    59,
    1,
    10230,
    4,
    2,
    99,
    113,
    19258,
    19263,
    114,
    59,
    3,
    55349,
    56525,
    99,
    117,
    112,
    59,
    1,
    10758,
    4,
    2,
    112,
    116,
    19275,
    19281,
    108,
    117,
    115,
    59,
    1,
    10756,
    114,
    105,
    59,
    1,
    9651,
    101,
    101,
    59,
    1,
    8897,
    101,
    100,
    103,
    101,
    59,
    1,
    8896,
    4,
    8,
    97,
    99,
    101,
    102,
    105,
    111,
    115,
    117,
    19316,
    19335,
    19349,
    19357,
    19362,
    19367,
    19373,
    19379,
    99,
    4,
    2,
    117,
    121,
    19323,
    19332,
    116,
    101,
    5,
    253,
    1,
    59,
    19330,
    1,
    253,
    59,
    1,
    1103,
    4,
    2,
    105,
    121,
    19341,
    19346,
    114,
    99,
    59,
    1,
    375,
    59,
    1,
    1099,
    110,
    5,
    165,
    1,
    59,
    19355,
    1,
    165,
    114,
    59,
    3,
    55349,
    56630,
    99,
    121,
    59,
    1,
    1111,
    112,
    102,
    59,
    3,
    55349,
    56682,
    99,
    114,
    59,
    3,
    55349,
    56526,
    4,
    2,
    99,
    109,
    19385,
    19389,
    121,
    59,
    1,
    1102,
    108,
    5,
    255,
    1,
    59,
    19395,
    1,
    255,
    4,
    10,
    97,
    99,
    100,
    101,
    102,
    104,
    105,
    111,
    115,
    119,
    19419,
    19426,
    19441,
    19446,
    19462,
    19467,
    19472,
    19480,
    19486,
    19492,
    99,
    117,
    116,
    101,
    59,
    1,
    378,
    4,
    2,
    97,
    121,
    19432,
    19438,
    114,
    111,
    110,
    59,
    1,
    382,
    59,
    1,
    1079,
    111,
    116,
    59,
    1,
    380,
    4,
    2,
    101,
    116,
    19452,
    19458,
    116,
    114,
    102,
    59,
    1,
    8488,
    97,
    59,
    1,
    950,
    114,
    59,
    3,
    55349,
    56631,
    99,
    121,
    59,
    1,
    1078,
    103,
    114,
    97,
    114,
    114,
    59,
    1,
    8669,
    112,
    102,
    59,
    3,
    55349,
    56683,
    99,
    114,
    59,
    3,
    55349,
    56527,
    4,
    2,
    106,
    110,
    19498,
    19501,
    59,
    1,
    8205,
    106,
    59,
    1,
    8204
]);



//Aliases
const $1402a60f2d09b0f9$var$$ = $4e69a73910c07b7d$export$e3f6c2feb5c0ecc0;
const $1402a60f2d09b0f9$var$$$ = $4e69a73910c07b7d$export$3dc99c30563e6ab8;
//C1 Unicode control character reference replacements
const $1402a60f2d09b0f9$var$C1_CONTROLS_REFERENCE_REPLACEMENTS = {
    0x80: 0x20ac,
    0x82: 0x201a,
    0x83: 0x0192,
    0x84: 0x201e,
    0x85: 0x2026,
    0x86: 0x2020,
    0x87: 0x2021,
    0x88: 0x02c6,
    0x89: 0x2030,
    0x8a: 0x0160,
    0x8b: 0x2039,
    0x8c: 0x0152,
    0x8e: 0x017d,
    0x91: 0x2018,
    0x92: 0x2019,
    0x93: 0x201c,
    0x94: 0x201d,
    0x95: 0x2022,
    0x96: 0x2013,
    0x97: 0x2014,
    0x98: 0x02dc,
    0x99: 0x2122,
    0x9a: 0x0161,
    0x9b: 0x203a,
    0x9c: 0x0153,
    0x9e: 0x017e,
    0x9f: 0x0178
};
// Named entity tree flags
const $1402a60f2d09b0f9$var$HAS_DATA_FLAG = 1;
const $1402a60f2d09b0f9$var$DATA_DUPLET_FLAG = 2;
const $1402a60f2d09b0f9$var$HAS_BRANCHES_FLAG = 4;
const $1402a60f2d09b0f9$var$MAX_BRANCH_MARKER_VALUE = $1402a60f2d09b0f9$var$HAS_DATA_FLAG | $1402a60f2d09b0f9$var$DATA_DUPLET_FLAG | $1402a60f2d09b0f9$var$HAS_BRANCHES_FLAG;
//States
const $1402a60f2d09b0f9$var$DATA_STATE = "DATA_STATE";
const $1402a60f2d09b0f9$var$RCDATA_STATE = "RCDATA_STATE";
const $1402a60f2d09b0f9$var$RAWTEXT_STATE = "RAWTEXT_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_STATE = "SCRIPT_DATA_STATE";
const $1402a60f2d09b0f9$var$PLAINTEXT_STATE = "PLAINTEXT_STATE";
const $1402a60f2d09b0f9$var$TAG_OPEN_STATE = "TAG_OPEN_STATE";
const $1402a60f2d09b0f9$var$END_TAG_OPEN_STATE = "END_TAG_OPEN_STATE";
const $1402a60f2d09b0f9$var$TAG_NAME_STATE = "TAG_NAME_STATE";
const $1402a60f2d09b0f9$var$RCDATA_LESS_THAN_SIGN_STATE = "RCDATA_LESS_THAN_SIGN_STATE";
const $1402a60f2d09b0f9$var$RCDATA_END_TAG_OPEN_STATE = "RCDATA_END_TAG_OPEN_STATE";
const $1402a60f2d09b0f9$var$RCDATA_END_TAG_NAME_STATE = "RCDATA_END_TAG_NAME_STATE";
const $1402a60f2d09b0f9$var$RAWTEXT_LESS_THAN_SIGN_STATE = "RAWTEXT_LESS_THAN_SIGN_STATE";
const $1402a60f2d09b0f9$var$RAWTEXT_END_TAG_OPEN_STATE = "RAWTEXT_END_TAG_OPEN_STATE";
const $1402a60f2d09b0f9$var$RAWTEXT_END_TAG_NAME_STATE = "RAWTEXT_END_TAG_NAME_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_LESS_THAN_SIGN_STATE = "SCRIPT_DATA_LESS_THAN_SIGN_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_END_TAG_OPEN_STATE = "SCRIPT_DATA_END_TAG_OPEN_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_END_TAG_NAME_STATE = "SCRIPT_DATA_END_TAG_NAME_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPE_START_STATE = "SCRIPT_DATA_ESCAPE_START_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPE_START_DASH_STATE = "SCRIPT_DATA_ESCAPE_START_DASH_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE = "SCRIPT_DATA_ESCAPED_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_DASH_STATE = "SCRIPT_DATA_ESCAPED_DASH_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE";
const $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE";
const $1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE = "BEFORE_ATTRIBUTE_NAME_STATE";
const $1402a60f2d09b0f9$var$ATTRIBUTE_NAME_STATE = "ATTRIBUTE_NAME_STATE";
const $1402a60f2d09b0f9$var$AFTER_ATTRIBUTE_NAME_STATE = "AFTER_ATTRIBUTE_NAME_STATE";
const $1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_VALUE_STATE = "BEFORE_ATTRIBUTE_VALUE_STATE";
const $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE";
const $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE";
const $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_UNQUOTED_STATE = "ATTRIBUTE_VALUE_UNQUOTED_STATE";
const $1402a60f2d09b0f9$var$AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE";
const $1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE = "SELF_CLOSING_START_TAG_STATE";
const $1402a60f2d09b0f9$var$BOGUS_COMMENT_STATE = "BOGUS_COMMENT_STATE";
const $1402a60f2d09b0f9$var$MARKUP_DECLARATION_OPEN_STATE = "MARKUP_DECLARATION_OPEN_STATE";
const $1402a60f2d09b0f9$var$COMMENT_START_STATE = "COMMENT_START_STATE";
const $1402a60f2d09b0f9$var$COMMENT_START_DASH_STATE = "COMMENT_START_DASH_STATE";
const $1402a60f2d09b0f9$var$COMMENT_STATE = "COMMENT_STATE";
const $1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_STATE = "COMMENT_LESS_THAN_SIGN_STATE";
const $1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_STATE = "COMMENT_LESS_THAN_SIGN_BANG_STATE";
const $1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE";
const $1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE";
const $1402a60f2d09b0f9$var$COMMENT_END_DASH_STATE = "COMMENT_END_DASH_STATE";
const $1402a60f2d09b0f9$var$COMMENT_END_STATE = "COMMENT_END_STATE";
const $1402a60f2d09b0f9$var$COMMENT_END_BANG_STATE = "COMMENT_END_BANG_STATE";
const $1402a60f2d09b0f9$var$DOCTYPE_STATE = "DOCTYPE_STATE";
const $1402a60f2d09b0f9$var$BEFORE_DOCTYPE_NAME_STATE = "BEFORE_DOCTYPE_NAME_STATE";
const $1402a60f2d09b0f9$var$DOCTYPE_NAME_STATE = "DOCTYPE_NAME_STATE";
const $1402a60f2d09b0f9$var$AFTER_DOCTYPE_NAME_STATE = "AFTER_DOCTYPE_NAME_STATE";
const $1402a60f2d09b0f9$var$AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE";
const $1402a60f2d09b0f9$var$BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE";
const $1402a60f2d09b0f9$var$DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE";
const $1402a60f2d09b0f9$var$DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE";
const $1402a60f2d09b0f9$var$AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE";
const $1402a60f2d09b0f9$var$BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE";
const $1402a60f2d09b0f9$var$AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE";
const $1402a60f2d09b0f9$var$BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE";
const $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE";
const $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE";
const $1402a60f2d09b0f9$var$AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE";
const $1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE = "BOGUS_DOCTYPE_STATE";
const $1402a60f2d09b0f9$var$CDATA_SECTION_STATE = "CDATA_SECTION_STATE";
const $1402a60f2d09b0f9$var$CDATA_SECTION_BRACKET_STATE = "CDATA_SECTION_BRACKET_STATE";
const $1402a60f2d09b0f9$var$CDATA_SECTION_END_STATE = "CDATA_SECTION_END_STATE";
const $1402a60f2d09b0f9$var$CHARACTER_REFERENCE_STATE = "CHARACTER_REFERENCE_STATE";
const $1402a60f2d09b0f9$var$NAMED_CHARACTER_REFERENCE_STATE = "NAMED_CHARACTER_REFERENCE_STATE";
const $1402a60f2d09b0f9$var$AMBIGUOUS_AMPERSAND_STATE = "AMBIGUOS_AMPERSAND_STATE";
const $1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_STATE = "NUMERIC_CHARACTER_REFERENCE_STATE";
const $1402a60f2d09b0f9$var$HEXADEMICAL_CHARACTER_REFERENCE_START_STATE = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE";
const $1402a60f2d09b0f9$var$DECIMAL_CHARACTER_REFERENCE_START_STATE = "DECIMAL_CHARACTER_REFERENCE_START_STATE";
const $1402a60f2d09b0f9$var$HEXADEMICAL_CHARACTER_REFERENCE_STATE = "HEXADEMICAL_CHARACTER_REFERENCE_STATE";
const $1402a60f2d09b0f9$var$DECIMAL_CHARACTER_REFERENCE_STATE = "DECIMAL_CHARACTER_REFERENCE_STATE";
const $1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_END_STATE = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
//Utils
//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function $1402a60f2d09b0f9$var$isWhitespace(cp) {
    return cp === $1402a60f2d09b0f9$var$$.SPACE || cp === $1402a60f2d09b0f9$var$$.LINE_FEED || cp === $1402a60f2d09b0f9$var$$.TABULATION || cp === $1402a60f2d09b0f9$var$$.FORM_FEED;
}
function $1402a60f2d09b0f9$var$isAsciiDigit(cp) {
    return cp >= $1402a60f2d09b0f9$var$$.DIGIT_0 && cp <= $1402a60f2d09b0f9$var$$.DIGIT_9;
}
function $1402a60f2d09b0f9$var$isAsciiUpper(cp) {
    return cp >= $1402a60f2d09b0f9$var$$.LATIN_CAPITAL_A && cp <= $1402a60f2d09b0f9$var$$.LATIN_CAPITAL_Z;
}
function $1402a60f2d09b0f9$var$isAsciiLower(cp) {
    return cp >= $1402a60f2d09b0f9$var$$.LATIN_SMALL_A && cp <= $1402a60f2d09b0f9$var$$.LATIN_SMALL_Z;
}
function $1402a60f2d09b0f9$var$isAsciiLetter(cp) {
    return $1402a60f2d09b0f9$var$isAsciiLower(cp) || $1402a60f2d09b0f9$var$isAsciiUpper(cp);
}
function $1402a60f2d09b0f9$var$isAsciiAlphaNumeric(cp) {
    return $1402a60f2d09b0f9$var$isAsciiLetter(cp) || $1402a60f2d09b0f9$var$isAsciiDigit(cp);
}
function $1402a60f2d09b0f9$var$isAsciiUpperHexDigit(cp) {
    return cp >= $1402a60f2d09b0f9$var$$.LATIN_CAPITAL_A && cp <= $1402a60f2d09b0f9$var$$.LATIN_CAPITAL_F;
}
function $1402a60f2d09b0f9$var$isAsciiLowerHexDigit(cp) {
    return cp >= $1402a60f2d09b0f9$var$$.LATIN_SMALL_A && cp <= $1402a60f2d09b0f9$var$$.LATIN_SMALL_F;
}
function $1402a60f2d09b0f9$var$isAsciiHexDigit(cp) {
    return $1402a60f2d09b0f9$var$isAsciiDigit(cp) || $1402a60f2d09b0f9$var$isAsciiUpperHexDigit(cp) || $1402a60f2d09b0f9$var$isAsciiLowerHexDigit(cp);
}
function $1402a60f2d09b0f9$var$toAsciiLowerCodePoint(cp) {
    return cp + 0x0020;
}
//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
//So, we need to workaround this manually.
//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
function $1402a60f2d09b0f9$var$toChar(cp) {
    if (cp <= 0xffff) return String.fromCharCode(cp);
    cp -= 0x10000;
    return String.fromCharCode(cp >>> 10 & 0x3ff | 0xd800) + String.fromCharCode(0xdc00 | cp & 0x3ff);
}
function $1402a60f2d09b0f9$var$toAsciiLowerChar(cp) {
    return String.fromCharCode($1402a60f2d09b0f9$var$toAsciiLowerCodePoint(cp));
}
function $1402a60f2d09b0f9$var$findNamedEntityTreeBranch(nodeIx, cp) {
    const branchCount = $9849b1bcc152963f$exports[++nodeIx];
    let lo = ++nodeIx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midCp = $9849b1bcc152963f$exports[mid];
        if (midCp < cp) lo = mid + 1;
        else if (midCp > cp) hi = mid - 1;
        else return $9849b1bcc152963f$exports[mid + branchCount];
    }
    return -1;
}
//Tokenizer
class $1402a60f2d09b0f9$var$Tokenizer {
    constructor(){
        this.preprocessor = new $14db446065d7ad01$exports();
        this.tokenQueue = [];
        this.allowCDATA = false;
        this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        this.returnState = "";
        this.charRefCode = -1;
        this.tempBuff = [];
        this.lastStartTagName = "";
        this.consumedAfterSnapshot = -1;
        this.active = false;
        this.currentCharacterToken = null;
        this.currentToken = null;
        this.currentAttr = null;
    }
    //Errors
    _err() {
    // NOTE: err reporting is noop by default. Enabled by mixin.
    }
    _errOnNextCodePoint(err) {
        this._consume();
        this._err(err);
        this._unconsume();
    }
    //API
    getNextToken() {
        while(!this.tokenQueue.length && this.active){
            this.consumedAfterSnapshot = 0;
            const cp = this._consume();
            if (!this._ensureHibernation()) this[this.state](cp);
        }
        return this.tokenQueue.shift();
    }
    write(chunk, isLastChunk) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
    }
    insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
    }
    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            for(; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)this.preprocessor.retreat();
            this.active = false;
            this.tokenQueue.push({
                type: $1402a60f2d09b0f9$var$Tokenizer.HIBERNATION_TOKEN
            });
            return true;
        }
        return false;
    }
    //Consumption
    _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
    }
    _unconsume() {
        this.consumedAfterSnapshot--;
        this.preprocessor.retreat();
    }
    _reconsumeInState(state) {
        this.state = state;
        this._unconsume();
    }
    _consumeSequenceIfMatch(pattern, startCp, caseSensitive) {
        let consumedCount = 0;
        let isMatch = true;
        const patternLength = pattern.length;
        let patternPos = 0;
        let cp = startCp;
        let patternCp = void 0;
        for(; patternPos < patternLength; patternPos++){
            if (patternPos > 0) {
                cp = this._consume();
                consumedCount++;
            }
            if (cp === $1402a60f2d09b0f9$var$$.EOF) {
                isMatch = false;
                break;
            }
            patternCp = pattern[patternPos];
            if (cp !== patternCp && (caseSensitive || cp !== $1402a60f2d09b0f9$var$toAsciiLowerCodePoint(patternCp))) {
                isMatch = false;
                break;
            }
        }
        if (!isMatch) while(consumedCount--)this._unconsume();
        return isMatch;
    }
    //Temp buffer
    _isTempBufferEqualToScriptString() {
        if (this.tempBuff.length !== $1402a60f2d09b0f9$var$$$.SCRIPT_STRING.length) return false;
        for(let i = 0; i < this.tempBuff.length; i++){
            if (this.tempBuff[i] !== $1402a60f2d09b0f9$var$$$.SCRIPT_STRING[i]) return false;
        }
        return true;
    }
    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: $1402a60f2d09b0f9$var$Tokenizer.START_TAG_TOKEN,
            tagName: "",
            selfClosing: false,
            ackSelfClosing: false,
            attrs: []
        };
    }
    _createEndTagToken() {
        this.currentToken = {
            type: $1402a60f2d09b0f9$var$Tokenizer.END_TAG_TOKEN,
            tagName: "",
            selfClosing: false,
            attrs: []
        };
    }
    _createCommentToken() {
        this.currentToken = {
            type: $1402a60f2d09b0f9$var$Tokenizer.COMMENT_TOKEN,
            data: ""
        };
    }
    _createDoctypeToken(initialName) {
        this.currentToken = {
            type: $1402a60f2d09b0f9$var$Tokenizer.DOCTYPE_TOKEN,
            name: initialName,
            forceQuirks: false,
            publicId: null,
            systemId: null
        };
    }
    _createCharacterToken(type, ch) {
        this.currentCharacterToken = {
            type: type,
            chars: ch
        };
    }
    _createEOFToken() {
        this.currentToken = {
            type: $1402a60f2d09b0f9$var$Tokenizer.EOF_TOKEN
        };
    }
    //Tag attributes
    _createAttr(attrNameFirstCh) {
        this.currentAttr = {
            name: attrNameFirstCh,
            value: ""
        };
    }
    _leaveAttrName(toState) {
        if ($1402a60f2d09b0f9$var$Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) === null) this.currentToken.attrs.push(this.currentAttr);
        else this._err($17010537ac9d51f5$exports.duplicateAttribute);
        this.state = toState;
    }
    _leaveAttrValue(toState) {
        this.state = toState;
    }
    //Token emission
    _emitCurrentToken() {
        this._emitCurrentCharacterToken();
        const ct = this.currentToken;
        this.currentToken = null;
        //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
        if (ct.type === $1402a60f2d09b0f9$var$Tokenizer.START_TAG_TOKEN) this.lastStartTagName = ct.tagName;
        else if (ct.type === $1402a60f2d09b0f9$var$Tokenizer.END_TAG_TOKEN) {
            if (ct.attrs.length > 0) this._err($17010537ac9d51f5$exports.endTagWithAttributes);
            if (ct.selfClosing) this._err($17010537ac9d51f5$exports.endTagWithTrailingSolidus);
        }
        this.tokenQueue.push(ct);
    }
    _emitCurrentCharacterToken() {
        if (this.currentCharacterToken) {
            this.tokenQueue.push(this.currentCharacterToken);
            this.currentCharacterToken = null;
        }
    }
    _emitEOFToken() {
        this._createEOFToken();
        this._emitCurrentToken();
    }
    //Characters emission
    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(type, ch) {
        if (this.currentCharacterToken && this.currentCharacterToken.type !== type) this._emitCurrentCharacterToken();
        if (this.currentCharacterToken) this.currentCharacterToken.chars += ch;
        else this._createCharacterToken(type, ch);
    }
    _emitCodePoint(cp) {
        let type = $1402a60f2d09b0f9$var$Tokenizer.CHARACTER_TOKEN;
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) type = $1402a60f2d09b0f9$var$Tokenizer.WHITESPACE_CHARACTER_TOKEN;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) type = $1402a60f2d09b0f9$var$Tokenizer.NULL_CHARACTER_TOKEN;
        this._appendCharToCurrentCharacterToken(type, $1402a60f2d09b0f9$var$toChar(cp));
    }
    _emitSeveralCodePoints(codePoints) {
        for(let i = 0; i < codePoints.length; i++)this._emitCodePoint(codePoints[i]);
    }
    //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
    //So we can avoid additional checks here.
    _emitChars(ch) {
        this._appendCharToCurrentCharacterToken($1402a60f2d09b0f9$var$Tokenizer.CHARACTER_TOKEN, ch);
    }
    // Character reference helpers
    _matchNamedCharacterReference(startCp) {
        let result = null;
        let excess = 1;
        let i = $1402a60f2d09b0f9$var$findNamedEntityTreeBranch(0, startCp);
        this.tempBuff.push(startCp);
        while(i > -1){
            const current = $9849b1bcc152963f$exports[i];
            const inNode = current < $1402a60f2d09b0f9$var$MAX_BRANCH_MARKER_VALUE;
            const nodeWithData = inNode && current & $1402a60f2d09b0f9$var$HAS_DATA_FLAG;
            if (nodeWithData) {
                //NOTE: we use greedy search, so we continue lookup at this point
                result = current & $1402a60f2d09b0f9$var$DATA_DUPLET_FLAG ? [
                    $9849b1bcc152963f$exports[++i],
                    $9849b1bcc152963f$exports[++i]
                ] : [
                    $9849b1bcc152963f$exports[++i]
                ];
                excess = 0;
            }
            const cp = this._consume();
            this.tempBuff.push(cp);
            excess++;
            if (cp === $1402a60f2d09b0f9$var$$.EOF) break;
            if (inNode) i = current & $1402a60f2d09b0f9$var$HAS_BRANCHES_FLAG ? $1402a60f2d09b0f9$var$findNamedEntityTreeBranch(i, cp) : -1;
            else i = cp === current ? ++i : -1;
        }
        while(excess--){
            this.tempBuff.pop();
            this._unconsume();
        }
        return result;
    }
    _isCharacterReferenceInAttribute() {
        return this.returnState === $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE || this.returnState === $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE || this.returnState === $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_UNQUOTED_STATE;
    }
    _isCharacterReferenceAttributeQuirk(withSemicolon) {
        if (!withSemicolon && this._isCharacterReferenceInAttribute()) {
            const nextCp = this._consume();
            this._unconsume();
            return nextCp === $1402a60f2d09b0f9$var$$.EQUALS_SIGN || $1402a60f2d09b0f9$var$isAsciiAlphaNumeric(nextCp);
        }
        return false;
    }
    _flushCodePointsConsumedAsCharacterReference() {
        if (this._isCharacterReferenceInAttribute()) for(let i = 0; i < this.tempBuff.length; i++)this.currentAttr.value += $1402a60f2d09b0f9$var$toChar(this.tempBuff[i]);
        else this._emitSeveralCodePoints(this.tempBuff);
        this.tempBuff = [];
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) this.state = $1402a60f2d09b0f9$var$TAG_OPEN_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.AMPERSAND) {
            this.returnState = $1402a60f2d09b0f9$var$DATA_STATE;
            this.state = $1402a60f2d09b0f9$var$CHARACTER_REFERENCE_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this._emitCodePoint(cp);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) this._emitEOFToken();
        else this._emitCodePoint(cp);
    }
    //  RCDATA state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$RCDATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $1402a60f2d09b0f9$var$$.AMPERSAND) {
            this.returnState = $1402a60f2d09b0f9$var$RCDATA_STATE;
            this.state = $1402a60f2d09b0f9$var$CHARACTER_REFERENCE_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) this.state = $1402a60f2d09b0f9$var$RCDATA_LESS_THAN_SIGN_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) this._emitEOFToken();
        else this._emitCodePoint(cp);
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$RAWTEXT_STATE](cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) this.state = $1402a60f2d09b0f9$var$RAWTEXT_LESS_THAN_SIGN_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) this._emitEOFToken();
        else this._emitCodePoint(cp);
    }
    // Script data state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_LESS_THAN_SIGN_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) this._emitEOFToken();
        else this._emitCodePoint(cp);
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$PLAINTEXT_STATE](cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) this._emitEOFToken();
        else this._emitCodePoint(cp);
    }
    // Tag open state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$TAG_OPEN_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.EXCLAMATION_MARK) this.state = $1402a60f2d09b0f9$var$MARKUP_DECLARATION_OPEN_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) this.state = $1402a60f2d09b0f9$var$END_TAG_OPEN_STATE;
        else if ($1402a60f2d09b0f9$var$isAsciiLetter(cp)) {
            this._createStartTagToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$TAG_NAME_STATE);
        } else if (cp === $1402a60f2d09b0f9$var$$.QUESTION_MARK) {
            this._err($17010537ac9d51f5$exports.unexpectedQuestionMarkInsteadOfTagName);
            this._createCommentToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_COMMENT_STATE);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofBeforeTagName);
            this._emitChars("<");
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.invalidFirstCharacterOfTagName);
            this._emitChars("<");
            this._reconsumeInState($1402a60f2d09b0f9$var$DATA_STATE);
        }
    }
    // End tag open state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$END_TAG_OPEN_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$TAG_NAME_STATE);
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.missingEndTagName);
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofBeforeTagName);
            this._emitChars("</");
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.invalidFirstCharacterOfTagName);
            this._createCommentToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_COMMENT_STATE);
        }
    }
    // Tag name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$TAG_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) this.state = $1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) this.state = $1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) this.currentToken.tagName += $1402a60f2d09b0f9$var$toAsciiLowerChar(cp);
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentToken.tagName += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInTag);
            this._emitEOFToken();
        } else this.currentToken.tagName += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$RCDATA_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
            this.tempBuff = [];
            this.state = $1402a60f2d09b0f9$var$RCDATA_END_TAG_OPEN_STATE;
        } else {
            this._emitChars("<");
            this._reconsumeInState($1402a60f2d09b0f9$var$RCDATA_STATE);
        }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$RCDATA_END_TAG_OPEN_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$RCDATA_END_TAG_NAME_STATE);
        } else {
            this._emitChars("</");
            this._reconsumeInState($1402a60f2d09b0f9$var$RCDATA_STATE);
        }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$RCDATA_END_TAG_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) {
            this.currentToken.tagName += $1402a60f2d09b0f9$var$toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if ($1402a60f2d09b0f9$var$isAsciiLower(cp)) {
            this.currentToken.tagName += $1402a60f2d09b0f9$var$toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if ($1402a60f2d09b0f9$var$isWhitespace(cp)) {
                    this.state = $1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }
                if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
                    this.state = $1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE;
                    return;
                }
                if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
                    this.state = $1402a60f2d09b0f9$var$DATA_STATE;
                    this._emitCurrentToken();
                    return;
                }
            }
            this._emitChars("</");
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState($1402a60f2d09b0f9$var$RCDATA_STATE);
        }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$RAWTEXT_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
            this.tempBuff = [];
            this.state = $1402a60f2d09b0f9$var$RAWTEXT_END_TAG_OPEN_STATE;
        } else {
            this._emitChars("<");
            this._reconsumeInState($1402a60f2d09b0f9$var$RAWTEXT_STATE);
        }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$RAWTEXT_END_TAG_OPEN_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$RAWTEXT_END_TAG_NAME_STATE);
        } else {
            this._emitChars("</");
            this._reconsumeInState($1402a60f2d09b0f9$var$RAWTEXT_STATE);
        }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$RAWTEXT_END_TAG_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) {
            this.currentToken.tagName += $1402a60f2d09b0f9$var$toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if ($1402a60f2d09b0f9$var$isAsciiLower(cp)) {
            this.currentToken.tagName += $1402a60f2d09b0f9$var$toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if ($1402a60f2d09b0f9$var$isWhitespace(cp)) {
                    this.state = $1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }
                if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
                    this.state = $1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE;
                    return;
                }
                if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = $1402a60f2d09b0f9$var$DATA_STATE;
                    return;
                }
            }
            this._emitChars("</");
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState($1402a60f2d09b0f9$var$RAWTEXT_STATE);
        }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
            this.tempBuff = [];
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_END_TAG_OPEN_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EXCLAMATION_MARK) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPE_START_STATE;
            this._emitChars("<!");
        } else {
            this._emitChars("<");
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_STATE);
        }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_END_TAG_OPEN_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_END_TAG_NAME_STATE);
        } else {
            this._emitChars("</");
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_STATE);
        }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_END_TAG_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) {
            this.currentToken.tagName += $1402a60f2d09b0f9$var$toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if ($1402a60f2d09b0f9$var$isAsciiLower(cp)) {
            this.currentToken.tagName += $1402a60f2d09b0f9$var$toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if ($1402a60f2d09b0f9$var$isWhitespace(cp)) {
                    this.state = $1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                } else if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
                    this.state = $1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE;
                    return;
                } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = $1402a60f2d09b0f9$var$DATA_STATE;
                    return;
                }
            }
            this._emitChars("</");
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_STATE);
        }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPE_START_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPE_START_DASH_STATE;
            this._emitChars("-");
        } else this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_STATE);
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPE_START_DASH_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
            this._emitChars("-");
        } else this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_STATE);
    }
    // Script data escaped state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_DASH_STATE;
            this._emitChars("-");
        } else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else this._emitCodePoint(cp);
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_DASH_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
            this._emitChars("-");
        } else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE;
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_DASH_DASH_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this._emitChars("-");
        else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_STATE;
            this._emitChars(">");
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE;
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
            this.tempBuff = [];
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
        } else if ($1402a60f2d09b0f9$var$isAsciiLetter(cp)) {
            this.tempBuff = [];
            this._emitChars("<");
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
        } else {
            this._emitChars("<");
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE);
        }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
        } else {
            this._emitChars("</");
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE);
        }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) {
            this.currentToken.tagName += $1402a60f2d09b0f9$var$toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if ($1402a60f2d09b0f9$var$isAsciiLower(cp)) {
            this.currentToken.tagName += $1402a60f2d09b0f9$var$toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if ($1402a60f2d09b0f9$var$isWhitespace(cp)) {
                    this.state = $1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }
                if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
                    this.state = $1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE;
                    return;
                }
                if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = $1402a60f2d09b0f9$var$DATA_STATE;
                    return;
                }
            }
            this._emitChars("</");
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE);
        }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp) || cp === $1402a60f2d09b0f9$var$$.SOLIDUS || cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = this._isTempBufferEqualToScriptString() ? $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE : $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        } else if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) {
            this.tempBuff.push($1402a60f2d09b0f9$var$toAsciiLowerCodePoint(cp));
            this._emitCodePoint(cp);
        } else if ($1402a60f2d09b0f9$var$isAsciiLower(cp)) {
            this.tempBuff.push(cp);
            this._emitCodePoint(cp);
        } else this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE);
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
            this._emitChars("-");
        } else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars("<");
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else this._emitCodePoint(cp);
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
            this._emitChars("-");
        } else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars("<");
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this._emitChars("-");
        else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars("<");
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_STATE;
            this._emitChars(">");
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitChars($4e69a73910c07b7d$export$e8d20e7a50e6c279);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) {
            this.tempBuff = [];
            this.state = $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
            this._emitChars("/");
        } else this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp) || cp === $1402a60f2d09b0f9$var$$.SOLIDUS || cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = this._isTempBufferEqualToScriptString() ? $1402a60f2d09b0f9$var$SCRIPT_DATA_ESCAPED_STATE : $1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitCodePoint(cp);
        } else if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) {
            this.tempBuff.push($1402a60f2d09b0f9$var$toAsciiLowerCodePoint(cp));
            this._emitCodePoint(cp);
        } else if ($1402a60f2d09b0f9$var$isAsciiLower(cp)) {
            this.tempBuff.push(cp);
            this._emitCodePoint(cp);
        } else this._reconsumeInState($1402a60f2d09b0f9$var$SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
    }
    // Before attribute name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS || cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN || cp === $1402a60f2d09b0f9$var$$.EOF) this._reconsumeInState($1402a60f2d09b0f9$var$AFTER_ATTRIBUTE_NAME_STATE);
        else if (cp === $1402a60f2d09b0f9$var$$.EQUALS_SIGN) {
            this._err($17010537ac9d51f5$exports.unexpectedEqualsSignBeforeAttributeName);
            this._createAttr("=");
            this.state = $1402a60f2d09b0f9$var$ATTRIBUTE_NAME_STATE;
        } else {
            this._createAttr("");
            this._reconsumeInState($1402a60f2d09b0f9$var$ATTRIBUTE_NAME_STATE);
        }
    }
    // Attribute name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$ATTRIBUTE_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp) || cp === $1402a60f2d09b0f9$var$$.SOLIDUS || cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN || cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._leaveAttrName($1402a60f2d09b0f9$var$AFTER_ATTRIBUTE_NAME_STATE);
            this._unconsume();
        } else if (cp === $1402a60f2d09b0f9$var$$.EQUALS_SIGN) this._leaveAttrName($1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_VALUE_STATE);
        else if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) this.currentAttr.name += $1402a60f2d09b0f9$var$toAsciiLowerChar(cp);
        else if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK || cp === $1402a60f2d09b0f9$var$$.APOSTROPHE || cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.unexpectedCharacterInAttributeName);
            this.currentAttr.name += $1402a60f2d09b0f9$var$toChar(cp);
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentAttr.name += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else this.currentAttr.name += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // After attribute name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$AFTER_ATTRIBUTE_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) this.state = $1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.EQUALS_SIGN) this.state = $1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_VALUE_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInTag);
            this._emitEOFToken();
        } else {
            this._createAttr("");
            this._reconsumeInState($1402a60f2d09b0f9$var$ATTRIBUTE_NAME_STATE);
        }
    }
    // Before attribute value state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_VALUE_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) this.state = $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) this.state = $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.missingAttributeValue);
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else this._reconsumeInState($1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_UNQUOTED_STATE);
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) this.state = $1402a60f2d09b0f9$var$AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.AMPERSAND) {
            this.returnState = $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
            this.state = $1402a60f2d09b0f9$var$CHARACTER_REFERENCE_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentAttr.value += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInTag);
            this._emitEOFToken();
        } else this.currentAttr.value += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) this.state = $1402a60f2d09b0f9$var$AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.AMPERSAND) {
            this.returnState = $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
            this.state = $1402a60f2d09b0f9$var$CHARACTER_REFERENCE_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentAttr.value += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInTag);
            this._emitEOFToken();
        } else this.currentAttr.value += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_UNQUOTED_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) this._leaveAttrValue($1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE);
        else if (cp === $1402a60f2d09b0f9$var$$.AMPERSAND) {
            this.returnState = $1402a60f2d09b0f9$var$ATTRIBUTE_VALUE_UNQUOTED_STATE;
            this.state = $1402a60f2d09b0f9$var$CHARACTER_REFERENCE_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._leaveAttrValue($1402a60f2d09b0f9$var$DATA_STATE);
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentAttr.value += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK || cp === $1402a60f2d09b0f9$var$$.APOSTROPHE || cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN || cp === $1402a60f2d09b0f9$var$$.EQUALS_SIGN || cp === $1402a60f2d09b0f9$var$$.GRAVE_ACCENT) {
            this._err($17010537ac9d51f5$exports.unexpectedCharacterInUnquotedAttributeValue);
            this.currentAttr.value += $1402a60f2d09b0f9$var$toChar(cp);
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInTag);
            this._emitEOFToken();
        } else this.currentAttr.value += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$AFTER_ATTRIBUTE_VALUE_QUOTED_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) this._leaveAttrValue($1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE);
        else if (cp === $1402a60f2d09b0f9$var$$.SOLIDUS) this._leaveAttrValue($1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE);
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._leaveAttrValue($1402a60f2d09b0f9$var$DATA_STATE);
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInTag);
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.missingWhitespaceBetweenAttributes);
            this._reconsumeInState($1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE);
        }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$SELF_CLOSING_START_TAG_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.currentToken.selfClosing = true;
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInTag);
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.unexpectedSolidusInTag);
            this._reconsumeInState($1402a60f2d09b0f9$var$BEFORE_ATTRIBUTE_NAME_STATE);
        }
    }
    // Bogus comment state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$BOGUS_COMMENT_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._emitCurrentToken();
            this._emitEOFToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentToken.data += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else this.currentToken.data += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$MARKUP_DECLARATION_OPEN_STATE](cp) {
        if (this._consumeSequenceIfMatch($1402a60f2d09b0f9$var$$$.DASH_DASH_STRING, cp, true)) {
            this._createCommentToken();
            this.state = $1402a60f2d09b0f9$var$COMMENT_START_STATE;
        } else if (this._consumeSequenceIfMatch($1402a60f2d09b0f9$var$$$.DOCTYPE_STRING, cp, false)) this.state = $1402a60f2d09b0f9$var$DOCTYPE_STATE;
        else if (this._consumeSequenceIfMatch($1402a60f2d09b0f9$var$$$.CDATA_START_STRING, cp, true)) {
            if (this.allowCDATA) this.state = $1402a60f2d09b0f9$var$CDATA_SECTION_STATE;
            else {
                this._err($17010537ac9d51f5$exports.cdataInHtmlContent);
                this._createCommentToken();
                this.currentToken.data = "[CDATA[";
                this.state = $1402a60f2d09b0f9$var$BOGUS_COMMENT_STATE;
            }
        } else if (!this._ensureHibernation()) {
            this._err($17010537ac9d51f5$exports.incorrectlyOpenedComment);
            this._createCommentToken();
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_COMMENT_STATE);
        }
    }
    // Comment start state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_START_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this.state = $1402a60f2d09b0f9$var$COMMENT_START_DASH_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.abruptClosingOfEmptyComment);
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_STATE);
    }
    // Comment start dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_START_DASH_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this.state = $1402a60f2d09b0f9$var$COMMENT_END_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.abruptClosingOfEmptyComment);
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += "-";
            this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_STATE);
        }
    }
    // Comment state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this.state = $1402a60f2d09b0f9$var$COMMENT_END_DASH_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) {
            this.currentToken.data += "<";
            this.state = $1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentToken.data += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else this.currentToken.data += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.EXCLAMATION_MARK) {
            this.currentToken.data += "!";
            this.state = $1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.LESS_THAN_SIGN) this.currentToken.data += "!";
        else this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_STATE);
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this.state = $1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE;
        else this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_STATE);
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this.state = $1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE;
        else this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_END_DASH_STATE);
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE](cp) {
        if (cp !== $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN && cp !== $1402a60f2d09b0f9$var$$.EOF) this._err($17010537ac9d51f5$exports.nestedComment);
        this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_END_STATE);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_END_DASH_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this.state = $1402a60f2d09b0f9$var$COMMENT_END_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += "-";
            this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_STATE);
        }
    }
    // Comment end state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_END_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EXCLAMATION_MARK) this.state = $1402a60f2d09b0f9$var$COMMENT_END_BANG_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) this.currentToken.data += "-";
        else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += "--";
            this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_STATE);
        }
    }
    // Comment end bang state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$COMMENT_END_BANG_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.HYPHEN_MINUS) {
            this.currentToken.data += "--!";
            this.state = $1402a60f2d09b0f9$var$COMMENT_END_DASH_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.incorrectlyClosedComment);
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += "--!";
            this._reconsumeInState($1402a60f2d09b0f9$var$COMMENT_STATE);
        }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DOCTYPE_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) this.state = $1402a60f2d09b0f9$var$BEFORE_DOCTYPE_NAME_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) this._reconsumeInState($1402a60f2d09b0f9$var$BEFORE_DOCTYPE_NAME_STATE);
        else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.missingWhitespaceBeforeDoctypeName);
            this._reconsumeInState($1402a60f2d09b0f9$var$BEFORE_DOCTYPE_NAME_STATE);
        }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$BEFORE_DOCTYPE_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) {
            this._createDoctypeToken($1402a60f2d09b0f9$var$toAsciiLowerChar(cp));
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_NAME_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this._createDoctypeToken($4e69a73910c07b7d$export$e8d20e7a50e6c279);
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_NAME_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.missingDoctypeName);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._createDoctypeToken($1402a60f2d09b0f9$var$toChar(cp));
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_NAME_STATE;
        }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DOCTYPE_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) this.state = $1402a60f2d09b0f9$var$AFTER_DOCTYPE_NAME_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if ($1402a60f2d09b0f9$var$isAsciiUpper(cp)) this.currentToken.name += $1402a60f2d09b0f9$var$toAsciiLowerChar(cp);
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentToken.name += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else this.currentToken.name += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$AFTER_DOCTYPE_NAME_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else if (this._consumeSequenceIfMatch($1402a60f2d09b0f9$var$$$.PUBLIC_STRING, cp, false)) this.state = $1402a60f2d09b0f9$var$AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE;
        else if (this._consumeSequenceIfMatch($1402a60f2d09b0f9$var$$$.SYSTEM_STRING, cp, false)) this.state = $1402a60f2d09b0f9$var$AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE;
        else if (!this._ensureHibernation()) {
            this._err($17010537ac9d51f5$exports.invalidCharacterSequenceAfterDoctypeName);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE);
        }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) this.state = $1402a60f2d09b0f9$var$BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) {
            this._err($17010537ac9d51f5$exports.missingWhitespaceAfterDoctypePublicKeyword);
            this.currentToken.publicId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) {
            this._err($17010537ac9d51f5$exports.missingWhitespaceAfterDoctypePublicKeyword);
            this.currentToken.publicId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.missingDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.missingQuoteBeforeDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE);
        }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) {
            this.currentToken.publicId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) {
            this.currentToken.publicId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.missingDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.missingQuoteBeforeDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE);
        }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) this.state = $1402a60f2d09b0f9$var$AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentToken.publicId += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.abruptDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else this.currentToken.publicId += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) this.state = $1402a60f2d09b0f9$var$AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentToken.publicId += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.abruptDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else this.currentToken.publicId += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) this.state = $1402a60f2d09b0f9$var$BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) {
            this._err($17010537ac9d51f5$exports.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
            this.currentToken.systemId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) {
            this._err($17010537ac9d51f5$exports.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
            this.currentToken.systemId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE);
        }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) {
            this.currentToken.systemId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) {
            this.currentToken.systemId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE);
        }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) this.state = $1402a60f2d09b0f9$var$BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) {
            this._err($17010537ac9d51f5$exports.missingWhitespaceAfterDoctypeSystemKeyword);
            this.currentToken.systemId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) {
            this._err($17010537ac9d51f5$exports.missingWhitespaceAfterDoctypeSystemKeyword);
            this.currentToken.systemId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.missingDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE);
        }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) {
            this.currentToken.systemId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) {
            this.currentToken.systemId = "";
            this.state = $1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.missingDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE);
        }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.QUOTATION_MARK) this.state = $1402a60f2d09b0f9$var$AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentToken.systemId += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.abruptDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else this.currentToken.systemId += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.APOSTROPHE) this.state = $1402a60f2d09b0f9$var$AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
            this.currentToken.systemId += $4e69a73910c07b7d$export$e8d20e7a50e6c279;
        } else if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._err($17010537ac9d51f5$exports.abruptDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else this.currentToken.systemId += $1402a60f2d09b0f9$var$toChar(cp);
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isWhitespace(cp)) return;
        if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err($17010537ac9d51f5$exports.unexpectedCharacterAfterDoctypeSystemIdentifier);
            this._reconsumeInState($1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE);
        }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$BOGUS_DOCTYPE_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        } else if (cp === $1402a60f2d09b0f9$var$$.NULL) this._err($17010537ac9d51f5$exports.unexpectedNullCharacter);
        else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._emitCurrentToken();
            this._emitEOFToken();
        }
    }
    // CDATA section state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$CDATA_SECTION_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.RIGHT_SQUARE_BRACKET) this.state = $1402a60f2d09b0f9$var$CDATA_SECTION_BRACKET_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.EOF) {
            this._err($17010537ac9d51f5$exports.eofInCdata);
            this._emitEOFToken();
        } else this._emitCodePoint(cp);
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$CDATA_SECTION_BRACKET_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.RIGHT_SQUARE_BRACKET) this.state = $1402a60f2d09b0f9$var$CDATA_SECTION_END_STATE;
        else {
            this._emitChars("]");
            this._reconsumeInState($1402a60f2d09b0f9$var$CDATA_SECTION_STATE);
        }
    }
    // CDATA section end state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$CDATA_SECTION_END_STATE](cp) {
        if (cp === $1402a60f2d09b0f9$var$$.GREATER_THAN_SIGN) this.state = $1402a60f2d09b0f9$var$DATA_STATE;
        else if (cp === $1402a60f2d09b0f9$var$$.RIGHT_SQUARE_BRACKET) this._emitChars("]");
        else {
            this._emitChars("]]");
            this._reconsumeInState($1402a60f2d09b0f9$var$CDATA_SECTION_STATE);
        }
    }
    // Character reference state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$CHARACTER_REFERENCE_STATE](cp) {
        this.tempBuff = [
            $1402a60f2d09b0f9$var$$.AMPERSAND
        ];
        if (cp === $1402a60f2d09b0f9$var$$.NUMBER_SIGN) {
            this.tempBuff.push(cp);
            this.state = $1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_STATE;
        } else if ($1402a60f2d09b0f9$var$isAsciiAlphaNumeric(cp)) this._reconsumeInState($1402a60f2d09b0f9$var$NAMED_CHARACTER_REFERENCE_STATE);
        else {
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }
    // Named character reference state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$NAMED_CHARACTER_REFERENCE_STATE](cp) {
        const matchResult = this._matchNamedCharacterReference(cp);
        //NOTE: matching can be abrupted by hibernation. In that case match
        //results are no longer valid and we will need to start over.
        if (this._ensureHibernation()) this.tempBuff = [
            $1402a60f2d09b0f9$var$$.AMPERSAND
        ];
        else if (matchResult) {
            const withSemicolon = this.tempBuff[this.tempBuff.length - 1] === $1402a60f2d09b0f9$var$$.SEMICOLON;
            if (!this._isCharacterReferenceAttributeQuirk(withSemicolon)) {
                if (!withSemicolon) this._errOnNextCodePoint($17010537ac9d51f5$exports.missingSemicolonAfterCharacterReference);
                this.tempBuff = matchResult;
            }
            this._flushCodePointsConsumedAsCharacterReference();
            this.state = this.returnState;
        } else {
            this._flushCodePointsConsumedAsCharacterReference();
            this.state = $1402a60f2d09b0f9$var$AMBIGUOUS_AMPERSAND_STATE;
        }
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$AMBIGUOUS_AMPERSAND_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiAlphaNumeric(cp)) {
            if (this._isCharacterReferenceInAttribute()) this.currentAttr.value += $1402a60f2d09b0f9$var$toChar(cp);
            else this._emitCodePoint(cp);
        } else {
            if (cp === $1402a60f2d09b0f9$var$$.SEMICOLON) this._err($17010537ac9d51f5$exports.unknownNamedCharacterReference);
            this._reconsumeInState(this.returnState);
        }
    }
    // Numeric character reference state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_STATE](cp) {
        this.charRefCode = 0;
        if (cp === $1402a60f2d09b0f9$var$$.LATIN_SMALL_X || cp === $1402a60f2d09b0f9$var$$.LATIN_CAPITAL_X) {
            this.tempBuff.push(cp);
            this.state = $1402a60f2d09b0f9$var$HEXADEMICAL_CHARACTER_REFERENCE_START_STATE;
        } else this._reconsumeInState($1402a60f2d09b0f9$var$DECIMAL_CHARACTER_REFERENCE_START_STATE);
    }
    // Hexademical character reference start state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$HEXADEMICAL_CHARACTER_REFERENCE_START_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiHexDigit(cp)) this._reconsumeInState($1402a60f2d09b0f9$var$HEXADEMICAL_CHARACTER_REFERENCE_STATE);
        else {
            this._err($17010537ac9d51f5$exports.absenceOfDigitsInNumericCharacterReference);
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }
    // Decimal character reference start state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DECIMAL_CHARACTER_REFERENCE_START_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiDigit(cp)) this._reconsumeInState($1402a60f2d09b0f9$var$DECIMAL_CHARACTER_REFERENCE_STATE);
        else {
            this._err($17010537ac9d51f5$exports.absenceOfDigitsInNumericCharacterReference);
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }
    // Hexademical character reference state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$HEXADEMICAL_CHARACTER_REFERENCE_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiUpperHexDigit(cp)) this.charRefCode = this.charRefCode * 16 + cp - 0x37;
        else if ($1402a60f2d09b0f9$var$isAsciiLowerHexDigit(cp)) this.charRefCode = this.charRefCode * 16 + cp - 0x57;
        else if ($1402a60f2d09b0f9$var$isAsciiDigit(cp)) this.charRefCode = this.charRefCode * 16 + cp - 0x30;
        else if (cp === $1402a60f2d09b0f9$var$$.SEMICOLON) this.state = $1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_END_STATE;
        else {
            this._err($17010537ac9d51f5$exports.missingSemicolonAfterCharacterReference);
            this._reconsumeInState($1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_END_STATE);
        }
    }
    // Decimal character reference state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$DECIMAL_CHARACTER_REFERENCE_STATE](cp) {
        if ($1402a60f2d09b0f9$var$isAsciiDigit(cp)) this.charRefCode = this.charRefCode * 10 + cp - 0x30;
        else if (cp === $1402a60f2d09b0f9$var$$.SEMICOLON) this.state = $1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_END_STATE;
        else {
            this._err($17010537ac9d51f5$exports.missingSemicolonAfterCharacterReference);
            this._reconsumeInState($1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_END_STATE);
        }
    }
    // Numeric character reference end state
    //------------------------------------------------------------------
    [$1402a60f2d09b0f9$var$NUMERIC_CHARACTER_REFERENCE_END_STATE]() {
        if (this.charRefCode === $1402a60f2d09b0f9$var$$.NULL) {
            this._err($17010537ac9d51f5$exports.nullCharacterReference);
            this.charRefCode = $1402a60f2d09b0f9$var$$.REPLACEMENT_CHARACTER;
        } else if (this.charRefCode > 0x10ffff) {
            this._err($17010537ac9d51f5$exports.characterReferenceOutsideUnicodeRange);
            this.charRefCode = $1402a60f2d09b0f9$var$$.REPLACEMENT_CHARACTER;
        } else if ($4e69a73910c07b7d$export$7e678b42035e707f(this.charRefCode)) {
            this._err($17010537ac9d51f5$exports.surrogateCharacterReference);
            this.charRefCode = $1402a60f2d09b0f9$var$$.REPLACEMENT_CHARACTER;
        } else if ($4e69a73910c07b7d$export$b3484aaf321bda02(this.charRefCode)) this._err($17010537ac9d51f5$exports.noncharacterCharacterReference);
        else if ($4e69a73910c07b7d$export$d6953a6077926e(this.charRefCode) || this.charRefCode === $1402a60f2d09b0f9$var$$.CARRIAGE_RETURN) {
            this._err($17010537ac9d51f5$exports.controlCharacterReference);
            const replacement = $1402a60f2d09b0f9$var$C1_CONTROLS_REFERENCE_REPLACEMENTS[this.charRefCode];
            if (replacement) this.charRefCode = replacement;
        }
        this.tempBuff = [
            this.charRefCode
        ];
        this._flushCodePointsConsumedAsCharacterReference();
        this._reconsumeInState(this.returnState);
    }
}
//Token types
$1402a60f2d09b0f9$var$Tokenizer.CHARACTER_TOKEN = "CHARACTER_TOKEN";
$1402a60f2d09b0f9$var$Tokenizer.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
$1402a60f2d09b0f9$var$Tokenizer.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
$1402a60f2d09b0f9$var$Tokenizer.START_TAG_TOKEN = "START_TAG_TOKEN";
$1402a60f2d09b0f9$var$Tokenizer.END_TAG_TOKEN = "END_TAG_TOKEN";
$1402a60f2d09b0f9$var$Tokenizer.COMMENT_TOKEN = "COMMENT_TOKEN";
$1402a60f2d09b0f9$var$Tokenizer.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
$1402a60f2d09b0f9$var$Tokenizer.EOF_TOKEN = "EOF_TOKEN";
$1402a60f2d09b0f9$var$Tokenizer.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
//Tokenizer initial states for different modes
$1402a60f2d09b0f9$var$Tokenizer.MODE = {
    DATA: $1402a60f2d09b0f9$var$DATA_STATE,
    RCDATA: $1402a60f2d09b0f9$var$RCDATA_STATE,
    RAWTEXT: $1402a60f2d09b0f9$var$RAWTEXT_STATE,
    SCRIPT_DATA: $1402a60f2d09b0f9$var$SCRIPT_DATA_STATE,
    PLAINTEXT: $1402a60f2d09b0f9$var$PLAINTEXT_STATE
};
//Static
$1402a60f2d09b0f9$var$Tokenizer.getTokenAttr = function(token, attrName) {
    for(let i = token.attrs.length - 1; i >= 0; i--){
        if (token.attrs[i].name === attrName) return token.attrs[i].value;
    }
    return null;
};
$1402a60f2d09b0f9$exports = $1402a60f2d09b0f9$var$Tokenizer;


var $6010bf3e76553f22$exports = {};
"use strict";
var $7f14ef296305472a$export$4d2fb7344096e022;
var $7f14ef296305472a$export$380b7bc9e6cb1918;
var $7f14ef296305472a$export$a74d46c85337d29a;
var $7f14ef296305472a$export$7e674a85a2656dce;
var $7f14ef296305472a$export$7e5172336f7d2bbb;
"use strict";
const $7f14ef296305472a$var$NS = $7f14ef296305472a$export$4d2fb7344096e022 = {
    HTML: "http://www.w3.org/1999/xhtml",
    MATHML: "http://www.w3.org/1998/Math/MathML",
    SVG: "http://www.w3.org/2000/svg",
    XLINK: "http://www.w3.org/1999/xlink",
    XML: "http://www.w3.org/XML/1998/namespace",
    XMLNS: "http://www.w3.org/2000/xmlns/"
};
$7f14ef296305472a$export$380b7bc9e6cb1918 = {
    TYPE: "type",
    ACTION: "action",
    ENCODING: "encoding",
    PROMPT: "prompt",
    NAME: "name",
    COLOR: "color",
    FACE: "face",
    SIZE: "size"
};
$7f14ef296305472a$export$a74d46c85337d29a = {
    NO_QUIRKS: "no-quirks",
    QUIRKS: "quirks",
    LIMITED_QUIRKS: "limited-quirks"
};
const $7f14ef296305472a$var$$ = $7f14ef296305472a$export$7e674a85a2656dce = {
    A: "a",
    ADDRESS: "address",
    ANNOTATION_XML: "annotation-xml",
    APPLET: "applet",
    AREA: "area",
    ARTICLE: "article",
    ASIDE: "aside",
    B: "b",
    BASE: "base",
    BASEFONT: "basefont",
    BGSOUND: "bgsound",
    BIG: "big",
    BLOCKQUOTE: "blockquote",
    BODY: "body",
    BR: "br",
    BUTTON: "button",
    CAPTION: "caption",
    CENTER: "center",
    CODE: "code",
    COL: "col",
    COLGROUP: "colgroup",
    DD: "dd",
    DESC: "desc",
    DETAILS: "details",
    DIALOG: "dialog",
    DIR: "dir",
    DIV: "div",
    DL: "dl",
    DT: "dt",
    EM: "em",
    EMBED: "embed",
    FIELDSET: "fieldset",
    FIGCAPTION: "figcaption",
    FIGURE: "figure",
    FONT: "font",
    FOOTER: "footer",
    FOREIGN_OBJECT: "foreignObject",
    FORM: "form",
    FRAME: "frame",
    FRAMESET: "frameset",
    H1: "h1",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    H5: "h5",
    H6: "h6",
    HEAD: "head",
    HEADER: "header",
    HGROUP: "hgroup",
    HR: "hr",
    HTML: "html",
    I: "i",
    IMG: "img",
    IMAGE: "image",
    INPUT: "input",
    IFRAME: "iframe",
    KEYGEN: "keygen",
    LABEL: "label",
    LI: "li",
    LINK: "link",
    LISTING: "listing",
    MAIN: "main",
    MALIGNMARK: "malignmark",
    MARQUEE: "marquee",
    MATH: "math",
    MENU: "menu",
    META: "meta",
    MGLYPH: "mglyph",
    MI: "mi",
    MO: "mo",
    MN: "mn",
    MS: "ms",
    MTEXT: "mtext",
    NAV: "nav",
    NOBR: "nobr",
    NOFRAMES: "noframes",
    NOEMBED: "noembed",
    NOSCRIPT: "noscript",
    OBJECT: "object",
    OL: "ol",
    OPTGROUP: "optgroup",
    OPTION: "option",
    P: "p",
    PARAM: "param",
    PLAINTEXT: "plaintext",
    PRE: "pre",
    RB: "rb",
    RP: "rp",
    RT: "rt",
    RTC: "rtc",
    RUBY: "ruby",
    S: "s",
    SCRIPT: "script",
    SECTION: "section",
    SELECT: "select",
    SOURCE: "source",
    SMALL: "small",
    SPAN: "span",
    STRIKE: "strike",
    STRONG: "strong",
    STYLE: "style",
    SUB: "sub",
    SUMMARY: "summary",
    SUP: "sup",
    TABLE: "table",
    TBODY: "tbody",
    TEMPLATE: "template",
    TEXTAREA: "textarea",
    TFOOT: "tfoot",
    TD: "td",
    TH: "th",
    THEAD: "thead",
    TITLE: "title",
    TR: "tr",
    TRACK: "track",
    TT: "tt",
    U: "u",
    UL: "ul",
    SVG: "svg",
    VAR: "var",
    WBR: "wbr",
    XMP: "xmp"
};
$7f14ef296305472a$export$7e5172336f7d2bbb = {
    [$7f14ef296305472a$var$NS.HTML]: {
        [$7f14ef296305472a$var$$.ADDRESS]: true,
        [$7f14ef296305472a$var$$.APPLET]: true,
        [$7f14ef296305472a$var$$.AREA]: true,
        [$7f14ef296305472a$var$$.ARTICLE]: true,
        [$7f14ef296305472a$var$$.ASIDE]: true,
        [$7f14ef296305472a$var$$.BASE]: true,
        [$7f14ef296305472a$var$$.BASEFONT]: true,
        [$7f14ef296305472a$var$$.BGSOUND]: true,
        [$7f14ef296305472a$var$$.BLOCKQUOTE]: true,
        [$7f14ef296305472a$var$$.BODY]: true,
        [$7f14ef296305472a$var$$.BR]: true,
        [$7f14ef296305472a$var$$.BUTTON]: true,
        [$7f14ef296305472a$var$$.CAPTION]: true,
        [$7f14ef296305472a$var$$.CENTER]: true,
        [$7f14ef296305472a$var$$.COL]: true,
        [$7f14ef296305472a$var$$.COLGROUP]: true,
        [$7f14ef296305472a$var$$.DD]: true,
        [$7f14ef296305472a$var$$.DETAILS]: true,
        [$7f14ef296305472a$var$$.DIR]: true,
        [$7f14ef296305472a$var$$.DIV]: true,
        [$7f14ef296305472a$var$$.DL]: true,
        [$7f14ef296305472a$var$$.DT]: true,
        [$7f14ef296305472a$var$$.EMBED]: true,
        [$7f14ef296305472a$var$$.FIELDSET]: true,
        [$7f14ef296305472a$var$$.FIGCAPTION]: true,
        [$7f14ef296305472a$var$$.FIGURE]: true,
        [$7f14ef296305472a$var$$.FOOTER]: true,
        [$7f14ef296305472a$var$$.FORM]: true,
        [$7f14ef296305472a$var$$.FRAME]: true,
        [$7f14ef296305472a$var$$.FRAMESET]: true,
        [$7f14ef296305472a$var$$.H1]: true,
        [$7f14ef296305472a$var$$.H2]: true,
        [$7f14ef296305472a$var$$.H3]: true,
        [$7f14ef296305472a$var$$.H4]: true,
        [$7f14ef296305472a$var$$.H5]: true,
        [$7f14ef296305472a$var$$.H6]: true,
        [$7f14ef296305472a$var$$.HEAD]: true,
        [$7f14ef296305472a$var$$.HEADER]: true,
        [$7f14ef296305472a$var$$.HGROUP]: true,
        [$7f14ef296305472a$var$$.HR]: true,
        [$7f14ef296305472a$var$$.HTML]: true,
        [$7f14ef296305472a$var$$.IFRAME]: true,
        [$7f14ef296305472a$var$$.IMG]: true,
        [$7f14ef296305472a$var$$.INPUT]: true,
        [$7f14ef296305472a$var$$.LI]: true,
        [$7f14ef296305472a$var$$.LINK]: true,
        [$7f14ef296305472a$var$$.LISTING]: true,
        [$7f14ef296305472a$var$$.MAIN]: true,
        [$7f14ef296305472a$var$$.MARQUEE]: true,
        [$7f14ef296305472a$var$$.MENU]: true,
        [$7f14ef296305472a$var$$.META]: true,
        [$7f14ef296305472a$var$$.NAV]: true,
        [$7f14ef296305472a$var$$.NOEMBED]: true,
        [$7f14ef296305472a$var$$.NOFRAMES]: true,
        [$7f14ef296305472a$var$$.NOSCRIPT]: true,
        [$7f14ef296305472a$var$$.OBJECT]: true,
        [$7f14ef296305472a$var$$.OL]: true,
        [$7f14ef296305472a$var$$.P]: true,
        [$7f14ef296305472a$var$$.PARAM]: true,
        [$7f14ef296305472a$var$$.PLAINTEXT]: true,
        [$7f14ef296305472a$var$$.PRE]: true,
        [$7f14ef296305472a$var$$.SCRIPT]: true,
        [$7f14ef296305472a$var$$.SECTION]: true,
        [$7f14ef296305472a$var$$.SELECT]: true,
        [$7f14ef296305472a$var$$.SOURCE]: true,
        [$7f14ef296305472a$var$$.STYLE]: true,
        [$7f14ef296305472a$var$$.SUMMARY]: true,
        [$7f14ef296305472a$var$$.TABLE]: true,
        [$7f14ef296305472a$var$$.TBODY]: true,
        [$7f14ef296305472a$var$$.TD]: true,
        [$7f14ef296305472a$var$$.TEMPLATE]: true,
        [$7f14ef296305472a$var$$.TEXTAREA]: true,
        [$7f14ef296305472a$var$$.TFOOT]: true,
        [$7f14ef296305472a$var$$.TH]: true,
        [$7f14ef296305472a$var$$.THEAD]: true,
        [$7f14ef296305472a$var$$.TITLE]: true,
        [$7f14ef296305472a$var$$.TR]: true,
        [$7f14ef296305472a$var$$.TRACK]: true,
        [$7f14ef296305472a$var$$.UL]: true,
        [$7f14ef296305472a$var$$.WBR]: true,
        [$7f14ef296305472a$var$$.XMP]: true
    },
    [$7f14ef296305472a$var$NS.MATHML]: {
        [$7f14ef296305472a$var$$.MI]: true,
        [$7f14ef296305472a$var$$.MO]: true,
        [$7f14ef296305472a$var$$.MN]: true,
        [$7f14ef296305472a$var$$.MS]: true,
        [$7f14ef296305472a$var$$.MTEXT]: true,
        [$7f14ef296305472a$var$$.ANNOTATION_XML]: true
    },
    [$7f14ef296305472a$var$NS.SVG]: {
        [$7f14ef296305472a$var$$.TITLE]: true,
        [$7f14ef296305472a$var$$.FOREIGN_OBJECT]: true,
        [$7f14ef296305472a$var$$.DESC]: true
    }
};


//Aliases
const $6010bf3e76553f22$var$$ = $7f14ef296305472a$export$7e674a85a2656dce;
const $6010bf3e76553f22$var$NS = $7f14ef296305472a$export$4d2fb7344096e022;
//Element utils
//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function $6010bf3e76553f22$var$isImpliedEndTagRequired(tn) {
    switch(tn.length){
        case 1:
            return tn === $6010bf3e76553f22$var$$.P;
        case 2:
            return tn === $6010bf3e76553f22$var$$.RB || tn === $6010bf3e76553f22$var$$.RP || tn === $6010bf3e76553f22$var$$.RT || tn === $6010bf3e76553f22$var$$.DD || tn === $6010bf3e76553f22$var$$.DT || tn === $6010bf3e76553f22$var$$.LI;
        case 3:
            return tn === $6010bf3e76553f22$var$$.RTC;
        case 6:
            return tn === $6010bf3e76553f22$var$$.OPTION;
        case 8:
            return tn === $6010bf3e76553f22$var$$.OPTGROUP;
    }
    return false;
}
function $6010bf3e76553f22$var$isImpliedEndTagRequiredThoroughly(tn) {
    switch(tn.length){
        case 1:
            return tn === $6010bf3e76553f22$var$$.P;
        case 2:
            return tn === $6010bf3e76553f22$var$$.RB || tn === $6010bf3e76553f22$var$$.RP || tn === $6010bf3e76553f22$var$$.RT || tn === $6010bf3e76553f22$var$$.DD || tn === $6010bf3e76553f22$var$$.DT || tn === $6010bf3e76553f22$var$$.LI || tn === $6010bf3e76553f22$var$$.TD || tn === $6010bf3e76553f22$var$$.TH || tn === $6010bf3e76553f22$var$$.TR;
        case 3:
            return tn === $6010bf3e76553f22$var$$.RTC;
        case 5:
            return tn === $6010bf3e76553f22$var$$.TBODY || tn === $6010bf3e76553f22$var$$.TFOOT || tn === $6010bf3e76553f22$var$$.THEAD;
        case 6:
            return tn === $6010bf3e76553f22$var$$.OPTION;
        case 7:
            return tn === $6010bf3e76553f22$var$$.CAPTION;
        case 8:
            return tn === $6010bf3e76553f22$var$$.OPTGROUP || tn === $6010bf3e76553f22$var$$.COLGROUP;
    }
    return false;
}
function $6010bf3e76553f22$var$isScopingElement(tn, ns) {
    switch(tn.length){
        case 2:
            if (tn === $6010bf3e76553f22$var$$.TD || tn === $6010bf3e76553f22$var$$.TH) return ns === $6010bf3e76553f22$var$NS.HTML;
            else if (tn === $6010bf3e76553f22$var$$.MI || tn === $6010bf3e76553f22$var$$.MO || tn === $6010bf3e76553f22$var$$.MN || tn === $6010bf3e76553f22$var$$.MS) return ns === $6010bf3e76553f22$var$NS.MATHML;
            break;
        case 4:
            if (tn === $6010bf3e76553f22$var$$.HTML) return ns === $6010bf3e76553f22$var$NS.HTML;
            else if (tn === $6010bf3e76553f22$var$$.DESC) return ns === $6010bf3e76553f22$var$NS.SVG;
            break;
        case 5:
            if (tn === $6010bf3e76553f22$var$$.TABLE) return ns === $6010bf3e76553f22$var$NS.HTML;
            else if (tn === $6010bf3e76553f22$var$$.MTEXT) return ns === $6010bf3e76553f22$var$NS.MATHML;
            else if (tn === $6010bf3e76553f22$var$$.TITLE) return ns === $6010bf3e76553f22$var$NS.SVG;
            break;
        case 6:
            return (tn === $6010bf3e76553f22$var$$.APPLET || tn === $6010bf3e76553f22$var$$.OBJECT) && ns === $6010bf3e76553f22$var$NS.HTML;
        case 7:
            return (tn === $6010bf3e76553f22$var$$.CAPTION || tn === $6010bf3e76553f22$var$$.MARQUEE) && ns === $6010bf3e76553f22$var$NS.HTML;
        case 8:
            return tn === $6010bf3e76553f22$var$$.TEMPLATE && ns === $6010bf3e76553f22$var$NS.HTML;
        case 13:
            return tn === $6010bf3e76553f22$var$$.FOREIGN_OBJECT && ns === $6010bf3e76553f22$var$NS.SVG;
        case 14:
            return tn === $6010bf3e76553f22$var$$.ANNOTATION_XML && ns === $6010bf3e76553f22$var$NS.MATHML;
    }
    return false;
}
//Stack of open elements
class $6010bf3e76553f22$var$OpenElementStack {
    constructor(document, treeAdapter){
        this.stackTop = -1;
        this.items = [];
        this.current = document;
        this.currentTagName = null;
        this.currentTmplContent = null;
        this.tmplCount = 0;
        this.treeAdapter = treeAdapter;
    }
    //Index of element
    _indexOf(element) {
        let idx = -1;
        for(let i = this.stackTop; i >= 0; i--)if (this.items[i] === element) {
            idx = i;
            break;
        }
        return idx;
    }
    //Update current element
    _isInTemplate() {
        return this.currentTagName === $6010bf3e76553f22$var$$.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === $6010bf3e76553f22$var$NS.HTML;
    }
    _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);
        this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
    }
    //Mutations
    push(element) {
        this.items[++this.stackTop] = element;
        this._updateCurrentElement();
        if (this._isInTemplate()) this.tmplCount++;
    }
    pop() {
        this.stackTop--;
        if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount--;
        this._updateCurrentElement();
    }
    replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);
        this.items[idx] = newElement;
        if (idx === this.stackTop) this._updateCurrentElement();
    }
    insertAfter(referenceElement, newElement) {
        const insertionIdx = this._indexOf(referenceElement) + 1;
        this.items.splice(insertionIdx, 0, newElement);
        if (insertionIdx === ++this.stackTop) this._updateCurrentElement();
    }
    popUntilTagNamePopped(tagName) {
        while(this.stackTop > -1){
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);
            this.pop();
            if (tn === tagName && ns === $6010bf3e76553f22$var$NS.HTML) break;
        }
    }
    popUntilElementPopped(element) {
        while(this.stackTop > -1){
            const poppedElement = this.current;
            this.pop();
            if (poppedElement === element) break;
        }
    }
    popUntilNumberedHeaderPopped() {
        while(this.stackTop > -1){
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);
            this.pop();
            if (tn === $6010bf3e76553f22$var$$.H1 || tn === $6010bf3e76553f22$var$$.H2 || tn === $6010bf3e76553f22$var$$.H3 || tn === $6010bf3e76553f22$var$$.H4 || tn === $6010bf3e76553f22$var$$.H5 || tn === $6010bf3e76553f22$var$$.H6 && ns === $6010bf3e76553f22$var$NS.HTML) break;
        }
    }
    popUntilTableCellPopped() {
        while(this.stackTop > -1){
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);
            this.pop();
            if (tn === $6010bf3e76553f22$var$$.TD || tn === $6010bf3e76553f22$var$$.TH && ns === $6010bf3e76553f22$var$NS.HTML) break;
        }
    }
    popAllUpToHtmlElement() {
        //NOTE: here we assume that root <html> element is always first in the open element stack, so
        //we perform this fast stack clean up.
        this.stackTop = 0;
        this._updateCurrentElement();
    }
    clearBackToTableContext() {
        while(this.currentTagName !== $6010bf3e76553f22$var$$.TABLE && this.currentTagName !== $6010bf3e76553f22$var$$.TEMPLATE && this.currentTagName !== $6010bf3e76553f22$var$$.HTML || this.treeAdapter.getNamespaceURI(this.current) !== $6010bf3e76553f22$var$NS.HTML)this.pop();
    }
    clearBackToTableBodyContext() {
        while(this.currentTagName !== $6010bf3e76553f22$var$$.TBODY && this.currentTagName !== $6010bf3e76553f22$var$$.TFOOT && this.currentTagName !== $6010bf3e76553f22$var$$.THEAD && this.currentTagName !== $6010bf3e76553f22$var$$.TEMPLATE && this.currentTagName !== $6010bf3e76553f22$var$$.HTML || this.treeAdapter.getNamespaceURI(this.current) !== $6010bf3e76553f22$var$NS.HTML)this.pop();
    }
    clearBackToTableRowContext() {
        while(this.currentTagName !== $6010bf3e76553f22$var$$.TR && this.currentTagName !== $6010bf3e76553f22$var$$.TEMPLATE && this.currentTagName !== $6010bf3e76553f22$var$$.HTML || this.treeAdapter.getNamespaceURI(this.current) !== $6010bf3e76553f22$var$NS.HTML)this.pop();
    }
    remove(element) {
        for(let i = this.stackTop; i >= 0; i--)if (this.items[i] === element) {
            this.items.splice(i, 1);
            this.stackTop--;
            this._updateCurrentElement();
            break;
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
        //Properly nested <body> element (should be second element in stack).
        const element = this.items[1];
        return element && this.treeAdapter.getTagName(element) === $6010bf3e76553f22$var$$.BODY ? element : null;
    }
    contains(element) {
        return this._indexOf(element) > -1;
    }
    getCommonAncestor(element) {
        let elementIdx = this._indexOf(element);
        return --elementIdx >= 0 ? this.items[elementIdx] : null;
    }
    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.currentTagName === $6010bf3e76553f22$var$$.HTML;
    }
    //Element in scope
    hasInScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (tn === tagName && ns === $6010bf3e76553f22$var$NS.HTML) return true;
            if ($6010bf3e76553f22$var$isScopingElement(tn, ns)) return false;
        }
        return true;
    }
    hasNumberedHeaderInScope() {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if ((tn === $6010bf3e76553f22$var$$.H1 || tn === $6010bf3e76553f22$var$$.H2 || tn === $6010bf3e76553f22$var$$.H3 || tn === $6010bf3e76553f22$var$$.H4 || tn === $6010bf3e76553f22$var$$.H5 || tn === $6010bf3e76553f22$var$$.H6) && ns === $6010bf3e76553f22$var$NS.HTML) return true;
            if ($6010bf3e76553f22$var$isScopingElement(tn, ns)) return false;
        }
        return true;
    }
    hasInListItemScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (tn === tagName && ns === $6010bf3e76553f22$var$NS.HTML) return true;
            if ((tn === $6010bf3e76553f22$var$$.UL || tn === $6010bf3e76553f22$var$$.OL) && ns === $6010bf3e76553f22$var$NS.HTML || $6010bf3e76553f22$var$isScopingElement(tn, ns)) return false;
        }
        return true;
    }
    hasInButtonScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (tn === tagName && ns === $6010bf3e76553f22$var$NS.HTML) return true;
            if (tn === $6010bf3e76553f22$var$$.BUTTON && ns === $6010bf3e76553f22$var$NS.HTML || $6010bf3e76553f22$var$isScopingElement(tn, ns)) return false;
        }
        return true;
    }
    hasInTableScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (ns !== $6010bf3e76553f22$var$NS.HTML) continue;
            if (tn === tagName) return true;
            if (tn === $6010bf3e76553f22$var$$.TABLE || tn === $6010bf3e76553f22$var$$.TEMPLATE || tn === $6010bf3e76553f22$var$$.HTML) return false;
        }
        return true;
    }
    hasTableBodyContextInTableScope() {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (ns !== $6010bf3e76553f22$var$NS.HTML) continue;
            if (tn === $6010bf3e76553f22$var$$.TBODY || tn === $6010bf3e76553f22$var$$.THEAD || tn === $6010bf3e76553f22$var$$.TFOOT) return true;
            if (tn === $6010bf3e76553f22$var$$.TABLE || tn === $6010bf3e76553f22$var$$.HTML) return false;
        }
        return true;
    }
    hasInSelectScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (ns !== $6010bf3e76553f22$var$NS.HTML) continue;
            if (tn === tagName) return true;
            if (tn !== $6010bf3e76553f22$var$$.OPTION && tn !== $6010bf3e76553f22$var$$.OPTGROUP) return false;
        }
        return true;
    }
    //Implied end tags
    generateImpliedEndTags() {
        while($6010bf3e76553f22$var$isImpliedEndTagRequired(this.currentTagName))this.pop();
    }
    generateImpliedEndTagsThoroughly() {
        while($6010bf3e76553f22$var$isImpliedEndTagRequiredThoroughly(this.currentTagName))this.pop();
    }
    generateImpliedEndTagsWithExclusion(exclusionTagName) {
        while($6010bf3e76553f22$var$isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName)this.pop();
    }
}
$6010bf3e76553f22$exports = $6010bf3e76553f22$var$OpenElementStack;


var $233582e571a8f049$exports = {};
"use strict";
//Const
const $233582e571a8f049$var$NOAH_ARK_CAPACITY = 3;
//List of formatting elements
class $233582e571a8f049$var$FormattingElementList {
    constructor(treeAdapter){
        this.length = 0;
        this.entries = [];
        this.treeAdapter = treeAdapter;
        this.bookmark = null;
    }
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(newElement) {
        const candidates = [];
        if (this.length >= $233582e571a8f049$var$NOAH_ARK_CAPACITY) {
            const neAttrsLength = this.treeAdapter.getAttrList(newElement).length;
            const neTagName = this.treeAdapter.getTagName(newElement);
            const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
            for(let i = this.length - 1; i >= 0; i--){
                const entry = this.entries[i];
                if (entry.type === $233582e571a8f049$var$FormattingElementList.MARKER_ENTRY) break;
                const element = entry.element;
                const elementAttrs = this.treeAdapter.getAttrList(element);
                const isCandidate = this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI && elementAttrs.length === neAttrsLength;
                if (isCandidate) candidates.push({
                    idx: i,
                    attrs: elementAttrs
                });
            }
        }
        return candidates.length < $233582e571a8f049$var$NOAH_ARK_CAPACITY ? [] : candidates;
    }
    _ensureNoahArkCondition(newElement) {
        const candidates = this._getNoahArkConditionCandidates(newElement);
        let cLength = candidates.length;
        if (cLength) {
            const neAttrs = this.treeAdapter.getAttrList(newElement);
            const neAttrsLength = neAttrs.length;
            const neAttrsMap = Object.create(null);
            //NOTE: build attrs map for the new element so we can perform fast lookups
            for(let i = 0; i < neAttrsLength; i++){
                const neAttr = neAttrs[i];
                neAttrsMap[neAttr.name] = neAttr.value;
            }
            for(let i = 0; i < neAttrsLength; i++)for(let j = 0; j < cLength; j++){
                const cAttr = candidates[j].attrs[i];
                if (neAttrsMap[cAttr.name] !== cAttr.value) {
                    candidates.splice(j, 1);
                    cLength--;
                }
                if (candidates.length < $233582e571a8f049$var$NOAH_ARK_CAPACITY) return;
            }
            //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
            for(let i = cLength - 1; i >= $233582e571a8f049$var$NOAH_ARK_CAPACITY - 1; i--){
                this.entries.splice(candidates[i].idx, 1);
                this.length--;
            }
        }
    }
    //Mutations
    insertMarker() {
        this.entries.push({
            type: $233582e571a8f049$var$FormattingElementList.MARKER_ENTRY
        });
        this.length++;
    }
    pushElement(element, token) {
        this._ensureNoahArkCondition(element);
        this.entries.push({
            type: $233582e571a8f049$var$FormattingElementList.ELEMENT_ENTRY,
            element: element,
            token: token
        });
        this.length++;
    }
    insertElementAfterBookmark(element, token) {
        let bookmarkIdx = this.length - 1;
        for(; bookmarkIdx >= 0; bookmarkIdx--){
            if (this.entries[bookmarkIdx] === this.bookmark) break;
        }
        this.entries.splice(bookmarkIdx + 1, 0, {
            type: $233582e571a8f049$var$FormattingElementList.ELEMENT_ENTRY,
            element: element,
            token: token
        });
        this.length++;
    }
    removeEntry(entry) {
        for(let i = this.length - 1; i >= 0; i--)if (this.entries[i] === entry) {
            this.entries.splice(i, 1);
            this.length--;
            break;
        }
    }
    clearToLastMarker() {
        while(this.length){
            const entry = this.entries.pop();
            this.length--;
            if (entry.type === $233582e571a8f049$var$FormattingElementList.MARKER_ENTRY) break;
        }
    }
    //Search
    getElementEntryInScopeWithTagName(tagName) {
        for(let i = this.length - 1; i >= 0; i--){
            const entry = this.entries[i];
            if (entry.type === $233582e571a8f049$var$FormattingElementList.MARKER_ENTRY) return null;
            if (this.treeAdapter.getTagName(entry.element) === tagName) return entry;
        }
        return null;
    }
    getElementEntry(element) {
        for(let i = this.length - 1; i >= 0; i--){
            const entry = this.entries[i];
            if (entry.type === $233582e571a8f049$var$FormattingElementList.ELEMENT_ENTRY && entry.element === element) return entry;
        }
        return null;
    }
}
//Entry types
$233582e571a8f049$var$FormattingElementList.MARKER_ENTRY = "MARKER_ENTRY";
$233582e571a8f049$var$FormattingElementList.ELEMENT_ENTRY = "ELEMENT_ENTRY";
$233582e571a8f049$exports = $233582e571a8f049$var$FormattingElementList;


var $56554d1da53e62e3$exports = {};
"use strict";
var $e7b605daec02218c$exports = {};
"use strict";
class $e7b605daec02218c$var$Mixin {
    constructor(host){
        const originalMethods = {};
        const overriddenMethods = this._getOverriddenMethods(this, originalMethods);
        for (const key of Object.keys(overriddenMethods))if (typeof overriddenMethods[key] === "function") {
            originalMethods[key] = host[key];
            host[key] = overriddenMethods[key];
        }
    }
    _getOverriddenMethods() {
        throw new Error("Not implemented");
    }
}
$e7b605daec02218c$var$Mixin.install = function(host, Ctor, opts) {
    if (!host.__mixins) host.__mixins = [];
    for(let i = 0; i < host.__mixins.length; i++){
        if (host.__mixins[i].constructor === Ctor) return host.__mixins[i];
    }
    const mixin = new Ctor(host, opts);
    host.__mixins.push(mixin);
    return mixin;
};
$e7b605daec02218c$exports = $e7b605daec02218c$var$Mixin;



var $91458d84f88e9b02$exports = {};
"use strict";


var $301d12e0857fd5af$exports = {};
"use strict";

class $301d12e0857fd5af$var$PositionTrackingPreprocessorMixin extends $e7b605daec02218c$exports {
    constructor(preprocessor){
        super(preprocessor);
        this.preprocessor = preprocessor;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;
        this.offset = 0;
        this.col = 0;
        this.line = 1;
    }
    _getOverriddenMethods(mxn, orig) {
        return {
            advance () {
                const pos = this.pos + 1;
                const ch = this.html[pos];
                //NOTE: LF should be in the last column of the line
                if (mxn.isEol) {
                    mxn.isEol = false;
                    mxn.line++;
                    mxn.lineStartPos = pos;
                }
                if (ch === "\n" || ch === "\r" && this.html[pos + 1] !== "\n") mxn.isEol = true;
                mxn.col = pos - mxn.lineStartPos + 1;
                mxn.offset = mxn.droppedBufferSize + pos;
                return orig.advance.call(this);
            },
            retreat () {
                orig.retreat.call(this);
                mxn.isEol = false;
                mxn.col = this.pos - mxn.lineStartPos + 1;
            },
            dropParsedChunk () {
                const prevPos = this.pos;
                orig.dropParsedChunk.call(this);
                const reduction = prevPos - this.pos;
                mxn.lineStartPos -= reduction;
                mxn.droppedBufferSize += reduction;
                mxn.offset = mxn.droppedBufferSize + this.pos;
            }
        };
    }
}
$301d12e0857fd5af$exports = $301d12e0857fd5af$var$PositionTrackingPreprocessorMixin;


class $91458d84f88e9b02$var$LocationInfoTokenizerMixin extends $e7b605daec02218c$exports {
    constructor(tokenizer){
        super(tokenizer);
        this.tokenizer = tokenizer;
        this.posTracker = $e7b605daec02218c$exports.install(tokenizer.preprocessor, $301d12e0857fd5af$exports);
        this.currentAttrLocation = null;
        this.ctLoc = null;
    }
    _getCurrentLocation() {
        return {
            startLine: this.posTracker.line,
            startCol: this.posTracker.col,
            startOffset: this.posTracker.offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
    }
    _attachCurrentAttrLocationInfo() {
        this.currentAttrLocation.endLine = this.posTracker.line;
        this.currentAttrLocation.endCol = this.posTracker.col;
        this.currentAttrLocation.endOffset = this.posTracker.offset;
        const currentToken = this.tokenizer.currentToken;
        const currentAttr = this.tokenizer.currentAttr;
        if (!currentToken.location.attrs) currentToken.location.attrs = Object.create(null);
        currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
    }
    _getOverriddenMethods(mxn, orig) {
        const methods = {
            _createStartTagToken () {
                orig._createStartTagToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },
            _createEndTagToken () {
                orig._createEndTagToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },
            _createCommentToken () {
                orig._createCommentToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },
            _createDoctypeToken (initialName) {
                orig._createDoctypeToken.call(this, initialName);
                this.currentToken.location = mxn.ctLoc;
            },
            _createCharacterToken (type, ch) {
                orig._createCharacterToken.call(this, type, ch);
                this.currentCharacterToken.location = mxn.ctLoc;
            },
            _createEOFToken () {
                orig._createEOFToken.call(this);
                this.currentToken.location = mxn._getCurrentLocation();
            },
            _createAttr (attrNameFirstCh) {
                orig._createAttr.call(this, attrNameFirstCh);
                mxn.currentAttrLocation = mxn._getCurrentLocation();
            },
            _leaveAttrName (toState) {
                orig._leaveAttrName.call(this, toState);
                mxn._attachCurrentAttrLocationInfo();
            },
            _leaveAttrValue (toState) {
                orig._leaveAttrValue.call(this, toState);
                mxn._attachCurrentAttrLocationInfo();
            },
            _emitCurrentToken () {
                const ctLoc = this.currentToken.location;
                //NOTE: if we have pending character token make it's end location equal to the
                //current token's start location.
                if (this.currentCharacterToken) {
                    this.currentCharacterToken.location.endLine = ctLoc.startLine;
                    this.currentCharacterToken.location.endCol = ctLoc.startCol;
                    this.currentCharacterToken.location.endOffset = ctLoc.startOffset;
                }
                if (this.currentToken.type === $1402a60f2d09b0f9$exports.EOF_TOKEN) {
                    ctLoc.endLine = ctLoc.startLine;
                    ctLoc.endCol = ctLoc.startCol;
                    ctLoc.endOffset = ctLoc.startOffset;
                } else {
                    ctLoc.endLine = mxn.posTracker.line;
                    ctLoc.endCol = mxn.posTracker.col + 1;
                    ctLoc.endOffset = mxn.posTracker.offset + 1;
                }
                orig._emitCurrentToken.call(this);
            },
            _emitCurrentCharacterToken () {
                const ctLoc = this.currentCharacterToken && this.currentCharacterToken.location;
                //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
                //then set it's location at the current preprocessor position.
                //We don't need to increment preprocessor position, since character token
                //emission is always forced by the start of the next character token here.
                //So, we already have advanced position.
                if (ctLoc && ctLoc.endOffset === -1) {
                    ctLoc.endLine = mxn.posTracker.line;
                    ctLoc.endCol = mxn.posTracker.col;
                    ctLoc.endOffset = mxn.posTracker.offset;
                }
                orig._emitCurrentCharacterToken.call(this);
            }
        };
        //NOTE: patch initial states for each mode to obtain token start position
        Object.keys($1402a60f2d09b0f9$exports.MODE).forEach((modeName)=>{
            const state = $1402a60f2d09b0f9$exports.MODE[modeName];
            methods[state] = function(cp) {
                mxn.ctLoc = mxn._getCurrentLocation();
                orig[state].call(this, cp);
            };
        });
        return methods;
    }
}
$91458d84f88e9b02$exports = $91458d84f88e9b02$var$LocationInfoTokenizerMixin;


var $eb53df3b90957e73$exports = {};
"use strict";

class $eb53df3b90957e73$var$LocationInfoOpenElementStackMixin extends $e7b605daec02218c$exports {
    constructor(stack, opts){
        super(stack);
        this.onItemPop = opts.onItemPop;
    }
    _getOverriddenMethods(mxn, orig) {
        return {
            pop () {
                mxn.onItemPop(this.current);
                orig.pop.call(this);
            },
            popAllUpToHtmlElement () {
                for(let i = this.stackTop; i > 0; i--)mxn.onItemPop(this.items[i]);
                orig.popAllUpToHtmlElement.call(this);
            },
            remove (element) {
                mxn.onItemPop(this.current);
                orig.remove.call(this, element);
            }
        };
    }
}
$eb53df3b90957e73$exports = $eb53df3b90957e73$var$LocationInfoOpenElementStackMixin;



//Aliases
const $56554d1da53e62e3$var$$ = $7f14ef296305472a$export$7e674a85a2656dce;
class $56554d1da53e62e3$var$LocationInfoParserMixin extends $e7b605daec02218c$exports {
    constructor(parser){
        super(parser);
        this.parser = parser;
        this.treeAdapter = this.parser.treeAdapter;
        this.posTracker = null;
        this.lastStartTagToken = null;
        this.lastFosterParentingLocation = null;
        this.currentToken = null;
    }
    _setStartLocation(element) {
        let loc = null;
        if (this.lastStartTagToken) {
            loc = Object.assign({}, this.lastStartTagToken.location);
            loc.startTag = this.lastStartTagToken.location;
        }
        this.treeAdapter.setNodeSourceCodeLocation(element, loc);
    }
    _setEndLocation(element, closingToken) {
        const loc = this.treeAdapter.getNodeSourceCodeLocation(element);
        if (loc) {
            if (closingToken.location) {
                const ctLoc = closingToken.location;
                const tn = this.treeAdapter.getTagName(element);
                // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
                // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
                const isClosingEndTag = closingToken.type === $1402a60f2d09b0f9$exports.END_TAG_TOKEN && tn === closingToken.tagName;
                const endLoc = {};
                if (isClosingEndTag) {
                    endLoc.endTag = Object.assign({}, ctLoc);
                    endLoc.endLine = ctLoc.endLine;
                    endLoc.endCol = ctLoc.endCol;
                    endLoc.endOffset = ctLoc.endOffset;
                } else {
                    endLoc.endLine = ctLoc.startLine;
                    endLoc.endCol = ctLoc.startCol;
                    endLoc.endOffset = ctLoc.startOffset;
                }
                this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
            }
        }
    }
    _getOverriddenMethods(mxn, orig) {
        return {
            _bootstrap (document, fragmentContext) {
                orig._bootstrap.call(this, document, fragmentContext);
                mxn.lastStartTagToken = null;
                mxn.lastFosterParentingLocation = null;
                mxn.currentToken = null;
                const tokenizerMixin = $e7b605daec02218c$exports.install(this.tokenizer, $91458d84f88e9b02$exports);
                mxn.posTracker = tokenizerMixin.posTracker;
                $e7b605daec02218c$exports.install(this.openElements, $eb53df3b90957e73$exports, {
                    onItemPop: function(element) {
                        mxn._setEndLocation(element, mxn.currentToken);
                    }
                });
            },
            _runParsingLoop (scriptHandler) {
                orig._runParsingLoop.call(this, scriptHandler);
                // NOTE: generate location info for elements
                // that remains on open element stack
                for(let i = this.openElements.stackTop; i >= 0; i--)mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
            },
            //Token processing
            _processTokenInForeignContent (token) {
                mxn.currentToken = token;
                orig._processTokenInForeignContent.call(this, token);
            },
            _processToken (token) {
                mxn.currentToken = token;
                orig._processToken.call(this, token);
                //NOTE: <body> and <html> are never popped from the stack, so we need to updated
                //their end location explicitly.
                const requireExplicitUpdate = token.type === $1402a60f2d09b0f9$exports.END_TAG_TOKEN && (token.tagName === $56554d1da53e62e3$var$$.HTML || token.tagName === $56554d1da53e62e3$var$$.BODY && this.openElements.hasInScope($56554d1da53e62e3$var$$.BODY));
                if (requireExplicitUpdate) for(let i = this.openElements.stackTop; i >= 0; i--){
                    const element = this.openElements.items[i];
                    if (this.treeAdapter.getTagName(element) === token.tagName) {
                        mxn._setEndLocation(element, token);
                        break;
                    }
                }
            },
            //Doctype
            _setDocumentType (token) {
                orig._setDocumentType.call(this, token);
                const documentChildren = this.treeAdapter.getChildNodes(this.document);
                const cnLength = documentChildren.length;
                for(let i = 0; i < cnLength; i++){
                    const node = documentChildren[i];
                    if (this.treeAdapter.isDocumentTypeNode(node)) {
                        this.treeAdapter.setNodeSourceCodeLocation(node, token.location);
                        break;
                    }
                }
            },
            //Elements
            _attachElementToTree (element) {
                //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
                //So we will use token location stored in this methods for the element.
                mxn._setStartLocation(element);
                mxn.lastStartTagToken = null;
                orig._attachElementToTree.call(this, element);
            },
            _appendElement (token, namespaceURI) {
                mxn.lastStartTagToken = token;
                orig._appendElement.call(this, token, namespaceURI);
            },
            _insertElement (token, namespaceURI) {
                mxn.lastStartTagToken = token;
                orig._insertElement.call(this, token, namespaceURI);
            },
            _insertTemplate (token) {
                mxn.lastStartTagToken = token;
                orig._insertTemplate.call(this, token);
                const tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);
                this.treeAdapter.setNodeSourceCodeLocation(tmplContent, null);
            },
            _insertFakeRootElement () {
                orig._insertFakeRootElement.call(this);
                this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
            },
            //Comments
            _appendCommentNode (token, parent) {
                orig._appendCommentNode.call(this, token, parent);
                const children = this.treeAdapter.getChildNodes(parent);
                const commentNode = children[children.length - 1];
                this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
            },
            //Text
            _findFosterParentingLocation () {
                //NOTE: store last foster parenting location, so we will be able to find inserted text
                //in case of foster parenting
                mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);
                return mxn.lastFosterParentingLocation;
            },
            _insertCharacters (token) {
                orig._insertCharacters.call(this, token);
                const hasFosterParent = this._shouldFosterParentOnInsertion();
                const parent = hasFosterParent && mxn.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current;
                const siblings = this.treeAdapter.getChildNodes(parent);
                const textNodeIdx = hasFosterParent && mxn.lastFosterParentingLocation.beforeElement ? siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1 : siblings.length - 1;
                const textNode = siblings[textNodeIdx];
                //NOTE: if we have location assigned by another token, then just update end position
                const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
                if (tnLoc) {
                    const { endLine: endLine, endCol: endCol, endOffset: endOffset } = token.location;
                    this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
                        endLine: endLine,
                        endCol: endCol,
                        endOffset: endOffset
                    });
                } else this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
            }
        };
    }
}
$56554d1da53e62e3$exports = $56554d1da53e62e3$var$LocationInfoParserMixin;


var $cc0a9038c76dd70d$exports = {};
"use strict";
var $d9411d7f17d3d484$exports = {};
"use strict";

class $d9411d7f17d3d484$var$ErrorReportingMixinBase extends $e7b605daec02218c$exports {
    constructor(host, opts){
        super(host);
        this.posTracker = null;
        this.onParseError = opts.onParseError;
    }
    _setErrorLocation(err) {
        err.startLine = err.endLine = this.posTracker.line;
        err.startCol = err.endCol = this.posTracker.col;
        err.startOffset = err.endOffset = this.posTracker.offset;
    }
    _reportError(code) {
        const err = {
            code: code,
            startLine: -1,
            startCol: -1,
            startOffset: -1,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
        this._setErrorLocation(err);
        this.onParseError(err);
    }
    _getOverriddenMethods(mxn) {
        return {
            _err (code) {
                mxn._reportError(code);
            }
        };
    }
}
$d9411d7f17d3d484$exports = $d9411d7f17d3d484$var$ErrorReportingMixinBase;


var $ed49ad4367fb571e$exports = {};
"use strict";

var $cfc268c2b5b89dd5$exports = {};
"use strict";



class $cfc268c2b5b89dd5$var$ErrorReportingPreprocessorMixin extends $d9411d7f17d3d484$exports {
    constructor(preprocessor, opts){
        super(preprocessor, opts);
        this.posTracker = $e7b605daec02218c$exports.install(preprocessor, $301d12e0857fd5af$exports);
        this.lastErrOffset = -1;
    }
    _reportError(code) {
        //NOTE: avoid reporting error twice on advance/retreat
        if (this.lastErrOffset !== this.posTracker.offset) {
            this.lastErrOffset = this.posTracker.offset;
            super._reportError(code);
        }
    }
}
$cfc268c2b5b89dd5$exports = $cfc268c2b5b89dd5$var$ErrorReportingPreprocessorMixin;



class $ed49ad4367fb571e$var$ErrorReportingTokenizerMixin extends $d9411d7f17d3d484$exports {
    constructor(tokenizer, opts){
        super(tokenizer, opts);
        const preprocessorMixin = $e7b605daec02218c$exports.install(tokenizer.preprocessor, $cfc268c2b5b89dd5$exports, opts);
        this.posTracker = preprocessorMixin.posTracker;
    }
}
$ed49ad4367fb571e$exports = $ed49ad4367fb571e$var$ErrorReportingTokenizerMixin;




class $cc0a9038c76dd70d$var$ErrorReportingParserMixin extends $d9411d7f17d3d484$exports {
    constructor(parser, opts){
        super(parser, opts);
        this.opts = opts;
        this.ctLoc = null;
        this.locBeforeToken = false;
    }
    _setErrorLocation(err) {
        if (this.ctLoc) {
            err.startLine = this.ctLoc.startLine;
            err.startCol = this.ctLoc.startCol;
            err.startOffset = this.ctLoc.startOffset;
            err.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine;
            err.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol;
            err.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset;
        }
    }
    _getOverriddenMethods(mxn, orig) {
        return {
            _bootstrap (document, fragmentContext) {
                orig._bootstrap.call(this, document, fragmentContext);
                $e7b605daec02218c$exports.install(this.tokenizer, $ed49ad4367fb571e$exports, mxn.opts);
                $e7b605daec02218c$exports.install(this.tokenizer, $91458d84f88e9b02$exports);
            },
            _processInputToken (token) {
                mxn.ctLoc = token.location;
                orig._processInputToken.call(this, token);
            },
            _err (code, options) {
                mxn.locBeforeToken = options && options.beforeToken;
                mxn._reportError(code);
            }
        };
    }
}
$cc0a9038c76dd70d$exports = $cc0a9038c76dd70d$var$ErrorReportingParserMixin;



var $dd96ea840bc7d0d2$exports = {};

$parcel$export($dd96ea840bc7d0d2$exports, "createDocument", function () { return $dd96ea840bc7d0d2$export$37330def6e48b4c9; }, function (v) { return $dd96ea840bc7d0d2$export$37330def6e48b4c9 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "createDocumentFragment", function () { return $dd96ea840bc7d0d2$export$fb51152cd5328759; }, function (v) { return $dd96ea840bc7d0d2$export$fb51152cd5328759 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "createElement", function () { return $dd96ea840bc7d0d2$export$c8a8987d4410bf2d; }, function (v) { return $dd96ea840bc7d0d2$export$c8a8987d4410bf2d = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "createCommentNode", function () { return $dd96ea840bc7d0d2$export$4471fa3c38cde6b0; }, function (v) { return $dd96ea840bc7d0d2$export$4471fa3c38cde6b0 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "appendChild", function () { return $dd96ea840bc7d0d2$export$1b8e57c9ea42f1d2; }, function (v) { return $dd96ea840bc7d0d2$export$1b8e57c9ea42f1d2 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "insertBefore", function () { return $dd96ea840bc7d0d2$export$86b68c7dbeb53c22; }, function (v) { return $dd96ea840bc7d0d2$export$86b68c7dbeb53c22 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "setTemplateContent", function () { return $dd96ea840bc7d0d2$export$d8b754ff191e3fe1; }, function (v) { return $dd96ea840bc7d0d2$export$d8b754ff191e3fe1 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getTemplateContent", function () { return $dd96ea840bc7d0d2$export$d4e734980dda982f; }, function (v) { return $dd96ea840bc7d0d2$export$d4e734980dda982f = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "setDocumentType", function () { return $dd96ea840bc7d0d2$export$b9ce160bbca30ea2; }, function (v) { return $dd96ea840bc7d0d2$export$b9ce160bbca30ea2 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "setDocumentMode", function () { return $dd96ea840bc7d0d2$export$3922aec94e35d04f; }, function (v) { return $dd96ea840bc7d0d2$export$3922aec94e35d04f = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getDocumentMode", function () { return $dd96ea840bc7d0d2$export$64782beacef87b30; }, function (v) { return $dd96ea840bc7d0d2$export$64782beacef87b30 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "detachNode", function () { return $dd96ea840bc7d0d2$export$3041402b402044d; }, function (v) { return $dd96ea840bc7d0d2$export$3041402b402044d = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "insertText", function () { return $dd96ea840bc7d0d2$export$78ba03e296d6b5ac; }, function (v) { return $dd96ea840bc7d0d2$export$78ba03e296d6b5ac = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "insertTextBefore", function () { return $dd96ea840bc7d0d2$export$38d1058f39db6d0c; }, function (v) { return $dd96ea840bc7d0d2$export$38d1058f39db6d0c = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "adoptAttributes", function () { return $dd96ea840bc7d0d2$export$29538161a764c450; }, function (v) { return $dd96ea840bc7d0d2$export$29538161a764c450 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getFirstChild", function () { return $dd96ea840bc7d0d2$export$9948b6d0956761ed; }, function (v) { return $dd96ea840bc7d0d2$export$9948b6d0956761ed = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getChildNodes", function () { return $dd96ea840bc7d0d2$export$1005530eda016c13; }, function (v) { return $dd96ea840bc7d0d2$export$1005530eda016c13 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getParentNode", function () { return $dd96ea840bc7d0d2$export$4e12058fc4d51d56; }, function (v) { return $dd96ea840bc7d0d2$export$4e12058fc4d51d56 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getAttrList", function () { return $dd96ea840bc7d0d2$export$6203bd2478d66ab; }, function (v) { return $dd96ea840bc7d0d2$export$6203bd2478d66ab = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getTagName", function () { return $dd96ea840bc7d0d2$export$cc701a2c22ef3722; }, function (v) { return $dd96ea840bc7d0d2$export$cc701a2c22ef3722 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getNamespaceURI", function () { return $dd96ea840bc7d0d2$export$45adff9ea46b4ba1; }, function (v) { return $dd96ea840bc7d0d2$export$45adff9ea46b4ba1 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getTextNodeContent", function () { return $dd96ea840bc7d0d2$export$c274d283283c7bc3; }, function (v) { return $dd96ea840bc7d0d2$export$c274d283283c7bc3 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getCommentNodeContent", function () { return $dd96ea840bc7d0d2$export$5f417125f84b13a1; }, function (v) { return $dd96ea840bc7d0d2$export$5f417125f84b13a1 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getDocumentTypeNodeName", function () { return $dd96ea840bc7d0d2$export$ceac021a32ef9d32; }, function (v) { return $dd96ea840bc7d0d2$export$ceac021a32ef9d32 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getDocumentTypeNodePublicId", function () { return $dd96ea840bc7d0d2$export$72489ffb6ed9cc0a; }, function (v) { return $dd96ea840bc7d0d2$export$72489ffb6ed9cc0a = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getDocumentTypeNodeSystemId", function () { return $dd96ea840bc7d0d2$export$826d7041a565ac60; }, function (v) { return $dd96ea840bc7d0d2$export$826d7041a565ac60 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "isTextNode", function () { return $dd96ea840bc7d0d2$export$ccbedd67ef6e9417; }, function (v) { return $dd96ea840bc7d0d2$export$ccbedd67ef6e9417 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "isCommentNode", function () { return $dd96ea840bc7d0d2$export$575485136eb1b1f; }, function (v) { return $dd96ea840bc7d0d2$export$575485136eb1b1f = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "isDocumentTypeNode", function () { return $dd96ea840bc7d0d2$export$ab36e4cc96cea759; }, function (v) { return $dd96ea840bc7d0d2$export$ab36e4cc96cea759 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "isElementNode", function () { return $dd96ea840bc7d0d2$export$95fe5d3c5526a812; }, function (v) { return $dd96ea840bc7d0d2$export$95fe5d3c5526a812 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "setNodeSourceCodeLocation", function () { return $dd96ea840bc7d0d2$export$3fed23e2df59e0fa; }, function (v) { return $dd96ea840bc7d0d2$export$3fed23e2df59e0fa = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "getNodeSourceCodeLocation", function () { return $dd96ea840bc7d0d2$export$e8b10d2cfa881e04; }, function (v) { return $dd96ea840bc7d0d2$export$e8b10d2cfa881e04 = v; });
$parcel$export($dd96ea840bc7d0d2$exports, "updateNodeSourceCodeLocation", function () { return $dd96ea840bc7d0d2$export$9d57d3ca576a724a; }, function (v) { return $dd96ea840bc7d0d2$export$9d57d3ca576a724a = v; });
//Node construction
var $dd96ea840bc7d0d2$export$37330def6e48b4c9;
var $dd96ea840bc7d0d2$export$fb51152cd5328759;
var $dd96ea840bc7d0d2$export$c8a8987d4410bf2d;
var $dd96ea840bc7d0d2$export$4471fa3c38cde6b0;
var $dd96ea840bc7d0d2$export$1b8e57c9ea42f1d2;
var $dd96ea840bc7d0d2$export$86b68c7dbeb53c22;
var $dd96ea840bc7d0d2$export$d8b754ff191e3fe1;
var $dd96ea840bc7d0d2$export$d4e734980dda982f;
var $dd96ea840bc7d0d2$export$b9ce160bbca30ea2;
var $dd96ea840bc7d0d2$export$3922aec94e35d04f;
var $dd96ea840bc7d0d2$export$64782beacef87b30;
var $dd96ea840bc7d0d2$export$3041402b402044d;
var $dd96ea840bc7d0d2$export$78ba03e296d6b5ac;
var $dd96ea840bc7d0d2$export$38d1058f39db6d0c;
var $dd96ea840bc7d0d2$export$29538161a764c450;
//Tree traversing
var $dd96ea840bc7d0d2$export$9948b6d0956761ed;
var $dd96ea840bc7d0d2$export$1005530eda016c13;
var $dd96ea840bc7d0d2$export$4e12058fc4d51d56;
var $dd96ea840bc7d0d2$export$6203bd2478d66ab;
//Node data
var $dd96ea840bc7d0d2$export$cc701a2c22ef3722;
var $dd96ea840bc7d0d2$export$45adff9ea46b4ba1;
var $dd96ea840bc7d0d2$export$c274d283283c7bc3;
var $dd96ea840bc7d0d2$export$5f417125f84b13a1;
var $dd96ea840bc7d0d2$export$ceac021a32ef9d32;
var $dd96ea840bc7d0d2$export$72489ffb6ed9cc0a;
var $dd96ea840bc7d0d2$export$826d7041a565ac60;
//Node types
var $dd96ea840bc7d0d2$export$ccbedd67ef6e9417;
var $dd96ea840bc7d0d2$export$575485136eb1b1f;
var $dd96ea840bc7d0d2$export$ab36e4cc96cea759;
var $dd96ea840bc7d0d2$export$95fe5d3c5526a812;
// Source code location
var $dd96ea840bc7d0d2$export$3fed23e2df59e0fa;
var $dd96ea840bc7d0d2$export$e8b10d2cfa881e04;
var $dd96ea840bc7d0d2$export$9d57d3ca576a724a;
"use strict";

var $dd96ea840bc7d0d2$require$DOCUMENT_MODE = $7f14ef296305472a$export$a74d46c85337d29a;
$dd96ea840bc7d0d2$export$37330def6e48b4c9 = function() {
    return {
        nodeName: "#document",
        mode: $dd96ea840bc7d0d2$require$DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
    };
};
$dd96ea840bc7d0d2$export$fb51152cd5328759 = function() {
    return {
        nodeName: "#document-fragment",
        childNodes: []
    };
};
$dd96ea840bc7d0d2$export$c8a8987d4410bf2d = function(tagName, namespaceURI, attrs) {
    return {
        nodeName: tagName,
        tagName: tagName,
        attrs: attrs,
        namespaceURI: namespaceURI,
        childNodes: [],
        parentNode: null
    };
};
$dd96ea840bc7d0d2$export$4471fa3c38cde6b0 = function(data) {
    return {
        nodeName: "#comment",
        data: data,
        parentNode: null
    };
};
const $dd96ea840bc7d0d2$var$createTextNode = function(value) {
    return {
        nodeName: "#text",
        value: value,
        parentNode: null
    };
};
//Tree mutation
const $dd96ea840bc7d0d2$var$appendChild = $dd96ea840bc7d0d2$export$1b8e57c9ea42f1d2 = function(parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
};
const $dd96ea840bc7d0d2$var$insertBefore = $dd96ea840bc7d0d2$export$86b68c7dbeb53c22 = function(parentNode, newNode, referenceNode) {
    const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
};
$dd96ea840bc7d0d2$export$d8b754ff191e3fe1 = function(templateElement, contentElement) {
    templateElement.content = contentElement;
};
$dd96ea840bc7d0d2$export$d4e734980dda982f = function(templateElement) {
    return templateElement.content;
};
$dd96ea840bc7d0d2$export$b9ce160bbca30ea2 = function(document, name, publicId, systemId) {
    let doctypeNode = null;
    for(let i = 0; i < document.childNodes.length; i++)if (document.childNodes[i].nodeName === "#documentType") {
        doctypeNode = document.childNodes[i];
        break;
    }
    if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
    } else $dd96ea840bc7d0d2$var$appendChild(document, {
        nodeName: "#documentType",
        name: name,
        publicId: publicId,
        systemId: systemId
    });
};
$dd96ea840bc7d0d2$export$3922aec94e35d04f = function(document, mode) {
    document.mode = mode;
};
$dd96ea840bc7d0d2$export$64782beacef87b30 = function(document) {
    return document.mode;
};
$dd96ea840bc7d0d2$export$3041402b402044d = function(node) {
    if (node.parentNode) {
        const idx = node.parentNode.childNodes.indexOf(node);
        node.parentNode.childNodes.splice(idx, 1);
        node.parentNode = null;
    }
};
$dd96ea840bc7d0d2$export$78ba03e296d6b5ac = function(parentNode, text) {
    if (parentNode.childNodes.length) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
        if (prevNode.nodeName === "#text") {
            prevNode.value += text;
            return;
        }
    }
    $dd96ea840bc7d0d2$var$appendChild(parentNode, $dd96ea840bc7d0d2$var$createTextNode(text));
};
$dd96ea840bc7d0d2$export$38d1058f39db6d0c = function(parentNode, text, referenceNode) {
    const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
    if (prevNode && prevNode.nodeName === "#text") prevNode.value += text;
    else $dd96ea840bc7d0d2$var$insertBefore(parentNode, $dd96ea840bc7d0d2$var$createTextNode(text), referenceNode);
};
$dd96ea840bc7d0d2$export$29538161a764c450 = function(recipient, attrs) {
    const recipientAttrsMap = [];
    for(let i = 0; i < recipient.attrs.length; i++)recipientAttrsMap.push(recipient.attrs[i].name);
    for(let j = 0; j < attrs.length; j++)if (recipientAttrsMap.indexOf(attrs[j].name) === -1) recipient.attrs.push(attrs[j]);
};
$dd96ea840bc7d0d2$export$9948b6d0956761ed = function(node) {
    return node.childNodes[0];
};
$dd96ea840bc7d0d2$export$1005530eda016c13 = function(node) {
    return node.childNodes;
};
$dd96ea840bc7d0d2$export$4e12058fc4d51d56 = function(node) {
    return node.parentNode;
};
$dd96ea840bc7d0d2$export$6203bd2478d66ab = function(element) {
    return element.attrs;
};
$dd96ea840bc7d0d2$export$cc701a2c22ef3722 = function(element) {
    return element.tagName;
};
$dd96ea840bc7d0d2$export$45adff9ea46b4ba1 = function(element) {
    return element.namespaceURI;
};
$dd96ea840bc7d0d2$export$c274d283283c7bc3 = function(textNode) {
    return textNode.value;
};
$dd96ea840bc7d0d2$export$5f417125f84b13a1 = function(commentNode) {
    return commentNode.data;
};
$dd96ea840bc7d0d2$export$ceac021a32ef9d32 = function(doctypeNode) {
    return doctypeNode.name;
};
$dd96ea840bc7d0d2$export$72489ffb6ed9cc0a = function(doctypeNode) {
    return doctypeNode.publicId;
};
$dd96ea840bc7d0d2$export$826d7041a565ac60 = function(doctypeNode) {
    return doctypeNode.systemId;
};
$dd96ea840bc7d0d2$export$ccbedd67ef6e9417 = function(node) {
    return node.nodeName === "#text";
};
$dd96ea840bc7d0d2$export$575485136eb1b1f = function(node) {
    return node.nodeName === "#comment";
};
$dd96ea840bc7d0d2$export$ab36e4cc96cea759 = function(node) {
    return node.nodeName === "#documentType";
};
$dd96ea840bc7d0d2$export$95fe5d3c5526a812 = function(node) {
    return !!node.tagName;
};
$dd96ea840bc7d0d2$export$3fed23e2df59e0fa = function(node, location) {
    node.sourceCodeLocation = location;
};
$dd96ea840bc7d0d2$export$e8b10d2cfa881e04 = function(node) {
    return node.sourceCodeLocation;
};
$dd96ea840bc7d0d2$export$9d57d3ca576a724a = function(node, endLocation) {
    node.sourceCodeLocation = Object.assign(node.sourceCodeLocation, endLocation);
};


var $f8e84399a711d5fe$exports = {};
"use strict";
$f8e84399a711d5fe$exports = function mergeOptions(defaults, options) {
    options = options || Object.create(null);
    return [
        defaults,
        options
    ].reduce((merged, optObj)=>{
        Object.keys(optObj).forEach((key)=>{
            merged[key] = optObj[key];
        });
        return merged;
    }, Object.create(null));
};


//API
var $0c39b5c5866ed00b$export$ee48152ecc0e3f40;
var $0c39b5c5866ed00b$export$64782beacef87b30;
var $0c39b5c5866ed00b$export$3dc7b315881a047c;
"use strict";

var $0c39b5c5866ed00b$require$DOCUMENT_MODE = $7f14ef296305472a$export$a74d46c85337d29a;
//Const
const $0c39b5c5866ed00b$var$VALID_DOCTYPE_NAME = "html";
const $0c39b5c5866ed00b$var$VALID_SYSTEM_ID = "about:legacy-compat";
const $0c39b5c5866ed00b$var$QUIRKS_MODE_SYSTEM_ID = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd";
const $0c39b5c5866ed00b$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
    "+//silmaril//dtd html pro v0r11 19970101//",
    "-//as//dtd html 3.0 aswedit + extensions//",
    "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
    "-//ietf//dtd html 2.0 level 1//",
    "-//ietf//dtd html 2.0 level 2//",
    "-//ietf//dtd html 2.0 strict level 1//",
    "-//ietf//dtd html 2.0 strict level 2//",
    "-//ietf//dtd html 2.0 strict//",
    "-//ietf//dtd html 2.0//",
    "-//ietf//dtd html 2.1e//",
    "-//ietf//dtd html 3.0//",
    "-//ietf//dtd html 3.2 final//",
    "-//ietf//dtd html 3.2//",
    "-//ietf//dtd html 3//",
    "-//ietf//dtd html level 0//",
    "-//ietf//dtd html level 1//",
    "-//ietf//dtd html level 2//",
    "-//ietf//dtd html level 3//",
    "-//ietf//dtd html strict level 0//",
    "-//ietf//dtd html strict level 1//",
    "-//ietf//dtd html strict level 2//",
    "-//ietf//dtd html strict level 3//",
    "-//ietf//dtd html strict//",
    "-//ietf//dtd html//",
    "-//metrius//dtd metrius presentational//",
    "-//microsoft//dtd internet explorer 2.0 html strict//",
    "-//microsoft//dtd internet explorer 2.0 html//",
    "-//microsoft//dtd internet explorer 2.0 tables//",
    "-//microsoft//dtd internet explorer 3.0 html strict//",
    "-//microsoft//dtd internet explorer 3.0 html//",
    "-//microsoft//dtd internet explorer 3.0 tables//",
    "-//netscape comm. corp.//dtd html//",
    "-//netscape comm. corp.//dtd strict html//",
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    "-//sq//dtd html 2.0 hotmetal + extensions//",
    "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
    "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
    "-//spyglass//dtd html 2.0 extended//",
    "-//sun microsystems corp.//dtd hotjava html//",
    "-//sun microsystems corp.//dtd hotjava strict html//",
    "-//w3c//dtd html 3 1995-03-24//",
    "-//w3c//dtd html 3.2 draft//",
    "-//w3c//dtd html 3.2 final//",
    "-//w3c//dtd html 3.2//",
    "-//w3c//dtd html 3.2s draft//",
    "-//w3c//dtd html 4.0 frameset//",
    "-//w3c//dtd html 4.0 transitional//",
    "-//w3c//dtd html experimental 19960712//",
    "-//w3c//dtd html experimental 970421//",
    "-//w3c//dtd w3 html//",
    "-//w3o//dtd w3 html 3.0//",
    "-//webtechs//dtd mozilla html 2.0//",
    "-//webtechs//dtd mozilla html//"
];
const $0c39b5c5866ed00b$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = $0c39b5c5866ed00b$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat([
    "-//w3c//dtd html 4.01 frameset//",
    "-//w3c//dtd html 4.01 transitional//"
]);
const $0c39b5c5866ed00b$var$QUIRKS_MODE_PUBLIC_IDS = [
    "-//w3o//dtd w3 html strict 3.0//en//",
    "-/w3c/dtd html 4.0 transitional/en",
    "html"
];
const $0c39b5c5866ed00b$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
    "-//w3c//dtd xhtml 1.0 frameset//",
    "-//w3c//dtd xhtml 1.0 transitional//"
];
const $0c39b5c5866ed00b$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = $0c39b5c5866ed00b$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat([
    "-//w3c//dtd html 4.01 frameset//",
    "-//w3c//dtd html 4.01 transitional//"
]);
//Utils
function $0c39b5c5866ed00b$var$enquoteDoctypeId(id) {
    const quote = id.indexOf('"') !== -1 ? "'" : '"';
    return quote + id + quote;
}
function $0c39b5c5866ed00b$var$hasPrefix(publicId, prefixes) {
    for(let i = 0; i < prefixes.length; i++){
        if (publicId.indexOf(prefixes[i]) === 0) return true;
    }
    return false;
}
$0c39b5c5866ed00b$export$ee48152ecc0e3f40 = function(token) {
    return token.name === $0c39b5c5866ed00b$var$VALID_DOCTYPE_NAME && token.publicId === null && (token.systemId === null || token.systemId === $0c39b5c5866ed00b$var$VALID_SYSTEM_ID);
};
$0c39b5c5866ed00b$export$64782beacef87b30 = function(token) {
    if (token.name !== $0c39b5c5866ed00b$var$VALID_DOCTYPE_NAME) return $0c39b5c5866ed00b$require$DOCUMENT_MODE.QUIRKS;
    const systemId = token.systemId;
    if (systemId && systemId.toLowerCase() === $0c39b5c5866ed00b$var$QUIRKS_MODE_SYSTEM_ID) return $0c39b5c5866ed00b$require$DOCUMENT_MODE.QUIRKS;
    let publicId = token.publicId;
    if (publicId !== null) {
        publicId = publicId.toLowerCase();
        if ($0c39b5c5866ed00b$var$QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1) return $0c39b5c5866ed00b$require$DOCUMENT_MODE.QUIRKS;
        let prefixes = systemId === null ? $0c39b5c5866ed00b$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : $0c39b5c5866ed00b$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES;
        if ($0c39b5c5866ed00b$var$hasPrefix(publicId, prefixes)) return $0c39b5c5866ed00b$require$DOCUMENT_MODE.QUIRKS;
        prefixes = systemId === null ? $0c39b5c5866ed00b$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : $0c39b5c5866ed00b$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
        if ($0c39b5c5866ed00b$var$hasPrefix(publicId, prefixes)) return $0c39b5c5866ed00b$require$DOCUMENT_MODE.LIMITED_QUIRKS;
    }
    return $0c39b5c5866ed00b$require$DOCUMENT_MODE.NO_QUIRKS;
};
$0c39b5c5866ed00b$export$3dc7b315881a047c = function(name, publicId, systemId) {
    let str = "!DOCTYPE ";
    if (name) str += name;
    if (publicId) str += " PUBLIC " + $0c39b5c5866ed00b$var$enquoteDoctypeId(publicId);
    else if (systemId) str += " SYSTEM";
    if (systemId !== null) str += " " + $0c39b5c5866ed00b$var$enquoteDoctypeId(systemId);
    return str;
};


var $fc331a781a9a535d$export$86512877756eb1b1;
//Check exit from foreign content
var $fc331a781a9a535d$export$3435eb4ab4d2ed2d;
//Token adjustments
var $fc331a781a9a535d$export$c583cc5a9d633feb;
var $fc331a781a9a535d$export$74ce06f755fb8f68;
var $fc331a781a9a535d$export$a5192af02995cbdc;
var $fc331a781a9a535d$export$95df78fe2e7f33e3;
var $fc331a781a9a535d$export$6baf3ebfdd620e1;
"use strict";


//Aliases
const $fc331a781a9a535d$var$$ = $7f14ef296305472a$export$7e674a85a2656dce;
const $fc331a781a9a535d$var$NS = $7f14ef296305472a$export$4d2fb7344096e022;
const $fc331a781a9a535d$var$ATTRS = $7f14ef296305472a$export$380b7bc9e6cb1918;
//MIME types
const $fc331a781a9a535d$var$MIME_TYPES = {
    TEXT_HTML: "text/html",
    APPLICATION_XML: "application/xhtml+xml"
};
//Attributes
const $fc331a781a9a535d$var$DEFINITION_URL_ATTR = "definitionurl";
const $fc331a781a9a535d$var$ADJUSTED_DEFINITION_URL_ATTR = "definitionURL";
const $fc331a781a9a535d$var$SVG_ATTRS_ADJUSTMENT_MAP = {
    attributename: "attributeName",
    attributetype: "attributeType",
    basefrequency: "baseFrequency",
    baseprofile: "baseProfile",
    calcmode: "calcMode",
    clippathunits: "clipPathUnits",
    diffuseconstant: "diffuseConstant",
    edgemode: "edgeMode",
    filterunits: "filterUnits",
    glyphref: "glyphRef",
    gradienttransform: "gradientTransform",
    gradientunits: "gradientUnits",
    kernelmatrix: "kernelMatrix",
    kernelunitlength: "kernelUnitLength",
    keypoints: "keyPoints",
    keysplines: "keySplines",
    keytimes: "keyTimes",
    lengthadjust: "lengthAdjust",
    limitingconeangle: "limitingConeAngle",
    markerheight: "markerHeight",
    markerunits: "markerUnits",
    markerwidth: "markerWidth",
    maskcontentunits: "maskContentUnits",
    maskunits: "maskUnits",
    numoctaves: "numOctaves",
    pathlength: "pathLength",
    patterncontentunits: "patternContentUnits",
    patterntransform: "patternTransform",
    patternunits: "patternUnits",
    pointsatx: "pointsAtX",
    pointsaty: "pointsAtY",
    pointsatz: "pointsAtZ",
    preservealpha: "preserveAlpha",
    preserveaspectratio: "preserveAspectRatio",
    primitiveunits: "primitiveUnits",
    refx: "refX",
    refy: "refY",
    repeatcount: "repeatCount",
    repeatdur: "repeatDur",
    requiredextensions: "requiredExtensions",
    requiredfeatures: "requiredFeatures",
    specularconstant: "specularConstant",
    specularexponent: "specularExponent",
    spreadmethod: "spreadMethod",
    startoffset: "startOffset",
    stddeviation: "stdDeviation",
    stitchtiles: "stitchTiles",
    surfacescale: "surfaceScale",
    systemlanguage: "systemLanguage",
    tablevalues: "tableValues",
    targetx: "targetX",
    targety: "targetY",
    textlength: "textLength",
    viewbox: "viewBox",
    viewtarget: "viewTarget",
    xchannelselector: "xChannelSelector",
    ychannelselector: "yChannelSelector",
    zoomandpan: "zoomAndPan"
};
const $fc331a781a9a535d$var$XML_ATTRS_ADJUSTMENT_MAP = {
    "xlink:actuate": {
        prefix: "xlink",
        name: "actuate",
        namespace: $fc331a781a9a535d$var$NS.XLINK
    },
    "xlink:arcrole": {
        prefix: "xlink",
        name: "arcrole",
        namespace: $fc331a781a9a535d$var$NS.XLINK
    },
    "xlink:href": {
        prefix: "xlink",
        name: "href",
        namespace: $fc331a781a9a535d$var$NS.XLINK
    },
    "xlink:role": {
        prefix: "xlink",
        name: "role",
        namespace: $fc331a781a9a535d$var$NS.XLINK
    },
    "xlink:show": {
        prefix: "xlink",
        name: "show",
        namespace: $fc331a781a9a535d$var$NS.XLINK
    },
    "xlink:title": {
        prefix: "xlink",
        name: "title",
        namespace: $fc331a781a9a535d$var$NS.XLINK
    },
    "xlink:type": {
        prefix: "xlink",
        name: "type",
        namespace: $fc331a781a9a535d$var$NS.XLINK
    },
    "xml:base": {
        prefix: "xml",
        name: "base",
        namespace: $fc331a781a9a535d$var$NS.XML
    },
    "xml:lang": {
        prefix: "xml",
        name: "lang",
        namespace: $fc331a781a9a535d$var$NS.XML
    },
    "xml:space": {
        prefix: "xml",
        name: "space",
        namespace: $fc331a781a9a535d$var$NS.XML
    },
    xmlns: {
        prefix: "",
        name: "xmlns",
        namespace: $fc331a781a9a535d$var$NS.XMLNS
    },
    "xmlns:xlink": {
        prefix: "xmlns",
        name: "xlink",
        namespace: $fc331a781a9a535d$var$NS.XMLNS
    }
};
//SVG tag names adjustment map
const $fc331a781a9a535d$var$SVG_TAG_NAMES_ADJUSTMENT_MAP = $fc331a781a9a535d$export$86512877756eb1b1 = {
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient",
    textpath: "textPath"
};
//Tags that causes exit from foreign content
const $fc331a781a9a535d$var$EXITS_FOREIGN_CONTENT = {
    [$fc331a781a9a535d$var$$.B]: true,
    [$fc331a781a9a535d$var$$.BIG]: true,
    [$fc331a781a9a535d$var$$.BLOCKQUOTE]: true,
    [$fc331a781a9a535d$var$$.BODY]: true,
    [$fc331a781a9a535d$var$$.BR]: true,
    [$fc331a781a9a535d$var$$.CENTER]: true,
    [$fc331a781a9a535d$var$$.CODE]: true,
    [$fc331a781a9a535d$var$$.DD]: true,
    [$fc331a781a9a535d$var$$.DIV]: true,
    [$fc331a781a9a535d$var$$.DL]: true,
    [$fc331a781a9a535d$var$$.DT]: true,
    [$fc331a781a9a535d$var$$.EM]: true,
    [$fc331a781a9a535d$var$$.EMBED]: true,
    [$fc331a781a9a535d$var$$.H1]: true,
    [$fc331a781a9a535d$var$$.H2]: true,
    [$fc331a781a9a535d$var$$.H3]: true,
    [$fc331a781a9a535d$var$$.H4]: true,
    [$fc331a781a9a535d$var$$.H5]: true,
    [$fc331a781a9a535d$var$$.H6]: true,
    [$fc331a781a9a535d$var$$.HEAD]: true,
    [$fc331a781a9a535d$var$$.HR]: true,
    [$fc331a781a9a535d$var$$.I]: true,
    [$fc331a781a9a535d$var$$.IMG]: true,
    [$fc331a781a9a535d$var$$.LI]: true,
    [$fc331a781a9a535d$var$$.LISTING]: true,
    [$fc331a781a9a535d$var$$.MENU]: true,
    [$fc331a781a9a535d$var$$.META]: true,
    [$fc331a781a9a535d$var$$.NOBR]: true,
    [$fc331a781a9a535d$var$$.OL]: true,
    [$fc331a781a9a535d$var$$.P]: true,
    [$fc331a781a9a535d$var$$.PRE]: true,
    [$fc331a781a9a535d$var$$.RUBY]: true,
    [$fc331a781a9a535d$var$$.S]: true,
    [$fc331a781a9a535d$var$$.SMALL]: true,
    [$fc331a781a9a535d$var$$.SPAN]: true,
    [$fc331a781a9a535d$var$$.STRONG]: true,
    [$fc331a781a9a535d$var$$.STRIKE]: true,
    [$fc331a781a9a535d$var$$.SUB]: true,
    [$fc331a781a9a535d$var$$.SUP]: true,
    [$fc331a781a9a535d$var$$.TABLE]: true,
    [$fc331a781a9a535d$var$$.TT]: true,
    [$fc331a781a9a535d$var$$.U]: true,
    [$fc331a781a9a535d$var$$.UL]: true,
    [$fc331a781a9a535d$var$$.VAR]: true
};
$fc331a781a9a535d$export$3435eb4ab4d2ed2d = function(startTagToken) {
    const tn = startTagToken.tagName;
    const isFontWithAttrs = tn === $fc331a781a9a535d$var$$.FONT && ($1402a60f2d09b0f9$exports.getTokenAttr(startTagToken, $fc331a781a9a535d$var$ATTRS.COLOR) !== null || $1402a60f2d09b0f9$exports.getTokenAttr(startTagToken, $fc331a781a9a535d$var$ATTRS.SIZE) !== null || $1402a60f2d09b0f9$exports.getTokenAttr(startTagToken, $fc331a781a9a535d$var$ATTRS.FACE) !== null);
    return isFontWithAttrs ? true : $fc331a781a9a535d$var$EXITS_FOREIGN_CONTENT[tn];
};
$fc331a781a9a535d$export$c583cc5a9d633feb = function(token) {
    for(let i = 0; i < token.attrs.length; i++)if (token.attrs[i].name === $fc331a781a9a535d$var$DEFINITION_URL_ATTR) {
        token.attrs[i].name = $fc331a781a9a535d$var$ADJUSTED_DEFINITION_URL_ATTR;
        break;
    }
};
$fc331a781a9a535d$export$74ce06f755fb8f68 = function(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrName = $fc331a781a9a535d$var$SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];
        if (adjustedAttrName) token.attrs[i].name = adjustedAttrName;
    }
};
$fc331a781a9a535d$export$a5192af02995cbdc = function(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrEntry = $fc331a781a9a535d$var$XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];
        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
};
$fc331a781a9a535d$export$95df78fe2e7f33e3 = function(token) {
    const adjustedTagName = $fc331a781a9a535d$var$SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];
    if (adjustedTagName) token.tagName = adjustedTagName;
};
//Integration points
function $fc331a781a9a535d$var$isMathMLTextIntegrationPoint(tn, ns) {
    return ns === $fc331a781a9a535d$var$NS.MATHML && (tn === $fc331a781a9a535d$var$$.MI || tn === $fc331a781a9a535d$var$$.MO || tn === $fc331a781a9a535d$var$$.MN || tn === $fc331a781a9a535d$var$$.MS || tn === $fc331a781a9a535d$var$$.MTEXT);
}
function $fc331a781a9a535d$var$isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === $fc331a781a9a535d$var$NS.MATHML && tn === $fc331a781a9a535d$var$$.ANNOTATION_XML) {
        for(let i = 0; i < attrs.length; i++)if (attrs[i].name === $fc331a781a9a535d$var$ATTRS.ENCODING) {
            const value = attrs[i].value.toLowerCase();
            return value === $fc331a781a9a535d$var$MIME_TYPES.TEXT_HTML || value === $fc331a781a9a535d$var$MIME_TYPES.APPLICATION_XML;
        }
    }
    return ns === $fc331a781a9a535d$var$NS.SVG && (tn === $fc331a781a9a535d$var$$.FOREIGN_OBJECT || tn === $fc331a781a9a535d$var$$.DESC || tn === $fc331a781a9a535d$var$$.TITLE);
}
$fc331a781a9a535d$export$6baf3ebfdd620e1 = function(tn, ns, attrs, foreignNS) {
    if ((!foreignNS || foreignNS === $fc331a781a9a535d$var$NS.HTML) && $fc331a781a9a535d$var$isHtmlIntegrationPoint(tn, ns, attrs)) return true;
    if ((!foreignNS || foreignNS === $fc331a781a9a535d$var$NS.MATHML) && $fc331a781a9a535d$var$isMathMLTextIntegrationPoint(tn, ns)) return true;
    return false;
};





//Aliases
const $3c987794e73954fa$var$$ = $7f14ef296305472a$export$7e674a85a2656dce;
const $3c987794e73954fa$var$NS = $7f14ef296305472a$export$4d2fb7344096e022;
const $3c987794e73954fa$var$ATTRS = $7f14ef296305472a$export$380b7bc9e6cb1918;
const $3c987794e73954fa$var$DEFAULT_OPTIONS = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    onParseError: null,
    treeAdapter: $dd96ea840bc7d0d2$exports
};
//Misc constants
const $3c987794e73954fa$var$HIDDEN_INPUT_TYPE = "hidden";
//Adoption agency loops iteration count
const $3c987794e73954fa$var$AA_OUTER_LOOP_ITER = 8;
const $3c987794e73954fa$var$AA_INNER_LOOP_ITER = 3;
//Insertion modes
const $3c987794e73954fa$var$INITIAL_MODE = "INITIAL_MODE";
const $3c987794e73954fa$var$BEFORE_HTML_MODE = "BEFORE_HTML_MODE";
const $3c987794e73954fa$var$BEFORE_HEAD_MODE = "BEFORE_HEAD_MODE";
const $3c987794e73954fa$var$IN_HEAD_MODE = "IN_HEAD_MODE";
const $3c987794e73954fa$var$IN_HEAD_NO_SCRIPT_MODE = "IN_HEAD_NO_SCRIPT_MODE";
const $3c987794e73954fa$var$AFTER_HEAD_MODE = "AFTER_HEAD_MODE";
const $3c987794e73954fa$var$IN_BODY_MODE = "IN_BODY_MODE";
const $3c987794e73954fa$var$TEXT_MODE = "TEXT_MODE";
const $3c987794e73954fa$var$IN_TABLE_MODE = "IN_TABLE_MODE";
const $3c987794e73954fa$var$IN_TABLE_TEXT_MODE = "IN_TABLE_TEXT_MODE";
const $3c987794e73954fa$var$IN_CAPTION_MODE = "IN_CAPTION_MODE";
const $3c987794e73954fa$var$IN_COLUMN_GROUP_MODE = "IN_COLUMN_GROUP_MODE";
const $3c987794e73954fa$var$IN_TABLE_BODY_MODE = "IN_TABLE_BODY_MODE";
const $3c987794e73954fa$var$IN_ROW_MODE = "IN_ROW_MODE";
const $3c987794e73954fa$var$IN_CELL_MODE = "IN_CELL_MODE";
const $3c987794e73954fa$var$IN_SELECT_MODE = "IN_SELECT_MODE";
const $3c987794e73954fa$var$IN_SELECT_IN_TABLE_MODE = "IN_SELECT_IN_TABLE_MODE";
const $3c987794e73954fa$var$IN_TEMPLATE_MODE = "IN_TEMPLATE_MODE";
const $3c987794e73954fa$var$AFTER_BODY_MODE = "AFTER_BODY_MODE";
const $3c987794e73954fa$var$IN_FRAMESET_MODE = "IN_FRAMESET_MODE";
const $3c987794e73954fa$var$AFTER_FRAMESET_MODE = "AFTER_FRAMESET_MODE";
const $3c987794e73954fa$var$AFTER_AFTER_BODY_MODE = "AFTER_AFTER_BODY_MODE";
const $3c987794e73954fa$var$AFTER_AFTER_FRAMESET_MODE = "AFTER_AFTER_FRAMESET_MODE";
//Insertion mode reset map
const $3c987794e73954fa$var$INSERTION_MODE_RESET_MAP = {
    [$3c987794e73954fa$var$$.TR]: $3c987794e73954fa$var$IN_ROW_MODE,
    [$3c987794e73954fa$var$$.TBODY]: $3c987794e73954fa$var$IN_TABLE_BODY_MODE,
    [$3c987794e73954fa$var$$.THEAD]: $3c987794e73954fa$var$IN_TABLE_BODY_MODE,
    [$3c987794e73954fa$var$$.TFOOT]: $3c987794e73954fa$var$IN_TABLE_BODY_MODE,
    [$3c987794e73954fa$var$$.CAPTION]: $3c987794e73954fa$var$IN_CAPTION_MODE,
    [$3c987794e73954fa$var$$.COLGROUP]: $3c987794e73954fa$var$IN_COLUMN_GROUP_MODE,
    [$3c987794e73954fa$var$$.TABLE]: $3c987794e73954fa$var$IN_TABLE_MODE,
    [$3c987794e73954fa$var$$.BODY]: $3c987794e73954fa$var$IN_BODY_MODE,
    [$3c987794e73954fa$var$$.FRAMESET]: $3c987794e73954fa$var$IN_FRAMESET_MODE
};
//Template insertion mode switch map
const $3c987794e73954fa$var$TEMPLATE_INSERTION_MODE_SWITCH_MAP = {
    [$3c987794e73954fa$var$$.CAPTION]: $3c987794e73954fa$var$IN_TABLE_MODE,
    [$3c987794e73954fa$var$$.COLGROUP]: $3c987794e73954fa$var$IN_TABLE_MODE,
    [$3c987794e73954fa$var$$.TBODY]: $3c987794e73954fa$var$IN_TABLE_MODE,
    [$3c987794e73954fa$var$$.TFOOT]: $3c987794e73954fa$var$IN_TABLE_MODE,
    [$3c987794e73954fa$var$$.THEAD]: $3c987794e73954fa$var$IN_TABLE_MODE,
    [$3c987794e73954fa$var$$.COL]: $3c987794e73954fa$var$IN_COLUMN_GROUP_MODE,
    [$3c987794e73954fa$var$$.TR]: $3c987794e73954fa$var$IN_TABLE_BODY_MODE,
    [$3c987794e73954fa$var$$.TD]: $3c987794e73954fa$var$IN_ROW_MODE,
    [$3c987794e73954fa$var$$.TH]: $3c987794e73954fa$var$IN_ROW_MODE
};
//Token handlers map for insertion modes
const $3c987794e73954fa$var$TOKEN_HANDLERS = {
    [$3c987794e73954fa$var$INITIAL_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenInInitialMode,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenInInitialMode,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$doctypeInInitialMode,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$tokenInInitialMode,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$tokenInInitialMode,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$tokenInInitialMode
    },
    [$3c987794e73954fa$var$BEFORE_HTML_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenBeforeHtml,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenBeforeHtml,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagBeforeHtml,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagBeforeHtml,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$tokenBeforeHtml
    },
    [$3c987794e73954fa$var$BEFORE_HEAD_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenBeforeHead,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenBeforeHead,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$misplacedDoctype,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagBeforeHead,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagBeforeHead,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$tokenBeforeHead
    },
    [$3c987794e73954fa$var$IN_HEAD_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenInHead,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenInHead,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$misplacedDoctype,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInHead,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInHead,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$tokenInHead
    },
    [$3c987794e73954fa$var$IN_HEAD_NO_SCRIPT_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenInHeadNoScript,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenInHeadNoScript,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$misplacedDoctype,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInHeadNoScript,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInHeadNoScript,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$tokenInHeadNoScript
    },
    [$3c987794e73954fa$var$AFTER_HEAD_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenAfterHead,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenAfterHead,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$misplacedDoctype,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagAfterHead,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagAfterHead,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$tokenAfterHead
    },
    [$3c987794e73954fa$var$IN_BODY_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInBody,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$whitespaceCharacterInBody,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInBody,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInBody,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$TEXT_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInText,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInText
    },
    [$3c987794e73954fa$var$IN_TABLE_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInTable,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInTable,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$IN_TABLE_TEXT_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTableText,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$whitespaceCharacterInTableText,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$tokenInTableText,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$tokenInTableText,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$tokenInTableText,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$tokenInTableText,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$tokenInTableText
    },
    [$3c987794e73954fa$var$IN_CAPTION_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInBody,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$whitespaceCharacterInBody,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInCaption,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInCaption,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$IN_COLUMN_GROUP_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenInColumnGroup,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenInColumnGroup,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInColumnGroup,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInColumnGroup,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$IN_TABLE_BODY_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInTableBody,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInTableBody,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$IN_ROW_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInTable,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInRow,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInRow,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$IN_CELL_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInBody,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$whitespaceCharacterInBody,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInCell,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInCell,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$IN_SELECT_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInSelect,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInSelect,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$IN_SELECT_IN_TABLE_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInSelectInTable,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInSelectInTable,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInBody
    },
    [$3c987794e73954fa$var$IN_TEMPLATE_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$characterInBody,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$whitespaceCharacterInBody,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInTemplate,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInTemplate,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$eofInTemplate
    },
    [$3c987794e73954fa$var$AFTER_BODY_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenAfterBody,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenAfterBody,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$whitespaceCharacterInBody,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendCommentToRootHtmlElement,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagAfterBody,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagAfterBody,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$stopParsing
    },
    [$3c987794e73954fa$var$IN_FRAMESET_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagInFrameset,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagInFrameset,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$stopParsing
    },
    [$3c987794e73954fa$var$AFTER_FRAMESET_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$insertCharacters,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendComment,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagAfterFrameset,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$endTagAfterFrameset,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$stopParsing
    },
    [$3c987794e73954fa$var$AFTER_AFTER_BODY_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenAfterAfterBody,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$tokenAfterAfterBody,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$whitespaceCharacterInBody,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendCommentToDocument,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagAfterAfterBody,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$tokenAfterAfterBody,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$stopParsing
    },
    [$3c987794e73954fa$var$AFTER_AFTER_FRAMESET_MODE]: {
        [$1402a60f2d09b0f9$exports.CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN]: $3c987794e73954fa$var$whitespaceCharacterInBody,
        [$1402a60f2d09b0f9$exports.COMMENT_TOKEN]: $3c987794e73954fa$var$appendCommentToDocument,
        [$1402a60f2d09b0f9$exports.DOCTYPE_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.START_TAG_TOKEN]: $3c987794e73954fa$var$startTagAfterAfterFrameset,
        [$1402a60f2d09b0f9$exports.END_TAG_TOKEN]: $3c987794e73954fa$var$ignoreToken,
        [$1402a60f2d09b0f9$exports.EOF_TOKEN]: $3c987794e73954fa$var$stopParsing
    }
};
//Parser
class $3c987794e73954fa$var$Parser {
    constructor(options){
        this.options = $f8e84399a711d5fe$exports($3c987794e73954fa$var$DEFAULT_OPTIONS, options);
        this.treeAdapter = this.options.treeAdapter;
        this.pendingScript = null;
        if (this.options.sourceCodeLocationInfo) $e7b605daec02218c$exports.install(this, $56554d1da53e62e3$exports);
        if (this.options.onParseError) $e7b605daec02218c$exports.install(this, $cc0a9038c76dd70d$exports, {
            onParseError: this.options.onParseError
        });
    }
    // API
    parse(html) {
        const document = this.treeAdapter.createDocument();
        this._bootstrap(document, null);
        this.tokenizer.write(html, true);
        this._runParsingLoop(null);
        return document;
    }
    parseFragment(html, fragmentContext) {
        //NOTE: use <template> element as a fragment context if context element was not provided,
        //so we will parse in "forgiving" manner
        if (!fragmentContext) fragmentContext = this.treeAdapter.createElement($3c987794e73954fa$var$$.TEMPLATE, $3c987794e73954fa$var$NS.HTML, []);
        //NOTE: create fake element which will be used as 'document' for fragment parsing.
        //This is important for jsdom there 'document' can't be recreated, therefore
        //fragment parsing causes messing of the main `document`.
        const documentMock = this.treeAdapter.createElement("documentmock", $3c987794e73954fa$var$NS.HTML, []);
        this._bootstrap(documentMock, fragmentContext);
        if (this.treeAdapter.getTagName(fragmentContext) === $3c987794e73954fa$var$$.TEMPLATE) this._pushTmplInsertionMode($3c987794e73954fa$var$IN_TEMPLATE_MODE);
        this._initTokenizerForFragmentParsing();
        this._insertFakeRootElement();
        this._resetInsertionMode();
        this._findFormInFragmentContext();
        this.tokenizer.write(html, true);
        this._runParsingLoop(null);
        const rootElement = this.treeAdapter.getFirstChild(documentMock);
        const fragment = this.treeAdapter.createDocumentFragment();
        this._adoptNodes(rootElement, fragment);
        return fragment;
    }
    //Bootstrap parser
    _bootstrap(document, fragmentContext) {
        this.tokenizer = new $1402a60f2d09b0f9$exports(this.options);
        this.stopped = false;
        this.insertionMode = $3c987794e73954fa$var$INITIAL_MODE;
        this.originalInsertionMode = "";
        this.document = document;
        this.fragmentContext = fragmentContext;
        this.headElement = null;
        this.formElement = null;
        this.openElements = new $6010bf3e76553f22$exports(this.document, this.treeAdapter);
        this.activeFormattingElements = new $233582e571a8f049$exports(this.treeAdapter);
        this.tmplInsertionModeStack = [];
        this.tmplInsertionModeStackTop = -1;
        this.currentTmplInsertionMode = null;
        this.pendingCharacterTokens = [];
        this.hasNonWhitespacePendingCharacterToken = false;
        this.framesetOk = true;
        this.skipNextNewLine = false;
        this.fosterParentingEnabled = false;
    }
    //Errors
    _err() {
    // NOTE: err reporting is noop by default. Enabled by mixin.
    }
    //Parsing loop
    _runParsingLoop(scriptHandler) {
        while(!this.stopped){
            this._setupTokenizerCDATAMode();
            const token = this.tokenizer.getNextToken();
            if (token.type === $1402a60f2d09b0f9$exports.HIBERNATION_TOKEN) break;
            if (this.skipNextNewLine) {
                this.skipNextNewLine = false;
                if (token.type === $1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === "\n") {
                    if (token.chars.length === 1) continue;
                    token.chars = token.chars.substr(1);
                }
            }
            this._processInputToken(token);
            if (scriptHandler && this.pendingScript) break;
        }
    }
    runParsingLoopForCurrentChunk(writeCallback, scriptHandler) {
        this._runParsingLoop(scriptHandler);
        if (scriptHandler && this.pendingScript) {
            const script = this.pendingScript;
            this.pendingScript = null;
            scriptHandler(script);
            return;
        }
        if (writeCallback) writeCallback();
    }
    //Text parsing
    _setupTokenizerCDATAMode() {
        const current = this._getAdjustedCurrentElement();
        this.tokenizer.allowCDATA = current && current !== this.document && this.treeAdapter.getNamespaceURI(current) !== $3c987794e73954fa$var$NS.HTML && !this._isIntegrationPoint(current);
    }
    _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, $3c987794e73954fa$var$NS.HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = $3c987794e73954fa$var$TEXT_MODE;
    }
    switchToPlaintextParsing() {
        this.insertionMode = $3c987794e73954fa$var$TEXT_MODE;
        this.originalInsertionMode = $3c987794e73954fa$var$IN_BODY_MODE;
        this.tokenizer.state = $1402a60f2d09b0f9$exports.MODE.PLAINTEXT;
    }
    //Fragment parsing
    _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    _findFormInFragmentContext() {
        let node = this.fragmentContext;
        do {
            if (this.treeAdapter.getTagName(node) === $3c987794e73954fa$var$$.FORM) {
                this.formElement = node;
                break;
            }
            node = this.treeAdapter.getParentNode(node);
        }while (node);
    }
    _initTokenizerForFragmentParsing() {
        if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === $3c987794e73954fa$var$NS.HTML) {
            const tn = this.treeAdapter.getTagName(this.fragmentContext);
            if (tn === $3c987794e73954fa$var$$.TITLE || tn === $3c987794e73954fa$var$$.TEXTAREA) this.tokenizer.state = $1402a60f2d09b0f9$exports.MODE.RCDATA;
            else if (tn === $3c987794e73954fa$var$$.STYLE || tn === $3c987794e73954fa$var$$.XMP || tn === $3c987794e73954fa$var$$.IFRAME || tn === $3c987794e73954fa$var$$.NOEMBED || tn === $3c987794e73954fa$var$$.NOFRAMES || tn === $3c987794e73954fa$var$$.NOSCRIPT) this.tokenizer.state = $1402a60f2d09b0f9$exports.MODE.RAWTEXT;
            else if (tn === $3c987794e73954fa$var$$.SCRIPT) this.tokenizer.state = $1402a60f2d09b0f9$exports.MODE.SCRIPT_DATA;
            else if (tn === $3c987794e73954fa$var$$.PLAINTEXT) this.tokenizer.state = $1402a60f2d09b0f9$exports.MODE.PLAINTEXT;
        }
    }
    //Tree mutation
    _setDocumentType(token) {
        const name = token.name || "";
        const publicId = token.publicId || "";
        const systemId = token.systemId || "";
        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
    }
    _attachElementToTree(element) {
        if (this._shouldFosterParentOnInsertion()) this._fosterParentElement(element);
        else {
            const parent = this.openElements.currentTmplContent || this.openElements.current;
            this.treeAdapter.appendChild(parent, element);
        }
    }
    _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element);
    }
    _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element);
        this.openElements.push(element);
    }
    _insertFakeElement(tagName) {
        const element = this.treeAdapter.createElement(tagName, $3c987794e73954fa$var$NS.HTML, []);
        this._attachElementToTree(element);
        this.openElements.push(element);
    }
    _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, $3c987794e73954fa$var$NS.HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();
        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl);
        this.openElements.push(tmpl);
    }
    _insertFakeRootElement() {
        const element = this.treeAdapter.createElement($3c987794e73954fa$var$$.HTML, $3c987794e73954fa$var$NS.HTML, []);
        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element);
    }
    _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);
        this.treeAdapter.appendChild(parent, commentNode);
    }
    _insertCharacters(token) {
        if (this._shouldFosterParentOnInsertion()) this._fosterParentText(token.chars);
        else {
            const parent = this.openElements.currentTmplContent || this.openElements.current;
            this.treeAdapter.insertText(parent, token.chars);
        }
    }
    _adoptNodes(donor, recipient) {
        for(let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)){
            this.treeAdapter.detachNode(child);
            this.treeAdapter.appendChild(recipient, child);
        }
    }
    //Token processing
    _shouldProcessTokenInForeignContent(token) {
        const current = this._getAdjustedCurrentElement();
        if (!current || current === this.document) return false;
        const ns = this.treeAdapter.getNamespaceURI(current);
        if (ns === $3c987794e73954fa$var$NS.HTML) return false;
        if (this.treeAdapter.getTagName(current) === $3c987794e73954fa$var$$.ANNOTATION_XML && ns === $3c987794e73954fa$var$NS.MATHML && token.type === $1402a60f2d09b0f9$exports.START_TAG_TOKEN && token.tagName === $3c987794e73954fa$var$$.SVG) return false;
        const isCharacterToken = token.type === $1402a60f2d09b0f9$exports.CHARACTER_TOKEN || token.type === $1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN || token.type === $1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN;
        const isMathMLTextStartTag = token.type === $1402a60f2d09b0f9$exports.START_TAG_TOKEN && token.tagName !== $3c987794e73954fa$var$$.MGLYPH && token.tagName !== $3c987794e73954fa$var$$.MALIGNMARK;
        if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, $3c987794e73954fa$var$NS.MATHML)) return false;
        if ((token.type === $1402a60f2d09b0f9$exports.START_TAG_TOKEN || isCharacterToken) && this._isIntegrationPoint(current, $3c987794e73954fa$var$NS.HTML)) return false;
        return token.type !== $1402a60f2d09b0f9$exports.EOF_TOKEN;
    }
    _processToken(token) {
        $3c987794e73954fa$var$TOKEN_HANDLERS[this.insertionMode][token.type](this, token);
    }
    _processTokenInBodyMode(token) {
        $3c987794e73954fa$var$TOKEN_HANDLERS[$3c987794e73954fa$var$IN_BODY_MODE][token.type](this, token);
    }
    _processTokenInForeignContent(token) {
        if (token.type === $1402a60f2d09b0f9$exports.CHARACTER_TOKEN) $3c987794e73954fa$var$characterInForeignContent(this, token);
        else if (token.type === $1402a60f2d09b0f9$exports.NULL_CHARACTER_TOKEN) $3c987794e73954fa$var$nullCharacterInForeignContent(this, token);
        else if (token.type === $1402a60f2d09b0f9$exports.WHITESPACE_CHARACTER_TOKEN) $3c987794e73954fa$var$insertCharacters(this, token);
        else if (token.type === $1402a60f2d09b0f9$exports.COMMENT_TOKEN) $3c987794e73954fa$var$appendComment(this, token);
        else if (token.type === $1402a60f2d09b0f9$exports.START_TAG_TOKEN) $3c987794e73954fa$var$startTagInForeignContent(this, token);
        else if (token.type === $1402a60f2d09b0f9$exports.END_TAG_TOKEN) $3c987794e73954fa$var$endTagInForeignContent(this, token);
    }
    _processInputToken(token) {
        if (this._shouldProcessTokenInForeignContent(token)) this._processTokenInForeignContent(token);
        else this._processToken(token);
        if (token.type === $1402a60f2d09b0f9$exports.START_TAG_TOKEN && token.selfClosing && !token.ackSelfClosing) this._err($17010537ac9d51f5$exports.nonVoidHtmlElementStartTagWithTrailingSolidus);
    }
    //Integration points
    _isIntegrationPoint(element, foreignNS) {
        const tn = this.treeAdapter.getTagName(element);
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);
        return $fc331a781a9a535d$export$6baf3ebfdd620e1(tn, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
    _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.length;
        if (listLength) {
            let unopenIdx = listLength;
            let entry = null;
            do {
                unopenIdx--;
                entry = this.activeFormattingElements.entries[unopenIdx];
                if (entry.type === $233582e571a8f049$exports.MARKER_ENTRY || this.openElements.contains(entry.element)) {
                    unopenIdx++;
                    break;
                }
            }while (unopenIdx > 0);
            for(let i = unopenIdx; i < listLength; i++){
                entry = this.activeFormattingElements.entries[i];
                this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
                entry.element = this.openElements.current;
            }
        }
    }
    //Close elements
    _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = $3c987794e73954fa$var$IN_ROW_MODE;
    }
    _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion($3c987794e73954fa$var$$.P);
        this.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.P);
    }
    //Insertion modes
    _resetInsertionMode() {
        for(let i = this.openElements.stackTop, last = false; i >= 0; i--){
            let element = this.openElements.items[i];
            if (i === 0) {
                last = true;
                if (this.fragmentContext) element = this.fragmentContext;
            }
            const tn = this.treeAdapter.getTagName(element);
            const newInsertionMode = $3c987794e73954fa$var$INSERTION_MODE_RESET_MAP[tn];
            if (newInsertionMode) {
                this.insertionMode = newInsertionMode;
                break;
            } else if (!last && (tn === $3c987794e73954fa$var$$.TD || tn === $3c987794e73954fa$var$$.TH)) {
                this.insertionMode = $3c987794e73954fa$var$IN_CELL_MODE;
                break;
            } else if (!last && tn === $3c987794e73954fa$var$$.HEAD) {
                this.insertionMode = $3c987794e73954fa$var$IN_HEAD_MODE;
                break;
            } else if (tn === $3c987794e73954fa$var$$.SELECT) {
                this._resetInsertionModeForSelect(i);
                break;
            } else if (tn === $3c987794e73954fa$var$$.TEMPLATE) {
                this.insertionMode = this.currentTmplInsertionMode;
                break;
            } else if (tn === $3c987794e73954fa$var$$.HTML) {
                this.insertionMode = this.headElement ? $3c987794e73954fa$var$AFTER_HEAD_MODE : $3c987794e73954fa$var$BEFORE_HEAD_MODE;
                break;
            } else if (last) {
                this.insertionMode = $3c987794e73954fa$var$IN_BODY_MODE;
                break;
            }
        }
    }
    _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) for(let i = selectIdx - 1; i > 0; i--){
            const ancestor = this.openElements.items[i];
            const tn = this.treeAdapter.getTagName(ancestor);
            if (tn === $3c987794e73954fa$var$$.TEMPLATE) break;
            else if (tn === $3c987794e73954fa$var$$.TABLE) {
                this.insertionMode = $3c987794e73954fa$var$IN_SELECT_IN_TABLE_MODE;
                return;
            }
        }
        this.insertionMode = $3c987794e73954fa$var$IN_SELECT_MODE;
    }
    _pushTmplInsertionMode(mode) {
        this.tmplInsertionModeStack.push(mode);
        this.tmplInsertionModeStackTop++;
        this.currentTmplInsertionMode = mode;
    }
    _popTmplInsertionMode() {
        this.tmplInsertionModeStack.pop();
        this.tmplInsertionModeStackTop--;
        this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
    }
    //Foster parenting
    _isElementCausesFosterParenting(element) {
        const tn = this.treeAdapter.getTagName(element);
        return tn === $3c987794e73954fa$var$$.TABLE || tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD || tn === $3c987794e73954fa$var$$.TR;
    }
    _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
    }
    _findFosterParentingLocation() {
        const location = {
            parent: null,
            beforeElement: null
        };
        for(let i = this.openElements.stackTop; i >= 0; i--){
            const openElement = this.openElements.items[i];
            const tn = this.treeAdapter.getTagName(openElement);
            const ns = this.treeAdapter.getNamespaceURI(openElement);
            if (tn === $3c987794e73954fa$var$$.TEMPLATE && ns === $3c987794e73954fa$var$NS.HTML) {
                location.parent = this.treeAdapter.getTemplateContent(openElement);
                break;
            } else if (tn === $3c987794e73954fa$var$$.TABLE) {
                location.parent = this.treeAdapter.getParentNode(openElement);
                if (location.parent) location.beforeElement = openElement;
                else location.parent = this.openElements.items[i - 1];
                break;
            }
        }
        if (!location.parent) location.parent = this.openElements.items[0];
        return location;
    }
    _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        else this.treeAdapter.appendChild(location.parent, element);
    }
    _fosterParentText(chars) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
        else this.treeAdapter.insertText(location.parent, chars);
    }
    //Special elements
    _isSpecialElement(element) {
        const tn = this.treeAdapter.getTagName(element);
        const ns = this.treeAdapter.getNamespaceURI(element);
        return $7f14ef296305472a$export$7e5172336f7d2bbb[ns][tn];
    }
}
$3c987794e73954fa$exports = $3c987794e73954fa$var$Parser;
//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------
//Steps 5-8 of the algorithm
function $3c987794e73954fa$var$aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        } else if (!p.openElements.hasInScope(token.tagName)) formattingElementEntry = null;
    } else $3c987794e73954fa$var$genericEndTagInBody(p, token);
    return formattingElementEntry;
}
//Steps 9 and 10 of the algorithm
function $3c987794e73954fa$var$aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;
    for(let i = p.openElements.stackTop; i >= 0; i--){
        const element = p.openElements.items[i];
        if (element === formattingElementEntry.element) break;
        if (p._isSpecialElement(element)) furthestBlock = element;
    }
    if (!furthestBlock) {
        p.openElements.popUntilElementPopped(formattingElementEntry.element);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }
    return furthestBlock;
}
//Step 13 of the algorithm
function $3c987794e73954fa$var$aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);
    for(let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement){
        //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);
        const elementEntry = p.activeFormattingElements.getElementEntry(element);
        const counterOverflow = elementEntry && i >= $3c987794e73954fa$var$AA_INNER_LOOP_ITER;
        const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
        if (shouldRemoveFromOpenElements) {
            if (counterOverflow) p.activeFormattingElements.removeEntry(elementEntry);
            p.openElements.remove(element);
        } else {
            element = $3c987794e73954fa$var$aaRecreateElementFromEntry(p, elementEntry);
            if (lastElement === furthestBlock) p.activeFormattingElements.bookmark = elementEntry;
            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }
    return lastElement;
}
//Step 13.7 of the algorithm
function $3c987794e73954fa$var$aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;
    return newElement;
}
//Step 14 of the algorithm
function $3c987794e73954fa$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    if (p._isElementCausesFosterParenting(commonAncestor)) p._fosterParentElement(lastElement);
    else {
        const tn = p.treeAdapter.getTagName(commonAncestor);
        const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
        if (tn === $3c987794e73954fa$var$$.TEMPLATE && ns === $3c987794e73954fa$var$NS.HTML) commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}
//Steps 15-19 of the algorithm
function $3c987794e73954fa$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const token = formattingElementEntry.token;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);
    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement);
}
//Algorithm entry point
function $3c987794e73954fa$var$callAdoptionAgency(p, token) {
    let formattingElementEntry;
    for(let i = 0; i < $3c987794e73954fa$var$AA_OUTER_LOOP_ITER; i++){
        formattingElementEntry = $3c987794e73954fa$var$aaObtainFormattingElementEntry(p, token, formattingElementEntry);
        if (!formattingElementEntry) break;
        const furthestBlock = $3c987794e73954fa$var$aaObtainFurthestBlock(p, formattingElementEntry);
        if (!furthestBlock) break;
        p.activeFormattingElements.bookmark = formattingElementEntry;
        const lastElement = $3c987794e73954fa$var$aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
        const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
        p.treeAdapter.detachNode(lastElement);
        $3c987794e73954fa$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        $3c987794e73954fa$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}
//Generic token handlers
//------------------------------------------------------------------
function $3c987794e73954fa$var$ignoreToken() {
//NOTE: do nothing =)
}
function $3c987794e73954fa$var$misplacedDoctype(p) {
    p._err($17010537ac9d51f5$exports.misplacedDoctype);
}
function $3c987794e73954fa$var$appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
}
function $3c987794e73954fa$var$appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}
function $3c987794e73954fa$var$appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}
function $3c987794e73954fa$var$insertCharacters(p, token) {
    p._insertCharacters(token);
}
function $3c987794e73954fa$var$stopParsing(p) {
    p.stopped = true;
}
// The "initial" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$doctypeInInitialMode(p, token) {
    p._setDocumentType(token);
    const mode = token.forceQuirks ? $7f14ef296305472a$export$a74d46c85337d29a.QUIRKS : $0c39b5c5866ed00b$export$64782beacef87b30(token);
    if (!$0c39b5c5866ed00b$export$ee48152ecc0e3f40(token)) p._err($17010537ac9d51f5$exports.nonConformingDoctype);
    p.treeAdapter.setDocumentMode(p.document, mode);
    p.insertionMode = $3c987794e73954fa$var$BEFORE_HTML_MODE;
}
function $3c987794e73954fa$var$tokenInInitialMode(p, token) {
    p._err($17010537ac9d51f5$exports.missingDoctype, {
        beforeToken: true
    });
    p.treeAdapter.setDocumentMode(p.document, $7f14ef296305472a$export$a74d46c85337d29a.QUIRKS);
    p.insertionMode = $3c987794e73954fa$var$BEFORE_HTML_MODE;
    p._processToken(token);
}
// The "before html" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagBeforeHtml(p, token) {
    if (token.tagName === $3c987794e73954fa$var$$.HTML) {
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        p.insertionMode = $3c987794e73954fa$var$BEFORE_HEAD_MODE;
    } else $3c987794e73954fa$var$tokenBeforeHtml(p, token);
}
function $3c987794e73954fa$var$endTagBeforeHtml(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML || tn === $3c987794e73954fa$var$$.HEAD || tn === $3c987794e73954fa$var$$.BODY || tn === $3c987794e73954fa$var$$.BR) $3c987794e73954fa$var$tokenBeforeHtml(p, token);
}
function $3c987794e73954fa$var$tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = $3c987794e73954fa$var$BEFORE_HEAD_MODE;
    p._processToken(token);
}
// The "before head" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagBeforeHead(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.HEAD) {
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        p.headElement = p.openElements.current;
        p.insertionMode = $3c987794e73954fa$var$IN_HEAD_MODE;
    } else $3c987794e73954fa$var$tokenBeforeHead(p, token);
}
function $3c987794e73954fa$var$endTagBeforeHead(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HEAD || tn === $3c987794e73954fa$var$$.BODY || tn === $3c987794e73954fa$var$$.HTML || tn === $3c987794e73954fa$var$$.BR) $3c987794e73954fa$var$tokenBeforeHead(p, token);
    else p._err($17010537ac9d51f5$exports.endTagWithoutMatchingOpenElement);
}
function $3c987794e73954fa$var$tokenBeforeHead(p, token) {
    p._insertFakeElement($3c987794e73954fa$var$$.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = $3c987794e73954fa$var$IN_HEAD_MODE;
    p._processToken(token);
}
// The "in head" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInHead(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.BASE || tn === $3c987794e73954fa$var$$.BASEFONT || tn === $3c987794e73954fa$var$$.BGSOUND || tn === $3c987794e73954fa$var$$.LINK || tn === $3c987794e73954fa$var$$.META) {
        p._appendElement(token, $3c987794e73954fa$var$NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $3c987794e73954fa$var$$.TITLE) p._switchToTextParsing(token, $1402a60f2d09b0f9$exports.MODE.RCDATA);
    else if (tn === $3c987794e73954fa$var$$.NOSCRIPT) {
        if (p.options.scriptingEnabled) p._switchToTextParsing(token, $1402a60f2d09b0f9$exports.MODE.RAWTEXT);
        else {
            p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
            p.insertionMode = $3c987794e73954fa$var$IN_HEAD_NO_SCRIPT_MODE;
        }
    } else if (tn === $3c987794e73954fa$var$$.NOFRAMES || tn === $3c987794e73954fa$var$$.STYLE) p._switchToTextParsing(token, $1402a60f2d09b0f9$exports.MODE.RAWTEXT);
    else if (tn === $3c987794e73954fa$var$$.SCRIPT) p._switchToTextParsing(token, $1402a60f2d09b0f9$exports.MODE.SCRIPT_DATA);
    else if (tn === $3c987794e73954fa$var$$.TEMPLATE) {
        p._insertTemplate(token, $3c987794e73954fa$var$NS.HTML);
        p.activeFormattingElements.insertMarker();
        p.framesetOk = false;
        p.insertionMode = $3c987794e73954fa$var$IN_TEMPLATE_MODE;
        p._pushTmplInsertionMode($3c987794e73954fa$var$IN_TEMPLATE_MODE);
    } else if (tn === $3c987794e73954fa$var$$.HEAD) p._err($17010537ac9d51f5$exports.misplacedStartTagForHeadElement);
    else $3c987794e73954fa$var$tokenInHead(p, token);
}
function $3c987794e73954fa$var$endTagInHead(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HEAD) {
        p.openElements.pop();
        p.insertionMode = $3c987794e73954fa$var$AFTER_HEAD_MODE;
    } else if (tn === $3c987794e73954fa$var$$.BODY || tn === $3c987794e73954fa$var$$.BR || tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$tokenInHead(p, token);
    else if (tn === $3c987794e73954fa$var$$.TEMPLATE) {
        if (p.openElements.tmplCount > 0) {
            p.openElements.generateImpliedEndTagsThoroughly();
            if (p.openElements.currentTagName !== $3c987794e73954fa$var$$.TEMPLATE) p._err($17010537ac9d51f5$exports.closingOfElementWithOpenChildElements);
            p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.TEMPLATE);
            p.activeFormattingElements.clearToLastMarker();
            p._popTmplInsertionMode();
            p._resetInsertionMode();
        } else p._err($17010537ac9d51f5$exports.endTagWithoutMatchingOpenElement);
    } else p._err($17010537ac9d51f5$exports.endTagWithoutMatchingOpenElement);
}
function $3c987794e73954fa$var$tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = $3c987794e73954fa$var$AFTER_HEAD_MODE;
    p._processToken(token);
}
// The "in head no script" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInHeadNoScript(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.BASEFONT || tn === $3c987794e73954fa$var$$.BGSOUND || tn === $3c987794e73954fa$var$$.HEAD || tn === $3c987794e73954fa$var$$.LINK || tn === $3c987794e73954fa$var$$.META || tn === $3c987794e73954fa$var$$.NOFRAMES || tn === $3c987794e73954fa$var$$.STYLE) $3c987794e73954fa$var$startTagInHead(p, token);
    else if (tn === $3c987794e73954fa$var$$.NOSCRIPT) p._err($17010537ac9d51f5$exports.nestedNoscriptInHead);
    else $3c987794e73954fa$var$tokenInHeadNoScript(p, token);
}
function $3c987794e73954fa$var$endTagInHeadNoScript(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.NOSCRIPT) {
        p.openElements.pop();
        p.insertionMode = $3c987794e73954fa$var$IN_HEAD_MODE;
    } else if (tn === $3c987794e73954fa$var$$.BR) $3c987794e73954fa$var$tokenInHeadNoScript(p, token);
    else p._err($17010537ac9d51f5$exports.endTagWithoutMatchingOpenElement);
}
function $3c987794e73954fa$var$tokenInHeadNoScript(p, token) {
    const errCode = token.type === $1402a60f2d09b0f9$exports.EOF_TOKEN ? $17010537ac9d51f5$exports.openElementsLeftAfterEof : $17010537ac9d51f5$exports.disallowedContentInNoscriptInHead;
    p._err(errCode);
    p.openElements.pop();
    p.insertionMode = $3c987794e73954fa$var$IN_HEAD_MODE;
    p._processToken(token);
}
// The "after head" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagAfterHead(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.BODY) {
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        p.framesetOk = false;
        p.insertionMode = $3c987794e73954fa$var$IN_BODY_MODE;
    } else if (tn === $3c987794e73954fa$var$$.FRAMESET) {
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        p.insertionMode = $3c987794e73954fa$var$IN_FRAMESET_MODE;
    } else if (tn === $3c987794e73954fa$var$$.BASE || tn === $3c987794e73954fa$var$$.BASEFONT || tn === $3c987794e73954fa$var$$.BGSOUND || tn === $3c987794e73954fa$var$$.LINK || tn === $3c987794e73954fa$var$$.META || tn === $3c987794e73954fa$var$$.NOFRAMES || tn === $3c987794e73954fa$var$$.SCRIPT || tn === $3c987794e73954fa$var$$.STYLE || tn === $3c987794e73954fa$var$$.TEMPLATE || tn === $3c987794e73954fa$var$$.TITLE) {
        p._err($17010537ac9d51f5$exports.abandonedHeadElementChild);
        p.openElements.push(p.headElement);
        $3c987794e73954fa$var$startTagInHead(p, token);
        p.openElements.remove(p.headElement);
    } else if (tn === $3c987794e73954fa$var$$.HEAD) p._err($17010537ac9d51f5$exports.misplacedStartTagForHeadElement);
    else $3c987794e73954fa$var$tokenAfterHead(p, token);
}
function $3c987794e73954fa$var$endTagAfterHead(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.BODY || tn === $3c987794e73954fa$var$$.HTML || tn === $3c987794e73954fa$var$$.BR) $3c987794e73954fa$var$tokenAfterHead(p, token);
    else if (tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$endTagInHead(p, token);
    else p._err($17010537ac9d51f5$exports.endTagWithoutMatchingOpenElement);
}
function $3c987794e73954fa$var$tokenAfterHead(p, token) {
    p._insertFakeElement($3c987794e73954fa$var$$.BODY);
    p.insertionMode = $3c987794e73954fa$var$IN_BODY_MODE;
    p._processToken(token);
}
// The "in body" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}
function $3c987794e73954fa$var$characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $3c987794e73954fa$var$htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}
function $3c987794e73954fa$var$bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}
function $3c987794e73954fa$var$framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        p.insertionMode = $3c987794e73954fa$var$IN_FRAMESET_MODE;
    }
}
function $3c987794e73954fa$var$addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
}
function $3c987794e73954fa$var$numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    const tn = p.openElements.currentTagName;
    if (tn === $3c987794e73954fa$var$$.H1 || tn === $3c987794e73954fa$var$$.H2 || tn === $3c987794e73954fa$var$$.H3 || tn === $3c987794e73954fa$var$$.H4 || tn === $3c987794e73954fa$var$$.H5 || tn === $3c987794e73954fa$var$$.H6) p.openElements.pop();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
}
function $3c987794e73954fa$var$preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}
function $3c987794e73954fa$var$formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;
    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        if (!inTemplate) p.formElement = p.openElements.current;
    }
}
function $3c987794e73954fa$var$listItemStartTagInBody(p, token) {
    p.framesetOk = false;
    const tn = token.tagName;
    for(let i = p.openElements.stackTop; i >= 0; i--){
        const element = p.openElements.items[i];
        const elementTn = p.treeAdapter.getTagName(element);
        let closeTn = null;
        if (tn === $3c987794e73954fa$var$$.LI && elementTn === $3c987794e73954fa$var$$.LI) closeTn = $3c987794e73954fa$var$$.LI;
        else if ((tn === $3c987794e73954fa$var$$.DD || tn === $3c987794e73954fa$var$$.DT) && (elementTn === $3c987794e73954fa$var$$.DD || elementTn === $3c987794e73954fa$var$$.DT)) closeTn = elementTn;
        if (closeTn) {
            p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
            p.openElements.popUntilTagNamePopped(closeTn);
            break;
        }
        if (elementTn !== $3c987794e73954fa$var$$.ADDRESS && elementTn !== $3c987794e73954fa$var$$.DIV && elementTn !== $3c987794e73954fa$var$$.P && p._isSpecialElement(element)) break;
    }
    if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
}
function $3c987794e73954fa$var$plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.tokenizer.state = $1402a60f2d09b0f9$exports.MODE.PLAINTEXT;
}
function $3c987794e73954fa$var$buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope($3c987794e73954fa$var$$.BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.BUTTON);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.framesetOk = false;
}
function $3c987794e73954fa$var$aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($3c987794e73954fa$var$$.A);
    if (activeElementEntry) {
        $3c987794e73954fa$var$callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $3c987794e73954fa$var$bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $3c987794e73954fa$var$nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    if (p.openElements.hasInScope($3c987794e73954fa$var$$.NOBR)) {
        $3c987794e73954fa$var$callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $3c987794e73954fa$var$appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}
function $3c987794e73954fa$var$tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== $7f14ef296305472a$export$a74d46c85337d29a.QUIRKS && p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.framesetOk = false;
    p.insertionMode = $3c987794e73954fa$var$IN_TABLE_MODE;
}
function $3c987794e73954fa$var$areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, $3c987794e73954fa$var$NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $3c987794e73954fa$var$inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, $3c987794e73954fa$var$NS.HTML);
    const inputType = $1402a60f2d09b0f9$exports.getTokenAttr(token, $3c987794e73954fa$var$ATTRS.TYPE);
    if (!inputType || inputType.toLowerCase() !== $3c987794e73954fa$var$HIDDEN_INPUT_TYPE) p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $3c987794e73954fa$var$paramStartTagInBody(p, token) {
    p._appendElement(token, $3c987794e73954fa$var$NS.HTML);
    token.ackSelfClosing = true;
}
function $3c987794e73954fa$var$hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    p._appendElement(token, $3c987794e73954fa$var$NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $3c987794e73954fa$var$imageStartTagInBody(p, token) {
    token.tagName = $3c987794e73954fa$var$$.IMG;
    $3c987794e73954fa$var$areaStartTagInBody(p, token);
}
function $3c987794e73954fa$var$textareaStartTagInBody(p, token) {
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = $1402a60f2d09b0f9$exports.MODE.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = $3c987794e73954fa$var$TEXT_MODE;
}
function $3c987794e73954fa$var$xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, $1402a60f2d09b0f9$exports.MODE.RAWTEXT);
}
function $3c987794e73954fa$var$iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, $1402a60f2d09b0f9$exports.MODE.RAWTEXT);
}
//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as a rawtext.
function $3c987794e73954fa$var$noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, $1402a60f2d09b0f9$exports.MODE.RAWTEXT);
}
function $3c987794e73954fa$var$selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.framesetOk = false;
    if (p.insertionMode === $3c987794e73954fa$var$IN_TABLE_MODE || p.insertionMode === $3c987794e73954fa$var$IN_CAPTION_MODE || p.insertionMode === $3c987794e73954fa$var$IN_TABLE_BODY_MODE || p.insertionMode === $3c987794e73954fa$var$IN_ROW_MODE || p.insertionMode === $3c987794e73954fa$var$IN_CELL_MODE) p.insertionMode = $3c987794e73954fa$var$IN_SELECT_IN_TABLE_MODE;
    else p.insertionMode = $3c987794e73954fa$var$IN_SELECT_MODE;
}
function $3c987794e73954fa$var$optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $3c987794e73954fa$var$$.OPTION) p.openElements.pop();
    p._reconstructActiveFormattingElements();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
}
function $3c987794e73954fa$var$rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope($3c987794e73954fa$var$$.RUBY)) p.openElements.generateImpliedEndTags();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
}
function $3c987794e73954fa$var$rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope($3c987794e73954fa$var$$.RUBY)) p.openElements.generateImpliedEndTagsWithExclusion($3c987794e73954fa$var$$.RTC);
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
}
function $3c987794e73954fa$var$menuStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._closePElement();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
}
function $3c987794e73954fa$var$mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $fc331a781a9a535d$export$c583cc5a9d633feb(token);
    $fc331a781a9a535d$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, $3c987794e73954fa$var$NS.MATHML);
    else p._insertElement(token, $3c987794e73954fa$var$NS.MATHML);
    token.ackSelfClosing = true;
}
function $3c987794e73954fa$var$svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $fc331a781a9a535d$export$74ce06f755fb8f68(token);
    $fc331a781a9a535d$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, $3c987794e73954fa$var$NS.SVG);
    else p._insertElement(token, $3c987794e73954fa$var$NS.SVG);
    token.ackSelfClosing = true;
}
function $3c987794e73954fa$var$genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
}
//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function $3c987794e73954fa$var$startTagInBody(p, token) {
    const tn = token.tagName;
    switch(tn.length){
        case 1:
            if (tn === $3c987794e73954fa$var$$.I || tn === $3c987794e73954fa$var$$.S || tn === $3c987794e73954fa$var$$.B || tn === $3c987794e73954fa$var$$.U) $3c987794e73954fa$var$bStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.P) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.A) $3c987794e73954fa$var$aStartTagInBody(p, token);
            else $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 2:
            if (tn === $3c987794e73954fa$var$$.DL || tn === $3c987794e73954fa$var$$.OL || tn === $3c987794e73954fa$var$$.UL) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.H1 || tn === $3c987794e73954fa$var$$.H2 || tn === $3c987794e73954fa$var$$.H3 || tn === $3c987794e73954fa$var$$.H4 || tn === $3c987794e73954fa$var$$.H5 || tn === $3c987794e73954fa$var$$.H6) $3c987794e73954fa$var$numberedHeaderStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.LI || tn === $3c987794e73954fa$var$$.DD || tn === $3c987794e73954fa$var$$.DT) $3c987794e73954fa$var$listItemStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.EM || tn === $3c987794e73954fa$var$$.TT) $3c987794e73954fa$var$bStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.BR) $3c987794e73954fa$var$areaStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.HR) $3c987794e73954fa$var$hrStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.RB) $3c987794e73954fa$var$rbStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.RT || tn === $3c987794e73954fa$var$$.RP) $3c987794e73954fa$var$rtStartTagInBody(p, token);
            else if (tn !== $3c987794e73954fa$var$$.TH && tn !== $3c987794e73954fa$var$$.TD && tn !== $3c987794e73954fa$var$$.TR) $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 3:
            if (tn === $3c987794e73954fa$var$$.DIV || tn === $3c987794e73954fa$var$$.DIR || tn === $3c987794e73954fa$var$$.NAV) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.PRE) $3c987794e73954fa$var$preStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.BIG) $3c987794e73954fa$var$bStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.IMG || tn === $3c987794e73954fa$var$$.WBR) $3c987794e73954fa$var$areaStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.XMP) $3c987794e73954fa$var$xmpStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.SVG) $3c987794e73954fa$var$svgStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.RTC) $3c987794e73954fa$var$rbStartTagInBody(p, token);
            else if (tn !== $3c987794e73954fa$var$$.COL) $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 4:
            if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$htmlStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.BASE || tn === $3c987794e73954fa$var$$.LINK || tn === $3c987794e73954fa$var$$.META) $3c987794e73954fa$var$startTagInHead(p, token);
            else if (tn === $3c987794e73954fa$var$$.BODY) $3c987794e73954fa$var$bodyStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.MAIN || tn === $3c987794e73954fa$var$$.MENU) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.FORM) $3c987794e73954fa$var$formStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.CODE || tn === $3c987794e73954fa$var$$.FONT) $3c987794e73954fa$var$bStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.NOBR) $3c987794e73954fa$var$nobrStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.AREA) $3c987794e73954fa$var$areaStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.MATH) $3c987794e73954fa$var$mathStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.MENU) $3c987794e73954fa$var$menuStartTagInBody(p, token);
            else if (tn !== $3c987794e73954fa$var$$.HEAD) $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 5:
            if (tn === $3c987794e73954fa$var$$.STYLE || tn === $3c987794e73954fa$var$$.TITLE) $3c987794e73954fa$var$startTagInHead(p, token);
            else if (tn === $3c987794e73954fa$var$$.ASIDE) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.SMALL) $3c987794e73954fa$var$bStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.TABLE) $3c987794e73954fa$var$tableStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.EMBED) $3c987794e73954fa$var$areaStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.INPUT) $3c987794e73954fa$var$inputStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.PARAM || tn === $3c987794e73954fa$var$$.TRACK) $3c987794e73954fa$var$paramStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.IMAGE) $3c987794e73954fa$var$imageStartTagInBody(p, token);
            else if (tn !== $3c987794e73954fa$var$$.FRAME && tn !== $3c987794e73954fa$var$$.TBODY && tn !== $3c987794e73954fa$var$$.TFOOT && tn !== $3c987794e73954fa$var$$.THEAD) $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 6:
            if (tn === $3c987794e73954fa$var$$.SCRIPT) $3c987794e73954fa$var$startTagInHead(p, token);
            else if (tn === $3c987794e73954fa$var$$.CENTER || tn === $3c987794e73954fa$var$$.FIGURE || tn === $3c987794e73954fa$var$$.FOOTER || tn === $3c987794e73954fa$var$$.HEADER || tn === $3c987794e73954fa$var$$.HGROUP || tn === $3c987794e73954fa$var$$.DIALOG) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.BUTTON) $3c987794e73954fa$var$buttonStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.STRIKE || tn === $3c987794e73954fa$var$$.STRONG) $3c987794e73954fa$var$bStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.APPLET || tn === $3c987794e73954fa$var$$.OBJECT) $3c987794e73954fa$var$appletStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.KEYGEN) $3c987794e73954fa$var$areaStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.SOURCE) $3c987794e73954fa$var$paramStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.IFRAME) $3c987794e73954fa$var$iframeStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.SELECT) $3c987794e73954fa$var$selectStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.OPTION) $3c987794e73954fa$var$optgroupStartTagInBody(p, token);
            else $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 7:
            if (tn === $3c987794e73954fa$var$$.BGSOUND) $3c987794e73954fa$var$startTagInHead(p, token);
            else if (tn === $3c987794e73954fa$var$$.DETAILS || tn === $3c987794e73954fa$var$$.ADDRESS || tn === $3c987794e73954fa$var$$.ARTICLE || tn === $3c987794e73954fa$var$$.SECTION || tn === $3c987794e73954fa$var$$.SUMMARY) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.LISTING) $3c987794e73954fa$var$preStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.MARQUEE) $3c987794e73954fa$var$appletStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.NOEMBED) $3c987794e73954fa$var$noembedStartTagInBody(p, token);
            else if (tn !== $3c987794e73954fa$var$$.CAPTION) $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 8:
            if (tn === $3c987794e73954fa$var$$.BASEFONT) $3c987794e73954fa$var$startTagInHead(p, token);
            else if (tn === $3c987794e73954fa$var$$.FRAMESET) $3c987794e73954fa$var$framesetStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.FIELDSET) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.TEXTAREA) $3c987794e73954fa$var$textareaStartTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$startTagInHead(p, token);
            else if (tn === $3c987794e73954fa$var$$.NOSCRIPT) {
                if (p.options.scriptingEnabled) $3c987794e73954fa$var$noembedStartTagInBody(p, token);
                else $3c987794e73954fa$var$genericStartTagInBody(p, token);
            } else if (tn === $3c987794e73954fa$var$$.OPTGROUP) $3c987794e73954fa$var$optgroupStartTagInBody(p, token);
            else if (tn !== $3c987794e73954fa$var$$.COLGROUP) $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 9:
            if (tn === $3c987794e73954fa$var$$.PLAINTEXT) $3c987794e73954fa$var$plaintextStartTagInBody(p, token);
            else $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        case 10:
            if (tn === $3c987794e73954fa$var$$.BLOCKQUOTE || tn === $3c987794e73954fa$var$$.FIGCAPTION) $3c987794e73954fa$var$addressStartTagInBody(p, token);
            else $3c987794e73954fa$var$genericStartTagInBody(p, token);
            break;
        default:
            $3c987794e73954fa$var$genericStartTagInBody(p, token);
    }
}
function $3c987794e73954fa$var$bodyEndTagInBody(p) {
    if (p.openElements.hasInScope($3c987794e73954fa$var$$.BODY)) p.insertionMode = $3c987794e73954fa$var$AFTER_BODY_MODE;
}
function $3c987794e73954fa$var$htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope($3c987794e73954fa$var$$.BODY)) {
        p.insertionMode = $3c987794e73954fa$var$AFTER_BODY_MODE;
        p._processToken(token);
    }
}
function $3c987794e73954fa$var$addressEndTagInBody(p, token) {
    const tn = token.tagName;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $3c987794e73954fa$var$formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const formElement = p.formElement;
    if (!inTemplate) p.formElement = null;
    if ((formElement || inTemplate) && p.openElements.hasInScope($3c987794e73954fa$var$$.FORM)) {
        p.openElements.generateImpliedEndTags();
        if (inTemplate) p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.FORM);
        else p.openElements.remove(formElement);
    }
}
function $3c987794e73954fa$var$pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope($3c987794e73954fa$var$$.P)) p._insertFakeElement($3c987794e73954fa$var$$.P);
    p._closePElement();
}
function $3c987794e73954fa$var$liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope($3c987794e73954fa$var$$.LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion($3c987794e73954fa$var$$.LI);
        p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.LI);
    }
}
function $3c987794e73954fa$var$ddEndTagInBody(p, token) {
    const tn = token.tagName;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $3c987794e73954fa$var$numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}
function $3c987794e73954fa$var$appletEndTagInBody(p, token) {
    const tn = token.tagName;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}
function $3c987794e73954fa$var$brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement($3c987794e73954fa$var$$.BR);
    p.openElements.pop();
    p.framesetOk = false;
}
function $3c987794e73954fa$var$genericEndTagInBody(p, token) {
    const tn = token.tagName;
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        if (p.treeAdapter.getTagName(element) === tn) {
            p.openElements.generateImpliedEndTagsWithExclusion(tn);
            p.openElements.popUntilElementPopped(element);
            break;
        }
        if (p._isSpecialElement(element)) break;
    }
}
//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function $3c987794e73954fa$var$endTagInBody(p, token) {
    const tn = token.tagName;
    switch(tn.length){
        case 1:
            if (tn === $3c987794e73954fa$var$$.A || tn === $3c987794e73954fa$var$$.B || tn === $3c987794e73954fa$var$$.I || tn === $3c987794e73954fa$var$$.S || tn === $3c987794e73954fa$var$$.U) $3c987794e73954fa$var$callAdoptionAgency(p, token);
            else if (tn === $3c987794e73954fa$var$$.P) $3c987794e73954fa$var$pEndTagInBody(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        case 2:
            if (tn === $3c987794e73954fa$var$$.DL || tn === $3c987794e73954fa$var$$.UL || tn === $3c987794e73954fa$var$$.OL) $3c987794e73954fa$var$addressEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.LI) $3c987794e73954fa$var$liEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.DD || tn === $3c987794e73954fa$var$$.DT) $3c987794e73954fa$var$ddEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.H1 || tn === $3c987794e73954fa$var$$.H2 || tn === $3c987794e73954fa$var$$.H3 || tn === $3c987794e73954fa$var$$.H4 || tn === $3c987794e73954fa$var$$.H5 || tn === $3c987794e73954fa$var$$.H6) $3c987794e73954fa$var$numberedHeaderEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.BR) $3c987794e73954fa$var$brEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.EM || tn === $3c987794e73954fa$var$$.TT) $3c987794e73954fa$var$callAdoptionAgency(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        case 3:
            if (tn === $3c987794e73954fa$var$$.BIG) $3c987794e73954fa$var$callAdoptionAgency(p, token);
            else if (tn === $3c987794e73954fa$var$$.DIR || tn === $3c987794e73954fa$var$$.DIV || tn === $3c987794e73954fa$var$$.NAV || tn === $3c987794e73954fa$var$$.PRE) $3c987794e73954fa$var$addressEndTagInBody(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        case 4:
            if (tn === $3c987794e73954fa$var$$.BODY) $3c987794e73954fa$var$bodyEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$htmlEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.FORM) $3c987794e73954fa$var$formEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.CODE || tn === $3c987794e73954fa$var$$.FONT || tn === $3c987794e73954fa$var$$.NOBR) $3c987794e73954fa$var$callAdoptionAgency(p, token);
            else if (tn === $3c987794e73954fa$var$$.MAIN || tn === $3c987794e73954fa$var$$.MENU) $3c987794e73954fa$var$addressEndTagInBody(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        case 5:
            if (tn === $3c987794e73954fa$var$$.ASIDE) $3c987794e73954fa$var$addressEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.SMALL) $3c987794e73954fa$var$callAdoptionAgency(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        case 6:
            if (tn === $3c987794e73954fa$var$$.CENTER || tn === $3c987794e73954fa$var$$.FIGURE || tn === $3c987794e73954fa$var$$.FOOTER || tn === $3c987794e73954fa$var$$.HEADER || tn === $3c987794e73954fa$var$$.HGROUP || tn === $3c987794e73954fa$var$$.DIALOG) $3c987794e73954fa$var$addressEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.APPLET || tn === $3c987794e73954fa$var$$.OBJECT) $3c987794e73954fa$var$appletEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.STRIKE || tn === $3c987794e73954fa$var$$.STRONG) $3c987794e73954fa$var$callAdoptionAgency(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        case 7:
            if (tn === $3c987794e73954fa$var$$.ADDRESS || tn === $3c987794e73954fa$var$$.ARTICLE || tn === $3c987794e73954fa$var$$.DETAILS || tn === $3c987794e73954fa$var$$.SECTION || tn === $3c987794e73954fa$var$$.SUMMARY || tn === $3c987794e73954fa$var$$.LISTING) $3c987794e73954fa$var$addressEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.MARQUEE) $3c987794e73954fa$var$appletEndTagInBody(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        case 8:
            if (tn === $3c987794e73954fa$var$$.FIELDSET) $3c987794e73954fa$var$addressEndTagInBody(p, token);
            else if (tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$endTagInHead(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        case 10:
            if (tn === $3c987794e73954fa$var$$.BLOCKQUOTE || tn === $3c987794e73954fa$var$$.FIGCAPTION) $3c987794e73954fa$var$addressEndTagInBody(p, token);
            else $3c987794e73954fa$var$genericEndTagInBody(p, token);
            break;
        default:
            $3c987794e73954fa$var$genericEndTagInBody(p, token);
    }
}
function $3c987794e73954fa$var$eofInBody(p, token) {
    if (p.tmplInsertionModeStackTop > -1) $3c987794e73954fa$var$eofInTemplate(p, token);
    else p.stopped = true;
}
// The "text" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$endTagInText(p, token) {
    if (token.tagName === $3c987794e73954fa$var$$.SCRIPT) p.pendingScript = p.openElements.current;
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}
function $3c987794e73954fa$var$eofInText(p, token) {
    p._err($17010537ac9d51f5$exports.eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}
// The "in table" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$characterInTable(p, token) {
    const curTn = p.openElements.currentTagName;
    if (curTn === $3c987794e73954fa$var$$.TABLE || curTn === $3c987794e73954fa$var$$.TBODY || curTn === $3c987794e73954fa$var$$.TFOOT || curTn === $3c987794e73954fa$var$$.THEAD || curTn === $3c987794e73954fa$var$$.TR) {
        p.pendingCharacterTokens = [];
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = $3c987794e73954fa$var$IN_TABLE_TEXT_MODE;
        p._processToken(token);
    } else $3c987794e73954fa$var$tokenInTable(p, token);
}
function $3c987794e73954fa$var$captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.insertionMode = $3c987794e73954fa$var$IN_CAPTION_MODE;
}
function $3c987794e73954fa$var$colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.insertionMode = $3c987794e73954fa$var$IN_COLUMN_GROUP_MODE;
}
function $3c987794e73954fa$var$colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($3c987794e73954fa$var$$.COLGROUP);
    p.insertionMode = $3c987794e73954fa$var$IN_COLUMN_GROUP_MODE;
    p._processToken(token);
}
function $3c987794e73954fa$var$tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    p.insertionMode = $3c987794e73954fa$var$IN_TABLE_BODY_MODE;
}
function $3c987794e73954fa$var$tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($3c987794e73954fa$var$$.TBODY);
    p.insertionMode = $3c987794e73954fa$var$IN_TABLE_BODY_MODE;
    p._processToken(token);
}
function $3c987794e73954fa$var$tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope($3c987794e73954fa$var$$.TABLE)) {
        p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.TABLE);
        p._resetInsertionMode();
        p._processToken(token);
    }
}
function $3c987794e73954fa$var$inputStartTagInTable(p, token) {
    const inputType = $1402a60f2d09b0f9$exports.getTokenAttr(token, $3c987794e73954fa$var$ATTRS.TYPE);
    if (inputType && inputType.toLowerCase() === $3c987794e73954fa$var$HIDDEN_INPUT_TYPE) p._appendElement(token, $3c987794e73954fa$var$NS.HTML);
    else $3c987794e73954fa$var$tokenInTable(p, token);
    token.ackSelfClosing = true;
}
function $3c987794e73954fa$var$formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}
function $3c987794e73954fa$var$startTagInTable(p, token) {
    const tn = token.tagName;
    switch(tn.length){
        case 2:
            if (tn === $3c987794e73954fa$var$$.TD || tn === $3c987794e73954fa$var$$.TH || tn === $3c987794e73954fa$var$$.TR) $3c987794e73954fa$var$tdStartTagInTable(p, token);
            else $3c987794e73954fa$var$tokenInTable(p, token);
            break;
        case 3:
            if (tn === $3c987794e73954fa$var$$.COL) $3c987794e73954fa$var$colStartTagInTable(p, token);
            else $3c987794e73954fa$var$tokenInTable(p, token);
            break;
        case 4:
            if (tn === $3c987794e73954fa$var$$.FORM) $3c987794e73954fa$var$formStartTagInTable(p, token);
            else $3c987794e73954fa$var$tokenInTable(p, token);
            break;
        case 5:
            if (tn === $3c987794e73954fa$var$$.TABLE) $3c987794e73954fa$var$tableStartTagInTable(p, token);
            else if (tn === $3c987794e73954fa$var$$.STYLE) $3c987794e73954fa$var$startTagInHead(p, token);
            else if (tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD) $3c987794e73954fa$var$tbodyStartTagInTable(p, token);
            else if (tn === $3c987794e73954fa$var$$.INPUT) $3c987794e73954fa$var$inputStartTagInTable(p, token);
            else $3c987794e73954fa$var$tokenInTable(p, token);
            break;
        case 6:
            if (tn === $3c987794e73954fa$var$$.SCRIPT) $3c987794e73954fa$var$startTagInHead(p, token);
            else $3c987794e73954fa$var$tokenInTable(p, token);
            break;
        case 7:
            if (tn === $3c987794e73954fa$var$$.CAPTION) $3c987794e73954fa$var$captionStartTagInTable(p, token);
            else $3c987794e73954fa$var$tokenInTable(p, token);
            break;
        case 8:
            if (tn === $3c987794e73954fa$var$$.COLGROUP) $3c987794e73954fa$var$colgroupStartTagInTable(p, token);
            else if (tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$startTagInHead(p, token);
            else $3c987794e73954fa$var$tokenInTable(p, token);
            break;
        default:
            $3c987794e73954fa$var$tokenInTable(p, token);
    }
}
function $3c987794e73954fa$var$endTagInTable(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.TABLE) {
        if (p.openElements.hasInTableScope($3c987794e73954fa$var$$.TABLE)) {
            p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.TABLE);
            p._resetInsertionMode();
        }
    } else if (tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$endTagInHead(p, token);
    else if (tn !== $3c987794e73954fa$var$$.BODY && tn !== $3c987794e73954fa$var$$.CAPTION && tn !== $3c987794e73954fa$var$$.COL && tn !== $3c987794e73954fa$var$$.COLGROUP && tn !== $3c987794e73954fa$var$$.HTML && tn !== $3c987794e73954fa$var$$.TBODY && tn !== $3c987794e73954fa$var$$.TD && tn !== $3c987794e73954fa$var$$.TFOOT && tn !== $3c987794e73954fa$var$$.TH && tn !== $3c987794e73954fa$var$$.THEAD && tn !== $3c987794e73954fa$var$$.TR) $3c987794e73954fa$var$tokenInTable(p, token);
}
function $3c987794e73954fa$var$tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;
    p.fosterParentingEnabled = true;
    p._processTokenInBodyMode(token);
    p.fosterParentingEnabled = savedFosterParentingState;
}
// The "in table text" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}
function $3c987794e73954fa$var$characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}
function $3c987794e73954fa$var$tokenInTableText(p, token) {
    let i = 0;
    if (p.hasNonWhitespacePendingCharacterToken) for(; i < p.pendingCharacterTokens.length; i++)$3c987794e73954fa$var$tokenInTable(p, p.pendingCharacterTokens[i]);
    else for(; i < p.pendingCharacterTokens.length; i++)p._insertCharacters(p.pendingCharacterTokens[i]);
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}
// The "in caption" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInCaption(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.CAPTION || tn === $3c987794e73954fa$var$$.COL || tn === $3c987794e73954fa$var$$.COLGROUP || tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TD || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.TH || tn === $3c987794e73954fa$var$$.THEAD || tn === $3c987794e73954fa$var$$.TR) {
        if (p.openElements.hasInTableScope($3c987794e73954fa$var$$.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_MODE;
            p._processToken(token);
        }
    } else $3c987794e73954fa$var$startTagInBody(p, token);
}
function $3c987794e73954fa$var$endTagInCaption(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.CAPTION || tn === $3c987794e73954fa$var$$.TABLE) {
        if (p.openElements.hasInTableScope($3c987794e73954fa$var$$.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_MODE;
            if (tn === $3c987794e73954fa$var$$.TABLE) p._processToken(token);
        }
    } else if (tn !== $3c987794e73954fa$var$$.BODY && tn !== $3c987794e73954fa$var$$.COL && tn !== $3c987794e73954fa$var$$.COLGROUP && tn !== $3c987794e73954fa$var$$.HTML && tn !== $3c987794e73954fa$var$$.TBODY && tn !== $3c987794e73954fa$var$$.TD && tn !== $3c987794e73954fa$var$$.TFOOT && tn !== $3c987794e73954fa$var$$.TH && tn !== $3c987794e73954fa$var$$.THEAD && tn !== $3c987794e73954fa$var$$.TR) $3c987794e73954fa$var$endTagInBody(p, token);
}
// The "in column group" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInColumnGroup(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.COL) {
        p._appendElement(token, $3c987794e73954fa$var$NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$startTagInHead(p, token);
    else $3c987794e73954fa$var$tokenInColumnGroup(p, token);
}
function $3c987794e73954fa$var$endTagInColumnGroup(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.COLGROUP) {
        if (p.openElements.currentTagName === $3c987794e73954fa$var$$.COLGROUP) {
            p.openElements.pop();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_MODE;
        }
    } else if (tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$endTagInHead(p, token);
    else if (tn !== $3c987794e73954fa$var$$.COL) $3c987794e73954fa$var$tokenInColumnGroup(p, token);
}
function $3c987794e73954fa$var$tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagName === $3c987794e73954fa$var$$.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = $3c987794e73954fa$var$IN_TABLE_MODE;
        p._processToken(token);
    }
}
// The "in table body" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInTableBody(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.TR) {
        p.openElements.clearBackToTableBodyContext();
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        p.insertionMode = $3c987794e73954fa$var$IN_ROW_MODE;
    } else if (tn === $3c987794e73954fa$var$$.TH || tn === $3c987794e73954fa$var$$.TD) {
        p.openElements.clearBackToTableBodyContext();
        p._insertFakeElement($3c987794e73954fa$var$$.TR);
        p.insertionMode = $3c987794e73954fa$var$IN_ROW_MODE;
        p._processToken(token);
    } else if (tn === $3c987794e73954fa$var$$.CAPTION || tn === $3c987794e73954fa$var$$.COL || tn === $3c987794e73954fa$var$$.COLGROUP || tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_MODE;
            p._processToken(token);
        }
    } else $3c987794e73954fa$var$startTagInTable(p, token);
}
function $3c987794e73954fa$var$endTagInTableBody(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_MODE;
        }
    } else if (tn === $3c987794e73954fa$var$$.TABLE) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_MODE;
            p._processToken(token);
        }
    } else if (tn !== $3c987794e73954fa$var$$.BODY && tn !== $3c987794e73954fa$var$$.CAPTION && tn !== $3c987794e73954fa$var$$.COL && tn !== $3c987794e73954fa$var$$.COLGROUP || tn !== $3c987794e73954fa$var$$.HTML && tn !== $3c987794e73954fa$var$$.TD && tn !== $3c987794e73954fa$var$$.TH && tn !== $3c987794e73954fa$var$$.TR) $3c987794e73954fa$var$endTagInTable(p, token);
}
// The "in row" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInRow(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.TH || tn === $3c987794e73954fa$var$$.TD) {
        p.openElements.clearBackToTableRowContext();
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
        p.insertionMode = $3c987794e73954fa$var$IN_CELL_MODE;
        p.activeFormattingElements.insertMarker();
    } else if (tn === $3c987794e73954fa$var$$.CAPTION || tn === $3c987794e73954fa$var$$.COL || tn === $3c987794e73954fa$var$$.COLGROUP || tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD || tn === $3c987794e73954fa$var$$.TR) {
        if (p.openElements.hasInTableScope($3c987794e73954fa$var$$.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else $3c987794e73954fa$var$startTagInTable(p, token);
}
function $3c987794e73954fa$var$endTagInRow(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.TR) {
        if (p.openElements.hasInTableScope($3c987794e73954fa$var$$.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_BODY_MODE;
        }
    } else if (tn === $3c987794e73954fa$var$$.TABLE) {
        if (p.openElements.hasInTableScope($3c987794e73954fa$var$$.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else if (tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD) {
        if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($3c987794e73954fa$var$$.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = $3c987794e73954fa$var$IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else if (tn !== $3c987794e73954fa$var$$.BODY && tn !== $3c987794e73954fa$var$$.CAPTION && tn !== $3c987794e73954fa$var$$.COL && tn !== $3c987794e73954fa$var$$.COLGROUP || tn !== $3c987794e73954fa$var$$.HTML && tn !== $3c987794e73954fa$var$$.TD && tn !== $3c987794e73954fa$var$$.TH) $3c987794e73954fa$var$endTagInTable(p, token);
}
// The "in cell" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInCell(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.CAPTION || tn === $3c987794e73954fa$var$$.COL || tn === $3c987794e73954fa$var$$.COLGROUP || tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TD || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.TH || tn === $3c987794e73954fa$var$$.THEAD || tn === $3c987794e73954fa$var$$.TR) {
        if (p.openElements.hasInTableScope($3c987794e73954fa$var$$.TD) || p.openElements.hasInTableScope($3c987794e73954fa$var$$.TH)) {
            p._closeTableCell();
            p._processToken(token);
        }
    } else $3c987794e73954fa$var$startTagInBody(p, token);
}
function $3c987794e73954fa$var$endTagInCell(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.TD || tn === $3c987794e73954fa$var$$.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped(tn);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = $3c987794e73954fa$var$IN_ROW_MODE;
        }
    } else if (tn === $3c987794e73954fa$var$$.TABLE || tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD || tn === $3c987794e73954fa$var$$.TR) {
        if (p.openElements.hasInTableScope(tn)) {
            p._closeTableCell();
            p._processToken(token);
        }
    } else if (tn !== $3c987794e73954fa$var$$.BODY && tn !== $3c987794e73954fa$var$$.CAPTION && tn !== $3c987794e73954fa$var$$.COL && tn !== $3c987794e73954fa$var$$.COLGROUP && tn !== $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$endTagInBody(p, token);
}
// The "in select" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInSelect(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.OPTION) {
        if (p.openElements.currentTagName === $3c987794e73954fa$var$$.OPTION) p.openElements.pop();
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    } else if (tn === $3c987794e73954fa$var$$.OPTGROUP) {
        if (p.openElements.currentTagName === $3c987794e73954fa$var$$.OPTION) p.openElements.pop();
        if (p.openElements.currentTagName === $3c987794e73954fa$var$$.OPTGROUP) p.openElements.pop();
        p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    } else if (tn === $3c987794e73954fa$var$$.INPUT || tn === $3c987794e73954fa$var$$.KEYGEN || tn === $3c987794e73954fa$var$$.TEXTAREA || tn === $3c987794e73954fa$var$$.SELECT) {
        if (p.openElements.hasInSelectScope($3c987794e73954fa$var$$.SELECT)) {
            p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.SELECT);
            p._resetInsertionMode();
            if (tn !== $3c987794e73954fa$var$$.SELECT) p._processToken(token);
        }
    } else if (tn === $3c987794e73954fa$var$$.SCRIPT || tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$startTagInHead(p, token);
}
function $3c987794e73954fa$var$endTagInSelect(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.OPTGROUP) {
        const prevOpenElement = p.openElements.items[p.openElements.stackTop - 1];
        const prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);
        if (p.openElements.currentTagName === $3c987794e73954fa$var$$.OPTION && prevOpenElementTn === $3c987794e73954fa$var$$.OPTGROUP) p.openElements.pop();
        if (p.openElements.currentTagName === $3c987794e73954fa$var$$.OPTGROUP) p.openElements.pop();
    } else if (tn === $3c987794e73954fa$var$$.OPTION) {
        if (p.openElements.currentTagName === $3c987794e73954fa$var$$.OPTION) p.openElements.pop();
    } else if (tn === $3c987794e73954fa$var$$.SELECT && p.openElements.hasInSelectScope($3c987794e73954fa$var$$.SELECT)) {
        p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.SELECT);
        p._resetInsertionMode();
    } else if (tn === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$endTagInHead(p, token);
}
//12.2.5.4.17 The "in select in table" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInSelectInTable(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.CAPTION || tn === $3c987794e73954fa$var$$.TABLE || tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD || tn === $3c987794e73954fa$var$$.TR || tn === $3c987794e73954fa$var$$.TD || tn === $3c987794e73954fa$var$$.TH) {
        p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.SELECT);
        p._resetInsertionMode();
        p._processToken(token);
    } else $3c987794e73954fa$var$startTagInSelect(p, token);
}
function $3c987794e73954fa$var$endTagInSelectInTable(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.CAPTION || tn === $3c987794e73954fa$var$$.TABLE || tn === $3c987794e73954fa$var$$.TBODY || tn === $3c987794e73954fa$var$$.TFOOT || tn === $3c987794e73954fa$var$$.THEAD || tn === $3c987794e73954fa$var$$.TR || tn === $3c987794e73954fa$var$$.TD || tn === $3c987794e73954fa$var$$.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.SELECT);
            p._resetInsertionMode();
            p._processToken(token);
        }
    } else $3c987794e73954fa$var$endTagInSelect(p, token);
}
// The "in template" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInTemplate(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.BASE || tn === $3c987794e73954fa$var$$.BASEFONT || tn === $3c987794e73954fa$var$$.BGSOUND || tn === $3c987794e73954fa$var$$.LINK || tn === $3c987794e73954fa$var$$.META || tn === $3c987794e73954fa$var$$.NOFRAMES || tn === $3c987794e73954fa$var$$.SCRIPT || tn === $3c987794e73954fa$var$$.STYLE || tn === $3c987794e73954fa$var$$.TEMPLATE || tn === $3c987794e73954fa$var$$.TITLE) $3c987794e73954fa$var$startTagInHead(p, token);
    else {
        const newInsertionMode = $3c987794e73954fa$var$TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || $3c987794e73954fa$var$IN_BODY_MODE;
        p._popTmplInsertionMode();
        p._pushTmplInsertionMode(newInsertionMode);
        p.insertionMode = newInsertionMode;
        p._processToken(token);
    }
}
function $3c987794e73954fa$var$endTagInTemplate(p, token) {
    if (token.tagName === $3c987794e73954fa$var$$.TEMPLATE) $3c987794e73954fa$var$endTagInHead(p, token);
}
function $3c987794e73954fa$var$eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped($3c987794e73954fa$var$$.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
        p._processToken(token);
    } else p.stopped = true;
}
// The "after body" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagAfterBody(p, token) {
    if (token.tagName === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else $3c987794e73954fa$var$tokenAfterBody(p, token);
}
function $3c987794e73954fa$var$endTagAfterBody(p, token) {
    if (token.tagName === $3c987794e73954fa$var$$.HTML) {
        if (!p.fragmentContext) p.insertionMode = $3c987794e73954fa$var$AFTER_AFTER_BODY_MODE;
    } else $3c987794e73954fa$var$tokenAfterBody(p, token);
}
function $3c987794e73954fa$var$tokenAfterBody(p, token) {
    p.insertionMode = $3c987794e73954fa$var$IN_BODY_MODE;
    p._processToken(token);
}
// The "in frameset" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagInFrameset(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.FRAMESET) p._insertElement(token, $3c987794e73954fa$var$NS.HTML);
    else if (tn === $3c987794e73954fa$var$$.FRAME) {
        p._appendElement(token, $3c987794e73954fa$var$NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $3c987794e73954fa$var$$.NOFRAMES) $3c987794e73954fa$var$startTagInHead(p, token);
}
function $3c987794e73954fa$var$endTagInFrameset(p, token) {
    if (token.tagName === $3c987794e73954fa$var$$.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();
        if (!p.fragmentContext && p.openElements.currentTagName !== $3c987794e73954fa$var$$.FRAMESET) p.insertionMode = $3c987794e73954fa$var$AFTER_FRAMESET_MODE;
    }
}
// The "after frameset" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagAfterFrameset(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.NOFRAMES) $3c987794e73954fa$var$startTagInHead(p, token);
}
function $3c987794e73954fa$var$endTagAfterFrameset(p, token) {
    if (token.tagName === $3c987794e73954fa$var$$.HTML) p.insertionMode = $3c987794e73954fa$var$AFTER_AFTER_FRAMESET_MODE;
}
// The "after after body" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagAfterAfterBody(p, token) {
    if (token.tagName === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else $3c987794e73954fa$var$tokenAfterAfterBody(p, token);
}
function $3c987794e73954fa$var$tokenAfterAfterBody(p, token) {
    p.insertionMode = $3c987794e73954fa$var$IN_BODY_MODE;
    p._processToken(token);
}
// The "after after frameset" insertion mode
//------------------------------------------------------------------
function $3c987794e73954fa$var$startTagAfterAfterFrameset(p, token) {
    const tn = token.tagName;
    if (tn === $3c987794e73954fa$var$$.HTML) $3c987794e73954fa$var$startTagInBody(p, token);
    else if (tn === $3c987794e73954fa$var$$.NOFRAMES) $3c987794e73954fa$var$startTagInHead(p, token);
}
// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function $3c987794e73954fa$var$nullCharacterInForeignContent(p, token) {
    token.chars = $4e69a73910c07b7d$export$e8d20e7a50e6c279;
    p._insertCharacters(token);
}
function $3c987794e73954fa$var$characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $3c987794e73954fa$var$startTagInForeignContent(p, token) {
    if ($fc331a781a9a535d$export$3435eb4ab4d2ed2d(token) && !p.fragmentContext) {
        while(p.treeAdapter.getNamespaceURI(p.openElements.current) !== $3c987794e73954fa$var$NS.HTML && !p._isIntegrationPoint(p.openElements.current))p.openElements.pop();
        p._processToken(token);
    } else {
        const current = p._getAdjustedCurrentElement();
        const currentNs = p.treeAdapter.getNamespaceURI(current);
        if (currentNs === $3c987794e73954fa$var$NS.MATHML) $fc331a781a9a535d$export$c583cc5a9d633feb(token);
        else if (currentNs === $3c987794e73954fa$var$NS.SVG) {
            $fc331a781a9a535d$export$95df78fe2e7f33e3(token);
            $fc331a781a9a535d$export$74ce06f755fb8f68(token);
        }
        $fc331a781a9a535d$export$a5192af02995cbdc(token);
        if (token.selfClosing) p._appendElement(token, currentNs);
        else p._insertElement(token, currentNs);
        token.ackSelfClosing = true;
    }
}
function $3c987794e73954fa$var$endTagInForeignContent(p, token) {
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        if (p.treeAdapter.getNamespaceURI(element) === $3c987794e73954fa$var$NS.HTML) {
            p._processToken(token);
            break;
        }
        if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
            p.openElements.popUntilElementPopped(element);
            break;
        }
    }
}




/**
 * @typedef {import('vfile').VFile} VFile
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Content} Content
 * @typedef {import('parse5').DefaultTreeAdapterMap} DefaultTreeAdapterMap
 * @typedef {import('parse5').Token.ElementLocation} P5ElementLocation
 * @typedef {import('parse5').Token.Location} P5Location
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {DefaultTreeAdapterMap['document']} P5Document
 * @typedef {DefaultTreeAdapterMap['documentFragment']} P5DocumentFragment
 * @typedef {DefaultTreeAdapterMap['documentType']} P5DocumentType
 * @typedef {DefaultTreeAdapterMap['commentNode']} P5Comment
 * @typedef {DefaultTreeAdapterMap['textNode']} P5Text
 * @typedef {DefaultTreeAdapterMap['element']} P5Element
 * @typedef {DefaultTreeAdapterMap['node']} P5Node
 * @typedef {DefaultTreeAdapterMap['template']} P5Template
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 * @typedef Options
 *   Configuration.
 * @property {Space | null | undefined} [space='html']
 *   Which space the document is in.
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 * @property {VFile | null | undefined} [file]
 *   File used to add positional info to nodes.
 *
 *   If given, the file should represent the original HTML source.
 * @property {boolean} [verbose=false]
 *   Whether to add extra positional info about starting tags, closing tags,
 *   and attributes to elements.
 *
 *   > 👉 **Note**: only used when `file` is given.
 *
 * @typedef State
 *   Info passed around about the current state.
 * @property {Schema} schema
 *   Current schema.
 * @property {VFile | undefined} file
 *   Corresponding file.
 * @property {boolean | undefined} verbose
 *   Add extra positional info.
 * @property {boolean} location
 *   Whether location info was found.
 */ /**
 * @typedef {import('./core.js').HChild} Child
 *   Acceptable child value.
 * @typedef {import('./core.js').HProperties} Properties
 *   Acceptable value for element properties.
 * @typedef {import('./core.js').HResult} Result
 *   Result from a `h` (or `s`) call.
 *
 * @typedef {import('./jsx-classic.js').Element} h.JSX.Element
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} h.JSX.IntrinsicElements
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 */ 
/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Content} Content
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 */ /**
 * @typedef {Content | Root} Node
 *   Any concrete `hast` node.
 * @typedef {Root | Element} HResult
 *   Result from a `h` (or `s`) call.
 *
 * @typedef {string | number} HStyleValue
 *   Value for a CSS style field.
 * @typedef {Record<string, HStyleValue>} HStyle
 *   Supported value of a `style` prop.
 * @typedef {string | number | boolean | null | undefined} HPrimitiveValue
 *   Primitive property value.
 * @typedef {Array<string | number>} HArrayValue
 *   List of property values for space- or comma separated values (such as `className`).
 * @typedef {HPrimitiveValue | HArrayValue} HPropertyValue
 *   Primitive value or list value.
 * @typedef {{[property: string]: HPropertyValue | HStyle}} HProperties
 *   Acceptable value for element properties.
 *
 * @typedef {string | number | null | undefined} HPrimitiveChild
 *   Primitive children, either ignored (nullish), or turned into text nodes.
 * @typedef {Array<Node | HPrimitiveChild>} HArrayChild
 *   List of children.
 * @typedef {Node | HPrimitiveChild | HArrayChild} HChild
 *   Acceptable child value.
 */ 
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 */ const $8b256f5466482309$var$search = /[#.]/g;
function $8b256f5466482309$export$529769e360e2fa1b(selector, defaultTagName) {
    const value = selector || "";
    /** @type {Properties} */ const props = {};
    let start = 0;
    /** @type {string | undefined} */ let previous;
    /** @type {string | undefined} */ let tagName;
    while(start < value.length){
        $8b256f5466482309$var$search.lastIndex = start;
        const match = $8b256f5466482309$var$search.exec(value);
        const subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) tagName = subvalue;
            else if (previous === "#") props.id = subvalue;
            else if (Array.isArray(props.className)) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: "element",
        // @ts-expect-error: fine.
        tagName: tagName || defaultTagName || "div",
        properties: props,
        children: []
    };
}




const $33eb6b4d9b6f1f17$var$buttonTypes = new Set([
    "menu",
    "submit",
    "reset",
    "button"
]);
const $33eb6b4d9b6f1f17$var$own = {}.hasOwnProperty;
function $33eb6b4d9b6f1f17$export$b75f8c4f8f3fbd14(schema, defaultTagName, caseSensitive) {
    const adjust = caseSensitive && $33eb6b4d9b6f1f17$var$createAdjustMap(caseSensitive);
    const h = /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */ /**
       * Hyperscript compatible DSL for creating virtual hast trees.
       *
       * @param {string | null} [selector]
       * @param {HProperties | HChild} [properties]
       * @param {Array<HChild>} children
       * @returns {HResult}
       */ function(selector, properties, ...children) {
        let index = -1;
        /** @type {HResult} */ let node;
        if (selector === undefined || selector === null) {
            node = {
                type: "root",
                children: []
            };
            // @ts-expect-error Properties are not supported for roots.
            children.unshift(properties);
        } else {
            node = (0, $8b256f5466482309$export$529769e360e2fa1b)(selector, defaultTagName);
            // Normalize the name.
            node.tagName = node.tagName.toLowerCase();
            if (adjust && $33eb6b4d9b6f1f17$var$own.call(adjust, node.tagName)) node.tagName = adjust[node.tagName];
            // Handle props.
            if ($33eb6b4d9b6f1f17$var$isProperties(properties, node.tagName)) {
                /** @type {string} */ let key;
                for(key in properties)if ($33eb6b4d9b6f1f17$var$own.call(properties, key)) // @ts-expect-error `node.properties` is set.
                $33eb6b4d9b6f1f17$var$addProperty(schema, node.properties, key, properties[key]);
            } else children.unshift(properties);
        }
        // Handle children.
        while(++index < children.length)$33eb6b4d9b6f1f17$var$addChild(node.children, children[index]);
        if (node.type === "element" && node.tagName === "template") {
            node.content = {
                type: "root",
                children: node.children
            };
            node.children = [];
        }
        return node;
    };
    return h;
}
/**
 * @param {HProperties | HChild} value
 * @param {string} name
 * @returns {value is HProperties}
 */ function $33eb6b4d9b6f1f17$var$isProperties(value, name) {
    if (value === null || value === undefined || typeof value !== "object" || Array.isArray(value)) return false;
    if (name === "input" || !value.type || typeof value.type !== "string") return true;
    if ("children" in value && Array.isArray(value.children)) return false;
    if (name === "button") return $33eb6b4d9b6f1f17$var$buttonTypes.has(value.type.toLowerCase());
    return !("value" in value);
}
/**
 * @param {Schema} schema
 * @param {Properties} properties
 * @param {string} key
 * @param {HStyle | HPropertyValue} value
 * @returns {void}
 */ function $33eb6b4d9b6f1f17$var$addProperty(schema, properties, key, value) {
    const info = (0, $a5d32c782dfb87d4$export$71aa6c912b956294)(schema, key);
    let index = -1;
    /** @type {HPropertyValue} */ let result;
    // Ignore nullish and NaN values.
    if (value === undefined || value === null) return;
    if (typeof value === "number") {
        // Ignore NaN.
        if (Number.isNaN(value)) return;
        result = value;
    } else if (typeof value === "boolean") result = value;
    else if (typeof value === "string") {
        if (info.spaceSeparated) result = (0, $3ffb311c7c73400a$export$98e6a39c04603d36)(value);
        else if (info.commaSeparated) result = (0, $8ee927eafd1154d1$export$98e6a39c04603d36)(value);
        else if (info.commaOrSpaceSeparated) result = (0, $3ffb311c7c73400a$export$98e6a39c04603d36)((0, $8ee927eafd1154d1$export$98e6a39c04603d36)(value).join(" "));
        else result = $33eb6b4d9b6f1f17$var$parsePrimitive(info, info.property, value);
    } else if (Array.isArray(value)) result = value.concat();
    else result = info.property === "style" ? $33eb6b4d9b6f1f17$var$style(value) : String(value);
    if (Array.isArray(result)) {
        /** @type {Array<string | number>} */ const finalResult = [];
        while(++index < result.length)// @ts-expect-error Assume no booleans in array.
        finalResult[index] = $33eb6b4d9b6f1f17$var$parsePrimitive(info, info.property, result[index]);
        result = finalResult;
    }
    // Class names (which can be added both on the `selector` and here).
    if (info.property === "className" && Array.isArray(properties.className)) // @ts-expect-error Assume no booleans in `className`.
    result = properties.className.concat(result);
    properties[info.property] = result;
}
/**
 * @param {Array<Content>} nodes
 * @param {HChild} value
 * @returns {void}
 */ function $33eb6b4d9b6f1f17$var$addChild(nodes, value) {
    let index = -1;
    if (value === undefined || value === null) ;
    else if (typeof value === "string" || typeof value === "number") nodes.push({
        type: "text",
        value: String(value)
    });
    else if (Array.isArray(value)) while(++index < value.length)$33eb6b4d9b6f1f17$var$addChild(nodes, value[index]);
    else if (typeof value === "object" && "type" in value) {
        if (value.type === "root") $33eb6b4d9b6f1f17$var$addChild(nodes, value.children);
        else nodes.push(value);
    } else throw new Error("Expected node, nodes, or string, got `" + value + "`");
}
/**
 * Parse a single primitives.
 *
 * @param {Info} info
 * @param {string} name
 * @param {HPrimitiveValue} value
 * @returns {HPrimitiveValue}
 */ function $33eb6b4d9b6f1f17$var$parsePrimitive(info, name, value) {
    if (typeof value === "string") {
        if (info.number && value && !Number.isNaN(Number(value))) return Number(value);
        if ((info.boolean || info.overloadedBoolean) && (value === "" || (0, $2e7eb01261ef6246$export$a3295358bff77e)(value) === (0, $2e7eb01261ef6246$export$a3295358bff77e)(name))) return true;
    }
    return value;
}
/**
 * Serialize a `style` object as a string.
 *
 * @param {HStyle} value
 *   Style object.
 * @returns {string}
 *   CSS string.
 */ function $33eb6b4d9b6f1f17$var$style(value) {
    /** @type {Array<string>} */ const result = [];
    /** @type {string} */ let key;
    for(key in value)if ($33eb6b4d9b6f1f17$var$own.call(value, key)) result.push([
        key,
        value[key]
    ].join(": "));
    return result.join("; ");
}
/**
 * Create a map to adjust casing.
 *
 * @param {Array<string>} values
 *   List of properly cased keys.
 * @returns {Record<string, string>}
 *   Map of lowercase keys to uppercase keys.
 */ function $33eb6b4d9b6f1f17$var$createAdjustMap(values) {
    /** @type {Record<string, string>} */ const result = {};
    let index = -1;
    while(++index < values.length)result[values[index].toLowerCase()] = values[index];
    return result;
}


const $22ef87f7acfe695a$export$dda1d9f60106f0e9 = (0, $33eb6b4d9b6f1f17$export$b75f8c4f8f3fbd14)((0, $d5b213d436a94199$export$c0bb0b647f701bb5), "div");

/**
 * @typedef {import('./core.js').HChild} Child
 *   Acceptable child value.
 * @typedef {import('./core.js').HProperties} Properties
 *   Acceptable value for element properties.
 * @typedef {import('./core.js').HResult} Result
 *   Result from a `h` (or `s`) call.
 *
 * @typedef {import('./jsx-classic.js').Element} s.JSX.Element
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} s.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} s.JSX.IntrinsicElements
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} s.JSX.ElementChildrenAttribute
 */ 

const $6c77754357108237$export$5ec6e4ea2f9364a1 = [
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "solidColor",
    "textArea",
    "textPath"
];


const $a27415ef86a92815$export$2408f22a0fab9ae5 = (0, $33eb6b4d9b6f1f17$export$b75f8c4f8f3fbd14)((0, $d5b213d436a94199$export$7ed1367e7fa1ad68), "g", (0, $6c77754357108237$export$5ec6e4ea2f9364a1));



/**
 * @typedef {import('vfile').VFile} VFile
 * @typedef {import('vfile').Value} Value
 */ /**
 * @typedef Point
 *   unist point, where `line` and `column` can be `undefined`.
 * @property {number | undefined} line
 *   Line.
 * @property {number | undefined} column
 *   Column.
 * @property {number | undefined} [offset]
 *   Offset.
 *
 * @typedef PointLike
 *   unist point, allowed as input.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @callback ToPoint
 *   Get a line/column-based `point` from `offset`.
 * @param {number | null | undefined} [offset]
 *   Something that should be an `offset.
 * @returns {Point}
 *   Point, line/column are undefined for invalid or out of bounds input.
 *
 * @callback ToOffset
 *   Get an offset from a line/column-based `point`.
 * @param {Point | null | undefined} [point]
 *   Something that should be a `point.
 * @returns {number}
 *   Offset or `-1` for invalid or out of bounds input.
 *
 * @typedef Location
 *   Accessors for index.
 * @property {ToPoint} toPoint
 *   Get a line/column-based `point` from `offset`.
 * @property {ToOffset} toOffset
 *   Get an offset from a line/column-based `point`.
 */ /**
 * Index the given document so you can translate between line/column and offset
 * based positional info.
 *
 * @param {VFile | Value} file
 *   File to index.
 * @returns {Location}
 *   Accessors for index.
 */ function $aab3607e5d54580d$export$17b07c660794dc13(file) {
    const value = String(file);
    /** @type {Array<number>} */ const indices = [];
    const search = /\r?\n|\r/g;
    while(search.test(value))indices.push(search.lastIndex);
    indices.push(value.length + 1);
    return {
        toPoint: toPoint,
        toOffset: toOffset
    };
    /** @type {ToPoint} */ function toPoint(offset) {
        let index = -1;
        if (typeof offset === "number" && offset > -1 && offset < indices[indices.length - 1]) while(++index < indices.length){
            if (indices[index] > offset) return {
                line: index + 1,
                column: offset - (index > 0 ? indices[index - 1] : 0) + 1,
                offset: offset
            };
        }
        return {
            line: undefined,
            column: undefined,
            offset: undefined
        };
    }
    /** @type {ToOffset} */ function toOffset(point) {
        const line = point && point.line;
        const column = point && point.column;
        if (typeof line === "number" && typeof column === "number" && !Number.isNaN(line) && !Number.isNaN(column) && line - 1 in indices) {
            const offset = (indices[line - 2] || 0) + column - 1 || 0;
            if (offset > -1 && offset < indices[indices.length - 1]) return offset;
        }
        return -1;
    }
}


/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */ const $146edf472bd639cb$export$f9bfcc6efbcb9478 = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


const $639b11cba4a9222d$var$own = {}.hasOwnProperty;
/** @type {unknown} */ // type-coverage:ignore-next-line
const $639b11cba4a9222d$var$proto = Object.prototype;
function $639b11cba4a9222d$export$371ddbe92c872127(tree, options) {
    const options_ = options || {};
    /** @type {Options} */ let settings;
    /** @type {VFile | undefined} */ let file;
    if ($639b11cba4a9222d$var$isFile(options_)) {
        file = options_;
        settings = {};
    } else {
        file = options_.file || undefined;
        settings = options_;
    }
    return $639b11cba4a9222d$var$one({
        schema: settings.space === "svg" ? (0, $d5b213d436a94199$export$7ed1367e7fa1ad68) : (0, $d5b213d436a94199$export$c0bb0b647f701bb5),
        file: file,
        verbose: settings.verbose,
        location: false
    }, tree);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {P5Node} node
 *   p5 node.
 * @returns {Node}
 *   hast node.
 */ function $639b11cba4a9222d$var$one(state, node) {
    /** @type {Node} */ let result;
    switch(node.nodeName){
        case "#comment":
            {
                const reference = /** @type {P5Comment} */ node;
                result = {
                    type: "comment",
                    value: reference.data
                };
                $639b11cba4a9222d$var$patch(state, reference, result);
                return result;
            }
        case "#document":
        case "#document-fragment":
            {
                const reference = /** @type {P5Document | P5DocumentFragment} */ node;
                const quirksMode = "mode" in reference ? reference.mode === "quirks" || reference.mode === "limited-quirks" : false;
                result = {
                    type: "root",
                    children: $639b11cba4a9222d$var$all(state, node.childNodes),
                    data: {
                        quirksMode: quirksMode
                    }
                };
                if (state.file && state.location) {
                    const doc = String(state.file);
                    const loc = (0, $aab3607e5d54580d$export$17b07c660794dc13)(doc);
                    const start = loc.toPoint(0);
                    const end = loc.toPoint(doc.length);
                    // @ts-expect-error: always defined as we give valid input.
                    result.position = {
                        start: start,
                        end: end
                    };
                }
                return result;
            }
        case "#documentType":
            {
                const reference = /** @type {P5DocumentType} */ node;
                // @ts-expect-error Types are out of date.
                result = {
                    type: "doctype"
                };
                $639b11cba4a9222d$var$patch(state, reference, result);
                return result;
            }
        case "#text":
            {
                const reference = /** @type {P5Text} */ node;
                result = {
                    type: "text",
                    value: reference.value
                };
                $639b11cba4a9222d$var$patch(state, reference, result);
                return result;
            }
        // Element.
        default:
            {
                const reference = /** @type {P5Element} */ node;
                result = $639b11cba4a9222d$var$element(state, reference);
                return result;
            }
    }
}
/**
 * Transform children.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Array<P5Node>} nodes
 *   Nodes.
 * @returns {Array<Content>}
 *   hast nodes.
 */ function $639b11cba4a9222d$var$all(state, nodes) {
    let index = -1;
    /** @type {Array<Content>} */ const result = [];
    while(++index < nodes.length)// @ts-expect-error Assume no roots in `nodes`.
    result[index] = $639b11cba4a9222d$var$one(state, nodes[index]);
    return result;
}
/**
 * Transform an element.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {P5Element} node
 *   `parse5` node to transform.
 * @returns {Element}
 *   hast node.
 */ function $639b11cba4a9222d$var$element(state, node) {
    const schema = state.schema;
    state.schema = node.namespaceURI === (0, $146edf472bd639cb$export$f9bfcc6efbcb9478).svg ? (0, $d5b213d436a94199$export$7ed1367e7fa1ad68) : (0, $d5b213d436a94199$export$c0bb0b647f701bb5);
    // Props.
    let index = -1;
    /** @type {Record<string, string>} */ const props = {};
    while(++index < node.attrs.length){
        const attribute = node.attrs[index];
        const name = (attribute.prefix ? attribute.prefix + ":" : "") + attribute.name;
        if (!$639b11cba4a9222d$var$own.call($639b11cba4a9222d$var$proto, name)) props[name] = attribute.value;
    }
    // Build.
    const fn = state.schema.space === "svg" ? (0, $a27415ef86a92815$export$2408f22a0fab9ae5) : (0, $22ef87f7acfe695a$export$dda1d9f60106f0e9);
    const result = fn(node.tagName, props, $639b11cba4a9222d$var$all(state, node.childNodes));
    $639b11cba4a9222d$var$patch(state, node, result);
    // Switch content.
    if (result.tagName === "template") {
        const reference = /** @type {P5Template} */ node;
        const pos = reference.sourceCodeLocation;
        const startTag = pos && pos.startTag && $639b11cba4a9222d$var$position(pos.startTag);
        const endTag = pos && pos.endTag && $639b11cba4a9222d$var$position(pos.endTag);
        /** @type {Root} */ // @ts-expect-error Types are wrong.
        const content = $639b11cba4a9222d$var$one(state, reference.content);
        if (startTag && endTag && state.file) content.position = {
            start: startTag.end,
            end: endTag.start
        };
        result.content = content;
    }
    state.schema = schema;
    return result;
}
/**
 * Patch positional info from `from` onto `to`.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {P5Node} from
 *   p5 node.
 * @param {Node} to
 *   hast node.
 * @returns {void}
 *   Nothing.
 */ function $639b11cba4a9222d$var$patch(state, from, to) {
    if ("sourceCodeLocation" in from && from.sourceCodeLocation && state.file) {
        const position = $639b11cba4a9222d$var$createLocation(state, to, from.sourceCodeLocation);
        if (position) {
            state.location = true;
            to.position = position;
        }
    }
}
/**
 * Create clean positional information.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Node} node
 *   hast node.
 * @param {P5ElementLocation} location
 *   p5 location info.
 * @returns {Position | undefined}
 *   Position, or nothing.
 */ function $639b11cba4a9222d$var$createLocation(state, node, location) {
    const result = $639b11cba4a9222d$var$position(location);
    if (node.type === "element") {
        const tail = node.children[node.children.length - 1];
        // Bug for unclosed with children.
        // See: <https://github.com/inikulin/parse5/issues/109>.
        if (result && !location.endTag && tail && tail.position && tail.position.end) result.end = Object.assign({}, tail.position.end);
        if (state.verbose) {
            /** @type {Record<string, Position | undefined>} */ const props = {};
            /** @type {string} */ let key;
            if (location.attrs) {
                for(key in location.attrs)if ($639b11cba4a9222d$var$own.call(location.attrs, key)) props[(0, $a5d32c782dfb87d4$export$71aa6c912b956294)(state.schema, key).property] = $639b11cba4a9222d$var$position(location.attrs[key]);
            }
            node.data = {
                position: {
                    // @ts-expect-error: assume not `undefined`.
                    opening: $639b11cba4a9222d$var$position(location.startTag),
                    closing: location.endTag ? $639b11cba4a9222d$var$position(location.endTag) : null,
                    properties: props
                }
            };
        }
    }
    return result;
}
/**
 * Turn a p5 location into a position.
 *
 * @param {P5Location} loc
 *   Location.
 * @returns {Position | undefined}
 *   Position or nothing.
 */ function $639b11cba4a9222d$var$position(loc) {
    const start = $639b11cba4a9222d$var$point({
        line: loc.startLine,
        column: loc.startCol,
        offset: loc.startOffset
    });
    const end = $639b11cba4a9222d$var$point({
        line: loc.endLine,
        column: loc.endCol,
        offset: loc.endOffset
    });
    // @ts-expect-error `undefined` is fine.
    return start || end ? {
        start: start,
        end: end
    } : undefined;
}
/**
 * Filter out invalid points.
 *
 * @param {Point} point
 *   Point with potentially `undefined` values.
 * @returns {Point | undefined}
 *   Point or nothing.
 */ function $639b11cba4a9222d$var$point(point) {
    return point.line && point.column ? point : undefined;
}
/**
 * Check if something is a file.
 *
 * @param {VFile | Options} value
 *   File or options.
 * @returns {value is VFile}
 *   Whether `value` is a file.
 */ function $639b11cba4a9222d$var$isFile(value) {
    return "messages" in value;
}


/**
 * @typedef {import('parse5').DefaultTreeAdapterMap} DefaultTreeAdapterMap
 * @typedef {DefaultTreeAdapterMap['document']} P5Document
 * @typedef {DefaultTreeAdapterMap['documentFragment']} P5Fragment
 * @typedef {DefaultTreeAdapterMap['element']} P5Element
 * @typedef {DefaultTreeAdapterMap['node']} P5Node
 * @typedef {DefaultTreeAdapterMap['documentType']} P5Doctype
 * @typedef {DefaultTreeAdapterMap['commentNode']} P5Comment
 * @typedef {DefaultTreeAdapterMap['textNode']} P5Text
 * @typedef {DefaultTreeAdapterMap['parentNode']} P5Parent
 * @typedef {import('parse5').Token.Attribute} P5Attribute
 * @typedef {Exclude<P5Node, P5Document | P5Fragment>} P5Child
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Content} Content
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {'html' | 'svg'} Space
 *
 * @typedef Options
 *   Configuration.
 * @property {Space | null | undefined} [space='html']
 *   Which space the document is in.
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 */ 



/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $6390e795d3685ed7$var$own = {}.hasOwnProperty;
function $6390e795d3685ed7$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $6390e795d3685ed7$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $6390e795d3685ed7$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}


const $1927293c779c065e$var$own = {}.hasOwnProperty;
/** @type {(from: Node, schema: Schema) => P5Node} */ const $1927293c779c065e$var$one = (0, $6390e795d3685ed7$export$d6a12bfbbedf6185)("type", {
    handlers: {
        root: $1927293c779c065e$var$root,
        element: $1927293c779c065e$var$element,
        text: $1927293c779c065e$var$text,
        comment: $1927293c779c065e$var$comment,
        doctype: $1927293c779c065e$var$doctype
    }
});
function $1927293c779c065e$export$b4cf803c867502fc(tree, options) {
    const space = options && typeof options === "object" ? options.space : options;
    return $1927293c779c065e$var$one(tree, space === "svg" ? (0, $d5b213d436a94199$export$7ed1367e7fa1ad68) : (0, $d5b213d436a94199$export$c0bb0b647f701bb5));
}
/**
 * @param {Root} node
 * @param {Schema} schema
 *   Current schema.
 * @returns {P5Document}
 */ function $1927293c779c065e$var$root(node, schema) {
    /** @type {P5Document} */ const result = {
        nodeName: "#document",
        // @ts-expect-error: `parse5` uses enums, which are actually strings.
        mode: (node.data || {}).quirksMode ? "quirks" : "no-quirks",
        childNodes: []
    };
    result.childNodes = $1927293c779c065e$var$all(node.children, result, schema);
    $1927293c779c065e$var$patch(node, result);
    return result;
}
/**
 * @param {Root} node
 * @param {Schema} schema
 *   Current schema.
 * @returns {P5Fragment}
 */ function $1927293c779c065e$var$fragment(node, schema) {
    /** @type {P5Fragment} */ const result = {
        nodeName: "#document-fragment",
        childNodes: []
    };
    result.childNodes = $1927293c779c065e$var$all(node.children, result, schema);
    $1927293c779c065e$var$patch(node, result);
    return result;
}
/**
 * @param {Doctype} node
 * @returns {P5Doctype}
 */ function $1927293c779c065e$var$doctype(node) {
    /** @type {P5Doctype} */ const result = {
        nodeName: "#documentType",
        name: "html",
        publicId: "",
        systemId: "",
        // @ts-expect-error: change to `null` in a major?
        parentNode: undefined
    };
    $1927293c779c065e$var$patch(node, result);
    return result;
}
/**
 * @param {Text} node
 * @returns {P5Text}
 */ function $1927293c779c065e$var$text(node) {
    /** @type {P5Text} */ const result = {
        nodeName: "#text",
        value: node.value,
        // @ts-expect-error: no `parentNode`
        parentNode: undefined
    };
    $1927293c779c065e$var$patch(node, result);
    return result;
}
/**
 * @param {Comment} node
 * @returns {P5Comment}
 */ function $1927293c779c065e$var$comment(node) {
    /** @type {P5Comment} */ const result = {
        nodeName: "#comment",
        data: node.value,
        // @ts-expect-error: no `parentNode`
        parentNode: undefined
    };
    $1927293c779c065e$var$patch(node, result);
    return result;
}
/**
 * @param {Element} node
 * @param {Schema} schema
 *   Current schema.
 * @returns {P5Element}
 *   `parse5` node.
 */ function $1927293c779c065e$var$element(node, schema) {
    const parentSchema = schema;
    let currentSchema = parentSchema;
    if (node.type === "element" && node.tagName.toLowerCase() === "svg" && parentSchema.space === "html") currentSchema = (0, $d5b213d436a94199$export$7ed1367e7fa1ad68);
    /** @type {Array<P5Attribute>} */ const attrs = [];
    /** @type {string} */ let prop;
    if (node.properties) {
        for(prop in node.properties)if (prop !== "children" && $1927293c779c065e$var$own.call(node.properties, prop)) {
            const result = $1927293c779c065e$var$createProperty(currentSchema, prop, node.properties[prop]);
            if (result) attrs.push(result);
        }
    }
    /** @type {P5Element} */ const result = {
        nodeName: node.tagName,
        tagName: node.tagName,
        attrs: attrs,
        // @ts-expect-error: html and svg both have a space.
        namespaceURI: (0, $146edf472bd639cb$export$f9bfcc6efbcb9478)[currentSchema.space],
        childNodes: [],
        // @ts-expect-error: no `parentNode`
        parentNode: undefined
    };
    result.childNodes = $1927293c779c065e$var$all(node.children, result, currentSchema);
    $1927293c779c065e$var$patch(node, result);
    if (node.tagName === "template" && node.content) // @ts-expect-error: `parse5` types are wrong.
    result.content = $1927293c779c065e$var$fragment(node.content, currentSchema);
    return result;
}
/**
 * Handle a property.
 *
 * @param {Schema} schema
 *   Current schema.
 * @param {string} prop
 *   Key.
 * @param {Array<string | number> | string | number | boolean | null | undefined} value
 *   hast property value.
 * @returns {P5Attribute | void}
 *   Field for runtime, optional.
 */ function $1927293c779c065e$var$createProperty(schema, prop, value) {
    const info = (0, $a5d32c782dfb87d4$export$71aa6c912b956294)(schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === undefined || value === null || value === false || typeof value === "number" && Number.isNaN(value) || !value && info.boolean) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $8ee927eafd1154d1$export$fac44ee5b035f737)(value) : (0, $3ffb311c7c73400a$export$fac44ee5b035f737)(value);
    /** @type {P5Attribute} */ const attribute = {
        name: info.attribute,
        value: value === true ? "" : String(value)
    };
    if (info.space && info.space !== "html" && info.space !== "svg") {
        const index = attribute.name.indexOf(":");
        if (index < 0) attribute.prefix = "";
        else {
            attribute.name = attribute.name.slice(index + 1);
            attribute.prefix = info.attribute.slice(0, index);
        }
        attribute.namespace = (0, $146edf472bd639cb$export$f9bfcc6efbcb9478)[info.space];
    }
    return attribute;
}
/**
 * Transform all hast nodes.
 *
 * @param {Array<Content>} children
 *   List of children.
 * @param {P5Parent} parentNode
 *   `parse5` parent node.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Array<P5Child>}
 *   Transformed children.
 */ function $1927293c779c065e$var$all(children, parentNode, schema) {
    let index = -1;
    /** @type {Array<P5Child>} */ const results = [];
    if (children) while(++index < children.length){
        /** @type {P5Child} */ // @ts-expect-error assume no document.
        const child = $1927293c779c065e$var$one(children[index], schema);
        child.parentNode = parentNode;
        results.push(child);
    }
    return results;
}
/**
 * Add position info from `from` to `to`.
 *
 * @param {Node} from
 *   hast node.
 * @param {P5Node} to
 *   `parse5` node.
 * @returns {void}
 *   Nothing.
 */ function $1927293c779c065e$var$patch(from, to) {
    const position = from.position;
    if (position && position.start && position.end) to.sourceCodeLocation = {
        startLine: position.start.line,
        startCol: position.start.column,
        // @ts-expect-error assume this is set.
        startOffset: position.start.offset,
        endLine: position.end.line,
        endCol: position.end.column,
        // @ts-expect-error assume this is set.
        endOffset: position.end.offset
    };
}


/**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */ const $53d8f7528825c062$export$762508062d068de = [
    "area",
    "base",
    "basefont",
    "bgsound",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "image",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "menuitem",
    "meta",
    "nextid",
    "param",
    "source",
    "track",
    "wbr"
];




const $2d98bbbe9649d0ee$var$inTemplateMode = "IN_TEMPLATE_MODE";
const $2d98bbbe9649d0ee$var$dataState = "DATA_STATE";
const $2d98bbbe9649d0ee$var$characterToken = "CHARACTER_TOKEN";
const $2d98bbbe9649d0ee$var$startTagToken = "START_TAG_TOKEN";
const $2d98bbbe9649d0ee$var$endTagToken = "END_TAG_TOKEN";
const $2d98bbbe9649d0ee$var$commentToken = "COMMENT_TOKEN";
const $2d98bbbe9649d0ee$var$doctypeToken = "DOCTYPE_TOKEN";
/** @type {P5ParserOptions} */ const $2d98bbbe9649d0ee$var$parseOptions = {
    sourceCodeLocationInfo: true,
    scriptingEnabled: false
};
const $2d98bbbe9649d0ee$export$1776c186c69df29e = /**
   * @type {(
   *   ((tree: Node, file: VFile|undefined, options?: Options) => Node) &
   *   ((tree: Node, options?: Options) => Node)
   * )}
   */ /**
     * @param {Node} tree
     * @param {VFile} [file]
     * @param {Options} [options]
     */ function(tree, file, options) {
    let index = -1;
    const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($3c987794e73954fa$exports)))($2d98bbbe9649d0ee$var$parseOptions);
    const one = (0, $6390e795d3685ed7$export$d6a12bfbbedf6185)("type", {
        handlers: {
            root: root,
            element: element,
            text: text,
            comment: comment,
            doctype: doctype,
            raw: handleRaw
        },
        unknown: // @ts-expect-error: hush.
        $2d98bbbe9649d0ee$var$unknown
    });
    /** @type {boolean|undefined} */ let stitches;
    /** @type {HiddenTokenizer|undefined} */ let tokenizer;
    /** @type {HiddenPreprocessor|undefined} */ let preprocessor;
    /** @type {HiddenPosTracker|undefined} */ let posTracker;
    /** @type {HiddenLocationTracker|undefined} */ let locationTracker;
    if ($2d98bbbe9649d0ee$var$isOptions(file)) {
        options = file;
        file = undefined;
    }
    if (options && options.passThrough) while(++index < options.passThrough.length)// @ts-expect-error: hush.
    one.handlers[options.passThrough[index]] = stitch;
    const result = (0, $639b11cba4a9222d$export$371ddbe92c872127)($2d98bbbe9649d0ee$var$documentMode(tree) ? document() : fragment(), file);
    if (stitches) (0, $93d8bd8148453afd$export$bf638b60ea8b89b7)(result, "comment", (node, index, parent)=>{
        const stitch = /** @type {unknown} */ node;
        if (stitch.value.stitch && parent !== null && index !== null) {
            // @ts-expect-error: assume the stitch is allowed.
            parent.children[index] = stitch.value.stitch;
            return index;
        }
    });
    // Unpack if possible and when not given a `root`.
    if (tree.type !== "root" && result.type === "root" && result.children.length === 1) return result.children[0];
    return result;
    /**
       * @returns {P5Fragment}
       */ function fragment() {
        /** @type {P5Element} */ const context = {
            nodeName: "template",
            tagName: "template",
            attrs: [],
            namespaceURI: (0, $146edf472bd639cb$export$f9bfcc6efbcb9478).html,
            childNodes: []
        };
        /** @type {P5Element} */ const mock = {
            nodeName: "documentmock",
            tagName: "documentmock",
            attrs: [],
            namespaceURI: (0, $146edf472bd639cb$export$f9bfcc6efbcb9478).html,
            childNodes: []
        };
        /** @type {P5Fragment} */ const doc = {
            nodeName: "#document-fragment",
            childNodes: []
        };
        parser._bootstrap(mock, context);
        parser._pushTmplInsertionMode($2d98bbbe9649d0ee$var$inTemplateMode);
        parser._initTokenizerForFragmentParsing();
        parser._insertFakeRootElement();
        parser._resetInsertionMode();
        parser._findFormInFragmentContext();
        tokenizer = parser.tokenizer;
        /* c8 ignore next */ if (!tokenizer) throw new Error("Expected `tokenizer`");
        preprocessor = tokenizer.preprocessor;
        locationTracker = tokenizer.__mixins[0];
        posTracker = locationTracker.posTracker;
        one(tree);
        resetTokenizer();
        parser._adoptNodes(mock.childNodes[0], doc);
        return doc;
    }
    /**
       * @returns {P5Document}
       */ function document() {
        /** @type {P5Document} */ const doc = parser.treeAdapter.createDocument();
        parser._bootstrap(doc, undefined);
        tokenizer = parser.tokenizer;
        /* c8 ignore next */ if (!tokenizer) throw new Error("Expected `tokenizer`");
        preprocessor = tokenizer.preprocessor;
        locationTracker = tokenizer.__mixins[0];
        posTracker = locationTracker.posTracker;
        one(tree);
        resetTokenizer();
        return doc;
    }
    /**
       * @param {Array<Content>} nodes
       * @returns {void}
       */ function all(nodes) {
        let index = -1;
        /* istanbul ignore else - invalid nodes, see rehypejs/rehype-raw#7. */ if (nodes) while(++index < nodes.length)one(nodes[index]);
    }
    /**
       * @param {Root} node
       * @returns {void}
       */ function root(node) {
        all(node.children);
    }
    /**
       * @param {Element} node
       * @returns {void}
       */ function element(node) {
        resetTokenizer();
        parser._processInputToken($2d98bbbe9649d0ee$var$startTag(node));
        all(node.children);
        if (!(0, $53d8f7528825c062$export$762508062d068de).includes(node.tagName)) {
            resetTokenizer();
            parser._processInputToken($2d98bbbe9649d0ee$var$endTag(node));
        }
    }
    /**
       * @param {Text} node
       * @returns {void}
       */ function text(node) {
        resetTokenizer();
        parser._processInputToken({
            type: $2d98bbbe9649d0ee$var$characterToken,
            chars: node.value,
            location: $2d98bbbe9649d0ee$var$createParse5Location(node)
        });
    }
    /**
       * @param {Doctype} node
       * @returns {void}
       */ function doctype(node) {
        resetTokenizer();
        parser._processInputToken({
            type: $2d98bbbe9649d0ee$var$doctypeToken,
            name: "html",
            forceQuirks: false,
            publicId: "",
            systemId: "",
            location: $2d98bbbe9649d0ee$var$createParse5Location(node)
        });
    }
    /**
       * @param {Comment|Stitch} node
       * @returns {void}
       */ function comment(node) {
        resetTokenizer();
        parser._processInputToken({
            type: $2d98bbbe9649d0ee$var$commentToken,
            data: node.value,
            location: $2d98bbbe9649d0ee$var$createParse5Location(node)
        });
    }
    /**
       * @param {Raw} node
       * @returns {void}
       */ function handleRaw(node) {
        const start = (0, $31d9094bf1c6aaa4$export$771bf3e4949bfbee)(node);
        const line = start.line || 1;
        const column = start.column || 1;
        const offset = start.offset || 0;
        /* c8 ignore next 4 */ if (!preprocessor) throw new Error("Expected `preprocessor`");
        if (!tokenizer) throw new Error("Expected `tokenizer`");
        if (!posTracker) throw new Error("Expected `posTracker`");
        if (!locationTracker) throw new Error("Expected `locationTracker`");
        // Reset preprocessor:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/tokenizer/preprocessor.js#L17>.
        preprocessor.html = undefined;
        preprocessor.pos = -1;
        preprocessor.lastGapPos = -1;
        preprocessor.lastCharPos = -1;
        preprocessor.gapStack = [];
        preprocessor.skipNextNewLine = false;
        preprocessor.lastChunkWritten = false;
        preprocessor.endOfChunkHit = false;
        // Reset preprocessor mixin:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/position-tracking/preprocessor-mixin.js>.
        posTracker.isEol = false;
        posTracker.lineStartPos = -column + 1 // Looks weird, but ensures we get correct positional info.
        ;
        posTracker.droppedBufferSize = offset;
        posTracker.offset = 0;
        posTracker.col = 1;
        posTracker.line = line;
        // Reset location tracker:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/location-info/tokenizer-mixin.js>.
        locationTracker.currentAttrLocation = undefined;
        locationTracker.ctLoc = $2d98bbbe9649d0ee$var$createParse5Location(node);
        // See the code for `parse` and `parseFragment`:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/parser/index.js#L371>.
        tokenizer.write(node.value);
        parser._runParsingLoop(null);
        // Character references hang, so if we ended there, we need to flush
        // those too.
        // We reset the preprocessor as if the document ends here.
        // Then one single call to the relevant state does the trick, parse5
        // consumes the whole token.
        if (tokenizer.state === "NAMED_CHARACTER_REFERENCE_STATE" || tokenizer.state === "NUMERIC_CHARACTER_REFERENCE_END_STATE") {
            preprocessor.lastChunkWritten = true;
            tokenizer[tokenizer.state](tokenizer._consume());
        }
    }
    /**
       * @param {Node} node
       */ function stitch(node) {
        stitches = true;
        /** @type {Node} */ let clone;
        // Recurse, because to somewhat handle `[<x>]</x>` (where `[]` denotes the
        // passed through node).
        if ("children" in node) clone = {
            ...node,
            children: $2d98bbbe9649d0ee$export$1776c186c69df29e({
                type: "root",
                children: node.children
            }, file, options).children
        };
        else clone = {
            ...node
        };
        // Hack: `value` is supposed to be a string, but as none of the tools
        // (`parse5` or `hast-util-from-parse5`) looks at it, we can pass nodes
        // through.
        comment({
            type: "comment",
            value: {
                stitch: clone
            }
        });
    }
    function resetTokenizer() {
        /* c8 ignore next 2 */ if (!tokenizer) throw new Error("Expected `tokenizer`");
        if (!posTracker) throw new Error("Expected `posTracker`");
        // Process final characters if they’re still there after hibernating.
        // Similar to:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/location-info/tokenizer-mixin.js#L95>.
        const token = tokenizer.currentCharacterToken;
        if (token) {
            token.location.endLine = posTracker.line;
            token.location.endCol = posTracker.col + 1;
            token.location.endOffset = posTracker.offset + 1;
            parser._processInputToken(token);
        }
        // Reset tokenizer:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/tokenizer/index.js#L218-L234>.
        // Especially putting it back in the `data` state is useful: some elements,
        // like textareas and iframes, change the state.
        // See GH-7.
        // But also if broken HTML is in `raw`, and then a correct element is given.
        // See GH-11.
        tokenizer.tokenQueue = [];
        tokenizer.state = $2d98bbbe9649d0ee$var$dataState;
        tokenizer.returnState = "";
        tokenizer.charRefCode = -1;
        tokenizer.tempBuff = [];
        tokenizer.lastStartTagName = "";
        tokenizer.consumedAfterSnapshot = -1;
        tokenizer.active = false;
        tokenizer.currentCharacterToken = undefined;
        tokenizer.currentToken = undefined;
        tokenizer.currentAttr = undefined;
    }
};
/**
 * @param {Element} node
 * @returns {HiddenToken}
 */ function $2d98bbbe9649d0ee$var$startTag(node) {
    /** @type {P5Location} */ const location = Object.assign($2d98bbbe9649d0ee$var$createParse5Location(node));
    // @ts-expect-error extra positional info.
    location.startTag = Object.assign({}, location);
    // Untyped token.
    return {
        type: $2d98bbbe9649d0ee$var$startTagToken,
        tagName: node.tagName,
        selfClosing: false,
        attrs: $2d98bbbe9649d0ee$var$attributes(node),
        location: location
    };
}
/**
 * @param {Element} node
 * @returns {Array<P5Attribute>}
 */ function $2d98bbbe9649d0ee$var$attributes(node) {
    return (0, $1927293c779c065e$export$b4cf803c867502fc)({
        tagName: node.tagName,
        type: "element",
        properties: node.properties,
        children: []
    }).attrs;
}
/**
 * @param {Element} node
 * @returns {HiddenToken}
 */ function $2d98bbbe9649d0ee$var$endTag(node) {
    /** @type {P5Location} */ const location = Object.assign($2d98bbbe9649d0ee$var$createParse5Location(node));
    // @ts-expect-error extra positional info.
    location.startTag = Object.assign({}, location);
    // Untyped token.
    return {
        type: $2d98bbbe9649d0ee$var$endTagToken,
        tagName: node.tagName,
        attrs: [],
        location: location
    };
}
/**
 * @param {Node} node
 */ function $2d98bbbe9649d0ee$var$unknown(node) {
    throw new Error("Cannot compile `" + node.type + "` node");
}
/**
 * @param {Node} node
 * @returns {boolean}
 */ function $2d98bbbe9649d0ee$var$documentMode(node) {
    const head = node.type === "root" ? node.children[0] : node;
    return Boolean(head && (head.type === "doctype" || head.type === "element" && head.tagName === "html"));
}
/**
 * @param {Node|Stitch} node
 * @returns {P5Location}
 */ function $2d98bbbe9649d0ee$var$createParse5Location(node) {
    const start = (0, $31d9094bf1c6aaa4$export$771bf3e4949bfbee)(node);
    const end = (0, $31d9094bf1c6aaa4$export$da309cdce9dc2a25)(node);
    return {
        startLine: start.line,
        startCol: start.column,
        startOffset: start.offset,
        endLine: end.line,
        endCol: end.column,
        endOffset: end.offset
    };
}
/**
 * @param {VFile|Options|undefined} value
 * @return {value is Options}
 */ function $2d98bbbe9649d0ee$var$isOptions(value) {
    return Boolean(value && !("message" in value && "messages" in value));
}


function $37360ee9ae8bb73a$export$2e2bcd8739ae039(options = {}) {
    return (tree, file)=>{
        // Assume that when a root was given, it’s also returned.
        const result = /** @type {Root} */ (0, $2d98bbbe9649d0ee$export$1776c186c69df29e)(tree, file, options);
        return result;
    };
}




"use client";
const $687d1557fc53c02d$var$CopyComp = ({ text: text })=>{
    const [copyText, setCopyText] = (0, $a70cf465074cab30$export$60241385465d0a34)("Als Markdown Kopieren");
    const [copyHTMLText, setCopyHTMLText] = (0, $a70cf465074cab30$export$60241385465d0a34)("Als HTML Kopieren");
    const handleCopy = ()=>{
        navigator.clipboard.writeText(text);
        setCopyText("\u2705 In Zwischenablage kopiert");
        const timeId = setTimeout(()=>{
            setCopyText("Als Markdown Kopieren");
        }, 5000);
        return ()=>{
            clearTimeout(timeId);
        };
    };
    const handleHTMLCopy = ()=>{
        const htmlText = document.getElementsByClassName("markdownHolder").item(0).innerHTML;
        navigator.clipboard.writeText(htmlText);
        setCopyHTMLText("\u2705 In Zwischenablage kopiert");
        const timeId = setTimeout(()=>{
            setCopyHTMLText("Als HTML Kopieren");
        }, 5000);
        return ()=>{
            clearTimeout(timeId);
        };
    };
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                type: "button",
                onClick: ()=>{
                    handleCopy();
                },
                className: "w-fit ml-auto border focus:ring-4 focus:outline-nonefont-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center focus:ring-gray-600 bg-gray-800 border-gray-700 text-white hover:bg-gray-700 mr-2 mb-2",
                children: copyText
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                type: "button",
                onClick: ()=>{
                    handleHTMLCopy();
                },
                className: "w-fit ml-auto border focus:ring-4 focus:outline-nonefont-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center focus:ring-gray-600 bg-gray-800 border-gray-700 text-white hover:bg-gray-700 mr-2 mb-2",
                children: copyHTMLText
            })
        ]
    });
};
var $687d1557fc53c02d$export$2e2bcd8739ae039 = $687d1557fc53c02d$var$CopyComp;




const $f4139e7986c8c695$export$e5f52487c03b159e = (promiseFn)=>{
    const [result, setResult] = (0, $a70cf465074cab30$export$60241385465d0a34)(undefined);
    const [loading, setLoading] = (0, $a70cf465074cab30$export$60241385465d0a34)(true);
    (0, $a70cf465074cab30$export$6d9c69b0de29b591)(()=>{
        let active = true;
        setLoading(true);
        load();
        return ()=>{
            active = false;
        };
        async function load() {
            setResult(undefined); // this is optional
            const res = await promiseFn();
            if (!active) return;
            setResult(res);
            setLoading(false);
        }
    // TODO: Do we need to add promiseFn to the dependency array?
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        loading,
        result
    ];
};




async function $1c9f9f2b0d9181a3$var$getBlog(id) {
    const { error: error, data: data } = await (0, $1a50cd70d80fe90f$export$a0b632a28672d3c0).functions.invoke("getBlog", {
        body: {
            blog_id: id
        }
    });
    return data?.content || undefined;
}
const $1c9f9f2b0d9181a3$export$8353a350193a5d77 = ()=>{
    const params = (0, $23ae8c349145cf41$export$99eaa27ddbbb95ef)();
    const [loading, blog] = (0, $f4139e7986c8c695$export$e5f52487c03b159e)(()=>$1c9f9f2b0d9181a3$var$getBlog(params?.id));
    if (!blog) return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "w-screen h-screen flex justify-center",
        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
            className: "w-full flex items-center flex-col max-w-[900px] gap-[16px] mt-[32px]",
            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                children: "Unter diesem Link gibt es keinen Artikel oder du hast keinen Zugriff auf diesen Artikel."
            })
        })
    });
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "w-screen h-screen flex justify-center",
        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
            className: "w-full flex items-center flex-col max-w-[900px] gap-[16px] mt-[32px]",
            children: [
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                    className: "flex justify-between w-full",
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h1", {
                        className: "text-[28px] font-semibold text-center",
                        children: "Dein Artikel ist fertig"
                    })
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                    style: {
                        overflow: "scroll"
                    },
                    className: "w-full cursor-pointer bg-[#E6EFEE] rounded-md shadow-lg p-[16px] m-[16px] flex flex-col gap-[16px] animate-fadeIn whitespace-break-spaces",
                    children: [
                        loading && /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $47afaa71a6a401ac$export$2e2bcd8739ae039), {}),
                        blog && !loading ? /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $687d1557fc53c02d$export$2e2bcd8739ae039), {
                                    text: blog
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $4c150aafc3247272$export$83ef7ab426386201), {
                                    remarkPlugins: [
                                        (0, $f826a548de96aedc$export$2e2bcd8739ae039)
                                    ],
                                    rehypePlugins: [
                                        (0, $37360ee9ae8bb73a$export$2e2bcd8739ae039)
                                    ],
                                    className: `markdownHolder`,
                                    children: blog
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
                            children: "Artikel nicht gefunden."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                    className: "w-full  rounded-md shadow-lg p-[16px] m-[16px] flex flex-col gap-[16px] animate-fadeIn whitespace-break-spaces",
                    children: [
                        "Diesen Artikel kannst du in Zukunft immer unter",
                        " ",
                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                            href: "https://cleverpenman.com/blog/{params.id}",
                            children: [
                                "cleverpenman.com/blog/",
                                params.id
                            ]
                        }),
                        " ",
                        "abrufen, wenn du dich mit deiner ID authentifiziert hast."
                    ]
                })
            ]
        })
    });
};




const $1547805c5793a413$export$c84671f46d6a1ca = ()=>{
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "md:mt-0 bg-secondary",
        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$910ae8079b2c2852), {})
    });
};









const $8fc97e69887d62e6$export$f14c0e3f98d164c0 = ()=>{
    const [voucher, setVoucher] = (0, $a70cf465074cab30$export$60241385465d0a34)(""); // TODO change to context
    const [trialMail, setTrialMail] = (0, $a70cf465074cab30$export$60241385465d0a34)("");
    const [trialMailError, setTrialMailError] = (0, $a70cf465074cab30$export$60241385465d0a34)("");
    const [loading, setLoading] = (0, $a70cf465074cab30$export$60241385465d0a34)(false);
    const auth = (0, $1b1216ab6f64a7b3$export$1d39dc5b47e56ff0)();
    const navigate = (0, $23ae8c349145cf41$export$9770f232ac06a008)();
    const [noUsesLeft, setNoUsesLeft] = (0, $a70cf465074cab30$export$60241385465d0a34)(false);
    const [loginError, setLoginError] = (0, $a70cf465074cab30$export$60241385465d0a34)(false);
    const [trialMailSent, setTrialMailSent] = (0, $a70cf465074cab30$export$60241385465d0a34)(false);
    const handleVoucherChange = (event)=>{
        setVoucher(event.target.value);
    };
    const handleTrialMailChange = (event)=>setTrialMail(event.target.value);
    (0, $a70cf465074cab30$export$6d9c69b0de29b591)(()=>{
        // Scroll to the top when the component mounts
        window.scrollTo(0, 0);
    }, []);
    const handleVoucherSubmit = async (event)=>{
        event.preventDefault();
        setLoading(true);
        try {
            await auth.signIn(voucher);
            const usesLeft = await (0, $ac0a6b968bc69320$export$31d6a278b5f09bf3)(voucher);
            if (usesLeft > 0) navigate("/create-transcript");
            setNoUsesLeft(true);
        } catch (err) {
            setLoginError(true);
            console.error(err);
        }
        setLoading(false);
    };
    const handleTrialMailSubmit = async (event)=>{
        event.preventDefault();
        setLoading(true);
        setTrialMailError("");
        try {
            const response = await (0, $1a50cd70d80fe90f$export$a0b632a28672d3c0).functions.invoke("sendDemoMail", {
                body: {
                    mail: trialMail
                }
            });
            setTrialMailSent(true);
            if (response.error instanceof (0, $17367bd8a14f7b69$export$761f8c0e0fa4624f)) {
                const { msg: msg } = await response.error.context.json();
                if (msg) throw new Error(msg);
                else throw new Error("An error occurred while sending the mail");
            }
        } catch (err) {
            setTrialMailSent(true);
            setTrialMailError(err.message);
            console.error(err);
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
            className: "sectionSize bg-secondary align",
            children: [
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                    className: "secondaryTitle bg-underline3 bg-100%",
                    children: "Guthaben aufladen"
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                    className: "text-xl",
                    children: "Unten gibt es einen kostenlosen Code zum Testen."
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                    className: "text-center",
                    children: "Du kannst dich mit deinem Code anmelden. Jeder Code hat ein Kontingent an Artikeln, die du damit generieren kannst."
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                    className: "w-screen h-screen flex justify-center",
                    children: !loading ? /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "w-full flex items-center flex-col max-w-[900px] gap-[16px] mt-[32px]",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("form", {
                                onSubmit: handleVoucherSubmit,
                                className: "w-full max-w-[400px] cursor-pointer bg-secondary rounded-md shadow-2xl p-[16px] flex flex-col gap-[16px] animate-fadeIn",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                        htmlFor: "voucher",
                                        className: "text-[16px] font-medium",
                                        children: "Melde dich mit deinem Code an:"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("input", {
                                        type: "text",
                                        id: "voucher",
                                        name: "voucher",
                                        placeholder: "a42aa4a2-42aa-42aa-4a2a-4a24aa24242a",
                                        value: voucher,
                                        onChange: handleVoucherChange,
                                        className: "border border-gray-400 rounded-md p-[8px] text-[16px] font-medium"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                        type: "submit",
                                        className: "bg-black text-white rounded-md p-[8px] text-[16px] font-medium hover:bg-[00005D] transition-colors",
                                        children: "Weiter"
                                    })
                                ]
                            }),
                            noUsesLeft && /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "w-full flex items-center flex-col max-w-[900px]",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    className: "error mb-4 text-center text-white text-lg font-bold w-full max-w-[400px] rounded-md shadow-2xl p-4 flex flex-col",
                                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                        children: "Dein Guthaben ist leider aufgebraucht."
                                    })
                                })
                            }),
                            " ",
                            loginError && /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "w-full flex items-center flex-col max-w-[900px]",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    className: "error mb-4 text-center text-white text-lg font-bold w-full max-w-[400px] rounded-md shadow-2xl p-4 flex flex-col",
                                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                        children: "Dieser Code ist ung\xfcltig."
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("form", {
                                onSubmit: handleTrialMailSubmit,
                                className: "w-full max-w-[400px] cursor-pointer bg-secondary rounded-md shadow-2xl p-[16px] flex flex-col gap-[16px] animate-fadeIn",
                                children: !trialMailSent ? /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
                                    children: [
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                            htmlFor: "voucher",
                                            className: "text-[16px] font-medium",
                                            children: [
                                                "Du hast keinen Code mit Guthaben?",
                                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("small", {
                                                    children: "Lasse dir einen mit kostenlosem Guthaben zuschicken. Damit kannst du das Tool kostenlos testen."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("input", {
                                            type: "text",
                                            id: "trialMail",
                                            name: "trialMail",
                                            inputMode: "email",
                                            placeholder: "mail@mail.com",
                                            value: trialMail,
                                            onChange: handleTrialMailChange,
                                            className: "border border-gray-400 rounded-md p-[8px] text-[16px] font-medium"
                                        }),
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                            type: "submit",
                                            className: "bg-black text-white rounded-md p-[8px] text-[16px] font-medium hover:bg-[00005D] transition-colors",
                                            children: "Senden"
                                        })
                                    ]
                                }) : trialMailError ? /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    className: " mb-4 text-center text-lg font-bold w-full max-w-[400px] p-4 flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                            children: trialMailError
                                        }),
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                            onClick: ()=>{
                                                setTrialMailSent(false);
                                                setTrialMailError("");
                                            },
                                            className: "bg-black text-white rounded-md p-[8px] text-[16px] font-medium hover:bg-[00005D] transition-colors",
                                            children: "Zur\xfcck"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
                                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "mb-4 text-center  text-lg font-bold w-full max-w-[400px] p-4 flex flex-col",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                            children: [
                                                "Dein Code wurde an ",
                                                trialMail,
                                                " gesendet."
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "w-full flex items-center flex-col max-w-[900px] gap-[16px] mt-[32px]",
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                            className: "w-full flex items-center flex-col max-w-[900px]",
                            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: " mb-4 text-center  text-lg font-bold w-full max-w-[400px] rounded-md shadow-2xl p-4 flex flex-col",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                    children: "Lade..."
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};





function $33bb2a8076af9cbd$export$8ef2ed426dede42d({ children: children }) {
    let auth = (0, $1b1216ab6f64a7b3$export$1d39dc5b47e56ff0)();
    let location = (0, $23ae8c349145cf41$export$45d76561a5302f2b)();
    if (!auth.jwt) // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$444b3ab0cb9aec40), {
        to: "/login",
        state: {
            from: location
        },
        replace: true
    });
    return children;
}






var $35ad6d1d71548763$exports = {};
$35ad6d1d71548763$exports = new URL("HowTo.df1d555c.webp", import.meta.url).toString();


const $7da27bfd17cda4c8$var$BLOG_ARTICLES = [
    {
        title: "Wie man aus einem Video einen Blog-Artikel generiert",
        link: "/articles/wie-man-aus-einem-video-einen-blog-artikel-generiert",
        date: new Date(2024, 6, 1),
        thumbnail: new URL($35ad6d1d71548763$exports),
        excerpt: "Erfahren Sie, wie Sie einfach und effizient Videos in hochwertige Blog-Artikel umwandeln k\xf6nnen..."
    }
];













const $7da27bfd17cda4c8$export$355f3d6a1f8b250c = ()=>{
    const { url: url, setUrl: setUrl } = (0, $a70cf465074cab30$export$fae74005e78b1a27)((0, $bd2db0da17abe19a$export$1218bc8dc9713867));
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                className: "md:h-screen flex flex-col justify-center text-center md:text-left md:flex-row md:justify-between md:items-center lg:px-48 md:px-12 px-4",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "md:flex-1 md:mr-10",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h1", {
                                className: "font-pt-serif text-4xl font-bold mb-7",
                                children: [
                                    "Der beste Content Manager ist dein",
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("span", {
                                        className: "bg-underline1 bg-left-bottom bg-no-repeat p-2 bg-100%",
                                        children: "YouTube-Kanal"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                className: "font-pt-serif font-normal mb-7",
                                children: "Verwandle jedes Video mit nur einem Klick in einen Artikel oder Social Media Beitrag. Unsere AI optimiert den Inhalt f\xfcr Suchmaschinen und organische Reichweite."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "font-montserrat",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                                        href: "#start",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                            className: "bg-black px-6 py-4 rounded-lg border-2 border-black border-solid text-white mr-2 mb-2",
                                            children: "Kostenlos testen"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                                        href: "#how",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                            className: "hover:bg-white px-6 py-4 border-2 border-black border-solid rounded-lg",
                                            children: "Wie geht das?"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "flex justify-around md:block mt-8 md:mt-0 md:flex-1",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "relative md:ml-10",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                    src: (parcelRequire("jLwkL")),
                                    alt: "highlight_splashes",
                                    className: "absolute -top-16 -left-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                src: new URL($3afe40411ef8172d$exports).href,
                                alt: "Logo",
                                className: "hidden md:block mx-auto"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                    src: (parcelRequire("cokhW")),
                                    alt: "highlight_splashes",
                                    className: "absolute -bottom-10 right-6"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                className: "bg-black text-white sectionSize",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        id: "how",
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                            className: "secondaryTitle bg-underline2 bg-100%",
                            children: "3 Schritte von Video zu Artikel"
                        })
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "flex flex-col md:flex-row",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex-1 mx-8 flex flex-col items-center my-4",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "border-2 rounded-full bg-secondary text-black h-12 w-12 flex justify-center items-center mb-3",
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                        className: "font-montserrat font-medium text-xl mb-2",
                                        children: "Link eingeben"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                        className: "text-center font-montserrat",
                                        children: "Gebe den Link eines YouTube-Videos (Englisch oder Deutsch) ein. Am Besten ist das Ergebnis, wenn das Video 3 bis 20 Minuten lang ist."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex-1 mx-8 flex flex-col items-center my-4",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "border-2 rounded-full bg-secondary text-black h-12 w-12 flex justify-center items-center mb-3",
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                        className: "font-montserrat font-medium text-xl mb-2",
                                        children: "Beitrag kopieren"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                        className: "text-center font-montserrat",
                                        children: "Unsere AI generiert einen SEO-Artikel zum Video. Du kannst ihn mit einem Klick als Text, HTML oder Markdown kopieren."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex-1 mx-8 flex flex-col items-center my-4",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "border-2 rounded-full bg-secondary text-black h-12 w-12 flex justify-center items-center mb-3",
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                        className: "font-montserrat font-medium text-xl mb-2",
                                        children: "Ver\xf6ffentlichen"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                        className: "text-center font-montserrat",
                                        children: "Den kopierten Text kannst du in WordPress oder dem Tool deiner Wahl einf\xfcgen. Den Inhalt erh\xe4ltst du als HTML, Markdown oder normalen Text."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                id: "start",
                className: "sectionSize bg-secondary align",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                        className: "secondaryTitle bg-underline3 bg-100%",
                        children: "Artikel erstellen"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("label", {
                                className: "block mb-2 text-sm font-medium",
                                children: "Aus welchem Video m\xf6chtest du einen Artikel erstellen?"
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("input", {
                                value: url,
                                onChange: (e)=>setUrl(e.target.value),
                                type: "text",
                                id: "url",
                                className: "border text-sm rounded-lg block w-full p-2.5 border-gray-600 placeholder-gray-400  focus:ring-coral-500 focus:border-coral-500",
                                placeholder: "https://www.youtube.com/watch?v=TX9qSaGXFyg",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "/create-transcript",
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                            className: "bg-black px-6 py-4 rounded-lg border-2 border-black border-solid text-white mr-2 mb-2",
                            children: "Kostenlos testen"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                id: "features",
                className: "sectionSize bg-secondary",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                            className: "secondaryTitle bg-underline4 bg-100%",
                            children: "Funktionen"
                        })
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "md:grid md:grid-cols-2 md:grid-rows-2",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex items-start font-montserrat my-6 mr-10",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                        src: (parcelRequire("akrcu")),
                                        alt: "heart icon",
                                        className: "h-7 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                                className: "font-semibold text-2xl",
                                                children: "Optimiert f\xfcr Deutsch & Englisch"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "Du kannst deutsche und englische Videos nutzen. CleverPenMan.com ist optimiert, um die Nuancen der deutschen Sprache abzubilden. Mehr als nur Duzen oder Siezen."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex items-start font-montserrat my-6 mr-10",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                        src: (parcelRequire("akrcu")),
                                        alt: "heart icon",
                                        className: "h-7 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                                className: "font-semibold text-2xl",
                                                children: "Individuell wie deine Inhalte"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "Nutze die Ausdrucksweise des Videos oder w\xe4hle einen von CleverPenMans verschiedenen Schreibstilen zur Auswahl. Somit passt der Inhalt zu deiner Kommunikationsart."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex items-start font-montserrat my-6 mr-10",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                        src: (parcelRequire("akrcu")),
                                        alt: "heart icon",
                                        className: "h-7 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                                className: "font-semibold text-2xl",
                                                children: "Einfaches Exportieren"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "Den erstellten Text kannst du einfach exportieren. Per Text, HTML oder Markdown kannst du ihn dann in Wordpress, Social Media oder jedem beliebigen CMS ver\xf6ffentlichen."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex items-start font-montserrat my-6 mr-10",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                        src: (parcelRequire("akrcu")),
                                        alt: "heart icon",
                                        className: "h-7 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                                className: "font-semibold text-2xl",
                                                children: "Schnell und Effektiv"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "Es dauert nur wenige Minuten bis zu einem fertigen Artikel. Somit kannst du mehr Content ver\xf6ffentlichen."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                id: "blog-articles",
                className: "bg-black text-white sectionSize",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                            className: "secondaryTitle bg-underline3W p-12 mb-0 bg-center bg-100%",
                            children: "Unser Blog"
                        })
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 p-4",
                        children: $7da27bfd17cda4c8$var$BLOG_ARTICLES.map((article, index)=>/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "bg-gray-800 rounded-lg shadow-md overflow-hidden",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    className: "p-4 text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                            to: article.link,
                                            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                                className: "font-montserrat font-bold text-lg mb-2",
                                                children: article.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                            className: "font-montserrat text-sm font-extralight mb-4",
                                            children: article.date.toLocaleDateString("de-DE", {
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                            className: "font-montserrat text-sm font-extralight mb-4",
                                            children: article.excerpt
                                        }),
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                            to: article.link,
                                            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                                className: "w-full h-48 object-cover rounded-lg",
                                                src: article.thumbnail.href,
                                                alt: article.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                            to: article.link,
                                            className: "inline-block bg-black px-6 py-2 rounded-lg border-2 border-black border-solid text-white mr-2 mt-2 mb-2",
                                            children: "Weiterlesen"
                                        })
                                    ]
                                })
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                id: "pricing",
                className: "sectionSize bg-secondary !pb-0 pt-2",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                            className: "secondaryTitle bg-underline3 mb-0 bg-100%",
                            children: "Pricing"
                        })
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "flex w-full flex-col md:flex-row",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex-1 flex flex-col mx-6 shadow-2xl relative bg-secondary rounded-2xl py-5 px-8 my-8 md:top-24",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                        className: "font-pt-serif font-normal text-2xl mb-4",
                                        children: "10 Artikel"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "font-montserrat font-bold text-2xl mb-4",
                                        children: [
                                            "\u20AC 0,75",
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("span", {
                                                className: "font-normal text-base",
                                                children: " / Artikel"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                                src: (parcelRequire("GHvYx")),
                                                alt: "checkbox",
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "G\xfcltig f\xfcr ein Jahr"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                                src: (parcelRequire("GHvYx")),
                                                alt: "",
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "Zuk\xfcnftigen Features nutzen"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                                src: (parcelRequire("GHvYx")),
                                                alt: "checkbox",
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "Support per E-Mail"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                                        className: "border-2 border-solid border-black rounded-xl text-lg py-3 mt-4 text-center",
                                        href: "https://buy.cleverpenman.com/b/DMWUY",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                            children: "W\xe4hlen"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex-1 flex flex-col mx-6 shadow-2xl relative bg-secondary rounded-2xl py-5 px-8 my-8 md:top-12",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                        className: "font-pt-serif font-normal text-2xl mb-4",
                                        children: "100 Artikel"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "font-montserrat font-bold text-2xl mb-4",
                                        children: [
                                            "\u20AC 0,49",
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("span", {
                                                className: "font-normal text-base",
                                                children: " / Artikel"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                                src: (parcelRequire("GHvYx")),
                                                alt: "",
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "Kein Verfall des Guthabens"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                                src: (parcelRequire("GHvYx")),
                                                alt: "",
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "Zuk\xfcnftige Features nutzen"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                                                src: (parcelRequire("GHvYx")),
                                                alt: "",
                                                className: "mr-1"
                                            }),
                                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                                children: "E-Mail & Telefon-Support"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                                        className: "border-2 border-solid border-black rounded-xl text-lg py-3 mt-4 text-center",
                                        href: "https://buy.cleverpenman.com/b/1iZP9",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                            children: "W\xe4hlen"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex-1 flex flex-col mx-6 shadow-2xl relative bg-secondary rounded-2xl py-5 px-8 my-8 md:top-24",
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                                        className: "font-pt-serif font-normal text-2xl mb-4",
                                        children: "Ab 1.000 Artikel"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "font-montserrat font-bold text-2xl mb-4",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("span", {
                                            className: "font-normal text-base",
                                            children: " Auf Anfrage"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                                            children: [
                                                "Nimm gerne Kontakt zu uns auf, damit wir die passende L\xf6sung f\xfcr deinen Bedarf finden k\xf6nnen.",
                                                " "
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                                        className: "border-2 border-solid border-black rounded-xl text-lg py-3 mt-4 text-center",
                                        href: "mailto:cleverpenman@dock51.de",
                                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("button", {
                                            children: "Kontakt"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                id: "faq",
                className: "sectionSize items-start pt-8 md:pt-36 bg-black text-white",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                            className: "secondaryTitle bg-highlight3 p-12 mb-0 bg-center bg-100%",
                            children: "FAQ"
                        })
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "w-full py-4",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex justify-between items-center",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    className: "font-montserrat font-bold mr-auto",
                                    children: "Kann ich jedes Video nutzen?"
                                })
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "font-montserrat text-sm font-extralight pb-1 ",
                                children: "Jedes Video auf YouTube in Deutscher oder Englischer Sprache kann genutzt werden. Am besten eignen sich Videos zwischen zwei und 15 Minuten."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("hr", {
                        className: "w-full bg-white"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "w-full py-4",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex justify-between items-center",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    className: "font-montserrat font-bold mr-auto",
                                    children: "Wof\xfcr kann ich den generierten Text nutzen?"
                                })
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "font-montserrat text-sm font-extralight pb-1 ",
                                children: "Der Anwendungsbereich ist gro\xdf. Bisher wird unser Tool vor allem f\xfcr SEO-Blogs und Portale f\xfcr Mitarbeitende genutzt. Auch das Erstellen von (technischen) Dokumentationen ist m\xf6glich."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("hr", {
                        className: "w-full bg-white"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                        className: "w-full py-4",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "flex justify-between items-center",
                                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                    className: "font-montserrat font-bold mr-auto",
                                    children: "Wie wird die Qualit\xe4t der Texte sichergestellt?"
                                })
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                                className: "font-montserrat text-sm font-extralight pb-1 ",
                                children: "Wir nutzen die besten Sprachmodelle auf dem Markt und bringen viel Erfahrung in Marketing und AI mit. Wir haben durch viele Testl\xe4ufe die Qualit\xe4t der Ergebnisse stets verbessert. Eine Garantie f\xfcr die Korrektheit der Texte kann allerdings nicht \xfcbernommen werden. Wir empfehlen daher die generierten Text auf Korrektheit zu pr\xfcfen."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





function $99c9ea1b9e2721c5$export$31641b61980e511f() {
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "flex flex-col items-center justify-center h-screen text-center bg-gray-100 text-gray-800",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h1", {
                className: "text-3xl font-bold mb-4",
                children: "Oh, da ist etwas schief gelaufen!"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
                className: "text-lg",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        children: "Diese Seite existiert leider nicht."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "text-blue-500 hover:underline",
                        children: "Zur\xfcck auf Start"
                    }),
                    " "
                ]
            })
        ]
    });
}




const $5d58930556305cc2$export$c1a5d0087f8230c1 = ()=>{
    (0, $a70cf465074cab30$export$6d9c69b0de29b591)(()=>{
        // Scroll to the top when the component mounts
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "max-w-4xl mx-auto p-6",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h1", {
                className: "text-4xl font-bold mb-6",
                children: "Wie man aus einem Video einen Blog-Artikel generiert"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                        className: "text-3xl font-semibold mb-4",
                        children: "Einleitung: Warum man Videos in Blog-Artikel umwandeln sollte"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        className: "mb-4",
                        children: "In der heutigen digitalen Welt sind Videos ein kraftvolles Medium, um Informationen zu teilen und ein breites Publikum zu erreichen. Aber warum sollte man die M\xfche auf sich nehmen, ein Video in einen Blog-Artikel zu verwandeln? Die Antwort liegt in den vielf\xe4ltigen Anwendungsbeispielen, die sich daraus ergeben."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        className: "mb-4",
                        children: "Erstens, SEO: Suchmaschinen bevorzugen Textinhalte, die sie analysieren und indexieren k\xf6nnen. Ein gut geschriebener Blog-Artikel erh\xf6ht die Sichtbarkeit Ihrer Inhalte in Suchmaschinen und lockt mehr Besucher auf Ihre Website."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        className: "mb-4",
                        children: "Zweitens, Mitarbeiter-Schulungen: Unternehmen nutzen oft Videos f\xfcr Schulungen und Fortbildungen. Ein begleitender Blog-Artikel kann das vermittelte Wissen festigen und als Nachschlagewerk dienen."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        className: "mb-4",
                        children: "Drittens, technische Dokumentation: Entwickler und Techniker erstellen oft Video-Tutorials. Diese in schriftlicher Form zu haben, erleichtert die Dokumentation und das Nachvollziehen komplexer Prozesse."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        className: "mb-4",
                        children: "Weitere Beispiele sind die Erg\xe4nzung von Video-Inhalten f\xfcr Social Media, E-Learning-Kurse oder die Erstellung von Marketing-Materialien. Durch die Umwandlung von Videos in Blog-Artikel erweitern Sie die Reichweite und Nutzbarkeit Ihrer Inhalte erheblich."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                        className: "text-3xl font-semibold mb-4",
                        children: "Vorgehensweise 1: Der einfache Weg mit CleverPenMan.com"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ol", {
                        className: "list-decimal list-inside mb-4",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Video-Link kopieren: Kopieren Sie den Link zu dem YouTube-Video, das Sie in einen Blog-Artikel umwandeln m\xf6chten."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Link einf\xfcgen: F\xfcgen Sie den kopierten Link in [CleverPenMan.com](https://cleverpenman.com/)."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Einstellungen anpassen: Passen Sie die Einstellungen nach Ihren W\xfcnschen an. M\xf6chten Sie genderneutrale Sprache verwenden? Sollen die Leser geduzt oder gesiezt werden? All diese Optionen k\xf6nnen Sie mit wenigen Klicks einstellen."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: 'Fertig: Klicken Sie auf "Generieren" und in wenigen Sekunden haben Sie einen fertigen Blog-Artikel, der Ihren Anforderungen entspricht.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        className: "mb-4",
                        children: "Mit CleverPenMan.com sparen Sie Zeit und M\xfche, w\xe4hrend Sie qualitativ hochwertige Artikel erhalten."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                        className: "text-3xl font-semibold mb-4",
                        children: "Vorgehensweise 2: Der manuelle Weg"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ol", {
                        className: "list-decimal list-inside mb-4",
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Video-Transkript herunterladen: Nutzen Sie YouTube oder andere Tools, um das Transkript des Videos herunterzuladen."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Transkript bereinigen: Entfernen Sie \xfcberfl\xfcssige W\xf6rter, F\xfcllw\xf6rter und Fehler, um ein sauberes Transkript zu erhalten."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Chat-GPT Account anlegen: Melden Sie sich bei Chat-GPT an, falls Sie noch keinen Account haben."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Konversation starten: Starten Sie eine Konversation mit Chat-GPT und geben Sie das bereinigte Transkript als Ausgangspunkt ein."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Erste Fassung erstellen: Arbeiten Sie mit Chat-GPT zusammen, um aus dem Transkript die erste Fassung des Blog-Artikels zu erstellen. Stellen Sie dabei sicher, dass die Struktur und der Inhalt den Anforderungen entsprechen."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "\xdcberarbeiten und verfeinern: Lesen Sie den erstellten Artikel sorgf\xe4ltig durch und nehmen Sie Korrekturen vor. F\xfcgen Sie zus\xe4tzliche Informationen hinzu und passen Sie den Text an, um sicherzustellen, dass er Ihre Anforderungen erf\xfcllt."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Formatierung: Formatieren Sie den Artikel, um sicherzustellen, dass er leicht lesbar ist und den Stilrichtlinien Ihres Blogs entspricht."
                            }),
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                className: "mb-2",
                                children: "Endg\xfcltige Pr\xfcfung: F\xfchren Sie eine abschlie\xdfende Pr\xfcfung durch, um Rechtschreib- und Grammatikfehler zu beseitigen."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        className: "mb-4",
                        children: "Der manuelle Weg ist zeitaufwendig und erfordert mehr Arbeit, kann aber dennoch zu guten Ergebnissen f\xfchren."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("section", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                        className: "text-3xl font-semibold mb-4",
                        children: "Fazit: CleverPenMan.com ist der klare Sieger"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                        className: "mb-4",
                        children: "Obwohl der manuelle Weg funktioniert, ist CleverPenMan.com eindeutig der effizientere und benutzerfreundlichere Weg, um aus einem Video einen Blog-Artikel zu generieren. Mit wenigen Klicks und minimalem Aufwand erhalten Sie einen professionellen, gut geschriebenen Artikel, der sofort einsatzbereit ist. Sparen Sie Zeit und Ressourcen und nutzen Sie CleverPenMan.com, um Ihre Video-Inhalte optimal zu verwerten."
                    })
                ]
            })
        ]
    });
};


const $e900c93c1685e091$export$7f5e6e4a87406c9c = [
    {
        url: "/articles/wie-man-aus-einem-video-einen-blog-artikel-generiert",
        component: (0, $5d58930556305cc2$export$c1a5d0087f8230c1)
    }
];





const $5955c39aa569b1c2$export$ca08d3cf8fdcd9c5 = ()=>{
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "max-w-4xl mx-auto p-6",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h1", {
                className: "text-4xl font-bold mb-6",
                children: "Impressum"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Angaben gem. \xa7 5 TMG:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "dock51 UG (haftungsbeschr\xe4nkt)",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Eichendorffstr. 38",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "24116 Kiel Deutschland"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Handelsregister"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Registergericht: Kiel",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Registernummer: 15611"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Vertreten durch:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Jannis Rosenbaum"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Kontakt"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "E-Mail: impressum <\xe4t> dock51.de"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Umsatzsteuer-ID"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Umsatzsteuer-Identifikationsnummer gem\xe4\xdf \xa727a: DE293802716"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Redaktionell verantwortlich"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Jannis Rosenbaum",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Eichendorffstr. 38",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    " 24116 Kiel"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Online-Streitbeilegung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Plattform der EU-Kommission zur Online-Streitbeilegung:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("a", {
                        href: "https://www.ec.europa.eu/consumers/odr",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "https://www.ec.europa.eu/consumers/odr"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Haftungsausschluss:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                className: "text-xl mt-4",
                children: "Haftung f\xfcr Inhalte"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Alle Inhalte unseres Internetauftritts wurden mit gr\xf6\xdfter Sorgfalt und nach bestem Gewissen erstellt. F\xfcr die Richtigkeit, Vollst\xe4ndigkeit und Aktualit\xe4t der Inhalte k\xf6nnen wir jedoch keine Gew\xe4hr \xfcbernehmen. Als Diensteanbieter sind wir gem\xe4\xdf \xa7 7 Abs.1 TMG f\xfcr eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach \xa7\xa7 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, \xfcbermittelte oder gespeicherte fremde Informationen zu \xfcberwachen oder nach Umst\xe4nden zu forschen, die auf eine rechtswidrige T\xe4tigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber\xfchrt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Eine diesbez\xfcgliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntniserlangung einer konkreten Rechtsverletzung m\xf6glich. Bei Bekanntwerden von den o.g. Rechtsverletzungen werden wir diese Inhalte unverz\xfcglich entfernen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h3", {
                className: "text-xl mt-4",
                children: "Haftungsbeschr\xe4nkung f\xfcr externe Links"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Unsere Webseite enth\xe4lt Links auf externe Webseiten Dritter. Auf die Inhalte dieser direkt oder indirekt verlinkten Webseiten haben wir keinen Einfluss. Daher k\xf6nnen wir f\xfcr die \u201Eexternen Links\u201C auch keine Gew\xe4hr auf Richtigkeit der Inhalte \xfcbernehmen. F\xfcr die Inhalte der externen Links sind die jeweilige Anbieter oder Betreiber (Urheber) der Seiten verantwortlich."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die externen Links wurden zum Zeitpunkt der Linksetzung auf eventuelle Rechtsverst\xf6\xdfe \xfcberpr\xfcft und waren im Zeitpunkt der Linksetzung frei von rechtswidrigen Inhalten. Eine st\xe4ndige inhaltliche \xdcberpr\xfcfung der externen Links ist ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht m\xf6glich. Bei direkten oder indirekten Verlinkungen auf die Webseiten Dritter, die au\xdferhalb unseres Verantwortungsbereichs liegen, w\xfcrde eine Haftungsverpflichtung ausschlie\xdflich in dem Fall nur bestehen, wenn wir von den Inhalten Kenntnis erlangen und es uns technisch m\xf6glich und zumutbar w\xe4re, die Nutzung im Falle rechtswidriger Inhalte zu verhindern."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    'Diese Haftungsausschlusserkl\xe4rung gilt auch innerhalb des eigenen Internetauftrittes "cleverpenman.com\u201C gesetzten Links und Verweise von Fragestellern, Blogeintr\xe4gern, G\xe4sten des Diskussionsforums. F\xfcr illegale, fehlerhafte oder unvollst\xe4ndige Inhalte und insbesondere f\xfcr Sch\xe4den, die aus der Nutzung oder Nichtnutzung solcherart dargestellten Informationen entstehen, haftet allein der Diensteanbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der \xfcber Links auf die jeweilige Ver\xf6ffentlichung lediglich verweist.',
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Werden uns Rechtsverletzungen bekannt, werden die externen Links durch uns unverz\xfcglich entfernt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Urheberrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die auf unserer Webseite ver\xf6ffentlichen Inhalte und Werke unterliegen dem deutschen Urheberrecht (http://www.gesetze-im-internet.de/bundesrecht/urhg/gesamt.pdf). Die Vervielf\xe4ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung des geistigen Eigentums in ideeller und materieller Sicht des Urhebers au\xdferhalb der Grenzen des Urheberrechtes bed\xfcrfen der vorherigen schriftlichen Zustimmung des jeweiligen Urhebers i.S.d. Urhebergesetzes (http://www.gesetze-im-internet.de/bundesrecht/urhg/gesamt.pdf). Downloads und Kopien dieser Seite sind nur f\xfcr den privaten und nicht kommerziellen Gebrauch erlaubt. Sind die Inhalte auf unserer Webseite nicht von uns erstellt wurden, sind die Urheberrechte Dritter zu beachten. Die Inhalte Dritter werden als solche kenntlich gemacht. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte unverz\xfcglich entfernen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Dieses Impressum wurde freundlicherweise von",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        target: "_blank",
                        to: "https://jurarat.de/muster-impressum",
                        children: "jurarat.de"
                    }),
                    " ",
                    "zur Verf\xfcgung gestellt."
                ]
            })
        ]
    });
};
var $5955c39aa569b1c2$export$2e2bcd8739ae039 = $5955c39aa569b1c2$export$ca08d3cf8fdcd9c5;





const $bb1c4bdf1bacd325$export$f7160926399b30c7 = ()=>{
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("div", {
        className: "max-w-4xl mx-auto p-6",
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h1", {
                className: "text-4xl font-bold mb-6",
                children: "Datenschutz"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "einleitung-ueberblick",
                children: "Einleitung und \xdcberblick"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wir haben diese Datenschutzerkl\xe4rung (Fassung 29.01.2023) verfasst, um Ihnen gem\xe4\xdf der Vorgaben der",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=312394123#d1e2269-1-1",
                        target: "_blank",
                        rel: "noopener",
                        children: "Datenschutz-Grundverordnung (EU) 2016/679"
                    }),
                    " ",
                    "und anwendbaren nationalen Gesetzen zu erkl\xe4ren, welche personenbezogenen Daten (kurz Daten) wir als Verantwortliche \u2013 und die von uns beauftragten Auftragsverarbeiter (z. B. Provider) \u2013 verarbeiten, zuk\xfcnftig verarbeiten werden und welche rechtm\xe4\xdfigen M\xf6glichkeiten Sie haben. Die verwendeten Begriffe sind geschlechtsneutral zu verstehen."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Kurz gesagt:"
                    }),
                    " Wir informieren Sie umfassend \xfcber Daten, die wir \xfcber Sie verarbeiten."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Datenschutzerkl\xe4rungen klingen f\xfcr gew\xf6hnlich sehr technisch und verwenden juristische Fachbegriffe. Diese Datenschutzerkl\xe4rung soll Ihnen hingegen die wichtigsten Dinge so einfach und transparent wie m\xf6glich beschreiben. Soweit es der Transparenz f\xf6rderlich ist, werden technische ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Begriffe leserfreundlich erkl\xe4rt"
                    }),
                    ", Links zu weiterf\xfchrenden Informationen geboten und ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Grafiken"
                    }),
                    " zum Einsatz gebracht. Wir informieren damit in klarer und einfacher Sprache, dass wir im Rahmen unserer Gesch\xe4ftst\xe4tigkeiten nur dann personenbezogene Daten verarbeiten, wenn eine entsprechende gesetzliche Grundlage gegeben ist. Das ist sicher nicht m\xf6glich, wenn man m\xf6glichst knappe, unklare und juristisch-technische Erkl\xe4rungen abgibt, so wie sie im Internet oft Standard sind, wenn es um Datenschutz geht. Ich hoffe, Sie finden die folgenden Erl\xe4uterungen interessant und informativ und vielleicht ist die eine oder andere Information dabei, die Sie noch nicht kannten.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Wenn trotzdem Fragen bleiben, m\xf6chten wir Sie bitten, sich an die unten bzw. im",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "/impressum",
                        "data-v-f58a9f50": true,
                        children: [
                            " ",
                            "Impressum"
                        ]
                    }),
                    " ",
                    "genannte verantwortliche Stelle zu wenden, den vorhandenen Links zu folgen und sich weitere Informationen auf Drittseiten durchzulesen. Unsere Kontaktdaten finden Sie selbstverst\xe4ndlich auch im",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "/impressum",
                        "data-v-f58a9f50": true,
                        children: "Impressum"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "anwendungsbereich",
                children: "Anwendungsbereich"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Diese Datenschutzerkl\xe4rung gilt f\xfcr alle von uns im Unternehmen verarbeiteten personenbezogenen Daten und f\xfcr alle personenbezogenen Daten, die von uns beauftragte Firmen (Auftragsverarbeiter) verarbeiten. Mit personenbezogenen Daten meinen wir Informationen im Sinne des Art. 4 Nr. 1 DSGVO wie zum Beispiel Name, E-Mail-Adresse und postalische Anschrift einer Person. Die Verarbeitung personenbezogener Daten sorgt daf\xfcr, dass wir unsere Dienstleistungen und Produkte anbieten und abrechnen k\xf6nnen, sei es online oder offline. Der Anwendungsbereich dieser Datenschutzerkl\xe4rung umfasst:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "alle Onlineauftritte (Websites, Onlineshops), die wir betreiben"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Social Media Auftritte und E-Mail-Kommunikation"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "mobile Apps f\xfcr Smartphones und andere Ger\xe4te"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Kurz gesagt:"
                    }),
                    " Die Datenschutzerkl\xe4rung gilt f\xfcr alle Bereiche, in denen personenbezogene Daten im Unternehmen \xfcber die genannten Kan\xe4le strukturiert verarbeitet werden. Sollten wir au\xdferhalb dieser Kan\xe4le mit Ihnen in Rechtsbeziehungen eintreten, werden wir Sie gegebenenfalls gesondert informieren."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "rechtsgrundlagen",
                children: "Rechtsgrundlagen"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "In der folgenden Datenschutzerkl\xe4rung geben wir Ihnen transparente Informationen zu den rechtlichen Grunds\xe4tzen und Vorschriften, also den Rechtsgrundlagen der Datenschutz-Grundverordnung, die uns erm\xf6glichen, personenbezogene Daten zu verarbeiten.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Was das EU-Recht betrifft, beziehen wir uns auf die VERORDNUNG (EU) 2016/679 DES EUROP\xc4ISCHEN PARLAMENTS UND DES RATES vom 27. April 2016. Diese Datenschutz-Grundverordnung der EU k\xf6nnen Sie selbstverst\xe4ndlich online auf EUR-Lex, dem Zugang zum EU-Recht, unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679",
                        children: "https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679"
                    }),
                    " ",
                    "nachlesen."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir verarbeiten Ihre Daten nur, wenn mindestens eine der folgenden Bedingungen zutrifft:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ol", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "Einwilligung"
                            }),
                            " (Artikel 6 Absatz 1 lit. a DSGVO): Sie haben uns Ihre Einwilligung gegeben, Daten zu einem bestimmten Zweck zu verarbeiten. Ein Beispiel w\xe4re die Speicherung Ihrer eingegebenen Daten eines Kontaktformulars."
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "Vertrag"
                            }),
                            " (Artikel 6 Absatz 1 lit. b DSGVO): Um einen Vertrag oder vorvertragliche Verpflichtungen mit Ihnen zu erf\xfcllen, verarbeiten wir Ihre Daten. Wenn wir zum Beispiel einen Kaufvertrag mit Ihnen abschlie\xdfen, ben\xf6tigen wir vorab personenbezogene Informationen."
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "Rechtliche Verpflichtung"
                            }),
                            " (Artikel 6 Absatz 1 lit. c DSGVO): Wenn wir einer rechtlichen Verpflichtung unterliegen, verarbeiten wir Ihre Daten. Zum Beispiel sind wir gesetzlich verpflichtet Rechnungen f\xfcr die Buchhaltung aufzuheben. Diese enthalten in der Regel personenbezogene Daten."
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "Berechtigte Interessen"
                            }),
                            " (Artikel 6 Absatz 1 lit. f DSGVO): Im Falle berechtigter Interessen, die Ihre Grundrechte nicht einschr\xe4nken, behalten wir uns die Verarbeitung personenbezogener Daten vor. Wir m\xfcssen zum Beispiel gewisse Daten verarbeiten, um unsere Website sicher und wirtschaftlich effizient betreiben zu k\xf6nnen. Diese Verarbeitung ist somit ein berechtigtes Interesse."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Weitere Bedingungen wie die Wahrnehmung von Aufnahmen im \xf6ffentlichen Interesse und Aus\xfcbung \xf6ffentlicher Gewalt sowie dem Schutz lebenswichtiger Interessen treten bei uns in der Regel nicht auf. Soweit eine solche Rechtsgrundlage doch einschl\xe4gig sein sollte, wird diese an der entsprechenden Stelle ausgewiesen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Zus\xe4tzlich zu der EU-Verordnung gelten auch noch nationale Gesetze:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            "In ",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "\xd6sterreich"
                            }),
                            " ist dies das Bundesgesetz zum Schutz nat\xfcrlicher Personen bei der Verarbeitung personenbezogener Daten (",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "Datenschutzgesetz"
                            }),
                            "), kurz ",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "DSG"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            "In ",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "Deutschland"
                            }),
                            " gilt das",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: "Bundesdatenschutzgesetz"
                            }),
                            ", kurz",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                children: " BDSG"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sofern weitere regionale oder nationale Gesetze zur Anwendung kommen, informieren wir Sie in den folgenden Abschnitten dar\xfcber."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "kontaktdaten-verantwortliche",
                children: "Kontaktdaten des Verantwortlichen"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sollten Sie Fragen zum Datenschutz oder zur Verarbeitung personenbezogener Daten haben, finden Sie nachfolgend die Kontaktdaten der verantwortlichen Person bzw. Stelle:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                className: "mt-2",
                children: "Jannis Rosenbaum"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "dock51 UG (haftungsbeschr\xe4nkt)",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Eichendorffstr. 38",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "24116 Kiel Deutschland"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "E-Mail: impressum <\xe4t> dock51.de "
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Impressum:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "/impressum",
                        "data-v-f58a9f50": true,
                        children: "Zum Impressum"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "speicherdauer",
                children: "Speicherdauer"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Dass wir personenbezogene Daten nur so lange speichern, wie es f\xfcr die Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig ist, gilt als generelles Kriterium bei uns. Das bedeutet, dass wir personenbezogene Daten l\xf6schen, sobald der Grund f\xfcr die Datenverarbeitung nicht mehr vorhanden ist. In einigen F\xe4llen sind wir gesetzlich dazu verpflichtet, bestimmte Daten auch nach Wegfall des urspr\xfcngliches Zwecks zu speichern, zum Beispiel zu Zwecken der Buchf\xfchrung."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sollten Sie die L\xf6schung Ihrer Daten w\xfcnschen oder die Einwilligung zur Datenverarbeitung widerrufen, werden die Daten so rasch wie m\xf6glich und soweit keine Pflicht zur Speicherung besteht, gel\xf6scht."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "\xdcber die konkrete Dauer der jeweiligen Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere Informationen dazu haben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "rechte-dsgvo",
                children: "Rechte laut Datenschutz-Grundverordnung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Gem\xe4\xdf Artikel 13, 14 DSGVO informieren wir Sie \xfcber die folgenden Rechte, die Ihnen zustehen, damit es zu einer fairen und transparenten Verarbeitung von Daten kommt:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            "Sie haben laut Artikel 15 DSGVO ein Auskunftsrecht dar\xfcber, ob wir Daten von Ihnen verarbeiten. Sollte das zutreffen, haben Sie Recht darauf eine Kopie der Daten zu erhalten und die folgenden Informationen zu erfahren:",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "zu welchem Zweck wir die Verarbeitung durchf\xfchren;"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "die Kategorien, also die Arten von Daten, die verarbeitet werden;"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "wer diese Daten erh\xe4lt und wenn die Daten an Drittl\xe4nder \xfcbermittelt werden, wie die Sicherheit garantiert werden kann;"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "wie lange die Daten gespeichert werden;"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "das Bestehen des Rechts auf Berichtigung, L\xf6schung oder Einschr\xe4nkung der Verarbeitung und dem Widerspruchsrecht gegen die Verarbeitung;"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "dass Sie sich bei einer Aufsichtsbeh\xf6rde beschweren k\xf6nnen (Links zu diesen Beh\xf6rden finden Sie weiter unten);"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "die Herkunft der Daten, wenn wir sie nicht bei Ihnen erhoben haben;"
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "ob Profiling durchgef\xfchrt wird, ob also Daten automatisch ausgewertet werden, um zu einem pers\xf6nlichen Profil von Ihnen zu gelangen."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Sie haben laut Artikel 16 DSGVO ein Recht auf Berichtigung der Daten, was bedeutet, dass wir Daten richtig stellen m\xfcssen, falls Sie Fehler finden."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Sie haben laut Artikel 17 DSGVO das Recht auf L\xf6schung (\u201ERecht auf Vergessenwerden\u201C), was konkret bedeutet, dass Sie die L\xf6schung Ihrer Daten verlangen d\xfcrfen."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Sie haben laut Artikel 18 DSGVO das Recht auf Einschr\xe4nkung der Verarbeitung, was bedeutet, dass wir die Daten nur mehr speichern d\xfcrfen aber nicht weiter verwenden."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Sie haben laut Artikel 20 DSGVO das Recht auf Daten\xfcbertragbarkeit, was bedeutet, dass wir Ihnen auf Anfrage Ihre Daten in einem g\xe4ngigen Format zur Verf\xfcgung stellen."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            "Sie haben laut Artikel 21 DSGVO ein Widerspruchsrecht, welches nach Durchsetzung eine \xc4nderung der Verarbeitung mit sich bringt.",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "Wenn die Verarbeitung Ihrer Daten auf Artikel 6 Abs. 1 lit. e (\xf6ffentliches Interesse, Aus\xfcbung \xf6ffentlicher Gewalt) oder Artikel 6 Abs. 1 lit. f (berechtigtes Interesse) basiert, k\xf6nnen Sie gegen die Verarbeitung Widerspruch einlegen. Wir pr\xfcfen danach so rasch wie m\xf6glich, ob wir diesem Widerspruch rechtlich nachkommen k\xf6nnen."
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "Werden Daten verwendet, um Direktwerbung zu betreiben, k\xf6nnen Sie jederzeit gegen diese Art der Datenverarbeitung widersprechen. Wir d\xfcrfen Ihre Daten danach nicht mehr f\xfcr Direktmarketing verwenden."
                                    }),
                                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                                        children: "Werden Daten verwendet, um Profiling zu betreiben, k\xf6nnen Sie jederzeit gegen diese Art der Datenverarbeitung widersprechen. Wir d\xfcrfen Ihre Daten danach nicht mehr f\xfcr Profiling verwenden."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Sie haben laut Artikel 22 DSGVO unter Umst\xe4nden das Recht, nicht einer ausschlie\xdflich auf einer automatisierten Verarbeitung (zum Beispiel Profiling) beruhenden Entscheidung unterworfen zu werden."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Sie haben laut Artikel 77 DSGVO das Recht auf Beschwerde. Das hei\xdft, Sie k\xf6nnen sich jederzeit bei der Datenschutzbeh\xf6rde beschweren, wenn Sie der Meinung sind, dass die Datenverarbeitung von personenbezogenen Daten gegen die DSGVO verst\xf6\xdft."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {}),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verst\xf6\xdft oder Ihre datenschutzrechtlichen Anspr\xfcche in sonst einer Weise verletzt worden sind, k\xf6nnen Sie sich bei der Aufsichtsbeh\xf6rde beschweren. Diese ist f\xfcr \xd6sterreich die Datenschutzbeh\xf6rde, deren Website Sie unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.dsb.gv.at/?tid=312394123",
                        target: "_blank",
                        rel: "noopener",
                        children: "https://www.dsb.gv.at/"
                    }),
                    " ",
                    "finden. In Deutschland gibt es f\xfcr jedes Bundesland einen Datenschutzbeauftragten. F\xfcr n\xe4here Informationen k\xf6nnen Sie sich an die",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.bfdi.bund.de/DE/Home/home_node.html",
                        target: "_blank",
                        rel: "noopener",
                        children: "Bundesbeauftragte f\xfcr den Datenschutz und die Informationsfreiheit (BfDI)"
                    }),
                    " ",
                    "wenden. F\xfcr unser Unternehmen ist die folgende lokale Datenschutzbeh\xf6rde zust\xe4ndig:"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "bremen-datenschutzbehoerde",
                children: "Die Landesbeauftragte f\xfcr Datenschutz und Informationsfreiheit der Freien Hansestadt Bremen"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Adresse: "
                    }),
                    "Arndtstra\xdfe 1, 27570 Bremerhaven",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Telefonnr.:"
                    }),
                    "+49 0421 361 2010",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "E-Mail-Adresse:"
                    }),
                    "office@datenschutz.bremen.de",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Website: "
                    }),
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.datenschutz.bremen.de/",
                        target: "_blank",
                        rel: "noopener",
                        children: "https://www.datenschutz.bremen.de/"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "datenuebertragung-drittlaender",
                children: "Daten\xfcbertragung in Drittl\xe4nder"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir \xfcbertragen oder verarbeiten Daten nur dann in L\xe4nder au\xdferhalb der EU (Drittl\xe4nder), wenn Sie dieser Verarbeitung zustimmen, dies gesetzlich vorgeschrieben ist oder vertraglich notwendig und in jedem Fall nur soweit dies generell erlaubt ist. Ihre Zustimmung ist in den meisten F\xe4llen der wichtigste Grund, dass wir Daten in Drittl\xe4ndern verarbeiten lassen. Die Verarbeitung personenbezogener Daten in Drittl\xe4ndern wie den USA, wo viele Softwarehersteller Dienstleistungen anbieten und Ihre Serverstandorte haben, kann bedeuten, dass personenbezogene Daten auf unerwartete Weise verarbeitet und gespeichert werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir weisen ausdr\xfccklich darauf hin, dass nach Meinung des Europ\xe4ischen Gerichtshofs derzeit kein angemessenes Schutzniveau f\xfcr den Datentransfer in die USA besteht. Die Datenverarbeitung durch US-Dienste (wie beispielsweise Google Analytics) kann dazu f\xfchren, dass gegebenenfalls Daten nicht anonymisiert verarbeitet und gespeichert werden. Ferner k\xf6nnen gegebenenfalls US-amerikanische staatliche Beh\xf6rden Zugriff auf einzelne Daten nehmen. Zudem kann es vorkommen, dass erhobene Daten mit Daten aus anderen Diensten desselben Anbieters, sofern Sie ein entsprechendes Nutzerkonto haben, verkn\xfcpft werden. Nach M\xf6glichkeit versuchen wir Serverstandorte innerhalb der EU zu nutzen, sofern das angeboten wird."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir informieren Sie an den passenden Stellen dieser Datenschutzerkl\xe4rung genauer \xfcber Daten\xfcbertragung in Drittl\xe4nder, sofern diese zutrifft."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "sicherheit-datenverarbeitung",
                children: "Sicherheit der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Um personenbezogene Daten zu sch\xfctzen, haben wir sowohl technische als auch organisatorische Ma\xdfnahmen umgesetzt. Wo es uns m\xf6glich ist, verschl\xfcsseln oder pseudonymisieren wir personenbezogene Daten. Dadurch machen wir es im Rahmen unserer M\xf6glichkeiten so schwer wie m\xf6glich, dass Dritte aus unseren Daten auf pers\xf6nliche Informationen schlie\xdfen k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Art. 25 DSGVO spricht hier von \u201CDatenschutz durch Technikgestaltung und durch datenschutzfreundliche Voreinstellungen\u201D und meint damit, dass man sowohl bei Software (z. B. Formularen) also auch Hardware (z. B. Zugang zum Serverraum) immer an Sicherheit denkt und entsprechende Ma\xdfnahmen setzt. Im Folgenden gehen wir, falls erforderlich, noch auf konkrete Ma\xdfnahmen ein."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "tls-verschluesselung-https",
                children: "TLS-Verschl\xfcsselung mit https"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "TLS, Verschl\xfcsselung und https klingen sehr technisch und sind es auch. Wir verwenden HTTPS (das Hypertext Transfer Protocol Secure steht f\xfcr \u201Esicheres Hypertext-\xdcbertragungsprotokoll\u201C), um Daten abh\xf6rsicher im Internet zu \xfcbertragen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Das bedeutet, dass die komplette \xdcbertragung aller Daten von Ihrem Browser zu unserem Webserver abgesichert ist \u2013 niemand kann \u201Cmith\xf6ren\u201D."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Damit haben wir eine zus\xe4tzliche Sicherheitsschicht eingef\xfchrt und erf\xfcllen den Datenschutz durch Technikgestaltung (",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=312394123",
                        target: "_blank",
                        rel: "noopener",
                        children: "Artikel 25 Absatz 1 DSGVO"
                    }),
                    " ",
                    "). Durch den Einsatz von TLS (Transport Layer Security), einem Verschl\xfcsselungsprotokoll zur sicheren Daten\xfcbertragung im Internet, k\xf6nnen wir den Schutz vertraulicher Daten sicherstellen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Sie erkennen die Benutzung dieser Absicherung der Daten\xfcbertragung am kleinen Schlosssymbol",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                        role: "img",
                        src: "https://www.adsimple.at/wp-content/uploads/2018/03/schlosssymbol-https.svg",
                        width: "17",
                        height: "18"
                    }),
                    "links oben im Browser, links von der Internetadresse (z. B. beispielseite.de) und der Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Wenn Sie mehr zum Thema Verschl\xfcsselung wissen m\xf6chten, empfehlen wir die Google Suche nach \u201CHypertext Transfer Protocol Secure wiki\u201D um gute Links zu weiterf\xfchrenden Informationen zu erhalten."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "kommunikation",
                children: "Kommunikation"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Kommunikation Zusammenfassung"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Alle, die mit uns z.B. per E-Mail oder Online-Formular kommunizieren",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: z. B. Name, E-Mail-Adresse, eingegebene Formulardaten. Mehr Details dazu finden Sie bei der jeweils eingesetzten Kontaktart",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Abwicklung der Kommunikation mit Kunden, Gesch\xe4ftspartnern usw.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: Dauer des Gesch\xe4ftsfalls und der gesetzlichen Vorschriften",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. b DSGVO (Vertrag), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie mit uns Kontakt aufnehmen und per Telefon, E-Mail oder Online-Formular kommunizieren, kann es zur Verarbeitung personenbezogener Daten kommen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die Daten werden f\xfcr die Abwicklung und Bearbeitung Ihrer Frage und des damit zusammenh\xe4ngenden Gesch\xe4ftsvorgangs verarbeitet. Die Daten w\xe4hrend eben solange gespeichert bzw. solange es das Gesetz vorschreibt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Betroffene Personen"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Von den genannten Vorg\xe4ngen sind alle betroffen, die \xfcber die von uns bereit gestellten Kommunikationswege den Kontakt zu uns suchen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Telefon"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie uns anrufen, werden die Anrufdaten auf dem jeweiligen Endger\xe4t und beim eingesetzten Telekommunikationsanbieter pseudonymisiert gespeichert. Au\xdferdem k\xf6nnen Daten wie Name und Telefonnummer im Anschluss per E-Mail versendet und zur Anfragebeantwortung gespeichert werden. Die Daten werden gel\xf6scht, sobald der Gesch\xe4ftsfall beendet wurde und es gesetzliche Vorgaben erlauben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "E-Mail"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie mit uns per E-Mail kommunizieren, werden Daten gegebenenfalls auf dem jeweiligen Endger\xe4t (Computer, Laptop, Smartphone,\u2026) gespeichert und es kommt zur Speicherung von Daten auf dem E-Mail-Server. Die Daten werden gel\xf6scht, sobald der Gesch\xe4ftsfall beendet wurde und es gesetzliche Vorgaben erlauben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Online Formulare"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie mit uns mittels Online-Formular kommunizieren, werden Daten auf unserem Webserver gespeichert und gegebenenfalls an eine E-Mail-Adresse von uns weitergeleitet. Die Daten werden gel\xf6scht, sobald der Gesch\xe4ftsfall beendet wurde und es gesetzliche Vorgaben erlauben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlagen"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die Verarbeitung der Daten basiert auf den folgenden Rechtsgrundlagen:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Art. 6 Abs. 1 lit. a DSGVO (Einwilligung): Sie geben uns die Einwilligung Ihre Daten zu speichern und weiter f\xfcr den Gesch\xe4ftsfall betreffende Zwecke zu verwenden;"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Art. 6 Abs. 1 lit. b DSGVO (Vertrag): Es besteht die Notwendigkeit f\xfcr die Erf\xfcllung eines Vertrags mit Ihnen oder einem Auftragsverarbeiter wie z. B. dem Telefonanbieter oder wir m\xfcssen die Daten f\xfcr vorvertragliche T\xe4tigkeiten, wie z. B. die Vorbereitung eines Angebots, verarbeiten;"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen): Wir wollen Kundenanfragen und gesch\xe4ftliche Kommunikation in einem professionellen Rahmen betreiben. Dazu sind gewisse technische Einrichtungen wie z. B. E-Mail-Programme, Exchange-Server und Mobilfunkbetreiber notwendig, um die Kommunikation effizient betreiben zu k\xf6nnen."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "cookies",
                children: "Cookies"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Cookies Zusammenfassung"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: abh\xe4ngig vom jeweiligen Cookie. Mehr Details dazu finden Sie weiter unten bzw. beim Hersteller der Software, der das Cookie setzt.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Abh\xe4ngig vom jeweils eingesetzten Cookie. Mehr Details dazu finden Sie weiter unten bzw. beim Hersteller der Software, der das Cookie setzt.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: abh\xe4ngig vom jeweiligen Cookie, kann von Stunden bis hin zu Jahren variieren",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit.f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was sind Cookies?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Unsere Website verwendet HTTP-Cookies, um nutzerspezifische Daten zu speichern.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    "Im Folgenden erkl\xe4ren wir, was Cookies sind und warum Sie genutzt werden, damit Sie die folgende Datenschutzerkl\xe4rung besser verstehen."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Immer wenn Sie durch das Internet surfen, verwenden Sie einen Browser. Bekannte Browser sind beispielsweise Chrome, Safari, Firefox, Internet Explorer und Microsoft Edge. Die meisten Websites speichern kleine Text-Dateien in Ihrem Browser. Diese Dateien nennt man Cookies."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Eines ist nicht von der Hand zu weisen: Cookies sind echt n\xfctzliche Helferlein. Fast alle Websites verwenden Cookies. Genauer gesprochen sind es HTTP-Cookies, da es auch noch andere Cookies f\xfcr andere Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien, die von unserer Website auf Ihrem Computer gespeichert werden. Diese Cookie-Dateien werden automatisch im Cookie-Ordner, quasi dem \u201CHirn\u201D Ihres Browsers, untergebracht. Ein Cookie besteht aus einem Namen und einem Wert. Bei der Definition eines Cookies m\xfcssen zus\xe4tzlich ein oder mehrere Attribute angegeben werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Cookies speichern gewisse Nutzerdaten von Ihnen, wie beispielsweise Sprache oder pers\xf6nliche Seiteneinstellungen. Wenn Sie unsere Seite wieder aufrufen, \xfcbermittelt Ihr Browser die \u201Euserbezogenen\u201C Informationen an unsere Seite zur\xfcck. Dank der Cookies wei\xdf unsere Website, wer Sie sind und bietet Ihnen die Einstellung, die Sie gewohnt sind. In einigen Browsern hat jedes Cookie eine eigene Datei, in anderen wie beispielsweise Firefox sind alle Cookies in einer einzigen Datei gespeichert."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die folgende Grafik zeigt eine m\xf6gliche Interaktion zwischen einem Webbrowser wie z. B. Chrome und dem Webserver. Dabei fordert der Webbrowser eine Website an und erh\xe4lt vom Server ein Cookie zur\xfcck, welches der Browser erneut verwendet, sobald eine andere Seite angefordert wird."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                    role: "img",
                    src: "https://www.adsimple.at/wp-content/uploads/2018/03/http-cookie-interaction.svg",
                    alt: "HTTP Cookie Interaktion zwischen Browser und Webserver",
                    width: "100%"
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Es gibt sowohl Erstanbieter Cookies als auch Drittanbieter-Cookies. Erstanbieter-Cookies werden direkt von unserer Seite erstellt, Drittanbieter-Cookies werden von Partner-Websites (z.B. Google Analytics) erstellt. Jedes Cookie ist individuell zu bewerten, da jedes Cookie andere Daten speichert. Auch die Ablaufzeit eines Cookies variiert von ein paar Minuten bis hin zu ein paar Jahren. Cookies sind keine Software-Programme und enthalten keine Viren, Trojaner oder andere \u201ESch\xe4dlinge\u201C. Cookies k\xf6nnen auch nicht auf Informationen Ihres PCs zugreifen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "So k\xf6nnen zum Beispiel Cookie-Daten aussehen:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " _ga",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " GA1.2.1326744211.152312394123-9",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Unterscheidung der Websitebesucher",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Diese Mindestgr\xf6\xdfen sollte ein Browser unterst\xfctzen k\xf6nnen:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Mindestens 4096 Bytes pro Cookie"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Mindestens 50 Cookies pro Domain"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Mindestens 3000 Cookies insgesamt"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Arten von Cookies gibt es?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die Frage welche Cookies wir im Speziellen verwenden, h\xe4ngt von den verwendeten Diensten ab und wird in den folgenden Abschnitten der Datenschutzerkl\xe4rung gekl\xe4rt. An dieser Stelle m\xf6chten wir kurz auf die verschiedenen Arten von HTTP-Cookies eingehen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Man kann 4 Arten von Cookies unterscheiden:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: [
                            "Unerl\xe4ssliche Cookies",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {})
                        ]
                    }),
                    "Diese Cookies sind n\xf6tig, um grundlegende Funktionen der Website sicherzustellen. Zum Beispiel braucht es diese Cookies, wenn ein User ein Produkt in den Warenkorb legt, dann auf anderen Seiten weitersurft und sp\xe4ter erst zur Kasse geht. Durch diese Cookies wird der Warenkorb nicht gel\xf6scht, selbst wenn der User sein Browserfenster schlie\xdft."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: [
                            "Zweckm\xe4\xdfige Cookies",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {})
                        ]
                    }),
                    "Diese Cookies sammeln Infos \xfcber das Userverhalten und ob der User etwaige Fehlermeldungen bekommt. Zudem werden mithilfe dieser Cookies auch die Ladezeit und das Verhalten der Website bei verschiedenen Browsern gemessen."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: [
                            "Zielorientierte Cookies",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {})
                        ]
                    }),
                    "Diese Cookies sorgen f\xfcr eine bessere Nutzerfreundlichkeit. Beispielsweise werden eingegebene Standorte, Schriftgr\xf6\xdfen oder Formulardaten gespeichert."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: [
                            "Werbe-Cookies",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {})
                        ]
                    }),
                    "Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen dazu dem User individuell angepasste Werbung zu liefern. Das kann sehr praktisch, aber auch sehr nervig sein."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "\xdcblicherweise werden Sie beim erstmaligen Besuch einer Website gefragt, welche dieser Cookiearten Sie zulassen m\xf6chten. Und nat\xfcrlich wird diese Entscheidung auch in einem Cookie gespeichert."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie mehr \xfcber Cookies wissen m\xf6chten und technische Dokumentationen nicht scheuen, empfehlen wir",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://datatracker.ietf.org/doc/html/rfc6265",
                        children: "https://datatracker.ietf.org/doc/html/rfc6265"
                    }),
                    " ",
                    ", dem Request for Comments der Internet Engineering Task Force (IETF) namens \u201CHTTP State Management Mechanism\u201D."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Zweck der Verarbeitung \xfcber Cookies"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Der Zweck ist letztendlich abh\xe4ngig vom jeweiligen Cookie. Mehr Details dazu finden Sie weiter unten bzw. beim Hersteller der Software, die das Cookie setzt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Cookies sind kleine Gehilfen f\xfcr eine viele verschiedene Aufgaben. Welche Daten in Cookies gespeichert werden, kann man leider nicht verallgemeinern, aber wir werden Sie im Rahmen der folgenden Datenschutzerkl\xe4rung \xfcber die verarbeiteten bzw. gespeicherten Daten informieren."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Speicherdauer von Cookies"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die Speicherdauer h\xe4ngt vom jeweiligen Cookie ab und wird weiter unter pr\xe4zisiert. Manche Cookies werden nach weniger als einer Stunde gel\xf6scht, andere k\xf6nnen mehrere Jahre auf einem Computer gespeichert bleiben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben au\xdferdem selbst Einfluss auf die Speicherdauer. Sie k\xf6nnen \xfcber ihren Browser s\xe4mtliche Cookies jederzeit manuell l\xf6schen (siehe auch unten \u201CWiderspruchsrecht\u201D). Ferner werden Cookies, die auf einer Einwilligung beruhen, sp\xe4testens nach Widerruf Ihrer Einwilligung gel\xf6scht, wobei die Rechtm\xe4\xdfigkeit der Speicherung bis dahin unber\xfchrt bleibt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht \u2013 wie kann ich Cookies l\xf6schen?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst. Unabh\xe4ngig von welchem Service oder welcher Website die Cookies stammen, haben Sie immer die M\xf6glichkeit Cookies zu l\xf6schen, zu deaktivieren oder nur teilweise zuzulassen. Zum Beispiel k\xf6nnen Sie Cookies von Drittanbietern blockieren, aber alle anderen Cookies zulassen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie feststellen m\xf6chten, welche Cookies in Ihrem Browser gespeichert wurden, wenn Sie Cookie-Einstellungen \xe4ndern oder l\xf6schen wollen, k\xf6nnen Sie dies in Ihren Browser-Einstellungen finden:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://support.google.com/chrome/answer/95647?tid=312394123",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Chrome: Cookies in Chrome l\xf6schen, aktivieren und verwalten"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=312394123",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Safari: Verwalten von Cookies und Websitedaten mit Safari"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=312394123",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Firefox: Cookies l\xf6schen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://support.microsoft.com/de-de/windows/l%C3%B6schen-und-verwalten-von-cookies-168dab11-0753-043d-7c16-ede5947fc64d?tid=312394123",
                        children: "Internet Explorer: L\xf6schen und Verwalten von Cookies"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://support.microsoft.com/de-de/microsoft-edge/cookies-in-microsoft-edge-l%C3%B6schen-63947406-40ac-c3b8-57b9-2a946a29ae09?tid=312394123",
                        children: "Microsoft Edge: L\xf6schen und Verwalten von Cookies"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Falls Sie grunds\xe4tzlich keine Cookies haben wollen, k\xf6nnen Sie Ihren Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie gesetzt werden soll. So k\xf6nnen Sie bei jedem einzelnen Cookie entscheiden, ob Sie das Cookie erlauben oder nicht. Die Vorgangsweise ist je nach Browser verschieden. Am besten Sie suchen die Anleitung in Google mit dem Suchbegriff \u201CCookies l\xf6schen Chrome\u201D oder \u201CCookies deaktivieren Chrome\u201D im Falle eines Chrome Browsers."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Seit 2009 gibt es die sogenannten \u201ECookie-Richtlinien\u201C. Darin ist festgehalten, dass das Speichern von Cookies eine",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Einwilligung"
                    }),
                    " (Artikel 6 Abs. 1 lit. a DSGVO) von Ihnen verlangt. Innerhalb der EU-L\xe4nder gibt es allerdings noch sehr unterschiedliche Reaktionen auf diese Richtlinien. In \xd6sterreich erfolgte aber die Umsetzung dieser Richtlinie in \xa7 96 Abs. 3 des Telekommunikationsgesetzes (TKG). In Deutschland wurden die Cookie-Richtlinien nicht als nationales Recht umgesetzt. Stattdessen erfolgte die Umsetzung dieser Richtlinie weitgehend in \xa7 15 Abs.3 des Telemediengesetzes (TMG)."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "F\xfcr unbedingt notwendige Cookies, auch soweit keine Einwilligung vorliegt, bestehen ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "berechtigte Interessen"
                    }),
                    " (Artikel 6 Abs. 1 lit. f DSGVO), die in den meisten F\xe4llen wirtschaftlicher Natur sind. Wir m\xf6chten den Besuchern der Website eine angenehme Benutzererfahrung bescheren und daf\xfcr sind bestimmte Cookies oft unbedingt notwendig."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Soweit nicht unbedingt erforderliche Cookies zum Einsatz kommen, geschieht dies nur im Falle Ihrer Einwilligung. Rechtsgrundlage ist insoweit Art. 6 Abs. 1 lit. a DSGVO."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "In den folgenden Abschnitten werden Sie genauer \xfcber den Einsatz von Cookies informiert, sofern eingesetzte Software Cookies verwendet."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "kundendaten",
                children: "Kundendaten"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Kundendaten Zusammenfassung"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Kunden bzw. Gesch\xe4fts- und Vertragspartner",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Erbringung der vertraglich oder vorvertraglich vereinbarten Leistungen einschlie\xdflich zugeh\xf6rige Kommunikation",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Name, Adresse, Kontaktdaten, E-Mail-Adresse, Telefonnummer, Zahlungsinformationen (wie z. B. Rechnungen und Bankdaten), Vertragsdaten (wie z. B. Laufzeit und Gegenstand des Vertrags), IP-Adresse, Bestelldaten",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: die Daten werden gel\xf6scht, sobald sie zur Erbringung unserer gesch\xe4ftlichen Zwecke nicht mehr erforderlich sind und es keine gesetzliche Aufbewahrungspflicht gibt.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO), Vertrag (Art. 6 Abs 1 lit. b DSGVO)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was sind Kundendaten?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Damit wir unser Service bzw. unsere vertraglichen Leistungen anbieten k\xf6nnen, verarbeiten wir auch Daten unserer Kunden und Gesch\xe4ftspartner. Unter diesen Daten befinden sich immer auch personenbezogene Daten. Unter Kundendaten versteht man alle Informationen, die auf Basis einer vertraglichen oder vorvertraglichen Zusammenarbeit verarbeitet werden, um die angebotenen Leistungen erbringen zu k\xf6nnen. Kundendaten sind also alle gesammelten Informationen, die wir \xfcber unsere Kunden erheben und verarbeiten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verarbeiten wir Kundendaten?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Es gibt viele Gr\xfcnde, warum wir Kundendaten sammeln und verarbeiten. Der wichtigste ist, dass wir zur Bereitstellung unserer Services einfach verschiedene Daten ben\xf6tigen. Manchmal reicht hier schon Ihre E-Mail-Adresse, doch wenn Sie etwa ein Produkt oder eine Dienstleistung erwerben, ben\xf6tigen wir auch Daten wie beispielsweise Name, Adresse, Bankdaten oder Vertragsdaten. Wir nutzen die Daten in weiterer Folge auch f\xfcr Marketing- und Vertriebsoptimierungen, damit wir insgesamt unser Service f\xfcr unsere Kunden verbessern k\xf6nnen. Ein weiterer wichtiger Punkt ist auch unser Kundenservice, der uns stets sehr am Herzen liegt. Wir wollen, dass Sie mit Frage zu unseren Angeboten jederzeit zu uns kommen k\xf6nnen und daf\xfcr brauchen wir zumindest Ihre E-Mail-Adresse."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Welche Daten genau gespeichert werden, kann an dieser Stelle nur anhand Kategorien wiedergegeben werden. Dies h\xe4ngt n\xe4mlich stets davon ab, welche Leistungen Sie von uns beziehen. In manchen F\xe4llen geben Sie uns lediglich Ihre E-Mail-Adresse, damit wir beispielsweise mit Ihnen in Kontakt treten k\xf6nnen oder wir Ihre Fragen beantworten k\xf6nnen. In anderen F\xe4llen erwerben Sie ein Produkt oder eine Dienstleistung bei uns und daf\xfcr ben\xf6tigen wir deutlich mehr Informationen, wie etwa Ihre Kontaktdaten, Zahlungsdaten und Vertragsdaten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Hier eine Liste m\xf6glicher Daten, die wir von Ihnen erhalten und verarbeiten:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Kontaktadresse"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "E-Mail-Adresse"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Telefonnummer"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Geburtsdatum"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Gesundheitsdaten im Rahmen von Antragsstellungen"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Zahlungsdaten (Rechnungen, Bankdaten, Zahlungshistorie etc.)"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Vertragsdaten ( Laufzeit, Inhalt)"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Nutzungsdaten (besuchte Websites, Zugriffsdaten ect.)"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Metadaten (IP-Adresse, Ger\xe4te-Informationen)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Wie lange werden die Daten gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sobald wir die Kundendaten zur Erf\xfcllung unserer vertraglichen Pflichten und unserer Zwecke nicht mehr ben\xf6tigen und die Daten auch nicht f\xfcr m\xf6gliche Gew\xe4hrleistungs- und Haftungspflichten n\xf6tig sind, l\xf6schen wir die entsprechenden Kundendaten. Das ist zum Beispiel der Fall, wenn ein gesch\xe4ftlicher Vertrag endet. Danach betr\xe4gt die Verj\xe4hrungsfrist in der Regel 3 Jahre, wobei l\xe4ngere Fristen im Einzelfall m\xf6glich sind. Wir halten uns nat\xfcrlich auch an die gesetzlichen Aufbewahrungspflichten. Ihre Kundendaten werden ganz sicher nicht an Dritte weitergegeben, wenn Sie dazu nicht explizit eine Einwilligung erteilt haben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Rechtsgrundlagen f\xfcr die Verarbeitung Ihrer Daten sind Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs 1 lit. b DSGVO (Vertrag bzw. vorvertragliche Ma\xdfnahmen), Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen) und in speziellen F\xe4llen (z. B. bei medizinischen Leistungen) Art. 9 Abs. 2 lit. a. DSGVO (Verarbeitung besonderer Kategorien)."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "F\xfcr den Fall des Schutzes lebenswichtiger Interessen erfolgt die Datenverarbeitung gem\xe4\xdf Art. 9 Abs. 2 lit. c. DSGVO. F\xfcr Zwecke der Gesundheitsversorgung, der Arbeitsmedizin, f\xfcr die medizinische Diagnostik, f\xfcr die Versorgung oder Behandlung im Gesundheits- oder Sozialbereich oder f\xfcr die Verwaltung von Systemen und Diensten im Gesundheits- oder Sozialbereich erfolgt die Verarbeitung personenbezogener Daten gem\xe4\xdf Art. 9 Abs. 2 lit. h. DSGVO. Wenn Sie freiwillig Daten der besonderen Kategorien mitteilen, erfolgt die Verarbeitung auf Grundlage von Art. 9 Abs. 2 lit. a. DSGVO."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "webhosting-einleitung",
                children: "Webhosting Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Webhosting Zusammenfassung"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: professionelles Hosting der Website und Absicherung des Betriebs",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: IP-Adresse, Zeitpunkt des Websitebesuchs, verwendeter Browser und weitere Daten. Mehr Details dazu finden Sie weiter unten bzw. beim jeweils eingesetzten Webhosting Provider.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: abh\xe4ngig vom jeweiligen Provider, aber in der Regel 2 Wochen",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit.f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist Webhosting?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie heutzutage Websites besuchen, werden gewisse Informationen \u2013 auch personenbezogene Daten \u2013 automatisch erstellt und gespeichert, so auch auf dieser Website. Diese Daten sollten m\xf6glichst sparsam und nur mit Begr\xfcndung verarbeitet werden. Mit Website meinen wir \xfcbrigens die Gesamtheit aller Webseiten auf einer Domain, d.h. alles von der Startseite (Homepage) bis hin zur aller letzten Unterseite (wie dieser hier). Mit Domain meinen wir zum Beispiel beispiel.de oder musterbeispiel.com."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie eine Website auf einem Computer, Tablet oder Smartphone ansehen m\xf6chten, verwenden Sie daf\xfcr ein Programm, das sich Webbrowser nennt. Sie kennen vermutlich einige Webbrowser beim Namen: Google Chrome, Microsoft Edge, Mozilla Firefox und Apple Safari. Wir sagen kurz Browser oder Webbrowser dazu."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Um die Website aufzurufen, muss sich der Browser zu einem anderen Computer verbinden, wo der Code der Website gespeichert ist: dem Webserver. Der Betrieb eines Webservers ist eine komplizierte und aufwendige Aufgabe, weswegen dies in der Regel von professionellen Anbietern, den Providern, \xfcbernommen wird. Diese bieten Webhosting an und sorgen damit f\xfcr eine verl\xe4ssliche und fehlerfreie Speicherung der Daten von Websites. Eine ganze Menge Fachbegriffe, aber bitte bleiben Sie dran, es wird noch besser!"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Bei der Verbindungsaufnahme des Browsers auf Ihrem Computer (Desktop, Laptop, Tablet oder Smartphone) und w\xe4hrend der Daten\xfcbertragung zu und vom Webserver kann es zu einer Verarbeitung personenbezogener Daten kommen. Einerseits speichert Ihr Computer Daten, andererseits muss auch der Webserver Daten eine Zeit lang speichern, um einen ordentlichen Betrieb zu gew\xe4hrleisten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Ein Bild sagt mehr als tausend Worte, daher zeigt folgende Grafik zur Veranschaulichung das Zusammenspiel zwischen Browser, dem Internet und dem Hosting-Provider."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                    role: "img",
                    src: "https://www.adsimple.at/wp-content/uploads/2018/03/browser-und-webserver.svg",
                    alt: "Browser und Webserver",
                    width: "100%"
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verarbeiten wir personenbezogene Daten?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die Zwecke der Datenverarbeitung sind:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ol", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Professionelles Hosting der Website und Absicherung des Betriebs"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "zur Aufrechterhaltung der Betriebs- und IT-Sicherheit"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Anonyme Auswertung des Zugriffsverhaltens zur Verbesserung unseres Angebots und ggf. zur Strafverfolgung bzw. Verfolgung von Anspr\xfcchen"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Auch w\xe4hrend Sie unsere Website jetzt gerade besuchen, speichert unser Webserver, das ist der Computer auf dem diese Webseite gespeichert ist, in der Regel automatisch Daten wie"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "die komplette Internetadresse (URL) der aufgerufenen Webseite"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Browser und Browserversion (z. B. Chrome 87)"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "das verwendete Betriebssystem (z. B. Windows 10)"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: [
                            "die Adresse (URL) der zuvor besuchten Seite (Referrer URL) (z. B.",
                            " ",
                            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                                to: "https://www.beispielquellsite.de/vondabinichgekommen/",
                                target: "_blank",
                                rel: "follow noopener",
                                children: "https://www.beispielquellsite.de/vondabinichgekommen/"
                            }),
                            " ",
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "den Hostnamen und die IP-Adresse des Ger\xe4ts von welchem aus zugegriffen wird (z. B. COMPUTERNAME und 194.23.43.121)"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Datum und Uhrzeit"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "in Dateien, den sogenannten Webserver-Logfiles"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Wie lange werden Daten gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "In der Regel werden die oben genannten Daten zwei Wochen gespeichert und danach automatisch gel\xf6scht. Wir geben diese Daten nicht weiter, k\xf6nnen jedoch nicht ausschlie\xdfen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten von Beh\xf6rden eingesehen werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Kurz gesagt:"
                    }),
                    " Ihr Besuch wird durch unseren Provider (Firma, die unsere Website auf speziellen Computern (Servern) laufen l\xe4sst), protokolliert, aber wir geben Ihre Daten nicht ohne Zustimmung weiter!"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die Rechtm\xe4\xdfigkeit der Verarbeitung personenbezogener Daten im Rahmen des Webhosting ergibt sich aus Art. 6 Abs. 1 lit. f DSGVO (Wahrung der berechtigten Interessen), denn die Nutzung von professionellem Hosting bei einem Provider ist notwendig, um das Unternehmen im Internet sicher und nutzerfreundlich pr\xe4sentieren und Angriffe und Forderungen hieraus gegebenenfalls verfolgen zu k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Zwischen uns und dem Hosting-Provider besteht in der Regel ein Vertrag \xfcber die Auftragsverarbeitung gem\xe4\xdf Art. 28 f. DSGVO, der die Einhaltung von Datenschutz gew\xe4hrleistet und Datensicherheit garantiert."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Automatisierungs-Software"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Nutzung von Automatisierungs-Software"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher, die einen Antrag absenden",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Automatisierte verarbeitung der Antragsdaten zu Erf\xfcllung des Auftrags der Antragserstellung und Anlegen der Kontakte f\xfcr sp\xe4tere Kommunikation.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte der Zugriffe, Ger\xe4tedaten, Personenbezogene Daten, die im Rahmen des Antrags angegeben wurden.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: abh\xe4ngig vom Antragsprozess",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Automatisierung mit Make.com (Celonis, Inc.)"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Make.com ist ein Softwareanbieter f\xfcr Automatisierungen. Wir haben mit Make.com einen Auftragsdaten\xadverarbeitungs\xadvertrag (Data processing agreement) abgeschlossen. In diesem Vertrag verpflichtet sich Make.com dazu, die Daten unserer Nutzer gem\xe4\xdf DSGVO und deren Datenschutzbestimmungen zu verarbeiten und zu sch\xfctzen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "web-analytics-einleitung",
                children: "Web Analytics Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Web Analytics Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Auswertung der Besucherinformationen zur Optimierung des Webangebots.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte der Zugriffe, Ger\xe4tedaten, Zugriffsdauer und Zeitpunkt, Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Mehr Details dazu finden Sie beim jeweils eingesetzten Web Analytics Tool.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: abh\xe4ngig vom eingesetzten Web-Analytics-Tool",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist Web Analytics?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir verwenden auf unserer Website Software zur Auswertung des Verhaltens der Website-Besucher, kurz Web Analytics oder Web-Analyse genannt. Dabei werden Daten gesammelt, die der jeweilige Analytic-Tool-Anbieter (auch Trackingtool genannt) speichert, verwaltet und verarbeitet. Mit Hilfe der Daten werden Analysen \xfcber das Nutzerverhalten auf unserer Website erstellt und uns als Websitebetreiber zur Verf\xfcgung gestellt. Zus\xe4tzlich bieten die meisten Tools verschiedene Testm\xf6glichkeiten an. So k\xf6nnen wir etwa testen, welche Angebote oder Inhalte bei unseren Besuchern am besten ankommen. Daf\xfcr zeigen wir Ihnen f\xfcr einen begrenzten Zeitabschnitt zwei verschiedene Angebote. Nach dem Test (sogenannter A/B-Test) wissen wir, welches Produkt bzw. welcher Inhalt unsere Websitebesucher interessanter finden. F\xfcr solche Testverfahren, wie auch f\xfcr andere Analytics-Verfahren, k\xf6nnen auch Userprofile erstellt werden und die Daten in Cookies gespeichert werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum betreiben wir Web Analytics?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Mit unserer Website haben wir ein klares Ziel vor Augen: wir wollen f\xfcr unsere Branche das beste Webangebot auf dem Markt liefern. Um dieses Ziel zu erreichen, wollen wir einerseits das beste und interessanteste Angebot bieten und andererseits darauf achten, dass Sie sich auf unserer Website rundum wohlf\xfchlen. Mit Hilfe von Webanalyse-Tools k\xf6nnen wir das Verhalten unserer Websitebesucher genauer unter die Lupe nehmen und dann entsprechend unser Webangebot f\xfcr Sie und uns verbessern. So k\xf6nnen wir beispielsweise erkennen wie alt unsere Besucher durchschnittlich sind, woher sie kommen, wann unsere Website am meisten besucht wird oder welche Inhalte oder Produkte besonders beliebt sind. All diese Informationen helfen uns die Website zu optimieren und entsprechend Ihrer Bed\xfcrfnisse, Interessen und W\xfcnsche zu \xfcberarbeiten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Welche Daten genau gespeichert werden, h\xe4ngt nat\xfcrlich von den verwendeten Analyse-Tools ab. Doch in der Regel wird zum Beispiel gespeichert, welche Inhalte Sie auf unserer Website ansehen, auf welche Buttons oder Links Sie klicken, wann Sie eine Seite aufrufen, welchen Browser sie verwenden, mit welchem Ger\xe4t (PC, Tablet, Smartphone usw.) Sie die Website besuchen oder welches Computersystem Sie verwenden. Wenn Sie damit einverstanden waren, dass auch Standortdaten erhoben werden d\xfcrfen, k\xf6nnen auch diese durch den Webanalyse-Tool-Anbieter verarbeitet werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Zudem wird auch Ihre IP-Adresse gespeichert. Gem\xe4\xdf der Datenschutz-Grundverordnung (DSGVO) sind IP-Adressen personenbezogene Daten. Ihre IP-Adresse wird allerdings in der Regel pseudonymisiert (also in unkenntlicher und gek\xfcrzter Form) gespeichert. F\xfcr den Zweck der Tests, der Webanalyse und der Weboptimierung werden grunds\xe4tzlich keine direkten Daten, wie etwa Ihr Name, Ihr Alter, Ihre Adresse oder Ihre E-Mail-Adresse gespeichert. All diese Daten werden, sofern sie erhoben werden, pseudonymisiert gespeichert. So k\xf6nnen Sie als Person nicht identifiziert werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Das folgende Beispiel zeigt schematisch die Funktionsweise von Google Analytics als Beispiel f\xfcr client-basiertes Webtracking mit Java-Script-Code."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                    role: "img",
                    src: "https://www.adsimple.at/wp-content/uploads/2021/04/google-analytics-dataflow.svg",
                    alt: "Schematischer Datenfluss bei Google Analytics",
                    width: "100%"
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wie lange die jeweiligen Daten gespeichert werden, h\xe4ngt immer vom Anbieter ab. Manche Cookies speichern Daten nur f\xfcr ein paar Minuten bzw. bis Sie die Website wieder verlassen, andere Cookies k\xf6nnen Daten \xfcber mehrere Jahre speichern."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Dauer der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "\xdcber die Dauer der Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere Informationen dazu haben. Generell verarbeiten wir personenbezogene Daten nur so lange wie es f\xfcr die Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig ist. Wenn es, wie zum Beispiel im Fall von Buchhaltung, gesetzlich vorgeschrieben ist, kann diese Speicherdauer auch \xfcberschritten werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben auch jederzeit das Recht und die M\xf6glichkeit Ihre Einwilligung zur Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert entweder \xfcber unser Cookie-Management-Tool oder \xfcber andere Opt-Out-Funktionen. Zum Beispiel k\xf6nnen Sie auch die Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren oder l\xf6schen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Der Einsatz von Web-Analytics setzt Ihre Einwilligung voraus, welche wir mit unserem Cookie Popup eingeholt haben. Diese Einwilligung stellt laut",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: " Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)"
                    }),
                    "die Rechtsgrundlage f\xfcr die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung durch Web-Analytics Tools vorkommen kann, dar."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Zus\xe4tzlich zur Einwilligung besteht von unserer Seite ein berechtigtes Interesse daran, das Verhalten der Websitebesucher zu analysieren und so unser Angebot technisch und wirtschaftlich zu verbessern. Mit Hilfe von Web-Analytics erkennen wir Fehler der Website, k\xf6nnen Attacken identifizieren und die Wirtschaftlichkeit verbessern. Die Rechtsgrundlage daf\xfcr ist",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                    }),
                    ". Wir setzen die Tools gleichwohl nur ein, soweit sie eine Einwilligung erteilt haben."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Da bei Web-Analytics-Tools Cookies zum Einsatz kommen, empfehlen wir Ihnen auch das Lesen unserer allgemeinen Datenschutzerkl\xe4rung zu Cookies. Um zu erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet werden, sollten Sie die Datenschutzerkl\xe4rungen der jeweiligen Tools durchlesen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Informationen zu speziellen Web-Analytics-Tools, erhalten Sie \u2013 sofern vorhanden \u2013 in den folgenden Abschnitten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "google-analytics-datenschutzerklaerung",
                children: "Google Analytics Datenschutzerkl\xe4rung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Google Analytics Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Auswertung der Besucherinformationen zur Optimierung des Webangebots.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte der Zugriffe, Ger\xe4tedaten, Zugriffsdauer und Zeitpunkt, Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Mehr Details dazu finden Sie weiter unten in dieser Datenschutzerkl\xe4rung.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: abh\xe4ngig von den verwendeten Properties",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist Google Analytics?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir verwenden auf unserer Website das Analyse-Tracking Tool Google Analytics (GA) des amerikanischen Unternehmens Google Inc. F\xfcr den europ\xe4ischen Raum ist das Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) f\xfcr alle Google-Dienste verantwortlich. Google Analytics sammelt Daten \xfcber Ihre Handlungen auf unserer Website. Wenn Sie beispielsweise einen Link anklicken, wird diese Aktion in einem Cookie gespeichert und an Google Analytics versandt. Mithilfe der Berichte, die wir von Google Analytics erhalten, k\xf6nnen wir unsere Website und unser Service besser an Ihre W\xfcnsche anpassen. Im Folgenden gehen wir n\xe4her auf das Tracking-Tool ein und informieren Sie vor allem dar\xfcber, welche Daten gespeichert werden und wie Sie das verhindern k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Google Analytics ist ein Trackingtool, das der Datenverkehrsanalyse unserer Website dient. Damit Google Analytics funktioniert, wird ein Tracking-Code in den Code unserer Website eingebaut. Wenn Sie unsere Website besuchen, zeichnet dieser Code verschiedene Handlungen auf, die Sie auf unserer Website ausf\xfchren. Sobald Sie unsere Website verlassen, werden diese Daten an die Google-Analytics-Server gesendet und dort gespeichert."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Google verarbeitet die Daten und wir bekommen Berichte \xfcber Ihr Userverhalten. Dabei kann es sich unter anderem um folgende Berichte handeln:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Zielgruppenberichte: \xdcber Zielgruppenberichte lernen wir unsere User besser kennen und wissen genauer, wer sich f\xfcr unser Service interessiert."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Anzeigeberichte: Durch Anzeigeberichte k\xf6nnen wir unsere Onlinewerbung leichter analysieren und verbessern."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Akquisitionsberichte: Akquisitionsberichte geben uns hilfreiche Informationen dar\xfcber, wie wir mehr Menschen f\xfcr unser Service begeistern k\xf6nnen."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Verhaltensberichte: Hier erfahren wir, wie Sie mit unserer Website interagieren. Wir k\xf6nnen nachvollziehen welchen Weg Sie auf unserer Seite zur\xfccklegen und welche Links Sie anklicken."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Conversionsberichte: Conversion nennt man einen Vorgang, bei dem Sie aufgrund einer Marketing-Botschaft eine gew\xfcnschte Handlung ausf\xfchren. Zum Beispiel, wenn Sie von einem reinen Websitebesucher zu einem K\xe4ufer oder Newsletter-Abonnent werden. Mithilfe dieser Berichte erfahren wir mehr dar\xfcber, wie unsere Marketing-Ma\xdfnahmen bei Ihnen ankommen. So wollen wir unsere Conversionrate steigern."
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Echtzeitberichte: Hier erfahren wir immer sofort, was gerade auf unserer Website passiert. Zum Beispiel sehen wir wie viele User gerade diesen Text lesen."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verwenden wir Google Analytics auf unserer Website?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Unser Ziel mit dieser Website ist klar: Wir wollen Ihnen das bestm\xf6gliche Service bieten. Die Statistiken und Daten von Google Analytics helfen uns dieses Ziel zu erreichen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die statistisch ausgewerteten Daten zeigen uns ein klares Bild von den St\xe4rken und Schw\xe4chen unserer Website. Einerseits k\xf6nnen wir unsere Seite so optimieren, dass sie von interessierten Menschen auf Google leichter gefunden wird. Andererseits helfen uns die Daten, Sie als Besucher besser zu verstehen. Wir wissen somit sehr genau, was wir an unserer Website verbessern m\xfcssen, um Ihnen das bestm\xf6gliche Service zu bieten. Die Daten dienen uns auch, unsere Werbe- und Marketing-Ma\xdfnahmen individueller und kosteng\xfcnstiger durchzuf\xfchren. Schlie\xdflich macht es nur Sinn, unsere Produkte und Dienstleistungen Menschen zu zeigen, die sich daf\xfcr interessieren."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden von Google Analytics gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Google Analytics erstellt mithilfe eines Tracking-Codes eine zuf\xe4llige, eindeutige ID, die mit Ihrem Browser-Cookie verbunden ist. So erkennt Sie Google Analytics als neuen User. Wenn Sie das n\xe4chste Mal unsere Seite besuchen, werden Sie als \u201Ewiederkehrender\u201C User erkannt. Alle gesammelten Daten werden gemeinsam mit dieser User-ID gespeichert. So ist es \xfcberhaupt erst m\xf6glich pseudonyme Userprofile auszuwerten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Um mit Google Analytics unsere Website analysieren zu k\xf6nnen, muss eine Property-ID in den Tracking-Code eingef\xfcgt werden. Die Daten werden dann in der entsprechenden Property gespeichert. F\xfcr jede neu angelegte Property ist die Google Analytics 4-Property standardm\xe4\xdfig. Alternativ kann man aber auch noch die Universal Analytics Property erstellen. Je nach verwendeter Property werden Daten unterschiedlich lange gespeichert."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Durch Kennzeichnungen wie Cookies und App-Instanz-IDs werden Ihre Interaktionen auf unserer Website gemessen. Interaktionen sind alle Arten von Handlungen, die Sie auf unserer Website ausf\xfchren. Wenn Sie auch andere Google-Systeme (wie z.B. ein Google-Konto) n\xfctzen, k\xf6nnen \xfcber Google Analytics generierte Daten mit Drittanbieter-Cookies verkn\xfcpft werden. Google gibt keine Google Analytics-Daten weiter, au\xdfer wir als Websitebetreiber genehmigen das. Zu Ausnahmen kann es kommen, wenn es gesetzlich erforderlich ist."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Folgende Cookies werden von Google Analytics verwendet:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " _ga",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "2.1326744211.152312394123-5",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Standardm\xe4\xdfig verwendet analytics.js das Cookie _ga, um die User-ID zu speichern. Grunds\xe4tzlich dient es zur Unterscheidung der Webseitenbesucher.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " _gid",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "2.1687193234.152312394123-1",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Das Cookie dient auch zur Unterscheidung der Webseitenbesucher",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 24 Stunden"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " _gat_gtag_UA_<property-id",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " 1",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Wird zum Senken der Anforderungsrate verwendet. Wenn Google Analytics \xfcber den Google Tag Manager bereitgestellt wird, erh\xe4lt dieser Cookie den Namen _dc_gtm_ <property-id.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum: "
                    }),
                    "nach 1 Minute"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " AMP_TOKEN",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " keine Angaben",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Das Cookie hat einen Token, mit dem eine User ID vom AMP-Client-ID-Dienst abgerufen werden kann. Andere m\xf6gliche Werte weisen auf eine Abmeldung, eine Anfrage oder einen Fehler hin.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 30 Sekunden bis zu einem Jahr"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " __utma",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "1564498958.1564498958.1564498958.1",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Mit diesem Cookie kann man Ihr Verhalten auf der Website verfolgen und die Leistung messen. Das Cookie wird jedes Mal aktualisiert, wenn Informationen an Google Analytics gesendet werden.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " __utmt",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " 1",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Das Cookie wird wie _gat_gtag_UA_<property-id zum Drosseln der Anforderungsrate verwendet.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 10 Minuten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " __utmb",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "3.10.1564498958",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie wird verwendet, um neue Sitzungen zu bestimmen. Es wird jedes Mal aktualisiert, wenn neue Daten bzw. Infos an Google Analytics gesendet werden.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 30 Minuten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " __utmc",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " 167421564",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie wird verwendet, um neue Sitzungen f\xfcr wiederkehrende Besucher festzulegen. Dabei handelt es sich um ein Session-Cookie und wird nur solange gespeichert, bis Sie den Browser wieder schlie\xdfen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " Nach Schlie\xdfung des Browsers"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " __utmz",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    "m|utmccn=(referral)|utmcmd=referral|utmcct=/",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Das Cookie wird verwendet, um die Quelle des Besucheraufkommens auf unserer Website zu identifizieren. Das hei\xdft, das Cookie speichert, von wo Sie auf unsere Website gekommen sind. Das kann eine andere Seite bzw. eine Werbeschaltung gewesen sein.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 6 Monaten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " __utmv",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " keine Angabe",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Das Cookie wird verwendet, um benutzerdefinierte Userdaten zu speichern. Es wird immer aktualisiert, wenn Informationen an Google Analytics gesendet werden.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Anmerkung:"
                    }),
                    " Diese Aufz\xe4hlung kann keinen Anspruch auf Vollst\xe4ndigkeit erheben, da Google die Wahl ihrer Cookies immer wieder auch ver\xe4ndert."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Hier zeigen wir Ihnen einen \xdcberblick \xfcber die wichtigsten Daten, die mit Google Analytics erhoben werden:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Heatmaps:"
                    }),
                    " Google legt sogenannte Heatmaps an. \xdcber Heatmaps sieht man genau jene Bereiche, die Sie anklicken. So bekommen wir Informationen, wo Sie auf unserer Seite \u201Eunterwegs\u201C sind."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Sitzungsdauer:"
                    }),
                    " Als Sitzungsdauer bezeichnet Google die Zeit, die Sie auf unserer Seite verbringen, ohne die Seite zu verlassen. Wenn Sie 20 Minuten inaktiv waren, endet die Sitzung automatisch."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Absprungrate"
                    }),
                    " (engl. Bouncerate): Von einem Absprung ist die Rede, wenn Sie auf unserer Website nur eine Seite ansehen und dann unsere Website wieder verlassen."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Kontoerstellung:"
                    }),
                    " Wenn Sie auf unserer Website ein Konto erstellen bzw. eine Bestellung machen, erhebt Google Analytics diese Daten."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "IP-Adresse:"
                    }),
                    " Die IP-Adresse wird nur in gek\xfcrzter Form dargestellt, damit keine eindeutige Zuordnung m\xf6glich ist."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Standort:"
                    }),
                    " \xdcber die IP-Adresse kann das Land und Ihr ungef\xe4hrer Standort bestimmt werden. Diesen Vorgang bezeichnet man auch als IP- Standortbestimmung."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Technische Informationen:"
                    }),
                    " Zu den technischen Informationen z\xe4hlen unter anderem Ihr Browsertyp, Ihr Internetanbieter oder Ihre Bildschirmaufl\xf6sung."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Herkunftsquelle:"
                    }),
                    " Google Analytics beziehungsweise uns interessiert nat\xfcrlich auch \xfcber welche Website oder welche Werbung Sie auf unsere Seite gekommen sind."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Weitere Daten sind Kontaktdaten, etwaige Bewertungen, das Abspielen von Medien (z. B. wenn Sie ein Video \xfcber unsere Seite abspielen), das Teilen von Inhalten \xfcber Social Media oder das Zuf\xfcgen zu Ihren Favoriten. Die Aufz\xe4hlung hat keinen Vollst\xe4ndigkeitsanspruch und dient nur zu einer allgemeinen Orientierung der Datenspeicherung durch Google Analytics."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Wie lange und wo werden die Daten gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Google hat ihre Server auf der ganzen Welt verteilt. Die meisten Server befinden sich in Amerika und folglich werden Ihre Daten meist auf amerikanischen Servern gespeichert. Hier k\xf6nnen Sie genau nachlesen wo sich die Google-Rechenzentren befinden:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.google.com/about/datacenters/locations/?hl=de",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://www.google.com/about/datacenters/locations/?hl=de"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Ihre Daten werden auf verschiedenen physischen Datentr\xe4gern verteilt. Das hat den Vorteil, dass die Daten schneller abrufbar sind und vor Manipulation besser gesch\xfctzt sind. In jedem Google-Rechenzentrum gibt es entsprechende Notfallprogramme f\xfcr Ihre Daten. Wenn beispielsweise die Hardware bei Google ausf\xe4llt oder Naturkatastrophen Server lahmlegen, bleibt das Risiko einer Dienstunterbrechung bei Google dennoch gering."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die Aufbewahrungsdauer der Daten h\xe4ngt von den verwendeten Properties ab. Bei der Verwendung der neueren Google Analytics 4-Properties ist die Aufbewahrungsdauer Ihrer Userdaten auf 14 Monate fix eingestellt. F\xfcr andere sogenannte Ereignisdaten haben wir die M\xf6glichkeit eine Aufbewahrungsdauer von 2 Monaten oder 14 Monaten zu w\xe4hlen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Bei Universal Analytics-Properties ist bei Google Analytics eine Aufbewahrungsdauer Ihrer Userdaten von 26 Monaten standardisiert eingestellt. Dann werden Ihre Userdaten gel\xf6scht. Allerdings haben wir die M\xf6glichkeit, die Aufbewahrungsdauer von Nutzdaten selbst zu w\xe4hlen. Daf\xfcr stehen uns f\xfcnf Varianten zur Verf\xfcgung:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("ul", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "L\xf6schung nach 14 Monaten"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "L\xf6schung nach 26 Monaten"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "L\xf6schung nach 38 Monaten"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "L\xf6schung nach 50 Monaten"
                    }),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("li", {
                        children: "Keine automatische L\xf6schung"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Zus\xe4tzlich gibt es auch die Option, dass Daten erst dann gel\xf6scht werden, wenn Sie innerhalb des von uns gew\xe4hlten Zeitraums nicht mehr unsere Website besuchen. In diesem Fall wird die Aufbewahrungsdauer jedes Mal zur\xfcckgesetzt, wenn Sie unsere Website innerhalb des festgelegten Zeitraums wieder besuchen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn der festgelegte Zeitraum abgelaufen ist, werden einmal im Monat die Daten gel\xf6scht. Diese Aufbewahrungsdauer gilt f\xfcr Ihre Daten, die mit Cookies, Usererkennung und Werbe-IDs (z.B. Cookies der DoubleClick-Domain) verkn\xfcpft sind. Berichtergebnisse basieren auf aggregierten Daten und werden unabh\xe4ngig von Nutzerdaten gespeichert. Aggregierte Daten sind eine Zusammenschmelzung von Einzeldaten zu einer gr\xf6\xdferen Einheit."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Wie kann ich meine Daten l\xf6schen bzw. die Datenspeicherung verhindern?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Nach dem Datenschutzrecht der Europ\xe4ischen Union haben Sie das Recht, Auskunft \xfcber Ihre Daten zu erhalten, sie zu aktualisieren, zu l\xf6schen oder zu limitieren. Mithilfe des Browser-Add-ons zur Deaktivierung von Google Analytics-JavaScript (ga.js, analytics.js, dc.js) verhindern Sie, dass Google Analytics Ihre Daten verwendet. Das Browser-Add-on k\xf6nnen Sie unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://tools.google.com/dlpage/gaoptout?hl=de",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "https://tools.google.com/dlpage/gaoptout?hl=de"
                    }),
                    " ",
                    "runterladen und installieren. Beachten Sie bitte, dass durch dieses Add-on nur die Datenerhebung durch Google Analytics deaktiviert wird."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Falls Sie grunds\xe4tzlich Cookies deaktivieren, l\xf6schen oder verwalten wollen, finden Sie unter dem Abschnitt \u201ECookies\u201C die entsprechenden Links zu den jeweiligen Anleitungen der bekanntesten Browser."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Der Einsatz von Google Analytics setzt Ihre Einwilligung voraus, welche wir mit unserem Cookie Popup eingeholt haben. Diese Einwilligung stellt laut",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)"
                    }),
                    "die Rechtsgrundlage f\xfcr die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung durch Web-Analytics Tools vorkommen kann, dar."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Zus\xe4tzlich zur Einwilligung besteht von unserer Seite ein berechtigtes Interesse daran, dass Verhalten der Websitebesucher zu analysieren und so unser Angebot technisch und wirtschaftlich zu verbessern. Mit Hilfe von Google Analytics erkennen wir Fehler der Website, k\xf6nnen Attacken identifizieren und die Wirtschaftlichkeit verbessern. Die Rechtsgrundlage daf\xfcr ist",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                    }),
                    ". Wir setzen Google Analytics gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Google verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf hin, dass nach Meinung des Europ\xe4ischen Gerichtshofs derzeit kein angemessenes Schutzniveau f\xfcr den Datentransfer in die USA besteht. Dies kann mit verschiedenen Risiken f\xfcr die Rechtm\xe4\xdfigkeit und Sicherheit der Datenverarbeitung einhergehen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Als Grundlage der Datenverarbeitung bei Empf\xe4ngern mit Sitz in Drittstaaten (au\xdferhalb der Europ\xe4ischen Union, Island, Liechtenstein, Norwegen, also insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses \u2013 SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass Ihre Daten auch dann den europ\xe4ischen Datenschutzstandards entsprechen, wenn diese in Drittl\xe4nder (wie beispielsweise in die USA) \xfcberliefert und dort gespeichert werden. Durch diese Klauseln verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten, das europ\xe4ische Datenschutzniveau zu wahren, selbst wenn die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf einem Durchf\xfchrungsbeschluss der EU-Kommission. Sie finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a. hier:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de",
                        target: "_blank",
                        rel: "noopener",
                        children: "https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing Terms), welche auf die Standardvertragsklauseln verweisen, finden Sie unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://business.safety.google/intl/de/adsprocessorterms/",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://business.safety.google/intl/de/adsprocessorterms/"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wir hoffen, wir konnten Ihnen die wichtigsten Informationen rund um die Datenverarbeitung von Google Analytics n\xe4herbringen. Wenn Sie mehr \xfcber den Tracking-Dienst erfahren wollen, empfehlen wir diese beiden Links:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://marketingplatform.google.com/about/analytics/terms/de/",
                        children: "https://marketingplatform.google.com/about/analytics/terms/de/"
                    }),
                    " ",
                    "und",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://support.google.com/analytics/answer/6004245?hl=de",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "https://support.google.com/analytics/answer/6004245?hl=de"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "google-analytics-berichte-zu-demografischen-merkmalen-und-interessen",
                children: "Google Analytics Berichte zu demografischen Merkmalen und Interessen"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wir haben in Google Analytics die Funktionen f\xfcr Werbeberichte eingeschaltet. Die Berichte zu demografischen Merkmalen und Interessen enthalten Angaben zu Alter, Geschlecht und Interessen. Damit k\xf6nnen wir uns \u2013 ohne diese Daten einzelnen Personen zuordnen zu k\xf6nnen \u2013 ein besseres Bild von unseren Nutzern machen. Mehr \xfcber die Werbefunktionen erfahren Sie auf",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://support.google.com/analytics/answer/3450482?hl=de",
                        children: "https://support.google.com/analytics/answer/3450482?hl=de"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Sie k\xf6nnen die Nutzung der Aktivit\xe4ten und Informationen Ihres Google Kontos unter \u201CEinstellungen f\xfcr Werbung\u201D auf",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://adssettings.google.com/authenticated",
                        children: "https://adssettings.google.com/authenticated"
                    }),
                    " ",
                    "per Checkbox beenden."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "google-analytics-im-einwilligungsmodus",
                children: "Google Analytics im Einwilligungsmodus"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Abh\xe4ngig von Ihrer Einwilligung werden im sogenannten Einwilligungsmodus (bzw. \u201EConsent Mode\u201C) personenbezogene Daten von Ihnen durch Google Analytics verarbeitet. Sie k\xf6nnen w\xe4hlen, ob Sie Google-Analytics-Cookies zustimmen oder nicht. Damit w\xe4hlen Sie auch, welche Daten Google Analytics von Ihnen verarbeitet darf. Diese erhobenen Daten werden haupts\xe4chlich daf\xfcr verwendet, Messungen \xfcber das Userverhalten auf der Website durchzuf\xfchren, zielgerichtete Werbung auszuspielen und uns Web-Analyseberichte zu liefern. In der Regel willigen Sie der Datenverarbeitung durch Google \xfcber ein Cookie-Consent-Tool ein. Wenn Sie der Datenverarbeitung nicht einwilligen, werden nur aggregierte Daten erfasst und verarbeitet. Das bedeutet, Daten k\xf6nnen einzelnen Usern nicht zugeordnet werden und es entsteht somit kein Userprofil von Ihnen. Sie k\xf6nnen auch nur der statistischen Messung zustimmen. Dabei werden keine personenbezogenen Daten verarbeitet und folglich nicht f\xfcr Werbungen oder Werbemesserfolge verwendet."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Tracking mit Hotjar"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir nutzen Hotjar, um die Bed\xfcrfnisse unserer Nutzer besser zu verstehen und das Angebot und die Erfahrung auf dieser Webseite zu optimieren. Mithilfe der Technologie von Hotjar bekommen wir ein besseres Verst\xe4ndnis von den Erfahrungen unserer Nutzer (z.B. wieviel Zeit Nutzer auf welchen Seiten verbringen, welche Links sie anklicken, was sie m\xf6gen und was nicht etc.) und das hilft uns, unser Angebot am Feedback unserer Nutzer auszurichten. Hotjar arbeitet mit Cookies und anderen Technologien, um Daten \xfcber das Verhalten unserer Nutzer und \xfcber ihre Endger\xe4te zu erheben, insbesondere IP Adresse des Ger\xe4ts (wird w\xe4hrend Ihrer Website-Nutzung nur in anonymisierter Form erfasst und gespeichert), Bildschirmgr\xf6\xdfe, Ger\xe4tetyp (Unique Device Identifiers), Informationen \xfcber den verwendeten Browser, Standort (nur Land), zum Anzeigen unserer Webseite bevorzugte Sprache. Hotjar speichert diese Informationen in unserem Auftrag in einem pseudonymisierten Nutzerprofil. Hotjar ist es vertraglich verboten, die in unserem Auftrag erhobenen Daten zu verkaufen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Weitere Informationen finden Sie in unter dem Abschnitt \u201Aabout Hotjar\u2018 auf",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://help.hotjar.com/hc/en-us/categories/115001323967-About-Hotjar",
                        target: "_blank",
                        rel: "nofollow noopener noreferrer",
                        children: "Hotjars Hilfe-Seite"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {}),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "e-mail-marketing-einleitung",
                children: "E-Mail-Marketing Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "E-Mail-Marketing Zusammenfassung"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Newsletter-Abonnenten",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Direktwerbung per E-Mail, Benachrichtigung \xfcber systemrelevante Ereignisse",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Eingegebene Daten bei der Registrierung jedoch mindestens die E-Mail-Adresse. Mehr Details dazu finden Sie beim jeweils eingesetzten E-Mail-Marketing-Tool.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: Dauer des Bestehens des Abonnements",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist E-Mail-Marketing?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Um Sie stets auf dem Laufenden zu halten, nutzen wir auch die M\xf6glichkeit des E-Mail-Marketings. Dabei werden, sofern Sie dem Empfang unserer E-Mails bzw. Newsletter zugestimmt haben, auch Daten von Ihnen verarbeitet und gespeichert. E-Mail-Marketing ist ein Teilbereich des Online-Marketings. Dabei werden Neuigkeiten oder allgemeine Informationen \xfcber ein Unternehmen, Produkte oder Dienstleistungen per E-Mail an eine bestimmte Gruppe an Menschen, die sich daf\xfcr interessieren, gesendet."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie an unserem E-Mail-Marketing (meist per Newsletter) teilnehmen wollen, m\xfcssen Sie sich im Normalfall einfach nur mit Ihrer E-Mail-Adresse anmelden. Daf\xfcr f\xfcllen Sie ein Online-Formular aus und senden es ab. Es kann aber auch vorkommen, dass wir Sie etwa um Ihre Anrede und Ihren Namen bitten, damit wir Sie auch pers\xf6nlich anschreiben k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Grunds\xe4tzlich funktioniert das Anmelden zu Newslettern mit Hilfe des sogenannten \u201EDouble-Opt-In-Verfahrens\u201C. Nachdem Sie sich f\xfcr unseren Newsletter auf unserer Website angemeldet haben, bekommen Sie eine E-Mail, \xfcber die Sie die Newsletter-Anmeldung best\xe4tigen. So wird sichergestellt, dass Ihnen die E-Mail-Adresse geh\xf6rt und sich niemand mit einer fremden E-Mail-Adresse angemeldet hat. Wir oder ein von uns verwendetes Benachrichtigungs-Tool protokolliert jede einzelne Anmeldung. Dies ist n\xf6tig, damit wir den rechtlich korrekten Anmeldevorgang auch nachweisen k\xf6nnen. Dabei wird in der Regel der Zeitpunkt der Anmeldung, der Zeitpunkt der Anmeldebest\xe4tigung und Ihre IP-Adresse gespeichert. Zus\xe4tzlich wird auch protokolliert, wenn Sie \xc4nderungen Ihrer gespeicherten Daten vornehmen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum nutzen wir E-Mail-Marketing?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir wollen nat\xfcrlich mit Ihnen in Kontakt bleiben und Ihnen stets die wichtigsten Neuigkeiten \xfcber unser Unternehmen pr\xe4sentieren. Daf\xfcr nutzen wir unter anderem E-Mail-Marketing \u2013 oft auch nur \u201CNewsletter\u201D bezeichnet \u2013 als wesentlichen Bestandteil unseres Online-Marketings. Sofern Sie sich damit einverstanden erkl\xe4ren oder es gesetzlich erlaubt ist, schicken wir Ihnen Newsletter, System-E-Mails oder andere Benachrichtigungen per E-Mail. Wenn wir im folgenden Text den Begriff \u201ENewsletter\u201C verwenden, meinen wir damit haupts\xe4chlich regelm\xe4\xdfig versandte E-Mails. Nat\xfcrlich wollen wir Sie mit unseren Newsletter in keiner Weise bel\xe4stigen. Darum sind wir wirklich stets bem\xfcht, nur relevante und interessante Inhalte zu bieten. So erfahren Sie etwa mehr \xfcber unser Unternehmen, unsere Leistungen oder Produkte. Da wir unsere Angebote auch immer verbessern, erfahren Sie \xfcber unseren Newsletter auch immer, wenn es Neuigkeiten gibt oder wir gerade spezielle, lukrative Aktionen anbieten. Sofern wir einen Dienstleister, der ein professionelles Versand-Tool anbietet, f\xfcr unser E-Mail-Marketing beauftragen, machen wir das, um Ihnen schnelle und sichere Newsletter bieten zu k\xf6nnen. Zweck unseres E-Mail-Marketings ist grunds\xe4tzlich, Sie \xfcber neue Angebote zu informieren und auch unseren unternehmerischen Zielen n\xe4her zu kommen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie \xfcber unsere Website Abonnent unseres Newsletters werden, best\xe4tigen Sie per E-Mail die Mitgliedschaft in einer E-Mail-Liste. Neben IP-Adresse und E-Mail-Adresse k\xf6nnen auch Ihre Anrede, Ihr Name, Ihre Adresse und Ihre Telefonnummer gespeichert werden. Allerdings nur, wenn Sie dieser Datenspeicherungen zustimmen. Die als solche markierten Daten sind notwendig, damit Sie an dem angebotenen Dienst teilnehmen k\xf6nnen. Die Angabe ist freiwillig, die Nichtangabe f\xfchrt jedoch dazu, dass Sie den Dienst nicht nutzen k\xf6nnen. Zus\xe4tzlich k\xf6nnen etwa auch Informationen zu Ihrem Ger\xe4t oder zu Ihren bevorzugten Inhalten auf unserer Website gespeichert werden. Mehr zur Speicherung von Daten, wenn Sie eine Website besuchen, finden Sie im Abschnitt \u201CAutomatische Datenspeicherung\u201D. Ihre Einwilligungserkl\xe4rung zeichnen wir auf, damit wir stets nachweisen k\xf6nnen, dass dieser unseren Gesetzen entspricht."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Dauer der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie Ihre E-Mail-Adresse aus unserem E-Mail/Newsletter-Verteiler austragen, d\xfcrfen wir Ihre Adresse bis zu drei Jahren auf Grundlage unserer berechtigten Interessen speichern, damit wir Ihre damalige Einwilligung noch nachweisen k\xf6nnen. Verarbeiten d\xfcrfen wir diese Daten nur, wenn wir uns gegen etwaige Anspr\xfcche wehren m\xfcssen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie allerdings best\xe4tigen, dass Sie uns die Einwilligung zur Newsletter-Anmeldung gegeben haben, k\xf6nnen Sie jederzeit einen individuellen L\xf6schantrag stellen. Widersprechen Sie der Einwilligung dauerhaft, behalten wir uns das Recht vor, Ihre E-Mail-Adresse in einer Sperrliste zu speichern. Solange Sie freiwillig unseren Newsletter abonniert haben, solange behalten wir selbstverst\xe4ndlich auch Ihre E-Mail-Adresse."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben jederzeit die M\xf6glichkeit Ihre Newsletter-Anmeldung zu k\xfcndigen. Daf\xfcr m\xfcssen Sie lediglich Ihre Einwilligung zur Newsletter-Anmeldung widerrufen. Das dauert im Normalfall nur wenige Sekunden bzw. einen oder zwei Klicks. Meistens finden Sie direkt am Ende jeder E-Mail einen Link, um das Newsletter-Abonnement zu k\xfcndigen. Wenn der Link im Newsletter wirklich nicht zu finden ist, kontaktieren Sie uns bitte per Mail und wir werden Ihr Newsletter-Abo unverz\xfcglich k\xfcndigen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Das Versenden unseres Newsletters erfolgt auf Grundlage Ihrer Einwilligung (Artikel 6 Abs. 1 lit. a DSGVO). Das hei\xdft, wir d\xfcrfen Ihnen nur dann einen Newsletter schicken, wenn Sie sich zuvor aktiv daf\xfcr angemeldet haben. Gegebenenfalls k\xf6nnen wir Ihnen auch Werbenachrichten senden, sofern Sie unser Kunde geworden sind und der Verwendung Ihrer E-Mailadresse f\xfcr Direktwerbung nicht widersprochen haben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Informationen zu speziellen E-Mail-Marketing Diensten und wie diese personenbezogene Daten verarbeiten, erfahren Sie \u2013 sofern vorhanden \u2013 in den folgenden Abschnitten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "E-Mail-Marketing mit Brevo (Sendinblue GmbH)"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Brevo ist ein Softwareanbieter f\xfcr E-Mail-Marketing und Customer Relationship Management (CRM). Wir haben mit Brevo einen Auftragsdaten\xadverarbeitungs\xadvertrag (AVV) abgeschlossen. In diesem Vertrag verpflichtet sich Brevo dazu, die Daten unserer Nutzer gem\xe4\xdf DSGVO und deren Datenschutzbestimmungen zu verarbeiten und zu sch\xfctzen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "online-marketing-einleitung",
                children: "Online-Marketing Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Online-Marketing Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Auswertung der Besucherinformationen zur Optimierung des Webangebots.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte der Zugriffe, Ger\xe4tedaten, Zugriffsdauer und Zeitpunkt, Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Auch personenbezogene Daten wie Name oder E-Mail-Adresse k\xf6nnen verarbeitet werden. Mehr Details dazu finden Sie beim jeweils eingesetzten Online-Marketing-Tool.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: abh\xe4ngig von den eingesetzten Online-Marketing-Tools",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit.f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist Online-Marketing?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Unter Online-Marketing bezeichnet man alle Ma\xdfnahmen, die online durchgef\xfchrt werden, um Marketingziele wie etwa die Steigerung der Markenbekanntheit oder einen Gesch\xe4ftsabschluss zu erreichen. Weiters zielen unserer Online-Marketing-Ma\xdfnahmen darauf ab, Menschen auf unsere Website aufmerksam zu machen. Um unser Angebot vielen interessierten Menschen zeigen zu k\xf6nnen, betreiben wir also Online-Marketing. Meistens handelt es sich dabei um Onlinewerbung, Content-Marketing oder Suchmaschinenoptimierung. Damit wir Online-Marketing effizient und zielgerecht einsetzen k\xf6nnen, werden auch personenbezogene Daten gespeichert und verarbeitet. Die Daten helfen uns einerseits unsere Inhalte nur wirklich jenen Personen zu zeigen, die sich daf\xfcr auch interessieren und andererseits k\xf6nnen wir den Werbeerfolg unserer Online-Marketing-Ma\xdfnahmen messen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum nutzen wir Online-Marketing-Tools?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir wollen jedem Menschen, der sich f\xfcr unser Angebot interessiert, unsere Website zeigen. Uns ist bewusst, dass dies ohne bewusst gesetzte Ma\xdfnahmen nicht m\xf6glich ist. Darum machen wir Online-Marketing. Es gibt verschiedene Tools, die uns die Arbeit an unseren Online-Marketing-Ma\xdfnahmen erleichtern und zus\xe4tzlich \xfcber Daten stets Verbesserungsvorschl\xe4ge liefern. So k\xf6nnen wir unsere Kampagnen genauer an unsere Zielgruppe richten. Zweck dieser eingesetzten Online-Marketing-Tools ist also letztlich die Optimierung unseres Angebots."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Damit unser Online-Marketing funktioniert und der Erfolg der Ma\xdfnahmen gemessen werden kann, werden Userprofile erstellt und Daten beispielsweise in Cookies (das sind kleine Text-Dateien) gespeichert. Mit Hilfe dieser Daten k\xf6nnen wir nicht nur Werbung in klassischer Hinsicht schalten, sondern auch direkt auf unserer Website, unsere Inhalte so darstellen, wie es Ihnen am liebsten ist. Daf\xfcr gibt es verschiedene Drittanbieter-Tools, die diese Funktionen anbieten und entsprechend auch Daten von Ihnen sammeln und speichern. In den benannten Cookies wird zum Beispiel gespeichert, welche Webseiten Sie auf unserer Website besucht haben, wie lange Sie diese Seiten angesehen haben, welche Links oder Buttons Sie klicken oder von welcher Website sie zu uns gekommen sind. Zus\xe4tzlich k\xf6nnen auch technische Informationen gespeichert werden. Etwa Ihre IP-Adresse, welchen Browser Sie nutzen, von welchem Endger\xe4t Sie unsere Website besuchen oder die Uhrzeit, wann Sie unserer Website aufgerufen haben und wann Sie sie wieder verlassen haben. Wenn Sie eingewilligt haben, dass wir auch Ihren Standort bestimmen d\xfcrfen, k\xf6nnen wir auch diesen speichern und verarbeiten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Ihre IP-Adresse wird in pseudonymisierter Form (also gek\xfcrzt) gespeichert. Eindeutige Daten, die Sie als Person direkt identifizieren, wie etwa Name, Adresse oder E-Mail-Adresse, werden im Rahmen der Werbe- und Online-Marketing-Verfahren auch nur in pseudonymisierter Form gespeichert. Wir k\xf6nnen Sie also nicht als Person identifizieren, sondern wir haben nur die pseudonymisierten, gespeicherten Informationen in den Userprofilen gespeichert."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die Cookies k\xf6nnen unter Umst\xe4nden auch auf anderen Websites, die mit denselben Werbetools arbeiten, eingesetzt, analysiert und f\xfcr Werbezwecke verwendet werden. Die Daten k\xf6nnen dann auch auf den Servern der Werbetools-Anbieter gespeichert werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "In Ausnahmef\xe4llen k\xf6nnen auch eindeutige Daten (Namen, Mail-Adresse usw.) in den Userprofilen gespeichert werden. Zu dieser Speicherung kommt es etwa, wenn Sie Mitglied eines Social-Media-Kanals sind, dass wir f\xfcr unsere Online-Marketing-Ma\xdfnahmen nutzen und das Netzwerk bereits fr\xfcher eingegangene Daten mit dem Userprofil verbindet."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Bei allen von uns verwendeten Werbetools, die Daten von Ihnen auf deren Servern speichert, erhalten wir immer nur zusammengefasste Informationen und nie Daten, die Sie als Einzelperson erkennbar machen. Die Daten zeigen lediglich, wie gut gesetzte Werbema\xdfnahmen funktionierten. Zum Beispiel sehen wir, welche Ma\xdfnahmen Sie oder andere User dazu bewogen haben, auf unsere Website zu kommen und dort eine Dienstleistung oder ein Produkt zu erwerben. Anhand der Analysen k\xf6nnen wir unser Werbeangebot in Zukunft verbessern und noch genauer an die Bed\xfcrfnisse und W\xfcnsche interessierter Personen anpassen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Dauer der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "\xdcber die Dauer der Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere Informationen dazu haben. Generell verarbeiten wir personenbezogene Daten nur so lange wie es f\xfcr die Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig ist. Daten, die in Cookies gespeichert werden, werden unterschiedlich lange gespeichert. Manche Cookies werden bereits nach dem Verlassen der Website wieder gel\xf6scht, anderen k\xf6nnen \xfcber einige Jahre in Ihrem Browser gespeichert sein. In den jeweiligen Datenschutzerkl\xe4rungen der einzelnen Anbieter erhalten Sie in der Regel genaue Informationen \xfcber die einzelnen Cookies, die der Anbieter verwendet."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben auch jederzeit das Recht und die M\xf6glichkeit Ihre Einwilligung zur Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert entweder \xfcber unser Cookie-Management-Tool oder \xfcber andere Opt-Out-Funktionen. Zum Bespiel k\xf6nnen Sie auch die Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren oder l\xf6schen. Die Rechtm\xe4\xdfigkeit der Verarbeitung bis zum Widerruf bleibt unber\xfchrt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Da bei Online-Marketing-Tools in der Regel Cookies zum Einsatz kommen k\xf6nnen, empfehlen wir Ihnen auch unsere allgemeine Datenschutzerkl\xe4rung \xfcber Cookies. Um zu erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet werden, sollten Sie die Datenschutzerkl\xe4rungen der jeweiligen Tools durchlesen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie eingewilligt haben, dass Drittanbieter eingesetzt werden d\xfcrfen, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Diese Einwilligung stellt laut",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)"
                    }),
                    "die Rechtsgrundlage f\xfcr die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung durch Online-Marketing-Tools vorkommen kann, dar."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Von unserer Seite besteht zudem ein berechtigtes Interesse, Online-Marketing-Ma\xdfnahmen in anonymisierter Form zu messen, um mithilfe der gewonnenen Daten unser Angebot und unsere Ma\xdfnahmen zu optimieren. Die daf\xfcr entsprechende Rechtsgrundlage ist",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                    }),
                    ". Wir setzen die Tools gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Informationen zu speziellen Online-Marketing-Tools erhalten Sie \u2013 sofern vorhanden \u2013 in den folgenden Abschnitten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "partnerprogramme-einleitung",
                children: "Partnerprogramme Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Partnerprogramme Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: wirtschaftlicher Erfolg und die Optimierung unserer Serviceleistung.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte der Zugriffe, Ger\xe4tedaten, Zugriffsdauer und Zeitpunkt, Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Auch personenbezogene Daten wie Name oder E-Mail-Adresse k\xf6nnen verarbeitet werden.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: pers\xf6nliche Daten werden meist von Partnerprogrammen gespeichert, bis diese nicht mehr ben\xf6tigt werden",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was sind Partnerprogramme?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir verwenden auf unserer Website Partnerprogramme unterschiedlicher Anbieter. Durch die Verwendung eines Partnerprogramms k\xf6nnen Daten von Ihnen an den jeweiligen Partnerprogramm-Anbieter \xfcbertragen, gespeichert und verarbeitet werden. In diesem Datenschutztext geben wir Ihnen einen allgemeinen \xdcberblick \xfcber die Datenverarbeitung durch Partnerprogramme und zeigen Ihnen wie Sie eine Daten\xfcbertragung auch unterbinden bzw. widerrufen k\xf6nnen. Jedes Partnerprogramm (auch Affiliateprogramm genannt) basiert auf dem Prinzip der Vermittlungsprovision. Auf unserer Website wird ein Link oder eine Werbung samt Link gesetzt und wenn Sie sich daf\xfcr interessieren und diesen anklicken und ein Produkt oder eine Dienstleistung auf diesem Wege erwerben, erhalten wir daf\xfcr eine Provision (Werbekostenerstattung)"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verwenden wir Partnerprogramme auf unserer Website?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Unser Ziel ist es, Ihnen eine angenehme Zeit mit vielen hilfreichen Inhalten zu liefern. Daf\xfcr stecken wir sehr viel Arbeit und Zeit in die Entwicklung unserer Website. Mit Hilfe von Partnerprogrammen haben wir die M\xf6glichkeit, f\xfcr unsere Arbeit auch ein bisschen entlohnt zu werden. Jeder Partnerlink hat selbstverst\xe4ndlich immer mit unserem Thema zu tun und zeigt Angebote, die Sie interessieren k\xf6nnten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Damit nachvollzogen werden kann, ob Sie einen von uns eingesetzten Link angeklickt haben, muss der Partnerprogramm-Anbieter erfahren, dass Sie es waren, die \xfcber unsere Website den Link gefolgt ist. Es muss also eine korrekte Zuordnung der eingesetzten Partnerprogramm-Links zu den folgenden Aktionen (Gesch\xe4ftsabschluss, Kauf, Conversion, Impression usw.) erfolgen. Nur dann kann auch die Abrechnung der Provisionen funktionieren."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Damit diese Zuordnung funktioniert, kann einem Link ein Wert angeh\xe4ngt werden (in der URL) oder Informationen in Cookies gespeichert werden. Darin wird etwa gespeichert, von welcher Seite Sie kommen (Referrer), wann Sie auf den Link geklickt haben, eine Kennung unserer Website, um welches Angebot es sich handelt und eine User-Kennung."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Das bedeutet, sobald Sie mit Produkten und Dienstleistungen eines Partnerprogramms interagieren, erhebt dieser Anbieter auch Daten von Ihnen. Welche Daten genau gespeichert werden, h\xe4ngt von den einzelnen Anbietern ab. Beispielsweise unterscheidet das Amazon-Partnerprogramm zwischen aktiven und automatischen Informationen. Zu den aktiven z\xe4hlen Name, E-Mail-Adresse, Telefonnummer, Alter, Zahlungsinformationen oder Standortinformationen. Zu den automatisch gespeicherten Informationen z\xe4hlen in diesem Fall Userverhalten, IP-Adresse, Ger\xe4teinformationen und die URL."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Dauer der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "\xdcber die Dauer der Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere Informationen dazu haben. Generell werden personenbezogene Daten nur so lange verarbeitet, wie es f\xfcr die Bereitstellung der Dienstleistungen und Produkte notwendig ist. Daten, die in Cookies gespeichert werden, werden unterschiedlich lange gespeichert. Manche Cookies werden bereits nach dem Verlassen der Website wieder gel\xf6scht, andere k\xf6nnen, sofern diese nicht aktiv gel\xf6scht werden, \xfcber einige Jahre in Ihrem Browser gespeichert sein. Die genaue Dauer der Datenverarbeitung h\xe4ngt vom verwendeten Anbieter ab, meistens sollten Sie sich auf eine Speicherdauer von mehreren Jahren einstellen. In den jeweiligen Datenschutzerkl\xe4rungen der einzelnen Anbieter erhalten Sie in der Regel genaue Informationen \xfcber die Dauer der Datenverarbeitung."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben immer das Recht auf Auskunft, Berichtigung und L\xf6schung Ihrer personenbezogenen Daten. Bei Fragen k\xf6nnen Sie auch jederzeit Verantwortliche des verwendeten Partnerprogramm-Anbieters kontaktieren. Kontaktdaten finden Sie entweder in unserer spezifischen Datenschutzerkl\xe4rung oder auf der Website des entsprechenden Anbieters."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Cookies, die Anbieter f\xfcr ihre Funktionen verwenden, k\xf6nnen Sie in Ihrem Browser l\xf6schen, deaktivieren oder verwalten. Je nachdem welchen Browser Sie verwenden, funktioniert dies auf unterschiedliche Art und Weise."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie eingewilligt haben, dass Partnerprogramme eingesetzt werden d\xfcrfen, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Diese Einwilligung stellt laut",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)"
                    }),
                    " die Rechtsgrundlage f\xfcr die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung durch ein Partnerprogramm vorkommen kann, dar."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Von unserer Seite besteht zudem ein berechtigtes Interesse, ein Partnerprogramm zu verwenden, um unser Online-Service und unsere Marketingma\xdfnahmen zu optimieren. Die daf\xfcr entsprechende Rechtsgrundlage ist",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                    }),
                    ". Wir setzen das Partnerprogramm gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Informationen zu speziellen Partnerprogramme, erhalten Sie \u2013 sofern vorhanden \u2013 in den folgenden Abschnitten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "amazon-partnerprogramm-datenschutzerklaerung",
                children: "Amazon-Partnerprogramm Datenschutzerkl\xe4rung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Amazon-Partnerprogramm Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: wirtschaftlicher Erfolg und die Optimierung unserer Serviceleistung.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte der Zugriffe, Ger\xe4tedaten, Zugriffsdauer und Zeitpunkt, Navigationsverhalten, Klickverhalten und IP-Adressen enthalten. Auch personenbezogene Daten wie Name oder E-Mail-Adresse k\xf6nnen verarbeitet werden.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: pers\xf6nliche Daten werden von Amazon gespeichert, bis diese nicht mehr ben\xf6tigt werden",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit.f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist das Amazon-Partnerprogramm?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir verwenden auf unserer Website das Amazon-Partnerprogramm des Unternehmens Amazon.com, Inc. Die verantwortlichen Stellen im Sinne der Datenschutzerkl\xe4rung sind die Amazon Europe Core S.\xe0.r.l., die Amazon EU S.\xe0.r.l, die Amazon Services Europe S.\xe0.r.l. und die Amazon Media EU S.\xe0.r.l., alle vier ans\xe4ssig 5, Rue Plaetis, L-2338 Luxemburg sowie Amazon Instant Video Germany GmbH, Domagkstr. 28, 80807 M\xfcnchen. Als Datenverarbeiter wird die Amazon Deutschland Services GmbH, Marcel-Breuer-Str. 12, 80807 M\xfcnchen, t\xe4tig. Durch die Verwendung dieses Amazon-Partnerprogramms k\xf6nnen Daten von Ihnen an Amazon \xfcbertragen, gespeichert und verarbeitet werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "In dieser Datenschutzerkl\xe4rung informieren wir Sie um welche Daten es sich handelt, warum wir das Programm verwenden und wie Sie die Daten\xfcbertragung verwalten bzw. unterbinden k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Das Amazon-Partnerprogramm ist ein Affiliate-Marketing-Programm des Online-Versandunternehmens",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.amazon.de/ref=as_li_ss_tl?site-redirect=at&linkCode=ll2&tag=thetraffic-21&linkId=16a65fb03b8cb39206283c5345d87944&language=de_DE&tid=312394123",
                        target: "_blank",
                        rel: "follow noopener noreferrer",
                        children: "Amazon.de"
                    }),
                    " ",
                    ". Wie jedes Affiliate-Programm basiert auch das Amazon-Partnerprogramm auf dem Prinzip der Vermittlungsprovision. Amazon bzw. wir platzieren auf unserer Website Werbung oder Partnerlinks und wenn Sie darauf klicken und ein Produkt \xfcber Amazon kaufen, erhalten wir eine Werbekostenerstattung (Provision)."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verwenden wir das Amazon-Partnerprogramm auf unserer Website?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Unser Ziel ist es Ihnen eine angenehme Zeit mit vielen hilfreichen Inhalten zu liefern. Daf\xfcr stecken wir sehr viel Arbeit und Energie in die Entwicklung unserer Website. Mit Hilfe des Amazon-Partnerprogramms haben wir die M\xf6glichkeit, f\xfcr unsere Arbeit auch ein bisschen entlohnt zu werden. Jeder Partnerlink zu Amazon hat selbstverst\xe4ndlich immer mit unserem Thema zu tun und zeigt Angebote, die Sie interessieren k\xf6nnten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden durch das Amazon-Partnerprogramm gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sobald Sie mit den Produkten und Dienstleistungen von Amazon interagieren, erhebt Amazon Daten von Ihnen. Amazon unterscheidet zwischen Informationen, die Sie aktiv dem Unternehmen geben und Informationen, die automatisch gesammelt und gespeichert werden. Zu den \u201Caktiven Informationen\u201D z\xe4hlen zum Beispiel Name, E-Mail-Adresse, Telefonnummer, Alter, Zahlungsinformationen oder Standortinformationen. Sogenannte \u201Eautomatische Informationen\u201C werden in erster Linie \xfcber Cookies gespeichert. Dazu z\xe4hlen Informationen zum Userverhalten, IP-Adresse, Ger\xe4tinformationen (Browsertyp, Standort, Betriebssysteme) oder die URL. Amazon speichert weiters auch den Clickstream. Damit ist der Weg (Reihenfolge der Seiten) gemeint, den Sie als User zur\xfccklegen, um zu einem Produkt zu kommen. Auch um die Herkunft einer Bestellung nachvollziehen zu k\xf6nnen, speichert Amazon Cookies in Ihrem Browser. So erkennt das Unternehmen, dass Sie \xfcber unsere Website eine Amazon-Werbeanzeige oder einen Partnerlink angeklickt haben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie ein Amazon-Konto haben und angemeldet sind, w\xe4hrend Sie auf unserer Webseite surfen, k\xf6nnen die erhobenen Daten Ihrem Account zugewiesen werden. Das verhindern Sie, indem Sie sich bei Amazon abmelden, bevor Sie auf unserer Website surfen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Hier zeigen wir Ihnen beispielhafte Cookies, die in Ihrem Browser gesetzt werden, wenn Sie auf unserer Website auf einen Amazon-Link klicken."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name"
                    }),
                    ": uid",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "3230928052675285215312394123-9",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck: "
                    }),
                    "Dieses Cookie speichert eine eindeutige User-ID und sammelt Informationen \xfcber Ihre Websiteaktivit\xe4t.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Monaten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name"
                    }),
                    ": ad-id",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "AyDaInRV1k-Lk59xSnp7h5o",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck: "
                    }),
                    "Dieses Cookie wird von amazon-adsystem.com zur Verf\xfcgung gestellt und dient dem Unternehmen f\xfcr verschiedene Werbezwecke.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 8 Monaten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name"
                    }),
                    ": uuid2",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "8965834524520213028312394123-2",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck: "
                    }),
                    "Dieses Cookie erm\xf6glicht gezielte und interessensbezogene Werbung \xfcber die AppNexus-Plattform. Das Cookie sammelt und speichert \xfcber die IP-Adresse beispielsweise anonyme Daten dar\xfcber, welche Werbung Sie angeklickt haben und welche Seiten Sie aufgerufen haben.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 3 Monaten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name"
                    }),
                    ": session-id",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "262-0272718-2582202312394123-1",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck: "
                    }),
                    "Dieses Cookie speichert eine eindeutige User-ID, die der Server Ihnen f\xfcr die Dauer eines Websitebesuchs (Session) zuweist. Besuchen Sie dieselbe Seite wieder, werden die darin gespeichert Information wieder abgerufen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 15 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name"
                    }),
                    ": APID",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "UP9801199c-4bee-11ea-931d-02e8e13f0574",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck: "
                    }),
                    "Dieses Cookie speichert Informationen dar\xfcber, wie Sie eine Website nutzen und welche Werbung Sie vor dem Websitebesuch angesehen haben.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach einem Jahr"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name"
                    }),
                    ": session-id-time",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "tb:s-STNY7ZS65H5335FZEVPE|1581329862486&t:1581329864300&adb:adblk_no",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck: "
                    }),
                    "Dieses Cookie erfasst die Zeit, die Sie mit einer eindeutigen Cookie-ID auf einer Webseite verbringen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name"
                    }),
                    ": csm-hit",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert: "
                    }),
                    "2082754801l",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck: "
                    }),
                    "Wir k\xf6nnten \xfcber dieses Cookie keine genauen Informationen in Erfahrung bringen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 15 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Anmerkung: "
                    }),
                    "Bitte beachten Sie, dass diese Liste lediglich Cookie-Beispiele zeigt und keinen Anspruch auf Vollst\xe4ndigkeit erheben kann."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Amazon nutzt diese erhaltenen Informationen, um Werbeanzeigen genauer an die Interessen der User abzustimmen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Wie lange und wo werden die Daten gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Pers\xf6nliche Daten werden von Amazon so lange gespeichert, wie es f\xfcr die gesch\xe4ftlichen Dienste von Amazon erforderlich ist oder aus rechtlichen Gr\xfcnden notwendig ist. Da das Unternehmen Amazon seinen Hauptsitz in den USA hat, werden die gesammelten Daten auch auf amerikanischen Servern gespeichert."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Wie kann ich meine Daten l\xf6schen bzw. die Datenspeicherung verhindern?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten zuzugreifen und sie auch zu l\xf6schen. Wenn Sie einen Amazon-Account besitzen, k\xf6nnen Sie in Ihrem Account viele der erhobenen Daten verwalten oder l\xf6schen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Eine weitere Option, die Datenverarbeitung und -speicherung durch Amazon nach Ihren Vorlieben zu verwalten, bietet Ihr Browser. Dort k\xf6nnen Sie Cookies verwalten, deaktivieren oder l\xf6schen. Dies funktioniert bei jedem Browser ein bisschen anders. Unter dem Abschnitt \u201ECookies\u201C finden Sie die entsprechenden Links zu den jeweiligen Anleitungen der bekanntesten Browser."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie eingewilligt haben, dass das Amazon-Partnerprogramm eingesetzt werden darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Diese Einwilligung stellt laut",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: " Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)"
                    }),
                    "die Rechtsgrundlage f\xfcr die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung durch das Amazon-Partnerprogramm vorkommen kann, dar."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Von unserer Seite besteht zudem ein berechtigtes Interesse, das Amazon-Partnerprogramm zu verwenden, um unser Online-Service und unsere Marketingma\xdfnahmen zu optimieren. Die daf\xfcr entsprechende Rechtsgrundlage ist",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                    }),
                    ". Wir setzen das Amazon-Partnerprogramm gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Amazon verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf hin, dass nach Meinung des Europ\xe4ischen Gerichtshofs derzeit kein angemessenes Schutzniveau f\xfcr den Datentransfer in die USA besteht. Dies kann mit verschiedenen Risiken f\xfcr die Rechtm\xe4\xdfigkeit und Sicherheit der Datenverarbeitung einhergehen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Als Grundlage der Datenverarbeitung bei Empf\xe4ngern mit Sitz in Drittstaaten (au\xdferhalb der Europ\xe4ischen Union, Island, Liechtenstein, Norwegen, also insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Amazon sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses \u2013 SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass Ihre Daten auch dann den europ\xe4ischen Datenschutzstandards entsprechen, wenn diese in Drittl\xe4nder (wie beispielsweise in die USA) \xfcberliefert und dort gespeichert werden. Durch diese Klauseln verpflichtet sich Amazon, bei der Verarbeitung Ihrer relevanten Daten, das europ\xe4ische Datenschutzniveau zu wahren, selbst wenn die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf einem Durchf\xfchrungsbeschluss der EU-Kommission. Sie finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a. hier:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Die Amazon Datenverarbeitungsbedingung (AWS GDPR DATA PROCESSING), welche den Standardvertragsklauseln entsprechen, finden Sie unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://d1.awsstatic.com/legal/aws-gdpr/AWS_GDPR_DPA.pdf",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://d1.awsstatic.com/legal/aws-gdpr/AWS_GDPR_DPA.pdf"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wir hoffen, wir haben Ihnen die wichtigsten Informationen \xfcber die Daten\xfcbertragung durch die Verwendung von dem Amazon-Partnerprogramm n\xe4hergebracht. Mehr Informationen finden Sie unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "ebay-partner-network-datenschutzerklaerung",
                children: "eBay Partner Network Datenschutzerkl\xe4rung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir nutzen f\xfcr unsere Website das Partnerprogramm von eBay. Dienstanbieter ist das amerikanische Unternehmen: eBay Partner Network, Inc., 2145 Hamilton Ave., San Jose, CA 95125, USA."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "eBay verarbeitet Daten u.a. auch in den USA. Wir weisen darauf hin, dass nach Meinung des Europ\xe4ischen Gerichtshofs derzeit kein angemessenes Schutzniveau f\xfcr den Datentransfer in die USA besteht. Dies kann mit verschiedenen Risiken f\xfcr die Rechtm\xe4\xdfigkeit und Sicherheit der Datenverarbeitung einhergehen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Als Grundlage der Datenverarbeitung bei Empf\xe4ngern mit Sitz in Drittstaaten (au\xdferhalb der Europ\xe4ischen Union, Island, Liechtenstein, Norwegen, also insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet eBay von der EU-Kommission genehmigte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO). Diese Klauseln verpflichten eBay, das EU-Datenschutzniveau bei der Verarbeitung relevanter Daten auch au\xdferhalb der EU zu wahren. Diese Klauseln basieren auf einem Durchf\xfchrungsbeschluss der EU-Kommission. Sie finden den Beschluss sowie die Klauseln u.a. hier:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://germany.representation.ec.europa.eu/index_de",
                        children: "https://germany.representation.ec.europa.eu/index_de"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Mehr \xfcber die Daten, die durch die Verwendung von eBay Partner Network verarbeitet werden, erfahren Sie in der Datenschutzerkl\xe4rung auf",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://partnernetwork.ebay.de/page/network-agreement#privacy-policy",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://partnernetwork.ebay.de/page/network-agreement#privacy-policy"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "content-delivery-networks-einleitung",
                children: "Content Delivery Networks Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Content Delivery Networks Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Optimierung unserer Serviceleistung (um die Website schneller laden zu k\xf6nnen)",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Daten wie etwa Ihre IP-Adresse",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "Mehr Details dazu finden Sie weiter unten und den einzelnen Datenschutztexten.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: meisten werden die Daten solange gespeichert, bis sie zur Erf\xfcllung der Dienstleistung nicht mehr ben\xf6tigt werden",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist ein Content Delivery Network?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir nutzen auf unserer Website ein sogenanntes Content Delivery Network. Meistens wird ein solchen Netzwerk nur CDN genannt. Ein CDN hilft uns, unsere Website, unabh\xe4ngig von Ihrem Standort, schnell und problemlos zu laden. Dabei werden auch personenbezogene Daten von Ihnen auf den Servern des eingesetzten CDN-Anbieters gespeichert, verwaltet und verarbeitet. Nachfolgend gehen wir allgemein n\xe4her auf den Dienst und dessen Datenverarbeitung ein. Genaue Informationen \xfcber den Umgang mit Ihren Daten finden Sie in der jeweiligen Datenschutzerkl\xe4rung des Anbieters."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Jedes Content Delivery Network (CDN) ist ein Netzwerk regional verteilter Server, die alle \xfcber das Internet miteinander verbunden sind. \xdcber dieses Netzwerk k\xf6nnen Inhalte von Websites (speziell auch sehr gro\xdfe Dateien) auch bei gro\xdfen Lastspitzen schnell und reibungslos ausgeliefert werden. Das CDN legt daf\xfcr eine Kopie unserer Website auf Ihren Servern an. Da diese Server weltweit verteilt sind, kann die Website schnell ausgeliefert werden. Die Daten\xfcbertragung zu Ihrem Browser wird folglich durch das CDN deutlich verk\xfcrzt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verwenden wir ein Content Delivery Network f\xfcr unsere Website?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Eine schnell ladende Website ist Teil unserer Dienstleistung. Wir wissen nat\xfcrlich, wie nervig es ist, wenn eine Website im Schneckentempo l\xe4dt. Meist verliert man sogar die Geduld und sucht das Weite, bevor die Website vollst\xe4ndig geladen ist. Das wollen wir nat\xfcrlich vermeiden. Daher geh\xf6rt eine schnell ladende Website ganz selbstverst\xe4ndlich zu unserem Websiteangebot. Mit einem Content Delivery Network wird in Ihrem Browser unsere Website deutlich schneller geladen. Besonders hilfreich ist der Einsatz des CDNs wenn Sie im Ausland sind, weil die Website von einem Server in Ihrer N\xe4he ausgeliefert wird."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie eine Website bzw. die Inhalte einer Website anfordern und diese in einem CDN zwischengespeichert sind, leitet das CDN die Anforderung an den von Ihnen am n\xe4chsten gelegenen Server und dieser liefert die Inhalte aus. Content Delivery Networks sind so aufgebaut, dass JavaScript-Bibliotheken heruntergeladen werden k\xf6nnen und auf npm- und Github-Servern gehostet werden. Alternativ k\xf6nnen bei den meisten CDNs auch WordPress-Plugins geladen werden, wenn diese auf",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://wordpress.org/",
                        target: "_blank",
                        rel: "noopener",
                        children: "WordPress.org"
                    }),
                    " ",
                    "gehostet werden. Ihr Browser kann personenbezogene Daten an das von uns eingesetzte Content Delivery Network senden. Dabei handelt es sich etwa um Daten wie IP-Adresse, Browsertyp, Browserversion, welche Webseite geladen wird oder Uhrzeit und Datum des Seitenbesuchs. Diese Daten werden vom CDN gesammelt und auch gespeichert. Ob zur Datenspeicherung Cookies verwendet werden, h\xe4ngt von dem eingesetzten Network ab. Bitte lesen Sie sich daf\xfcr die Datenschutztexte des jeweiligen Dienstes durch."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Falls Sie diese Daten\xfcbertragung vollkommen unterbinden wollen, k\xf6nnen Sie einen JavaScript-Blocker (siehe beispielsweise",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://noscript.net/",
                        target: "_blank",
                        rel: "noopener",
                        children: "https://noscript.net/"
                    }),
                    " ",
                    ") auf Ihrem PC installieren. Nat\xfcrlich kann dann unsere Website nicht mehr das gewohnte Service (wie beispielsweise eine schnelle Ladegeschwindigkeit) bieten."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie eingewilligt haben, dass ein Content Delivery Network eingesetzt werden darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Diese Einwilligung stellt laut",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)"
                    }),
                    " die Rechtsgrundlage f\xfcr die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung durch ein Content Delivery Network vorkommen kann, dar."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Von unserer Seite besteht zudem ein berechtigtes Interesse, ein Content Delivery Network zu verwenden, um unser Online-Service zu optimieren und sicherer zu machen. Die daf\xfcr entsprechende Rechtsgrundlage ist",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                    }),
                    ". Wir setzen das Tool gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Informationen zu speziellen Content Delivery Network erhalten Sie \u2013 sofern vorhanden \u2013 in den folgenden Abschnitten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "cookie-consent-management-platform-einleitung",
                children: "Cookie Consent Management Platform Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Cookie Consent Management Platform Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Website Besucher",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Einholung und Verwaltung der Zustimmung zu bestimmten Cookies und somit dem Einsatz bestimmter Tools",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Daten zur Verwaltung der eingestellten Cookie-Einstellungen wie IP-Adresse, Zeitpunkt der Zustimmung, Art der Zustimmung, einzelne Zustimmungen. Mehr Details dazu finden Sie beim jeweils eingesetzten Tool.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: H\xe4ngt vom eingesetzten Tool ab, man muss sich auf Zeitr\xe4ume von mehreren Jahren einstellen",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit.f DSGVO (berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist eine Cookie Consent Manangement Platform?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir verwenden auf unserer Website eine Consent Management Platform (CMP) Software, die uns und Ihnen den korrekten und sicheren Umgang mit verwendeten Skripten und Cookies erleichtert. Die Software erstellt automatisch ein Cookie-Popup, scannt und kontrolliert alle Skripts und Cookies, bietet eine datenschutzrechtlich notwendige Cookie-Einwilligung f\xfcr Sie und hilft uns und Ihnen den \xdcberblick \xfcber alle Cookies zu behalten. Bei den meisten Cookie Consent Management Tools werden alle vorhandenen Cookies identifiziert und kategorisiert. Sie als Websitebesucher entscheiden dann selbst, ob und welche Skripte und Cookies Sie zulassen oder nicht zulassen. Die folgende Grafik stellt die Beziehung zwischen Browser, Webserver und CMP dar."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("img", {
                    role: "img",
                    src: "https://www.adsimple.at/wp-content/uploads/2021/03/consent-management-platform-overview.svg",
                    alt: "Consent Management Platform \xdcberblick",
                    width: "100%"
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verwenden wir ein Cookie-Management-Tool?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Unser Ziel ist es, Ihnen im Bereich Datenschutz die bestm\xf6gliche Transparenz zu bieten. Zudem sind wir dazu auch rechtlich verpflichtet. Wir wollen Sie \xfcber alle Tools und alle Cookies, die Daten von Ihnen speichern und verarbeiten k\xf6nnen, so gut wie m\xf6glich aufkl\xe4ren. Es ist auch Ihr Recht, selbst zu entscheiden, welche Cookies Sie akzeptieren und welche nicht. Um Ihnen dieses Recht zu garantieren, m\xfcssen wir zuerst genau wissen, welche Cookies \xfcberhaupt auf unserer Website gelandet sind. Dank eines Cookie-Management-Tools, welches die Website regelm\xe4\xdfig nach allen vorhandenen Cookies scannt, wissen wir \xfcber alle Cookies Bescheid und k\xf6nnen Ihnen DSGVO-konform Auskunft dar\xfcber geben. \xdcber das Einwilligungssystem k\xf6nnen Sie dann Cookies akzeptieren oder ablehnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Im Rahmen unseres Cookie-Management-Tools k\xf6nnen Sie jedes einzelnen Cookies selbst verwalten und haben die vollst\xe4ndige Kontrolle \xfcber die Speicherung und Verarbeitung Ihrer Daten. Die Erkl\xe4rung Ihrer Einwilligung wird gespeichert, damit wir Sie nicht bei jedem neuen Besuch unserer Website abfragen m\xfcssen und wir Ihre Einwilligung, wenn gesetzlich n\xf6tig, auch nachweisen k\xf6nnen. Gespeichert wird dies entweder in einem Opt-in-Cookie oder auf einem Server. Je nach Anbieter des Cookie-Management-Tools variiert Speicherdauer Ihrer Cookie-Einwilligung. Meist werden diese Daten (etwa pseudonyme User-ID, Einwilligungs-Zeitpunkt, Detailangaben zu den Cookie-Kategorien oder Tools, Browser, Ger\xe4tinformationen) bis zu zwei Jahren gespeichert."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Dauer der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "\xdcber die Dauer der Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere Informationen dazu haben. Generell verarbeiten wir personenbezogene Daten nur so lange wie es f\xfcr die Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig ist. Daten, die in Cookies gespeichert werden, werden unterschiedlich lange gespeichert. Manche Cookies werden bereits nach dem Verlassen der Website wieder gel\xf6scht, andere k\xf6nnen \xfcber einige Jahre in Ihrem Browser gespeichert sein. Die genaue Dauer der Datenverarbeitung h\xe4ngt vom verwendeten Tool ab, meistens sollten Sie sich auf eine Speicherdauer von mehreren Jahren einstellen. In den jeweiligen Datenschutzerkl\xe4rungen der einzelnen Anbieter erhalten Sie in der Regel genaue Informationen \xfcber die Dauer der Datenverarbeitung."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben auch jederzeit das Recht und die M\xf6glichkeit Ihre Einwilligung zur Verwendung von Cookies zu widerrufen. Das funktioniert entweder \xfcber unser Cookie-Management-Tool oder \xfcber andere Opt-Out-Funktionen. Zum Bespiel k\xf6nnen Sie auch die Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren oder l\xf6schen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Informationen zu speziellen Cookie-Management-Tools, erfahren Sie \u2013 sofern vorhanden \u2013 in den folgenden Abschnitten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie Cookies zustimmen, werden \xfcber diese Cookies personenbezogene Daten von Ihnen verarbeitet und gespeichert. Falls wir durch Ihre",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Einwilligung"
                    }),
                    " (Artikel 6 Abs. 1 lit. a DSGVO) Cookies verwenden d\xfcrfen, ist diese Einwilligung auch gleichzeitig die Rechtsgrundlage f\xfcr die Verwendung von Cookies bzw. die Verarbeitung Ihrer Daten. Um die Einwilligung zu Cookies verwalten zu k\xf6nnen und Ihnen die Einwilligung erm\xf6glichen zu k\xf6nnen, kommt eine Cookie-Consent-Management-Platform-Software zum Einsatz. Der Einsatz dieser Software erm\xf6glicht uns, die Website auf effiziente Weise rechtskonform zu betreiben, was ein",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "berechtigtes Interesse"
                    }),
                    " (Artikel 6 Abs. 1 lit. f DSGVO) darstellt."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "externe-onlineplattformen-einleitung",
                children: "Externe Onlineplattformen Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Externe Onlineplattformen Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website bzw. Besucher der externen Onlineplattformen",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Darstellung, Bewertung und Optimierung unserer Serviceleistung, Kontakt zu Besuchern, Interessenten",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Daten wie etwa Telefonnummern, E-Mail-Adressen, Kontaktdaten, Daten zum Nutzerverhalten, Informationen zu Ihrem Ger\xe4t und Ihre IP-Adresse.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "Mehr Details dazu finden Sie bei der jeweils eingesetzten Plattform.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: abh\xe4ngig von den verwendeten Plattformen",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was sind externe Onlineplattformen?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Um unsere Leistungen oder Produkte auch au\xdferhalb unserer Website anbieten zu k\xf6nnen, nutzen wir auch externe Plattformen. Dabei handelt es sich meist um Online-Marktpl\xe4tze wie etwa Amazon oder eBay oder Bewertungsplattformen wie TrustPilot. Neben unserer Verantwortlichkeit des Datenschutzes gelten auch die Datenschutzbestimmungen der von uns verwendeten externen Plattformen. Dies ist speziell dann der Fall, wenn \xfcber die Plattform unsere Produkte erworben werden. Also wenn es einen Zahlungsvorgang gibt. Weiters n\xfctzen die meisten Plattformen Ihre Daten auch, um die eigenen Marketingma\xdfnahmen zu optimieren. Beispielsweise kann die Plattform, mit Hilfe erhobener Daten, Werbeanzeigen genau an die Interessen der Kunden und Websitebesucher zuschneiden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum nutzen wir externe Onlineplattformen?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Neben unserer Website wollen wir unser Angebot auch auf anderen Plattformen anbieten, um mehr Kunden unser Angebot n\xe4her zu bringen. Externe Online-Marktpl\xe4tze wie etwa Amazon oder Ebay bieten gro\xdfe Verkaufswebsites und Bewertungsportale wie TrustPilot erm\xf6glichen es die Reputation unserer Dienstleistungen darzustellen. Es kann auch vorkommen, dass eingebaute Elemente auf unserer Seite zu einer externen Onlineplattform leiten. Daten, die von der verwendeten Onlineplattform verarbeitet und gespeichert werden, dienen dem Unternehmen einerseits den Zahlungsvorgang zu protokollieren, andererseits aber auch um Webanalysen durchf\xfchren zu k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Ziel dieser Analysen ist es, genauere und personenbezogene Marketing- und Werbestrategien entwickeln zu k\xf6nnen. Abh\xe4ngig von Ihrem Verhalten auf einer Plattform, k\xf6nnen mit Hilfe der ausgewerteten Daten, passende R\xfcckschl\xfcsse auf Ihre Interessen getroffen werden und sogenannte Userprofile erstellt werden. So ist es den Plattformen auch m\xf6glich, Ihnen ma\xdfgeschneiderte Werbeanzeigen bzw. Produkte zu pr\xe4sentieren. Meistens werden f\xfcr diesen Zweck Cookies in Ihrem Browser gesetzt, die Daten zu Ihrem Nutzungsverhalten speichern."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Bitte beachten Sie, dass bei der Nutzung der Plattformen oder unserer eingebauten Elemente auch Daten von Ihnen au\xdferhalb der Europ\xe4ischen Union verarbeitet werden k\xf6nnen, da Onlineplattformen, beispielsweise Amazon oder eBay, amerikanische Unternehmen sind. Dadurch k\xf6nnen Sie m\xf6glicherweise Ihre Rechte in Bezug auf Ihre personenbezogenen Daten nicht mehr so leicht einfordern bzw. durchsetzen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden verarbeitet?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Welche Daten genau gespeichert und verarbeitet werden, h\xe4ngt von der jeweiligen externen Plattform ab. Aber f\xfcr gew\xf6hnlich handelt es sich um Daten wie etwa Telefonnummern, E-Mailadressen, Daten, die Sie in ein Kontaktformular eingeben, Nutzerdaten wie zum Beispiel welche Buttons Sie klicken, wann Sie welche Seiten besucht haben, Informationen zu Ihrem Ger\xe4t und Ihre IP-Adresse. Sehr h\xe4ufig werden die meisten dieser Daten in Cookies gespeichert. Wenn Sie bei einer externen Plattform ein eigenes Profil haben und dort auch angemeldet sind, k\xf6nnen Daten mit dem Profil verkn\xfcpft werden. Die erhobenen Daten werden auf den Servern der verwendeten Plattformen gespeichert und dort verarbeitet. Wie eine externe Plattform Daten genau speichert, verwaltet und verarbeitet, erfahren Sie in der jeweiligen Datenschutzerkl\xe4rung. Falls Sie zur Datenspeicherung und Datenverarbeitung Fragen haben oder entsprechende Rechte geltend machen wollen, empfehlen wir Ihnen, sich direkt an die Plattform zu wenden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Dauer der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "\xdcber die Dauer der Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere Informationen dazu haben. Beispielsweise speichert Amazon Daten, bis sie f\xfcr den eigenen Zweck nicht mehr ben\xf6tigt werden. Generell verarbeiten wir personenbezogene Daten nur so lange wie es f\xfcr die Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig ist."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben auch jederzeit das Recht und die M\xf6glichkeit Ihre Einwilligung zur Verwendung von Cookies zu widerrufen. Das funktioniert entweder \xfcber unser Cookie-Management-Tool oder \xfcber Opt-Out-Funktionen bei der jeweiligen externen Plattform. Weiters k\xf6nnen Sie auch die Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren oder l\xf6schen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Da Cookies zum Einsatz kommen k\xf6nnen, empfehlen wir Ihnen auch unsere allgemeine Datenschutzerkl\xe4rung \xfcber Cookies. Um zu erfahren, welche Daten von Ihnen genau gespeichert und verarbeitet werden, sollten Sie die Datenschutzerkl\xe4rungen der jeweiligen externen Plattformen durchlesen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie eingewilligt haben, dass Daten von Ihnen durch externe Plattformen verarbeitet und gespeichert werden k\xf6nnen, gilt diese",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Einwilligung"
                    }),
                    " als Rechtsgrundlage der Datenverarbeitung",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "(Art. 6 Abs. 1 lit. a DSGVO)"
                    }),
                    ". Grunds\xe4tzlich werden Ihre Daten bei Vorliegen einer Einwilligung auch auf Grundlage eines",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO)"
                    }),
                    "an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und Gesch\xe4ftspartnern gespeichert und verarbeitet. Falls wir eingebundene Elemente externer Plattformen auf unser Website haben, setzen wir diese gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Informationen zu speziellen externen Plattformen erfahren Sie \u2013 sofern vorhanden \u2013 in den folgenden Abschnitten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "amazon-europe-datenschutzerklaerung",
                children: "Amazon (Europe) Datenschutzerkl\xe4rung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir nutzen auch die Online-Handelsplattform Amazon (Europe). Dienstanbieter ist das amerikanische Unternehmen Amazon Inc. F\xfcr den europ\xe4ischen Raum ist das Unternehmen Amazon Europe Core S.\xe0 r.l. (Soci\xe9t\xe9 \xe0 responsabilit\xe9 limit\xe9e), 38 avenue John F. Kennedy, L-1855 Luxemburg verantwortlich."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Amazon verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf hin, dass nach Meinung des Europ\xe4ischen Gerichtshofs derzeit kein angemessenes Schutzniveau f\xfcr den Datentransfer in die USA besteht. Dies kann mit verschiedenen Risiken f\xfcr die Rechtm\xe4\xdfigkeit und Sicherheit der Datenverarbeitung einhergehen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Als Grundlage der Datenverarbeitung bei Empf\xe4ngern mit Sitz in Drittstaaten (au\xdferhalb der Europ\xe4ischen Union, Island, Liechtenstein, Norwegen, also insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Amazon sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard Contractual Clauses \u2013 SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass Ihre Daten auch dann den europ\xe4ischen Datenschutzstandards entsprechen, wenn diese in Drittl\xe4nder (wie beispielsweise in die USA) \xfcberliefert und dort gespeichert werden. Durch diese Klauseln verpflichtet sich Amazon, bei der Verarbeitung Ihrer relevanten Daten, das europ\xe4ische Datenschutzniveau zu wahren, selbst wenn die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf einem Durchf\xfchrungsbeschluss der EU-Kommission. Sie finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a. hier:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Die Amazon Datenverarbeitungsbedingung (AWS GDPR DATA PROCESSING), welche den Standardvertragsklauseln entsprechen, finden Sie unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://d1.awsstatic.com/legal/aws-gdpr/AWS_GDPR_DPA.pdf",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://d1.awsstatic.com/legal/aws-gdpr/AWS_GDPR_DPA.pdf"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Mehr \xfcber die Daten, die durch die Verwendung von Amazon verarbeitet werden, erfahren Sie in der Datenschutzerkl\xe4rung auf",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("u", {
                        children: "."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "ebay-datenschutzerklaerung",
                children: "eBay Datenschutzerkl\xe4rung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir nutzen die Online-Handelsplattform eBay. Dienstanbieter ist das amerikanische Unternehmen eBay Inc., 2025 Hamilton Avenue, San Jose, CA 95125, USA."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "eBay verarbeitet Daten u.a. auch in den USA. Wir weisen darauf hin, dass nach Meinung des Europ\xe4ischen Gerichtshofs derzeit kein angemessenes Schutzniveau f\xfcr den Datentransfer in die USA besteht. Dies kann mit verschiedenen Risiken f\xfcr die Rechtm\xe4\xdfigkeit und Sicherheit der Datenverarbeitung einhergehen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Als Grundlage der Datenverarbeitung bei Empf\xe4ngern mit Sitz in Drittstaaten (au\xdferhalb der Europ\xe4ischen Union, Island, Liechtenstein, Norwegen, also insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet eBay von der EU-Kommission genehmigte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO). Diese Klauseln verpflichten eBay, das EU-Datenschutzniveau bei der Verarbeitung relevanter Daten auch au\xdferhalb der EU zu wahren."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Diese Klauseln basieren auf einem Durchf\xfchrungsbeschluss der EU-Kommission. Sie finden den Beschluss sowie die Klauseln u.a. hier:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://germany.representation.ec.europa.eu/index_de",
                        children: "https://germany.representation.ec.europa.eu/index_de"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Mehr \xfcber die Daten, die durch die Verwendung von eBay verarbeitet werden, erfahren Sie in der Datenschutzerkl\xe4rung auf",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.ebay.com/help/policies/member-behaviour-policies/user-privacy-notice-privacy-policy?id=4260",
                        children: "https://www.ebay.com/help/policies/member-behaviour-policies/user-privacy-notice-privacy-policy?id=4260"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "TrustPilot"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "F\xfcr die Bewertung unserer Dienstleistungen arbeiten wir mit TrustPilot zusammen. Die Weitergabe Ihrer Angaben erfolgt nur zum Zwecke des Einholens von Bewertungen. Das Bewerten ist freiwillig."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "TrustPilot ist ein Dienst von Trustpilot A/S mit Sitz in Kopenhagen, D\xe4nemark. Auftragsdaten\xadverarbeitungs\xadvertrag (Data processing agreement). Weitere Informationen finden Sie inder Datenschutzerkl\xe4rung von Familiara:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://de.legal.trustpilot.com/for-reviewers/end-user-privacy-terms",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://de.legal.trustpilot.com/for-reviewers/end-user-privacy-terms"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "audio-video-einleitung",
                children: "Audio & Video Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Audio & Video Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Optimierung unserer Serviceleistung",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Daten wie etwa Kontaktdaten, Daten zum Nutzerverhalten, Informationen zu Ihrem Ger\xe4t und Ihre IP-Adresse k\xf6nnen gespeichert werden.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "Mehr Details dazu finden Sie weiter unten in den entsprechenden Datenschutztexten.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: Daten bleiben grunds\xe4tzlich gespeichert, solange sie f\xfcr den Dienstzweck n\xf6tig sind",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was sind Audio- und Videoelemente?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir haben auf unsere Website Audio- bzw. Videoelemente eingebunden, damit Sie sich direkt \xfcber unsere Website etwa Videos ansehen oder Musik/Podcasts anh\xf6ren k\xf6nnen. Die Inhalte werden von Dienstanbietern zur Verf\xfcgung gestellt. Alle Inhalte werden also auch von den entsprechenden Servern der Anbieter bezogen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Es handelt sich dabei um eingebundene Funktionselemente von Plattformen wie etwa YouTube, Vimeo oder Spotify. Die Nutzung dieser Portale ist in der Regel kostenlos, es k\xf6nnen aber auch kostenpflichtige Inhalte ver\xf6ffentlicht werden. Mit Hilfe dieser eingebundenen Elemente k\xf6nne Sie sich \xfcber unsere Website die jeweiligen Inhalte anh\xf6ren oder ansehen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie Audio- oder Videoelemente auf unsere Website verwenden, k\xf6nnen auch personenbezogene Daten von Ihnen an die Dienstanbieter \xfcbermittelt, verarbeitet und gespeichert werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verwenden wir Audio- & Videoelemente auf unserer Website?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Nat\xfcrlich wollen wir Ihnen auf unserer Website das beste Angebot liefern. Und uns ist bewusst, dass Inhalte nicht mehr blo\xdf in Text und statischem Bild vermittelt werden. Statt Ihnen einfach nur einen Link zu einem Video zu geben, bieten wir Ihnen direkt auf unserer Website Audio- und Videoformate, die unterhaltend oder informativ und im Idealfall sogar beides sind. Das erweitert unser Service und erleichtert Ihnen den Zugang zu interessanten Inhalten. Somit bieten wir neben unseren Texten und Bildern auch Video und/oder Audio-Inhalte an."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden durch Audio- & Videoelemente gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie eine Seite auf unserer Website aufrufen, die beispielsweise ein eingebettetes Video hat, verbindet sich Ihr Server mit dem Server des Dienstanbieters. Dabei werden auch Daten von Ihnen an den Drittanbieter \xfcbertragen und dort gespeichert. Manche Daten werden ganz unabh\xe4ngig davon, ob Sie bei dem Drittanbieter ein Konto haben oder nicht, gesammelt und gespeichert. Dazu z\xe4hlen meist Ihre IP-Adresse, Browsertyp, Betriebssystem, und weitere allgemeine Informationen zu Ihrem Endger\xe4t. Weiters werden von den meisten Anbietern auch Informationen \xfcber Ihre Webaktivit\xe4t eingeholt. Dazu z\xe4hlen etwa Sitzungsdauer, Absprungrate, auf welchen Button Sie geklickt haben oder \xfcber welche Website Sie den Dienst nutzen. All diese Informationen werden meist \xfcber Cookies oder Pixel-Tags (auch Web Beacon genannt) gespeichert. Pseudonymisierte Daten werden meist in Cookies in Ihrem Browser gespeichert. Welche Daten genau gespeichert und verarbeitet werden, erfahren Sie stets in der Datenschutzerkl\xe4rung des jeweiligen Anbieters."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Dauer der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wie lange die Daten auf den Servern der Drittanbieter genau gespeichert werden, erfahren Sie entweder weiter unten im Datenschutztext des jeweiligen Tools oder in der Datenschutzerkl\xe4rung des Anbieters. Grunds\xe4tzlich werden personenbezogene Daten immer nur so lange verarbeitet, wie es f\xfcr die Bereitstellung unserer Dienstleistungen oder Produkte unbedingt n\xf6tig wird. Dies gilt in der Regel auch f\xfcr Drittanbieter. Meist k\xf6nnen Sie davon ausgehen, dass gewisse Daten \xfcber mehrere Jahre auf den Servern der Drittanbieter gespeichert werden. Daten k\xf6nnen speziell in Cookies unterschiedlich lange gespeichert werden. Manche Cookies werden bereits nach dem Verlassen der Website wieder gel\xf6scht, anderen k\xf6nnen \xfcber einige Jahre in Ihrem Browser gespeichert sein."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sie haben auch jederzeit das Recht und die M\xf6glichkeit Ihre Einwilligung zur Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert entweder \xfcber unser Cookie-Management-Tool oder \xfcber andere Opt-Out-Funktionen. Zum Bespiel k\xf6nnen Sie auch die Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren oder l\xf6schen. Die Rechtm\xe4\xdfigkeit der Verarbeitung bis zum Widerruf bleibt unber\xfchrt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Da durch die eingebundenen Audio- und Video-Funktionen auf unserer Seite meist auch Cookies verwendet werden, sollte Sie sich auch unsere allgemeine Datenschutzerkl\xe4rung \xfcber Cookies durchlesen. In den Datenschutzerkl\xe4rungen der jeweiligen Drittanbieter erfahren Sie genaueres \xfcber den Umgang und die Speicherung Ihrer Daten."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                    children: "Rechtsgrundlage"
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene Audio- und Video-Elemente verarbeitet und gespeichert werden k\xf6nnen, gilt diese Einwilligung als Rechtsgrundlage der Datenverarbeitung",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "(Art. 6 Abs. 1 lit. a DSGVO)"
                    }),
                    ". Grunds\xe4tzlich werden Ihre Daten auch auf Grundlage unseres berechtigten Interesses",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "(Art. 6 Abs. 1 lit. f DSGVO)"
                    }),
                    " an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und Gesch\xe4ftspartnern gespeichert und verarbeitet. Wir setzen die eingebundenen Audio- und Video-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "youtube-datenschutzerklaerung",
                children: "YouTube Datenschutzerkl\xe4rung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "YouTube Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Optimierung unserer Serviceleistung",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Daten wie etwa Kontaktdaten, Daten zum Nutzerverhalten, Informationen zu Ihrem Ger\xe4t und Ihre IP-Adresse k\xf6nnen gespeichert werden.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "Mehr Details dazu finden Sie weiter unten in dieser Datenschutzerkl\xe4rung.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: Daten bleiben grunds\xe4tzlich gespeichert, solange sie f\xfcr den Dienstzweck n\xf6tig sind",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist YouTube?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir haben auf unserer Website YouTube-Videos eingebaut. So k\xf6nnen wir Ihnen interessante Videos direkt auf unserer Seite pr\xe4sentieren. YouTube ist ein Videoportal, das seit 2006 eine Tochterfirma von Google ist. Betrieben wird das Videoportal durch YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn Sie auf unserer Website eine Seite aufrufen, die ein YouTube-Video eingebettet hat, verbindet sich Ihr Browser automatisch mit den Servern von YouTube bzw. Google. Dabei werden (je nach Einstellungen) verschiedene Daten \xfcbertragen. F\xfcr die gesamte Datenverarbeitung im europ\xe4ischen Raum ist Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) verantwortlich."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Im Folgenden wollen wir Ihnen genauer erkl\xe4ren, welche Daten verarbeitet werden, warum wir YouTube-Videos eingebunden haben und wie Sie Ihre Daten verwalten oder l\xf6schen k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Auf YouTube k\xf6nnen die User kostenlos Videos ansehen, bewerten, kommentieren und selbst hochladen. \xdcber die letzten Jahre wurde YouTube zu einem der wichtigsten Social-Media-Kan\xe4le weltweit. Damit wir Videos auf unserer Webseite anzeigen k\xf6nnen, stellt YouTube einen Codeausschnitt zur Verf\xfcgung, den wir auf unserer Seite eingebaut haben."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verwenden wir YouTube-Videos auf unserer Website?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "YouTube ist die Videoplattform mit den meisten Besuchern und dem besten Content. Wir sind bem\xfcht, Ihnen die bestm\xf6gliche User-Erfahrung auf unserer Webseite zu bieten. Und nat\xfcrlich d\xfcrfen interessante Videos dabei nicht fehlen. Mithilfe unserer eingebetteten Videos stellen wir Ihnen neben unseren Texten und Bildern weiteren hilfreichen Content zur Verf\xfcgung. Zudem wird unsere Webseite auf der Google-Suchmaschine durch die eingebetteten Videos leichter gefunden. Auch wenn wir \xfcber Google Ads Werbeanzeigen schalten, kann Google \u2013 dank der gesammelten Daten \u2013 diese Anzeigen wirklich nur Menschen zeigen, die sich f\xfcr unsere Angebote interessieren."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden von YouTube gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Sobald Sie eine unserer Seiten besuchen, die ein YouTube-Video eingebaut hat, setzt YouTube zumindest ein Cookie, das Ihre IP-Adresse und unsere URL speichert. Wenn Sie in Ihrem YouTube-Konto eingeloggt sind, kann YouTube Ihre Interaktionen auf unserer Webseite meist mithilfe von Cookies Ihrem Profil zuordnen. Dazu z\xe4hlen Daten wie Sitzungsdauer, Absprungrate, ungef\xe4hrer Standort, technische Informationen wie Browsertyp, Bildschirmaufl\xf6sung oder Ihr Internetanbieter. Weitere Daten k\xf6nnen Kontaktdaten, etwaige Bewertungen, das Teilen von Inhalten \xfcber Social Media oder das Zuf\xfcgen zu Ihren Favoriten auf YouTube sein."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie nicht in einem Google-Konto oder einem Youtube-Konto angemeldet sind, speichert Google Daten mit einer eindeutigen Kennung, die mit Ihrem Ger\xe4t, Browser oder App verkn\xfcpft sind. So bleibt beispielsweise Ihre bevorzugte Spracheinstellung beibehalten. Aber viele Interaktionsdaten k\xf6nnen nicht gespeichert werden, da weniger Cookies gesetzt werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "In der folgenden Liste zeigen wir Cookies, die in einem Test im Browser gesetzt wurden. Wir zeigen einerseits Cookies, die ohne angemeldetes YouTube-Konto gesetzt werden. Andererseits zeigen wir Cookies, die mit angemeldetem Account gesetzt werden. Die Liste kann keinen Vollst\xe4ndigkeitsanspruch erheben, weil die Userdaten immer von den Interaktionen auf YouTube abh\xe4ngen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " YSC",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " b9-CV6ojI5Y312394123-1",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie registriert eine eindeutige ID, um Statistiken des gesehenen Videos zu speichern.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach Sitzungsende"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " PREF",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " f1=50000000",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie registriert ebenfalls Ihre eindeutige ID. Google bekommt \xfcber PREF Statistiken, wie Sie YouTube-Videos auf unserer Webseite verwenden.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 8 Monaten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " GPS",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " 1",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie registriert Ihre eindeutige ID auf mobilen Ger\xe4ten, um den GPS-Standort zu tracken.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 30 Minuten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " VISITOR_INFO1_LIVE",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " 95Chz8bagyU",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie versucht die Bandbreite des Users auf unseren Webseiten (mit eingebautem YouTube-Video) zu sch\xe4tzen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 8 Monaten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Weitere Cookies, die gesetzt werden, wenn Sie mit Ihrem YouTube-Konto angemeldet sind:"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " APISID",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " zILlvClZSkqGsSwI/AU1aZI6HY7312394123-",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie wird verwendet, um ein Profil \xfcber Ihre Interessen zu erstellen. Gen\xfctzt werden die Daten f\xfcr personalisierte Werbeanzeigen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " CONSENT",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " YES+AT.de+20150628-20-0",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Das Cookie speichert den Status der Zustimmung eines Users zur Nutzung unterschiedlicher Services von Google. CONSENT dient auch der Sicherheit, um User zu \xfcberpr\xfcfen und Userdaten vor unbefugten Angriffen zu sch\xfctzen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum: "
                    }),
                    "nach 19 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " HSID",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " AcRwpgUik9Dveht0I",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie wird verwendet, um ein Profil \xfcber Ihre Interessen zu erstellen. Diese Daten helfen personalisierte Werbung anzeigen zu k\xf6nnen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " LOGIN_INFO",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " AFmmF2swRQIhALl6aL\u2026",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " In diesem Cookie werden Informationen \xfcber Ihre Login-Daten gespeichert.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " SAPISID",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " 7oaPxoG-pZsJuuF5/AnUdDUIsJ9iJz2vdM",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie funktioniert, indem es Ihren Browser und Ihr Ger\xe4t eindeutig identifiziert. Es wird verwendet, um ein Profil \xfcber Ihre Interessen zu erstellen.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " SID",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " oQfNKjAsI312394123-",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie speichert Ihre Google-Konto-ID und Ihren letzten Anmeldezeitpunkt in digital signierter und verschl\xfcsselter Form.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 2 Jahren"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Name:"
                    }),
                    " SIDCC",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Wert:"
                    }),
                    " AN0-TYuqub2JOcDTyL",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Verwendungszweck:"
                    }),
                    " Dieses Cookie speichert Informationen, wie Sie die Webseite nutzen und welche Werbung Sie vor dem Besuch auf unserer Seite m\xf6glicherweise gesehen haben.",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "Ablaufdatum:"
                    }),
                    " nach 3 Monaten"
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Wie lange und wo werden die Daten gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Die Daten, die YouTube von Ihnen erh\xe4lt und verarbeitet werden auf den Google-Servern gespeichert. Die meisten dieser Server befinden sich in Amerika. Unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.google.com/about/datacenters/locations/?hl=de",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://www.google.com/about/datacenters/locations/?hl=de"
                    }),
                    " ",
                    "sehen Sie genau wo sich die Google-Rechenzentren befinden. Ihre Daten sind auf den Servern verteilt. So sind die Daten schneller abrufbar und vor Manipulation besser gesch\xfctzt."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Die erhobenen Daten speichert Google unterschiedlich lang. Manche Daten k\xf6nnen Sie jederzeit l\xf6schen, andere werden automatisch nach einer begrenzten Zeit gel\xf6scht und wieder andere werden von Google \xfcber l\xe4ngere Zeit gespeichert. Einige Daten (wie Elemente aus \u201EMeine Aktivit\xe4t\u201C, Fotos oder Dokumente, Produkte), die in Ihrem Google-Konto gespeichert sind, bleiben so lange gespeichert, bis Sie sie l\xf6schen. Auch wenn Sie nicht in einem Google-Konto angemeldet sind, k\xf6nnen Sie einige Daten, die mit Ihrem Ger\xe4t, Browser oder App verkn\xfcpft sind, l\xf6schen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Wie kann ich meine Daten l\xf6schen bzw. die Datenspeicherung verhindern?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Grunds\xe4tzlich k\xf6nnen Sie Daten im Google Konto manuell l\xf6schen. Mit der 2019 eingef\xfchrten automatischen L\xf6schfunktion von Standort- und Aktivit\xe4tsdaten werden Informationen abh\xe4ngig von Ihrer Entscheidung \u2013 entweder 3 oder 18 Monate gespeichert und dann gel\xf6scht."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Unabh\xe4ngig, ob Sie ein Google-Konto haben oder nicht, k\xf6nnen Sie Ihren Browser so konfigurieren, dass Cookies von Google gel\xf6scht bzw. deaktiviert werden. Je nachdem welchen Browser Sie verwenden, funktioniert dies auf unterschiedliche Art und Weise. Unter dem Abschnitt \u201ECookies\u201C finden Sie die entsprechenden Links zu den jeweiligen Anleitungen der bekanntesten Browser."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Falls Sie grunds\xe4tzlich keine Cookies haben wollen, k\xf6nnen Sie Ihren Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie gesetzt werden soll. So k\xf6nnen Sie bei jedem einzelnen Cookie entscheiden, ob Sie es erlauben oder nicht."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene YouTube-Elemente verarbeitet und gespeichert werden k\xf6nnen, gilt diese Einwilligung als Rechtsgrundlage der Datenverarbeitung",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "(Art. 6 Abs. 1 lit. a DSGVO)"
                    }),
                    ". Grunds\xe4tzlich werden Ihre Daten auch auf Grundlage unseres berechtigten Interesses",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                        children: "(Art. 6 Abs. 1 lit. f DSGVO)"
                    }),
                    " an einer schnellen und guten Kommunikation mit Ihnen oder anderen Kunden und Gesch\xe4ftspartnern gespeichert und verarbeitet. Wir setzen die eingebundenen YouTube-Elemente gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben. YouTube setzt auch Cookies in Ihrem Browser, um Daten zu speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext \xfcber Cookies genau durchzulesen und die Datenschutzerkl\xe4rung oder sehen Sie sich die Cookie-Richtlinien des jeweiligen Dienstanbieters an."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "YouTube verarbeitet Daten u.a. auch in den USA. Wir weisen darauf hin, dass nach Meinung des Europ\xe4ischen Gerichtshofs derzeit kein angemessenes Schutzniveau f\xfcr den Datentransfer in die USA besteht. Dies kann mit verschiedenen Risiken f\xfcr die Rechtm\xe4\xdfigkeit und Sicherheit der Datenverarbeitung einhergehen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Als Grundlage der Datenverarbeitung bei Empf\xe4ngern mit Sitz in Drittstaaten (au\xdferhalb der Europ\xe4ischen Union, Island, Liechtenstein, Norwegen, also insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet YouTube von der EU-Kommission genehmigte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO). Diese Klauseln verpflichten YouTube, das EU-Datenschutzniveau bei der Verarbeitung relevanter Daten auch au\xdferhalb der EU zu wahren. Diese Klauseln basieren auf einem Durchf\xfchrungsbeschluss der EU-Kommission. Sie finden den Beschluss sowie die Klauseln u.a. hier:",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://germany.representation.ec.europa.eu/index_de",
                        target: "_blank",
                        rel: "follow noopener",
                        children: "https://germany.representation.ec.europa.eu/index_de"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Da YouTube ein Tochterunternehmen von Google ist, gibt es eine gemeinsame Datenschutzerkl\xe4rung. Wenn Sie mehr \xfcber den Umgang mit Ihren Daten erfahren wollen, empfehlen wir Ihnen die Datenschutzerkl\xe4rung unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://policies.google.com/privacy?hl=de",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "https://policies.google.com/privacy?hl=de."
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                id: "webdesign-einleitung",
                children: "Webdesign Einleitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("table", {
                border: 1,
                cellPadding: 15,
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tbody", {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("tr", {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("td", {
                            children: [
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("strong", {
                                    children: "Webdesign Datenschutzerkl\xe4rung Zusammenfassung"
                                }),
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDC65 Betroffene: Besucher der Website",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83E\uDD1D Zweck: Verbesserung der Nutzererfahrung",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCD3 Verarbeitete Daten: Welche Daten verarbeitet werden, h\xe4ngt stark von den verwendeten Diensten ab. Meist handelt es sich etwa um IP-Adresse, technische Daten, Spracheinstellungen, Browserversion, Bildschirmaufl\xf6sung und Name des Browsers. Mehr Details dazu finden Sie bei den jeweils eingesetzten Webdesign-Tools.",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\uD83D\uDCC5 Speicherdauer: abh\xe4ngig von den eingesetzten Tools",
                                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("br", {}),
                                "\u2696\uFE0F Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Was ist Webdesign?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir verwenden auf unserer Website verschiedene Tools, die unserem Webdesign dienen. Bei Webdesign geht es nicht, wie oft angenommen, nur darum, dass unsere Website h\xfcbsch aussieht, sondern auch um Funktionalit\xe4t und Leistung. Aber nat\xfcrlich ist die passende Optik einer Website auch eines der gro\xdfen Ziele professionellen Webdesigns. Webdesign ist ein Teilbereich des Mediendesigns und besch\xe4ftigt sich sowohl mit der visuellen als auch der strukturellen und funktionalen Gestaltung einer Website. Ziel ist es mit Hilfe von Webdesign Ihre Erfahrung auf unserer Website zu verbessern. Im Webdesign-Jargon spricht man in diesem Zusammenhang von User-Experience (UX) und Usability. Unter User Experience versteht man alle Eindr\xfccke und Erlebnisse, die der Websitebesucher auf einer Website erf\xe4hrt. Ein Unterpunkt der User Experience ist die Usability. Dabei geht es um die Nutzerfreundlichkeit einer Website. Wert gelegt wird hier vor allem darauf, dass Inhalte, Unterseiten oder Produkte klar strukturiert sind und Sie leicht und schnell finden, wonach Sie suchen. Um Ihnen die bestm\xf6gliche Erfahrung auf unserer Website zu bieten, verwenden wir auch sogenannte Webdesign-Tools von Drittanbietern. Unter die Kategorie \u201EWebdesign\u201C fallen in dieser Datenschutzerkl\xe4rung also alle Dienste, die unsere Website gestalterisch verbessern. Das k\xf6nnen beispielsweise Schriftarten, diverse Plugins oder andere eingebundene Webdesign-Funktionen sein."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Warum verwenden wir Webdesign-Tools?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wie Sie Informationen auf einer Website aufnehmen, h\xe4ngt sehr stark von der Struktur, der Funktionalit\xe4t und der visuellen Wahrnehmung der Website ab. Daher wurde auch f\xfcr uns ein gutes und professionelles Webdesign immer wichtiger. Wir arbeiten st\xe4ndig an der Verbesserung unserer Website und sehen dies auch als erweiterte Dienstleistung f\xfcr Sie als Websitebesucher. Weiters hat eine sch\xf6ne und funktionierende Website auch wirtschaftliche Vorteile f\xfcr uns. Schlie\xdflich werden Sie uns nur besuchen und unsere Angebote in Anspruch nehmen, wenn Sie sich rundum wohl f\xfchlen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Welche Daten werden durch Webdesign-Tools gespeichert?"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie unsere Website besuchen, k\xf6nnen Webdesign-Elemente in unseren Seiten eingebunden sein, die auch Daten verarbeiten k\xf6nnen. Um welche Daten es sich genau handelt, h\xe4ngt nat\xfcrlich stark von den verwendeten Tools ab. Weiter unter sehen Sie genau, welche Tools wir f\xfcr unsere Website verwenden. Wir empfehlen Ihnen f\xfcr n\xe4here Informationen \xfcber die Datenverarbeitung auch die jeweilige Datenschutzerkl\xe4rung der verwendeten Tools durchzulesen. Meistens erfahren Sie dort, welche Daten verarbeitet werden, ob Cookies eingesetzt werden und wie lange die Daten aufbewahrt werden. Durch Schriftarten wie etwa Google Fonts werden beispielsweise auch Informationen wie Spracheinstellungen, IP-Adresse, Version des Browsers, Bildschirmaufl\xf6sung des Browsers und Name des Browsers automatisch an die Google-Server \xfcbertragen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Dauer der Datenverarbeitung"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wie lange Daten verarbeitet werden, ist sehr individuell und h\xe4ngt von den eingesetzten Webdesign-Elementen ab. Wenn Cookies beispielsweise zum Einsatz kommen, kann die Aufbewahrungsdauer nur eine Minute, aber auch ein paar Jahre dauern. Machen Sie sich diesbez\xfcglich bitte schlau. Dazu empfehlen wir Ihnen einerseits unseren allgemeinen Textabschnitt \xfcber Cookies sowie die Datenschutzerkl\xe4rungen der eingesetzten Tools. Dort erfahren Sie in der Regel, welche Cookies genau eingesetzt werden, und welche Informationen darin gespeichert werden. Google-Font-Dateien werden zum Beispiel ein Jahr gespeichert. Damit soll die Ladezeit einer Website verbessert werden. Grunds\xe4tzlich werden Daten immer nur so lange aufbewahrt, wie es f\xfcr die Bereitstellung des Dienstes n\xf6tig ist. Bei gesetzlichen Vorschreibungen k\xf6nnen Daten auch l\xe4nger gespeichert werden."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Widerspruchsrecht"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: [
                    "Sie haben auch jederzeit das Recht und die M\xf6glichkeit Ihre Einwilligung zur Verwendung von Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert entweder \xfcber unser Cookie-Management-Tool oder \xfcber andere Opt-Out-Funktionen. Sie k\xf6nnen auch die Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren oder l\xf6schen. Unter Webdesign-Elementen (meistens bei Schriftarten) gibt es allerdings auch Daten, die nicht ganz so einfach gel\xf6scht werden k\xf6nnen. Das ist dann der Fall, wenn Daten direkt bei einem Seitenaufruf automatisch erhoben und an einen Drittanbieter (wie z. B. Google) \xfcbermittelt werden. Wenden Sie sich dann bitte an den Support des entsprechenden Anbieters. Im Fall von Google erreichen Sie den Support unter",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://support.google.com/?hl=de",
                        children: "https://support.google.com/?hl=de"
                    }),
                    " ",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Rechtsgrundlage"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wenn Sie eingewilligt haben, dass Webdesign-Tools eingesetzt werden d\xfcrfen, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) die Rechtsgrundlage f\xfcr die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung durch Webdesign-Tools vorkommen kann, dar. Von unserer Seite besteht zudem ein berechtigtes Interesse, das Webdesign auf unserer Website zu verbessern. Schlie\xdflich k\xf6nnen wir Ihnen nur dann ein sch\xf6nes und professionelles Webangebot liefern. Die daf\xfcr entsprechende Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen). Wir setzen Webdesign-Tools gleichwohl nur ein, soweit Sie eine Einwilligung erteilt haben. Das wollen wir hier auf jeden Fall nochmals betonen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "Zahlungsdienstleister"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Wir nutzen externe Zahlungsdienstleister, um Dienstleistungen abzurechnen oder damit Nutzende freiwillige Beitr\xe4ge zahlen k\xf6nnen."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("h2", {
                className: "text-2xl mt-4",
                children: "PayPal"
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: 'Auf dieser Internetseite und in E-Mails sind Komponenten von PayPal integriert. Dies entspricht unserem berechtigten Interesse, eine effiziente und sichere Zahlungsmethode anzubieten (Art. 6 Abs. 1 lit. f DSGVO). Zahlungen werden \xfcber sogenannte virtuelle PayPal-Konten oder Kreditkarten und Girokonten abgewickelt, auch wenn kein PayPal-Konto besteht. Wenn Nutzer im Bestellvorgang oder aufgrund eines Hinweises \u201EPayPal" als Zahlungsdienstleister ausw\xe4hlt, werden automatisiert Daten der betroffenen Person an PayPal \xfcbermittelt. Mit der Auswahl dieser Zahlungsoption willigt die betroffene Person in die zur Zahlungsabwicklung erforderliche \xdcbermittlung personenbezogener Daten ein. Dies sind in der Regel Vorname, Nachname, Adresse, E-Mail-Adresse, Telefonnummer oder andere Daten, die zur Zahlungsabwicklung notwendig sind. Alle Daten werden lediglich zwecks Zahlungsabwicklung und zur Betrugspr\xe4vention \xfcbermittelt. Die \xdcbermittlung der Daten bezweckt die Zahlungsabwicklung und die Betrugspr\xe4vention. PayPal kann zwecks Bonit\xe4tspr\xfcfung Ihre Daten (insb. Name, Adresse, Geburtsdatum und Bankkontodetails) ans Auskunftsdateien weitergeben. PayPal ist ein Dienst von PayPal (Europe) S.\xe0.r.l. & Cie. S.C.A. mit Sitz in Luxembourg, Luxembourg. Weitere Informationen zum Datenschutz und Widerspruchs- und Beseitigungsm\xf6glichkeiten gegen\xfcber PayPal finden Sie in der Datenschutzerkl\xe4rung von PayPal: https://www.paypal.com/de/webapps/mpp/ua/privacy-full'
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                children: "Alle Texte sind urheberrechtlich gesch\xfctzt."
            }),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)("p", {
                style: {
                    marginTop: "15px"
                },
                children: [
                    "Quelle: Erstellt mit dem",
                    " ",
                    /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$a6c7ac8248d6e38a), {
                        to: "https://www.adsimple.de/datenschutz-generator/",
                        title: "Datenschutz Generator von AdSimple f\xfcr Deutschland",
                        children: "Datenschutz Generator"
                    }),
                    " ",
                    "von AdSimple"
                ]
            })
        ]
    });
};
var $bb1c4bdf1bacd325$export$2e2bcd8739ae039 = $bb1c4bdf1bacd325$export$f7160926399b30c7;


const $42999f209dffa68e$export$55185c17a0fcbe46 = ()=>/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$3565eb3d00ca5a74), {
        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
            path: "/",
            Component: (0, $1547805c5793a413$export$c84671f46d6a1ca),
            children: [
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
                    index: true,
                    Component: (0, $7da27bfd17cda4c8$export$355f3d6a1f8b250c)
                }),
                (0, $e900c93c1685e091$export$7f5e6e4a87406c9c).map((article)=>/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
                        path: article.url,
                        element: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)(article.component, {})
                    }, article.url)),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
                    path: "login",
                    Component: (0, $8fc97e69887d62e6$export$f14c0e3f98d164c0)
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
                    path: "create-transcript",
                    element: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $33bb2a8076af9cbd$export$8ef2ed426dede42d), {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $127fc70a3eb0946d$export$e0492843958acefd), {})
                    })
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
                    path: "blog/:id",
                    element: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $33bb2a8076af9cbd$export$8ef2ed426dede42d), {
                        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $1c9f9f2b0d9181a3$export$8353a350193a5d77), {})
                    })
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
                    path: "impressum",
                    element: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $5955c39aa569b1c2$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
                    path: "datenschutz",
                    element: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $bb1c4bdf1bacd325$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $23ae8c349145cf41$export$e7b0ac011bb776c6), {
                    path: "*",
                    Component: (0, $99c9ea1b9e2721c5$export$31641b61980e511f)
                })
            ]
        })
    });


function $bbbc8a9e4314932d$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $e48b1195589f71e3$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $c1334e9b7557fad0$export$42cfbb80f7861e77), {}),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $42999f209dffa68e$export$55185c17a0fcbe46), {}),
            /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $5db68e7af9fcf8ff$export$a06f1c675e846f6f), {})
        ]
    });
}






const $7af279647a13de53$var$root = (0, $06caa6fd762958d5$export$2e2bcd8739ae039).createRoot(document.getElementById("root"));
$7af279647a13de53$var$root.render(/*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $69d723089b47cf34$export$2e2bcd8739ae039).StrictMode, {
    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $de187eb300fae735$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $b84d49b1a1347f2d$export$5261e812c31263e7), {
            children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $f1091c596cd24cbd$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $bd2db0da17abe19a$export$d724fb526705b3e), {
                    children: /*#__PURE__*/ (0, $3945ef68f6afb8b5$export$34b9dba7ce09269b)((0, $bbbc8a9e4314932d$export$86fbec116b87613f), {})
                })
            })
        })
    })
}));


//# sourceMappingURL=index.a940ae00.js.map
